webpackJsonp([1],{

/***/ "+4WN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTH_SOCIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTH_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_COMPLATE_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPLATE_REGISTRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_USER_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DECRYPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ENCRYPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REGISTRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REGISTRATION_ERROR; });
/* unused harmony export SET_TAPPA */
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SOCIAL = 'AUTH_SOCIAL';
var AUTH_OK = 'AUTH_OK';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
var AUTH_REGISTRATION = 'AUTH_REGISTRATION';
var AUTH_COMPLATE_REGISTRATION = 'AUTH_COMPLATE_REGISTRATION';
var COMPLATE_REGISTRATION_SUCCESS = 'COMPLATE_REGISTRATION_SUCCESS';
var SET_USER_TOKEN = 'COMPLATE_REGISTRATION_SUCCESS';
var DECRYPT = 'DECRYPT';
var ENCRYPT = 'ENCRYPT';
var REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
var REGISTRATION_ERROR = 'REGISTRATION_ERROR';
var SET_TAPPA = 'SET_TAPPA';

/***/ }),

/***/ "+qws":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iedL");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2fadcc87", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "+tnh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-3a1cdd68] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-3a1cdd68] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-3a1cdd68] {\n  width: 75px;\n}\n.bigTitle[data-v-3a1cdd68] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-3a1cdd68] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-3a1cdd68] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-3a1cdd68] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-3a1cdd68] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-3a1cdd68] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-3a1cdd68] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-3a1cdd68] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-3a1cdd68] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-3a1cdd68] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-3a1cdd68] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-3a1cdd68] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-3a1cdd68] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-3a1cdd68] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-3a1cdd68] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-3a1cdd68] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-3a1cdd68]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-3a1cdd68] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-3a1cdd68] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-3a1cdd68]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-3a1cdd68]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-3a1cdd68]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-3a1cdd68] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-3a1cdd68] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-3a1cdd68] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0rFJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Poste.81915ab.jpg";

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1SEM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1mNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_NOTIFICATIONS; });
var ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS';
var GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2TQw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/calcBack.9839f74.jpg";

/***/ }),

/***/ "2czj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc_condominio.45acf03.jpg";

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Dg/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contact2.a34415e.png";

/***/ }),

/***/ "3Gu/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.center-container[data-v-896ab43a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "3XyK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.table-striped[data-v-7191a0d4] {\n\toverflow-x: auto;\n\tdisplay: table;\n\tmax-height: 63vh;\n}\n.priceVal[data-v-7191a0d4], .priceCent[data-v-7191a0d4]{\n\twidth: calc(50% - 1.5vw - 7.5px);\n\tdisplay: inline-grid;\n}\n.pseudoEuro[data-v-7191a0d4] {\n\tposition: absolute;\n\ttop: 6px;\n}\n.pseudoCent[data-v-7191a0d4] {\n\tposition: absolute;\n\ttop: 6px;\n\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-7191a0d4] {\n\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-7191a0d4]{\n\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-7191a0d4] {\n\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-7191a0d4]{\n\tdisplay:block;\n}\n.euroInput[data-v-7191a0d4]{\n\tposition: relative;\n\twidth:200%;\n\tz-index: 4;\n}\n.euroInput[data-v-7191a0d4]::before{\n\tcontent: 'Euro';\n}\n.euroInput[data-v-7191a0d4]:focus, .euroInput.valid[data-v-7191a0d4]{\n\twidth:100%;\n}\n.euroInput[data-v-7191a0d4]:focus::before, .euroInput.valid[data-v-7191a0d4]::before{\n\tcontent: 'Euro';\n\tcolor: #2b773c;\n\tposition: absolute;\n}\n.table[data-v-7191a0d4]{\n\tdisplay: table;\n}\n.priceVal[data-v-7191a0d4]{\n}\n.priceCent[data-v-7191a0d4]{\n}\n.labelFileInput[data-v-7191a0d4]{\n\ttop: -20px;\n\tfont-size: 14px;\n\tcolor: #d3a399;\n}\n.fileInput[data-v-7191a0d4]{\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0;\n\ttop: 4px;\n\tborder-bottom: none;\n\tcolor: #000000;\n}\n.fileInputLabel[data-v-7191a0d4]{\n\tz-index: 3;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tpadding-right: 20px;\n\ttext-overflow: ellipsis;\n\tcolor: #fffbde;\n}\n.newPriceLabel[data-v-7191a0d4]{\n\tz-index: 5;\n\tbackground: #fcfcfc;\n\tmargin-left: -5px;\n\tpadding-left: 5px;\n\toverflow: initial;\n\tmin-width: calc(200% + 17px);\n}\n.formHeader[data-v-7191a0d4] {\n\tfont-size: 18px;\n\tbackground: #990033!important;\n\twidth: 100%;\n\tcolor: #ffffff!important;\n\ttext-transform: uppercase;\n\tfont-family: CoreRhino75Heavy;\n}\n.greyDesc[data-v-7191a0d4]{\n\tfont-size: 3vw;\n}\nimg.playVideoButton[data-v-7191a0d4] {\n\tmax-width: 200px;\n\tcursor: pointer;\n}\n.zindex1[data-v-7191a0d4]{\n\tz-index: 1;\n}\n.maxCertificate[data-v-7191a0d4]{\n\tmax-width: 130px;\n}\n.reflection[data-v-7191a0d4]{\n\tposition: absolute;\n\twidth: 20vw;\n\theight: 19vw;\n\ttop: -3%;\n\tright: 0%;\n\tborder-radius: 50%;\n\tbackground: radial-gradient(#ffffff59,#e7798985,#eee0,#eee0);\n\tz-index: 0;\n}\n.relative[data-v-7191a0d4]{\n\tposition: relative;\n}\n.cup4Shadow[data-v-7191a0d4]{\n\tposition: absolute;\n\theight: 40px;\n\tbackground: radial-gradient(#0e0e0ee0,#000000e3, #ffffff00, #f9f9f900);\n\tborder-radius: 50%;\n\twidth: 50%;\n\tright: 19%;\n\tbottom: 37.4%;\n\tz-index: 0;\n}\n.cup1Shadow[data-v-7191a0d4] {\n\tposition: absolute;\n\theight: 57px;\n\tbackground: radial-gradient(#0e0e0ec4,#ffc80024, #00000000, #38383845);\n\tborder-radius: 50%;\n\twidth: 67%;\n\tright: 24%;\n\tbottom: 35%;\n\tz-index: 1;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.greyDesc[data-v-7191a0d4]{\n\t\ttext-align: center;\n\t\tfont-size: 4vw;\n}\nimg.playVideoButton[data-v-7191a0d4] {\n\t\tposition: relative!important;\n\t\ttop: 0!important;\n\t\tmargin-top: 20px;\n}\n.maxCertificate[data-v-7191a0d4]{\n\t\tmax-width: 100px;\n}\n.reflection[data-v-7191a0d4] {\n\t\twidth: 73vw;\n\t\theight: 64vw;\n}\n.cup4Shadow[data-v-7191a0d4]{\n\t\theight: 57px;\n\t\twidth: 50vw;\n\t\tright: 18%;\n\t\tbottom: 36.4%;\n}\n.cup1Shadow[data-v-7191a0d4] {\n\t\theight: 74px;\n\t\twidth: 80%;\n\t\tright: 10%;\n\t\tbottom: 35%;\n}\n}\n\n\n", ""]);

// exports


/***/ }),

/***/ "4AGf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "54oZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-415b2084] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-415b2084] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-415b2084] {\n  width: 75px;\n}\n.bigTitle[data-v-415b2084] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-415b2084] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-415b2084] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: .4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-415b2084] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-415b2084] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-415b2084] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-415b2084] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-415b2084] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-415b2084] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-415b2084] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-415b2084] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-415b2084] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-415b2084] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-415b2084] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-415b2084] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important;\n    left: 0;\n}\n.front-image > label > span[data-v-415b2084] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-415b2084]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-415b2084] {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-415b2084] {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n.front-image > label[data-v-415b2084]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-415b2084]:after {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-415b2084]:after {\n          margin: 0 auto !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-415b2084] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin-bottom: 40px !important;\n        margin: 0 auto !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-415b2084] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin-bottom: 40px !important !important;\n        margin: 0 auto !important;\n}\n}\n.center-container[data-v-415b2084] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "5j5C":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "5uEW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/card.c6bab37.png";

/***/ }),

/***/ "6PKJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6Z51":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "7EV4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8C68");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("04110622", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38471c95\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38471c95\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7Hb7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("q5vZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3f06ea14", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35b793fb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./emicon.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-35b793fb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./emicon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7N6W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7UA4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7sA3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__("gCMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4588f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__("l+T2");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("l+gf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c4588f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-timepicker/src/vue-timepicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c4588f32", Component.options)
  } else {
    hotAPI.reload("data-v-c4588f32", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "879u":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("x/1t");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("82340ad2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-67f3a69c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-67f3a69c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8C68":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-38471c95] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-38471c95] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-38471c95] {\n  width: 75px;\n}\n.bigTitle[data-v-38471c95] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-38471c95] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-38471c95] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-38471c95] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-38471c95] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-38471c95] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-38471c95] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-38471c95] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-38471c95] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image2[data-v-38471c95] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 29px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 100%;\n  margin-bottom: 0;\n  background: #00897e !important;\n  color: white;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n}\n@media screen and (max-width: 1024px) {\n.front-image2[data-v-38471c95] {\n      margin-top: 15px !important;\n}\n}\n.front-image2 > .fileInputLabel[data-v-38471c95] {\n    display: none;\n}\n.front-image2 > .invalid-feedback[data-v-38471c95] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image2 > input[data-v-38471c95] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 30px;\n    z-index: 10;\n    top: 0;\n    cursor: pointer !important;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 99;\n    /*This makes the button huge. If you want a bigger button, increase the font size*/\n    font-size: 50px;\n    /*Opacity settings for all browsers*/\n    opacity: 0;\n    -moz-opacity: 0;\n    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n}\n.front-image2 > label[data-v-38471c95] {\n    /*display: none;*/\n    cursor: pointer;\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image2 > label > span[data-v-38471c95] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 100%;\n      margin-top: 0 !important;\n      display: block;\n      height: 29px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 0;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 19px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n      cursor: pointer;\n}\n.front-image2 > label > span[data-v-38471c95]:before {\n        cursor: pointer;\n        content: \"CARICA\";\n        font-family: Regular;\n        font-weight: 300 !important;\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 29px;\n        width: 100%;\n        border-radius: 7px;\n        padding-top: 3px;\n        font-size: 0.775rem !important;\n        font-weight: 600;\n        color: white;\n        border: 3px solid #00917e;\n        /*padding: .55rem .55rem !important;*/\n        font-size: 0.775rem !important;\n        line-height: 0.9 !important;\n        border-radius: 0.1rem !important;\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label > span[data-v-38471c95] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label > span[data-v-38471c95] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image2 > label[data-v-38471c95]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 100%;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      cursor: pointer;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-38471c95]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-38471c95]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-38471c95] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-38471c95] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.niceInputLabel2[data-v-38471c95] {\n  color: #ffffff !important;\n  font-size: 21px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 0;\n  top: 0;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.center-container[data-v-38471c95] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8gwm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("K4Pf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("101a46a2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6428c8d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6428c8d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./loading.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "98bG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pWsl");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("23c4de96", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9fMG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.component-badger-accordion .badger-accordion__panel {\n  max-height: 0;\n}\n.badger-accordion__panel {\n  max-height: 75vh;\n  overflow: hidden;\n}\n.badger-accordion__panel.-ba-is-hidden {\n    max-height: 0 !important;\n}\n.badger-accordion--initialized .badger-accordion__panel {\n  -webkit-transition: max-height ease-in-out 0.2s;\n  transition: max-height ease-in-out 0.2s;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle {\n  width: 100%;\n  background: transparent;\n  border: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-accordion-title {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 90%;\n            flex: 0 0 90%;\n    cursor: pointer;\n    text-align: left;\n}\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-toggle-indicator {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 0 10%;\n            flex: 0 0 10%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "9pkI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dPwX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7832977b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-648fb19c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-648fb19c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9x6x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traficLight_green.50ac074.png";

/***/ }),

/***/ "AaPU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.select-checkbox, .select-all-checkbox {\r\n  cursor: pointer;\n}\n.vdtnet-footer .dataTables_length {\r\n  padding-top: 6px;\r\n  padding-right: 10px;\n}\n.vdtnet-footer .dataTables_length, .vdtnet-footer .dataTables_paginate {\r\n  float: right;\n}\n.hide-footer .vdtnet-footer {\r\n  display: none;\n}\n.master .details-plus\r\n{\r\n  cursor: pointer;\r\n  display: none;\n}\n.details-minus\r\n{\r\n  cursor: pointer;\r\n  display: none;\n}\n.master .details-minus\r\n{\r\n  cursor: pointer;\r\n  display: inline;\n}\n.details-control {\r\n  cursor: pointer;\r\n  font-weight: 700;\n}\r\n", ""]);

// exports


/***/ }),

/***/ "CXbD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Cz55":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Gu8a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0cef7764", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5414bf37\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5414bf37\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DaEW":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "DjRw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3XyK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1c38b49d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7191a0d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7191a0d4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DydT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mainBack2.4258943.jpg";

/***/ }),

/***/ "FIF3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/servicesBack.ead12c8.jpg";

/***/ }),

/***/ "FLts":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "FMAQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var myUniqueId = 1;

var compiler = __webpack_require__("p255");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VdtnetTable',
  props: {
    /**
     * The table id
     *
     * @type String
     */
    id: {
      type: String,
      default: null
    },
    /**
     * The table id
     *
     * @type String
     */
    url: {
      type: String,
      default: null
    },
    /**
     * Set the container classes.
     *
     * @type String
     */
    containerClassName: {
      type: String,
      default: 'table-responsive d-print-inline'
    },
    /**
     * Set the table classes you wish to use, default with bootstrap4
     * but you can override with: themeforest, foundation, etc..
     *
     * @type String
     */
    className: {
      type: String,
      default: 'table mt-0 table-striped table-borderless nowrap w-100'
    },
    /**
     * the options object: https://datatables.net/manual/options
     *
     * @type Object
     */
    opts: {
      type: Object
    },
    /**
     * List all fields to be converted to opts columns
     *
     * @type Object
     */
    fields: {
      type: Object
    },
    /**
     * Pass in DataTables.Net jQuery to resolve any conflict from
     * multiple jQuery loaded in the browser
     *
     * @type Object
     */
    jquery: {
      type: Object
    },
    /**
     * Pass in Vue to resolve any conflict from multiple loaded
     *
     * @type Object
     */
    vue: {
      type: Object
    },
    /**
     * The select-checkbox column index (start at 1)
     * Current implementation require datatables.net-select
     *
     * @type Number
     */
    selectCheckbox: {
      type: Number
    },
    /**
     * Provide custom local data loading.  Warning: this option has not been
     * thoroughly tested.  Please use ajax and serverSide instead.
     *
     * @type Function
     */
    dataLoader: {
      type: Function
    },
    /**
     * true to hide the footer of the table
     *
     * @type Boolean
     */
    hideFooter: {
      type: Boolean
    },
    /**
     * The details column configuration of master/details.
     *
     * @type {Object}
     */
    details: {
      type: Object
    }
  },
  data: function data() {
    // initialize defaults
    return {
      tableId: null,
      fieldsNew: {},
      options: {
        /*eslint-disable */
        dom: "tr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
        /*eslint-enable */
        columns: [],
        language: {
          emptyTable: "La tabella non contiene informazioni",
          info: "Visualizzazione da _START_ a _END_ di _TOTAL_ righe totali",
          infoEmpty: "Visualizzazione da  0 a 0 di 0 righe totali",
          infoFiltered: "(dati filtrati da _MAX_ record totali)",
          lengthMenu: " _MENU_ Mostra righe",
          loadingRecords: "Sto caricando ...",
          processing: "Processing...",
          search: "Cerca:",
          searchPlaceholder: "Scrivi e premi INVIO...",
          zeroRecords: "Nessun record trovato",
          paginate: {
            first: "Prima",
            last: "Ultima",
            next: "Successiva",
            previous: "Precedente"
          }
        },
        lengthMenu: [[-1, 5, 10, 15, 20], ['All', 5, 10, 15, 20]],
        pageLength: 1000,
        buttons: [] // remove any button defaults
      },
      dataTable: null,
      vdtnet: this
    };
  },

  computed: {
    jq: function jq() {
      return this.jquery || __webpack_provided_window_dot_jQuery;
    },
    myVue: function myVue() {
      return __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */] || window.Vue;
    },
    classes: function classes() {
      var that = this;
      var classes = that.containerClassName + ' vdtnet-container';
      if (this.hideFooter) {
        classes += ' hide-footer';
      }

      return classes;
    }
  },
  created: function created() {
    var that = this;
    var jq = that.jq;
    that.tableId = that.id || 'vdtnetable' + myUniqueId++;

    // allow user to override default options
    if (that.opts) {
      that.options = jq.extend({}, that.options, that.opts);
    }
  },
  beforeMount: function beforeMount() {
    var url = this.url;

    //this.loadRegistrationData()
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var that, jq, $el, orders, startCol, icol, fields, cols, k, field, _col, col, _col2, renderFunc;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this;
              jq = that.jq;
              $el = jq(that.$refs.table);
              orders = [];
              startCol = 0;
              icol = 0;

              // if fields are passed in, generate column definition
              // from our custom fields schema

              _this.$log('I AM START WAITIIIIING');
              //await this.loadRegistrationData()
              _this.$log('OK FINISH WAITIIIIING');
              if (that.fieldsNew) {
                fields = that.fields;
                cols = that.options.columns;


                for (k in fields) {
                  field = fields[k];

                  field.name = field.name || k;

                  // disable search and sort for local field
                  if (field.isLocal) {
                    field.searchable = false;
                    field.sortable = false;
                  }

                  // generate
                  _col = {
                    title: field.label || field.name,
                    data: field.data || field.name,
                    width: field.width,
                    name: field.name,
                    className: field.className,
                    index: field.index || icol + 1
                  };


                  if (field.width) {
                    _col.width = field.width;
                  }

                  if (field.hasOwnProperty('defaultContent')) {
                    _col.defaultContent = field.defaultContent;
                  }

                  if (field.hasOwnProperty('sortable')) {
                    _col.orderable = field.sortable;
                  }

                  if (field.hasOwnProperty('visible')) {
                    _col.visible = field.visible;
                  }

                  if (field.hasOwnProperty('searchable')) {
                    _col.searchable = field.searchable;
                  }

                  if (field.template || that.$scopedSlots[field.name]) {
                    field.render = that.compileTemplate(field, that.$scopedSlots[field.name]);
                  }

                  if (field.render) {
                    if (!field.render.templated) {
                      (function () {
                        var myRender = field.render;
                        field.render = function () {
                          return myRender.apply(that, Array.prototype.slice.call(arguments));
                        };
                      })();
                    }

                    _col.render = field.render;
                  }

                  // this.$log(col)
                  cols.push(_col);

                  if (field.defaultOrder) {
                    orders.push([icol, field.defaultOrder]);
                  }

                  icol++;
                }

                // sort columns
                cols = cols.sort(function (a, b) {
                  return a.index - b.index;
                });
              }

              // apply orders calculated from above
              that.options.order = that.options.order || orders;

              if (that.selectCheckbox) {
                that.selectCheckbox = that.selectCheckbox || 1;

                // create checkbox column
                col = {
                  orderable: false,
                  searchable: false,
                  name: '_select_checkbox',
                  className: 'select-checkbox d-print-none',
                  data: null,
                  defaultContent: '',
                  title: '<input type="checkbox" class="select-all-checkbox d-print-none">',
                  index: that.selectCheckbox - 1
                };

                that.options.columns.splice(that.selectCheckbox - 1, 0, col);

                // this.$log(that.options.columns)
                that.options.select = jq.extend(that.options.select || {}, {
                  style: 'os',
                  selector: 'td.select-checkbox'
                });

                if (that.selectCheckbox === 1) {
                  startCol++;
                }
              }

              // handle master details
              if (that.details) {
                that.details.index = that.details.index || 1;

                // create details column
                _col2 = {
                  orderable: false,
                  searchable: false,
                  name: '_details_control',
                  className: 'details-control d-print-none',
                  data: null,
                  defaultContent: that.details.icons || '<span class="details-plus" title="Show details">+</span><span class="details-minus" title="Hide details">-</span>',
                  index: that.details.index - 1
                };

                that.options.columns.splice(that.details.index - 1, 0, _col2);

                if (that.details.index === 1) {
                  startCol++;
                }
              }

              if (startCol > 0) {
                if (that.options.order) {
                  that.options.order.forEach(function (v) {
                    v[0] += startCol;
                  });
                } else {
                  that.options.order = [[startCol, 'asc']];
                }
              }

              // handle local data loader
              if (that.dataLoader) {
                delete that.options.ajax;
                that.options.serverSide = false;
              }

              // you can access and update the that.options and $el here before we create the DataTable


              that.$emit('table-creating', that, $el);

              that.dataTable = $el.DataTable(that.options);

              if (that.selectCheckbox) {
                // handle select all checkbox
                $el.on('click', 'th input.select-all-checkbox', function (e) {
                  if (jq(e.target).is(':checked')) {
                    that.dataTable.rows().select();
                  } else {
                    that.dataTable.rows().deselect();
                  }
                });

                // handle individual row select events
                that.dataTable.on('select deselect', function () {
                  var $input = $el.find('th input.select-all-checkbox');
                  if (that.dataTable.rows({
                    selected: true
                  }).count() !== that.dataTable.rows().count()) {
                    jq('th.select-checkbox').removeClass('selected');
                    $input.attr('checked', false);
                  } else {
                    jq('th.select-checkbox').addClass('selected');
                    $input.attr('checked', true);
                  }
                  // TODO: that.$emit the selected row?
                });
              }

              // wire up edit, delete, and/or action buttons
              $el.on('click', '[data-action]', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var target = jq(e.target);
                var action = target.attr('data-action');
                while (!action) {
                  // don't let it propagate outside of container
                  if (target.hasClass('vdtnet-container') || target.prop('tagName') === 'table') {
                    // no action, simply exit
                    return;
                  }
                  target = target.parent();
                  action = target.attr('data-action');
                }

                // only emit if there is action
                if (action) {
                  // detect if row action
                  _this.$log(action);

                  var tr = target.closest('tr');

                  if (action == 'link') {

                    // BIND ROUTER PATH AND URL **********************************************************************************

                    var par = that.url;
                    par = par.replace("https://wsbot.eu/ebonusBack/public/" + 'api/loadProducts?id=', "");

                    if (tr.attr('role') !== 'row') {
                      tr = tr.prev();
                    }
                    var row1 = that.dataTable.row(tr);
                    var data1 = row1.data();

                    _this.$router.push({
                      name: 'addDocuments',
                      params: { id: par, data: data1 }
                    });

                    // BIND ROUTER PATH AND URL **********************************************************************************
                  }

                  if (tr) {
                    if (tr.attr('role') !== 'row') {
                      tr = tr.prev();
                    }
                    var row = that.dataTable.row(tr);
                    var data = row.data();
                    that.$emit(action, data, row, tr, target);
                  } else {
                    // not a row click, must be other kind of action
                    // such as bulk, csv, pdf, etc...
                    if (action == 'link') {} else {
                      that.$emit(action, null, null, null, target);
                    }
                  }
                }
              });

              // handle master/details
              if (that.details) {
                // default to render function
                renderFunc = that.details.render;

                // must be string template

                if (that.details.template || that.$scopedSlots['_details']) {
                  renderFunc = that.compileTemplate(that.details, that.$scopedSlots['_details']);
                } else if (renderFunc) {
                  renderFunc = function renderFunc() {
                    return that.details.render.apply(that, Array.prototype.slice.call(arguments));
                  };
                }

                // handle master/details
                // Add event listener for opening and closing details
                $el.on('click', 'td.details-control', function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  var target = jq(e.target);
                  var tr = target.closest('tr');
                  if (tr.attr('role') !== 'row') {
                    tr = tr.prev();
                  }
                  var row = that.dataTable.row(tr);
                  if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                    tr.removeClass('master');
                  } else {
                    // Open this row
                    var data = row.data();
                    row.child(renderFunc(data, 'child', row, tr)).show();
                    tr.addClass('master');
                  }
                });
              }

              // handle master/Search on specific field
              // Add event listener for all search fields
              $el.on('keyup', '.footSearch', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var target = jq(e.target);
                if (e.keyCode == 13) {
                  _this.$log('Enter was pressed');
                  var fieldK = jq(target).data('field');
                  _this.$log(fieldK);
                  _this.$log(that.dataTable);
                  that.dataTable.columns(fieldK).search(target[0].value);
                  that.dataTable.draw();
                }
              });

              that.$emit('table-created', that);

              // finally, load data
              if (that.dataLoader) {
                that.reload();
              }

              _this.$log('BEFORE CREATE FOOTER ################################');

              // CREATE FOOTER
              jq('.dataTable thead tr').each(function (e) {
                var elemX = this;
                if (jq(elemX).html() != '') {
                  var k = 0;
                  jq(elemX).children('th').each(function (e) {
                    if (k != 500) {
                      var title = jq(this).text();
                      var style = jq(this).attr("style");
                      this.$log(title);

                      jq('thead').append('<th><input class="footSearch p-0 m-0 center" type="text" data-field="' + k + '" rows="3" style="' + style + 'min-width:70px;" placeholder="Cerca" /></th>');
                    } else {
                      jq('thead').append('<th></th>');
                    }
                    k++;
                  });
                }
              });

              _this.$log('END CREATE FOOTER ################################');

            case 25:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    var that = this;
    if (that.dataTable) {
      that.dataTable.destroy(true);
    }

    that.dataTable = null;
  },

  methods: {
    loadRegistrationData: function loadRegistrationData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _vue, fields, data, l;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _vue = _this2;
                fields = {};
                data = { getFieldsNames: true };
                l = _this2.url;
                fields = {
                  confirmed: {
                    label: 'Esito',
                    sortable: true,
                    searchable: false,
                    render: function render(data, display, row) {

                      if (data == 0) {
                        return ' In Verifica ';
                      }

                      if (data == 1) {
                        return ' Approvato ';
                      }

                      if (data == 2) {
                        return ' Respinto <br/> <small> ' + row.confirm_info + '</small>';
                      }
                    }
                  },

                  azienda: { label: 'Azienda', sortable: true, searchable: true },
                  partita_iva: { label: 'Partita IVA', sortable: true, searchable: true },
                  codice_fiscale: { label: 'Codice Fiscale', sortable: true, searchable: true },

                  barcode: {
                    label: 'Matricola',
                    sortable: true,
                    searchable: true,
                    render: function render(data, display, row) {
                      return ' <a class="simpleLink green" target="_blank" href="' + row.image + '"> <small>' + data + '</small> </a> ';
                    }
                  },
                  product: { label: 'Prodotto', sortable: true, searchable: true },

                  invoice_number: {
                    label: 'Prova d`acquisto',
                    sortable: true,
                    searchable: true,
                    render: function render(data, display, row) {
                      return ' <a class="simpleLink green" target="_blank" href="' + row.invoice + '"> <small>' + data + '</small> </a> ';
                    }
                  },

                  invoice_date: { label: 'Data Doc.', sortable: true, searchable: true }

                };


                _vue.fieldsNew = fields;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    /**
     * Vue.compile a template string and return the compiled function
     *
     * @param  {Object} object with template property
     * @param  {Object} the slot
     * @return {Function}          the compiled template function
     */
    compileTemplate: function compileTemplate(field, slot) {
      var _this3 = this;

      var that = this;
      var jq = that.jq;
      var vue = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */];
      var res = __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].compile('<div>' + (field.template || '') + '</div>');

      var renderFunc = function renderFunc(data, type, row, meta) {
        var myRender = res.render;

        if (slot) {
          _this3.$log(slot);
          myRender = function myRender(createElement) {
            return createElement('div', [slot({
              data: data,
              type: type,
              row: row,
              meta: meta,
              vdtnet: that,
              def: field,
              comp: that.$parent
            })]);
          };
        }

        var comp = new vue({
          data: {
            data: data,
            type: type,
            row: row,
            meta: meta,
            vdtnet: that,
            def: field,
            comp: that.$parent
          },
          render: myRender,
          staticRenderFns: res.staticRenderFns
        }).$mount();
        return jq(comp.$el).html();
      };

      renderFunc.templated = true;

      return renderFunc;
    },

    /**
     * Set table data array that was loaded from somewhere else
     * This method allow for local setting of data; though, it
     * is recommended to use ajax instead of this.
     *
     * @param {Array} data   the array of data
     * @return {Object}            the component
     */
    setTableData: function setTableData(data) {
      var that = this;
      if (data.constructor === Array) {
        that.dataTable.clear().rows.add(data);
        that.dataTable.draw(false);
        that.dataTable.columns.adjust();
      }
      return that;
    },

    /**
     * pass through reload method
     *
     * @param  {Boolean}  resetPaging true to reset current page position
     * @return {Object}            the component
     */
    reload: function reload() {
      var resetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var that = this;
      if (that.dataLoader) {
        // manual data loading
        that.dataLoader(function (data) {
          if (data && !data.data) {
            data = { data: data };
          }
          that.setTableData(data.data);

          that.$emit('reloaded', data, that);
        });
      } else {
        that.dataTable.ajax.reload(function (data) {
          that.$emit('reloaded', data, that);
        }, resetPaging);
      }

      return that;
    },
    search: function search(value) {
      var that = this;
      that.dataTable.search(value).draw();

      return that;
    },
    setPageLength: function setPageLength(value) {
      var that = this;
      that.dataTable.page.len(value);

      return that.reload();
    },
    getServerParams: function getServerParams() {
      if (this.dataLoader) {
        return {};
      }

      return this.dataTable.ajax.params();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "FiR5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doc_singola.2b2c882.jpg";

/***/ }),

/***/ "Fp4o":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@media (min-width: 20px) and (max-width: 767px) {\n.seachMobButton {\r\n    padding: 0 !important;\r\n    height: 30px !important;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "G6ei":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-89f7b05a] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-89f7b05a] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-89f7b05a] {\n  width: 75px;\n}\n.bigTitle[data-v-89f7b05a] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-89f7b05a] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-89f7b05a] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-89f7b05a] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-89f7b05a] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-89f7b05a] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-89f7b05a] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-89f7b05a] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-89f7b05a] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-89f7b05a] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-89f7b05a] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-89f7b05a] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-89f7b05a] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-89f7b05a] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-89f7b05a] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-89f7b05a] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-89f7b05a]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #0091da;\n        border: 3px solid #0091da;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-89f7b05a] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-89f7b05a] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-89f7b05a]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-89f7b05a]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-89f7b05a]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-89f7b05a] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-89f7b05a] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-89f7b05a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "Gu8a":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-5414bf37] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-5414bf37] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-5414bf37] {\n  width: 75px;\n}\n.bigTitle[data-v-5414bf37] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-5414bf37] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-5414bf37] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-5414bf37] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-5414bf37] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-5414bf37] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-5414bf37] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-5414bf37] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-5414bf37] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-5414bf37] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-5414bf37] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-5414bf37] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-5414bf37] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-5414bf37] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-5414bf37] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-5414bf37] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-5414bf37]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-5414bf37] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-5414bf37] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-5414bf37]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-5414bf37]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-5414bf37]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-5414bf37] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-5414bf37] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-5414bf37] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "H0mA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.timeElement[data-v-0de2e1c8] {\n  background: white;\n  color: #eb6608;\n  padding: 18px;\n  width: 64px;\n  height: 64px;\n  font-size: 20px;\n  border-radius: 7px;\n  font-family: Bold;\n}\n.headerLogo[data-v-0de2e1c8] {\n  max-width: 115px;\n}\n@media screen and (max-width: 667px) {\n.headerLogo[data-v-0de2e1c8] {\n      max-width: 70px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.headerLogo[data-v-0de2e1c8] {\n      max-width: 100px;\n}\n}\n.coca-logo[data-v-0de2e1c8] {\n  top: -5px;\n  height: 40px;\n  position: relative;\n}\n@media screen and (max-width: 667px) {\n.coca-logo[data-v-0de2e1c8] {\n      height: 20px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.coca-logo[data-v-0de2e1c8] {\n      height: 23px;\n}\n}\n.ce-logo[data-v-0de2e1c8] {\n  top: -15px;\n  height: 65px;\n  position: relative;\n}\n@media screen and (max-width: 667px) {\n.ce-logo[data-v-0de2e1c8] {\n      top: -7px;\n      height: 37px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.ce-logo[data-v-0de2e1c8] {\n      top: -7px;\n      height: 37px;\n}\n}\n.mainFont[data-v-0de2e1c8] {\n  font-size: 14px;\n}\n.big-red[data-v-0de2e1c8] {\n  font-family: 'Gotham Rounded', sans-serif;\n  font-weight: bold;\n  font-size: 26px;\n  color: #E30613;\n}\n@media screen and (max-width: 667px) {\n.big-red[data-v-0de2e1c8] {\n      font-size: 14px;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.big-red[data-v-0de2e1c8] {\n      font-size: 16px;\n}\n}\n.main[data-v-0de2e1c8] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-position: 0% 50% !important;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n", ""]);

// exports


/***/ }),

/***/ "HJqQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("q2xu"), "");
exports.i(__webpack_require__("bYAS"), "");

// module
exports.push([module.i, "\n\n\n", ""]);

// exports


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/store/actions/user.js
var actions_user = __webpack_require__("yLEp");

// EXTERNAL MODULE: ./src/store/actions/auth.js
var auth = __webpack_require__("+4WN");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("Av7u");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// CONCATENATED MODULE: ./src/store/modules/auth.js




var _actions, _mutations;

/* eslint-disable promise/param-names */





var auth_state = { token: localStorage.getItem('22a5s2dffe$fswe565') || '', jwtToken: localStorage.getItem("11a5s2dffe$fswe561") || '', tempEncrypt: '', tempCrypt: '', status: '', login_error: '', loadingState: '', hasLoadedOnce: false };

var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token && !!state.jwtToken;
  },
  authStatus: function authStatus(state) {
    return state.status;
  },
  loginerror: function loginerror(state) {
    return state.login_error;
  },
  loadingState: function loadingState(state) {
    return state.loadingState;
  }
};
var moment = __webpack_require__("PJh5");
var actions = (_actions = {}, defineProperty_default()(_actions, auth["f" /* AUTH_REQUEST */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(auth["f" /* AUTH_REQUEST */]);
    axios_default()({ url: "https://wsbot.eu/ebonusBack/public/" + 'api/login', data: user, method: 'POST', crossDomain: true, headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(auth["j" /* DECRYPT */], resp.data);
      resp.data = auth_state.tempCrypt;
      if (resp.data.role && (resp.data.role == 'admin' || resp.data.role == 'super' || resp.data.role == 'adminKpmg') && (resp.data.corporateClient == 'hoval' || resp.data.corporateClient == 'emicon')) {
        commit(auth["b" /* AUTH_ERROR */], resp.data);
        localStorage.removeItem('22a5s2dffe$fswe565');
      } else {

        var token = resp.data.userToken;
        var jwtToken = resp.data.jwtToken;
        localStorage.setItem('55a5s1dffe$fswe545', '$234' + token.split("").reverse().join("") + '2324234');
        localStorage.setItem('66a5s2dtte$fswe565', '$vr4' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token.substring(1, 8) + '3453455');
        localStorage.setItem('99a3s2dgfe$fswe565', '$34f' + token.substring(9, 20) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'wer345f');
        localStorage.setItem("11a5s2dffe$fswe561", jwtToken);
        localStorage.setItem('01a5s2dhge$fswe565', '$fwe' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + jwtToken.substring(1, 20) + 'werweqe');
        localStorage.setItem('98a0s2ddee$fswe565', '$5fs' + token.substring(3, 20) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'fertfdw');
        localStorage.setItem('75a9s2dsse$fswe565', '$4ff' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token.substring(2, 37) + 'werfsfd');
        localStorage.setItem('22a5s2dffe$fswe565', token);
        localStorage.setItem('96a3s2djje$fswe565', '$45f' + token.substring(2, 40) + '435wefs');
        localStorage.setItem('81a4s2dyye$fswe565', '$4fe' + token + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token.substring(1, 20) + 'sdtrrdf');
        localStorage.setItem('72a5s2diie$fswe565', '$5fs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token.substring(4, 28) + 'dswe443');
        localStorage.setItem('97a6s2dkke$fswe565', '$ng4' + jwtToken.substring(7, 27) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'cvrt433');
        localStorage.setItem('00a7s2dwde$fswe565', '$8hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + jwtToken.substring(5, 20) + 'gfdgerg');
        sessionStorage.setItem('token', '$2th#eto#ket$h%a6tyo^ua@ret$ryi%ng^tof&5in$di^snota)9vaiable');
        localStorage.removeItem('55a5s1dfflo$fswe545');
        localStorage.removeItem('66a5s2dttlo$fswe565');
        localStorage.removeItem('99a3s2dgflo$fswe565');
        localStorage.removeItem('01a5s2dhglo$fswe565');
        localStorage.removeItem('98a0s2ddelo$fswe565');
        localStorage.removeItem('75a9s2dsslo$fswe565');
        localStorage.removeItem('96a3s2djjlo$fswe565');
        localStorage.removeItem('81a4s2dyylo$fswe565');
        localStorage.removeItem('72a5s2diilo$fswe565');
        localStorage.removeItem('97a6s2dkklo$fswe565');
        localStorage.removeItem('55a7s2dwdlo$fswe564');
        localStorage.removeItem('00a7s2dwdlo$fswe567');
        localStorage.removeItem('11a7s2dwdlo$fswe566');
        localStorage.removeItem('44a7s2dwdlo$fswe565');
        localStorage.removeItem('77a7s2dwdlo$fswe563');
        localStorage.removeItem('88a7s2dwdlo$fswe562');
        localStorage.removeItem('99a7s2dwdlo$fswe562');
        localStorage.removeItem('10a7s2dwdlo$fswe561');
        // store the token in localstorage
        commit(auth["h" /* AUTH_SUCCESS */], token, jwtToken);
        // you have your token, now log in your user :)
        dispatch(actions_user["d" /* USER_REQUEST */], resp.data);
        resolve(resp.data);
      }
    }).catch(function (err) {
      commit(auth["j" /* DECRYPT */], err.response.data);
      err.response.data = auth_state.tempCrypt;
      commit(auth["b" /* AUTH_ERROR */], err.response.data.status);
      localStorage.removeItem('22a5s2dffe$fswe565'); // if the request fails, remove any possible user token if possible
      reject(err);
    });
  });
}), defineProperty_default()(_actions, auth["e" /* AUTH_REGISTRATION */], function (_ref2, user) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(auth["e" /* AUTH_REGISTRATION */]);
    axios_default()({
      url: "https://wsbot.eu/ebonusBack/public/" + 'add_new_user.php',
      data: user,
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' }
    }).then(function (resp) {
      commit(auth["m" /* REGISTRATION_SUCCESS */], resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(auth["l" /* REGISTRATION_ERROR */]);
      reject(err);
    });
  });
}), defineProperty_default()(_actions, auth["a" /* AUTH_COMPLATE_REGISTRATION */], function (_ref3, user) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  return new promise_default.a(function (resolve, reject) {
    // The Promise used for router redirect in login
    commit(auth["a" /* AUTH_COMPLATE_REGISTRATION */]);
    axios_default()({
      url: "https://wsbot.eu/ebonusBack/public/" + 'editUser.php',
      data: user,
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' }
    }).then(function (resp) {
      commit(auth["i" /* COMPLATE_REGISTRATION_SUCCESS */], resp.data);
      dispatch(actions_user["g" /* USER_UPDATE_DATA */], resp.data);
      resolve(resp.data);
    }).catch(function (err) {
      commit(auth["l" /* REGISTRATION_ERROR */]);
      reject(err);
    });
  });
}), defineProperty_default()(_actions, auth["c" /* AUTH_LOGOUT */], function (_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(auth["c" /* AUTH_LOGOUT */]);
    localStorage.removeItem('22a5s2dffe$fswe565');
    localStorage.removeItem('55a5s1dffe$fswe545');
    localStorage.removeItem('66a5s2dtte$fswe565');
    localStorage.removeItem('99a3s2dgfe$fswe565');
    localStorage.removeItem('01a5s2dhge$fswe565');
    localStorage.removeItem('98a0s2ddee$fswe565');
    localStorage.removeItem('75a9s2dsse$fswe565');
    localStorage.removeItem('96a3s2djje$fswe565');
    localStorage.removeItem('81a4s2dyye$fswe565');
    localStorage.removeItem('72a5s2diie$fswe565');
    localStorage.removeItem('97a6s2dkke$fswe565');
    localStorage.removeItem('00a7s2dwde$fswe565');
    localStorage.removeItem("11a5s2dffe$fswe561");
    sessionStorage.removeItem('token');
    sessionStorage.setItem('token', '$2n@3ow5$thet^ok&en8^th86atyo7uar8etr&yi(ng)to)_findisava$#iabl3efo%%rc$$hac##kingme');
    var token2 = '$2y$10$weQPwu16AY/qh1UXJJxkQubT.s0dcVF9rHnwpwDH8URb2ZlaUruJ2';
    localStorage.setItem('55a5s1dfflo$fswe545', '$234' + token2.split("").reverse().join("") + '2324234');
    localStorage.setItem('66a5s2dttlo$fswe565', '$vr4' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(1, 8) + '3453455');
    localStorage.setItem('99a3s2dgflo$fswe565', '$34f' + token2.substring(9, 20) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'wer345f');
    localStorage.setItem('01a5s2dhglo$fswe565', '$fwe' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(1, 20) + 'werweqe');
    localStorage.setItem('98a0s2ddelo$fswe565', '$5fs' + token2.substring(3, 20) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'fertfdw');
    localStorage.setItem('75a9s2dsslo$fswe565', '$4ff' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(2, 37) + 'werfsfd');
    localStorage.setItem('22a5s2dfflo$fswe565', token2 + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'));
    localStorage.setItem('96a3s2djjlo$fswe565', '$45f' + token2.substring(2, 40) + '435wefs');
    localStorage.setItem('81a4s2dyylo$fswe565', '$4fe' + token2 + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(1, 20) + 'sdtrrdf');
    localStorage.setItem('72a5s2diilo$fswe565', '$5fs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(4, 28) + 'dswe443');
    localStorage.setItem('97a6s2dkklo$fswe568', '$ng4' + token2.substring(7, 27) + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'cvrt433');
    localStorage.setItem('00a7s2dwdlo$fswe567', '$1hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(7, 29) + 'gfdgerg');
    localStorage.setItem('11a7s2dwdlo$fswe566', '$2hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(6, 30) + 'gfdgerg');
    localStorage.setItem('44a7s2dwdlo$fswe565', '$5hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(4, 30) + 'gfdgerg');
    localStorage.setItem('55a7s2dwdlo$fswe564', '$6hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(5, 40) + 'gfdgerg');
    localStorage.setItem('77a7s2dwdlo$fswe563', '$8hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(4, 30) + 'gfdgerg');
    localStorage.setItem('88a7s2dwdlo$fswe562', '$9hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(3, 20) + 'gfdgerg');
    localStorage.setItem('99a7s2dwdlo$fswe562', '$0hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(2, 40) + 'gfdgerg');
    localStorage.setItem('10a7s2dwdlo$fswe561', '$1hs' + moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + token2.substring(1, 30) + 'gfdgerg');

    resolve();
  });
}), defineProperty_default()(_actions, auth["n" /* SET_USER_TOKEN */], function (_ref5, token, jwtToken) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(auth["n" /* SET_USER_TOKEN */], token, jwtToken);

    dispatch(actions_user["d" /* USER_REQUEST */], token, jwtToken);

    resolve();
  });
}), defineProperty_default()(_actions, auth["d" /* AUTH_OK */], function (_ref6) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  return new promise_default.a(function (resolve, reject) {
    resolve();
  });
}), _actions);

var mutations = (_mutations = {}, defineProperty_default()(_mutations, auth["f" /* AUTH_REQUEST */], function (state) {
  state.status = 'loading';
  state.login_error = false;
  state.loadingState = true;
}), defineProperty_default()(_mutations, auth["n" /* SET_USER_TOKEN */], function (state, token, jwtToken) {
  state.status = 'success';
  state.token = token;
  state.jwtToken = jwtToken;
  state.hasLoadedOnce = true;
}), defineProperty_default()(_mutations, auth["g" /* AUTH_SOCIAL */], function (state) {
  state.status = 'loading';
  state.login_error = false;
  state.loadingState = true;
}), defineProperty_default()(_mutations, auth["h" /* AUTH_SUCCESS */], function (state, resp) {
  state.status = 'success';
  state.token = resp;
  state.jwtToken = resp;
  state.hasLoadedOnce = true;
  state.loadingState = false;
}), defineProperty_default()(_mutations, auth["b" /* AUTH_ERROR */], function (state, error) {
  state.status = error;
  state.login_error = true;
  state.hasLoadedOnce = true;
  state.loadingState = false;
}), defineProperty_default()(_mutations, auth["c" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
  state.jwtToken = '';
  state.status = '';
}), defineProperty_default()(_mutations, auth["e" /* AUTH_REGISTRATION */], function (state) {
  state.status = 'loading';
  state.loadingState = true;
}), defineProperty_default()(_mutations, auth["a" /* AUTH_COMPLATE_REGISTRATION */], function (state) {
  state.status = 'loading';
  state.loadingState = true;
}), defineProperty_default()(_mutations, auth["m" /* REGISTRATION_SUCCESS */], function (state) {
  state.status = 'success';
  state.loadingState = false;
}), defineProperty_default()(_mutations, auth["i" /* COMPLATE_REGISTRATION_SUCCESS */], function (state) {
  state.status = 'success';
  state.loadingState = false;
}), defineProperty_default()(_mutations, auth["l" /* REGISTRATION_ERROR */], function (state) {
  state.status = 'error';
  state.loadingState = false;
}), defineProperty_default()(_mutations, auth["j" /* DECRYPT */], function (state, resp) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse("B%t$AD!YMfnCZnfD");
    var ciphertext = crypto_js_default.a.enc.Hex.parse(resp);
    var srcs = crypto_js_default.a.enc.Base64.stringify(ciphertext);
    var decrypt = crypto_js_default.a.AES.decrypt(srcs, ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    var decrypted = decrypt.toString(crypto_js_default.a.enc.Utf8);
    state.tempCrypt = JSON.parse(decrypted);
  } else {
    state.tempCrypt = resp;
  }
}), defineProperty_default()(_mutations, auth["k" /* ENCRYPT */], function (state, resp) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse("B%t$AD!YMfnCZnfD");
    var encrypted = crypto_js_default.a.AES.encrypt(stringify_default()(resp), ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    state.tempEncrypt = encrypted.ciphertext.toString();
  } else {
    state.tempEncrypt = resp;
  }
}), _mutations);

/* harmony default export */ var modules_auth = ({
  state: auth_state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/store/modules/user.js


var user__actions, user__mutations;







var user_state = { status: '', profile: {}, defaultShipData: {}, checkAge: localStorage.getItem('checkAge') || false, acceptCookies: localStorage.getItem('acceptCookies') || false };

var user_getters = {
  getProfile: function getProfile(state) {
    return state.profile;
  },
  getDefaultShipData: function getDefaultShipData(state) {
    return state.defaultShipData;
  },
  isComplateAccount: function isComplateAccount(state) {
    return !!state.profile.name;
  },
  isProfileLoaded: function isProfileLoaded(state) {
    return !!state.profile.name;
  },
  checkAge: function checkAge(state) {
    return !!state.checkAge;
  },
  acceptCookies: function acceptCookies(state) {
    return !!state.acceptCookies;
  }
};
var user_moment = __webpack_require__("PJh5");
var user_actions = (user__actions = {}, defineProperty_default()(user__actions, actions_user["d" /* USER_REQUEST */], function (_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit(actions_user["d" /* USER_REQUEST */]);
  if (localStorage.getItem('22a5s2dffe$fswe565') && localStorage.getItem("11a5s2dffe$fswe561")) {
    var _data;

    //@*&^%%$###%@@#^^ -> token
    //@*&^%($##^%@@#^^ -> jwtToken

    var data = (_data = {

      '@*&^%%$###%@@#^^': localStorage.getItem('22a5s2dffe$fswe565'), //TOKEN
      '@*&^&%$####@@#^^': '$vr4' + user_moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + localStorage.getItem('22a5s2dffe$fswe565').substring(1, 8) + '3453455',
      '@*&^%%$####%@@#^^': '$2y$10$weQPwu16AY/qh1UXJJxkQubT.s0dcVF9rHnwpwDH8URb2ZlaUruJ2',
      '@*&^%%$###%@$!^^': '$34d' + localStorage.getItem('22a5s2dffe$fswe565') + '3',
      '@*&^%($##^%@@#^^': localStorage.getItem("11a5s2dffe$fswe561"), //JWTTOKEN
      '@*&^#%$###%@##^^': '$4fe' + localStorage.getItem("11a5s2dffe$fswe561") + user_moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + localStorage.getItem('22a5s2dffe$fswe565').substring(1, 20) + 'sdtrrdf',
      '@*&^%###$###%@@#^^': '$34f' + localStorage.getItem("11a5s2dffe$fswe561").substring(9, 20) + user_moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ') + 'wer345f'
    }, defineProperty_default()(_data, '@*&^%%$###%@$!^^', '$34d' + localStorage.getItem('22a5s2dffe$fswe565') + '3'), defineProperty_default()(_data, '@*&^%%$###%@$!^#^', '$33d' + localStorage.getItem("11a5s2dffe$fswe561") + '2'), defineProperty_default()(_data, '@*&^%%$###%@$!^^&^', '$32d' + localStorage.getItem('22a5s2dffe$fswe565') + '3'), defineProperty_default()(_data, '@*&^%%$###%@$!^)(^', '$31d' + localStorage.getItem("11a5s2dffe$fswe561") + '3'), defineProperty_default()(_data, '@*&^%%$###%@$!^)^', '$38d' + localStorage.getItem('22a5s2dffe$fswe565') + '3'), _data);
    commit(auth["k" /* ENCRYPT */], data);
    data = modules_auth.state.tempEncrypt;
    axios_default()({ url: "https://wsbot.eu/ebonusBack/public/" + 'api/getUser', data: { data: data }, method: 'POST', headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
      commit(auth["j" /* DECRYPT */], resp.data);
      resp.data = modules_auth.state.tempCrypt;
      commit(actions_user["f" /* USER_SUCCESS */], resp.data);
      dispatch(auth["d" /* AUTH_OK */]);
    }).catch(function (resp) {
      commit(auth["j" /* DECRYPT */], resp.response.data);
      resp.response.data = modules_auth.state.tempCrypt;
      dispatch(auth["c" /* AUTH_LOGOUT */], resp.response.data.message);

      commit(actions_user["c" /* USER_ERROR */], resp.response.data.message);
      // if resp is unauthorized, logout, to
    });
  }
}), defineProperty_default()(user__actions, actions_user["g" /* USER_UPDATE_DATA */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit(actions_user["g" /* USER_UPDATE_DATA */]);
}), defineProperty_default()(user__actions, actions_user["e" /* USER_SET_DEFAULT_SHIP_DATA */], function (_ref3, shipData) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  commit(actions_user["e" /* USER_SET_DEFAULT_SHIP_DATA */], shipData);
}), defineProperty_default()(user__actions, actions_user["b" /* USER_CHECK_AGE */], function (_ref4) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  localStorage.setItem('checkAge', true); // store the token in localstorage
  commit(actions_user["b" /* USER_CHECK_AGE */]);
}), defineProperty_default()(user__actions, actions_user["a" /* ACCEPT_COOKIES */], function (_ref5) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  localStorage.setItem('acceptCookies', true); // store the token in localstorage
  commit(actions_user["a" /* ACCEPT_COOKIES */]);
}), user__actions);

var user_mutations = (user__mutations = {}, defineProperty_default()(user__mutations, actions_user["d" /* USER_REQUEST */], function (state) {
  state.status = 'loading';
}), defineProperty_default()(user__mutations, actions_user["f" /* USER_SUCCESS */], function (state, resp) {
  state.status = 'success';
  vue_esm["a" /* default */].set(state, 'profile', resp.user);
}), defineProperty_default()(user__mutations, actions_user["c" /* USER_ERROR */], function (state, resp) {
  state.status = resp;
}), defineProperty_default()(user__mutations, actions_user["g" /* USER_UPDATE_DATA */], function (state) {
  state.status = 'success';
  vue_esm["a" /* default */].set(state.profile, 'support_id', true);
}), defineProperty_default()(user__mutations, auth["c" /* AUTH_LOGOUT */], function (state) {
  state.profile = {};
}), defineProperty_default()(user__mutations, actions_user["e" /* USER_SET_DEFAULT_SHIP_DATA */], function (state, shipData) {
  vue_esm["a" /* default */].set(state, 'defaultShipData', shipData);
}), defineProperty_default()(user__mutations, actions_user["b" /* USER_CHECK_AGE */], function (state) {
  state.checkAge = true;
}), defineProperty_default()(user__mutations, actions_user["a" /* ACCEPT_COOKIES */], function (state) {
  state.acceptCookies = true;
}), user__mutations);

/* harmony default export */ var modules_user = ({
  state: user_state,
  getters: user_getters,
  actions: user_actions,
  mutations: user_mutations
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./src/store/actions/notifications.js
var notifications = __webpack_require__("1mNM");

// CONCATENATED MODULE: ./src/store/modules/notifications.js




var notifications__actions;

/* eslint-disable promise/param-names */




var notifications_state = {
  notifications: localStorage.getItem('notifications') || {},
  status: '',
  count: 0
};

var notifications_getters = {
  hasNotifications: function hasNotifications(state) {
    return !!state.notifications;
  },
  NotificationsStatus: function NotificationsStatus(state) {
    return state.status;
  },
  getNotifications: function getNotifications(state) {
    return state.notifications;
  },
  getNotificationsCount: function getNotificationsCount(state) {
    return state.count;
  }
};

var notifications_actions = (notifications__actions = {}, defineProperty_default()(notifications__actions, notifications["a" /* ADD_NOTIFICATIONS */], function (_ref, value) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new promise_default.a(function (resolve, reject) {
    commit(notifications["a" /* ADD_NOTIFICATIONS */], value);
    //localStorage.removeItem('user-token'.process.env.PROJECT)
    resolve();
  });
}), defineProperty_default()(notifications__actions, notifications["b" /* GET_NOTIFICATIONS */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new promise_default.a(function (resolve, reject) {
    resolve();
  });
}), notifications__actions);

var notifications_mutations = defineProperty_default()({}, notifications["a" /* ADD_NOTIFICATIONS */], function (state, value) {
  var notf = state.notifications;
  var size = 0,
      key;
  for (key in notf) {
    if (notf.hasOwnProperty(key)) size++;
  }
  notf[size] = value;
  // /notf = notf.slice().reverse();
  vue_esm["a" /* default */].set(state, 'count', size + 1);
  state.notifications = assign_default()({}, state.notifications, notf);
});

/* harmony default export */ var modules_notifications = ({
  state: notifications_state,
  getters: notifications_getters,
  actions: notifications_actions,
  mutations: notifications_mutations
});
// CONCATENATED MODULE: ./src/store/index.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  modules: {
    user: modules_user,
    auth: modules_auth,
    notifications: modules_notifications
  },
  strict: debug
}));

/***/ }),

/***/ "Idp3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("P5nk");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1df3e0e5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-83256d60\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./hoval.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-83256d60\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./hoval.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JHcX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-2a523c12]{\n\tfont-size: 18px;\n}\n.page__title[data-v-2a523c12]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-2a523c12] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-2a523c12] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-2a523c12]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-2a523c12]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-2a523c12] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "Jkjn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traficLight_yellow.622eb7a.png";

/***/ }),

/***/ "K4Pf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  LOADSCREEN  */\n.bg_load[data-v-6428c8d2] {\n\t\n\tposition: fixed;\n\tleft: 0px;\n\ttop: 0px;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #00000082;\n\tz-index: 100;\n}\n.imgLoad[data-v-6428c8d2]{\n\tposition: absolute;\n\ttop: 48.5%;\n\tmargin-left: 48.5vw;\n\twidth: 3vw;\n\tbackground: transparent;\n}\n@media (min-width: 767px) and (max-width: 1140px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 47.5%;\n\t\tmargin-left: -1.5vw;\n\t\twidth: 5vw;\n}\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.imgLoad[data-v-6428c8d2]{\n\t\tposition: absolute;\n\t\ttop: 45%;\n\t\tmargin-left: -1.5vw;\n\t\twidth: 10vw;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.1","C:\\wamp64\\www\\21071_EASYBONUS_KPMG"]],"_development":true,"_from":"elliptic@6.4.1","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.1","saveSpec":null,"fetchSpec":"6.4.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_spec":"6.4.1","_where":"C:\\wamp64\\www\\21071_EASYBONUS_KPMG","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),

/***/ "KwyM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ki2I");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("824e365e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62fe346e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-62fe346e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "LUuT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/headerTitle.7c9f9c0.png";

/***/ }),

/***/ "LdOU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/arial.c3c1625.woff";

/***/ }),

/***/ "MMz/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAAB4BAMAAACHqbN1AAAAHlBMVEVHcEwAapsAapsAapsAapsAapsAapsAapsAapsAapsAKJE5AAAACXRSTlMAetqbuypLZhG7plTfAAAD70lEQVR42u3bzU8aQRQA8EFYWG+kGAk3tcR0b1CIhpsCh3LbtAXlhk3AegONEG6bJjZ4Kwulff9t52N3GVZsFRmcNO8dWNjP3868+RBZQjAwMDAw9A8LALoauuKgKWxLV1hGU5gBmsI+agozLU1hosD0g8VBU1hJU9gX0BP2CfSE3YCesDggbBXYuKQpLKkpbEb0hLm2prAc0RN2SPSEHRI9YUdET5g8wUAYwhCGMIQhDGEIQxjCEIYwhCmB1WmMHJ1g5oiZSI1/heRmK4V0+/x1YXeNXqFYFv/HmHowL9xqvu28BsxspKqWLAnBeGTz7c3CGqnyA8SUpIrVavkgtNqt9J3NwMzLohW6+EG2Wq0c+zuM6p1eqmzJtltHNcw8k1VuNp/u1EeP5N+lVKzuaVtl79LYsaT06f+75d1JpTs9ttWojJualDf2M/IxOO7trbNulXn2Prjz57e0RsovNzf/dZ2s79KJV8yVs2KQA7trqlLjIsjhyq0G51Fxp2soeVW5IeXqyra5CirrbE2rtm5xsNr+R7pnNpw+8a5NeSB8YS48cQTJFgZ/15mNQaH8ojFuZRufJ6X77cUBblRvXPZCsxi1qiWVI80JvFiyKfuSSd5z03kpbimqb5PNhtnoFcvW4yQ6W09vrKSWTEU6g1SBzjQDoUvneYX8oHNOMDAwMDAwMDAw/veI8BngvuM9SgDQoisvAMZsWQP68gbg1N8PoLvNF7v84CaMpS1XkFw7DH7KMP5b9IkjYFfiN4ohmDBkwFUNm0ow8bQD7HGY+ODaYdiMHcx3VwujFwhgTfFmzGFRujRKkAzDaFF5P19UBqO1aFj0nBnw/hYrwbRFrgE4bAtOCNlmxSfe0vc5fju0pmMwgd8k2KIARs+ZC2Am/3aaWlsCNvN3lWDEYjvfwxH82hwsAhO2uN7lJRajTXYJrMZ2HkKLJadCWFxUpcis6LyMKCzBGmgrDIuyimabxd2ogYlwAliMl6EP4/95cLsyzG8aBi1agVEIG5NF2JB3VQyW4G3QCcPesUNndN0PtbDWozASYd83noRgrPtlqAivd3WwLu/G/eSfLcD4wxmzRZgrBqQkrc6pwuTP8Ov6sLhoac05jPeyUvLTtvKBBEOFow6W8Koy6MeScxhfayzCyDdeZBCMmsq6i4x4kXv+C68qr9g14yGYyboX/2GSPYWwqDSIs/LwH13hPf/EFnC5H2vSyhf9XYy9KoMZEHSw9LKGPIjH57OchbHSde55T5Fg44S6IWnIm4AHI5/5RMiW5mPjh2NlbsgdJst+dbAozeY5jCXYvu3PYHe8DwswWpclPtmlGdlVAsPAwMDQOf4A8UXF8RTUI+kAAAAASUVORK5CYII="

/***/ }),

/***/ "MPp2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+tnh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0eab8069", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a1cdd68\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3a1cdd68\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Mda3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/@babel/polyfill/lib/index.js
var lib = __webpack_require__("u7Vc");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/store/actions/auth.js
var auth = __webpack_require__("+4WN");

// EXTERNAL MODULE: ./src/store/actions/user.js
var user = __webpack_require__("yLEp");

// EXTERNAL MODULE: ./src/store/actions/notifications.js
var notifications = __webpack_require__("1mNM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/navigation/index.vue



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var moment = __webpack_require__("PJh5");

/* harmony default export */ var navigation = ({
  name: "navigation",
  components: {},
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      scroll: 0,
      toggleTabState: "close",
      vw: window.innerWidth,
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      notifications: {},
      countNotification: 0,
      showNotification: false,
      menuOFF: false,
      hasPrev: true,
      adminIs: false
    };
  },


  methods: (_methods = {
    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    },
    toggleTab: function toggleTab() {
      this.$log(this.toggleTabState);
      if (this.toggleTabState == "close") {
        this.toggleTabState = "open";
      } else {
        this.toggleTabState = "close";
      }
    },
    toggleNotification: function toggleNotification() {
      if (this.showNotification) {
        this.showNotification = false;
      } else {
        this.showNotification = true;
      }
    },

    updateScroll: function updateScroll() {
      this.scroll = window.pageYOffset;
    },
    outside2: function outside2(e) {
      if (this.toggleTabState == "open") {
        this.toggleTabState = "close";
      }
    },
    outside3: function outside3(e) {
      if (this.showNotification) {
        this.showNotification = false;
      }
    },
    doAcceptCookies: function doAcceptCookies() {
      this.$store.dispatch(user["a" /* ACCEPT_COOKIES */]).then(function (resp) {
        //this.$router.push('/')
      });
    },
    logout: function logout() {
      var _this = this;

      this.$store.dispatch(auth["c" /* AUTH_LOGOUT */]).then(function () {
        return _this.$router.push("/login");
      });
    }
  }, defineProperty_default()(_methods, "handleResize", function handleResize() {
    this.vw = window.innerWidth;
  }), defineProperty_default()(_methods, "checkForfettario", function checkForfettario() {
    if (this.getProfile) {
      if (this.profile.corporateClient == "agnellimetalli") {
        this.hasPrev = false;
      }
      if (this.profile.corporateClient == "hoval") {
        this.hasPrev = true;
      }
      if (this.profile.corporateClient == "emicon") {
        this.hasPrev = true;
      }
      if ((this.getProfile.tipo_azienda == "Ditta Individuale" || this.getProfile.tipo_azienda == "Professionista iscritto ad albi") && this.getProfile.reg_forfettario == "0") {
        this.$swal({
          type: "warning",
          title: "Attenzione!",
          text: "Indica nell`apposito form se rientri o meno nel Regime Forfettario e clicca sul pulsante SALVA."
        });

        this.$router.push("/account");
      }
    }
  }), defineProperty_default()(_methods, "setProfile", function setProfile() {
    this.$warn(this.profile);
    //type 1 => no preventivatore
    if (this.profile.corporateClient == "agnellimetalli") {
      this.hasPrev = false;
    }
    if (this.profile.corporateClient == "hoval") {
      this.hasPrev = true;
    }
    if (this.profile.status == "admin") {
      this.adminIs = true;
    } else if (this.profile.status == "user") {
      this.adminIs = false;
    }
  }), _methods),
  watch: {
    getProfile: function getProfile() {
      this.checkForfettario();
      this.setProfile();
      if (this.profile.corporateClient == "agnellimetalli") {
        this.hasPrev = false;
      }
      if (this.profile.corporateClient == "hoval") {
        this.hasPrev = true;
      }
    },

    getNotifications: function getNotifications() {
      this.notifications = this.getNotifications;
      this.countNotification = this.getNotificationsCount;

      // CHECK MENU OFF
      for (var x in this.notifications) {
        if (this.notifications[x].type == "MENU_OFF") {
          this.menuOFF = true;
        }
      }

      this.$log("NEW NOTIFICATION");
      this.$log(this.showNotification);
      var _vue = this;
      setTimeout(function () {
        //_vue.showNotification = true
      }, 200);
      setTimeout(function () {
        //_vue.showNotification = false
      }, 12000);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getNotificationsCount", "getProfile", "isAuthenticated", "isProfileLoaded", "acceptCookies", "checkAge"]), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === "loading";
    },
    name: function name(state) {
      return "" + state.user.profile.name;
    },
    profile: function profile(state) {
      return state.user.profile;
    },
    managedArea: function managedArea(state) {
      return state.user.profile.type;
    }
    //notifications: state => `${state.notifications}`,
  })),
  updated: function updated() {},
  mounted: function mounted() {
    var _vue = this;
    window.addEventListener("scroll", this.updateScroll);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.checkForfettario();
    this.setProfile();
    if (this.profile.corporateClient == "agnellimetalli") {
      this.hasPrev = false;
    }
    if (this.profile.corporateClient == "hoval") {
      this.hasPrev = true;
    }
  },

  directives: {
    "click-outside": {
      bind: function bind(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          var compName = vNode.context.name;
          var warn = "[Vue-click-outside:] provided expression '" + binding.expression + "' is not a function, but has to be";
          if (compName) {
            warn += "Found in component '" + compName + "'";
          }

          this.$warn(warn);
        }
        // Define Handler and cache it on the element
        var bubble = binding.modifiers.bubble;
        var handler = function handler(e) {
          if (bubble || !el.contains(e.target) && el !== e.target) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function unbind(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eacecb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/index.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull", attrs: { id: "site-nav" } }, [
    _c(
      "nav",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.menuOFF,
            expression: "!menuOFF"
          }
        ],
        staticClass: "navbar navbar-light navbar-expand-lg fixed-top",
        class: { navGreen: _vm.scroll > 30 || _vm.$route.path != "/" },
        staticStyle: { "z-index": "11" }
      },
      [
        _c("div", { staticClass: "container widthFull" }, [
          _c(
            "div",
            { staticClass: "navbar-header" },
            [
              _c(
                "router-link",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: ".main",
                      expression: "'.main'"
                    }
                  ],
                  staticClass:
                    "navbar-brand router-link-exact-active router-link-active",
                  attrs: { to: "/" }
                },
                [
                  _c("img", {
                    ref: "mainNavLogo",
                    staticClass: "img-fluid logo ml-3",
                    attrs: {
                      src: __webpack_require__("iQH9"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._m(0)
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse flex-column ml-0 pl-3",
              attrs: { id: "navbarCollapse" }
            },
            [
              _c("ul", { staticClass: "navbar-nav ml-auto mb-lg-0 mb-5" }, [
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: ".main",
                                expression: "'.main'"
                              }
                            ],
                            staticClass: "nav-link",
                            attrs: {
                              to: "/",
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Home")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _c("li", { staticClass: "nav-item dropdown mr-0 pd-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link dropdown-toggle menuItem mr-0 pd-0",
                          attrs: {
                            href: "#",
                            id: "navbardrop",
                            "data-toggle": "dropdown"
                          }
                        },
                        [_vm._v("\n                Home\n              ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu bgDrop",
                          attrs: {
                            "data-toggle": "collapse ",
                            "data-target": ".navbar-collapse.show"
                          }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: ".main",
                                  expression: "'.main'"
                                }
                              ],
                              staticClass: "dropdown-item menuItem",
                              attrs: {
                                to: "/",
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("HOME")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: { el: "#howplay", offset: -45 },
                                  expression: "{ el: '#howplay', offset: -45 }"
                                }
                              ],
                              staticClass: "dropdown-item menuItem",
                              attrs: {
                                to: "/",
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Come funziona")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: { el: "#services", offset: -45 },
                                  expression: "{ el: '#services', offset: -45 }"
                                }
                              ],
                              staticClass: "dropdown-item menuItem",
                              attrs: {
                                to: { path: "/" },
                                "data-toggle": "collapse",
                                "data-target": ".navbar-collapse.show"
                              }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Servizi")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#howplay", offset: -45 },
                                expression: "{ el: '#howplay', offset: -45 }"
                              }
                            ],
                            staticClass: "nav-link",
                            attrs: {
                              to: "/",
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Come funziona")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#services", offset: -45 },
                                expression: "{ el: '#services', offset: -45 }"
                              }
                            ],
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Servizi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded && _vm.hasPrev
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/calcolatore" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Crea Nuovo Preventivo")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded && _vm.hasPrev
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/offerte" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Preventivi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded && !_vm.hasPrev
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/calcolatore" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Crea Pratica")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "nav-link",
                            attrs: {
                              to: { path: "/pratiche" },
                              "data-toggle": "collapse",
                              "data-target": ".navbar-collapse.show"
                            }
                          },
                          [
                            _c("span", { staticClass: "menuItem Bold" }, [
                              _vm._v("Gestione Pratiche")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isProfileLoaded
                  ? _c("li", { staticClass: "nav-item dropdown mr-0 pd-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-link dropdown-toggle menuItem mr-0 pd-0",
                          attrs: {
                            href: "#",
                            id: "navbardrop",
                            "data-toggle": "dropdown"
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "pointer mr-0 pd-0",
                            attrs: { icon: "user", size: "1x" }
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.getProfile.name) +
                              " " +
                              _vm._s(_vm.getProfile.lastname) +
                              "\n              "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu bgDrop",
                          attrs: {
                            "data-toggle": "collapse ",
                            "data-target": ".navbar-collapse.show"
                          }
                        },
                        [
                          !_vm.adminIs
                            ? _c(
                                "router-link",
                                {
                                  directives: [
                                    {
                                      name: "scroll-to",
                                      rawName: "v-scroll-to",
                                      value: ".main",
                                      expression: "'.main'"
                                    }
                                  ],
                                  staticClass: "dropdown-item menuItem",
                                  attrs: {
                                    to: "/account",
                                    "data-toggle": "collapse",
                                    "data-target": ".navbar-collapse.show"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "menuItem ipadMenu" },
                                    [_vm._v("Modifica Profilo")]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item pointer menuItem black",
                              on: { click: _vm.logout }
                            },
                            [
                              _c("span", { staticClass: "menuItem ipadMenu" }, [
                                _vm._v("Esci")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isProfileLoaded
                  ? _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        attrs: {
                          "data-toggle": "collapse",
                          "data-target": ".navbar-collapse.show"
                        }
                      },
                      [
                        _c(
                          "router-link",
                          { staticClass: "nav-link", attrs: { to: "/login" } },
                          [
                            _c("span", { staticClass: "menuItem" }, [
                              _vm._v("Accedi")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "notificationContent",
              class: { notificationC: _vm.showNotification }
            },
            [
              _c(
                "div",
                { staticClass: "container relative pb-5 maxNotification" },
                [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center widthFull" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-8 pl-5 pb-2 pt-4 pb-4 reverse" },
                        [
                          _vm._l(_vm.notifications, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "row justify-content-center widthFull"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-11 pl-5 mb-2",
                                    class: {
                                      errorBg: item.type == "ERROR",
                                      successBg: item.type == "SUCCESS"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(parseInt(index) + 1) +
                                        ") "
                                    ),
                                    _c("span", {
                                      domProps: { innerHTML: _vm._s(item.text) }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.countNotification == 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-content-center widthFull"
                                },
                                [_vm._m(2)]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }),
    _vm._v(" "),
    _vm.vw > 767
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.menuOFF,
                expression: "!menuOFF"
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.outside3,
                expression: "outside3"
              }
            ],
            staticClass: "sidetab2"
          },
          [
            _c(
              "div",
              { staticClass: "label", on: { click: _vm.toggleNotification } },
              [
                _vm.vw < 533
                  ? _c("img", {
                      staticClass: "img-fluid contactImg",
                      attrs: {
                        src: __webpack_require__("3Dg/")
                      }
                    })
                  : _c("span", [
                      _c("img", {
                        staticClass: "leftIm2",
                        attrs: {
                          src: __webpack_require__("jkql")
                        }
                      }),
                      _vm._v("\n          Notifiche\n          "),
                      _vm.countNotification
                        ? _c("span", [_vm._v(_vm._s(_vm.countNotification))])
                        : _vm._e()
                    ])
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.acceptCookies
      ? _c("div", { staticClass: "container-fluid fixed cookieBaner" }, [
          _c("div", { staticClass: "row justify-content-center widthFull" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-sm-10 col-md-9 col-lg-6 pt-sm-0 pt-md-3"
              },
              [
                _c("span", { staticClass: "cookieText" }, [
                  _vm._v(
                    "\n            Utilizziamo i cookie al fine di personalizzare e migliorare la tua\n            esperienza sul nostro sito. Visita la nostra\n            "
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        color: "#f39324 !important",
                        "text-decoration": "underline"
                      },
                      attrs: { target: "_blank", href: _vm.cookiePolicy }
                    },
                    [_vm._v("informativa")]
                  ),
                  _vm._v(
                    "\n            per acquisire maggiori informazioni. Utilizzando il nostro sito\n            accetti l'utilizzo dei cookie da parte nostra.\n          "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "\n            col-12 col-sm-2\n            center\n            col-md-2 col-lg-2\n            mt-sm-5\n            pt-3 pt-md-2\n            mt-md-3\n          "
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary btn-lg yellowBtn mb-5 pr-3 pl-3",
                    on: { click: _vm.doAcceptCookies }
                  },
                  [_vm._v("\n            OK\n          ")]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "\n              navbar-toggler navbar-toggler-right\n              align-self-center\n              navbar-toggle\n              collapsed\n            ",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarCollapse",
          "aria-expanded": "false"
        }
      },
      [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Toggle navigation")]),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar top-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar middle-bar" }),
        _vm._v(" "),
        _c("span", { staticClass: "icon-bar bottom-bar" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 pl-5 pb-2" }, [
      _c("h2", { staticClass: "black widthFull pb-0 mb-1" }, [
        _c("b", { staticClass: "widthFull" }, [_vm._v("Notifiche")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "widthFull" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center pl-5" }, [
      _c("h5", {}, [_c("b", [_vm._v("Non hai nessuna notifica")])])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_navigation = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eacecb2", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/navigation/index.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("QCBm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1eacecb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  navigation,
  components_navigation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/navigation/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1eacecb2", Component.options)
  } else {
    hotAPI.reload("data-v-1eacecb2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_components_navigation = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var footer_moment = __webpack_require__("PJh5");

/* harmony default export */ var footer = ({
  name: "sqreen-footer",
  data: function data() {
    return {
      moment: footer_moment,
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf"
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "loadingState", "isAuthenticated", "isProfileLoaded", "authStatus", "checkAge"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fe346e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/index.vue
var footer_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container footer", attrs: { id: "footer" } },
    [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-md-12 align-self-center center pt-2 pr-0" },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row justify-content-center" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-11 align-self-center text-left" },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "black Bold text-left pb-3 pt-3",
                        staticStyle: { "line-height": "30px" }
                      },
                      [
                        _vm._v(
                          "\n              © " +
                            _vm._s(_vm.moment().format("YYYY")) +
                            "\n\n              KPMG S.p.A., KPMG Advisory S.p.A., KPMG Fides Servizi di\n              Amministrazione S.p.A. e KPMG Audit S.p.A., società per azioni\n              di diritto italiano, KPMG Business Services S.r.l., società a\n              responsabilità limitata di diritto italiano, e Studio Associato\n              - Consulenza legale e tributaria, associazione professionale di\n              diritto italiano, fanno parte del network KPMG di entità\n              indipendenti affiliate a KPMG International Limited, società di\n              diritto inglese. Tutti i diritti riservati. Per maggiori\n              dettagli sulla struttura organizzativa di KPMG a livello\n              globale, visita il sito\n              "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "green link underline",
                            attrs: { href: "https://www.home.kpmg/governance" }
                          },
                          [_vm._v("home.kpmg/governance")]
                        ),
                        _vm._v(".\n            ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "green",
                        attrs: { href: _vm.privacyPolicy, target: "_blank" }
                      },
                      [_c("b", [_vm._v("Privacy Policy")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "green ml-5",
                        attrs: { href: _vm.cookiePolicy, target: "_blank" }
                      },
                      [_c("b", [_vm._v("Cookie Policy")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "green ml-5",
                        attrs: { href: _vm.utilizzoPolicy, target: "_blank" }
                      },
                      [_c("b", [_vm._v("Termini di utilizzo")])]
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row pb-5" })
    ]
  )
}
var footer_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 col-md-6 text-left pt-2 pr-0" }, [
      _c("img", {
        staticClass: "img-fluid widthFull",
        staticStyle: { "max-width": "300px" },
        attrs: { src: __webpack_require__("ndT8") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-6 align-self-center text-right black pl-0" },
      [
        _c("div", { staticClass: "footer__social" }, [
          _c("ul", { staticClass: "social" }, [
            _c("li", { staticClass: "social__facebook" }, [
              _c(
                "a",
                {
                  staticStyle: {
                    "background-image":
                      "url(data:image/png;base64,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)"
                  },
                  attrs: {
                    target: "_blank",
                    href: "https://www.facebook.com/kpmgitaly/",
                    title: "Facebook",
                    "data-ga-tracking":
                      "{ 'category': 'text', 'action': 'footer', 'label': 'facebook' }"
                  }
                },
                [_vm._v("Facebook")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "social__youtube" }, [
              _c(
                "a",
                {
                  staticStyle: {
                    "background-image":
                      "url(data:image/png;base64,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)"
                  },
                  attrs: {
                    target: "_blank",
                    href: "https://www.youtube.com/c/KPMGItaly",
                    title: "Youtube",
                    "data-ga-tracking":
                      "{ 'category': 'text', 'action': 'footer', 'label': 'youtube' }"
                  }
                },
                [_vm._v("Youtube")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "social__linkedin" }, [
              _c(
                "a",
                {
                  staticStyle: {
                    "background-image":
                      "url(data:image/png;base64,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)"
                  },
                  attrs: {
                    target: "_blank",
                    href: "https://www.linkedin.com/company/kpmg-italy",
                    title: "Linkedin",
                    "data-ga-tracking":
                      "{ 'category': 'text', 'action': 'footer', 'label': 'linkedin' }"
                  }
                },
                [_vm._v("Linkedin")]
              )
            ])
          ])
        ])
      ]
    )
  }
]
footer_render._withStripped = true
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var components_footer = (footer_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62fe346e", footer_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/footer/index.vue
var footer_disposed = false
function footer_injectStyle (ssrContext) {
  if (footer_disposed) return
  __webpack_require__("KwyM")
}
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = footer_injectStyle
/* scopeId */
var footer___vue_scopeId__ = "data-v-62fe346e"
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  components_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)
footer_Component.options.__file = "src/components/footer/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62fe346e", footer_Component.options)
  } else {
    hotAPI.reload("data-v-62fe346e", footer_Component.options)
  }
  module.hot.dispose(function (data) {
    footer_disposed = true
  })
})()}

/* harmony default export */ var src_components_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  components: {
    SqreenFooter: src_components_footer,
    Navigation: src_components_navigation
    //loading,
  },
  name: 'app',
  data: function data() {
    return {
      fullscreen: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isAuthenticated'])),
  watch: {
    isAuthenticated: function isAuthenticated() {
      this.$store.dispatch(user["d" /* USER_REQUEST */]);
    }
  },
  mounted: function mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch(user["d" /* USER_REQUEST */]);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("vue-headful", {
        attrs: {
          title: "BONUS FACILE",
          description:
            "Incentivi fiscali. Ci pensiamo noi. Offri ai tuoi clienti sconti immediati direttamente in fattura. Noi gestiamo tutta la parte burocratica"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("navigation"),
          _vm._v(" "),
          _c("div", { staticClass: "main-container" }, [_c("router-view")], 1)
        ],
        1
      ),
      _vm._v(" "),
      _c("sqreen-footer")
    ],
    1
  )
}
var App_staticRenderFns = []
App_render._withStripped = true
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", App_esExports)
  }
}
// CONCATENATED MODULE: ./src/App.vue
var App_disposed = false
function App_injectStyle (ssrContext) {
  if (App_disposed) return
  __webpack_require__("x3vu")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-7ba5bd90"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)
App_Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", App_Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", App_Component.options)
  }
  module.hot.dispose(function (data) {
    App_disposed = true
  })
})()}

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var home_moment = __webpack_require__("PJh5");

/* harmony default export */ var home = ({
  components: {},
  data: function data() {
    return {
      moment: __webpack_require__("PJh5"),
      status: 'home',
      id: '',
      hasPrev: false

    };
  },

  name: 'home',
  methods: {
    showError: function showError(text) {
      this.$swal({
        type: 'error',
        title: text,
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#b61617'

      });
    },


    setProfile: function setProfile() {

      //type 1 => no preventivatore
      if (this.profile.type == 1) {
        this.hasPrev = false;
      }
      if (this.profile.status == 'admin') {
        this.adminIs = true;
      } else if (this.profile.status == 'user') {
        this.adminIs = false;
      }
    }
  },
  watch: {

    getProfile: function getProfile() {
      this.setProfile();
    }

  },
  mounted: function mounted() {
    this.setProfile();
  },
  beforeUpdate: function beforeUpdate() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['isAuthenticated', 'authStatus', 'getProfile']), Object(vuex_esm["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    },
    profile: function profile(state) {
      return state.user.profile;
    },
    managedArea: function managedArea(state) {
      return state.user.profile.type;
    }
  }), {
    loading: function loading() {
      return this.authStatus === 'loading' && !this.isAuthenticated;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f3a69c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
var home_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull " }, [
    _c("div", { staticClass: "widthFull headerBack section" }, [
      _c("div", { staticClass: "container dataContainer" }, [
        _c("div", { staticClass: "row justify-content-center " }, [
          _c("div", { staticClass: "col-md-6 " }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 pt-5 mt-5 text-md-right text-center" },
            [
              _c("img", {
                staticClass: "img-fluid widthFull",
                attrs: { src: __webpack_require__("LUuT") }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: "#howplay",
                      expression: "'#howplay'"
                    }
                  ],
                  staticClass: "btn btn-primary btnYellow btn-lg mr-md-4 mt-5",
                  attrs: { type: "button" }
                },
                [_vm._v("SCOPRI DI PIÙ")]
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "widthFull howplayBack section",
        attrs: { id: "howplay" }
      },
      [
        _c("div", { staticClass: "container " }, [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("div", { staticClass: "col-md-5 pt-5  center" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-7 pt-5 mb-5 center " }, [
              _c("img", {
                staticClass: "img-fluid widthFull pt-5 howPlayTitle",
                attrs: {
                  src: __webpack_require__("5j5C")
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "row justify-content-center align-items-center"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-6 center" },
                    [
                      _vm.hasPrev && _vm.isAuthenticated
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                              attrs: { to: "/calcolatore" }
                            },
                            [_vm._v("Calcolatore Preventivi")]
                          )
                        : !_vm.hasPrev && _vm.isAuthenticated
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                              attrs: { to: "/calcolatore" }
                            },
                            [_vm._v("Crea pratica")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "widthFull servicesBack section",
        attrs: { id: "services" }
      },
      [
        _c("div", { staticClass: "container " }, [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("div", { staticClass: "col-md-4 pt-5  center" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8 pt-5 mb-5 center " }, [
              _c("img", {
                staticClass: "img-fluid widthFull pt-5 howPlayTitle",
                attrs: {
                  src: __webpack_require__("7UA4")
                }
              }),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _vm._m(8),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-right " }, [
                _c("div", { staticClass: "col-md-6 center" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6 center" },
                  [
                    _vm.hasPrev && _vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                            attrs: { to: "/calcolatore" }
                          },
                          [_vm._v("Calcolatore Preventivi")]
                        )
                      : !_vm.hasPrev && _vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btnYellow mr-4 mt-2 ",
                            attrs: { to: "/calcolatore" }
                          },
                          [_vm._v("Crea pratica")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var home_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-5" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: __webpack_require__("MMz/") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n                  "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-5" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: __webpack_require__("FLts") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-1" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: __webpack_require__("yIMT") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-1" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: __webpack_require__("1SEM") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "howplayContainers center mt-1" }, [
        _c("img", {
          staticClass: "img-fluid widthFull widthFull howPlayImg",
          attrs: { src: __webpack_require__("PFng") }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "pl-2 pr-2 pb-2 noVisible" }, [
          _vm._v(
            "\r\n\t\t\t\t\t\t\t\t\tLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has\r\n\t\t\t\t\t\t\t\t\t been the industry's\r\n\t\t\t\t\t\t\t\t\t"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pt-5 pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: __webpack_require__("Mda3") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("BONUS CASA")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "Lavori di ristrutturazione di abitazioni e parti comuni di edifici residenziali\r\n                  Per saperne di più\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow link green underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: __webpack_require__("h0Rp") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("ECOBONUS")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "interventi di riqualificazione energetica degli edifici esistenti: sostituzione della vecchia caldaia con una caldaia a condensazione in classe A,\r\n                  installazione di pannelli solari  o sostituzione di impianti di riscaldamento con pompe di calore ad alta efficienza ed impianti geotermici a bassa entalpia.\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow green link underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: __webpack_require__("oOUs") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black  smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("ECOBONUS")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "interventi di riqualificazione energetica degli edifici esistenti: sostituzione della vecchia caldaia con una caldaia a condensazione in classe A\r\n                   abbinata a sistemi di termoregolazione evoluti (appartenenti alle classi V, VI o VIII), installazione di pannelli solari  o sostituzione di impianti di\r\n                  riscaldamento con pompe di calore ad alta efficienza ed impianti geotermici a bassa entalpia .\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow link green underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: " center" }, [
          _c("img", {
            staticClass: "img-fluid widthFull widthFull ",
            attrs: { src: __webpack_require__("q2yx") }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "text-left" }, [
          _c("p", { staticClass: "pl-2 pr-2 black smallDesc" }, [
            _c("strong", { staticClass: "h4 black" }, [
              _c("b", [_vm._v("SUPERBONUS")])
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "Detrazione per le spese sostenute per specifici interventi di riqualificazione energetica dal 1° luglio 2020 al 31 dicembre 2021\r\n                  "
            ),
            _c("br"),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "yellow link green underline",
                attrs: { target: "_blank", href: "https://www" }
              },
              [_vm._v(" Per saperne di più")]
            )
          ])
        ])
      ])
    ])
  }
]
home_render._withStripped = true
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var components_home = (home_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f3a69c", home_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/home/index.vue
var home_disposed = false
function home_injectStyle (ssrContext) {
  if (home_disposed) return
  __webpack_require__("879u")
}
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = home_injectStyle
/* scopeId */
var home___vue_scopeId__ = "data-v-67f3a69c"
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  home,
  components_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)
home_Component.options.__file = "src/components/home/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-67f3a69c", home_Component.options)
  } else {
    hotAPI.reload("data-v-67f3a69c", home_Component.options)
  }
  module.hot.dispose(function (data) {
    home_disposed = true
  })
})()}

/* harmony default export */ var src_components_home = (home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/regulation/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var regulation = ({
  name: 'regulation',
  data: function data() {
    return {
      loadingState: '',
      userToken: ''
    };
  },

  methods: {},
  watch: {},
  mounted: function mounted() {},
  computed: Object(vuex_esm["c" /* mapState */])({ profile: function profile(state) {
      return state.user.profile;
    } })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-711de7bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/regulation/index.vue
var regulation_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bbaBackground widthFull fitAvailableHeight",
      staticStyle: { color: "white" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer" })
    ],
    1
  )
}
var regulation_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-4 pt-5 pb-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center pt-5 widthFull" }, [
          _c("span", { staticStyle: { color: "white" } }, [
            _c("strong", [_vm._v("REGOLAMENTO")])
          ])
        ])
      ])
    ])
  }
]
regulation_render._withStripped = true
var regulation_esExports = { render: regulation_render, staticRenderFns: regulation_staticRenderFns }
/* harmony default export */ var components_regulation = (regulation_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-711de7bd", regulation_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/regulation/index.vue
var regulation_disposed = false
function regulation_injectStyle (ssrContext) {
  if (regulation_disposed) return
  __webpack_require__("en44")
}
var regulation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var regulation___vue_template_functional__ = false
/* styles */
var regulation___vue_styles__ = regulation_injectStyle
/* scopeId */
var regulation___vue_scopeId__ = "data-v-711de7bd"
/* moduleIdentifier (server only) */
var regulation___vue_module_identifier__ = null
var regulation_Component = regulation_normalizeComponent(
  regulation,
  components_regulation,
  regulation___vue_template_functional__,
  regulation___vue_styles__,
  regulation___vue_scopeId__,
  regulation___vue_module_identifier__
)
regulation_Component.options.__file = "src/components/regulation/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-711de7bd", regulation_Component.options)
  } else {
    hotAPI.reload("data-v-711de7bd", regulation_Component.options)
  }
  module.hot.dispose(function (data) {
    regulation_disposed = true
  })
})()}

/* harmony default export */ var src_components_regulation = (regulation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cookie/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var cookie = ({
	name: 'privacy',
	data: function data() {
		return {
			loadingState: '',
			userToken: ''
		};
	},

	methods: {
		scrollToTop: function scrollToTop() {
			window.scrollTo(0, 0);
		}
	},
	watch: {},
	mounted: function mounted() {
		window.location.replace("https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf");
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a523c12","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookie/index.vue
var cookie_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "privacy",
      staticClass: " widthFull fitAvailableHeight pt-5",
      staticStyle: { color: "black" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer pb-5" })
    ],
    1
  )
}
var cookie_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-5 pt-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center  widthFull" }, [
          _c("span", { staticStyle: { color: "black" } }, [
            _vm._v("Informativa per il trattamento dei dati personali")
          ])
        ])
      ])
    ])
  }
]
cookie_render._withStripped = true
var cookie_esExports = { render: cookie_render, staticRenderFns: cookie_staticRenderFns }
/* harmony default export */ var components_cookie = (cookie_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a523c12", cookie_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/cookie/index.vue
var cookie_disposed = false
function cookie_injectStyle (ssrContext) {
  if (cookie_disposed) return
  __webpack_require__("biI2")
}
var cookie_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cookie___vue_template_functional__ = false
/* styles */
var cookie___vue_styles__ = cookie_injectStyle
/* scopeId */
var cookie___vue_scopeId__ = "data-v-2a523c12"
/* moduleIdentifier (server only) */
var cookie___vue_module_identifier__ = null
var cookie_Component = cookie_normalizeComponent(
  cookie,
  components_cookie,
  cookie___vue_template_functional__,
  cookie___vue_styles__,
  cookie___vue_scopeId__,
  cookie___vue_module_identifier__
)
cookie_Component.options.__file = "src/components/cookie/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a523c12", cookie_Component.options)
  } else {
    hotAPI.reload("data-v-2a523c12", cookie_Component.options)
  }
  module.hot.dispose(function (data) {
    cookie_disposed = true
  })
})()}

/* harmony default export */ var src_components_cookie = (cookie_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var admin = ({
	name: 'privacy',
	data: function data() {
		return {
			loadingState: '',
			userToken: ''
		};
	},

	methods: {
		scrollToTop: function scrollToTop() {
			window.scrollTo(0, 0);
		}
	},
	watch: {},
	mounted: function mounted() {
		window.location.replace('https://wsbot.eu/21005Verifica/public/');
	}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648fb19c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/index.vue
var admin_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "privacy",
      staticClass: " widthFull fitAvailableHeight pt-5",
      staticStyle: { color: "black" }
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "container regulationContainer pb-5" })
    ],
    1
  )
}
var admin_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row mb-5 pt-5 center" }, [
        _c("h3", { staticClass: "tizaFont bbaWhite center  widthFull" }, [
          _c("span", { staticStyle: { color: "black" } }, [_vm._v("Redirect")])
        ])
      ])
    ])
  }
]
admin_render._withStripped = true
var admin_esExports = { render: admin_render, staticRenderFns: admin_staticRenderFns }
/* harmony default export */ var components_admin = (admin_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-648fb19c", admin_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/admin/index.vue
var admin_disposed = false
function admin_injectStyle (ssrContext) {
  if (admin_disposed) return
  __webpack_require__("9pkI")
}
var admin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var admin___vue_template_functional__ = false
/* styles */
var admin___vue_styles__ = admin_injectStyle
/* scopeId */
var admin___vue_scopeId__ = "data-v-648fb19c"
/* moduleIdentifier (server only) */
var admin___vue_module_identifier__ = null
var admin_Component = admin_normalizeComponent(
  admin,
  components_admin,
  admin___vue_template_functional__,
  admin___vue_styles__,
  admin___vue_scopeId__,
  admin___vue_module_identifier__
)
admin_Component.options.__file = "src/components/admin/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-648fb19c", admin_Component.options)
  } else {
    hotAPI.reload("data-v-648fb19c", admin_Component.options)
  }
  module.hot.dispose(function (data) {
    admin_disposed = true
  })
})()}

/* harmony default export */ var src_components_admin = (admin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loginasgod/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var loginasgod = ({
  name: 'confirm',
  components: {},
  data: function data() {

    return {
      result: 'Verifica Token',
      status: false,
      loadingState: false
    };
  },

  methods: {
    confirm: function confirm() {
      this.$log(this.$route);
      var token = this.$route.query.token;
      var _vue = this;
      this.$log(token);

      localStorage.setItem('user-token' + "BONUS", token);
      _vue.$router.push('/');
      setTimeout(function () {
        window.location.reload();
      }, 1000);
    }
  },
  mounted: function mounted() {
    this.confirm();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77553494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginasgod/index.vue
var loginasgod_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container whiteCont mt-5 mb-5" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center verticalCentred" },
          [
            _c("div", { staticClass: "col-6 mt-5 pt-5" }, [
              _c(
                "h1",
                {
                  staticClass: "mb-5 center",
                  attrs: { type: "text" },
                  model: {
                    value: _vm.result,
                    callback: function($$v) {
                      _vm.result = $$v
                    },
                    expression: "result"
                  }
                },
                [_vm._v(_vm._s(_vm.result))]
              ),
              _vm._v(" "),
              _vm.status
                ? _c(
                    "div",
                    { staticClass: "mt-5 center" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-primary btn-lg",
                          attrs: { to: "/login" }
                        },
                        [_vm._v("Accedi")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var loginasgod_staticRenderFns = []
loginasgod_render._withStripped = true
var loginasgod_esExports = { render: loginasgod_render, staticRenderFns: loginasgod_staticRenderFns }
/* harmony default export */ var components_loginasgod = (loginasgod_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77553494", loginasgod_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loginasgod/index.vue
var loginasgod_disposed = false
var loginasgod_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loginasgod___vue_template_functional__ = false
/* styles */
var loginasgod___vue_styles__ = null
/* scopeId */
var loginasgod___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loginasgod___vue_module_identifier__ = null
var loginasgod_Component = loginasgod_normalizeComponent(
  loginasgod,
  components_loginasgod,
  loginasgod___vue_template_functional__,
  loginasgod___vue_styles__,
  loginasgod___vue_scopeId__,
  loginasgod___vue_module_identifier__
)
loginasgod_Component.options.__file = "src/components/loginasgod/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77553494", loginasgod_Component.options)
  } else {
    hotAPI.reload("data-v-77553494", loginasgod_Component.options)
  }
  module.hot.dispose(function (data) {
    loginasgod_disposed = true
  })
})()}

/* harmony default export */ var src_components_loginasgod = (loginasgod_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue-form-wizard/dist/vue-form-wizard.js
var vue_form_wizard = __webpack_require__("3kHb");
var vue_form_wizard_default = /*#__PURE__*/__webpack_require__.n(vue_form_wizard);

// EXTERNAL MODULE: ./node_modules/vue-form-wizard/dist/vue-form-wizard.min.css
var vue_form_wizard_min = __webpack_require__("2+hT");
var vue_form_wizard_min_default = /*#__PURE__*/__webpack_require__.n(vue_form_wizard_min);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/vuejs-datepicker.esm.js
var vuejs_datepicker_esm = __webpack_require__("IC97");

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/locale/index.js
var locale = __webpack_require__("D52M");
var locale_default = /*#__PURE__*/__webpack_require__.n(locale);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.css
var vue_select = __webpack_require__("R870");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// CONCATENATED MODULE: ./src/components/documents/documents.js


var _PersonaFisica, _PartitaIVA, _AmministratoreDiCo;

var documents = {

  'Persona fisica': (_PersonaFisica = {
    // LISTA DOCS
    '2050D08': {
      'name': 'Carta d`identità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08'
    },
    '2050D09': {
      'name': 'Codice Fiscale',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D09'
    },
    '2050D10S': {
      'name': 'Visura Camerale Serramentista',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10S'
    },
    '2050D11': {
      'name': 'Visura Catastale o Richiesta Accatastamento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11'
    },
    '2050D11E': {
      'name': 'Titolo giuridico ',
      'mandatory': "yes",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D12': {
      'name': 'Dichiarazione sostitutiva di atto notorio di consenso all`esecuzione dei lavori, sottoscritta dal proprietario dell`immobile ',
      'mandatory': "no",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D12'
    },

    '2050D13': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l`accesso all`agevolazione, ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    }

  }, defineProperty_default()(_PersonaFisica, '2050D06E', {
    'name': 'Contratto di fornitura tra installatore e beneficiario',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D06E'
  }), defineProperty_default()(_PersonaFisica, '2050D14', {
    'name': 'Dichiarazione sostitutiva di atto di notorio attestante la data di inizio lavori e la natura agevolabile degli interventi realizzati o in corso di realizzazione',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D14'
  }), defineProperty_default()(_PersonaFisica, '2050D15', {
    'name': 'Dichiarazione sostitutiva di atto notorio attestante la ultimazione/non ultimazione dei lavori',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D15'
  }), defineProperty_default()(_PersonaFisica, '2050D16', {
    'name': 'Autocertificazione dei prodotti installati con dichiarazione di conformità degli impianti installati ',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D16'
  }), defineProperty_default()(_PersonaFisica, '2050D17', {
    'name': 'Fattura con indicazione dello sconto praticato',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D17'
  }), defineProperty_default()(_PersonaFisica, '2050D18', {
    'name': 'Bonifico Parlante',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D18'
  }), defineProperty_default()(_PersonaFisica, '2050D19', {
    'name': 'Riepilogo massimali di costo (€/mq) di cui all’Allegato I, Decreto Requisiti 6 Agosto 2020',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D19'
  }), defineProperty_default()(_PersonaFisica, '2050D20', {
    'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D20'
  }), defineProperty_default()(_PersonaFisica, '2050D21', {
    'name': 'Delega all`invio del Modello all`Agenzia delle Entrate tra Cedente e KPMG',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D21'
  }), defineProperty_default()(_PersonaFisica, '2050D22', {
    'name': 'Modello Comunicazione Agenzia delle Entrate firmato dal Cliente e relativa ricevuta di avvenuta presa in carico',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D22'
  }), _PersonaFisica),

  'Partita IVA': (_PartitaIVA = {
    // LISTA DOCS
    '2050D10': {
      'name': 'Visura Camerale Cedente',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10'
    },
    '2050D10S': {
      'name': 'Visura Camerale Serramentista',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10S'
    },
    '2050D11': {
      'name': 'Visura Catastale o Richiesta Accatastamento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11'
    },
    '2050D11E': {
      'name': 'Titolo giuridico ',
      'mandatory': "yes",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D12': {
      'name': 'Dichiarazione sostitutiva di atto notorio di consenso all`esecuzione dei lavori, sottoscritta dal proprietario dell`immobile ',
      'mandatory': "no",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D12'
    },

    '2050D13': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l`accesso all`agevolazione, ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    }

  }, defineProperty_default()(_PartitaIVA, '2050D06E', {
    'name': 'Contratto di fornitura tra installatore e beneficiario',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D06E'
  }), defineProperty_default()(_PartitaIVA, '2050D14', {
    'name': 'Dichiarazione sostitutiva di atto di notorio attestante la data di inizio lavori e la natura agevolabile degli interventi realizzati o in corso di realizzazione',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D14'
  }), defineProperty_default()(_PartitaIVA, '2050D15', {
    'name': 'Dichiarazione sostitutiva di atto notorio attestante la ultimazione/non ultimazione dei lavori',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D15'
  }), defineProperty_default()(_PartitaIVA, '2050D16', {
    'name': 'Autocertificazione dei prodotti installati con dichiarazione di conformità degli impianti installati ',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D16'
  }), defineProperty_default()(_PartitaIVA, '2050D17', {
    'name': 'Fattura con indicazione dello sconto praticato',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D17'
  }), defineProperty_default()(_PartitaIVA, '2050D18', {
    'name': 'Bonifico Parlante',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D18'
  }), defineProperty_default()(_PartitaIVA, '2050D19', {
    'name': 'Riepilogo massimali di costo (€/mq) di cui all’Allegato I, Decreto Requisiti 6 Agosto 2020',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D19'
  }), defineProperty_default()(_PartitaIVA, '2050D20', {
    'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D20'
  }), defineProperty_default()(_PartitaIVA, '2050D21', {
    'name': 'Delega all`invio del Modello all`Agenzia delle Entrate tra Cedente e KPMG',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D21'
  }), defineProperty_default()(_PartitaIVA, '2050D22', {
    'name': 'Modello Comunicazione Agenzia delle Entrate firmato dal Cliente e relativa ricevuta di avvenuta presa in carico',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D22'
  }), _PartitaIVA),

  'Amministratore di condominio': (_AmministratoreDiCo = {
    '2050D10': {
      'name': 'Visura Camerale Cedente',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10'
    },
    '2050D10S': {
      'name': 'Visura Camerale Serramentista',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D10S'
    },
    '2050D11': {
      'name': 'Visura Catastale o Richiesta Accatastamento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11'
    },
    '2050D11E': {
      'name': 'Titolo giuridico ',
      'mandatory': "yes",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D12': {
      'name': 'Dichiarazione sostitutiva di atto notorio di consenso all`esecuzione dei lavori, sottoscritta dal proprietario dell`immobile ',
      'mandatory': "no",
      'multidocuments': 'yes',
      'multipage': 'yes',
      'template': 'no',
      'codice': '2050D12'
    },

    '2050D13': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l`accesso all`agevolazione, ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D13'
    },

    '2050D06E': {
      'name': 'Contratto di fornitura tra installatore e beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06E'
    }

  }, defineProperty_default()(_AmministratoreDiCo, '2050D06E', {
    'name': 'Contratto di fornitura tra installatore e beneficiario',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D06E'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D14', {
    'name': 'Dichiarazione sostitutiva di atto di notorio attestante la data di inizio lavori e la natura agevolabile degli interventi realizzati o in corso di realizzazione',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D14'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D15', {
    'name': 'Dichiarazione sostitutiva di atto notorio attestante la ultimazione/non ultimazione dei lavori',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D15'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D16', {
    'name': 'Autocertificazione dei prodotti installati con dichiarazione di conformità degli impianti installati ',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D16'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D17', {
    'name': 'Fattura con indicazione dello sconto praticato',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D17'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D18', {
    'name': 'Bonifico Parlante',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D18'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D19', {
    'name': 'Riepilogo massimali di costo (€/mq) di cui all’Allegato I, Decreto Requisiti 6 Agosto 2020',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D19'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D20', {
    'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D20'
  }), defineProperty_default()(_AmministratoreDiCo, '2050D22', {
    'name': 'Modello Comunicazione Agenzia delle Entrate firmato dal Cliente e relativa ricevuta di avvenuta presa in carico',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D22'
  }), _AmministratoreDiCo)

};

/* harmony default export */ var documents_documents = (documents);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calcolatore/agnellimetalli.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var agnellimetalli_moment = __webpack_require__("PJh5");

var numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';







// GET DOC LIST


/* harmony default export */ var agnellimetalli = ({
  name: "login",
  data: function data() {
    var _ref;

    return _ref = {
      username: "",
      documents: documents_documents,
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",
      corporateClient: '',
      usersForAdmin: [],
      userSel: "",
      seleErr: false,
      person: true,
      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",
      partita_iva: "",
      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione"
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale"
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi"
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua"
        },
        5: {
          name: "Climatizzatore",
          value: "climatizzatore"
        },
        6: {
          name: "Collettore solare termico",
          value: "solare"
        },
        7: {
          name: "Altro Prodotto Vaillant",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione"
        },
        1: {
          name: "Altro Accessorio Vaillant",
          value: "altroV"
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche"
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: 0,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      passwordFieldType: "password",
      moment: agnellimetalli_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      accessories: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",
      priceDcast: "",
      hasPrev: true,
      adminIs: false,

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      codice_fiscale: "",
      existCF: false,
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", ""), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", ""), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", false), defineProperty_default()(_ref, "foglio", ""), defineProperty_default()(_ref, "subalterno", ""), defineProperty_default()(_ref, "particella", ""), defineProperty_default()(_ref, "selectready", false), defineProperty_default()(_ref, "selectionOk", false), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateInst: function validateInst() {
      var _vue = this;
      if (!this.selectionOk) {
        this.seleErr = true;

        return false;
      } else {
        _vue.$scrollTo("#app", 700, {
          offset: -170
        });
        return true;
      }
    },
    validateZeroTab: function validateZeroTab() {
      var _vue = this;

      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$warn(this.errors);
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");

          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
    },

    validateSecondTab: function validateSecondTab() {
      this.$log(this.$validator);
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });

      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                docTemp = _this.documents[_this.client_type];

                _this.documents[_this.client_type] = {};

                selettore_titoloPossesso = _this.client_ownership;
                selettore_enea = _this.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this.documents[_this.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this.documents[_this.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this.documents[_this.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onComplate: function onComplate() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingState = true;
                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;

                // ALL USER DATA
                data.user = !_this2.adminIs ? _this2.getProfile : _this2.referSel;
                // BONUS SELECTED
                data.bonus = _this2.ecoBonus ? _this2.ecoBonus : "";
                // CLIENT DATA
                data.client_name = _this2.clientName;
                data.client_lastname = _this2.clientLastname;
                data.client_type = _this2.client_type;
                data.client_codice_fiscale = _this2.codice_fiscale ? _this2.codice_fiscale : "";
                data.client_partita_iva = _this2.partita_iva ? _this2.partita_iva : "";
                data.client_mobile = _this2.client_mobile;
                data.client_phone = _this2.client_phone;
                data.client_email = _this2.client_email;
                data.building_foglio = _this2.foglio ? _this2.foglio : "";
                data.building_particella = _this2.particella ? _this2.particella : "";
                data.building_subalterno = _this2.subalterno ? _this2.subalterno : "";
                data.dcast_export = _this2.dcast_export ? _this2.dcast_export : 0;
                data.admin_ref = _this2.adminIs ? _this2.AdminId : "";
                data.corporateClient = _this2.profile.corporateClient ? _this2.profile.corporateClient : "";
                // NEWWWWWWWWW
                if (_this2.zeroEnea) {
                  data.client_price_enea = _this2.zeroEneaOld;
                } else {
                  data.client_price_enea = _this2.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this2.zeroDcast) {
                  data.client_price_dcast = _this2.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this2.priceDcast;
                }

                data.client_ownership = _this2.client_ownership;

                // CLIENT HOUSE DATA
                data.building_province = _this2.province;
                data.building_city = _this2.city.city;
                data.building_zip = _this2.zip;
                data.building_address = _this2.adress;
                data.building_civic = _this2.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this2.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this2.eventType;
                data.intervention_date = _this2.eventStartdate ? agnellimetalli_moment(_this2.eventStartdate).format("YYYY-MM-DD") : "";
                // PRODUCTS & ACCESSORIES
                data.products = _this2.products;
                data.accessories = _this2.accessories;
                data.enea_request = _this2.enea;
                data.created_at = agnellimetalli_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = agnellimetalli_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this2.totalProducts;
                data.total_accessories_price = _this2.totalAccessories;
                data.price_work = _this2.priceWork;

                data.total_transfer_for_user = _this2.calcInfo.aInstallatore ? _this2.calcInfo.aInstallatore : "";
                data.total_transfer_for_client = _this2.calcInfo.finalPrice ? _this2.calcInfo.finalPrice : "";
                data.total_bonus_savings = _this2.calcInfo.totalWithBonus ? _this2.calcInfo.totalWithBonus : "";

                data.total_work_and_iva = _this2.calcInfo.totalBaseAndIva ? _this2.calcInfo.totalBaseAndIva : "";

                // HTML FOR PDF
                data.htmlInvoice = _this2.hasPrev ? _this2.$refs.invoiceData.innerHTML : "";
                data.payment_id = !_this2.hasPrev ? 1 : 0;
                data.status = !_this2.hasPrev ? 1 : 0;
                //requiredOperations: '',

                data.building_uso_abitativo = _this2.usoAbitativo;
                data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/savePriceQuotation",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "La tua Pratica è stata salvata correttamente";
                  alert.type = "SUCCESS";
                  _this2.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this2.$swal({
                    type: "success",
                    title: "Pratica salvata",
                    html: alert.text
                  });
                  _this2.loadingState = false;

                  _this2.$router.push("/pratiche");
                }).catch(function (resp) {
                  _this2.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this2.loadingState = false;
                });

              case 49:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        this.calcInfo.serviceCost = 160;
      }
      //var AttPercent = 10.58
      var AttPercent = 13.96;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totProducts) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totProducts - totAltroAcc;
      } else {
        var x10 = totProducts;
        var x22 = 0;
      }

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;

      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = ((parseFloat(totAltroAcc) + parseFloat(totAge) * ratio10) * 0.1).toFixed(2);
        this.calcInfo.iva10NonAge = (parseFloat(totalExtraMise) * ratio10 * 0.1).toFixed(2);

        this.calcInfo.iva22Age = (parseFloat(totAge) * ratio22 * 0.22).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * ratio22 * 0.22).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      //TOTAL BASE AND IVA 10 && 22
      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age);
      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) / 100 * 22;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 12.2;
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea) * 1.22 + parseFloat(this.priceDcast) * 1.22 + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 61;
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },

    selectChange: function selectChange(param) {
      if (param) {
        for (var i in this.loadUserData) {
          if (param == this.loadUserData[i].sel) {
            this.referSel = this.loadUserData[i].all;
            this.seleErr = false;
            this.$log("Installatore Selezionato");
            this.$log(this.referSel);
            this.selectionOk = true;
          }
        }
      } else {
        this.selectionOk = false;
      }
    },
    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      this.productIndex = this.productIndex + 1;
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      this.accessoriesIndex = this.accessoriesIndex + 1;
      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },

    loadUsers: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        var data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loadingState = true;

                this.flagForCheck = this.areaAdmin == "all" ? "all" : this.flagForCheck;

                if (!this.flagForCheck) {
                  _context3.next = 7;
                  break;
                }

                data = {
                  id: this.flagForCheck,
                  type: this.profile.type
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 7;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/loadUsers",
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  if (!resp.data) {
                    _this3.loadingState = false;
                  } else {
                    for (var i in resp.data) {
                      _this3.usersForAdmin[i] = resp.data[i].sel;
                    }
                    _this3.loadUserData = resp.data;
                    _this3.selectready = true;
                    _this3.loadingState = false;
                  }
                }).catch(function (resp) {});

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadUsers() {
        return _ref2.apply(this, arguments);
      }

      return loadUsers;
    }(),
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = numeral(this.priceDcast).format("0.0,[00]");
    },


    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
        method: "POST",
        data: {
          key: "calc"
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this5.allProducts = resp.data.allProducts;
        _this5.$log(_this5.allProducts);
      }).catch(function (resp) {});
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = {
        index: "",
        name: "",
        serial: ""
      };
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);
        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = false;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 <br/>";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      if (this.eventType == "Instalazione") {
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale" || this.products[i].group == "pompadicalore" || this.products[i].group == "ibridi" || this.products[i].group == "scaldacqua") {
          var alert = {};
          alert.text = "Per " + this.ecoBonus + " con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END EVENT TYPE  *********************************************************************************************************************
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context4.sent;
                    length = searchlength;

                    if (!(length != 10)) {
                      _context4.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context4.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context4.next = 11;
                      break;
                    }

                    return _context4.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 12:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, _this6);
          }));

          return function preConfirm(_x) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = _this7.allProducts;
                _context5.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context5.t1 = _context5.t0()).done) {
                  _context5.next = 18;
                  break;
                }

                x = _context5.t1.value;
                _context5.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context5.t3 = _context5.t2()).done) {
                  _context5.next = 16;
                  break;
                }

                y = _context5.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context5.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context5.abrupt("return", data[x][y]);

              case 14:
                _context5.next = 5;
                break;

              case 16:
                _context5.next = 2;
                break;

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE ***************************************" + this.totalExtraMise);

      this.$log(this.products);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;
      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (this.ecoBonus != "Bonus Casa 50%") {
          alert.type = "ERROR";
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      for (var x in this.accessories) {
        price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
      }
      if (price) {
        this.totalAccessories = numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      this.accessories[i].price = numeral(this.accessories[i].price).format("0.0,[00]");
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza;
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context6.sent;
                    length = searchlength;

                    if (!(length != 10)) {
                      _context6.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context6.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context6.next = 11;
                      break;
                    }

                    return _context6.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref4.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                data = _this9.allProducts;
                _context7.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context7.t1 = _context7.t0()).done) {
                  _context7.next = 20;
                  break;
                }

                x = _context7.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context7.next = 18;
                  break;
                }

                _context7.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context7.t3 = _context7.t2()).done) {
                  _context7.next = 18;
                  break;
                }

                y = _context7.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context7.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context7.abrupt("return", data[x][y]);

              case 16:
                _context7.next = 6;
                break;

              case 18:
                _context7.next = 2;
                break;

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.profile.type == 1) {
        this.hasPrev = false;
      }
      if (this.profile.status == "admin") {
        this.adminIs = true;
        this.AdminId = this.profile.id;
        this.flagForCheck = this.profile.id;
        this.areaAdmin = this.profile.area;
      } else if (this.profile.status == "user") {
        this.adminIs = false;
        this.flagForCheck = this.profile.id;
        this.areaAdmin = this.profile.area;
      }
    }
  },
  watch: {
    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    client_type: function client_type(val) {
      if (val == "Persona fisica") {
        this.person = true;
        this.codice_fiscale = "";
        this.partita_iva = "";
      } else {
        this.person = false;
        this.partita_iva = "";
        this.codice_fiscale = "";
      }
    },
    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    codice_fiscale: function codice_fiscale(val) {
      if (val) {
        this.codice_fiscale = this.codice_fiscale.toUpperCase();
      }
    },

    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this11 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.zips = resp.data.zips;
          _this11.zipsState = false;
        }).catch(function (resp) {
          _this11.zips = [];
          _this11.zipsState = false;
        });
      }
    },
    getProfile: function getProfile() {

      this.setProfile();
      this.loadUsers();
    }
  },
  created: function created() {
    this.loadProducts();
    this.setProfile();
    this.loadUsers();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();
    this.setProfile();
    this.loadUsers();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    },
    profile: function profile(state) {
      return state.user.profile;
    },
    managedArea: function managedArea(state) {
      return state.user.profile.type;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4005bb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/agnellimetalli.vue
var agnellimetalli_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-5" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12 " }, [
            _vm.proccess == "START" && _vm.hasPrev
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Calcolatore preventivi")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && !_vm.hasPrev
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Crea la pratica")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && _vm.hasPrev
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v(
                    "\r\n          Compila i seguenti step. In caso di conferma del preventivo tutti\r\n          i dati inseriti verranno poi utilizzati per generare i documenti richiesti per lo sconto in fattura.\r\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && !_vm.hasPrev
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v("\r\n          Compila i seguenti step.\r\n        ")
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0!important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      staticClass: "mt-0 pb-2 formp ",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva pratica",
                        stepSize: _vm.stepSize,
                        color: "#00337f",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": _vm.onComplate
                      }
                    },
                    [
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Scegli Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-2 " },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass:
                                                "pb-0 center Bold theme uppercase"
                                            },
                                            [
                                              _vm._v(
                                                "Clicca sull`icona del bonus a cui vuoi associare la pratica"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Bonus Casa 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("6PKJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("DaEW")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [_vm._v(" Bonus Casa")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6  col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 50%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("6PKJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("DaEW")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\r\n                      Se vuoi aderire al\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Ecobonus 65%\r\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\r\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 65%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("w/IJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("CXbD")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [_vm._v(" Ecobonus")]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{required:true, max: 63, min: 2}"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le tre icone sopraindicate. "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-3 " },
                                        [
                                          _vm._v(
                                            "\r\n                  Novatag e KPMG,  \r\n                  non si ritengono responsabili per eventuali danni economici \r\n                  derivanti dall.utilizo della piattaforma e dall.informazioni fornite."
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Seleziona l'istallatore",
                                icon: "",
                                "before-change": _vm.validateInst
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 center" },
                                        [
                                          _c(
                                            "h1",
                                            { staticClass: "Bold theme" },
                                            [
                                              _vm._v(
                                                "Seleziona l'istallatore a cui associare la pratica"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-5 col-md-6 col-12"
                                        },
                                        [
                                          _vm.selectready
                                            ? _c("v-select", {
                                                key: 1,
                                                attrs: {
                                                  options: _vm.usersForAdmin,
                                                  type: "text",
                                                  placeholder: "Seleziona..."
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.selectChange(
                                                      _vm.userSel
                                                    )
                                                  }
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "search",
                                                      fn: function(ref) {
                                                        var attributes =
                                                          ref.attributes
                                                        var events = ref.events
                                                        return [
                                                          _c(
                                                            "input",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "vs__search",
                                                                  attrs: {
                                                                    required:
                                                                      _vm.userSel
                                                                  }
                                                                },
                                                                "input",
                                                                attributes,
                                                                false
                                                              ),
                                                              events
                                                            )
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1550066045
                                                ),
                                                model: {
                                                  value: _vm.userSel,
                                                  callback: function($$v) {
                                                    _vm.userSel = $$v
                                                  },
                                                  expression: "userSel"
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.seleErr
                                            ? _c(
                                                "small",
                                                { staticClass: "red Bold" },
                                                [_vm._v("Il campo è richiesto")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-12" }),
                                      _vm._v(" "),
                                      _vm.selectionOk
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-12 center mb-3"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "center theme Bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "Di seguito l'anagrafica dell'istallatore selezionato:"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticClass:
                                                  "img img-fluid mt-5 imgIco mb-3",
                                                staticStyle: {
                                                  "max-width": "150px"
                                                },
                                                attrs: {
                                                  src: __webpack_require__("qsgh")
                                                }
                                              }),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "uppercase Bold theme"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.referSel.name) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.referSel.cognome
                                                      )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.email
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.email,
                                                        expression:
                                                          "referSel.email"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.email"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .email
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.email",
                                                      name: "referSel.email",
                                                      "data-vv-as": "Email"
                                                    },
                                                    domProps: {
                                                      value: _vm.referSel.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "email",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.email"
                                                      }
                                                    },
                                                    [_vm._v("Email")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.email"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.email"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.azienda
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.azienda,
                                                        expression:
                                                          "referSel.azienda"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.azienda"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .azienda
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.azienda",
                                                      name: "referSel.azienda",
                                                      "data-vv-as": "Azienda"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.azienda
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "azienda",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.email"
                                                      }
                                                    },
                                                    [_vm._v("Azienda")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.azienda"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.azienda"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk &&
                                      _vm.referSel.partita_iva
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .partita_iva,
                                                        expression:
                                                          "referSel.partita_iva"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.partita_iva"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .partita_iva
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id:
                                                        "referSel.partita_iva",
                                                      name:
                                                        "referSel.partita_iva",
                                                      "data-vv-as":
                                                        "Partita IVA"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.partita_iva
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "partita_iva",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.partita_iva"
                                                      }
                                                    },
                                                    [_vm._v("Partita IVA")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.partita_iva"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.partita_iva"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk &&
                                      _vm.referSel.codice_fiscale
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .codice_fiscale,
                                                        expression:
                                                          "referSel.codice_fiscale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.codice_fiscale"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .codice_fiscale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id:
                                                        "referSel.codice_fiscale",
                                                      name:
                                                        "referSel.codice_fiscale",
                                                      "data-vv-as":
                                                        "Codice Fiscale"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel
                                                          .codice_fiscale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "codice_fiscale",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.codice_fiscale"
                                                      }
                                                    },
                                                    [_vm._v("Codice Fiscale")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.codice_fiscale"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.codice_fiscale"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.telefono
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.telefono,
                                                        expression:
                                                          "referSel.telefono"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.telefono"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .telefono
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.telefono",
                                                      name: "referSel.telefono",
                                                      "data-vv-as": "Telefono"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.telefono
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "telefono",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.telefono"
                                                      }
                                                    },
                                                    [_vm._v("Telefono")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.telefono"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.telefono"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.cellulare
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .cellulare,
                                                        expression:
                                                          "referSel.cellulare"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.cellulare"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .cellulare
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.cellulare",
                                                      name:
                                                        "referSel.cellulare",
                                                      "data-vv-as": "Cellulare"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.cellulare
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "cellulare",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.cellulare"
                                                      }
                                                    },
                                                    [_vm._v("Cellulare")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.cellulare"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.cellulare"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.emailPEC
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.emailPEC,
                                                        expression:
                                                          "referSel.emailPEC"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.emailPEC"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .emailPEC
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.emailPEC",
                                                      name: "referSel.emailPEC",
                                                      "data-vv-as": "PEC"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.emailPEC
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "emailPEC",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.emailPEC"
                                                      }
                                                    },
                                                    [_vm._v("PEC")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.emailPEC"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.emailPEC"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.provincia
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel
                                                            .provincia,
                                                        expression:
                                                          "referSel.provincia"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.provincia"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .provincia
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.provincia",
                                                      name:
                                                        "referSel.provincia",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.provincia
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "provincia",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for:
                                                          "referSel.provincia"
                                                      }
                                                    },
                                                    [_vm._v("Provincia")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.provincia"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.provincia"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.regione
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.regione,
                                                        expression:
                                                          "referSel.regione"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.regione"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .regione
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.regione",
                                                      name: "referSel.regione",
                                                      "data-vv-as": "Regione"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.referSel.regione
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "regione",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.regione"
                                                      }
                                                    },
                                                    [_vm._v("Regione")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.regione"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.regione"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.selectionOk && _vm.referSel.comune
                                        ? _c(
                                            "div",
                                            { staticClass: "col-md-4 mb-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.referSel.comune,
                                                        expression:
                                                          "referSel.comune"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-0.referSel.comune"
                                                      ),
                                                      valid: !!_vm.referSel
                                                        .comune
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      disabled: "",
                                                      id: "referSel.comune",
                                                      name: "referSel.comune",
                                                      "data-vv-as": "comune"
                                                    },
                                                    domProps: {
                                                      value: _vm.referSel.comune
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.referSel,
                                                          "comune",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "referSel.comune"
                                                      }
                                                    },
                                                    [_vm._v("Comune")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-0.referSel.comune"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                      " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-0.referSel.comune"
                                                                )
                                                              ) +
                                                              "\r\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "col-md-12 mb-3 "
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    Inserisci i dati del cliente finale\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_type,
                                                        expression:
                                                          "client_type"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{required:true, max: 63, min: 2}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_type"
                                                      ),
                                                      valid: !!_vm.client_type
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "client_type",
                                                      name: "client_type",
                                                      "data-vv-as":
                                                        "Tipologia cliente"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.client_type = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        key: 11,
                                                        attrs: {
                                                          value:
                                                            "Persona fisica"
                                                        }
                                                      },
                                                      [_vm._v("Persona fisica")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c(
                                                          "option",
                                                          {
                                                            key: 12,
                                                            attrs: {
                                                              value:
                                                                "Partita IVA"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Partita IVA"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_type"
                                                    }
                                                  },
                                                  [_vm._v("Tipologia cliente")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_type"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_type"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientName,
                                                      expression: "clientName"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{required:true, max: 63, min: 2}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientName"
                                                    ),
                                                    valid: !!_vm.clientName
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientName",
                                                    name: "clientName",
                                                    "data-vv-as": "Nome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientName =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "clientName" }
                                                  },
                                                  [_vm._v("Nome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientName"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientName"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientLastname,
                                                      expression:
                                                        "clientLastname"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{required:true, max: 63, min: 2}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientLastname"
                                                    ),
                                                    valid: !!_vm.clientLastname
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientLastname",
                                                    name: "clientLastname",
                                                    "data-vv-as": "Cognome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientLastname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientLastname =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "clientLastname"
                                                    }
                                                  },
                                                  [_vm._v("Cognome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientLastname"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientLastname"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3 " },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_email,
                                                      expression: "client_email"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        email: true,
                                                        temporaryEmail: true,
                                                        plusIssueEmail: true,
                                                        max: 56
                                                      },
                                                      expression:
                                                        "{required:true, email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                                    }
                                                  ],
                                                  ref: "client_email",
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_email"
                                                    ),
                                                    valid: !!_vm.client_email
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_email",
                                                    name: "client_email",
                                                    "data-vv-as": "Email"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_email =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_email"
                                                    }
                                                  },
                                                  [_vm._v("Email* ")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_email"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_email"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_phone,
                                                      expression: "client_phone"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[0]+/
                                                      },
                                                      expression:
                                                        "{required: false, max: 12, min: 8, regex: /^[0]+/}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_phone"
                                                    ),
                                                    valid: !!_vm.client_phone
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_phone",
                                                    name: "client_phone",
                                                    "data-vv-as": "Telefono"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_phone
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_phone =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_phone"
                                                    }
                                                  },
                                                  [_vm._v("Telefono ")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_phone"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_phone"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_mobile,
                                                      expression:
                                                        "client_mobile"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[3]+/
                                                      },
                                                      expression:
                                                        "{required: true, max: 12, min: 8, regex: /^[3]+/}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_mobile"
                                                    ),
                                                    valid: !!_vm.client_mobile
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_mobile",
                                                    name: "client_mobile",
                                                    "data-vv-as": "Cellulare"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_mobile
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_mobile =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_mobile"
                                                    }
                                                  },
                                                  [_vm._v("Cellulare * ")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_mobile"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_mobile"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              !_vm.person
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.partita_iva,
                                                        expression:
                                                          "partita_iva"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          partitaIva: true,
                                                          max: 11,
                                                          min: 11
                                                        },
                                                        expression:
                                                          "{required:true, partitaIva: true, max: 11, min: 11}"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control ",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.partita_iva"
                                                      ),
                                                      valid: !!_vm.partita_iva
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "partita_iva",
                                                      name: "partita_iva",
                                                      "data-vv-as":
                                                        "Partita IVA"
                                                    },
                                                    domProps: {
                                                      value: _vm.partita_iva
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.partita_iva =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              !_vm.person
                                                ? _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "partita_iva"
                                                      }
                                                    },
                                                    [_vm._v("Partita IVA *")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-1.partita_iva"
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-1.partita_iva"
                                                            )
                                                          ) +
                                                          "\r\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.client_type == "Partita IVA"
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "usoAbitativo"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                        Prevalente uso abitativo\r\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("SI")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("NO")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-1.usoAbitativo"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-1.usoAbitativo')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                        Il servizio deve essere accettato oppure rifiutato\r\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.person
                                          ? _c("div", { staticClass: "col-12" })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _vm.person
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.codice_fiscale,
                                                        expression:
                                                          "codice_fiscale"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          codiceFiscale: true,
                                                          max: 16,
                                                          min: 16
                                                        },
                                                        expression:
                                                          "{required: true, codiceFiscale: true, max: 16, min: 16}"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "form-control ",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.codice_fiscale"
                                                      ),
                                                      valid: !!_vm.codice_fiscale
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "codice_fiscale",
                                                      name: "codice_fiscale",
                                                      "data-vv-as":
                                                        "Codice Fiscale"
                                                    },
                                                    domProps: {
                                                      value: _vm.codice_fiscale
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.codice_fiscale =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _vm.person
                                                ? _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: "codice_fiscale"
                                                      }
                                                    },
                                                    [_vm._v("Codice Fiscale *")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.existCF
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback",
                                                      staticStyle: {
                                                        display: "block"
                                                      }
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Codice Fiscale inserito già presente."
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-1.codice_fiscale"
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\r\n                " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-1.codice_fiscale"
                                                            )
                                                          ) +
                                                          "\r\n              "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black pb-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    Inserisci l'indirizzo dell'immobile\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.province,
                                                        expression: "province"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{required:true}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.province"
                                                      ),
                                                      valid: !!_vm.province
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomy",
                                                      id: "province",
                                                      name: "province",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.province = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.provincies,
                                                      function(province) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: province.sigla,
                                                            domProps: {
                                                              value:
                                                                province.sigla
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n                        " +
                                                                _vm._s(
                                                                  province.sigla
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  province.provincia
                                                                ) +
                                                                "\r\n                      "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "province" }
                                                  },
                                                  [_vm._v("Provincia")]
                                                ),
                                                _vm._v(" "),
                                                _vm.provinciesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id:
                                                                "loadProvince",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.province"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.province"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.cityError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli Provincia"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.city,
                                                        expression: "city"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{required:true}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.city"
                                                      ),
                                                      valid: !!_vm.city
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomu",
                                                      id: "city",
                                                      name: "city",
                                                      "data-vv-as": "Località",
                                                      disabled: _vm.citiesState
                                                    },
                                                    on: {
                                                      click: _vm.checkProvince,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.city = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.cities, function(
                                                      city
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: city.comune,
                                                          domProps: {
                                                            value: {
                                                              cityistat:
                                                                city.istat,
                                                              city: city.comune
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        " +
                                                              _vm._s(
                                                                city.comune
                                                              ) +
                                                              "\r\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "city" }
                                                  },
                                                  [_vm._v("Località")]
                                                ),
                                                _vm._v(" "),
                                                _vm.citiesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadCity",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.city")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.city"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.zipError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli città"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zip,
                                                        expression: "zip"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{required:true}"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.zip"
                                                      ),
                                                      valid: !!_vm.zip
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomi",
                                                      id: "zip",
                                                      name: "zip",
                                                      "data-vv-as": "Cap",
                                                      disabled: _vm.zipsState
                                                    },
                                                    on: {
                                                      click: _vm.checkZip,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.zip = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        selected: true
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.zips, function(
                                                      zip
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: zip.cap,
                                                          domProps: {
                                                            value: zip.cap
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\r\n                        " +
                                                              _vm._s(zip.cap) +
                                                              "\r\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "zip" }
                                                  },
                                                  [_vm._v("Cap")]
                                                ),
                                                _vm._v(" "),
                                                _vm.zipsState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadZips",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.zip")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.zip"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.adress,
                                                      expression: "adress"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 128,
                                                        min: 5
                                                      },
                                                      expression:
                                                        "{required:true, max: 128, min: 5}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.adress"
                                                    ),
                                                    valid: !!_vm.adress
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "adress",
                                                    name: "adress",
                                                    "data-vv-as": "Indirizzo"
                                                  },
                                                  domProps: {
                                                    value: _vm.adress
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.adress =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "adress" }
                                                  },
                                                  [_vm._v("Indirizzo")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.adress")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.adress"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.civic,
                                                      expression: "civic"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 15,
                                                        min: 1
                                                      },
                                                      expression:
                                                        "{required:true, max: 15, min: 1}"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.civic"
                                                    ),
                                                    valid: !!_vm.civic
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "civic",
                                                    name: "civic",
                                                    "data-vv-as": "Civico"
                                                  },
                                                  domProps: {
                                                    value: _vm.civic
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.civic =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "civic" }
                                                  },
                                                  [_vm._v("Civico")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.civic")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\r\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.civic"
                                                              )
                                                            ) +
                                                            "\r\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _vm.client_type !=
                                            "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                              ? _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "widthFull center black pb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\r\n            Dati Catastali\r\n          "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.client_type !=
                                        "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 mb-3 " },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.foglio,
                                                          expression: "foglio"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 10,
                                                            min: 1
                                                          },
                                                          expression:
                                                            "{required:true,  max: 10, min: 1}"
                                                        }
                                                      ],
                                                      ref: "foglio",
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.foglio"
                                                        ),
                                                        valid: !!_vm.foglio
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id: "foglio",
                                                        name: "foglio",
                                                        "data-vv-as": "foglio"
                                                      },
                                                      domProps: {
                                                        value: _vm.foglio
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.foglio =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "foglio" }
                                                      },
                                                      [_vm._v("Foglio")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-1.foglio"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n              " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-1.foglio"
                                                                  )
                                                                ) +
                                                                "\r\n            "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.client_type !=
                                        "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 mb-3 " },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.particella,
                                                          expression:
                                                            "particella"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 10,
                                                            min: 1
                                                          },
                                                          expression:
                                                            "{required:true, max: 10, min: 1}"
                                                        }
                                                      ],
                                                      ref: "particella",
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.particella"
                                                        ),
                                                        valid: !!_vm.particella
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id: "particella",
                                                        name: "particella",
                                                        "data-vv-as":
                                                          "particella"
                                                      },
                                                      domProps: {
                                                        value: _vm.particella
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.particella =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: "particella"
                                                        }
                                                      },
                                                      [_vm._v("Particella")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-1.particella"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n              " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-1.particella"
                                                                  )
                                                                ) +
                                                                "\r\n            "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.client_type !=
                                        "Amministratore di condominio" /*&& to_get_cadastral_data != '1'*/
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-4 mb-3 " },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.subalterno,
                                                          expression:
                                                            "subalterno"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            max: 10,
                                                            min: 1
                                                          },
                                                          expression:
                                                            "{required: true, max: 10, min: 1}"
                                                        }
                                                      ],
                                                      ref: "subalterno",
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-1.subalterno"
                                                        ),
                                                        valid: !!_vm.subalterno
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id: "subalterno",
                                                        name: "subalterno",
                                                        "data-vv-as":
                                                          "subalterno"
                                                      },
                                                      domProps: {
                                                        value: _vm.subalterno
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.subalterno =
                                                            $event.target.value
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: "subalterno"
                                                        }
                                                      },
                                                      [_vm._v("Subalterno")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-1.subalterno"
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\r\n              " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-1.subalterno"
                                                                  )
                                                                ) +
                                                                "\r\n            "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        })
                                      ])
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row " }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    LISTA DOCUMENTI\r\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var agnellimetalli_staticRenderFns = []
agnellimetalli_render._withStripped = true
var agnellimetalli_esExports = { render: agnellimetalli_render, staticRenderFns: agnellimetalli_staticRenderFns }
/* harmony default export */ var calcolatore_agnellimetalli = (agnellimetalli_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4005bb1a", agnellimetalli_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/calcolatore/agnellimetalli.vue
var agnellimetalli_disposed = false
var agnellimetalli_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var agnellimetalli___vue_template_functional__ = false
/* styles */
var agnellimetalli___vue_styles__ = null
/* scopeId */
var agnellimetalli___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var agnellimetalli___vue_module_identifier__ = null
var agnellimetalli_Component = agnellimetalli_normalizeComponent(
  agnellimetalli,
  calcolatore_agnellimetalli,
  agnellimetalli___vue_template_functional__,
  agnellimetalli___vue_styles__,
  agnellimetalli___vue_scopeId__,
  agnellimetalli___vue_module_identifier__
)
agnellimetalli_Component.options.__file = "src/components/calcolatore/agnellimetalli.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4005bb1a", agnellimetalli_Component.options)
  } else {
    hotAPI.reload("data-v-4005bb1a", agnellimetalli_Component.options)
  }
  module.hot.dispose(function (data) {
    agnellimetalli_disposed = true
  })
})()}

/* harmony default export */ var components_calcolatore_agnellimetalli = (agnellimetalli_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calcolatore/hoval.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var hoval_moment = __webpack_require__("PJh5");

var hoval_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';







// GET DOC LIST


/* harmony default export */ var hoval = ({
  name: "hoval",
  data: function data() {
    var _ref;

    return _ref = {
      username: "",
      documents: documents_documents,
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",

      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",

      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione"
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale"
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi"
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua"
        },
        /*5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },*/
        5: {
          name: "Collettore solare termico",
          value: "solare"
        },
        6: {
          name: "Altro Prodotto",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione"
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV"
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche"
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      passwordFieldType: "password",
      moment: hoval_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      accessories: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "0",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", "0"), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", "0"), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", true), defineProperty_default()(_ref, "priceDcast", "0"), defineProperty_default()(_ref, "iva_altri_oneri", 0.22), defineProperty_default()(_ref, "iva_accessori_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_extra", 0.22), defineProperty_default()(_ref, "iva_age_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_accessori", 0.1), defineProperty_default()(_ref, "priceNew", 0), defineProperty_default()(_ref, "pricenewFlag", false), defineProperty_default()(_ref, "costoAttualizazioneChange", false), defineProperty_default()(_ref, "serviceCostChange", false), defineProperty_default()(_ref, "age_lavoro", 0), defineProperty_default()(_ref, "age_extra", 0), defineProperty_default()(_ref, "corporateClient", ''), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab: function validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
      return true;
    },

    validateSecondTab: function validateSecondTab() {
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      this.$store.dispatch(user["d" /* USER_REQUEST */]);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function modPrice(selectorModPrice) {
      var _this = this;

      var txt = "";
      if (selectorModPrice == "oneri") {
        txt += parseFloat(this.calcInfo.allOneri) - parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri));
      }
      if (selectorModPrice == "pratica") {
        txt += parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri));
      }
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: "MODIFICA PREZZO",
        html: txt + '<br /><br />Prezzo aggiornato:<input type="number" step="0.01" id="swal-input1" placeholder = "Prezzo.." class="swal2-input">',
        placeholder: "Inserisci il prezzo",
        inputAttributes: {
          autocapitalize: "off"
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost = parseFloat(_vue.priceNew) / (1 + parseFloat(_vue.iva_altri_oneri));
            _this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            _this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        }
      }).then(function (result) {});
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                docTemp = _this2.documents[_this2.client_type];

                _this2.documents[_this2.client_type] = {};

                selettore_titoloPossesso = _this2.client_ownership;
                selettore_enea = _this2.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this2.documents[_this2.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this2.documents[_this2.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this2.documents[_this2.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onComplate: function onComplate() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingState = true;

                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;
                data.serviceCost = _this3.serviceCostChange ? _this3.calcInfo.serviceCost : "no";
                data.costoAttualizazione = _this3.costoAttualizazioneChange ? _this3.calcInfo.costoAttualizazione : "no";
                // ALL USER DATA
                data.user = _this3.getProfile;
                // BONUS SELECTED
                data.bonus = _this3.ecoBonus;
                // CLIENT DATA
                data.client_name = _this3.clientName;
                data.client_lastname = _this3.clientLastname;
                data.client_type = _this3.client_type;

                data.client_mobile = _this3.client_mobile;
                data.client_phone = _this3.client_phone;
                data.client_email = _this3.client_email;

                // NEWWWWWWWWW
                if (_this3.zeroEnea) {
                  data.client_price_enea = _this3.zeroEneaOld;
                } else {
                  data.client_price_enea = _this3.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this3.zeroDcast) {
                  data.client_price_dcast = _this3.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this3.priceDcast;
                }

                data.client_ownership = _this3.client_ownership;
                data.corporateClient = _this3.getProfile.corporateClient ? _this3.getProfile.corporateClient : "";
                // CLIENT HOUSE DATA
                data.building_province = _this3.province;
                data.building_city = _this3.city.city;
                data.building_zip = _this3.zip;
                data.building_address = _this3.adress;
                data.building_civic = _this3.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this3.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this3.eventType;
                data.intervention_date = hoval_moment(_this3.eventStartdate).format("YYYY-MM-DD");
                // PRODUCTS & ACCESSORIES
                data.products = _this3.products;
                data.accessories = _this3.accessories;
                data.enea_request = _this3.enea;
                data.created_at = hoval_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = hoval_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this3.totalProducts;
                data.total_accessories_price = _this3.totalAccessories;
                data.price_work = _this3.priceWork;

                data.total_transfer_for_user = _this3.calcInfo.aInstallatore;
                data.total_transfer_for_client = _this3.calcInfo.finalPrice;
                data.total_bonus_savings = _this3.calcInfo.totalWithBonus;
                data.total_work_and_iva = _this3.calcInfo.totalBaseAndIva;

                data.iva_altri_oneri = _this3.iva_altri_oneri;
                data.iva_accessori_lavoro = _this3.iva_accessori_lavoro;
                data.iva_age_extra = _this3.iva_age_extra;
                data.iva_age_lavoro = _this3.iva_age_lavoro;
                data.iva_age_accessori = _this3.iva_age_accessori;

                // HTML FOR PDF
                data.htmlInvoice = _this3.$refs.invoiceData.innerHTML;
                //requiredOperations: '',

                data.building_uso_abitativo = _this3.usoAbitativo;
                data = _this3.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/savePriceQuotation",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "Il tuo preventivo è stato salvato correttamento";
                  alert.type = "SUCCESS";
                  _this3.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this3.$swal({
                    type: "success",
                    title: "Preventivo salvato",
                    html: alert.text
                  });
                  _this3.loadingState = false;

                  _this3.$router.push("/offerte");
                }).catch(function (resp) {
                  _this3.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this3.loadingState = false;
                });

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = 800;
      }
      //var AttPercent = 10.58
      var AttPercent = 20;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "").replace(",", ".")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (parseFloat(totAltroAcc) * this.iva_accessori_lavoro + parseFloat(totAge) * this.iva_age_lavoro).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (parseFloat(this.age_extra) * this.iva_age_extra).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * this.iva_altri_oneri).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva = parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) + parseFloat(this.age_extra) * (1 + parseFloat(temp)) + parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      if (this.ecoBonus != "Bonus Casa 50%" && this.client_type == "Partita IVA" && this.usoAbitativo == 0 && this.iva_age_lavoro == "0.22" && this.iva_age_extra == "0.22" && this.iva_accessori_lavoro == "0.22") {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBase) / 100 * parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      }
      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.priceDcast) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;

        var haveCondensed = false;

        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },


    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      this.productIndex = this.productIndex + 1;
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      this.accessoriesIndex = this.accessoriesIndex + 1;
      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = hoval_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = hoval_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = hoval_numeral(this.priceDcast).format("0.0,[00]");
    },


    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      if (this.corporateClient) {
        var data = {
          key: "calc",
          cc: this.corporateClient
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
          method: "POST",
          data: {
            data: data
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.allProducts = resp.data.allProducts;
          _this5.$log(_this5.allProducts);
        }).catch(function (resp) {});
      } else {
        this.setProfile();
      }
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.corporateClient) this.loadProducts();
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = {
        index: "",
        name: "",
        serial: ""
      };
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = hoval_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);
        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 <br/>";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/
        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (this.eventType == "Instalazione" && this.ecoBonus == "Bonus Casa 50%") {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162: function warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text = "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }, 1000);
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    },
    warning16: function warning16() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning15: function warning15() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning2: function warning2() {
      var alert = {};
      alert.text = "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning1: function warning1() {
      var alert = {};
      alert.text = "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;
      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context3.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context3.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context3.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context3.next = 12;
                      break;
                    }

                    _vue.checkProductWithBonusRules(input);
                    return _context3.abrupt("return", result);

                  case 12:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 13:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, _this6);
          }));

          return function preConfirm(_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this7.allProducts;
                _context4.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 18;
                  break;
                }

                x = _context4.t1.value;
                _context4.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context4.t3 = _context4.t2()).done) {
                  _context4.next = 16;
                  break;
                }

                y = _context4.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context4.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context4.abrupt("return", data[x][y]);

              case 14:
                _context4.next = 5;
                break;

              case 16:
                _context4.next = 2;
                break;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = hoval_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE ***************************************" + this.totalExtraMise);

      this.$log(this.products);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;
      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (this.ecoBonus != "Bonus Casa 50%") {
          alert.type = "ERROR";
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      for (var x in this.accessories) {
        price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
      }
      if (price) {
        this.totalAccessories = hoval_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      this.accessories[i].price = hoval_numeral(this.accessories[i].price).format("0.0,[00]");
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza;
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context5.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context5.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context5.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context5.next = 11;
                      break;
                    }

                    return _context5.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _this9.allProducts;
                _context6.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 20;
                  break;
                }

                x = _context6.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context6.next = 18;
                  break;
                }

                _context6.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context6.t3 = _context6.t2()).done) {
                  _context6.next = 18;
                  break;
                }

                y = _context6.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context6.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context6.abrupt("return", data[x][y]);

              case 16:
                _context6.next = 6;
                break;

              case 18:
                _context6.next = 2;
                break;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
    calcIvaCustom: function calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
      }
    }
  },
  watch: {
    client_type: function client_type(val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function usoAbitativo(val) {
      this.calcIvaCustom(this.client_type);
    },
    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    getProfile: function getProfile() {

      this.setProfile();
    },

    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this11 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.zips = resp.data.zips;
          _this11.zipsState = false;
        }).catch(function (resp) {
          _this11.zips = [];
          _this11.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    this.setProfile();
    this.loadProducts();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();
    this.setProfile();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0a9b30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/hoval.vue
var hoval_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm.proccess == "START"
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Calcolatore preventivi")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v(
                    "\n          Compila i seguenti step. In caso di conferma del preventivo tutti i\n          dati inseriti verranno poi utilizzati per generare i documenti\n          richiesti per lo sconto in fattura.\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0 !important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      staticClass: "mt-0 pb-2 formp",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva preventivo",
                        stepSize: _vm.stepSize,
                        color: "#00337f",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": _vm.onComplate
                      }
                    },
                    [
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Scegli Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-12" }, [
                                        _c(
                                          "h2",
                                          {
                                            staticClass:
                                              "pb-0 center section-heading"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Clicca sull`icona del bonus al quale vuoi aderire.\n                  "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Bonus Casa 50% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("6PKJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("DaEW")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Bonus Casa\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Ecobonus 50% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("6PKJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("DaEW")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Ecobonus\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Ecobonus 65% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 65%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("w/IJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("CXbD")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Ecobonus\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{ required: true, max: 63, min: 2 }"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le quattro icone\n                      sopraindicate.\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-3" },
                                        [
                                          _vm._v(
                                            "\n                  Novatag e KPMG, non si ritengono responsabili per eventuali\n                  danni economici derivanti dall.utilizo della piattaforma e\n                  dall.informazioni fornite.\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Inserisci i dati del cliente finale\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_type,
                                                        expression:
                                                          "client_type"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{ required: true, max: 63, min: 2 }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_type"
                                                      ),
                                                      valid: !!_vm.client_type
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "client_type",
                                                      name: "client_type",
                                                      "data-vv-as":
                                                        "Tipologia cliente"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.client_type = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "Amministratore di condominio"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Condominio (Amministratore)\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "Persona fisica"
                                                        }
                                                      },
                                                      [_vm._v("Persona fisica")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value:
                                                                "Partita IVA"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Partita IVA\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_type"
                                                    }
                                                  },
                                                  [_vm._v("Tipologia cliente")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_type"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_type"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientName,
                                                      expression: "clientName"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientName"
                                                    ),
                                                    valid: !!_vm.clientName
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientName",
                                                    name: "clientName",
                                                    "data-vv-as": "Nome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientName =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "clientName" }
                                                  },
                                                  [_vm._v("Nome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientName"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientName"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientLastname,
                                                      expression:
                                                        "clientLastname"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientLastname"
                                                    ),
                                                    valid: !!_vm.clientLastname
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientLastname",
                                                    name: "clientLastname",
                                                    "data-vv-as": "Cognome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientLastname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientLastname =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "clientLastname"
                                                    }
                                                  },
                                                  [_vm._v("Cognome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientLastname"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientLastname"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_email,
                                                      expression: "client_email"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        email: true,
                                                        temporaryEmail: true,
                                                        plusIssueEmail: true,
                                                        max: 56
                                                      },
                                                      expression:
                                                        "{\n                        required: true,\n                        email: true,\n                        temporaryEmail: true,\n                        plusIssueEmail: true,\n                        max: 56,\n                      }"
                                                    }
                                                  ],
                                                  ref: "client_email",
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_email"
                                                    ),
                                                    valid: !!_vm.client_email
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_email",
                                                    name: "client_email",
                                                    "data-vv-as": "Email"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_email =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_email"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Email*\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_email"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_email"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_phone,
                                                      expression: "client_phone"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[0]+/
                                                      },
                                                      expression:
                                                        "{\n                        required: false,\n                        max: 12,\n                        min: 8,\n                        regex: /^[0]+/,\n                      }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_phone"
                                                    ),
                                                    valid: !!_vm.client_phone
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_phone",
                                                    name: "client_phone",
                                                    "data-vv-as": "Telefono"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_phone
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_phone =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_phone"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Telefono\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_phone"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_phone"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_mobile,
                                                      expression:
                                                        "client_mobile"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[3]+/
                                                      },
                                                      expression:
                                                        "{\n                        required: true,\n                        max: 12,\n                        min: 8,\n                        regex: /^[3]+/,\n                      }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_mobile"
                                                    ),
                                                    valid: !!_vm.client_mobile
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_mobile",
                                                    name: "client_mobile",
                                                    "data-vv-as": "Cellulare"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_mobile
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_mobile =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_mobile"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Cellulare *\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_mobile"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_mobile"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.ecoBonus != "Bonus Casa 50%"
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "usoAbitativo"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Prevalente uso abitativo\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("SI")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("NO")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-1.usoAbitativo"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-1.usoAbitativo')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Il servizio deve essere accettato oppure rifiutato\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black pb-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Inserisci l'indirizzo dell'immobile\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.province,
                                                        expression: "province"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.province"
                                                      ),
                                                      valid: !!_vm.province
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomy",
                                                      id: "province",
                                                      name: "province",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.province = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.provincies,
                                                      function(province) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: province.sigla,
                                                            domProps: {
                                                              value:
                                                                province.sigla
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  province.sigla
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  province.provincia
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "province" }
                                                  },
                                                  [_vm._v("Provincia")]
                                                ),
                                                _vm._v(" "),
                                                _vm.provinciesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id:
                                                                "loadProvince",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.province"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.province"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.cityError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli Provincia"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.city,
                                                        expression: "city"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.city"
                                                      ),
                                                      valid: !!_vm.city
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomu",
                                                      id: "city",
                                                      name: "city",
                                                      "data-vv-as": "Località",
                                                      disabled: _vm.citiesState
                                                    },
                                                    on: {
                                                      click: _vm.checkProvince,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.city = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.cities, function(
                                                      city
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: city.comune,
                                                          domProps: {
                                                            value: {
                                                              cityistat:
                                                                city.istat,
                                                              city: city.comune
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                city.comune
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "city" }
                                                  },
                                                  [_vm._v("Località")]
                                                ),
                                                _vm._v(" "),
                                                _vm.citiesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadCity",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.city")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.city"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.zipError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli città"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zip,
                                                        expression: "zip"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.zip"
                                                      ),
                                                      valid: !!_vm.zip
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomi",
                                                      id: "zip",
                                                      name: "zip",
                                                      "data-vv-as": "Cap",
                                                      disabled: _vm.zipsState
                                                    },
                                                    on: {
                                                      click: _vm.checkZip,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.zip = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        selected: true
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.zips, function(
                                                      zip
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: zip.cap,
                                                          domProps: {
                                                            value: zip.cap
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(zip.cap) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "zip" }
                                                  },
                                                  [_vm._v("Cap")]
                                                ),
                                                _vm._v(" "),
                                                _vm.zipsState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadZips",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.zip")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.zip"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.adress,
                                                      expression: "adress"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 128,
                                                        min: 5
                                                      },
                                                      expression:
                                                        "{ required: true, max: 128, min: 5 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.adress"
                                                    ),
                                                    valid: !!_vm.adress
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "adress",
                                                    name: "adress",
                                                    "data-vv-as": "Indirizzo"
                                                  },
                                                  domProps: {
                                                    value: _vm.adress
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.adress =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "adress" }
                                                  },
                                                  [_vm._v("Indirizzo")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.adress")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.adress"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.civic,
                                                      expression: "civic"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 15,
                                                        min: 1
                                                      },
                                                      expression:
                                                        "{ required: true, max: 15, min: 1 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.civic"
                                                    ),
                                                    valid: !!_vm.civic
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "civic",
                                                    name: "civic",
                                                    "data-vv-as": "Civico"
                                                  },
                                                  domProps: {
                                                    value: _vm.civic
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.civic =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "civic" }
                                                  },
                                                  [_vm._v("Civico")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.civic")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.civic"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        })
                                      ])
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [_vm._v("LISTA DOCUMENTI")]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Dati Intervento",
                            icon: "",
                            "before-change": _vm.validateSecondTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull orangeBg",
                              attrs: {
                                "data-vv-scope": "form-2",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                    Inserisci i dati dell'intervento\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.eventType,
                                                expression: "eventType"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-2.eventType"
                                              ),
                                              valid: !!_vm.eventType
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "eventType",
                                              name: "eventType",
                                              "data-vv-as": "Tipo di intervento"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.eventType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                                selected: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "sostituzione" }
                                              },
                                              [_vm._v("Sostituzione")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "Instalazione" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Nuova Installazione\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "eventType" }
                                          },
                                          [_vm._v("Tipo di intervento")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-2.eventType")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-2.eventType"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                    Inserisci Beni Significativi\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "widthFull" },
                                        _vm._l(_vm.products, function(
                                          elem,
                                          num
                                        ) {
                                          return _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: elem.group,
                                                              expression:
                                                                "elem.group"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{ required: true, is_not: '' }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.g" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.group
                                                          },
                                                          attrs: {
                                                            id:
                                                              "g" + elem.index,
                                                            name:
                                                              "g" + elem.index,
                                                            "data-vv-as":
                                                              "Gruppo"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "group",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setGroup(
                                                                  elem.index
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _vm.ecoBonus ==
                                                          "Ecobonus 50%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value ==
                                                                        "condensazione" ||
                                                                      item.value ==
                                                                        "altroVaillant"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : _vm.ecoBonus ==
                                                              "Ecobonus 65%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value !=
                                                                      "tradizionale"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                item.name
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "group"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli gruppo prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.g" + elem.index
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.g" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-5" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      elem.group != "ibridi" &&
                                                      elem.group !=
                                                        "altroVaillant"
                                                        ? _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{ required: true, is_not: '' }"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : elem.group ==
                                                          "altroVaillant"
                                                        ? _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product
                                                                    .name,
                                                                expression:
                                                                  "elem.product.name"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required: true,
                                                                  is_not: ""
                                                                },
                                                                expression:
                                                                  "{ required: true, is_not: '' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.p" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id:
                                                                "p" +
                                                                elem.index,
                                                              name:
                                                                "p" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Prodotto"
                                                            },
                                                            domProps: {
                                                              value:
                                                                elem.product
                                                                  .name
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              },
                                                              click:
                                                                _vm.checkIfEmpty,
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  elem.product,
                                                                  "name",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{ required: true, is_not: '' }"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        "\n                              " +
                                                                        _vm._s(
                                                                          item.ModelloPompaDiCalore
                                                                        ) +
                                                                        " +\n                              " +
                                                                        _vm._s(
                                                                          item.ModelloCaldaiaACondensazione
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "product"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli Prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.p" + elem.index
                                                      ) && !elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.p" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Prima scegli gruppo\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mr-md-0 pr-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.quantity,
                                                            expression:
                                                              "elem.quantity"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0",
                                                              min_value: 1,
                                                              max: 4
                                                            },
                                                            expression:
                                                              "{\n                              required: true,\n                              is_not: '0',\n                              min_value: 1,\n                              max: 4,\n                            }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.q" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.quantity
                                                        },
                                                        attrs: {
                                                          type: "number",
                                                          id:
                                                            "q" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "q" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Quantità"
                                                        },
                                                        domProps: {
                                                          value: elem.quantity
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.calcTotalPriceProducts()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "quantity",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Quantità")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.q" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.q" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 pl-md-0 ml-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.price,
                                                            expression:
                                                              "elem.price"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0"
                                                            },
                                                            expression:
                                                              "{ required: true, is_not: '0' }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.i" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.price
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id:
                                                            "i" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "i" +
                                                            elem.indexCount,
                                                          "data-vv-as": "Prezzo"
                                                        },
                                                        domProps: {
                                                          value: elem.price
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.formatPrice(
                                                              elem.index
                                                            ),
                                                              _vm.calcTotalPriceProducts()
                                                          },
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            return _vm.keymonitor(
                                                              $event,
                                                              elem.index,
                                                              "prod"
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "price",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Prezzo €")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "widthFull center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            (IVA esclusa)\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.i" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.i" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "removeProduct pointer",
                                                      class: elem.index
                                                    },
                                                    [
                                                      num != 0
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "trash-alt",
                                                                size: "lg"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeProduct(
                                                                    num
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: { click: _vm.addProduct }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: { click: _vm.addProduct }
                                                }),
                                                _vm._v(
                                                  "\n                        Aggiungi prodotto\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo prodotti (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalProducts) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Inserisci altri Beni/Accessori opzionali\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.accessories, function(
                                        elem,
                                        num
                                      ) {
                                        return _c(
                                          "div",
                                          { staticClass: "row" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.group,
                                                            expression:
                                                              "elem.group"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {},
                                                            expression: "{}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.ac" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.group
                                                        },
                                                        attrs: {
                                                          id: "ac" + elem.index,
                                                          name:
                                                            "ac" + elem.index,
                                                          "data-vv-as":
                                                            "accessori opzionali"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "group",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setTypeAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessori,
                                                        function(item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                selected:
                                                                  "selected"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    item.name
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "group" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Scegli accessori opzionali"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ac" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ac" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product,
                                                                expression:
                                                                  "elem.product"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required:
                                                                    elem.group !=
                                                                    ""
                                                                },
                                                                expression:
                                                                  "{ required: elem.group != '' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.ap" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              id:
                                                                "ap" +
                                                                elem.index,
                                                              name:
                                                                "ap" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Accessorio"
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    elem,
                                                                    "product",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setAccessories(
                                                                    elem.index
                                                                  )
                                                                }
                                                              ],
                                                              click:
                                                                _vm.checkIfEmpty
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .itemsAccessories[
                                                              elem.index
                                                            ],
                                                            function(
                                                              item,
                                                              ind
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value: {
                                                                      index: ind,
                                                                      name:
                                                                        item.Modello,
                                                                      serial:
                                                                        item.codice
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        item.Modello
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product
                                                                  .name,
                                                              expression:
                                                                "elem.product.name"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required:
                                                                  elem.group !=
                                                                  "",
                                                                max: 128
                                                              },
                                                              expression:
                                                                "{\n                            required: elem.group != '',\n                            max: 128,\n                          }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.ap" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem
                                                              .product.name
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            id:
                                                              "ap" + elem.index,
                                                            name:
                                                              "ap" + elem.index,
                                                            "data-vv-as":
                                                              "Accessorio"
                                                          },
                                                          domProps: {
                                                            value:
                                                              elem.product.name
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                elem.product,
                                                                "name",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Scegli Accessorio"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Inserisci Accessorio"
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ) && !elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ap" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          Prima scegli tipo\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-2 mr-md-0 pr-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.quantity,
                                                          expression:
                                                            "elem.quantity"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0",
                                                            min_value: 1,
                                                            max: 4
                                                          },
                                                          expression:
                                                            "{\n                            required: elem.group != '',\n                            is_not: '0',\n                            min_value: 1,\n                            max: 4,\n                          }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.aq" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.quantity
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        id:
                                                          "aq" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "aq" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Quantità"
                                                      },
                                                      domProps: {
                                                        value: elem.quantity
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.calcTotalPriceAccessories()
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "quantity",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Quantità")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.aq" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.aq" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-2 pl-md-0 ml-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.price,
                                                          expression:
                                                            "elem.price"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0"
                                                          },
                                                          expression:
                                                            "{\n                            required: elem.group != '',\n                            is_not: '0',\n                          }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.ai" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.price
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id:
                                                          "ai" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "ai" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Prezzo"
                                                      },
                                                      domProps: {
                                                        value: elem.price
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.formatPriceAccessories(
                                                            elem.index
                                                          )
                                                          _vm.calcTotalPriceAccessories()
                                                        },
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          return _vm.keymonitor(
                                                            $event,
                                                            elem.index,
                                                            "accs"
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "price",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Prezzo €")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "widthFull center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          (IVA esclusa)\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ai" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ai" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "removeProduct pointer",
                                                    class: elem.index
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "trash-alt",
                                                        size: "lg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeAccessories(
                                                            num
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: {
                                                  click: _vm.addAccessories
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: {
                                                    click: _vm.addAccessories
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                        Aggiungi accessorio\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo accessori opzionali (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalAccessories) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [_vm._v("Pratica ENEA")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceEnea,
                                                      expression: "priceEnea"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceEnea"
                                                    ),
                                                    valid: !!_vm.priceEnea
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceEnea",
                                                    name: "priceEnea",
                                                    "data-vv-as":
                                                      "Costo Gestione Pratica ENEA"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceEnea
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceEnea()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceEnea =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceEnea" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Costo Gestione Pratica ENEA"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    "Valore che sarà addebitato al cliente "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceEnea"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceEnea"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !_vm.NoEnea
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "datiCatastali"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Servizio di redazione e invio pratica ENEA ad un\n                            costo di €50 +IVA ( costo che ti sarà addebitato\n                            se accetti il servizio )\n                          "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.enea = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.enea,
                                                                      expression:
                                                                        "enea"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-2.enea"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name: "enea"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.enea,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.enea =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "ACCETTO"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.enea = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.enea,
                                                                      expression:
                                                                        "enea"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-2.enea"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name: "enea"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.enea,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.enea =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "NON ACCETTO"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-2.enea"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-2.enea')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Il servizio deve essere accettato oppure rifiutato\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Installazione e Posa in Opera\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceWork,
                                                      expression: "priceWork"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceWork"
                                                    ),
                                                    valid: !!_vm.priceWork
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceWork",
                                                    name: "priceWork",
                                                    "data-vv-as":
                                                      "Importo installazione/posa in opera"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceWork
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceWork()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceWork =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceWork" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera ( IVA esclusa\n                          )"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceWork"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceWork"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceDcast
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                    "\n                        €\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-2 pb-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Riepilogo aliquote IVA\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota concorrente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_lavoro,
                                                          expression:
                                                            "iva_age_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_age_lavoro
                                                      },
                                                      attrs: {
                                                        id: "iva_age_lavoro",
                                                        name: "iva_age_lavoro",
                                                        "data-vv-as":
                                                          "Beni significativi, quota concorrente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota eccedente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_extra,
                                                          expression:
                                                            "iva_age_extra"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_extra"
                                                        ),
                                                        valid: !!_vm.iva_age_extra
                                                      },
                                                      attrs: {
                                                        id: "iva_age_extra",
                                                        name: "iva_age_extra",
                                                        "data-vv-as":
                                                          "Beni significativi, quota eccedente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_extra = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri Beni / Accessori opzionali / Installazione e\n                        Posa in Opera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_accessori_lavoro,
                                                          expression:
                                                            "iva_accessori_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_accessori_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_accessori_lavoro
                                                      },
                                                      attrs: {
                                                        id:
                                                          "iva_accessori_lavoro",
                                                        name:
                                                          "iva_accessori_lavoro",
                                                        "data-vv-as":
                                                          "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_accessori_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri oneri per il Committente\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_altri_oneri,
                                                          expression:
                                                            "iva_altri_oneri"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_altri_oneri"
                                                        ),
                                                        valid: !!_vm.iva_altri_oneri
                                                      },
                                                      attrs: {
                                                        id: "iva_altri_oneri",
                                                        name: "iva_altri_oneri",
                                                        "data-vv-as":
                                                          "Altri oneri per il Committente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_altri_oneri = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.client_type ==
                                                "Persona fisica" &&
                                              _vm.usoAbitativo == 1 &&
                                              (_vm.iva_altri_oneri == "0.04" ||
                                                _vm.iva_accessori_lavoro ==
                                                  "0.04" ||
                                                _vm.iva_age_extra == "0.04" ||
                                                _vm.iva_age_lavoro == "0.04")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-8 mb-3 center text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "Bold center"
                                                        },
                                                        [_vm._v("Attenzione!")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b", [
                                                        _vm._v(
                                                          "Non tutti gli acquisti e interventi, a prescindere,\n                        possono essere considerati secondo l’aliquota\n                        agevolata al 4% bensì esclusivamente quelli\n                        prettamente collegati alla specifica disabilità del\n                        cliente finale.\n                      "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _c("br"),
                                                      _c(
                                                        "b",
                                                        { staticClass: "red" },
                                                        [
                                                          _vm._v(
                                                            "Occorre, pertanto, verificare la tipologia di\n                        intervento da eseguire per verificare se il cliente\n                        potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mt-2 center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Consulta la\n                        "
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "Bold underline black",
                                                              attrs: {
                                                                href:
                                                                  "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [_vm._v("guida")]
                                                          ),
                                                          _vm._v(
                                                            "\n                        relativa alle agevolazioni fiscali per le persone con\n                        disabilità.\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _vm.requiredOperations
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 mb-3 requiredCont"
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "green" },
                                                  [
                                                    _vm._v(
                                                      "\n                        Requisiti tecnici richiesti per aderire al bonus:\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("h5", {
                                                  staticClass: "black",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.requiredOperations
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Anteprima",
                            subtitle: "Tutti i campi sono obbligatori",
                            icon: "",
                            "before-change": _vm.validateThirdTab
                          }
                        },
                        [
                          _vm.calcFinish
                            ? _c(
                                "form",
                                {
                                  staticClass: "widthFull orio pt-3 pr-md-3",
                                  attrs: {
                                    "data-vv-scope": "form-3",
                                    autocomplete: "qwerqrt3"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "invoiceData",
                                      staticClass: "widthFull"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider fordelete"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 mt-4"
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Cessionario/prestatore (fornitore)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Identificativo fiscale ai fini IVA:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile
                                                          .partita_iva
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Denominazione: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.azienda
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Indirizzo:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.indirizzo
                                                      ) +
                                                        "\n                          " +
                                                        _vm._s(
                                                          _vm.getProfile.civico
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Comune:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.comune
                                                      ) +
                                                        " (" +
                                                        _vm._s(
                                                          _vm.getProfile
                                                            .provincia
                                                        ) +
                                                        ")"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cap: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.getProfile.cap)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.email
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cellulare: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.cellulare
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("IBAN: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.iban
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm.getProfile.logo
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "50% !important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            _vm.getProfile.logo
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Benificiario/committente (cliente)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Denominazione:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.clientName) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.clientLastname
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Indirizzo: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.adress) +
                                                        " " +
                                                        _vm._s(_vm.civic)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Comune: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.city.city) +
                                                        " (" +
                                                        _vm._s(_vm.province) +
                                                        ")"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cap: "),
                                                  _c("b", [
                                                    _vm._v(_vm._s(_vm.zip))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.client_email)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_phone
                                                    ? _c("span", [
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_phone
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_mobile
                                                    ? _c("span", [
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_mobile
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left pt-4 h0 black"
                                        },
                                        [_c("b", [_vm._v("La tua offerta:")])]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario == "si"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89\n                  della Legge n. 190/2014, così come modificato dalla Legge\n                  numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\n                "
                                              )
                                            ]
                                          )
                                        : _vm.client_type == "Partita IVA" &&
                                          _vm.iva_age_lavoro == "0.00" &&
                                          _vm.iva_age_extra == "0.00"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Operazione soggetta al reverse charge art. 17, comma 6,\n                  lett. a-ter DPR 633/1972.\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead"),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Beni significativi"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prezzo unitario")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.products, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.price) +
                                                            " €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.totalProducts
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Agevolabile Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalProducts
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) -
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Altri beni ed accessori"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prezzo unitario")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.accessories, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.price) +
                                                            " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", {
                                                  attrs: { scope: "row" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "2" } },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.priceWork
                                                          ) +
                                                          " € "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale altri beni ed accessori\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.totalAccessories
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ) +
                                                              parseFloat(
                                                                _vm.priceWork
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              )
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale intervento\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    "imponibile"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "220",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .totalBase
                                                              )
                                                            ) + " €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si"
                                        ? _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("thead", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [_vm._v("Riepilogo")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", {
                                                    attrs: {
                                                      align: "left",
                                                      scope: "row"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm._v(
                                                            "Importo\n                          "
                                                          ),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                          "si"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Aliquota IVA")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Totale (IVA Inclusa)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota concorrente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.age_lavoro)
                                                          ) + " €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.age_lavoro
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_age_lavoro
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota eccedente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.age_extra)
                                                          ) + " €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_extra *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.age_extra
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_age_extra
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri Beni / Accessori opzionali / Installazione e\n                        Posa in Opera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.totalAccessories
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                                parseFloat(
                                                                  _vm.priceWork
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                )
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_accessori_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                (parseFloat(
                                                                  _vm.totalAccessories
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.priceWork
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  )) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_accessori_lavoro
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale fattura Spesa agevolabile\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    "(IVA INCLUSA)"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .totalBaseAndIva
                                                              )
                                                            ) +
                                                              "\n                            €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        { staticClass: "table table-bordered" },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "uppercase",
                                                  attrs: {
                                                    colspan: "2",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Sconto in fattura " +
                                                      _vm._s(this.ecoBonus) +
                                                      "\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        this.client_type ==
                                                          "Partita IVA" &&
                                                        this.usoAbitativo ==
                                                          0 &&
                                                        this.iva_age_lavoro ==
                                                          "0.22" &&
                                                        this.iva_age_extra ==
                                                          "0.22" &&
                                                        this
                                                          .iva_accessori_lavoro ==
                                                          "0.22"
                                                          ? void 0
                                                          : [
                                                              _vm._v(
                                                                " (IVA INCLUSA)"
                                                              )
                                                            ]
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 121, D.L. 34/20 convertito con Legge 17 luglio\n                          2020)\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.calcInfo
                                                            .totalWithBonus
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale fattura al committente per bonifico parlante\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus ==
                                                        "Bonus Casa 50%"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            (Art. 16 bis, D.P.R. 917/86)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus !=
                                                        "Bonus Casa 50%"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            (Art. 1, Legge 296/2006 e art. 14 D.L.\n                            63/2013)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .totalBaseAndIva
                                                            ) -
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .totalWithBonus
                                                              )
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Altri oneri per il committente"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: "2",
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Quota spesa non agevolata\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.totalExtraMise
                                                            ) +
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .iva22NonAge
                                                            ) +
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .iva10NonAge
                                                            )
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                          €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm._v(
                                                    "\n                        Gestione Pratica ENEA\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.zeroEnea,
                                                            expression:
                                                              "zeroEnea"
                                                          }
                                                        ],
                                                        key: "1111",
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: "zeroEnea"
                                                        },
                                                        domProps: {
                                                          checked: Array.isArray(
                                                            _vm.zeroEnea
                                                          )
                                                            ? _vm._i(
                                                                _vm.zeroEnea,
                                                                null
                                                              ) > -1
                                                            : _vm.zeroEnea
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.zeroEnea,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.zeroEnea = $$a.concat(
                                                                    [$$v]
                                                                  ))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.zeroEnea = $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                              }
                                                            } else {
                                                              _vm.zeroEnea = $$c
                                                            }
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          attrs: {
                                                            for: "zeroEnea"
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "Escludi questa voce dal preventivo"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            (
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                            ).toFixed(2)
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm.priceEnea
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ).toFixed(2)
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Oneri Finanziari\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [_vm._v("(IVA ESENTE)")]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label btn btn-sm btn-primary",
                                                          attrs: {
                                                            for: "zeroOneri"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modPrice(
                                                                "oneri"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Modifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.pricenewFlag
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .serviceCost
                                                                ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_altri_oneri
                                                                    ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .serviceCost
                                                                ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_altri_oneri
                                                                    ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Costi di gestione pratica\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label btn btn-sm btn-primary",
                                                          attrs: {
                                                            for: "zeroPratica"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modPrice(
                                                                "pratica"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Modifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.pricenewFlag
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale altri oneri per il committente\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA " +
                                                                  _vm._s(
                                                                    _vm.iva_altri_oneri *
                                                                      100
                                                                  ) +
                                                                  " %\n                            INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario != "si"
                                                      ? _c("b", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\n                          €"
                                                          )
                                                        ])
                                                      : _c("b", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\n                          €"
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row ml-0 mr-0 pt-2" },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale da pagare "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            ( a carico dell’utente finale\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    ", IVA inclusa"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                            )"
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .finalPrice
                                                              )
                                                            ) + " €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table mb-0 mt-3 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm.getProfile
                                                          .reg_forfettario ==
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "\n                            Operazione in franchigia da Iva ex art. 1 cc.\n                            54-89 L. 190/2014\n                          "
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n\n                          L’utilizzo dei servizi descritti sul Sito comporta\n                          l’integrale accettazione dei\n                          "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "green",
                                                            attrs: {
                                                              href:
                                                                _vm.utilizzoPolicy,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Termini e delle condizioni di riferimento\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "widthFull mt-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row justify-content-center"
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table table-bordered"
                                          },
                                          [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      "\n                          IMPORTO TOTALE DEL CREDITO CEDUTO\n                          "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalWithBonus
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var hoval_staticRenderFns = []
hoval_render._withStripped = true
var hoval_esExports = { render: hoval_render, staticRenderFns: hoval_staticRenderFns }
/* harmony default export */ var calcolatore_hoval = (hoval_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f0a9b30", hoval_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/calcolatore/hoval.vue
var hoval_disposed = false
var hoval_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var hoval___vue_template_functional__ = false
/* styles */
var hoval___vue_styles__ = null
/* scopeId */
var hoval___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var hoval___vue_module_identifier__ = null
var hoval_Component = hoval_normalizeComponent(
  hoval,
  calcolatore_hoval,
  hoval___vue_template_functional__,
  hoval___vue_styles__,
  hoval___vue_scopeId__,
  hoval___vue_module_identifier__
)
hoval_Component.options.__file = "src/components/calcolatore/hoval.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f0a9b30", hoval_Component.options)
  } else {
    hotAPI.reload("data-v-7f0a9b30", hoval_Component.options)
  }
  module.hot.dispose(function (data) {
    hoval_disposed = true
  })
})()}

/* harmony default export */ var components_calcolatore_hoval = (hoval_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calcolatore/emicon.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var emicon_moment = __webpack_require__("PJh5");

var emicon_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';







// GET DOC LIST


/* harmony default export */ var emicon = ({
  name: "emicon",
  data: function data() {
    var _ref;

    return _ref = {
      username: "",
      documents: documents_documents,
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",

      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",

      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {

        /*0: {
          name: "Caldaia a condensazione",
          value: "condensazione",
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale",
        },*/
        0: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        /*3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi",
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua",
        },
        5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },
        5: {
          name: "Collettore solare termico",
          value: "solare",
        },*/
        1: {
          name: "Altro Prodotto",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        /*0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione",
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV",
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche",
        },*/
        0: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: 1,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      passwordFieldType: "password",
      moment: emicon_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      accessories: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "0",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", "0"), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", "0"), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", true), defineProperty_default()(_ref, "priceDcast", "0"), defineProperty_default()(_ref, "iva_altri_oneri", 0.22), defineProperty_default()(_ref, "iva_accessori_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_extra", 0.22), defineProperty_default()(_ref, "iva_age_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_accessori", 0.1), defineProperty_default()(_ref, "priceNew", 0), defineProperty_default()(_ref, "pricenewFlag", false), defineProperty_default()(_ref, "costoAttualizazioneChange", false), defineProperty_default()(_ref, "serviceCostChange", false), defineProperty_default()(_ref, "age_lavoro", 0), defineProperty_default()(_ref, "age_extra", 0), defineProperty_default()(_ref, "corporateClient", ''), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab: function validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
      return true;
    },

    validateSecondTab: function validateSecondTab() {
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      this.$store.dispatch(user["d" /* USER_REQUEST */]);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function modPrice(selectorModPrice) {
      var _this = this;

      var txt = "";
      if (selectorModPrice == "oneri") {
        txt += parseFloat(this.calcInfo.allOneri) - parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri));
      }
      if (selectorModPrice == "pratica") {
        txt += parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri));
      }
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: "MODIFICA PREZZO",
        html: txt + '<br /><br />Prezzo aggiornato:<input type="number" step="0.01" id="swal-input1" placeholder = "Prezzo.." class="swal2-input">',
        placeholder: "Inserisci il prezzo",
        inputAttributes: {
          autocapitalize: "off"
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost = parseFloat(_vue.priceNew) / (1 + parseFloat(_vue.iva_altri_oneri));
            _this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            _this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        }
      }).then(function (result) {});
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                docTemp = _this2.documents[_this2.client_type];

                _this2.documents[_this2.client_type] = {};

                selettore_titoloPossesso = _this2.client_ownership;
                selettore_enea = _this2.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this2.documents[_this2.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this2.documents[_this2.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this2.documents[_this2.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onComplate: function onComplate() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingState = true;

                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;
                data.serviceCost = _this3.serviceCostChange ? _this3.calcInfo.serviceCost : "no";
                data.costoAttualizazione = _this3.costoAttualizazioneChange ? _this3.calcInfo.costoAttualizazione : "no";
                // ALL USER DATA
                data.user = _this3.getProfile;
                // BONUS SELECTED
                data.bonus = _this3.ecoBonus;
                // CLIENT DATA
                data.client_name = _this3.clientName;
                data.client_lastname = _this3.clientLastname;
                data.client_type = _this3.client_type;

                data.client_mobile = _this3.client_mobile;
                data.client_phone = _this3.client_phone;
                data.client_email = _this3.client_email;

                // NEWWWWWWWWW
                if (_this3.zeroEnea) {
                  data.client_price_enea = _this3.zeroEneaOld;
                } else {
                  data.client_price_enea = _this3.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this3.zeroDcast) {
                  data.client_price_dcast = _this3.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this3.priceDcast;
                }

                data.client_ownership = _this3.client_ownership;
                data.corporateClient = _this3.getProfile.corporateClient ? _this3.getProfile.corporateClient : "";
                // CLIENT HOUSE DATA
                data.building_province = _this3.province;
                data.building_city = _this3.city.city;
                data.building_zip = _this3.zip;
                data.building_address = _this3.adress;
                data.building_civic = _this3.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this3.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this3.eventType;
                data.intervention_date = emicon_moment(_this3.eventStartdate).format("YYYY-MM-DD");
                // PRODUCTS & ACCESSORIES
                data.products = _this3.products;
                data.accessories = _this3.accessories;
                data.enea_request = _this3.enea;
                data.created_at = emicon_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = emicon_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this3.totalProducts;
                data.total_accessories_price = _this3.totalAccessories;
                data.price_work = _this3.priceWork;

                data.total_transfer_for_user = _this3.calcInfo.aInstallatore;
                data.total_transfer_for_client = _this3.calcInfo.finalPrice;
                data.total_bonus_savings = _this3.calcInfo.totalWithBonus;
                data.total_work_and_iva = _this3.calcInfo.totalBaseAndIva;

                data.iva_altri_oneri = _this3.iva_altri_oneri;
                data.iva_accessori_lavoro = _this3.iva_accessori_lavoro;
                data.iva_age_extra = _this3.iva_age_extra;
                data.iva_age_lavoro = _this3.iva_age_lavoro;
                data.iva_age_accessori = _this3.iva_age_accessori;

                // HTML FOR PDF
                data.htmlInvoice = _this3.$refs.invoiceData.innerHTML;
                //requiredOperations: '',

                data.building_uso_abitativo = _this3.usoAbitativo;
                data = _this3.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/savePriceQuotation",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "Il tuo preventivo è stato salvato correttamento";
                  alert.type = "SUCCESS";
                  _this3.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this3.$swal({
                    type: "success",
                    title: "Preventivo salvato",
                    html: alert.text
                  });
                  _this3.loadingState = false;

                  _this3.$router.push("/offerte");
                }).catch(function (resp) {
                  _this3.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this3.loadingState = false;
                });

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = 800;
      }
      //var AttPercent = 10.58
      var AttPercent = 20;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "").replace(",", ".")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (parseFloat(totAltroAcc) * this.iva_accessori_lavoro + parseFloat(totAge) * this.iva_age_lavoro).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (parseFloat(this.age_extra) * this.iva_age_extra).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * this.iva_altri_oneri).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva = parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) + parseFloat(this.age_extra) * (1 + parseFloat(temp)) + parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      if (this.ecoBonus != "Bonus Casa 50%" && this.client_type == "Partita IVA" && this.usoAbitativo == 0 && this.iva_age_lavoro == "0.22" && this.iva_age_extra == "0.22" && this.iva_accessori_lavoro == "0.22") {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBase) / 100 * parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      }
      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.priceDcast) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;

        var haveCondensed = false;

        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },


    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      this.productIndex = this.productIndex + 1;
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      this.accessoriesIndex = this.accessoriesIndex + 1;
      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = emicon_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = emicon_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = emicon_numeral(this.priceDcast).format("0.0,[00]");
    },


    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      if (this.corporateClient) {
        var data = {
          key: "calc",
          cc: this.corporateClient
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
          method: "POST",
          data: {
            data: data
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.allProducts = resp.data.allProducts;
          _this5.$log(_this5.allProducts);
        }).catch(function (resp) {});
      } else {
        this.setProfile();
      }
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.corporateClient) this.loadProducts();
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = {
        index: "",
        name: "",
        serial: ""
      };
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = emicon_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);
        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 <br/>";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/
        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (this.eventType == "Instalazione" && this.ecoBonus == "Bonus Casa 50%") {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162: function warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text = "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }, 1000);
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    },
    warning16: function warning16() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning15: function warning15() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning2: function warning2() {
      var alert = {};
      alert.text = "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning1: function warning1() {
      var alert = {};
      alert.text = "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;
      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context3.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context3.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context3.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context3.next = 12;
                      break;
                    }

                    _vue.checkProductWithBonusRules(input);
                    return _context3.abrupt("return", result);

                  case 12:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 13:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, _this6);
          }));

          return function preConfirm(_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this7.allProducts;
                _context4.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 18;
                  break;
                }

                x = _context4.t1.value;
                _context4.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context4.t3 = _context4.t2()).done) {
                  _context4.next = 16;
                  break;
                }

                y = _context4.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context4.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context4.abrupt("return", data[x][y]);

              case 14:
                _context4.next = 5;
                break;

              case 16:
                _context4.next = 2;
                break;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = emicon_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE ***************************************" + this.totalExtraMise);

      this.$log(this.products);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;
      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (this.ecoBonus != "Bonus Casa 50%") {
          alert.type = "ERROR";
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      for (var x in this.accessories) {
        price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
      }
      if (price) {
        this.totalAccessories = emicon_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      this.accessories[i].price = emicon_numeral(this.accessories[i].price).format("0.0,[00]");
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza;
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context5.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context5.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context5.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context5.next = 11;
                      break;
                    }

                    return _context5.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _this9.allProducts;
                _context6.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 20;
                  break;
                }

                x = _context6.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context6.next = 18;
                  break;
                }

                _context6.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context6.t3 = _context6.t2()).done) {
                  _context6.next = 18;
                  break;
                }

                y = _context6.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context6.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context6.abrupt("return", data[x][y]);

              case 16:
                _context6.next = 6;
                break;

              case 18:
                _context6.next = 2;
                break;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
    calcIvaCustom: function calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
      }
    }
  },
  watch: {
    client_type: function client_type(val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function usoAbitativo(val) {
      this.calcIvaCustom(this.client_type);
    },
    getProfile: function getProfile() {

      this.setProfile();
    },

    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this11 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.zips = resp.data.zips;
          _this11.zipsState = false;
        }).catch(function (resp) {
          _this11.zips = [];
          _this11.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    this.setProfile();
    this.loadProducts();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();
    this.setProfile();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75574de3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/emicon.vue
var emicon_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm.proccess == "START"
              ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
                  _c("b", [_vm._v("Calcolatore preventivi")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
                  _vm._v(
                    "\n          Compila i seguenti step. In caso di conferma del preventivo tutti i\n          dati inseriti verranno poi utilizzati per generare i documenti\n          richiesti per lo sconto in fattura.\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          _vm.proccess == "START"
            ? _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
                  staticStyle: { "margin-top": "0 !important" }
                },
                [
                  _c(
                    "form-wizard",
                    {
                      staticClass: "mt-0 pb-2 formp",
                      attrs: {
                        title: "",
                        subtitle: "",
                        nextButtonText: "Avanti >",
                        backButtonText: "< Indietro",
                        finishButtonText: "Salva preventivo",
                        stepSize: _vm.stepSize,
                        color: "#00337f",
                        errorColor: "#ff1100"
                      },
                      on: {
                        "on-change": _vm.stepIndex,
                        "on-complete": _vm.onComplate
                      }
                    },
                    [
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Scegli Bonus",
                                icon: "",
                                "before-change": _vm.validateZeroTab
                              }
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "widthFull",
                                  attrs: {
                                    "data-vv-scope": "form-0",
                                    autocomplete: "qwerqrt2"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-4"
                                    },
                                    [
                                      _c("div", { staticClass: "col-md-12" }, [
                                        _c(
                                          "h2",
                                          {
                                            staticClass:
                                              "pb-0 center section-heading"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Clicca sull`icona del bonus al quale vuoi aderire.\n                  "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Bonus Casa 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Bonus Casa 50% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("6PKJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("DaEW")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Bonus Casa 50%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Bonus Casa\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 50%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Ecobonus 50% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 50%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("6PKJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("DaEW")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Ecobonus\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-6 col-md-3 pr-2 pl-2"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusCont pt-5 pb-4 mb-4",
                                              class: {
                                                bonusSelected:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selectBonusContBack",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setBonus(
                                                        "Ecobonus 65%"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Se vuoi aderire al\n                      "
                                                  ),
                                                  _c("br"),
                                                  _vm._v("Ecobonus 65% "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Clicca qui >\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Ecobonus 65%"
                                                ? _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("w/IJ")
                                                    }
                                                  })
                                                : _c("img", {
                                                    staticClass:
                                                      "img-fluid widthFull mb-4",
                                                    attrs: {
                                                      src: __webpack_require__("CXbD")
                                                    }
                                                  }),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black",
                                                  class: {
                                                    white:
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Ecobonus\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3",
                                          staticStyle: { display: "none" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.ecoBonus,
                                                    expression: "ecoBonus"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: true,
                                                      max: 63,
                                                      min: 2
                                                    },
                                                    expression:
                                                      "{ required: true, max: 63, min: 2 }"
                                                  }
                                                ],
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-0.ecoBonus"
                                                  ),
                                                  valid: !!_vm.ecoBonus
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ecobonus",
                                                  name: "ecobonus",
                                                  "data-vv-as": "ecoBonus"
                                                },
                                                domProps: {
                                                  value: _vm.ecoBonus
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.ecoBonus =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 mb-3 center"
                                        },
                                        [
                                          _vm.errors.has("form-0.ecobonus")
                                            ? _c(
                                                "div",
                                                { staticClass: "red" },
                                                [
                                                  _c(
                                                    "b",
                                                    { staticClass: "h5 red" },
                                                    [
                                                      _vm._v(
                                                        "Per procedere devi selezionare una tra le quattro icone\n                      sopraindicate.\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 mb-3" },
                                        [
                                          _vm._v(
                                            "\n                  Novatag e KPMG, non si ritengono responsabili per eventuali\n                  danni economici derivanti dall.utilizo della piattaforma e\n                  dall.informazioni fornite.\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                       true
                        ? _c(
                            "tab-content",
                            {
                              attrs: {
                                title: "Dati Cliente",
                                icon: "",
                                "before-change": _vm.validateFirstTab
                              }
                            },
                            [
                              _vm.ecoBonus != "Superbonus 110%"
                                ? _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Inserisci i dati del cliente finale\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.client_type,
                                                        expression:
                                                          "client_type"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          max: 63,
                                                          min: 2
                                                        },
                                                        expression:
                                                          "{ required: true, max: 63, min: 2 }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.client_type"
                                                      ),
                                                      valid: !!_vm.client_type
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      autocomplete: "randomq",
                                                      id: "client_type",
                                                      name: "client_type",
                                                      "data-vv-as":
                                                        "Tipologia cliente"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.client_type = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "Amministratore di condominio"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Condominio (Amministratore)\n                      "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          value:
                                                            "Persona fisica"
                                                        }
                                                      },
                                                      [_vm._v("Persona fisica")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.ecoBonus !=
                                                    "Bonus Casa 50%"
                                                      ? _c(
                                                          "option",
                                                          {
                                                            attrs: {
                                                              value:
                                                                "Partita IVA"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Partita IVA\n                      "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_type"
                                                    }
                                                  },
                                                  [_vm._v("Tipologia cliente")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_type"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_type"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientName,
                                                      expression: "clientName"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientName"
                                                    ),
                                                    valid: !!_vm.clientName
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientName",
                                                    name: "clientName",
                                                    "data-vv-as": "Nome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientName
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientName =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "clientName" }
                                                  },
                                                  [_vm._v("Nome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientName"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientName"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.clientLastname,
                                                      expression:
                                                        "clientLastname"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.clientLastname"
                                                    ),
                                                    valid: !!_vm.clientLastname
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "clientLastname",
                                                    name: "clientLastname",
                                                    "data-vv-as": "Cognome"
                                                  },
                                                  domProps: {
                                                    value: _vm.clientLastname
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.clientLastname =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "clientLastname"
                                                    }
                                                  },
                                                  [_vm._v("Cognome")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.clientLastname"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.clientLastname"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_email,
                                                      expression: "client_email"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        email: true,
                                                        temporaryEmail: true,
                                                        plusIssueEmail: true,
                                                        max: 56
                                                      },
                                                      expression:
                                                        "{\n                        required: true,\n                        email: true,\n                        temporaryEmail: true,\n                        plusIssueEmail: true,\n                        max: 56,\n                      }"
                                                    }
                                                  ],
                                                  ref: "client_email",
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_email"
                                                    ),
                                                    valid: !!_vm.client_email
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_email",
                                                    name: "client_email",
                                                    "data-vv-as": "Email"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_email
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_email =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_email"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Email*\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_email"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_email"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_phone,
                                                      expression: "client_phone"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[0]+/
                                                      },
                                                      expression:
                                                        "{\n                        required: false,\n                        max: 12,\n                        min: 8,\n                        regex: /^[0]+/,\n                      }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_phone"
                                                    ),
                                                    valid: !!_vm.client_phone
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_phone",
                                                    name: "client_phone",
                                                    "data-vv-as": "Telefono"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_phone
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_phone =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_phone"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Telefono\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_phone"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_phone"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.client_mobile,
                                                      expression:
                                                        "client_mobile"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 12,
                                                        min: 8,
                                                        regex: /^[3]+/
                                                      },
                                                      expression:
                                                        "{\n                        required: true,\n                        max: 12,\n                        min: 8,\n                        regex: /^[3]+/,\n                      }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.client_mobile"
                                                    ),
                                                    valid: !!_vm.client_mobile
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "client_mobile",
                                                    name: "client_mobile",
                                                    "data-vv-as": "Cellulare"
                                                  },
                                                  domProps: {
                                                    value: _vm.client_mobile
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.client_mobile =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: "client_mobile"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Cellulare *\n                    "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.client_mobile"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.client_mobile"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.ecoBonus != "Bonus Casa 50%"
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "usoAbitativo"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Prevalente uso abitativo\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("SI")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.usoAbitativo = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.usoAbitativo,
                                                                      expression:
                                                                        "usoAbitativo"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-1.usoAbitativo"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name:
                                                                      "usoAbitativo"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.usoAbitativo,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.usoAbitativo =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v("NO")
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-1.usoAbitativo"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-1.usoAbitativo')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Il servizio deve essere accettato oppure rifiutato\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black pb-4"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    Inserisci l'indirizzo dell'immobile\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.province,
                                                        expression: "province"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.province"
                                                      ),
                                                      valid: !!_vm.province
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomy",
                                                      id: "province",
                                                      name: "province",
                                                      "data-vv-as": "Provincia"
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.province = $event
                                                          .target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.provincies,
                                                      function(province) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: province.sigla,
                                                            domProps: {
                                                              value:
                                                                province.sigla
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  province.sigla
                                                                ) +
                                                                " - " +
                                                                _vm._s(
                                                                  province.provincia
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "province" }
                                                  },
                                                  [_vm._v("Provincia")]
                                                ),
                                                _vm._v(" "),
                                                _vm.provinciesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id:
                                                                "loadProvince",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-1.province"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.province"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.cityError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli Provincia"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.city,
                                                        expression: "city"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.city"
                                                      ),
                                                      valid: !!_vm.city
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomu",
                                                      id: "city",
                                                      name: "city",
                                                      "data-vv-as": "Località",
                                                      disabled: _vm.citiesState
                                                    },
                                                    on: {
                                                      click: _vm.checkProvince,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.city = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        disabled: "",
                                                        value: "",
                                                        selected: "selected"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.cities, function(
                                                      city
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: city.comune,
                                                          domProps: {
                                                            value: {
                                                              cityistat:
                                                                city.istat,
                                                              city: city.comune
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                city.comune
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "city" }
                                                  },
                                                  [_vm._v("Località")]
                                                ),
                                                _vm._v(" "),
                                                _vm.citiesState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadCity",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.city")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.city"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _vm.zipError
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass: "formError"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Prima scegli città"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zip,
                                                        expression: "zip"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true
                                                        },
                                                        expression:
                                                          "{ required: true }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-1.zip"
                                                      ),
                                                      valid: !!_vm.zip
                                                    },
                                                    attrs: {
                                                      autocomplete: "randomi",
                                                      id: "zip",
                                                      name: "zip",
                                                      "data-vv-as": "Cap",
                                                      disabled: _vm.zipsState
                                                    },
                                                    on: {
                                                      click: _vm.checkZip,
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.zip = $event.target
                                                          .multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("option", {
                                                      attrs: {
                                                        value: "",
                                                        disabled: ""
                                                      },
                                                      domProps: {
                                                        selected: true
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm._l(_vm.zips, function(
                                                      zip
                                                    ) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: zip.cap,
                                                          domProps: {
                                                            value: zip.cap
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(zip.cap) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    })
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "zip" }
                                                  },
                                                  [_vm._v("Cap")]
                                                ),
                                                _vm._v(" "),
                                                _vm.zipsState
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "loadSpinner",
                                                            attrs: {
                                                              id: "loadZips",
                                                              icon: "spinner",
                                                              size: "1x",
                                                              pulse: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.zip")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.zip"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.adress,
                                                      expression: "adress"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 128,
                                                        min: 5
                                                      },
                                                      expression:
                                                        "{ required: true, max: 128, min: 5 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.adress"
                                                    ),
                                                    valid: !!_vm.adress
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "adress",
                                                    name: "adress",
                                                    "data-vv-as": "Indirizzo"
                                                  },
                                                  domProps: {
                                                    value: _vm.adress
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.adress =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "adress" }
                                                  },
                                                  [_vm._v("Indirizzo")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.adress")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.adress"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.civic,
                                                      expression: "civic"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 15,
                                                        min: 1
                                                      },
                                                      expression:
                                                        "{ required: true, max: 15, min: 1 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-1.civic"
                                                    ),
                                                    valid: !!_vm.civic
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "civic",
                                                    name: "civic",
                                                    "data-vv-as": "Civico"
                                                  },
                                                  domProps: {
                                                    value: _vm.civic
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.civic =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "civic" }
                                                  },
                                                  [_vm._v("Civico")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has("form-1.civic")
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-1.civic"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "row justify-content-center divider"
                                        })
                                      ])
                                    ]
                                  )
                                : _c(
                                    "form",
                                    {
                                      staticClass: "widthFull",
                                      attrs: {
                                        "data-vv-scope": "form-1",
                                        autocomplete: "qwerqrt2"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [_vm._v("LISTA DOCUMENTI")]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Dati Intervento",
                            icon: "",
                            "before-change": _vm.validateSecondTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull orangeBg",
                              attrs: {
                                "data-vv-scope": "form-2",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                    Inserisci i dati dell'intervento\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.eventType,
                                                expression: "eventType"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-2.eventType"
                                              ),
                                              valid: !!_vm.eventType
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "eventType",
                                              name: "eventType",
                                              "data-vv-as": "Tipo di intervento"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.eventType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: "",
                                                selected: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "sostituzione" }
                                              },
                                              [_vm._v("Sostituzione")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: { value: "Instalazione" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Nuova Installazione\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "eventType" }
                                          },
                                          [_vm._v("Tipo di intervento")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-2.eventType")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-2.eventType"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                    Inserisci Beni Significativi\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "widthFull" },
                                        _vm._l(_vm.products, function(
                                          elem,
                                          num
                                        ) {
                                          return _c(
                                            "div",
                                            { staticClass: "row" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "col-md-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: elem.group,
                                                              expression:
                                                                "elem.group"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{ required: true, is_not: '' }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.g" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.group
                                                          },
                                                          attrs: {
                                                            id:
                                                              "g" + elem.index,
                                                            name:
                                                              "g" + elem.index,
                                                            "data-vv-as":
                                                              "Gruppo"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "group",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setGroup(
                                                                  elem.index
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        [
                                                          _vm.ecoBonus ==
                                                          "Ecobonus 50%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item,
                                                                    ii
                                                                  ) {
                                                                    return [
                                                                      item.value ==
                                                                        "condensazione" ||
                                                                      item.value ==
                                                                        "altroVaillant"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              key: ii,
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : _vm.ecoBonus ==
                                                              "Ecobonus 65%"
                                                            ? [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      item.value !=
                                                                      "tradizionale"
                                                                        ? _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                selected:
                                                                                  "selected"
                                                                              },
                                                                              domProps: {
                                                                                value:
                                                                                  item.value
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                  " +
                                                                                  _vm._s(
                                                                                    item.name
                                                                                  ) +
                                                                                  "\n                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                            : [
                                                                _vm._l(
                                                                  _vm.groups,
                                                                  function(
                                                                    item
                                                                  ) {
                                                                    return [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                  " +
                                                                              _vm._s(
                                                                                item.name
                                                                              ) +
                                                                              "\n                                "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "group"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli gruppo prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.g" + elem.index
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.g" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "h4",
                                                        {
                                                          staticClass:
                                                            "widthFull black pointer m-0",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.insertProductCode(
                                                                elem.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "search",
                                                                size: "sm"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.insertProductCode(
                                                                    elem.index
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c("small", [
                                                            _vm._v(
                                                              "o cerca con codice prodotto "
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-5" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      elem.group != "ibridi" &&
                                                      elem.group !=
                                                        "altroVaillant"
                                                        ? _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{ required: true, is_not: '' }"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : elem.group ==
                                                          "altroVaillant"
                                                        ? _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product
                                                                    .name,
                                                                expression:
                                                                  "elem.product.name"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required: true,
                                                                  is_not: ""
                                                                },
                                                                expression:
                                                                  "{ required: true, is_not: '' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.p" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              type: "text",
                                                              id:
                                                                "p" +
                                                                elem.index,
                                                              name:
                                                                "p" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Prodotto"
                                                            },
                                                            domProps: {
                                                              value:
                                                                elem.product
                                                                  .name
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              },
                                                              click:
                                                                _vm.checkIfEmpty,
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  elem.product,
                                                                  "name",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : _c(
                                                            "select",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    elem.product,
                                                                  expression:
                                                                    "elem.product"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value: {
                                                                    required: true,
                                                                    is_not: ""
                                                                  },
                                                                  expression:
                                                                    "{ required: true, is_not: '' }"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                ),
                                                                valid: !!elem.product
                                                              },
                                                              attrs: {
                                                                id:
                                                                  "p" +
                                                                  elem.index,
                                                                name:
                                                                  "p" +
                                                                  elem.index,
                                                                "data-vv-as":
                                                                  "Prodotto"
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$selectedVal = Array.prototype.filter
                                                                      .call(
                                                                        $event
                                                                          .target
                                                                          .options,
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          return o.selected
                                                                        }
                                                                      )
                                                                      .map(
                                                                        function(
                                                                          o
                                                                        ) {
                                                                          var val =
                                                                            "_value" in
                                                                            o
                                                                              ? o._value
                                                                              : o.value
                                                                          return val
                                                                        }
                                                                      )
                                                                    _vm.$set(
                                                                      elem,
                                                                      "product",
                                                                      $event
                                                                        .target
                                                                        .multiple
                                                                        ? $$selectedVal
                                                                        : $$selectedVal[0]
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.setProduct(
                                                                      elem.index
                                                                    )
                                                                  }
                                                                ],
                                                                click:
                                                                  _vm.checkIfEmpty
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.items[
                                                                elem.index
                                                              ],
                                                              function(
                                                                item,
                                                                ind
                                                              ) {
                                                                return _c(
                                                                  "option",
                                                                  {
                                                                    domProps: {
                                                                      value: {
                                                                        index: ind,
                                                                        name:
                                                                          item.Modello,
                                                                        serial:
                                                                          item.codice
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          item.Modello
                                                                        ) +
                                                                        "\n                              " +
                                                                        _vm._s(
                                                                          item.ModelloPompaDiCalore
                                                                        ) +
                                                                        " +\n                              " +
                                                                        _vm._s(
                                                                          item.ModelloCaldaiaACondensazione
                                                                        ) +
                                                                        "\n                            "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: "product"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Scegli Prodotto"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.p" + elem.index
                                                      ) && !elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.p" +
                                                                        elem.index
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      elem.error
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            Prima scegli gruppo\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mr-md-0 pr-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.quantity,
                                                            expression:
                                                              "elem.quantity"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0",
                                                              min_value: 1,
                                                              max: 4
                                                            },
                                                            expression:
                                                              "{\n                              required: true,\n                              is_not: '0',\n                              min_value: 1,\n                              max: 4,\n                            }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.q" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.quantity
                                                        },
                                                        attrs: {
                                                          type: "number",
                                                          id:
                                                            "q" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "q" +
                                                            elem.indexCount,
                                                          "data-vv-as":
                                                            "Quantità"
                                                        },
                                                        domProps: {
                                                          value: elem.quantity
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.calcTotalPriceProducts()
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "quantity",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Quantità")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.q" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.q" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 pl-md-0 ml-md-0"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "group custInput"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.price,
                                                            expression:
                                                              "elem.price"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: "0"
                                                            },
                                                            expression:
                                                              "{ required: true, is_not: '0' }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.i" +
                                                              elem.indexCount
                                                          ),
                                                          valid: !!elem.price
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id:
                                                            "i" +
                                                            elem.indexCount,
                                                          min: "1",
                                                          name:
                                                            "i" +
                                                            elem.indexCount,
                                                          "data-vv-as": "Prezzo"
                                                        },
                                                        domProps: {
                                                          value: elem.price
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            _vm.formatPrice(
                                                              elem.index
                                                            ),
                                                              _vm.calcTotalPriceProducts()
                                                          },
                                                          keyup: function(
                                                            $event
                                                          ) {
                                                            return _vm.keymonitor(
                                                              $event,
                                                              elem.index,
                                                              "prod"
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem,
                                                              "price",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "highlight"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass: "bar"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "niceInputLabel",
                                                          attrs: {
                                                            for: elem.indexCount
                                                          }
                                                        },
                                                        [_vm._v("Prezzo €")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "widthFull center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            (IVA esclusa)\n                          "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.errors.has(
                                                        "form-2.i" +
                                                          elem.indexCount
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.errors.first(
                                                                      "form-2.i" +
                                                                        elem.indexCount
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "removeProduct pointer",
                                                      class: elem.index
                                                    },
                                                    [
                                                      num != 0
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "trash-alt",
                                                                size: "lg"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.removeProduct(
                                                                    num
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: { click: _vm.addProduct }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: { click: _vm.addProduct }
                                                }),
                                                _vm._v(
                                                  "\n                        Aggiungi prodotto\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo prodotti (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalProducts) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Inserisci altri Beni/Accessori opzionali\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.accessories, function(
                                        elem,
                                        num
                                      ) {
                                        return _c(
                                          "div",
                                          { staticClass: "row" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-md-3" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c(
                                                      "select",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: elem.group,
                                                            expression:
                                                              "elem.group"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {},
                                                            expression: "{}"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.ac" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.group
                                                        },
                                                        attrs: {
                                                          id: "ac" + elem.index,
                                                          name:
                                                            "ac" + elem.index,
                                                          "data-vv-as":
                                                            "accessori opzionali"
                                                        },
                                                        on: {
                                                          change: [
                                                            function($event) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return val
                                                                })
                                                              _vm.$set(
                                                                elem,
                                                                "group",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                            function($event) {
                                                              return _vm.setTypeAccessories(
                                                                elem.index
                                                              )
                                                            }
                                                          ]
                                                        }
                                                      },
                                                      _vm._l(
                                                        _vm.groupsAccessori,
                                                        function(item) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                selected:
                                                                  "selected"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  item.value
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    item.name
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: { for: "group" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Scegli accessori opzionali"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ac" + elem.index
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ac" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "widthFull black pointer m-0",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.insertAccessoriesCode(
                                                              elem.index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "search",
                                                              size: "sm"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.insertAccessoriesCode(
                                                                  elem.index
                                                                )
                                                              }
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v(
                                                            "o cerca con codice accessorio "
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-md-5" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "select",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  elem.product,
                                                                expression:
                                                                  "elem.product"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required:
                                                                    elem.group !=
                                                                    ""
                                                                },
                                                                expression:
                                                                  "{ required: elem.group != '' }"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-2.ap" +
                                                                  elem.index
                                                              ),
                                                              valid: !!elem.product
                                                            },
                                                            attrs: {
                                                              id:
                                                                "ap" +
                                                                elem.index,
                                                              name:
                                                                "ap" +
                                                                elem.index,
                                                              "data-vv-as":
                                                                "Accessorio"
                                                            },
                                                            on: {
                                                              change: [
                                                                function(
                                                                  $event
                                                                ) {
                                                                  var $$selectedVal = Array.prototype.filter
                                                                    .call(
                                                                      $event
                                                                        .target
                                                                        .options,
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        return o.selected
                                                                      }
                                                                    )
                                                                    .map(
                                                                      function(
                                                                        o
                                                                      ) {
                                                                        var val =
                                                                          "_value" in
                                                                          o
                                                                            ? o._value
                                                                            : o.value
                                                                        return val
                                                                      }
                                                                    )
                                                                  _vm.$set(
                                                                    elem,
                                                                    "product",
                                                                    $event
                                                                      .target
                                                                      .multiple
                                                                      ? $$selectedVal
                                                                      : $$selectedVal[0]
                                                                  )
                                                                },
                                                                function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setAccessories(
                                                                    elem.index
                                                                  )
                                                                }
                                                              ],
                                                              click:
                                                                _vm.checkIfEmpty
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .itemsAccessories[
                                                              elem.index
                                                            ],
                                                            function(
                                                              item,
                                                              ind
                                                            ) {
                                                              return _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value: {
                                                                      index: ind,
                                                                      name:
                                                                        item.Modello,
                                                                      serial:
                                                                        item.codice
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                            " +
                                                                      _vm._s(
                                                                        item.Modello
                                                                      ) +
                                                                      "\n                          "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product
                                                                  .name,
                                                              expression:
                                                                "elem.product.name"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required:
                                                                  elem.group !=
                                                                  "",
                                                                max: 128
                                                              },
                                                              expression:
                                                                "{\n                            required: elem.group != '',\n                            max: 128,\n                          }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.ap" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem
                                                              .product.name
                                                          },
                                                          attrs: {
                                                            type: "text",
                                                            id:
                                                              "ap" + elem.index,
                                                            name:
                                                              "ap" + elem.index,
                                                            "data-vv-as":
                                                              "Accessorio"
                                                          },
                                                          domProps: {
                                                            value:
                                                              elem.product.name
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                elem.product,
                                                                "name",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    elem.group ==
                                                    "termoregolazione"
                                                      ? _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Scegli Accessorio"
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "niceInputLabel",
                                                            attrs: {
                                                              for: "product"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Inserisci Accessorio"
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ) && !elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ap" +
                                                                      elem.index
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    elem.error
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          Prima scegli tipo\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-2 mr-md-0 pr-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.quantity,
                                                          expression:
                                                            "elem.quantity"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0",
                                                            min_value: 1,
                                                            max: 4
                                                          },
                                                          expression:
                                                            "{\n                            required: elem.group != '',\n                            is_not: '0',\n                            min_value: 1,\n                            max: 4,\n                          }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.aq" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.quantity
                                                      },
                                                      attrs: {
                                                        type: "number",
                                                        id:
                                                          "aq" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "aq" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Quantità"
                                                      },
                                                      domProps: {
                                                        value: elem.quantity
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.calcTotalPriceAccessories()
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "quantity",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Quantità")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.aq" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.aq" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-2 pl-md-0 ml-md-0"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "group custInput"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.price,
                                                          expression:
                                                            "elem.price"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              elem.group != "",
                                                            is_not: "0"
                                                          },
                                                          expression:
                                                            "{\n                            required: elem.group != '',\n                            is_not: '0',\n                          }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.ai" +
                                                            elem.indexCount
                                                        ),
                                                        valid: !!elem.price
                                                      },
                                                      attrs: {
                                                        type: "text",
                                                        id:
                                                          "ai" +
                                                          elem.indexCount,
                                                        min: "1",
                                                        name:
                                                          "ai" +
                                                          elem.indexCount,
                                                        "data-vv-as": "Prezzo"
                                                      },
                                                      domProps: {
                                                        value: elem.price
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.formatPriceAccessories(
                                                            elem.index
                                                          )
                                                          _vm.calcTotalPriceAccessories()
                                                        },
                                                        keyup: function(
                                                          $event
                                                        ) {
                                                          return _vm.keymonitor(
                                                            $event,
                                                            elem.index,
                                                            "accs"
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            elem,
                                                            "price",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "highlight"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass: "bar"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "niceInputLabel",
                                                        attrs: {
                                                          for: elem.indexCount
                                                        }
                                                      },
                                                      [_vm._v("Prezzo €")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "widthFull center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          (IVA esclusa)\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.errors.has(
                                                      "form-2.ai" +
                                                        elem.indexCount
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invalid-feedback"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "form-2.ai" +
                                                                      elem.indexCount
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "removeProduct pointer",
                                                    class: elem.index
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "trash-alt",
                                                        size: "lg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeAccessories(
                                                            num
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-3 mb-3 text-left pr-4"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "pointer helper btn btn-secondary",
                                                on: {
                                                  click: _vm.addAccessories
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass:
                                                    "helper pointer addProduct",
                                                  attrs: {
                                                    icon: "plus-circle",
                                                    size: "1x"
                                                  },
                                                  on: {
                                                    click: _vm.addAccessories
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                        Aggiungi accessorio\n                      "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo accessori opzionali (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalAccessories) +
                                                    " €"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [_vm._v("Pratica ENEA")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceEnea,
                                                      expression: "priceEnea"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceEnea"
                                                    ),
                                                    valid: !!_vm.priceEnea
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceEnea",
                                                    name: "priceEnea",
                                                    "data-vv-as":
                                                      "Costo Gestione Pratica ENEA"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceEnea
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceEnea()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceEnea =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceEnea" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Costo Gestione Pratica ENEA"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    "Valore che sarà addebitato al cliente "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceEnea"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceEnea"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.NoEnea
                                          ? _c(
                                              "div",
                                              { staticClass: "col-md-6 mb-3" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-check" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "group" },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label widthFull black h5",
                                                            attrs: {
                                                              for:
                                                                "datiCatastali"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Servizio di redazione e invio pratica ENEA ad un\n                            costo di €50 +IVA ( costo che ti sarà addebitato\n                            se accetti il servizio )\n                          "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline mt-2"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.enea = 1
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.enea,
                                                                      expression:
                                                                        "enea"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-2.enea"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "1",
                                                                    name: "enea"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.enea,
                                                                      "1"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.enea =
                                                                        "1"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "ACCETTO"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-check form-check-inline"
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form-check-label",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.enea = 0
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm.enea,
                                                                      expression:
                                                                        "enea"
                                                                    },
                                                                    {
                                                                      name:
                                                                        "validate",
                                                                      rawName:
                                                                        "v-validate",
                                                                      value:
                                                                        "required|included:1,0",
                                                                      expression:
                                                                        "'required|included:1,0'"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-check-input inline mr-3",
                                                                  class: {
                                                                    "is-invalid": _vm.errors.has(
                                                                      "form-2.enea"
                                                                    )
                                                                  },
                                                                  attrs: {
                                                                    type:
                                                                      "radio",
                                                                    value: "0",
                                                                    name: "enea"
                                                                  },
                                                                  domProps: {
                                                                    checked: _vm._q(
                                                                      _vm.enea,
                                                                      "0"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.enea =
                                                                        "0"
                                                                    }
                                                                  }
                                                                }),
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "NON ACCETTO"
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value: _vm.errors.has(
                                                                  "form-2.enea"
                                                                ),
                                                                expression:
                                                                  "errors.has('form-2.enea')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "errorMes red"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Il servizio deve essere accettato oppure rifiutato\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-4" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull center black"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        Installazione e Posa in Opera\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.priceWork,
                                                      expression: "priceWork"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        max: 63,
                                                        min: 2
                                                      },
                                                      expression:
                                                        "{ required: true, max: 63, min: 2 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.priceWork"
                                                    ),
                                                    valid: !!_vm.priceWork
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    autocomplete: "randomq",
                                                    id: "priceWork",
                                                    name: "priceWork",
                                                    "data-vv-as":
                                                      "Importo installazione/posa in opera"
                                                  },
                                                  domProps: {
                                                    value: _vm.priceWork
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.formatpriceWork()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.priceWork =
                                                        $event.target.value
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "priceWork" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera ( IVA esclusa\n                          )"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.priceWork"
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.priceWork"
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Totale importo (IVA esclusa):\n                      "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "Bold" },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                          parseFloat(
                                                            _vm.priceDcast
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                    "\n                        €\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row justify-content-center pt-2 pb-4"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull center black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Riepilogo aliquote IVA\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota concorrente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_lavoro,
                                                          expression:
                                                            "iva_age_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_age_lavoro
                                                      },
                                                      attrs: {
                                                        id: "iva_age_lavoro",
                                                        name: "iva_age_lavoro",
                                                        "data-vv-as":
                                                          "Beni significativi, quota concorrente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota eccedente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_age_extra,
                                                          expression:
                                                            "iva_age_extra"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_age_extra"
                                                        ),
                                                        valid: !!_vm.iva_age_extra
                                                      },
                                                      attrs: {
                                                        id: "iva_age_extra",
                                                        name: "iva_age_extra",
                                                        "data-vv-as":
                                                          "Beni significativi, quota eccedente accessori e manodopera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_age_extra = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri Beni / Accessori opzionali / Installazione e\n                        Posa in Opera\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_accessori_lavoro,
                                                          expression:
                                                            "iva_accessori_lavoro"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_accessori_lavoro"
                                                        ),
                                                        valid: !!_vm.iva_accessori_lavoro
                                                      },
                                                      attrs: {
                                                        id:
                                                          "iva_accessori_lavoro",
                                                        name:
                                                          "iva_accessori_lavoro",
                                                        "data-vv-as":
                                                          "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_accessori_lavoro = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-6 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "h5",
                                                    {
                                                      staticClass:
                                                        "widthFull text-left black"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri oneri per il Committente\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-2 mb-3 center"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.iva_altri_oneri,
                                                          expression:
                                                            "iva_altri_oneri"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true
                                                          },
                                                          expression:
                                                            "{ required: true }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.iva_altri_oneri"
                                                        ),
                                                        valid: !!_vm.iva_altri_oneri
                                                      },
                                                      attrs: {
                                                        id: "iva_altri_oneri",
                                                        name: "iva_altri_oneri",
                                                        "data-vv-as":
                                                          "Altri oneri per il Committente"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.iva_altri_oneri = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.client_type !=
                                                        "Partita IVA" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.10"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          10%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                        "Persona fisica" &&
                                                      _vm.usoAbitativo == 1
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.04"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          4%\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.22"
                                                          }
                                                        },
                                                        [_vm._v("22%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.client_type ==
                                                      "Partita IVA"
                                                        ? _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0.00"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Reverse Charge\n                        "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.client_type ==
                                                "Persona fisica" &&
                                              _vm.usoAbitativo == 1 &&
                                              (_vm.iva_altri_oneri == "0.04" ||
                                                _vm.iva_accessori_lavoro ==
                                                  "0.04" ||
                                                _vm.iva_age_extra == "0.04" ||
                                                _vm.iva_age_lavoro == "0.04")
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-md-8 mb-3 center text-left"
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "Bold center"
                                                        },
                                                        [_vm._v("Attenzione!")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("b", [
                                                        _vm._v(
                                                          "Non tutti gli acquisti e interventi, a prescindere,\n                        possono essere considerati secondo l’aliquota\n                        agevolata al 4% bensì esclusivamente quelli\n                        prettamente collegati alla specifica disabilità del\n                        cliente finale.\n                      "
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _c("br"),
                                                      _c(
                                                        "b",
                                                        { staticClass: "red" },
                                                        [
                                                          _vm._v(
                                                            "Occorre, pertanto, verificare la tipologia di\n                        intervento da eseguire per verificare se il cliente\n                        potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mt-2 center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Consulta la\n                        "
                                                          ),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "Bold underline black",
                                                              attrs: {
                                                                href:
                                                                  "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [_vm._v("guida")]
                                                          ),
                                                          _vm._v(
                                                            "\n                        relativa alle agevolazioni fiscali per le persone con\n                        disabilità.\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row pt-2" }, [
                                        _vm.requiredOperations
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-md-12 mb-3 requiredCont"
                                              },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "green" },
                                                  [
                                                    _vm._v(
                                                      "\n                        Requisiti tecnici richiesti per aderire al bonus:\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("h5", {
                                                  staticClass: "black",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.requiredOperations
                                                    )
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider"
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "row" })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Anteprima",
                            subtitle: "Tutti i campi sono obbligatori",
                            icon: "",
                            "before-change": _vm.validateThirdTab
                          }
                        },
                        [
                          _vm.calcFinish
                            ? _c(
                                "form",
                                {
                                  staticClass: "widthFull orio pt-3 pr-md-3",
                                  attrs: {
                                    "data-vv-scope": "form-3",
                                    autocomplete: "qwerqrt3"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      ref: "invoiceData",
                                      staticClass: "widthFull"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "row justify-content-center divider fordelete"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 mt-4"
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Cessionario/prestatore (fornitore)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Identificativo fiscale ai fini IVA:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v("IT03402390409")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Denominazione: "),
                                                  _c("b", [
                                                    _vm._v("EMICON A.C. S.p.A.")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Indirizzo:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v("Via A. Volta, 49")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Comune:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v("Meldola (FC) Italy")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cap: "),
                                                  _c("b", [_vm._v("47014")]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.email
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cellulare: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.cellulare
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("IBAN: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getProfile.iban
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm.getProfile.logo
                                                    ? _c("img", {
                                                        staticClass:
                                                          "img-fluid",
                                                        staticStyle: {
                                                          width:
                                                            "50% !important",
                                                          "max-width": "150px"
                                                        },
                                                        attrs: {
                                                          src:
                                                            _vm.getProfile.logo
                                                        }
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticStyle: {
                                                    "vertical-align": "top"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Benificiario/committente (cliente)"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(
                                                    "Denominazione:\n                        "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.clientName) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.clientLastname
                                                        )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Indirizzo: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.adress) +
                                                        " " +
                                                        _vm._s(_vm.civic)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Comune: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.city.city) +
                                                        " (" +
                                                        _vm._s(_vm.province) +
                                                        ")"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Cap: "),
                                                  _c("b", [
                                                    _vm._v(_vm._s(_vm.zip))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v("Email: "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(_vm.client_email)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_phone
                                                    ? _c("span", [
                                                        _vm._v("Telefono: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_phone
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm.client_mobile
                                                    ? _c("span", [
                                                        _vm._v("Cellulare: "),
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.client_mobile
                                                            )
                                                          )
                                                        ])
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left pt-4 h0 black"
                                        },
                                        [_c("b", [_vm._v("La tua offerta:")])]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario == "si"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89\n                  della Legge n. 190/2014, così come modificato dalla Legge\n                  numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\n                "
                                              )
                                            ]
                                          )
                                        : _vm.client_type == "Partita IVA" &&
                                          _vm.iva_age_lavoro == "0.00" &&
                                          _vm.iva_age_extra == "0.00"
                                        ? _c(
                                            "h5",
                                            {
                                              staticClass:
                                                "Regular widthFull text-left h0 black"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Operazione soggetta al reverse charge art. 17, comma 6,\n                  lett. a-ter DPR 633/1972.\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead"),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            [
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Beni significativi"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prezzo unitario")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.products, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.price) +
                                                            " €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.totalProducts
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase text-right widthFull"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale Agevolabile Beni Significativi"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalProducts
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) -
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tr",
                                                { staticClass: "greenBg" },
                                                [
                                                  _c(
                                                    "td",
                                                    { attrs: { colspan: "4" } },
                                                    [
                                                      _c(
                                                        "b",
                                                        {
                                                          staticClass:
                                                            "uppercase"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Altri beni ed accessori"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Codice prodotto")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prodotto/servizio")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Quantita")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "col" } },
                                                  [_vm._v("Prezzo unitario")]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(_vm.accessories, function(
                                                item,
                                                ind
                                              ) {
                                                return _c("tr", [
                                                  _c(
                                                    "td",
                                                    { attrs: { scope: "row" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.serial
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.product.name
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(item.quantity)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(item.price) +
                                                            " € "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              }),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", {
                                                  attrs: { scope: "row" }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "2" } },
                                                  [
                                                    _vm._v(
                                                      "Importo installazione/posa in opera"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.priceWork
                                                          ) +
                                                          " € "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale altri beni ed accessori\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { attrs: { align: "right" } },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.totalAccessories
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ) +
                                                              parseFloat(
                                                                _vm.priceWork
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              )
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale intervento\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    "imponibile"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          width: "220",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .totalBase
                                                              )
                                                            ) + " €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getProfile.reg_forfettario != "si"
                                        ? _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("thead", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greenBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "4" }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase"
                                                          },
                                                          [_vm._v("Riepilogo")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", {
                                                    attrs: {
                                                      align: "left",
                                                      scope: "row"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c(
                                                        "b",
                                                        [
                                                          _vm._v(
                                                            "Importo\n                          "
                                                          ),
                                                          _vm.getProfile
                                                            .reg_forfettario !=
                                                          "si"
                                                            ? [
                                                                _vm._v(
                                                                  "imponibile"
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Aliquota IVA")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Totale (IVA Inclusa)"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota concorrente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.age_lavoro)
                                                          ) + " €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.age_lavoro
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_age_lavoro
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Beni significativi, quota eccedente accessori e\n                        manodopera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(_vm.age_extra)
                                                          ) + " €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_age_extra *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                parseFloat(
                                                                  _vm.age_extra
                                                                ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_age_extra
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      attrs: {
                                                        align: "left",
                                                        scope: "row"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        Altri Beni / Accessori opzionali / Installazione e\n                        Posa in Opera\n                      "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.totalAccessories
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                                parseFloat(
                                                                  _vm.priceWork
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                )
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.iva_accessori_lavoro *
                                                              100
                                                          ) + " %"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              (
                                                                (parseFloat(
                                                                  _vm.totalAccessories
                                                                    .replace(
                                                                      ".",
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      ",",
                                                                      "."
                                                                    )
                                                                ) +
                                                                  parseFloat(
                                                                    _vm.priceWork
                                                                      .replace(
                                                                        ".",
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        ",",
                                                                        "."
                                                                      )
                                                                  )) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_accessori_lavoro
                                                                  ))
                                                              ).toFixed(2)
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ])
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row ml-0 mr-0 greyBg pt-2"
                                        },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale fattura Spesa agevolabile\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    "(IVA INCLUSA)"
                                                                  )
                                                                ]
                                                              : _vm._e()
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .totalBaseAndIva
                                                              )
                                                            ) +
                                                              "\n                            €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        { staticClass: "table table-bordered" },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "uppercase",
                                                  attrs: {
                                                    colspan: "2",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Sconto in fattura " +
                                                      _vm._s(this.ecoBonus) +
                                                      "\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm.ecoBonus !=
                                                          "Bonus Casa 50%" &&
                                                        this.client_type ==
                                                          "Partita IVA" &&
                                                        this.usoAbitativo ==
                                                          0 &&
                                                        this.iva_age_lavoro ==
                                                          "0.22" &&
                                                        this.iva_age_extra ==
                                                          "0.22" &&
                                                        this
                                                          .iva_accessori_lavoro ==
                                                          "0.22"
                                                          ? void 0
                                                          : [
                                                              _vm._v(
                                                                " (IVA INCLUSA)"
                                                              )
                                                            ]
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 121, D.L. 34/20 convertito con Legge 17 luglio\n                          2020)\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.calcInfo
                                                            .totalWithBonus
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale fattura al committente per bonifico parlante\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus ==
                                                        "Bonus Casa 50%"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            (Art. 16 bis, D.P.R. 917/86)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.ecoBonus !=
                                                        "Bonus Casa 50%"
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            (Art. 1, Legge 296/2006 e art. 14 D.L.\n                            63/2013)"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .totalBaseAndIva
                                                            ) -
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .totalWithBonus
                                                              )
                                                          )
                                                        ) +
                                                          "\n                          €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Altri oneri per il committente"
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    colspan: "2",
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Quota spesa non agevolata\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.totalExtraMise
                                                            ) +
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .iva22NonAge
                                                            ) +
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .iva10NonAge
                                                            )
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                          €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _vm._v(
                                                    "\n                        Gestione Pratica ENEA\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: _vm.zeroEnea,
                                                            expression:
                                                              "zeroEnea"
                                                          }
                                                        ],
                                                        key: "1111",
                                                        staticClass:
                                                          "form-check-input",
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: "zeroEnea"
                                                        },
                                                        domProps: {
                                                          checked: Array.isArray(
                                                            _vm.zeroEnea
                                                          )
                                                            ? _vm._i(
                                                                _vm.zeroEnea,
                                                                null
                                                              ) > -1
                                                            : _vm.zeroEnea
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.zeroEnea,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v = null,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.zeroEnea = $$a.concat(
                                                                    [$$v]
                                                                  ))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.zeroEnea = $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                              }
                                                            } else {
                                                              _vm.zeroEnea = $$c
                                                            }
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          attrs: {
                                                            for: "zeroEnea"
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "Escludi questa voce dal preventivo"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            (
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                            ).toFixed(2)
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm.priceEnea
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ).toFixed(2)
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Oneri Finanziari\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [_vm._v("(IVA ESENTE)")]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label btn btn-sm btn-primary",
                                                          attrs: {
                                                            for: "zeroOneri"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modPrice(
                                                                "oneri"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Modifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.pricenewFlag
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .serviceCost
                                                                ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_altri_oneri
                                                                    ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              ) -
                                                                parseFloat(
                                                                  _vm.calcInfo
                                                                    .serviceCost
                                                                ) *
                                                                  (1 +
                                                                    parseFloat(
                                                                      _vm.iva_altri_oneri
                                                                    ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Costi di gestione pratica\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { attrs: { align: "left" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check hideOnPdf"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label btn btn-sm btn-primary",
                                                          attrs: {
                                                            for: "zeroPratica"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.modPrice(
                                                                "pratica"
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("Modifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              !_vm.pricenewFlag
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                : _c(
                                                    "td",
                                                    {
                                                      staticClass: "text-right"
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .serviceCost
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  ))
                                                            )
                                                          ) +
                                                            "\n                          €"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right uppercase",
                                                    attrs: {
                                                      colspan: "2",
                                                      align: "right",
                                                      scope: "row"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      [
                                                        _vm._v(
                                                          "Totale altri oneri per il committente\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA " +
                                                                  _vm._s(
                                                                    _vm.iva_altri_oneri *
                                                                      100
                                                                  ) +
                                                                  " %\n                            INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario != "si"
                                                      ? _c("b", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) *
                                                                      (1 +
                                                                        parseFloat(
                                                                          _vm.iva_altri_oneri
                                                                        )) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\n                          €"
                                                          )
                                                        ])
                                                      : _c("b", [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  (
                                                                    parseFloat(
                                                                      _vm.totalExtraMise
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva22NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .iva10NonAge
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceDcast
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm.priceEnea
                                                                        .replace(
                                                                          ".",
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          ",",
                                                                          "."
                                                                        )
                                                                    ) +
                                                                    parseFloat(
                                                                      _vm
                                                                        .calcInfo
                                                                        .allOneri
                                                                    )
                                                                  ).toFixed(2)
                                                                )
                                                              ) +
                                                              "\n                          €"
                                                          )
                                                        ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row ml-0 mr-0 pt-2" },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table table-bordered mb-0 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "b",
                                                          {
                                                            staticClass:
                                                              "uppercase",
                                                            attrs: {
                                                              align: "right"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Totale da pagare "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            ( a carico dell’utente finale\n                            "
                                                            ),
                                                            _vm.getProfile
                                                              .reg_forfettario !=
                                                            "si"
                                                              ? [
                                                                  _vm._v(
                                                                    ", IVA inclusa"
                                                                  )
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(
                                                              "\n                            )"
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          align: "right",
                                                          width: "220"
                                                        }
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                _vm.calcInfo
                                                                  .finalPrice
                                                              )
                                                            ) + " €"
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table mb-0 mt-3 greyBg"
                                            },
                                            [
                                              _c("tbody", [
                                                _c(
                                                  "tr",
                                                  { staticClass: "greyBg" },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: {
                                                          colspan: "3",
                                                          align: "left"
                                                        }
                                                      },
                                                      [
                                                        _vm.getProfile
                                                          .reg_forfettario ==
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "\n                            Operazione in franchigia da Iva ex art. 1 cc.\n                            54-89 L. 190/2014\n                          "
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("br"),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n\n                          L’utilizzo dei servizi descritti sul Sito comporta\n                          l’integrale accettazione dei\n                          "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "green",
                                                            attrs: {
                                                              href:
                                                                _vm.utilizzoPolicy,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            Termini e delle condizioni di riferimento\n                          "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "widthFull mt-5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row justify-content-center"
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass: "table table-bordered"
                                          },
                                          [
                                            _c("tbody", [
                                              _c("tr", [
                                                _c(
                                                  "th",
                                                  { attrs: { scope: "row" } },
                                                  [
                                                    _vm._v(
                                                      "\n                          IMPORTO TOTALE DEL CREDITO CEDUTO\n                          "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalWithBonus
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var emicon_staticRenderFns = []
emicon_render._withStripped = true
var emicon_esExports = { render: emicon_render, staticRenderFns: emicon_staticRenderFns }
/* harmony default export */ var calcolatore_emicon = (emicon_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75574de3", emicon_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/calcolatore/emicon.vue
var emicon_disposed = false
var emicon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var emicon___vue_template_functional__ = false
/* styles */
var emicon___vue_styles__ = null
/* scopeId */
var emicon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var emicon___vue_module_identifier__ = null
var emicon_Component = emicon_normalizeComponent(
  emicon,
  calcolatore_emicon,
  emicon___vue_template_functional__,
  emicon___vue_styles__,
  emicon___vue_scopeId__,
  emicon___vue_module_identifier__
)
emicon_Component.options.__file = "src/components/calcolatore/emicon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75574de3", emicon_Component.options)
  } else {
    hotAPI.reload("data-v-75574de3", emicon_Component.options)
  }
  module.hot.dispose(function (data) {
    emicon_disposed = true
  })
})()}

/* harmony default export */ var components_calcolatore_emicon = (emicon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/calcolatore/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var calcolatore_moment = __webpack_require__("PJh5");

var calcolatore_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';







// GET DOC LIST


/* harmony default export */ var calcolatore = ({
  name: "login",
  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    Hoval: components_calcolatore_hoval,
    Emicon: components_calcolatore_emicon,
    Agnellimetalli: components_calcolatore_agnellimetalli
  },
  data: function data() {
    var _ref;

    return _ref = {
      username: "",
      documents: documents_documents,
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",
      corporateClient: '',
      usersForAdmin: [],
      userSel: "",
      seleErr: false,
      person: true,
      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",
      partita_iva: "",
      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione"
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale"
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi"
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua"
        },
        5: {
          name: "Climatizzatore",
          value: "climatizzatore"
        },
        6: {
          name: "Collettore solare termico",
          value: "solare"
        },
        7: {
          name: "Altro Prodotto Vaillant",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione"
        },
        1: {
          name: "Altro Accessorio Vaillant",
          value: "altroV"
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche"
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: 0,
      resend_success: false,
      loadingState2: false,
      loadingState: false,
      passwordFieldType: "password",
      moment: calcolatore_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      accessories: [{
        index: "product" + 0,
        indexCount: "quantity" + 0,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      }],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",
      priceDcast: "",
      hasPrev: true,
      adminIs: false,

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      codice_fiscale: "",
      existCF: false,
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", ""), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", ""), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", false), defineProperty_default()(_ref, "foglio", ""), defineProperty_default()(_ref, "subalterno", ""), defineProperty_default()(_ref, "particella", ""), defineProperty_default()(_ref, "selectready", false), defineProperty_default()(_ref, "selectionOk", false), defineProperty_default()(_ref, "corporateClient", ''), _ref;
  },


  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateInst: function validateInst() {
      var _vue = this;
      if (!this.selectionOk) {
        this.seleErr = true;

        return false;
      } else {
        _vue.$scrollTo("#app", 700, {
          offset: -170
        });
        return true;
      }
    },
    validateZeroTab: function validateZeroTab() {
      var _vue = this;

      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          this.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$warn(this.errors);
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          this.$log("ERROR IN FORM");

          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
    },

    validateSecondTab: function validateSecondTab() {
      this.$log(this.$validator);
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          this.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });

      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          this.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                docTemp = _this.documents[_this.client_type];

                _this.documents[_this.client_type] = {};

                selettore_titoloPossesso = _this.client_ownership;
                selettore_enea = _this.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this.documents[_this.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this.documents[_this.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this.documents[_this.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onComplate: function onComplate() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loadingState = true;
                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;

                // ALL USER DATA
                data.user = !_this2.adminIs ? _this2.getProfile : _this2.referSel;
                // BONUS SELECTED
                data.bonus = _this2.ecoBonus ? _this2.ecoBonus : "";
                // CLIENT DATA
                data.client_name = _this2.clientName;
                data.client_lastname = _this2.clientLastname;
                data.client_type = _this2.client_type;
                data.client_codice_fiscale = _this2.codice_fiscale ? _this2.codice_fiscale : "";
                data.client_partita_iva = _this2.partita_iva ? _this2.partita_iva : "";
                data.client_mobile = _this2.client_mobile;
                data.client_phone = _this2.client_phone;
                data.client_email = _this2.client_email;
                data.building_foglio = _this2.foglio ? _this2.foglio : "";
                data.building_particella = _this2.particella ? _this2.particella : "";
                data.building_subalterno = _this2.subalterno ? _this2.subalterno : "";
                data.dcast_export = _this2.dcast_export ? _this2.dcast_export : 0;
                data.admin_ref = _this2.adminIs ? _this2.AdminId : "";
                data.corporateClient = _this2.profile.corporateClient ? _this2.profile.corporateClient : "";
                // NEWWWWWWWWW
                if (_this2.zeroEnea) {
                  data.client_price_enea = _this2.zeroEneaOld;
                } else {
                  data.client_price_enea = _this2.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this2.zeroDcast) {
                  data.client_price_dcast = _this2.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this2.priceDcast;
                }

                data.client_ownership = _this2.client_ownership;

                // CLIENT HOUSE DATA
                data.building_province = _this2.province;
                data.building_city = _this2.city.city;
                data.building_zip = _this2.zip;
                data.building_address = _this2.adress;
                data.building_civic = _this2.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this2.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this2.eventType;
                data.intervention_date = _this2.eventStartdate ? calcolatore_moment(_this2.eventStartdate).format("YYYY-MM-DD") : "";
                // PRODUCTS & ACCESSORIES
                data.products = _this2.products;
                data.accessories = _this2.accessories;
                data.enea_request = _this2.enea;
                data.created_at = calcolatore_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = calcolatore_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this2.totalProducts;
                data.total_accessories_price = _this2.totalAccessories;
                data.price_work = _this2.priceWork;

                data.total_transfer_for_user = _this2.calcInfo.aInstallatore ? _this2.calcInfo.aInstallatore : "";
                data.total_transfer_for_client = _this2.calcInfo.finalPrice ? _this2.calcInfo.finalPrice : "";
                data.total_bonus_savings = _this2.calcInfo.totalWithBonus ? _this2.calcInfo.totalWithBonus : "";

                data.total_work_and_iva = _this2.calcInfo.totalBaseAndIva ? _this2.calcInfo.totalBaseAndIva : "";

                // HTML FOR PDF
                data.htmlInvoice = _this2.hasPrev ? _this2.$refs.invoiceData.innerHTML : "";
                data.payment_id = !_this2.hasPrev ? 1 : 0;
                data.status = !_this2.hasPrev ? 1 : 0;
                //requiredOperations: '',

                data.building_uso_abitativo = _this2.usoAbitativo;
                _this2.$log(data);
                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/savePriceQuotation",
                  method: "POST",
                  data: data,
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "La tua Pratica è stata salvata correttamente";
                  alert.type = "SUCCESS";
                  _this2.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this2.$swal({
                    type: "success",
                    title: "Pratica salvata",
                    html: alert.text
                  });
                  _this2.loadingState = false;

                  _this2.$router.push("/pratiche");
                }).catch(function (resp) {
                  _this2.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this2.loadingState = false;
                });

              case 49:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        this.calcInfo.serviceCost = 160;
      }
      //var AttPercent = 10.58
      var AttPercent = 13.96;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totProducts) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totProducts - totAltroAcc;
      } else {
        var x10 = totProducts;
        var x22 = 0;
      }

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;

      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = ((parseFloat(totAltroAcc) + parseFloat(totAge) * ratio10) * 0.1).toFixed(2);
        this.calcInfo.iva10NonAge = (parseFloat(totalExtraMise) * ratio10 * 0.1).toFixed(2);

        this.calcInfo.iva22Age = (parseFloat(totAge) * ratio22 * 0.22).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * ratio22 * 0.22).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      //TOTAL BASE AND IVA 10 && 22
      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age);
      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) / 100 * 22;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 12.2;
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea) * 1.22 + parseFloat(this.priceDcast) * 1.22 + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 61;
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },

    selectChange: function selectChange(param) {
      if (param) {
        for (var i in this.loadUserData) {
          if (param == this.loadUserData[i].sel) {
            this.referSel = this.loadUserData[i].all;
            this.seleErr = false;
            this.$log("Installatore Selezionato");
            this.$log(this.referSel);
            this.selectionOk = true;
          }
        }
      } else {
        this.selectionOk = false;
      }
    },
    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      this.productIndex = this.productIndex + 1;
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      this.accessoriesIndex = this.accessoriesIndex + 1;
      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },

    loadUsers: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        var data;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loadingState = true;

                this.flagForCheck = this.areaAdmin == "all" ? "all" : this.flagForCheck;

                if (!this.flagForCheck) {
                  _context3.next = 7;
                  break;
                }

                data = {
                  id: this.flagForCheck,
                  type: this.profile.type
                };

                data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context3.next = 7;
                return axios_default()({
                  method: "POST",
                  data: { data: data },
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/loadUsers",
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  if (!resp.data) {
                    _this3.loadingState = false;
                  } else {
                    for (var i in resp.data) {
                      _this3.usersForAdmin[i] = resp.data[i].sel;
                    }
                    _this3.loadUserData = resp.data;
                    _this3.selectready = true;
                    _this3.loadingState = false;
                  }
                }).catch(function (resp) {});

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadUsers() {
        return _ref2.apply(this, arguments);
      }

      return loadUsers;
    }(),
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = calcolatore_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = calcolatore_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = calcolatore_numeral(this.priceDcast).format("0.0,[00]");
    },


    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      var data = {
        key: "calc",
        cc: this.corporateClient
      };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
        method: "POST",
        data: {
          data: data
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this5.allProducts = resp.data.allProducts;
        _this5.$log(_this5.allProducts);
      }).catch(function (resp) {});
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = {
        index: "",
        name: "",
        serial: ""
      };
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = calcolatore_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);
        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = false;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 <br/>";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      if (this.eventType == "Instalazione") {
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale" || this.products[i].group == "pompadicalore" || this.products[i].group == "ibridi" || this.products[i].group == "scaldacqua") {
          var alert = {};
          alert.text = "Per " + this.ecoBonus + " con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END EVENT TYPE  *********************************************************************************************************************
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context4.sent;
                    length = searchlength;

                    if (!(length != 10)) {
                      _context4.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context4.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context4.next = 11;
                      break;
                    }

                    return _context4.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 12:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, _this6);
          }));

          return function preConfirm(_x) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = _this7.allProducts;
                _context5.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context5.t1 = _context5.t0()).done) {
                  _context5.next = 18;
                  break;
                }

                x = _context5.t1.value;
                _context5.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context5.t3 = _context5.t2()).done) {
                  _context5.next = 16;
                  break;
                }

                y = _context5.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context5.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context5.abrupt("return", data[x][y]);

              case 14:
                _context5.next = 5;
                break;

              case 16:
                _context5.next = 2;
                break;

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = calcolatore_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE ***************************************" + this.totalExtraMise);

      this.$log(this.products);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;
      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (this.ecoBonus != "Bonus Casa 50%") {
          alert.type = "ERROR";
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      for (var x in this.accessories) {
        price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
      }
      if (price) {
        this.totalAccessories = calcolatore_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      this.accessories[i].price = calcolatore_numeral(this.accessories[i].price).format("0.0,[00]");
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza;
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context6.sent;
                    length = searchlength;

                    if (!(length != 10)) {
                      _context6.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context6.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context6.next = 11;
                      break;
                    }

                    return _context6.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref4.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                data = _this9.allProducts;
                _context7.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context7.t1 = _context7.t0()).done) {
                  _context7.next = 20;
                  break;
                }

                x = _context7.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context7.next = 18;
                  break;
                }

                _context7.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context7.t3 = _context7.t2()).done) {
                  _context7.next = 18;
                  break;
                }

                y = _context7.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context7.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context7.abrupt("return", data[x][y]);

              case 16:
                _context7.next = 6;
                break;

              case 18:
                _context7.next = 2;
                break;

              case 20:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.profile.type == 1) {
        this.hasPrev = false;
      }
      if (this.profile.status == "admin") {
        this.adminIs = true;
        this.AdminId = this.profile.id;
        this.flagForCheck = this.profile.id;
        this.areaAdmin = this.profile.area;
      } else if (this.profile.status == "user") {
        this.adminIs = false;
        this.flagForCheck = this.profile.id;
        this.areaAdmin = this.profile.area;
      }
    }
  },
  watch: {
    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    client_type: function client_type(val) {
      if (val == "Persona fisica") {
        this.person = true;
        this.codice_fiscale = "";
        this.partita_iva = "";
      } else {
        this.person = false;
        this.partita_iva = "";
        this.codice_fiscale = "";
      }
    },
    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    codice_fiscale: function codice_fiscale(val) {
      if (val) {
        this.codice_fiscale = this.codice_fiscale.toUpperCase();
      }
    },

    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this11 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.zips = resp.data.zips;
          _this11.zipsState = false;
        }).catch(function (resp) {
          _this11.zips = [];
          _this11.zipsState = false;
        });
      }
    },
    getProfile: function getProfile() {

      this.setProfile();
      this.loadUsers();
    }
  },
  created: function created() {
    this.loadProducts();
    this.setProfile();
    this.loadUsers();
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();
    this.setProfile();
    this.loadUsers();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    },
    profile: function profile(state) {
      return state.user.profile;
    },
    managedArea: function managedArea(state) {
      return state.user.profile.type;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c2a4680","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calcolatore/index.vue
var calcolatore_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.corporateClient == "agnellimetalli"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [_c("Agnellimetalli")],
        1
      )
    : _vm.corporateClient == "hoval"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [_c("Hoval")],
        1
      )
    : _vm.corporateClient == "emicon"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [_c("Emicon")],
        1
      )
    : _vm._e()
}
var calcolatore_staticRenderFns = []
calcolatore_render._withStripped = true
var calcolatore_esExports = { render: calcolatore_render, staticRenderFns: calcolatore_staticRenderFns }
/* harmony default export */ var components_calcolatore = (calcolatore_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c2a4680", calcolatore_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/calcolatore/index.vue
var calcolatore_disposed = false
var calcolatore_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var calcolatore___vue_template_functional__ = false
/* styles */
var calcolatore___vue_styles__ = null
/* scopeId */
var calcolatore___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var calcolatore___vue_module_identifier__ = null
var calcolatore_Component = calcolatore_normalizeComponent(
  calcolatore,
  components_calcolatore,
  calcolatore___vue_template_functional__,
  calcolatore___vue_styles__,
  calcolatore___vue_scopeId__,
  calcolatore___vue_module_identifier__
)
calcolatore_Component.options.__file = "src/components/calcolatore/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c2a4680", calcolatore_Component.options)
  } else {
    hotAPI.reload("data-v-3c2a4680", calcolatore_Component.options)
  }
  module.hot.dispose(function (data) {
    calcolatore_disposed = true
  })
})()}

/* harmony default export */ var src_components_calcolatore = (calcolatore_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var login_moment = __webpack_require__("PJh5");

/* harmony default export */ var components_login = ({
  name: "login",
  data: function data() {
    return {
      username: "",
      password: "",
      token: "",
      loading: false,
      tempMail: "",
      socialEmail: false,
      social: "",
      confirmed: true,
      resend_success: false,
      loadingState2: false,
      passwordFieldType: "password",
      moment: login_moment,
      finish: "2030-12-15 23:59:59",
      to_activate: false,
      hasregistration: true,
      corporateClient: ""
    };
  },

  methods: {
    switchVisibility: function switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    login: function login() {
      var _this = this;

      var username = this.username,
          password = this.password;


      this.$validator.validate().then(function (valid) {
        if (valid) {
          var data = {
            username: username,
            password: password
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          _this.$store.dispatch(auth["f" /* AUTH_REQUEST */], {
            data: data
          }).then(function (resp) {
            _this.$router.push("/");
          }).catch(function (error) {
            _this.$log(error.response.data.user);
            if (error.response.data.status == "to_activate") {
              _this.to_activate = true;
            }
            if (error.response.data.user.corporateClient) _this.corporateClient = error.response.data.user.corporateClient;
            if (_this.corporateClient == 'emicon') {
              _this.$router.push('/recovery-password?token=' + _this.$encryptByAES(stringify_default()(error.response.data.user.email), "B%t$AD!YMfnCZnfD") + '&corporateClient=' + _this.$encryptByAES(stringify_default()(error.response.data.user.corporateClient), "B%t$AD!YMfnCZnfD"));
            }
          });
        }
      });
    },

    resetState: function resetState() {
      this.resend_success = false;
      this.confirmed = true;
    },

    resendConfirmEmail: function resendConfirmEmail() {
      var _this2 = this;

      var username = this.username;


      if (username) {
        this.loadingState2 = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/resend_registration_email",
          method: "POST",
          data: {
            username: username
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this2.resend_success = true;
          _this2.loadingState2 = false;
        }).catch(function (error) {
          _this2.loadingState2 = false;

          _this2.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
      } else {
        this.confirmed = true;
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "loadingState", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  })),
  mounted: function mounted() {},
  watch: {
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c98a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/index.vue
var login_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-3" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pt- mb-5" }, [
          _c(
            "div",
            { staticClass: "col-md-6 col-lg-4 pt-4 pb-4 vaillantCont" },
            [
              _c(
                "form",
                {
                  staticClass: "login widthFull",
                  attrs: { id: "login-form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login($event)
                    }
                  }
                },
                [
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", { staticClass: "widthFull" }, [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-1" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.username,
                                      expression: "username"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        email: true,
                                        temporaryEmail: true,
                                        plusIssueEmail: true,
                                        max: 56
                                      },
                                      expression:
                                        "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("username"),
                                    valid: !!_vm.username
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "username",
                                    name: "username",
                                    "data-vv-as": "Email"
                                  },
                                  domProps: { value: _vm.username },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.username = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "username" }
                                  },
                                  [_vm._v("Email")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("username")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                    " +
                                            _vm._s(
                                              _vm.errors.first("username")
                                            ) +
                                            "\r\n\r\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.socialEmail
                                  ? _c(
                                      "div",
                                      { staticClass: "text-danger mt-3" },
                                      [
                                        _vm._v(
                                          "\r\n                    Sei registrato con: "
                                        ),
                                        _c(
                                          "strong",
                                          { staticClass: "text-capitalize" },
                                          [_vm._v(_vm._s(_vm.socialEmail))]
                                        ),
                                        _vm._v(
                                          ". Per effetuare accesso clicca sulla apposita icona\r\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-3" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        min: 8,
                                        max: 56
                                      },
                                      expression:
                                        "{required:true, min: 8, max: 56}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("password"),
                                    valid: !!_vm.password
                                  },
                                  attrs: {
                                    type: "password",
                                    id: "password",
                                    name: "password",
                                    "data-vv-as": "Password"
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "password" }
                                  },
                                  [_vm._v("Password")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("password")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                    " +
                                            _vm._s(
                                              _vm.errors.first("password")
                                            ) +
                                            "\r\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loginerror
                                  ? _c("div", { staticClass: "mb-3" }, [
                                      _c(
                                        "span",
                                        { staticClass: "formError ml-1" },
                                        [_vm._v("Email o password errati.")]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", { staticClass: "widthFull" }, [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm.hasregistration
                              ? _c(
                                  "div",
                                  { staticClass: "col-md-12 mb-3" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "black Medium pl-3 ",
                                        attrs: { to: "/forgot-password" }
                                      },
                                      [_vm._v("Password dimenticata?")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm.social
                              ? _c(
                                  "div",
                                  { staticClass: "text-danger mb-5 " },
                                  [
                                    _vm._v(
                                      "\r\n                Sei registrato con altra social network: "
                                    ),
                                    _c(
                                      "strong",
                                      { staticClass: "text-capitalize" },
                                      [_vm._v(_vm._s(_vm.social))]
                                    ),
                                    _vm._v(
                                      " Per effetuare accesso clicca sulla apposita icona\r\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm.hasregistration
            ? _c(
                "div",
                {
                  staticClass: "col-md-6 col-lg-4 pt-1 pb-4 mb-5 vaillantCont"
                },
                [
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-12 mb-0 pb-0 text-center"
                              },
                              [
                                _vm.moment(_vm.finish) > _vm.moment()
                                  ? _c(
                                      "h1",
                                      {},
                                      [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              " Regular center glade pb-2"
                                          },
                                          [_vm._v("Non sei registrato?")]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isAuthenticated
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn btn-primary  btnYellow",
                                                attrs: { to: "/registration" }
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                  Registrati\r\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm.resend_success && !_vm.to_activate
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { to: "/login" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.resetState($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Accedi")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : !_vm.resend_success &&
                      !_vm.to_activate &&
                      _vm.corporateClient != "emicom"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary mt-3",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.resendConfirmEmail($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Invia")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.to_activate
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-3" }, [
                              _vm.corporateClient != "hoval"
                                ? _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "mb-4 center text-red sans-serifBold"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "La tua richiesta è in fase di approvazione."
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("br"),
                                      _vm._v(
                                        "A breve riceverai la conferma via email e potrai accedere alla piattaforma."
                                      )
                                    ]
                                  )
                                : _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "mb-4 center text-red sans-serifBold"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "La tua richiesta è in fase di approvazione."
                                        )
                                      ])
                                    ]
                                  )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-primary mt-3",
                                    attrs: { to: "/" }
                                  },
                                  [_vm._v("Home")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._m(5)
        ])
      ])
    ],
    1
  )
}
var login_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 center " }, [
        _c("h1", { staticClass: "Regular center  pt-4 h0" }, [_vm._v("Accedi")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 text-center" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary  btnYellow shadow mb-4 mt-4",
          attrs: { type: "submit" }
        },
        [_vm._v("Accedi")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-12 pt-1 " }, [
      _c("div", { staticClass: "row justify-content-center divider" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v(
            "L'e-mail di conferma della registrazione è stata inviata alla tua casella di posta elettronica"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v("Non hai ricevuto l'e-mail "),
          _c("br"),
          _vm._v("di conferma della registrazione?")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4 mt-5" }, [
        _vm._v(
          "Controlla che il tuo gestore di posta elettronica non abbia inserito il messaggio nella cartella di posta indesiderata (spam) o con destinatario sconosciuto."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4" }, [
        _vm._v(
          "Se sono passati diversi minuti da quando hai fatto la richiesta e il messaggio non è ancora arrivato clicca sul bottone qui sotto per chiederne il reinivio."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-12 pt-1" }, [
      _c("div", { staticClass: "row justify-content-center divider" })
    ])
  }
]
login_render._withStripped = true
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_login = (login_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c98a68", login_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/login/index.vue
var login_disposed = false
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = null
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  components_login,
  selectortype_template_index_0_src_components_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)
login_Component.options.__file = "src/components/login/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-70c98a68", login_Component.options)
  } else {
    hotAPI.reload("data-v-70c98a68", login_Component.options)
  }
  module.hot.dispose(function (data) {
    login_disposed = true
  })
})()}

/* harmony default export */ var src_components_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-timepicker/index.js
var vue2_timepicker = __webpack_require__("SVjV");
var vue2_timepicker_default = /*#__PURE__*/__webpack_require__.n(vue2_timepicker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/hoval.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var account_hoval_moment = __webpack_require__("PJh5");

/* harmony default export */ var account_hoval = ({
  name: "play",
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a
  },
  data: function data() {
    return {
      loadingState: false,
      proccess: "START",
      userToken: "",
      partita_iva: "",
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: "",
      tempCF: "",
      tempEmail: "",
      azienda: "",
      name: "",
      lastname: "",
      email: "",
      phone: "",
      cellulare: "",
      codice_fiscale: "",
      shipEqual: true,
      shipData: {},
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: "",
      ibanNome: "",
      ibanCognome: "",
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: "",
      confirm_password: "",
      ship_name: "",
      ship_lastname: "",
      near: "",
      ship_phone: "",
      ship_cellulare: "",
      ship_address: "",
      ship_civic: "",
      ship_region: "",
      ship_province: "",
      ship_city: "",
      ship_zip: "",
      note: "",
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      invoiceRear: "",
      invoiceRearName: "",
      invoiceRearBucket: "",
      uploadRearPercentage: 0,
      id_eps: "",
      precompiled_iva: "",
      vw: window.innerWidth,
      logo: "",
      reg_forfettario: ""
    };
  },

  methods: {
    editUser: function editUser(type) {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;
          var data = {
            user: {
              email: _this.email,
              name: _this.name,
              cognome: _this.lastname,
              azienda: _this.azienda,
              //id_eps: this.id_eps,
              indirizzo: _this.address,
              civico: _this.civic,
              comune: _this.city.city,
              provincia: _this.province,
              regione: _this.region.text,
              cap: _this.zip,
              telefono: _this.phone,
              cellulare: _this.cellulare,
              logo: _this.saveDb,
              reg_forfettario: _this.reg_forfettario,

              iban: _this.iban,
              intestatario: _this.ibanNome
            },
            regType: _this.precompiled_iva == _this.partita_iva ? "old" : "new"
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          if (_this.password != "" && _this.confirm_password != "") {
            data.password = _this.password;
          }

          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/editUser",
            method: "POST",
            data: {
              data: data
            },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.$store.dispatch(user["d" /* USER_REQUEST */]);

            if (type == "logo") {} else {
              _this.addClientSuccess();
              _this.$router.push("/");
            }

            //this.proccess = 'REG_SUCCESS'
            _this.loadingState = false;
          }).catch(function (error) {
            _this.loadingState = false;
            var text = error.response.data.error;
            _this.addClientError(text);
          });
        }
      });
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;
      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.target.files[0]);
        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadImageInvoice", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
            _vue.saveDb = e.data.fatturaNoCrypt;
            _vue.logo = e.data.fattura;
            _vue.editUser("logo");
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.saveDb = "";
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = "";
          _vue.invoiceFrontBucket = "";
          _vue.saveDb = "";
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },
    UploadError: function UploadError() {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    checkIfExistUser: function checkIfExistUser() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, _vue, regione;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this2.profile) {
                  _context4.next = 25;
                  break;
                }

                data = _this2.profile;


                _this2.$log(data);

                _this2.codice_fiscale = data.codice_fiscale;
                _this2.partita_iva = data.partita_iva;
                _this2.email = data.email;
                _this2.azienda = data.azienda;
                _this2.address = data.indirizzo;
                _this2.civic = data.civico;
                _this2.phone = data.telefono;
                _this2.cellulare = data.cellulare;
                _this2.id_eps = data.tipo_azienda;

                _this2.name = data.name;
                _this2.lastname = data.cognome;

                _this2.logo = data.logo;

                _this2.iban = data.iban;
                _this2.ibanNome = data.intestatario;

                _this2.reg_forfettario = data.reg_forfettario == "0" ? "" : data.reg_forfettario;

                _vue = _this2;


                _vue.$log("SET REGION");
                regione = data.regione;
                _context4.next = 23;
                return _vue.setRegion(regione);

              case 23:
                _vue.$log("SET REGION SUCCESS");

                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                  var province;
                  return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _vue.$log("SET PROVINCE");
                          province = data.provincia;
                          _context3.next = 4;
                          return _vue.setProvince(province);

                        case 4:
                          _vue.$log("SET PROVINCE SUCCESS");

                          setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                            var city;
                            return regenerator_default.a.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _vue.$log("SET CITY");
                                    city = data.comune;
                                    _context2.next = 4;
                                    return _vue.setCity(city);

                                  case 4:
                                    _vue.$log("SET CITY SUCCESS");

                                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                      var cap;
                                      return regenerator_default.a.wrap(function _callee$(_context) {
                                        while (1) {
                                          switch (_context.prev = _context.next) {
                                            case 0:
                                              _vue.$log("SET CAP");
                                              cap = data.cap;
                                              _context.next = 4;
                                              return _vue.setCap(cap);

                                            case 4:
                                              _vue.$log("SET CAP SUCCESS");

                                            case 5:
                                            case "end":
                                              return _context.stop();
                                          }
                                        }
                                      }, _callee, this);
                                    })), 1000);

                                  case 6:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, this);
                          })), 1000);

                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                })), 1000);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    setCap: function setCap(cap) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (x in _this3.zips) {
                  if (_this3.zips[x].cap == cap.toUpperCase()) {
                    _this3.zip = _this3.zips[x].cap;
                  }
                }
                _this3.$log(_this3.province);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    setCity: function setCity(city) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var x, k;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (x in _this4.cities) {
                  if (_this4.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this4.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this4.city = k;
                  }
                }
                _this4.$log(_this4.city);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this5.provincies) {
                  _this5.$log("START");
                  _this5.$log(_this5.provincies[x].sigla + " =?= " + province.toUpperCase());
                  if (_this5.provincies[x].sigla == province.toUpperCase()) {
                    _this5.province = _this5.provincies[x].sigla;
                  }
                }
                _this5.$log(_this5.province);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    setRegion: function setRegion(regione) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this6.regions) {
                  if (_this6.regions[x].regione == regione.toUpperCase()) {
                    k = {
                      text: regione.toUpperCase(),
                      id: _this6.regions[x].id_regione
                    };

                    _this6.region = k;
                  }
                }
                _this6.$log(_this6.region);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },
    addClientSuccess: function addClientSuccess() {
      this.$swal({
        type: "success",
        title: '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    populateRegions: function populateRegions() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getRegions",
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this7.regions = resp.data.regions;
                  _this7.regionsState = false;

                  _this7.ship_regions = resp.data.regions;
                  _this7.ship_regionsState = false;
                }).catch(function (resp) {
                  _this7.regions = [];
                  _this7.regionsState = false;

                  _this7.ship_regions = [];
                  _this7.ship_regionsState = false;
                });

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this7);
      }))();
    },


    checkRegion: function checkRegion() {
      var region = this.region;

      if (region) {
        this.provinceError = false;
      } else {
        this.provinceError = true;
      }
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    ship_checkRegion: function ship_checkRegion() {
      var ship_region = this.ship_region;

      if (ship_region) {
        this.ship_provinceError = false;
      } else {
        this.ship_provinceError = true;
      }
    },
    ship_checkProvince: function ship_checkProvince() {
      var ship_province = this.ship_province;

      if (ship_province) {
        this.ship_cityError = false;
      } else {
        this.ship_cityError = true;
      }
    },
    ship_checkZip: function ship_checkZip() {
      var ship_city = this.ship_city;

      if (ship_city) {
        this.ship_zipError = false;
      } else {
        this.ship_zipError = true;
      }
    },

    calcToDate: function calcToDate() {
      var start = Object({"year":2021,"month":2,"day":15});
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = date;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var stopObj = Object({"year":2030,"month":12,"day":15});
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },


    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    }
  },
  watch: {
    iban: function iban(value) {
      if (value) {
        this.iban = value.toUpperCase().trim();
        this.iban = this.iban.replace(" ", "");
      }
    },
    azienda: function azienda(value) {
      this.azienda = value.toUpperCase();
    },
    name: function name(value) {
      this.name = value.toUpperCase();
    },
    lastname: function lastname(value) {
      this.lastname = value.toUpperCase();
    },
    ship_name: function ship_name(value) {
      this.ship_name = value.toUpperCase();
    },
    ship_lastname: function ship_lastname(value) {
      this.ship_lastname = value.toUpperCase();
    },
    number: function number(value) {
      this.number = parseInt(value);
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    id_eps: function id_eps(val) {
      if (val) {
        //this.id_eps = val.replace(/\D+/g, '');
      }
    },
    cellulare: function cellulare(val) {
      if (val) {
        this.cellulare = val.replace(/\D+/g, "");
      }
    },
    ship_phone: function ship_phone(val) {
      if (val) {
        this.ship_phone = val.replace(/\D+/g, "");
      }
    },
    ship_cellulare: function ship_cellulare(val) {
      if (val) {
        this.ship_cellulare = val.replace(/\D+/g, "");
      }
    },
    region: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(newVal) {
        var _this8 = this;

        var provincies, provinciesState;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.zips = [];
                this.cities = [];
                this.zip = "";
                this.city = "";
                this.cityError = false;
                this.provinceError = false;
                this.zipError = false;
                this.province = "";
                this.provincies = [];
                this.provinciesState = true;

                provincies = this.provincies, provinciesState = this.provinciesState;
                _context10.next = 13;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvincies",
                  method: "POST",
                  data: {
                    region: newVal.id
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this8.provincies = resp.data.provincies;
                  _this8.provinciesState = false;
                }).catch(function (resp) {
                  _this8.provincies = [];
                  _this8.provinciesState = false;
                });

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function region(_x) {
        return _ref4.apply(this, arguments);
      }

      return region;
    }(),
    ship_region: function ship_region(newVal) {
      var _this9 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_provinceError = false;
      this.ship_zipError = false;
      this.ship_province = "";
      this.ship_provincies = [];
      this.ship_provinciesState = true;

      var ship_provincies = this.ship_provincies,
          ship_provinciesState = this.ship_provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvincies",
        method: "POST",
        data: {
          region: newVal.id
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this9.ship_provincies = resp.data.provincies;
        _this9.ship_provinciesState = false;
      }).catch(function (resp) {
        _this9.ship_provincies = [];
        _this9.ship_provinciesState = false;
      });
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_province: function ship_province(newProvince) {
      var _this11 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_zipError = false;

      if (newProvince) {
        this.ship_citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.ship_cities = resp.data.cities;
          _this11.ship_citiesState = false;
        }).catch(function (resp) {
          _this11.ship_cities = [];
          _this11.ship_citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this12 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this12.zips = resp.data.zips;
          _this12.zipsState = false;
        }).catch(function (resp) {
          _this12.zips = [];
          _this12.zipsState = false;
        });
      }
    },
    getProfile: function getProfile() {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this13.checkIfExistUser();

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_city: function ship_city(newCity) {
      var _this14 = this;

      this.ship_zipError = false;
      this.ship_zips = [];
      this.ship_zip = "";

      if (newCity.cityistat) {
        this.ship_zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this14.ship_zips = resp.data.zips;
          _this14.ship_zipsState = false;
        }).catch(function (resp) {
          _this14.ship_zips = [];
          _this14.ship_zipsState = false;
        });
      }
    },
    vw: function vw() {}
  },
  updated: function updated() {},
  created: function created() {
    this.$validator.extend("notZeros", {
      getMessage: function getMessage(field) {
        return " Il campo Numero di telefono non ha un formato valido.";
      },
      validate: function validate(value) {
        // value must be > zero
        if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
        return false;
      }
    });
  },
  mounted: function mounted() {
    var _this15 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      var _vue;

      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _vue = _this15;

              window.addEventListener("resize", _this15.handleResize);
              _this15.handleResize();
              _context12.next = 5;
              return _this15.populateRegions();

            case 5:
              _this15.lastnamex = _this15.getProfile.cognome;

              _this15.xuserx = _this15.getProfile.name;

              if (!_this15.getProfile) {
                _context12.next = 10;
                break;
              }

              _context12.next = 10;
              return _this15.checkIfExistUser();

            case 10:

              setTimeout(function () {
                _vue.disabledDates = {
                  to: _vue.calcToDate(), // Disable all dates up to specific date
                  from: _vue.calcFromDate() // Disable all dates after specific date
                };

                _vue.scrollFinished = true;
              }, 1500);

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this15);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25d2da78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/hoval.vue
var account_hoval_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5 mb-5" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-12 center mt-5" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h5", { staticClass: "black" }, [
              _vm._v(
                "\n          Tutti i campi sono obbligatori e puoi modificare le celle di colore\n          bianco.\n        "
              )
            ]),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black" }, [
                  _vm._v(
                    "\n          In caso di variazione di email, partita iva o codice fiscale\n          contatta il assistenza\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm.proccess == "START"
            ? _c(
                "form",
                {
                  staticClass: "pb-5 black vaillantCont widthFull",
                  attrs: { id: "registration-form" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row mb-4 justify-content-center" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-5 col-md-3 mb-3 pl-md-5 pr-md-5" },
                        [
                          _vm.logo
                            ? _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: _vm.logo }
                              })
                            : _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src: __webpack_require__("YSGn")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _vm.logo
                          ? _c("div", { staticClass: "center" }, [
                              _vm._v(
                                "\n              Cambia Logo (formato: jpg, png)\n            "
                              )
                            ])
                          : _c("div", { staticClass: "center" }, [
                              _vm._v(
                                "\n              Carica Logo (formato: jpg, png)\n            "
                              )
                            ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png"
                                  ]
                                },
                                expression:
                                  "{\n                  required: false,\n                  size: 10240,\n                  ext: ['jpeg', 'jpg', 'png'],\n                  mimes: ['image/jpeg', 'image/jpg', 'image/png'],\n                }"
                              }
                            ],
                            ref: "fileInput",
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: { change: _vm.uploadFile }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Scegli il Contratto quadro*\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\n              "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.uploadFrontPercentage
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar",
                                      style: {
                                        width: _vm.uploadFrontPercentage + "%"
                                      },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.uploadFrontPercentage) +
                                          " %\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c("p", {
                                staticClass:
                                  "smallText center white mt-3 mb-0 pb-0 fileNameText"
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        !_vm.logo
                          ? _c(
                              "small",
                              { staticClass: "pt-4 pl-3 pr-3 center" },
                              [
                                _vm._v(
                                  "\n              Il campo non è obbligatorio. Se carichi il logo potremo\n              personalizzare i tuoi preventivi con il logo della tua azienda.\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.azienda,
                              expression: "azienda"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 128, min: 3 },
                              expression: "{ required: true, max: 128, min: 3 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("azienda"),
                            valid: !!_vm.azienda
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "azienda",
                            id: "azienda",
                            name: "azienda",
                            "data-vv-as": "Ragione sociale"
                          },
                          domProps: { value: _vm.azienda },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.azienda = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "azienda" }
                          },
                          [_vm._v("Ragione sociale *\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("azienda")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("azienda")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.partita_iva,
                              expression: "partita_iva"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !_vm.codice_fiscale,
                                partitaIva: true,
                                max: 11,
                                min: 11
                              },
                              expression:
                                "{\n                  required: !codice_fiscale,\n                  partitaIva: true,\n                  max: 11,\n                  min: 11,\n                }"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("partita_iva"),
                            valid: !!_vm.partita_iva
                          },
                          attrs: {
                            type: "text",
                            disabled: "",
                            autocomplete: "partina-iva",
                            id: "partita_iva",
                            name: "partita_iva",
                            "data-vv-as": "Partita IVA"
                          },
                          domProps: { value: _vm.partita_iva },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.partita_iva = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "partita_iva" }
                          },
                          [_vm._v("Partita IVA *")]
                        ),
                        _vm._v(" "),
                        _vm.existPIVA
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Partita IVA inserita già presente.")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("partita_iva")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("partita_iva")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.codice_fiscale,
                              expression: "codice_fiscale"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !_vm.partita_iva,
                                codiceFiscale: true,
                                max: 16,
                                min: 16
                              },
                              expression:
                                "{\n                  required: !partita_iva,\n                  codiceFiscale: true,\n                  max: 16,\n                  min: 16,\n                }"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("codice_fiscale"),
                            valid: !!_vm.codice_fiscale
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "codice-fiscale",
                            id: "codice_fiscale",
                            disabled: "",
                            name: "codice_fiscale",
                            "data-vv-as": "Codice Fiscale"
                          },
                          domProps: { value: _vm.codice_fiscale },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.codice_fiscale = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "codice_fiscale" }
                          },
                          [_vm._v("o Codice Fiscale *")]
                        ),
                        _vm._v(" "),
                        _vm.existCF
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "Codice Fiscale inserito già presente."
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("codice_fiscale")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("codice_fiscale")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.id_eps,
                              expression: "id_eps"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {},
                              expression: "{}"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("id_eps"),
                            valid: !!_vm.id_eps
                          },
                          attrs: {
                            type: "text",
                            disabled: "",
                            id: "id_eps",
                            name: "id_eps",
                            "data-vv-as": "Tipo Azienda"
                          },
                          domProps: { value: _vm.id_eps },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.id_eps = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "id_eps" }
                          },
                          [_vm._v("Tipo Azienda ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("id_eps")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("id_eps")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.id_eps == "Ditta Individuale" ||
                    _vm.id_eps == "Professionista iscritto ad albi"
                      ? _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reg_forfettario,
                                    expression: "reg_forfettario"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{ required: true }"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(
                                    "reg_forfettario"
                                  ),
                                  valid: !!_vm.reg_forfettario,
                                  disabled:
                                    _vm.getProfile.reg_forfettario != "0"
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "reg_forfettario",
                                  disabled:
                                    _vm.getProfile.reg_forfettario != "0",
                                  name: "reg_forfettario",
                                  "data-vv-as": "Regime Forfettario"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.reg_forfettario = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { key: 911, attrs: { value: "si" } },
                                  [_vm._v("si")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { key: 912, attrs: { value: "no" } },
                                  [_vm._v("no")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "region" }
                              },
                              [_vm._v("Regime Forfettario *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("reg_forfettario")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.errors.first("reg_forfettario")
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 55, min: 2 },
                              expression: "{ required: true, max: 55, min: 2 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("name"),
                            valid: !!_vm.name
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "name",
                            id: "name",
                            name: "name",
                            "data-vv-as": "Nome"
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "name" }
                          },
                          [_vm._v("Nome *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("name")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("name")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lastname,
                              expression: "lastname"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 55, min: 2 },
                              expression: "{ required: true, max: 55, min: 2 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("lastname"),
                            valid: !!_vm.lastname
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "lastname",
                            id: "lastname",
                            name: "lastname",
                            "data-vv-as": "Cognome"
                          },
                          domProps: { value: _vm.lastname },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastname = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "lastname" }
                          },
                          [_vm._v("Cognome *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("lastname")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("lastname")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                email: true,
                                temporaryEmail: true,
                                plusIssueEmail: true,
                                max: 56
                              },
                              expression:
                                "{\n                  required: true,\n                  email: true,\n                  temporaryEmail: true,\n                  plusIssueEmail: true,\n                  max: 56,\n                }"
                            }
                          ],
                          ref: "email",
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid":
                              _vm.errors.has("email") || _vm.existEmail,
                            valid: !!_vm.email
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "email",
                            disabled: "",
                            id: "email",
                            name: "email",
                            "data-vv-as": "Email"
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "email" }
                          },
                          [_vm._v("Email * ")]
                        ),
                        _vm._v(" "),
                        _vm.existEmail
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Email digitato già presente")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("email")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("email")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                max: 12,
                                min: 8,
                                notZeros: true,
                                regex: /^[0,3]+/
                              },
                              expression:
                                "{\n                  required: true,\n                  max: 12,\n                  min: 8,\n                  notZeros: true,\n                  regex: /^[0,3]+/,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("phone"),
                            valid: !!_vm.phone
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "telefono",
                            id: "phone",
                            name: "phone",
                            "data-vv-as": "Telefono"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "phone" }
                          },
                          [_vm._v("Telefono * ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("phone")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("phone")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cellulare,
                              expression: "cellulare"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                max: 12,
                                min: 8,
                                notZeros: true,
                                regex: /^[0,3]+/
                              },
                              expression:
                                "{\n                  required: true,\n                  max: 12,\n                  min: 8,\n                  notZeros: true,\n                  regex: /^[0,3]+/,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("cellulare"),
                            valid: !!_vm.cellulare
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "cellulare",
                            id: "cellulare",
                            name: "cellulare",
                            "data-vv-as": "Cellulare"
                          },
                          domProps: { value: _vm.cellulare },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.cellulare = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "cellulare" }
                          },
                          [_vm._v("Cellulare *\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("cellulare")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("cellulare")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address,
                              expression: "address"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 128, min: 5 },
                              expression: "{ required: true, max: 128, min: 5 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("address"),
                            valid: !!_vm.address
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "indirizzo",
                            id: "address",
                            name: "address",
                            "data-vv-as": "Indirizzo"
                          },
                          domProps: { value: _vm.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.address = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "address" }
                          },
                          [_vm._v("Indirizzo *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("address")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("address")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.civic,
                              expression: "civic"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 15 },
                              expression: "{ required: true, max: 15 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("civic"),
                            valid: !!_vm.civic
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "civico",
                            id: "civic",
                            name: "civic",
                            "data-vv-as": "Civico"
                          },
                          domProps: { value: _vm.civic },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.civic = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "civic" }
                          },
                          [_vm._v("Civico *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("civic")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("civic")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.region,
                                expression: "region"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("region"),
                              valid: !!_vm.region
                            },
                            attrs: {
                              autocomplete: "region-new",
                              id: "region",
                              name: "region",
                              "data-vv-as": "Regione"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.region = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.regions, function(region) {
                            return _c(
                              "option",
                              {
                                key: region.id_regione,
                                domProps: {
                                  value: {
                                    id: region.id_regione,
                                    text: region.regione
                                  },
                                  selected:
                                    region.id_regione == _vm.shipData.region
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(region.regione) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "region" }
                          },
                          [_vm._v("Regione *")]
                        ),
                        _vm._v(" "),
                        _vm.regionsState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadregion",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("region")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("region")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.province,
                                expression: "province"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("province"),
                              valid: !!_vm.province
                            },
                            attrs: {
                              autocomplete: "randomy",
                              id: "province",
                              name: "province",
                              "data-vv-as": "Provincia"
                            },
                            on: {
                              click: _vm.checkRegion,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.province = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.provincies, function(province) {
                            return _c(
                              "option",
                              {
                                key: province.sigla,
                                domProps: {
                                  value: province.sigla,
                                  selected:
                                    province.sigla == _vm.shipData.province
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(province.sigla) +
                                    " - " +
                                    _vm._s(province.provincia) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "province" }
                          },
                          [
                            _vm._v("Provincia *"),
                            _vm.provinceError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Regione")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.provinciesState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadProvince",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("province")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("province")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.city,
                                expression: "city"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("city"),
                              valid: !!_vm.city
                            },
                            attrs: {
                              autocomplete: "randomu",
                              id: "city",
                              name: "city",
                              "data-vv-as": "Località",
                              disabled: _vm.citiesState
                            },
                            on: {
                              click: _vm.checkProvince,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.city = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.cities, function(city) {
                            return _c(
                              "option",
                              {
                                key: city.comune,
                                domProps: {
                                  value: {
                                    cityistat: city.istat,
                                    city: city.comune
                                  },
                                  selected: city.comune == _vm.shipData.city
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(city.comune) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "city" }
                          },
                          [
                            _vm._v("Località *"),
                            _vm.cityError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Provincia")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.citiesState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadCity",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("city")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("city")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.zip,
                                expression: "zip"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("zip"),
                              valid: !!_vm.zip
                            },
                            attrs: {
                              autocomplete: "zip",
                              id: "zip",
                              name: "zip",
                              "data-vv-as": "Cap",
                              disabled: _vm.zipsState
                            },
                            on: {
                              click: _vm.checkZip,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.zip = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.zips, function(zip) {
                            return _c(
                              "option",
                              {
                                key: zip.cap,
                                domProps: {
                                  value: zip.cap,
                                  selected: zip.cap == _vm.shipData.zip
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(zip.cap) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "zip" }
                          },
                          [
                            _vm._v("Cap *"),
                            _vm.zipError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Località")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.zipsState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadZips",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("zip")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("zip")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { passwordCheck: true, min: 8, max: 56 },
                              expression:
                                "{ passwordCheck: true, min: 8, max: 56 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("password"),
                            valid: !!_vm.password
                          },
                          attrs: {
                            type: "password",
                            autocomplete: "new-password",
                            id: "password",
                            name: "password",
                            "data-vv-as": "Password"
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "password" }
                          },
                          [_vm._v("Scegli nuova password *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("password")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("password")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirm_password,
                              expression: "confirm_password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !!_vm.password,
                                passwordCheck: true,
                                min: 8,
                                max: 56,
                                confirmed: _vm.password
                              },
                              expression:
                                "{\n                  required: !!password,\n                  passwordCheck: true,\n                  min: 8,\n                  max: 56,\n                  confirmed: password,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("confirm_password"),
                            valid: !!_vm.confirm_password
                          },
                          attrs: {
                            type: "password",
                            autocomplete: "confirm-new-password",
                            id: "confirm_password",
                            name: "confirm_password",
                            "data-vv-as": "Conferma Password"
                          },
                          domProps: { value: _vm.confirm_password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirm_password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "confirm_password" }
                          },
                          [_vm._v("Conferma nuova password *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("confirm_password")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("confirm_password")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 center mb-0 pt-4 mb-1" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.editUser("normal")
                              }
                            }
                          },
                          [_vm._v("\n              Salva\n            ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var account_hoval_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "Bold" }, [_c("b", [_vm._v("ANAGRAFICA")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "text-center pt-4" }, [
        _vm._v("Logo della tua azienda")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "black center" }, [_vm._v("Modifica Password")])
    ])
  }
]
account_hoval_render._withStripped = true
var account_hoval_esExports = { render: account_hoval_render, staticRenderFns: account_hoval_staticRenderFns }
/* harmony default export */ var components_account_hoval = (account_hoval_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25d2da78", account_hoval_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/account/hoval.vue
var account_hoval_disposed = false
function hoval_injectStyle (ssrContext) {
  if (account_hoval_disposed) return
  __webpack_require__("kU6H")
  __webpack_require__("mrXZ")
}
var account_hoval_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var account_hoval___vue_template_functional__ = false
/* styles */
var account_hoval___vue_styles__ = hoval_injectStyle
/* scopeId */
var account_hoval___vue_scopeId__ = "data-v-25d2da78"
/* moduleIdentifier (server only) */
var account_hoval___vue_module_identifier__ = null
var account_hoval_Component = account_hoval_normalizeComponent(
  account_hoval,
  components_account_hoval,
  account_hoval___vue_template_functional__,
  account_hoval___vue_styles__,
  account_hoval___vue_scopeId__,
  account_hoval___vue_module_identifier__
)
account_hoval_Component.options.__file = "src/components/account/hoval.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25d2da78", account_hoval_Component.options)
  } else {
    hotAPI.reload("data-v-25d2da78", account_hoval_Component.options)
  }
  module.hot.dispose(function (data) {
    account_hoval_disposed = true
  })
})()}

/* harmony default export */ var src_components_account_hoval = (account_hoval_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/emicon.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var account_emicon_moment = __webpack_require__("PJh5");

/* harmony default export */ var account_emicon = ({
  name: "play",
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a
  },
  data: function data() {
    return {
      loadingState: false,
      proccess: "START",
      userToken: "",
      partita_iva: "",
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: "",
      tempCF: "",
      tempEmail: "",
      azienda: "",
      name: "",
      lastname: "",
      email: "",
      phone: "",
      cellulare: "",
      codice_fiscale: "",
      shipEqual: true,
      shipData: {},
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: "",
      ibanNome: "",
      ibanCognome: "",
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: "",
      confirm_password: "",
      ship_name: "",
      ship_lastname: "",
      near: "",
      ship_phone: "",
      ship_cellulare: "",
      ship_address: "",
      ship_civic: "",
      ship_region: "",
      ship_province: "",
      ship_city: "",
      ship_zip: "",
      note: "",
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      invoiceRear: "",
      invoiceRearName: "",
      invoiceRearBucket: "",
      uploadRearPercentage: 0,
      id_eps: "",
      precompiled_iva: "",
      vw: window.innerWidth,
      logo: "",
      reg_forfettario: ""
    };
  },

  methods: {
    editUser: function editUser(type) {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;
          var data = {
            user: {
              email: _this.email,
              name: _this.name,
              cognome: _this.lastname,
              azienda: _this.azienda,
              //id_eps: this.id_eps,
              indirizzo: _this.address,
              civico: _this.civic,
              comune: _this.city.city,
              provincia: _this.province,
              regione: _this.region.text,
              cap: _this.zip,
              telefono: _this.phone,
              cellulare: _this.cellulare,
              logo: _this.saveDb,
              reg_forfettario: _this.reg_forfettario,

              iban: _this.iban,
              intestatario: _this.ibanNome
            },
            regType: _this.precompiled_iva == _this.partita_iva ? "old" : "new"
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          if (_this.password != "" && _this.confirm_password != "") {
            data.password = _this.password;
          }

          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/editUser",
            method: "POST",
            data: {
              data: data
            },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.$store.dispatch(user["d" /* USER_REQUEST */]);

            if (type == "logo") {} else {
              _this.addClientSuccess();
              _this.$router.push("/");
            }

            //this.proccess = 'REG_SUCCESS'
            _this.loadingState = false;
          }).catch(function (error) {
            _this.loadingState = false;
            var text = error.response.data.error;
            _this.addClientError(text);
          });
        }
      });
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;
      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.target.files[0]);
        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadImageInvoice", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
            _vue.saveDb = e.data.fatturaNoCrypt;
            _vue.logo = e.data.fattura;
            _vue.editUser("logo");
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.saveDb = "";
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = "";
          _vue.invoiceFrontBucket = "";
          _vue.saveDb = "";
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },
    UploadError: function UploadError() {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    checkIfExistUser: function checkIfExistUser() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, _vue, regione;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this2.profile) {
                  _context4.next = 25;
                  break;
                }

                data = _this2.profile;


                _this2.$log(data);

                _this2.codice_fiscale = data.codice_fiscale;
                _this2.partita_iva = data.partita_iva;
                _this2.email = data.email;
                _this2.azienda = data.azienda;
                _this2.address = data.indirizzo;
                _this2.civic = data.civico;
                _this2.phone = data.telefono;
                _this2.cellulare = data.cellulare;
                _this2.id_eps = data.tipo_azienda;

                _this2.name = data.name;
                _this2.lastname = data.cognome;

                _this2.logo = data.logo;

                _this2.iban = data.iban;
                _this2.ibanNome = data.intestatario;

                _this2.reg_forfettario = data.reg_forfettario == "0" ? "" : data.reg_forfettario;

                _vue = _this2;


                _vue.$log("SET REGION");
                regione = data.regione;
                _context4.next = 23;
                return _vue.setRegion(regione);

              case 23:
                _vue.$log("SET REGION SUCCESS");

                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                  var province;
                  return regenerator_default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _vue.$log("SET PROVINCE");
                          province = data.provincia;
                          _context3.next = 4;
                          return _vue.setProvince(province);

                        case 4:
                          _vue.$log("SET PROVINCE SUCCESS");

                          setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                            var city;
                            return regenerator_default.a.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _vue.$log("SET CITY");
                                    city = data.comune;
                                    _context2.next = 4;
                                    return _vue.setCity(city);

                                  case 4:
                                    _vue.$log("SET CITY SUCCESS");

                                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                      var cap;
                                      return regenerator_default.a.wrap(function _callee$(_context) {
                                        while (1) {
                                          switch (_context.prev = _context.next) {
                                            case 0:
                                              _vue.$log("SET CAP");
                                              cap = data.cap;
                                              _context.next = 4;
                                              return _vue.setCap(cap);

                                            case 4:
                                              _vue.$log("SET CAP SUCCESS");

                                            case 5:
                                            case "end":
                                              return _context.stop();
                                          }
                                        }
                                      }, _callee, this);
                                    })), 1000);

                                  case 6:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, this);
                          })), 1000);

                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                })), 1000);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }))();
    },
    setCap: function setCap(cap) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (x in _this3.zips) {
                  if (_this3.zips[x].cap == cap.toUpperCase()) {
                    _this3.zip = _this3.zips[x].cap;
                  }
                }
                _this3.$log(_this3.province);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    setCity: function setCity(city) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var x, k;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (x in _this4.cities) {
                  if (_this4.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this4.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this4.city = k;
                  }
                }
                _this4.$log(_this4.city);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this5.provincies) {
                  _this5.$log("START");
                  _this5.$log(_this5.provincies[x].sigla + " =?= " + province.toUpperCase());
                  if (_this5.provincies[x].sigla == province.toUpperCase()) {
                    _this5.province = _this5.provincies[x].sigla;
                  }
                }
                _this5.$log(_this5.province);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    },
    setRegion: function setRegion(regione) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this6.regions) {
                  if (_this6.regions[x].regione == regione.toUpperCase()) {
                    k = {
                      text: regione.toUpperCase(),
                      id: _this6.regions[x].id_regione
                    };

                    _this6.region = k;
                  }
                }
                _this6.$log(_this6.region);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this6);
      }))();
    },
    addClientSuccess: function addClientSuccess() {
      this.$swal({
        type: "success",
        title: '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    populateRegions: function populateRegions() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getRegions",
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this7.regions = resp.data.regions;
                  _this7.regionsState = false;

                  _this7.ship_regions = resp.data.regions;
                  _this7.ship_regionsState = false;
                }).catch(function (resp) {
                  _this7.regions = [];
                  _this7.regionsState = false;

                  _this7.ship_regions = [];
                  _this7.ship_regionsState = false;
                });

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this7);
      }))();
    },


    checkRegion: function checkRegion() {
      var region = this.region;

      if (region) {
        this.provinceError = false;
      } else {
        this.provinceError = true;
      }
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    ship_checkRegion: function ship_checkRegion() {
      var ship_region = this.ship_region;

      if (ship_region) {
        this.ship_provinceError = false;
      } else {
        this.ship_provinceError = true;
      }
    },
    ship_checkProvince: function ship_checkProvince() {
      var ship_province = this.ship_province;

      if (ship_province) {
        this.ship_cityError = false;
      } else {
        this.ship_cityError = true;
      }
    },
    ship_checkZip: function ship_checkZip() {
      var ship_city = this.ship_city;

      if (ship_city) {
        this.ship_zipError = false;
      } else {
        this.ship_zipError = true;
      }
    },

    calcToDate: function calcToDate() {
      var start = Object({"year":2021,"month":2,"day":15});
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = date;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var stopObj = Object({"year":2030,"month":12,"day":15});
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },


    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    }
  },
  watch: {
    iban: function iban(value) {
      if (value) {
        this.iban = value.toUpperCase().trim();
        this.iban = this.iban.replace(" ", "");
      }
    },
    azienda: function azienda(value) {
      this.azienda = value.toUpperCase();
    },
    name: function name(value) {
      this.name = value.toUpperCase();
    },
    lastname: function lastname(value) {
      this.lastname = value.toUpperCase();
    },
    ship_name: function ship_name(value) {
      this.ship_name = value.toUpperCase();
    },
    ship_lastname: function ship_lastname(value) {
      this.ship_lastname = value.toUpperCase();
    },
    number: function number(value) {
      this.number = parseInt(value);
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    id_eps: function id_eps(val) {
      if (val) {
        //this.id_eps = val.replace(/\D+/g, '');
      }
    },
    cellulare: function cellulare(val) {
      if (val) {
        this.cellulare = val.replace(/\D+/g, "");
      }
    },
    ship_phone: function ship_phone(val) {
      if (val) {
        this.ship_phone = val.replace(/\D+/g, "");
      }
    },
    ship_cellulare: function ship_cellulare(val) {
      if (val) {
        this.ship_cellulare = val.replace(/\D+/g, "");
      }
    },
    region: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(newVal) {
        var _this8 = this;

        var provincies, provinciesState;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.zips = [];
                this.cities = [];
                this.zip = "";
                this.city = "";
                this.cityError = false;
                this.provinceError = false;
                this.zipError = false;
                this.province = "";
                this.provincies = [];
                this.provinciesState = true;

                provincies = this.provincies, provinciesState = this.provinciesState;
                _context10.next = 13;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvincies",
                  method: "POST",
                  data: {
                    region: newVal.id
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this8.provincies = resp.data.provincies;
                  _this8.provinciesState = false;
                }).catch(function (resp) {
                  _this8.provincies = [];
                  _this8.provinciesState = false;
                });

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function region(_x) {
        return _ref4.apply(this, arguments);
      }

      return region;
    }(),
    ship_region: function ship_region(newVal) {
      var _this9 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_provinceError = false;
      this.ship_zipError = false;
      this.ship_province = "";
      this.ship_provincies = [];
      this.ship_provinciesState = true;

      var ship_provincies = this.ship_provincies,
          ship_provinciesState = this.ship_provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvincies",
        method: "POST",
        data: {
          region: newVal.id
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this9.ship_provincies = resp.data.provincies;
        _this9.ship_provinciesState = false;
      }).catch(function (resp) {
        _this9.ship_provincies = [];
        _this9.ship_provinciesState = false;
      });
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this10 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.cities = resp.data.cities;
          _this10.citiesState = false;
        }).catch(function (resp) {
          _this10.cities = [];
          _this10.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_province: function ship_province(newProvince) {
      var _this11 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_zipError = false;

      if (newProvince) {
        this.ship_citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.ship_cities = resp.data.cities;
          _this11.ship_citiesState = false;
        }).catch(function (resp) {
          _this11.ship_cities = [];
          _this11.ship_citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this12 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this12.zips = resp.data.zips;
          _this12.zipsState = false;
        }).catch(function (resp) {
          _this12.zips = [];
          _this12.zipsState = false;
        });
      }
    },
    getProfile: function getProfile() {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this13.checkIfExistUser();

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_city: function ship_city(newCity) {
      var _this14 = this;

      this.ship_zipError = false;
      this.ship_zips = [];
      this.ship_zip = "";

      if (newCity.cityistat) {
        this.ship_zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this14.ship_zips = resp.data.zips;
          _this14.ship_zipsState = false;
        }).catch(function (resp) {
          _this14.ship_zips = [];
          _this14.ship_zipsState = false;
        });
      }
    },
    vw: function vw() {}
  },
  updated: function updated() {},
  created: function created() {
    this.$validator.extend("notZeros", {
      getMessage: function getMessage(field) {
        return " Il campo Numero di telefono non ha un formato valido.";
      },
      validate: function validate(value) {
        // value must be > zero
        if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
        return false;
      }
    });
  },
  mounted: function mounted() {
    var _this15 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      var _vue;

      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _vue = _this15;

              window.addEventListener("resize", _this15.handleResize);
              _this15.handleResize();
              _context12.next = 5;
              return _this15.populateRegions();

            case 5:
              _this15.lastnamex = _this15.getProfile.cognome;

              _this15.xuserx = _this15.getProfile.name;

              if (!_this15.getProfile) {
                _context12.next = 10;
                break;
              }

              _context12.next = 10;
              return _this15.checkIfExistUser();

            case 10:

              setTimeout(function () {
                _vue.disabledDates = {
                  to: _vue.calcToDate(), // Disable all dates up to specific date
                  from: _vue.calcFromDate() // Disable all dates after specific date
                };

                _vue.scrollFinished = true;
              }, 1500);

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this15);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89f7b05a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/emicon.vue
var account_emicon_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5 mb-5" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-12 center mt-5" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("h5", { staticClass: "black" }, [
              _vm._v(
                "\n          Tutti i campi sono obbligatori e puoi modificare le celle di colore\n          bianco.\n        "
              )
            ]),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c("p", { staticClass: "black" }, [
                  _vm._v(
                    "\n          In caso di variazione di email, partita iva o codice fiscale\n          contatta il assistenza\n        "
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm.proccess == "START"
            ? _c(
                "form",
                {
                  staticClass: "pb-5 black vaillantCont widthFull",
                  attrs: { id: "registration-form" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row mb-4 justify-content-center" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-5 col-md-3 mb-3 pl-md-5 pr-md-5" },
                        [
                          _vm.logo
                            ? _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: _vm.logo }
                              })
                            : _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src: __webpack_require__("YSGn")
                                }
                              })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.azienda,
                              expression: "azienda"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 128, min: 3 },
                              expression: "{ required: true, max: 128, min: 3 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("azienda"),
                            valid: !!_vm.azienda
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "azienda",
                            id: "azienda",
                            name: "azienda",
                            "data-vv-as": "Ragione sociale"
                          },
                          domProps: { value: _vm.azienda },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.azienda = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "azienda" }
                          },
                          [_vm._v("Ragione sociale *\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("azienda")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("azienda")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.partita_iva,
                              expression: "partita_iva"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !_vm.codice_fiscale,
                                partitaIva: true,
                                max: 11,
                                min: 11
                              },
                              expression:
                                "{\n                  required: !codice_fiscale,\n                  partitaIva: true,\n                  max: 11,\n                  min: 11,\n                }"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("partita_iva"),
                            valid: !!_vm.partita_iva
                          },
                          attrs: {
                            type: "text",
                            disabled: "",
                            autocomplete: "partina-iva",
                            id: "partita_iva",
                            name: "partita_iva",
                            "data-vv-as": "Partita IVA"
                          },
                          domProps: { value: _vm.partita_iva },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.partita_iva = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "partita_iva" }
                          },
                          [_vm._v("Partita IVA *")]
                        ),
                        _vm._v(" "),
                        _vm.existPIVA
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Partita IVA inserita già presente.")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("partita_iva")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("partita_iva")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.codice_fiscale,
                              expression: "codice_fiscale"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !_vm.partita_iva,
                                codiceFiscale: true,
                                max: 16,
                                min: 16
                              },
                              expression:
                                "{\n                  required: !partita_iva,\n                  codiceFiscale: true,\n                  max: 16,\n                  min: 16,\n                }"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("codice_fiscale"),
                            valid: !!_vm.codice_fiscale
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "codice-fiscale",
                            id: "codice_fiscale",
                            disabled: "",
                            name: "codice_fiscale",
                            "data-vv-as": "Codice Fiscale"
                          },
                          domProps: { value: _vm.codice_fiscale },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.codice_fiscale = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "codice_fiscale" }
                          },
                          [_vm._v("o Codice Fiscale *")]
                        ),
                        _vm._v(" "),
                        _vm.existCF
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "Codice Fiscale inserito già presente."
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("codice_fiscale")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("codice_fiscale")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.id_eps,
                              expression: "id_eps"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {},
                              expression: "{}"
                            }
                          ],
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid": _vm.errors.has("id_eps"),
                            valid: !!_vm.id_eps
                          },
                          attrs: {
                            type: "text",
                            disabled: "",
                            id: "id_eps",
                            name: "id_eps",
                            "data-vv-as": "Tipo Azienda"
                          },
                          domProps: { value: _vm.id_eps },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.id_eps = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "id_eps" }
                          },
                          [_vm._v("Tipo Azienda ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("id_eps")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("id_eps")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.id_eps == "Ditta Individuale" ||
                    _vm.id_eps == "Professionista iscritto ad albi"
                      ? _c("div", { staticClass: "col-md-4 mb-3" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reg_forfettario,
                                    expression: "reg_forfettario"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{ required: true }"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(
                                    "reg_forfettario"
                                  ),
                                  valid: !!_vm.reg_forfettario,
                                  disabled:
                                    _vm.getProfile.reg_forfettario != "0"
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "reg_forfettario",
                                  disabled:
                                    _vm.getProfile.reg_forfettario != "0",
                                  name: "reg_forfettario",
                                  "data-vv-as": "Regime Forfettario"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.reg_forfettario = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { key: 911, attrs: { value: "si" } },
                                  [_vm._v("si")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "option",
                                  { key: 912, attrs: { value: "no" } },
                                  [_vm._v("no")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "region" }
                              },
                              [_vm._v("Regime Forfettario *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("reg_forfettario")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.errors.first("reg_forfettario")
                                      ) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.name,
                              expression: "name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 55, min: 2 },
                              expression: "{ required: true, max: 55, min: 2 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("name"),
                            valid: !!_vm.name
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "name",
                            id: "name",
                            name: "name",
                            "data-vv-as": "Nome"
                          },
                          domProps: { value: _vm.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "name" }
                          },
                          [_vm._v("Nome *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("name")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("name")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.lastname,
                              expression: "lastname"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 55, min: 2 },
                              expression: "{ required: true, max: 55, min: 2 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("lastname"),
                            valid: !!_vm.lastname
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "lastname",
                            id: "lastname",
                            name: "lastname",
                            "data-vv-as": "Cognome"
                          },
                          domProps: { value: _vm.lastname },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastname = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "lastname" }
                          },
                          [_vm._v("Cognome *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("lastname")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("lastname")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-4" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                email: true,
                                temporaryEmail: true,
                                plusIssueEmail: true,
                                max: 56
                              },
                              expression:
                                "{\n                  required: true,\n                  email: true,\n                  temporaryEmail: true,\n                  plusIssueEmail: true,\n                  max: 56,\n                }"
                            }
                          ],
                          ref: "email",
                          staticClass: "form-control disabled",
                          class: {
                            "is-invalid":
                              _vm.errors.has("email") || _vm.existEmail,
                            valid: !!_vm.email
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "email",
                            disabled: "",
                            id: "email",
                            name: "email",
                            "data-vv-as": "Email"
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "email" }
                          },
                          [_vm._v("Email * ")]
                        ),
                        _vm._v(" "),
                        _vm.existEmail
                          ? _c(
                              "div",
                              {
                                staticClass: "invalid-feedback",
                                staticStyle: { display: "block" }
                              },
                              [
                                _c("span", [
                                  _vm._v("Email digitato già presente")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("email")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("email")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.phone,
                              expression: "phone"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                max: 12,
                                min: 8,
                                notZeros: true,
                                regex: /^[0,3]+/
                              },
                              expression:
                                "{\n                  required: true,\n                  max: 12,\n                  min: 8,\n                  notZeros: true,\n                  regex: /^[0,3]+/,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("phone"),
                            valid: !!_vm.phone
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "telefono",
                            id: "phone",
                            name: "phone",
                            "data-vv-as": "Telefono"
                          },
                          domProps: { value: _vm.phone },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.phone = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "phone" }
                          },
                          [_vm._v("Telefono * ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("phone")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("phone")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cellulare,
                              expression: "cellulare"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: true,
                                max: 12,
                                min: 8,
                                notZeros: true,
                                regex: /^[0,3]+/
                              },
                              expression:
                                "{\n                  required: true,\n                  max: 12,\n                  min: 8,\n                  notZeros: true,\n                  regex: /^[0,3]+/,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("cellulare"),
                            valid: !!_vm.cellulare
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "cellulare",
                            id: "cellulare",
                            name: "cellulare",
                            "data-vv-as": "Cellulare"
                          },
                          domProps: { value: _vm.cellulare },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.cellulare = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "cellulare" }
                          },
                          [_vm._v("Cellulare *\n              ")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("cellulare")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("cellulare")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.address,
                              expression: "address"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 128, min: 5 },
                              expression: "{ required: true, max: 128, min: 5 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("address"),
                            valid: !!_vm.address
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "indirizzo",
                            id: "address",
                            name: "address",
                            "data-vv-as": "Indirizzo"
                          },
                          domProps: { value: _vm.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.address = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "address" }
                          },
                          [_vm._v("Indirizzo *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("address")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("address")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.civic,
                              expression: "civic"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true, max: 15 },
                              expression: "{ required: true, max: 15 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("civic"),
                            valid: !!_vm.civic
                          },
                          attrs: {
                            type: "text",
                            autocomplete: "civico",
                            id: "civic",
                            name: "civic",
                            "data-vv-as": "Civico"
                          },
                          domProps: { value: _vm.civic },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.civic = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "civic" }
                          },
                          [_vm._v("Civico *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("civic")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("civic")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.region,
                                expression: "region"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("region"),
                              valid: !!_vm.region
                            },
                            attrs: {
                              autocomplete: "region-new",
                              id: "region",
                              name: "region",
                              "data-vv-as": "Regione"
                            },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.region = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.regions, function(region) {
                            return _c(
                              "option",
                              {
                                key: region.id_regione,
                                domProps: {
                                  value: {
                                    id: region.id_regione,
                                    text: region.regione
                                  },
                                  selected:
                                    region.id_regione == _vm.shipData.region
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(region.regione) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "region" }
                          },
                          [_vm._v("Regione *")]
                        ),
                        _vm._v(" "),
                        _vm.regionsState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadregion",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("region")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("region")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.province,
                                expression: "province"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("province"),
                              valid: !!_vm.province
                            },
                            attrs: {
                              autocomplete: "randomy",
                              id: "province",
                              name: "province",
                              "data-vv-as": "Provincia"
                            },
                            on: {
                              click: _vm.checkRegion,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.province = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.provincies, function(province) {
                            return _c(
                              "option",
                              {
                                key: province.sigla,
                                domProps: {
                                  value: province.sigla,
                                  selected:
                                    province.sigla == _vm.shipData.province
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(province.sigla) +
                                    " - " +
                                    _vm._s(province.provincia) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "province" }
                          },
                          [
                            _vm._v("Provincia *"),
                            _vm.provinceError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Regione")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.provinciesState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadProvince",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("province")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("province")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.city,
                                expression: "city"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("city"),
                              valid: !!_vm.city
                            },
                            attrs: {
                              autocomplete: "randomu",
                              id: "city",
                              name: "city",
                              "data-vv-as": "Località",
                              disabled: _vm.citiesState
                            },
                            on: {
                              click: _vm.checkProvince,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.city = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.cities, function(city) {
                            return _c(
                              "option",
                              {
                                key: city.comune,
                                domProps: {
                                  value: {
                                    cityistat: city.istat,
                                    city: city.comune
                                  },
                                  selected: city.comune == _vm.shipData.city
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(city.comune) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "city" }
                          },
                          [
                            _vm._v("Località *"),
                            _vm.cityError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Provincia")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.citiesState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadCity",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("city")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("city")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.zip,
                                expression: "zip"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{ required: true }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("zip"),
                              valid: !!_vm.zip
                            },
                            attrs: {
                              autocomplete: "zip",
                              id: "zip",
                              name: "zip",
                              "data-vv-as": "Cap",
                              disabled: _vm.zipsState
                            },
                            on: {
                              click: _vm.checkZip,
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.zip = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.zips, function(zip) {
                            return _c(
                              "option",
                              {
                                key: zip.cap,
                                domProps: {
                                  value: zip.cap,
                                  selected: zip.cap == _vm.shipData.zip
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(zip.cap) +
                                    "\n                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "zip" }
                          },
                          [
                            _vm._v("Cap *"),
                            _vm.zipError
                              ? _c("span", { staticClass: "formError" }, [
                                  _vm._v("Prima scegli Località")
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.zipsState
                          ? _c(
                              "div",
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "loadSpinner",
                                  attrs: {
                                    id: "loadZips",
                                    icon: "spinner",
                                    size: "1x",
                                    pulse: ""
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors.has("zip")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("zip")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { passwordCheck: true, min: 8, max: 56 },
                              expression:
                                "{ passwordCheck: true, min: 8, max: 56 }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("password"),
                            valid: !!_vm.password
                          },
                          attrs: {
                            type: "password",
                            autocomplete: "new-password",
                            id: "password",
                            name: "password",
                            "data-vv-as": "Password"
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "password" }
                          },
                          [_vm._v("Scegli nuova password *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("password")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("password")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3" }, [
                      _c("div", { staticClass: "group custInput" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.confirm_password,
                              expression: "confirm_password"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                required: !!_vm.password,
                                passwordCheck: true,
                                min: 8,
                                max: 56,
                                confirmed: _vm.password
                              },
                              expression:
                                "{\n                  required: !!password,\n                  passwordCheck: true,\n                  min: 8,\n                  max: 56,\n                  confirmed: password,\n                }"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("confirm_password"),
                            valid: !!_vm.confirm_password
                          },
                          attrs: {
                            type: "password",
                            autocomplete: "confirm-new-password",
                            id: "confirm_password",
                            name: "confirm_password",
                            "data-vv-as": "Conferma Password"
                          },
                          domProps: { value: _vm.confirm_password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.confirm_password = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "highlight" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "niceInputLabel",
                            attrs: { for: "confirm_password" }
                          },
                          [_vm._v("Conferma nuova password *")]
                        ),
                        _vm._v(" "),
                        _vm.errors.has("confirm_password")
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errors.first("confirm_password")) +
                                  "\n              "
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "row justify-content-center divider"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12 center mb-0 pt-4 mb-1" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.editUser("normal")
                              }
                            }
                          },
                          [_vm._v("\n              Salva\n            ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var account_emicon_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "Bold" }, [_c("b", [_vm._v("ANAGRAFICA")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "text-center pt-4" }, [
        _vm._v("Logo della tua azienda")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h5", { staticClass: "black center" }, [_vm._v("Modifica Password")])
    ])
  }
]
account_emicon_render._withStripped = true
var account_emicon_esExports = { render: account_emicon_render, staticRenderFns: account_emicon_staticRenderFns }
/* harmony default export */ var components_account_emicon = (account_emicon_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89f7b05a", account_emicon_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/account/emicon.vue
var account_emicon_disposed = false
function emicon_injectStyle (ssrContext) {
  if (account_emicon_disposed) return
  __webpack_require__("j4gP")
  __webpack_require__("R0yp")
}
var account_emicon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var account_emicon___vue_template_functional__ = false
/* styles */
var account_emicon___vue_styles__ = emicon_injectStyle
/* scopeId */
var account_emicon___vue_scopeId__ = "data-v-89f7b05a"
/* moduleIdentifier (server only) */
var account_emicon___vue_module_identifier__ = null
var account_emicon_Component = account_emicon_normalizeComponent(
  account_emicon,
  components_account_emicon,
  account_emicon___vue_template_functional__,
  account_emicon___vue_styles__,
  account_emicon___vue_scopeId__,
  account_emicon___vue_module_identifier__
)
account_emicon_Component.options.__file = "src/components/account/emicon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-89f7b05a", account_emicon_Component.options)
  } else {
    hotAPI.reload("data-v-89f7b05a", account_emicon_Component.options)
  }
  module.hot.dispose(function (data) {
    account_emicon_disposed = true
  })
})()}

/* harmony default export */ var src_components_account_emicon = (account_emicon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/account/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var account_moment = __webpack_require__("PJh5");

/* harmony default export */ var account = ({
  name: "play",
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a,
    Emicon: src_components_account_emicon,
    Hoval: src_components_account_hoval
  },
  data: function data() {
    return {
      loadingState: false,
      proccess: "START",
      userToken: "",
      partita_iva: "",
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: "",
      tempCF: "",
      tempEmail: "",
      corporateClient: "",
      azienda: "",
      name: "",
      lastname: "",
      email: "",
      phone: "",
      cellulare: "",
      codice_fiscale: "",
      shipEqual: true,
      shipData: {},
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: "",
      ibanNome: "",
      ibanCognome: "",
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: "",
      confirm_password: "",
      ship_name: "",
      ship_lastname: "",
      near: "",
      ship_phone: "",
      ship_cellulare: "",
      ship_address: "",
      ship_civic: "",
      ship_region: "",
      ship_province: "",
      ship_city: "",
      ship_zip: "",
      note: "",
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      invoiceRear: "",
      invoiceRearName: "",
      invoiceRearBucket: "",
      uploadRearPercentage: 0,
      id_eps: "",
      precompiled_iva: "",
      vw: window.innerWidth,
      logo: "",
      reg_forfettario: ""
    };
  },

  methods: {
    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
    }
  },
  watch: {
    getProfile: function getProfile() {
      this.setProfile();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$log(_this.$route);
              _this.setProfile();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcfb22e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/index.vue
var account_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.corporateClient == "hoval"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [_vm.loadingState ? _c("loading") : _vm._e(), _vm._v(" "), _c("Hoval")],
        1
      )
    : _vm.corporateClient == "emicon"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("Emicon")
        ],
        1
      )
    : _vm._e()
}
var account_staticRenderFns = []
account_render._withStripped = true
var account_esExports = { render: account_render, staticRenderFns: account_staticRenderFns }
/* harmony default export */ var components_account = (account_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcfb22e0", account_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/account/index.vue
var account_disposed = false
function account_injectStyle (ssrContext) {
  if (account_disposed) return
  __webpack_require__("pNxK")
  __webpack_require__("98bG")
}
var account_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var account___vue_template_functional__ = false
/* styles */
var account___vue_styles__ = account_injectStyle
/* scopeId */
var account___vue_scopeId__ = "data-v-bcfb22e0"
/* moduleIdentifier (server only) */
var account___vue_module_identifier__ = null
var account_Component = account_normalizeComponent(
  account,
  components_account,
  account___vue_template_functional__,
  account___vue_styles__,
  account___vue_scopeId__,
  account___vue_module_identifier__
)
account_Component.options.__file = "src/components/account/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bcfb22e0", account_Component.options)
  } else {
    hotAPI.reload("data-v-bcfb22e0", account_Component.options)
  }
  module.hot.dispose(function (data) {
    account_disposed = true
  })
})()}

/* harmony default export */ var src_components_account = (account_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addClient/index.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var addClient_moment = __webpack_require__("PJh5");

/* harmony default export */ var addClient = ({
  name: "play",
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */],
    VueTimepicker: vue2_timepicker_default.a
  },
  data: function data() {
    return {
      loadingState: false,
      proccess: "START",
      codRif: "",
      userToken: "",
      partita_iva: "",
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: "",
      tempCF: "",
      tempEmail: "",
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      azienda: "",
      name: "",
      lastname: "",
      email: "",
      phone: "",
      cellulare: "",
      codice_fiscale: "",
      shipEqual: true,
      shipData: {},
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: "",
      ibanNome: "",
      ibanCognome: "",
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: "",
      confirm_password: "",
      ship_name: "",
      ship_lastname: "",
      near: "",
      ship_phone: "",
      ship_cellulare: "",
      ship_address: "",
      ship_civic: "",
      ship_region: "",
      ship_province: "",
      ship_city: "",
      ship_zip: "",
      note: "",
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      invoiceRear: "",
      invoiceRearName: "",
      invoiceRearBucket: "",
      uploadRearPercentage: 0,
      id_eps: "",
      precompiled_iva: "",
      vw: window.innerWidth,
      emailPEC: "",
      sdiCode: "",
      formed: false,
      privacy: "",
      privacy1: "",
      privacy2: "",
      privacy3: "",
      privacy4: "",
      tipo_azienda: "",
      reg_forfettario: "",
      reg_role: "Installatore",
      hasPoste: false,
      reg_roleSel: false,
      registration1: true,
      codeIsOk: false,
      corporateClient: "",
      accordoQuadro: "https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf"
    };
  },

  methods: {
    registration: function registration() {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;

          if (_this.tipo_azienda != "Ditta Individuale" && _this.tipo_azienda != "Professionista iscritto ad albi") {
            _this.reg_forfettario = "no";
          }

          var data = {
            user: {
              name: _this.name,
              cognome: _this.lastname,
              email: _this.email,
              password: _this.password,
              azienda: _this.azienda,
              id_eps: _this.id_eps,
              partita_iva: _this.partita_iva,
              codice_fiscale: _this.codice_fiscale,
              indirizzo: _this.address,
              civico: _this.civic,
              comune: _this.city.city,
              provincia: _this.province,
              regione: _this.region.text,
              cap: _this.zip,
              telefono: _this.phone,
              cellulare: _this.cellulare,
              privacy: _this.privacy,
              privacy1: _this.privacy1,
              privacy2: _this.privacy2 ? _this.privacy2 : 0,
              privacy3: _this.privacy3 ? _this.privacy3 : 0,
              //privacy4: this.privacy4,
              corporateClient: _this.corporateClient,
              ship_presso: _this.near,
              ship_note: _this.note,
              ship_name: _this.shipEqual ? _this.name : _this.ship_name,
              ship_cognome: _this.shipEqual ? _this.lastname : _this.ship_lastname,
              ship_indirizzo: _this.shipEqual ? _this.address : _this.ship_address,
              ship_civico: _this.shipEqual ? _this.civic : _this.ship_civic,
              ship_comune: _this.shipEqual ? _this.city.city : _this.ship_city.city,
              ship_provincia: _this.shipEqual ? _this.province : _this.ship_province,
              ship_regione: _this.shipEqual ? _this.region.text : _this.ship_region.text,
              ship_cap: _this.shipEqual ? _this.zip : _this.ship_zip,
              ship_telefono: _this.shipEqual ? _this.phone : _this.ship_phone,
              ship_cellulare: _this.shipEqual ? _this.cellulare : _this.ship_cellulare,
              emailPEC: _this.emailPEC,
              sdiCode: _this.sdiCode,
              logo: _this.saveDb,
              tipo_azienda: _this.tipo_azienda,
              formed: _this.formed,
              reg_forfettario: _this.reg_forfettario,
              reg_role: _this.reg_role,

              type: _this.precompiled_iva == _this.partita_iva ? "old" : "new",
              confirmed: 0,

              iban: _this.iban,
              intestatario: _this.ibanNome
            },
            regType: _this.precompiled_iva == _this.partita_iva ? "old" : "new"
          };
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/newUser",
            method: "POST",
            data: {
              data: data
            },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.$scrollTo("#app", 700, {
              offset: -75
            });
            resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            //this.addClientSuccess()
            //this.$router.push('/')
            _this.proccess = "REG_SUCCESS";
            _this.loadingState = false;
          }).catch(function (error) {
            _this.loadingState = false;
            error.response.data = _this.$decryptByAES(error.response.data, "B%t$AD!YMfnCZnfD");
            var text = error.response.data.error;
            _this.addClientError(text);
          });
        }
      });
    },
    registrationCod: function registrationCod() {
      var _this2 = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this2.loadingState = true;

          var data = {
            code: _this2.codRif
          };
          data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/verifyCod",
            method: "POST",
            data: {
              data: data
            },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
            if (resp.data) _this2.showSuccesCode();else _this2.showErrorCode();
            _this2.$warn(resp.data);
            _this2.corporateClient = resp.data.corporateClient;
            _this2.loadingState = false;
          }).catch(function (error) {
            _this2.loadingState = false;
            _this2.showErrorCode();
            error.response.data = _this2.$decryptByAES(error.response.data, "B%t$AD!YMfnCZnfD");
            var text = error.response.data.error;
            _this2.addClientError(text);
          });
        }
      });
    },

    checkIfExistUser: function checkIfExistUser(value) {
      var _this3 = this;

      var newValue = value.target.value;
      var field = this.$validator.fields.find({
        name: "partita_iva"
      });
      var typeCall;
      var tempVal;
      if (value.target.id == "partita_iva") {
        typeCall = "partita_iva";
        tempVal = this.tempIva;
      }
      if (value.target.id == "codice_fiscale") {
        typeCall = "codice_fiscale";
        tempVal = this.tempCF;
      }
      if (value.target.id == "email") {
        typeCall = "email";
        tempVal = this.tempEmail;
      }

      if (!this.errors.has(value.target.id) && tempVal != newValue && newValue) {
        if (typeCall == "partita_iva") {
          this.tempIva = newValue;
        }
        if (typeCall == "codice_fiscale") {
          this.tempCF = newValue;
        }
        if (typeCall == "email") {
          this.tempEmail = newValue;
        }

        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/checkExUser",
          method: "POST",
          data: {
            value: newValue,
            typeCall: typeCall
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(resp) {
            var data, _vue, regione;

            return regenerator_default.a.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (typeCall == "partita_iva") {
                      _this3.existPIVA = false;
                    }
                    if (typeCall == "codice_fiscale") {
                      _this3.existCF = false;
                    }
                    if (typeCall == "email") {
                      _this3.existEmail = false;
                    }

                    if (!(resp.data.status == "precompile")) {
                      _context4.next = 25;
                      break;
                    }

                    data = resp.data.data;

                    _this3.$log(data);
                    if (typeCall == "partita_iva") {
                      _this3.codice_fiscale = data.codice_fiscale;
                    }
                    if (typeCall == "codice_fiscale") {
                      _this3.partita_iva = data.partita_iva;
                    }

                    if (data.formed == 1) {
                      _this3.formed = true;
                    } else {
                      _this3.formed = false;
                    }

                    _this3.precompiled_iva = data.partita_iva;

                    _this3.email = data.email;
                    _this3.azienda = data.azienda;
                    _this3.address = data.indirizzo;
                    _this3.civic = data.indirizzo_num;
                    _this3.civic = data.indirizzo_num;
                    //this.city.city = data.Comune
                    //this.province = data.Provincia
                    //this.region.text = data.Regione
                    //this.zip = data.CAP
                    _this3.phone = data.telefono;
                    _this3.cellulare = data.telefono_mobile;
                    _this3.id_eps = data.id_eps;

                    _vue = _this3;


                    _this3.$log("SET REGION");
                    regione = data.Regione;
                    _context4.next = 23;
                    return _vue.setRegion(regione);

                  case 23:
                    _this3.$log("SET REGION SUCCESS");

                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                      var province;
                      return regenerator_default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              this.$log("SET PROVINCE");
                              province = data.Provincia;
                              _context3.next = 4;
                              return _vue.setProvince(province);

                            case 4:
                              this.$log("SET PROVINCE SUCCESS");

                              setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                var city;
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        this.$log("SET CITY");
                                        city = data.Comune;
                                        _context2.next = 4;
                                        return _vue.setCity(city);

                                      case 4:
                                        this.$log("SET CITY SUCCESS");

                                        setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                          var cap;
                                          return regenerator_default.a.wrap(function _callee$(_context) {
                                            while (1) {
                                              switch (_context.prev = _context.next) {
                                                case 0:
                                                  this.$log("SET CAP");
                                                  cap = data.CAP;
                                                  _context.next = 4;
                                                  return _vue.setCap(cap);

                                                case 4:
                                                  this.$log("SET CAP SUCCESS");

                                                case 5:
                                                case "end":
                                                  return _context.stop();
                                              }
                                            }
                                          }, _callee, this);
                                        })), 1000);

                                      case 6:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, this);
                              })), 1000);

                            case 6:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, this);
                    })), 1000);

                  case 25:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, _this3);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (error) {
          if (typeCall == "partita_iva") {
            _this3.existPIVA = true;
          }
          if (typeCall == "codice_fiscale") {
            _this3.existCF = true;
          }
          if (typeCall == "email") {
            _this3.existEmail = true;
          }
        });
      }
    },
    setCap: function setCap(cap) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (x in _this4.zips) {
                  _this4.$log("START");
                  _this4.$log(_this4.zips[x].cap + " =?= " + cap.toUpperCase());
                  if (_this4.zips[x].cap == cap.toUpperCase()) {
                    _this4.zip = _this4.zips[x].cap;
                  }
                }
                _this4.$log(_this4.province);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    },
    setCity: function setCity(city) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var x, k;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (x in _this5.cities) {
                  if (_this5.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this5.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this5.city = k;
                  }
                }
                _this5.$log(_this5.city);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this6.provincies) {
                  _this6.$log("START");
                  _this6.$log(_this6.provincies[x].sigla + " =?= " + province.toUpperCase());
                  if (_this6.provincies[x].sigla == province.toUpperCase()) {
                    _this6.province = _this6.provincies[x].sigla;
                  }
                }
                _this6.$log(_this6.province);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    setRegion: function setRegion(regione) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this7.regions) {
                  if (_this7.regions[x].regione == regione.toUpperCase()) {
                    k = {
                      text: regione.toUpperCase(),
                      id: _this7.regions[x].id_regione
                    };

                    _this7.region = k;
                  }
                }
                _this7.$log(_this7.region);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;
      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.target.files[0]);
        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadImageInvoice", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
            _vue.saveDb = e.data.fatturaNoCrypt;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.saveDb = "";
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = "";
          _vue.invoiceFrontBucket = "";
          _vue.saveDb = "";
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },

    uploadFileRear: function uploadFileRear(input) {
      var file = input.target.files[0].name;

      this.invoiceRearName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceRear = input.target.files[0].name;

        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.target.files[0]);

        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadImageInvoice", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadRearPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadRearPercentage = 0;
            _vue.invoiceRearBucket = e.data.fattura;
          } else {
            _vue.uploadRearPercentage = 0;
            _vue.invoiceRear = "";
            _vue.invoiceRearBucket = "";
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadRearPercentage = 0;
          _vue.invoiceRear = "";
          _vue.invoiceRearBucket = "";
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },

    showSuccesCode: function showSuccesCode() {
      var _this8 = this;

      this.$swal({
        type: "success",
        title: '<strong class="modalText ">Il codice Inserito è corretto</strong>',
        html: "",
        confirmButtonText: "PROSEGUI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this8.codeIsOk = true;
        }
      });
    },
    showErrorCode: function showErrorCode() {
      var _this9 = this;

      this.$swal({
        type: "error",
        title: '<strong class="modalText ">Il codice Inserito è errato</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267",
        onClose: function onClose() {
          _this9.codeIsOk = false;
        }
      });
    },
    addClientSuccess: function addClientSuccess() {
      this.$swal({
        type: "success",
        title: '<strong class="modalText ">Registrazione andata a buon fine.</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    addClientError: function addClientError(text) {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Registrazione non andato a buon fine.</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },
    UploadError: function UploadError() {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267"
      });
    },


    populateRegions: function populateRegions() {
      var _this10 = this;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getRegions",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this10.regions = resp.data.regions;
        _this10.regionsState = false;

        _this10.ship_regions = resp.data.regions;
        _this10.ship_regionsState = false;
      }).catch(function (resp) {
        _this10.regions = [];
        _this10.regionsState = false;

        _this10.ship_regions = [];
        _this10.ship_regionsState = false;
      });
    },

    checkRegion: function checkRegion() {
      var region = this.region;

      if (region) {
        this.provinceError = false;
      } else {
        this.provinceError = true;
      }
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    ship_checkRegion: function ship_checkRegion() {
      var ship_region = this.ship_region;

      if (ship_region) {
        this.ship_provinceError = false;
      } else {
        this.ship_provinceError = true;
      }
    },
    ship_checkProvince: function ship_checkProvince() {
      var ship_province = this.ship_province;

      if (ship_province) {
        this.ship_cityError = false;
      } else {
        this.ship_cityError = true;
      }
    },
    ship_checkZip: function ship_checkZip() {
      var ship_city = this.ship_city;

      if (ship_city) {
        this.ship_zipError = false;
      } else {
        this.ship_zipError = true;
      }
    },

    calcToDate: function calcToDate() {
      var start = Object({"year":2021,"month":2,"day":15});
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = date;
      }
      return finalTo;
    },
    calcFromDate: function calcFromDate() {
      var stopObj = Object({"year":2030,"month":12,"day":15});
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },


    handleResize: function handleResize() {
      this.vw = window.innerWidth;
    }
  },
  watch: {
    iban: function iban(value) {
      this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(" ", "");
    },
    azienda: function azienda(value) {
      this.azienda = value.toUpperCase();
    },
    sdiCode: function sdiCode(value) {
      this.sdiCode = value.toUpperCase();
    },
    codice_fiscale: function codice_fiscale(value) {
      this.codice_fiscale = value.toUpperCase();
    },

    address: function address(value) {
      this.address = value.toUpperCase();
    },
    civic: function civic(value) {
      this.civic = value.toUpperCase();
    },
    name: function name(value) {
      this.name = value.toUpperCase();
    },
    lastname: function lastname(value) {
      this.lastname = value.toUpperCase();
    },
    ship_name: function ship_name(value) {
      this.ship_name = value.toUpperCase();
    },
    ship_lastname: function ship_lastname(value) {
      this.ship_lastname = value.toUpperCase();
    },
    number: function number(value) {
      this.number = parseInt(value);
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    id_eps: function id_eps(val) {
      if (val) {
        this.id_eps = val.replace(/\D+/g, "");
      }
    },
    cellulare: function cellulare(val) {
      if (val) {
        this.cellulare = val.replace(/\D+/g, "");
      }
    },
    ship_phone: function ship_phone(val) {
      if (val) {
        this.ship_phone = val.replace(/\D+/g, "");
      }
    },
    ship_cellulare: function ship_cellulare(val) {
      if (val) {
        this.ship_cellulare = val.replace(/\D+/g, "");
      }
    },
    region: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(newVal) {
        var _this11 = this;

        var provincies, provinciesState;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.zips = [];
                this.cities = [];
                this.zip = "";
                this.city = "";
                this.cityError = false;
                this.provinceError = false;
                this.zipError = false;
                this.province = "";
                this.provincies = [];
                this.provinciesState = true;

                provincies = this.provincies, provinciesState = this.provinciesState;
                _context9.next = 13;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvincies",
                  method: "POST",
                  data: {
                    region: newVal.id
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this11.provincies = resp.data.provincies;
                  _this11.provinciesState = false;
                }).catch(function (resp) {
                  _this11.provincies = [];
                  _this11.provinciesState = false;
                });

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function region(_x2) {
        return _ref5.apply(this, arguments);
      }

      return region;
    }(),
    ship_region: function ship_region(newVal) {
      var _this12 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_provinceError = false;
      this.ship_zipError = false;
      this.ship_province = "";
      this.ship_provincies = [];
      this.ship_provinciesState = true;

      var ship_provincies = this.ship_provincies,
          ship_provinciesState = this.ship_provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvincies",
        method: "POST",
        data: {
          region: newVal.id
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this12.ship_provincies = resp.data.provincies;
        _this12.ship_provinciesState = false;
      }).catch(function (resp) {
        _this12.ship_provincies = [];
        _this12.ship_provinciesState = false;
      });
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this13 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this13.cities = resp.data.cities;
          _this13.citiesState = false;
        }).catch(function (resp) {
          _this13.cities = [];
          _this13.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_province: function ship_province(newProvince) {
      var _this14 = this;

      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_zipError = false;

      if (newProvince) {
        this.ship_citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this14.ship_cities = resp.data.cities;
          _this14.ship_citiesState = false;
        }).catch(function (resp) {
          _this14.ship_cities = [];
          _this14.ship_citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this15 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this15.zips = resp.data.zips;
          _this15.zipsState = false;
        }).catch(function (resp) {
          _this15.zips = [];
          _this15.zipsState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_city: function ship_city(newCity) {
      var _this16 = this;

      this.ship_zipError = false;
      this.ship_zips = [];
      this.ship_zip = "";

      if (newCity.cityistat) {
        this.ship_zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this16.ship_zips = resp.data.zips;
          _this16.ship_zipsState = false;
        }).catch(function (resp) {
          _this16.ship_zips = [];
          _this16.ship_zipsState = false;
        });
      }
    },
    vw: function vw() {}
  },
  updated: function updated() {},
  created: function created() {
    this.$validator.extend("notZeros", {
      getMessage: function getMessage(field) {
        return " Il campo Numero di telefono non ha un formato valido.";
      },
      validate: function validate(value) {
        // value must be > zero
        if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
        return false;
      }
    });
  },
  mounted: function mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    this.lastnamex = this.getProfile.cognome;
    this.xuserx = this.getProfile.name;

    var _vue = this;

    setTimeout(function () {
      _vue.populateRegions(), _vue.disabledDates = {
        to: _vue.calcToDate(), // Disable all dates up to specific date
        from: _vue.calcFromDate() // Disable all dates after specific date
      };

      _vue.scrollFinished = true;
    }, 1500);
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "isAuthenticated", "isProfileLoaded"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a5036f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addClient/index.vue
var addClient_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.registration1
        ? _c("div", { staticClass: "container whiteCont mt-5 mb-5 pt-5" }, [
            !_vm.codeIsOk
              ? _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 pt-5 justify-content-center row vaillantCont"
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.codeIsOk
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.registrationCod($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "justify-content-center row vaillantCont"
                      },
                      [
                        _c("div", { staticClass: "col-lg-4 col-md-6" }, [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.codRif,
                                  expression: "codRif"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 55, min: 2 },
                                  expression:
                                    "{ required: true, max: 55, min: 2 }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("codRif"),
                                valid: !!_vm.codRif
                              },
                              attrs: {
                                type: "text",
                                id: "codRif",
                                name: "codRif",
                                "data-vv-as": "Codice Riferimento"
                              },
                              domProps: { value: _vm.codRif },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.codRif = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "codRif" }
                              },
                              [_vm._v("Codice di Riferimento *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("codRif")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("codRif")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-12 center mb-0 mb-5" },
                          [
                            !_vm.isAuthenticated && !_vm.codeIsOk
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-lg btn-primary",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v("\n            Verifica\n          ")]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.codeIsOk
              ? _c("div", { staticClass: "row justify-content-center" }, [
                  _c("div", { staticClass: "col-md-12 center" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _vm.corporateClient == "hoval"
                      ? _c("img", {
                          staticClass: "img img-fluid",
                          attrs: {
                            syle: "max-width:300px",
                            src: __webpack_require__("sDGe")
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 center mb-4" }, [
                    _vm.proccess == "START"
                      ? _c("h2", { staticClass: "black" }, [
                          _c("b", [_vm._v("REGISTRATI")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.proccess == "START"
                      ? _c("h5", { staticClass: "black" }, [
                          _vm._v(
                            "\n          Inserisci tutti i dati richiesti e clicca Registrati per procedere\n          con la registrazione.\n        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.proccess == "START"
                      ? _c("p", { staticClass: "black" }, [
                          _vm._v(
                            "\n          I campi contrassegnati con * sono obbligatori.\n        "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.proccess == "REG_SUCCESS"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "widthFull center pb-5 mb-5 vaillantCont pt-5"
                        },
                        [
                          _c(
                            "h1",
                            { staticClass: "widthFull center mt-3 black" },
                            [_vm._v("Ci sei quasi!")]
                          ),
                          _vm._v(" "),
                          !_vm.formed && _vm.corporateClient != "hoval"
                            ? _c(
                                "h3",
                                {
                                  staticClass:
                                    "widthFull center black mt-5 mb-5"
                                },
                                [
                                  _vm._v(
                                    "\n          La tua richiesta è stata inoltrata per approvazione.\n          "
                                  ),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(
                                    "A breve riceverai la conferma della registrazione\n          "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "via email e potrai accedere alla piattaforma.\n        "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.formed && _vm.corporateClient == "hoval"
                            ? _c(
                                "h3",
                                {
                                  staticClass:
                                    "widthFull center black mt-5 mb-5"
                                },
                                [
                                  _vm._v(
                                    "\n          La tua richiesta è stata inoltrata per approvazione.\n          "
                                  ),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(
                                    "A breve riceverai la conferma della registrazione\n          "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "via email per verificare la tua email.\n        "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formed
                            ? _c(
                                "h3",
                                { staticClass: "widthFull center black mt-5" },
                                [
                                  _vm._v(
                                    "\n          TI abbiamo inviato una mail al tuo indirizzo di posta elettronica\n        "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formed
                            ? _c("h3", { staticClass: "widthFull center" }, [
                                _c("b", [
                                  _vm._v(
                                    "Per confermare la tua registrazione clicca sul link che trovi\n            all’interno."
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formed
                            ? _c(
                                "h4",
                                {
                                  staticClass: "widthFull center mt-5 mb-5",
                                  staticStyle: { color: "black" }
                                },
                                [
                                  _vm._v(
                                    "\n          Verifica per favore anche nella cartella Spam o Posta indesiderata\n        "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formed
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { to: "/login" }
                                },
                                [_vm._v("\n          LOGIN\n        ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.formed
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { to: "/" }
                                },
                                [_vm._v("\n          HOME\n        ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.proccess == "START" && _vm.codeIsOk
              ? _c(
                  "form",
                  {
                    staticClass: "pb-5 pt-4 black vaillantCont",
                    attrs: { id: "registration-form" }
                  },
                  [
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mb-3",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c("div", { staticClass: "group custInput" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tipo_azienda,
                                    expression: "tipo_azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{ required: true }"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("tipo_azienda"),
                                  valid: !!_vm.tipo_azienda
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "tipo_azienda",
                                  name: "tipo_azienda",
                                  "data-vv-as": "Tipo Azienda"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.tipo_azienda = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "optgroup",
                                  {
                                    attrs: {
                                      label:
                                        "SOGGETTI CON PERSONALITA’ GIURIDICA"
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      {
                                        key: 111,
                                        attrs: {
                                          value:
                                            "Società in accomandita per azioni"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Società in accomandita per azioni\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 112,
                                        attrs: {
                                          value:
                                            "Società a responsabilità limitata"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Società a responsabilità limitata\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 113,
                                        attrs: { value: "Società per azioni" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Società per azioni\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 114,
                                        attrs: {
                                          value: "Società in nome collettivo"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Società in nome collettivo\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 115,
                                        attrs: {
                                          value:
                                            "Società in accomandita semplice"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Società in accomandita semplice\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 116,
                                        attrs: { value: "Società cooperative" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Società cooperative\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 117,
                                        attrs: {
                                          value:
                                            "Consorzi con o senza personalità giuridica"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Consorzi con o senza personalità giuridica\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 118,
                                        attrs: {
                                          value: "Associazioni riconosciute"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Associazioni riconosciute\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 119,
                                        attrs: {
                                          value:
                                            "STP Società tra professionisti"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  STP Società tra professionisti\n                "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "optgroup",
                                  { attrs: { label: "PERSONE FISICHE" } },
                                  [
                                    _c(
                                      "option",
                                      {
                                        key: 311,
                                        attrs: { value: "Ditta Individuale" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Ditta Individuale\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        key: 312,
                                        attrs: {
                                          value:
                                            "Professionista iscritto ad albi"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Professionista iscritto ad albi\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "region" }
                              },
                              [_vm._v("Tipo Azienda *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("tipo_azienda")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("tipo_azienda")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.tipo_azienda == "Ditta Individuale" ||
                      _vm.tipo_azienda == "Professionista iscritto ad albi"
                        ? _c("div", { staticClass: "col-md-3 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reg_forfettario,
                                      expression: "reg_forfettario"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{ required: true }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has(
                                      "reg_forfettario"
                                    ),
                                    valid: !!_vm.reg_forfettario
                                  },
                                  attrs: {
                                    autocomplete: "randomy",
                                    id: "reg_forfettario",
                                    name: "reg_forfettario",
                                    "data-vv-as": "Regime Forfettario"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.reg_forfettario = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { key: 911, attrs: { value: "si" } },
                                    [_vm._v("si")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { key: 912, attrs: { value: "no" } },
                                    [_vm._v("no")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "region" }
                                },
                                [_vm._v("Regime Forfettario *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("reg_forfettario")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.errors.first("reg_forfettario")
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.reg_roleSel
                        ? _c("div", { staticClass: "col-md-6 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reg_role,
                                      expression: "reg_role"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{ required: true }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("reg_role"),
                                    valid: !!_vm.reg_role
                                  },
                                  attrs: {
                                    autocomplete: "randomy",
                                    id: "reg_role",
                                    name: "reg_role",
                                    "data-vv-as":
                                      "Tipologia fornitura ed installazione prodotti"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.reg_role = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      key: 911,
                                      attrs: { value: "Installatore" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Formula installatore (standard) - Fornitura ed installazione\n                prodotti\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      key: 912,
                                      attrs: { value: "General Contractor" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Formula General Contractor\n              "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "region" }
                                },
                                [
                                  _vm._v(
                                    "Tipologia fornitura ed installazione prodotti *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("reg_role")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("reg_role")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.azienda,
                                expression: "azienda"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 128, min: 3 },
                                expression:
                                  "{ required: true, max: 128, min: 3 }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("azienda"),
                              valid: !!_vm.azienda
                            },
                            attrs: {
                              type: "text",
                              id: "azienda",
                              name: "azienda",
                              "data-vv-as": "Ragione sociale"
                            },
                            domProps: { value: _vm.azienda },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.azienda = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "azienda" }
                            },
                            [_vm._v("Ragione sociale *\n            ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("azienda")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("azienda")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partita_iva,
                                expression: "partita_iva"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  partitaIva: true,
                                  max: 11,
                                  min: 11
                                },
                                expression:
                                  "{\n                required: true,\n                partitaIva: true,\n                max: 11,\n                min: 11,\n              }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("partita_iva"),
                              valid: !!_vm.partita_iva
                            },
                            attrs: {
                              type: "text",
                              id: "partita_iva",
                              name: "partita_iva",
                              "data-vv-as": "Partita IVA"
                            },
                            domProps: { value: _vm.partita_iva },
                            on: {
                              blur: _vm.checkIfExistUser,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partita_iva = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "partita_iva" }
                            },
                            [_vm._v("Partita IVA *")]
                          ),
                          _vm._v(" "),
                          _vm.existPIVA
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Partita IVA inserita già presente.")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("partita_iva")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("partita_iva")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.codice_fiscale,
                                expression: "codice_fiscale"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  codiceFiscale:
                                    _vm.tipo_azienda == "Ditta Individuale" ||
                                    _vm.tipo_azienda ==
                                      "Professionista iscritto ad albi",
                                  partitaIva:
                                    _vm.tipo_azienda != "Ditta Individuale" &&
                                    _vm.tipo_azienda !=
                                      "Professionista iscritto ad albi",
                                  max:
                                    _vm.tipo_azienda == "Ditta Individuale" ||
                                    _vm.tipo_azienda ==
                                      "Professionista iscritto ad albi"
                                      ? 16
                                      : 11,
                                  min:
                                    _vm.tipo_azienda == "Ditta Individuale" ||
                                    _vm.tipo_azienda ==
                                      "Professionista iscritto ad albi"
                                      ? 16
                                      : 11
                                },
                                expression:
                                  "{\n                required: true,\n                codiceFiscale:\n                  tipo_azienda == 'Ditta Individuale' ||\n                  tipo_azienda == 'Professionista iscritto ad albi',\n                partitaIva:\n                  tipo_azienda != 'Ditta Individuale' &&\n                  tipo_azienda != 'Professionista iscritto ad albi',\n                max:\n                  tipo_azienda == 'Ditta Individuale' ||\n                  tipo_azienda == 'Professionista iscritto ad albi'\n                    ? 16\n                    : 11,\n                min:\n                  tipo_azienda == 'Ditta Individuale' ||\n                  tipo_azienda == 'Professionista iscritto ad albi'\n                    ? 16\n                    : 11,\n              }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("codice_fiscale"),
                              valid: !!_vm.codice_fiscale
                            },
                            attrs: {
                              type: "text",
                              id: "codice_fiscale",
                              name: "codice_fiscale",
                              "data-vv-as": "Codice Fiscale"
                            },
                            domProps: { value: _vm.codice_fiscale },
                            on: {
                              blur: _vm.checkIfExistUser,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.codice_fiscale = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "codice_fiscale" }
                            },
                            [_vm._v("Codice Fiscale *")]
                          ),
                          _vm._v(" "),
                          _vm.existCF
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Codice Fiscale inserito già presente."
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("codice_fiscale")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("codice_fiscale")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-4",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.name,
                                  expression: "name"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 55, min: 2 },
                                  expression:
                                    "{ required: true, max: 55, min: 2 }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("name"),
                                valid: !!_vm.name
                              },
                              attrs: {
                                type: "text",
                                id: "name",
                                name: "name",
                                "data-vv-as": "Nome"
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.name = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "name" }
                              },
                              [_vm._v("Nome *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("name")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("name")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-4",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c("div", { staticClass: "group custInput" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lastname,
                                  expression: "lastname"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 55, min: 2 },
                                  expression:
                                    "{ required: true, max: 55, min: 2 }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("lastname"),
                                valid: !!_vm.lastname
                              },
                              attrs: {
                                type: "text",
                                id: "lastname",
                                name: "lastname",
                                "data-vv-as": "Cognome"
                              },
                              domProps: { value: _vm.lastname },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.lastname = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "lastname" }
                              },
                              [_vm._v("Cognome *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("lastname")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("lastname")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.email,
                                expression: "email"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  email: true,
                                  temporaryEmail: true,
                                  plusIssueEmail: true,
                                  max: 56
                                },
                                expression:
                                  "{\n                required: true,\n                email: true,\n                temporaryEmail: true,\n                plusIssueEmail: true,\n                max: 56,\n              }"
                              }
                            ],
                            ref: "email",
                            staticClass: "form-control",
                            class: {
                              "is-invalid":
                                _vm.errors.has("email") || _vm.existEmail,
                              valid: !!_vm.email
                            },
                            attrs: {
                              type: "text",
                              id: "email",
                              name: "email",
                              "data-vv-as": "Email"
                            },
                            domProps: { value: _vm.email },
                            on: {
                              blur: _vm.checkIfExistUser,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.email = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "email" }
                            },
                            [_vm._v("Email* ")]
                          ),
                          _vm._v(" "),
                          _vm.existEmail
                            ? _c(
                                "div",
                                {
                                  staticClass: "invalid-feedback",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _c("span", [
                                    _vm._v("Email digitato già presente")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("email")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("email")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.password,
                                expression: "password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  passwordCheck: true,
                                  min: 8,
                                  max: 56
                                },
                                expression:
                                  "{\n                required: true,\n                passwordCheck: true,\n                min: 8,\n                max: 56,\n              }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("password"),
                              valid: !!_vm.password
                            },
                            attrs: {
                              type: "password",
                              id: "password",
                              name: "password",
                              "data-vv-as": "Password"
                            },
                            domProps: { value: _vm.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "password" }
                            },
                            [_vm._v("Scegli nuova password *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("password")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("password")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.confirm_password,
                                expression: "confirm_password"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  passwordCheck: true,
                                  min: 8,
                                  max: 56,
                                  confirmed: _vm.password
                                },
                                expression:
                                  "{\n                required: true,\n                passwordCheck: true,\n                min: 8,\n                max: 56,\n                confirmed: password,\n              }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("confirm_password"),
                              valid: !!_vm.confirm_password
                            },
                            attrs: {
                              type: "password",
                              id: "confirm_password",
                              name: "confirm_password",
                              "data-vv-as": "Conferma Password"
                            },
                            domProps: { value: _vm.confirm_password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.confirm_password = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "confirm_password" }
                            },
                            [_vm._v("Conferma nuova password *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("confirm_password")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.errors.first("confirm_password")
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phone,
                                expression: "phone"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  max: 12,
                                  min: 8,
                                  notZeros: true,
                                  regex: /^[0,3]+/
                                },
                                expression:
                                  "{\n                required: true,\n                max: 12,\n                min: 8,\n                notZeros: true,\n                regex: /^[0,3]+/,\n              }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("phone"),
                              valid: !!_vm.phone
                            },
                            attrs: {
                              type: "text",
                              id: "phone",
                              name: "phone",
                              "data-vv-as": "Telefono"
                            },
                            domProps: { value: _vm.phone },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phone = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "phone" }
                            },
                            [_vm._v("Telefono * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("phone")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("phone")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cellulare,
                                expression: "cellulare"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  max: 12,
                                  min: 8,
                                  notZeros: true,
                                  regex: /^[0,3]+/
                                },
                                expression:
                                  "{\n                required: true,\n                max: 12,\n                min: 8,\n                notZeros: true,\n                regex: /^[0,3]+/,\n              }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("cellulare"),
                              valid: !!_vm.cellulare
                            },
                            attrs: {
                              type: "text",
                              id: "cellulare",
                              name: "cellulare",
                              "data-vv-as": "Cellulare"
                            },
                            domProps: { value: _vm.cellulare },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.cellulare = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "cellulare" }
                            },
                            [_vm._v("Cellulare * ")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("cellulare")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("cellulare")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.address,
                                expression: "address"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 128, min: 5 },
                                expression:
                                  "{ required: true, max: 128, min: 5 }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("address"),
                              valid: !!_vm.address
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomr",
                              id: "address",
                              name: "address",
                              "data-vv-as": "Indirizzo"
                            },
                            domProps: { value: _vm.address },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.address = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "address" }
                            },
                            [_vm._v("Indirizzo *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("address")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("address")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.civic,
                                expression: "civic"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, max: 15 },
                                expression: "{ required: true, max: 15 }"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("civic"),
                              valid: !!_vm.civic
                            },
                            attrs: {
                              type: "text",
                              autocomplete: "randomt",
                              id: "civic",
                              name: "civic",
                              "data-vv-as": "Civico"
                            },
                            domProps: { value: _vm.civic },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.civic = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "civic" }
                            },
                            [_vm._v("Civico *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("civic")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("civic")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.region,
                                  expression: "region"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{ required: true }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("region"),
                                valid: !!_vm.region
                              },
                              attrs: {
                                autocomplete: "randomy",
                                id: "region",
                                name: "region",
                                "data-vv-as": "Regione"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.region = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.regions, function(region) {
                              return _c(
                                "option",
                                {
                                  key: region.id_regione,
                                  domProps: {
                                    value: {
                                      id: region.id_regione,
                                      text: region.regione
                                    },
                                    selected:
                                      region.id_regione == _vm.shipData.region
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(region.regione) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "region" }
                            },
                            [_vm._v("Regione *")]
                          ),
                          _vm._v(" "),
                          _vm.regionsState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadregion",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("region")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("region")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.province,
                                  expression: "province"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{ required: true }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("province"),
                                valid: !!_vm.province
                              },
                              attrs: {
                                autocomplete: "randomy",
                                id: "province",
                                name: "province",
                                "data-vv-as": "Provincia"
                              },
                              on: {
                                click: _vm.checkRegion,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.province = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.provincies, function(province) {
                              return _c(
                                "option",
                                {
                                  key: province.sigla,
                                  domProps: {
                                    value: province.sigla,
                                    selected:
                                      province.sigla == _vm.shipData.province
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(province.sigla) +
                                      " - " +
                                      _vm._s(province.provincia) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "province" }
                            },
                            [
                              _vm._v("Provincia *"),
                              _vm.provinceError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Regione")
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.provinciesState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadProvince",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("province")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("province")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{ required: true }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("city"),
                                valid: !!_vm.city
                              },
                              attrs: {
                                autocomplete: "randomu",
                                id: "city",
                                name: "city",
                                "data-vv-as": "Località",
                                disabled: _vm.citiesState
                              },
                              on: {
                                click: _vm.checkProvince,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.city = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.cities, function(city) {
                              return _c(
                                "option",
                                {
                                  key: city.comune,
                                  domProps: {
                                    value: {
                                      cityistat: city.istat,
                                      city: city.comune
                                    },
                                    selected: city.comune == _vm.shipData.city
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(city.comune) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [
                              _vm._v("Località *"),
                              _vm.cityError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Provincia")
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.citiesState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadCity",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("city")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("city")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{ required: true }"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("zip"),
                                valid: !!_vm.zip
                              },
                              attrs: {
                                autocomplete: "randomi",
                                id: "zip",
                                name: "zip",
                                "data-vv-as": "Cap",
                                disabled: _vm.zipsState
                              },
                              on: {
                                click: _vm.checkZip,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.zip = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            _vm._l(_vm.zips, function(zip) {
                              return _c(
                                "option",
                                {
                                  key: zip.cap,
                                  domProps: {
                                    value: zip.cap,
                                    selected: zip.cap == _vm.shipData.zip
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(zip.cap) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "zip" }
                            },
                            [
                              _vm._v("Cap *"),
                              _vm.zipError
                                ? _c("span", { staticClass: "formError" }, [
                                    _vm._v("Prima scegli Località")
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.zipsState
                            ? _c(
                                "div",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "loadSpinner",
                                    attrs: {
                                      id: "loadZips",
                                      icon: "spinner",
                                      size: "1x",
                                      pulse: ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.errors.has("zip")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("zip")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "row justify-content-center divider"
                    }),
                    _vm._v(" "),
                    _vm.hasPoste
                      ? _c(
                          "div",
                          { staticClass: "row justify-content-center pt-3" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-5 mb-3" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.iban,
                                      expression: "iban"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        ibanControl: true,
                                        ibanItalian: true,
                                        ibanPoste: true,
                                        max: 27,
                                        min: 27
                                      },
                                      expression:
                                        "{\n                ibanControl: true,\n                ibanItalian: true,\n                ibanPoste: true,\n                max: 27,\n                min: 27,\n              }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("iban"),
                                    valid: !!_vm.iban
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomr",
                                    id: "iban",
                                    name: "iban",
                                    "data-vv-as": "IBAN"
                                  },
                                  domProps: { value: _vm.iban },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.iban = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "iban" }
                                  },
                                  [_vm._v("IBAN Poste Italiane")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("iban")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.errors.first("iban")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-7 mb-3" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.ibanNome,
                                      expression: "ibanNome"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: _vm.iban != "",
                                        max: 128,
                                        min: 5
                                      },
                                      expression:
                                        "{ required: iban != '', max: 128, min: 5 }"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("ibanNome"),
                                    valid: !!_vm.ibanNome
                                  },
                                  attrs: {
                                    type: "text",
                                    autocomplete: "randomr",
                                    id: "ibanNome",
                                    name: "ibanNome",
                                    "data-vv-as": "Nome intestatario"
                                  },
                                  domProps: { value: _vm.ibanNome },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.ibanNome = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "ibanNome" }
                                  },
                                  [_vm._v("Intestazione conto")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("ibanNome")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first("ibanNome")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6 mb-3" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.emailPEC,
                                      expression: "emailPEC"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        email: true,
                                        temporaryEmail: true,
                                        plusIssueEmail: true,
                                        max: 56
                                      },
                                      expression:
                                        "{\n                required: true,\n                email: true,\n                temporaryEmail: true,\n                plusIssueEmail: true,\n                max: 56,\n              }"
                                    }
                                  ],
                                  ref: "emailPEC",
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("emailPEC"),
                                    valid: !!_vm.emailPEC
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "emailPEC",
                                    name: "emailPEC",
                                    "data-vv-as": "email PEC"
                                  },
                                  domProps: { value: _vm.emailPEC },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.emailPEC = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "email" }
                                  },
                                  [_vm._v("Email PEC* ")]
                                ),
                                _vm._v(" "),
                                _vm.existEmail
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "invalid-feedback",
                                        staticStyle: { display: "block" }
                                      },
                                      [
                                        _c("span", [
                                          _vm._v("Email digitato già presente")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.errors.has("emailPEC")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first("emailPEC")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6 mb-3" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sdiCode,
                                      expression: "sdiCode"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true, min: 7, max: 7 },
                                      expression:
                                        "{ required: true, min: 7, max: 7 }"
                                    }
                                  ],
                                  ref: "sdiCode",
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("sdiCode"),
                                    valid: !!_vm.sdiCode
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "sdiCode",
                                    name: "sdiCode",
                                    "data-vv-as": "CODICE SDI"
                                  },
                                  domProps: { value: _vm.sdiCode },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.sdiCode = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "sdiCode" }
                                  },
                                  [
                                    _vm._v(
                                      "CODICE SDI fatturazione elettronica *\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("sdiCode")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first("sdiCode")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-4" }, [
                      _c("div", { staticClass: "col-md-2 mb-3 center" }, [
                        _vm.invoiceFrontBucket
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.invoiceFrontBucket,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm.invoiceFrontBucket.substring(
                                  _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                                  _vm.invoiceFrontBucket.length
                                ) == "pdf"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "center widthFull pdfLink",
                                        attrs: {
                                          href: _vm.invoiceFrontBucket,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v("APRI "),
                                        _c("br"),
                                        _vm._v("\n              PDF")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3 mt-4" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 10240,
                                  ext: ["jpeg", "jpg", "png"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png"
                                  ]
                                },
                                expression:
                                  "{\n                required: false,\n                size: 10240,\n                ext: ['jpeg', 'jpg', 'png'],\n                mimes: ['image/jpeg', 'image/jpg', 'image/png'],\n              }"
                              }
                            ],
                            ref: "fileInput",
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: { change: _vm.uploadFile }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Scegli il Contratto quadro*\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.uploadFrontPercentage
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar",
                                      style: {
                                        width: _vm.uploadFrontPercentage + "%"
                                      },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.uploadFrontPercentage) +
                                          " %\n              "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.invoiceFrontName) +
                                      "\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(3)
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("div", { staticClass: "p-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacy,
                                  expression: "privacy"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{ required: true }"
                                }
                              ],
                              staticClass: "form-check-input",
                              class: {
                                "is-invalid": _vm.errors.has("privacy")
                              },
                              attrs: {
                                type: "checkbox",
                                id: "privacy",
                                name: "privacy",
                                "data-vv-as": "Termini di utilizzo"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacy)
                                  ? _vm._i(_vm.privacy, null) > -1
                                  : _vm.privacy
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.privacy,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacy = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacy = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacy = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label textStable",
                                attrs: { for: "privacy" }
                              },
                              [
                                _vm._v(
                                  "\n                Effettuando la registrazione e utilizzando i servizi presenti\n                sul Sito accetto i presenti\n                "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "green",
                                    attrs: {
                                      href: _vm.utilizzoPolicy,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Termini di utilizzo\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("privacy")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("privacy")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("div", { staticClass: "p-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacy1,
                                  expression: "privacy1"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{ required: true }"
                                }
                              ],
                              staticClass: "form-check-input",
                              class: {
                                "is-invalid": _vm.errors.has("privacy1")
                              },
                              attrs: {
                                type: "checkbox",
                                id: "privacy1",
                                name: "privacy1",
                                "data-vv-as": "Informativa privacy"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacy1)
                                  ? _vm._i(_vm.privacy1, null) > -1
                                  : _vm.privacy1
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.privacy1,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacy1 = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacy1 = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacy1 = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label textStable",
                                attrs: { for: "privacy1" }
                              },
                              [
                                _vm._v(
                                  "\n                Dichiaro di aver letto e compreso\n                "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "green",
                                    attrs: {
                                      href: _vm.privacyPolicy,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  l’Informativa privacy\n                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("privacy1")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("privacy1")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.corporateClient == "hoval"
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                            _c("div", { staticClass: "form-check" }, [
                              _c("div", { staticClass: "p-3" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.privacy2,
                                      expression: "privacy2"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{ required: true }"
                                    }
                                  ],
                                  staticClass: "form-check-input",
                                  class: {
                                    "is-invalid": _vm.errors.has("privacy2")
                                  },
                                  attrs: {
                                    type: "checkbox",
                                    id: "privacy2",
                                    name: "privacy2",
                                    "data-vv-as": "Download contratto quadro"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.privacy2)
                                      ? _vm._i(_vm.privacy2, null) > -1
                                      : _vm.privacy2
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.privacy2,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.privacy2 = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.privacy2 = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.privacy2 = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("small", [
                                  _vm._v(
                                    "Scarica e compila il\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      attrs: {
                                        href: _vm.accordoQuadro,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  contratto quadro di cessione del credito di imposta "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    ", una volta compilato invialo a\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      attrs: {
                                        href:
                                          "mailto: ilaria.pesenti@hoval.com?subject=“Sottoscrizione contratto Hoval – Due Diligence condomini”",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                   ilaria.pesenti@hoval.com\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                E \n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      attrs: {
                                        href:
                                          "mailto:daniela.conte@hoval.com?subject=“Sottoscrizione contratto Hoval – Due Diligence condomini”",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  daniela.conte@hoval.com\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.errors.has("privacy2")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.errors.first("privacy2")
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: 1 == 2,
                            expression: "1 == 2"
                          }
                        ],
                        staticClass: "row"
                      },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("div", { staticClass: "p-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.privacy3,
                                    expression: "privacy3"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {},
                                    expression: "{}"
                                  }
                                ],
                                staticClass: "form-check-input",
                                class: {
                                  "is-invalid": _vm.errors.has("privacy3")
                                },
                                attrs: {
                                  type: "checkbox",
                                  id: "privacy3",
                                  name: "privacy3",
                                  "data-vv-as": "Informativa privacy3"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.privacy3)
                                    ? _vm._i(_vm.privacy3, null) > -1
                                    : _vm.privacy3
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.privacy3,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.privacy3 = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.privacy3 = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.privacy3 = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(4),
                              _vm._v(" "),
                              _vm.errors.has("privacy3")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("privacy3")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-12 center mb-0 mb-1" }, [
                        !_vm.isAuthenticated
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-lg btn-primary",
                                attrs: { type: "button" },
                                on: { click: _vm.registration }
                              },
                              [_vm._v("\n            Registrati\n          ")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var addClient_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 center mt-5" }, [
      _c("h5", [
        _vm._v(
          "\n          Inserisci il codice di riferimento della tua azienda per proseguire\n          con la registrazione\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3 center" }, [
      _c("h5", { staticClass: "black center" }, [
        _vm._v(
          "\n            Inserisci i dati del conto corrente bancario, PEC e codice SDI.\n          "
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "ptImage mr-3",
        attrs: { src: __webpack_require__("0rFJ") }
      }),
      _c("small", [
        _vm._v(
          "Attenzione! Per usufruire del servizio è necessario inserire\n            "
        ),
        _c("b", [_vm._v("iban del conto corrente affari di poste italiane")]),
        _vm._v(".\n          ")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("small", [_vm._v(" ( può essere inserito anche successivamente ) ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center" }, [
      _vm._v("Logo "),
      _c("small", [_vm._v("(formato: jpg, png)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mb-3" }, [
      _c("h5", { staticClass: "text-left pt-4" }, [
        _vm._v("Carica logo della tua azienda")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Il campo non è obbligatorio. Se carichi il logo potremo\n            personalizzare i tuoi preventivi con il logo della tua azienda.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label textStable",
        attrs: { for: "privacy3" }
      },
      [
        _vm._v(
          "\n                Dichiaro di aver letto e compreso\n                "
        ),
        _c(
          "a",
          {
            staticClass: "green",
            attrs: { href: "privacy.pdf", target: "_blank" }
          },
          [
            _vm._v(
              "\n                  l’Informativa privacy\n                "
            )
          ]
        ),
        _vm._v(
          "\n                resa dal Titolare del trattamento ai sensi dell’art. 13 del\n                GDPR*\n              "
        )
      ]
    )
  }
]
addClient_render._withStripped = true
var addClient_esExports = { render: addClient_render, staticRenderFns: addClient_staticRenderFns }
/* harmony default export */ var components_addClient = (addClient_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a5036f", addClient_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/addClient/index.vue
var addClient_disposed = false
function addClient_injectStyle (ssrContext) {
  if (addClient_disposed) return
  __webpack_require__("fcBF")
  __webpack_require__("v4hK")
}
var addClient_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addClient___vue_template_functional__ = false
/* styles */
var addClient___vue_styles__ = addClient_injectStyle
/* scopeId */
var addClient___vue_scopeId__ = "data-v-03a5036f"
/* moduleIdentifier (server only) */
var addClient___vue_module_identifier__ = null
var addClient_Component = addClient_normalizeComponent(
  addClient,
  components_addClient,
  addClient___vue_template_functional__,
  addClient___vue_styles__,
  addClient___vue_scopeId__,
  addClient___vue_module_identifier__
)
addClient_Component.options.__file = "src/components/addClient/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-03a5036f", addClient_Component.options)
  } else {
    hotAPI.reload("data-v-03a5036f", addClient_Component.options)
  }
  module.hot.dispose(function (data) {
    addClient_disposed = true
  })
})()}

/* harmony default export */ var src_components_addClient = (addClient_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/vue-badger-accordion/index.js
var vue_badger_accordion = __webpack_require__("paJE");

// EXTERNAL MODULE: ./node_modules/vue-svg-gauge/dist/vue-svg-gauge.js
var vue_svg_gauge = __webpack_require__("o39/");
var vue_svg_gauge_default = /*#__PURE__*/__webpack_require__.n(vue_svg_gauge);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/offerte/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var offerte_moment = __webpack_require__("PJh5");



/* harmony default export */ var offerte = ({
  name: "login",
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"]
  },
  data: function data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countloop: 1,
      countCashInst: 0,
      practicesFiltred: {},
      filter: "",
      presentPractices: true,
      moment: __webpack_require__("PJh5"),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false
    };
  },

  methods: {
    getPractices: function getPractices() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _vue, token, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _vue = _this;

                _this.loadingState = true;
                _this.$log(_vue.getProfile.userToken);
                token = _vue.getProfile.userToken;

                if (_vue.getProfile.corporateClient == 'agnellimetalli') {
                  _vue.$router.push('/');
                }

                if (!token) {
                  _context.next = 10;
                  break;
                }

                data = {
                  type: 0,
                  user_token: token
                };

                data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 10;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getPractices",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _vue.practices = resp.data.practices;
                  _vue.totCash = 0;
                  _vue.countPractices = 0;
                  _vue.countCashInst = 0;
                  _vue.countCashClient = 0;
                  for (var x in _vue.practices) {
                    if (_vue.practices[x].status == "0") {
                      // CALC ONLY VALID ORDERS
                      _vue.countPractices++;
                      _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2);

                      _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2);
                      _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                    }

                    if (_vue.practices[x].status == "9") {
                      _vue.hasRemovedPractics = true;
                    }
                  }
                  _this.totCash = parseFloat(_this.totCash);
                  if (_this.totCash < 10000) {
                    _this.maxTotCash = 10000;
                    _this.step = 1000;
                  } else if (_this.totCash < 100000) {
                    _this.maxTotCash = 100000;
                    _this.step = 10000;
                  } else if (_this.totCash < 1000000) {
                    _this.maxTotCash = 1000000;
                    _this.step = 100000;
                  } else if (_this.totCash < 100000000) {
                    _this.maxTotCash = 100000000;
                    _this.step = 1000000;
                  }
                  _vue.practicesFiltred = _vue.practices;

                  _vue.loadingState = false;
                }).catch(function (resp) {
                  _this.presentPractices = false;
                  _vue.loadingState = false;
                  //_vue.$swal({
                  //  type: 'error',
                  //  title: 'Oops...',
                  //  text: 'Riprova piu tardi!',
                  //});
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filterValues: function filterValues() {
      var text = this.filter.toLowerCase();
      this.$log(text);
      this.showFilterText = false;
      this.practicesFiltred = {};
      var z = 0;
      var bank = {};
      assign_default()(this.practicesFiltred, {});

      for (var x in this.practices) {
        if ((this.practices[x].code.toLowerCase().includes(text) || this.practices[x].client_lastname.toLowerCase().includes(text) || this.practices[x].client_name.toLowerCase().includes(text) || this.practices[x].building_city.toLowerCase().includes(text)) && this.practices[x].status != "9") {
          bank[x] = this.practices[x];
          z = z + 1;
        }
      }

      this.countloop = this.countloop + 1;

      assign_default()(this.practicesFiltred, bank);

      if (z == 0) {
        this.showFilterText = true;
      } else {
        this.showFilterText = false;
      }
    },
    removeOrder: function removeOrder(id, code, key) {
      var _this2 = this;

      var id_order = id;
      var _vue = this;

      if (key == "restore") {
        var type = 0;
        var popUpText = "<br/>Sei sicuro di voler ripristinare Preventivo N. " + code + "?<br/><br/>";
      } else {
        var type = 9;
        var popUpText = "<br/>Sei sicuro di voler archiviare Preventivo N. " + code + "?<br/><br/>";
      }

      this.$swal({
        title: "Attenzione!",
        type: "warning",
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        _this2.$log(result);
        if (result.value) {
          var data = {
            id: id,
            user_token: _vue.getProfile.userToken,
            status: type
          };
          data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/changeOrderState",
            method: "POST",
            data: { data: data },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _vue.getPractices();

            if (key == "restore") {
              _vue.$swal("Preventivo N. " + code + " <br/>è stato ripristinato ", "", "success");
            } else {
              _vue.$swal("Preventivo N. " + code + " <br/>è stato archiviato ", "", "success");
            }
          }).catch(function (resp) {
            _vue.$swal("Ops. Riprova piu tardi", "", "error");
          });
        }
      });
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      if (val) {
        this.$log(val);
        this.getPractices();
      }
    },
    filter: function filter(val) {
      this.filterValues();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.getProfile) {

      this.getPractices();
    }

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8b643a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offerte/index.vue
var offerte_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-md-5 pt-4" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-md-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("Non hai Preventivi")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Crea Preventivo")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-md-3 align-items-end"
              },
              [
                _c("div", { staticClass: "col-md-4 pb-0" }, [
                  _c("h5", { staticClass: "grey pt-0 pb-0" }, [
                    _vm._v("\n          Totale Preventivi: "),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(" " + _vm._s(_vm.countPractices))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v(
                      "\n          Totale Fatturato verso Clienti:\n          "
                    ),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(_vm._f("formatNumber")(_vm.countCashClient))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h5", { staticClass: "grey pt-0 mt-2" }, [
                    _vm._v(
                      "\n          Totale da Cessione del Credito:\n          "
                    ),
                    _c("b", { staticClass: "black" }, [
                      _vm._v(
                        "€ " + _vm._s(_vm._f("formatNumber")(_vm.countCashInst))
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-10 col-md-4 center pl-5 pr-5" },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: _vm.totCash,
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm._f("formatNumber")(_vm.totCash))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Fatturabili")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.filterValues($event)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey mobSearchT" }, [
                        _vm._v("Ricerca Preventivo")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter,
                              expression: "filter"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Preventivo o Cognome ....."
                          },
                          domProps: { value: _vm.filter },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filter = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    { key: "1231dsdfh32354134", staticClass: "pb-5 mt-4" },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 9
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-9" },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "\n                    Preventivo N. "
                                            ),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [_vm._v(_vm._s(item.code))]
                                            ),
                                            _vm._v(
                                              " del\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .moment(item.created_at)
                                                    .format("DD-MM-YYYY HH:mm")
                                                ) +
                                                " (\n                    " +
                                                _vm._s(item.bonus) +
                                                " ) per\n                    "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.client_name) +
                                                  " " +
                                                  _vm._s(item.client_lastname) +
                                                  " "
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-primary m-2 btn-sm",
                                              attrs: {
                                                href:
                                                  item.invoice_quotation_pdf,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "print",
                                                  size: "sm"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    visualizza/stampa/scarica\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-green m-2 btn-sm",
                                              attrs: {
                                                to: {
                                                  name: "acceptInvoice",
                                                  params: { item: item }
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "clipboard-check",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Conferma preventivo\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-primary m-2 btn-sm",
                                              attrs: {
                                                to: {
                                                  name: "editInvoice",
                                                  params: { item: item }
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "edit",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Modifica\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-danger m-2 btn-sm mr-md-5",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.removeOrder(
                                                    item.id,
                                                    item.code,
                                                    key
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                     ARCHIVIA\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "inline-block center relative mt-3"
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "qrcodeImg",
                                              attrs: { src: item.qrcode }
                                            }),
                                            _vm._v(" "),
                                            _c("br"),
                                            _c(
                                              "small",
                                              { staticClass: "qrcodeText" },
                                              [
                                                _c("b", [
                                                  _vm._v("Conferma con")
                                                ])
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "greenLinkAccordion Regular"
                                          },
                                          [_vm._v("Dettagli")]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 col-lg-12" },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _c("b", [
                                              _vm._v("Indirizzo dell'immobile")
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 col-lg-12" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.building_address) +
                                              " " +
                                              _vm._s(item.building_civic) +
                                              "\n                  " +
                                              _vm._s(item.building_city) +
                                              " (" +
                                              _vm._s(item.building_province) +
                                              ") CAP:\n                  " +
                                              _vm._s(item.building_zip) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-12 col-lg-12" },
                                        [
                                          _c(
                                            "h5",
                                            { staticClass: "black pb-0" },
                                            [
                                              _c("b", [
                                                _vm._v("Dati dell'intervento")
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-6" }, [
                                        _vm._v(
                                          "\n                  Tipo:\n                  "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "uppercase" },
                                          [
                                            _vm._v(
                                              _vm._s(item.intervention_type)
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "badger-accordion",
                    { key: "1231243412512354134", staticClass: "pb-5 mt-4" },
                    [
                      _vm.hasRemovedPractics
                        ? _c(
                            "badger-accordion-item",
                            { attrs: { id: "id_closed" } },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "h5",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Preventivi Archiviati\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "p",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Attenzione! i dati della dashboard non includono il valori di\n                preventivi archiviati.\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "badger-accordion",
                                    { staticClass: "pb-5 mt-4 greyBg" },
                                    _vm._l(_vm.practicesFiltred, function(
                                      item,
                                      key
                                    ) {
                                      return item.status == 9 &&
                                        _vm.filter == ""
                                        ? _c(
                                            "badger-accordion-item",
                                            {
                                              key:
                                                item.code +
                                                "_r_" +
                                                _vm.countloop,
                                              attrs: { id: "id" + item.code }
                                            },
                                            [
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "center",
                                                  slot: "header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-9"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Preventivo N.\n                          "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.code
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " del\n                          " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .moment(
                                                                        item.created_at
                                                                      )
                                                                      .format(
                                                                        "DD-MM-YYYY HH:mm"
                                                                      )
                                                                  ) +
                                                                  "\n                          ( " +
                                                                  _vm._s(
                                                                    item.bonus
                                                                  ) +
                                                                  " ) per\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.client_name
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item.client_lastname
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary m-2 btn-sm",
                                                              attrs: {
                                                                href:
                                                                  item.invoice_quotation_pdf,
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon:
                                                                      "print",
                                                                    size: "sm"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                          visualizza/stampa/scarica\n                        "
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn btn-danger m-2 btn-sm mr-md-5",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.removeOrder(
                                                                    item.id,
                                                                    item.code,
                                                                    "restore"
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon:
                                                                      "trash-restore-alt",
                                                                    size: "sm"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                          Ripristina\n                        "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass: "col-md-3"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "bbaLightColor",
                                                  slot: "content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 col-lg-12"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Indirizzo dell'immobile"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 col-lg-12"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                item.building_address
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                item.building_civic
                                                              ) +
                                                              "\n                        " +
                                                              _vm._s(
                                                                item.building_city
                                                              ) +
                                                              " (" +
                                                              _vm._s(
                                                                item.building_province
                                                              ) +
                                                              ") CAP: " +
                                                              _vm._s(
                                                                item.building_zip
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12 col-lg-12"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Dati dell'intervento"
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Tipo:\n                        "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "uppercase"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.intervention_type
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-6"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Data:\n                        "
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "uppercase"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .moment(
                                                                      item.intervention_date
                                                                    )
                                                                    .format(
                                                                      "DD-MM-YYYY"
                                                                    )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v("Nessun risultato per " + _vm._s(_vm.filter))
                  ])
                ]
              )
        ])
      ])
    ],
    1
  )
}
var offerte_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular center h0 widthFull" }, [
        _c("b", [_vm._v("I tuoi preventivi")])
      ])
    ])
  }
]
offerte_render._withStripped = true
var offerte_esExports = { render: offerte_render, staticRenderFns: offerte_staticRenderFns }
/* harmony default export */ var components_offerte = (offerte_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8b643a0", offerte_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/offerte/index.vue
var offerte_disposed = false
var offerte_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var offerte___vue_template_functional__ = false
/* styles */
var offerte___vue_styles__ = null
/* scopeId */
var offerte___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var offerte___vue_module_identifier__ = null
var offerte_Component = offerte_normalizeComponent(
  offerte,
  components_offerte,
  offerte___vue_template_functional__,
  offerte___vue_styles__,
  offerte___vue_scopeId__,
  offerte___vue_module_identifier__
)
offerte_Component.options.__file = "src/components/offerte/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8b643a0", offerte_Component.options)
  } else {
    hotAPI.reload("data-v-d8b643a0", offerte_Component.options)
  }
  module.hot.dispose(function (data) {
    offerte_disposed = true
  })
})()}

/* harmony default export */ var src_components_offerte = (offerte_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/superbonus/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var superbonus_moment = __webpack_require__("PJh5");



/* harmony default export */ var superbonus = ({
  name: 'superbonus',
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"]
  },
  data: function data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      practices: {},
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: '',
      presentPractices: true,
      moment: __webpack_require__("PJh5"),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      showFilterText: false,
      hasRemovedPractics: false
    };
  },

  methods: {
    getPractices: function getPractices() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _vue, token;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _vue = _this;

                _this.loadingState = true;
                _this.$log(_vue.getProfile.userToken);
                token = _vue.getProfile.userToken;

                if (!token) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + 'api/getPractices',
                  method: 'POST',
                  data: {
                    type: 0,
                    user_token: token
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {

                  _vue.practices = resp.data.practices;
                  _vue.totCash = 0;
                  _vue.countPractices = 0;
                  _vue.countCashInst = 0;
                  _vue.countCashClient = 0;
                  for (var x in _vue.practices) {
                    if (_vue.practices[x].status == '0') {
                      // CALC ONLY VALID ORDERS
                      _vue.countPractices++;
                      _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2);

                      _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                    }

                    if (_vue.practices[x].status == '9') {
                      _vue.hasRemovedPractics = true;
                    }
                  }
                  _this.totCash = parseFloat(_this.totCash);
                  if (_this.totCash < 10000) {
                    _this.maxTotCash = 10000;
                    _this.step = 1000;
                  } else if (_this.totCash < 100000) {
                    _this.maxTotCash = 100000;
                    _this.step = 10000;
                  } else if (_this.totCash < 1000000) {
                    _this.maxTotCash = 1000000;
                    _this.step = 100000;
                  } else if (_this.totCash < 100000000) {
                    _this.maxTotCash = 100000000;
                    _this.step = 1000000;
                  }
                  _vue.practicesFiltred = _vue.practices;

                  _vue.loadingState = false;
                }).catch(function (resp) {

                  _this.presentPractices = false;
                  _vue.loadingState = false;
                  //_vue.$swal({
                  //  type: 'error',
                  //  title: 'Oops...',
                  //  text: 'Riprova piu tardi!',
                  //});
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    filterValues: function filterValues() {
      var text = this.filter.toLowerCase();
      this.$log(text);
      this.practicesFiltred = {};
      var z = 0;

      for (var x in this.practices) {
        if (this.practices[x].code.toLowerCase().includes(text) || this.practices[x].client_lastname.toLowerCase().includes(text) || this.practices[x].client_name.toLowerCase().includes(text) || this.practices[x].building_city.toLowerCase().includes(text)) {
          this.practicesFiltred[x] = this.practices[x];
          z = z + 1;
        }
      }

      if (z == 0) {
        this.showFilterText = true;
      } else {
        this.showFilterText = false;
      }
    },
    removeOrder: function removeOrder(id, code, key) {
      var _this2 = this;

      var id_order = id;
      var _vue = this;

      if (key == 'restore') {
        var type = 0;
        var popUpText = '<br/>Sei sicuro di voler ripristinare Preventivo N. ' + code + '?<br/><br/>';
      } else {
        var type = 9;
        var popUpText = '<br/>Sei sicuro di voler eliminare Preventivo N. ' + code + '?<br/><br/>';
      }

      this.$swal({
        title: 'Attenzione!',
        type: 'warning',
        html: popUpText,
        showCancelButton: true,
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        _this2.$log(result);
        if (result.value) {

          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + 'api/changeOrderState',
            method: 'POST',
            data: {
              id: id,
              user_token: _vue.getProfile.userToken,
              status: type
            },
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {

            _vue.getPractices();

            if (key == 'restore') {
              _vue.$swal('Preventivo N. ' + code + ' <br/>è stato ripristinato ', '', 'success');
            } else {
              _vue.$swal('Preventivo N. ' + code + ' <br/>è stato eliminato ', '', 'success');
            }
          }).catch(function (resp) {
            _vue.$swal('Ops. Riprova piu tardi', '', 'error');
          });
        }
      });
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Something went wrong!'
      });
    }
  },
  watch: {
    getProfile: function getProfile(val) {
      if (val) {
        this.$log(val);
        this.getPractices();
      }
    },
    filter: function filter(val) {
      this.filterValues();
    }
  },
  created: function created() {},
  mounted: function mounted() {

    if (this.getProfile) {
      this.getPractices();
    }

    this.$scrollTo('#app', 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0b1917","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superbonus/index.vue
var superbonus_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-md-5 pt-4 mb-5" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center text-left vaillantCont pt-4 mb-5"
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12 mb-5  center" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Indietro")]
                )
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var superbonus_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular center h0 widthFull" }, [
        _c("b", [_vm._v(" Superbonus 110% ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h5", [
        _vm._v(
          "Se vuoi gestire una pratica di Cessione del credito per il Superbonus 110% questi sono il documenti necessari\r\n          "
        ),
        _c("br"),
        _vm._v(
          "( seleziona l'elenco in base al tipo di unita immobiliare oggetto dell'intervento )"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs mt-5",
          attrs: { id: "myTab", role: "tablist" }
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link active black",
                attrs: {
                  id: "home-tab",
                  "data-toggle": "tab",
                  href: "#home",
                  role: "tab",
                  "aria-controls": "home",
                  "aria-selected": "true"
                }
              },
              [_vm._v("Unità Singola")]
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link black",
                attrs: {
                  id: "profile-tab",
                  "data-toggle": "tab",
                  href: "#profile",
                  role: "tab",
                  "aria-controls": "profile",
                  "aria-selected": "false"
                }
              },
              [_vm._v("Condominio")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tab-content", attrs: { id: "myTabContent" } }, [
        _c(
          "div",
          {
            staticClass: "tab-pane fade show active center",
            attrs: {
              id: "home",
              role: "tabpanel",
              "aria-labelledby": "home-tab"
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("img", {
                  staticClass: "img-fluid widthFull mt-4",
                  attrs: { src: __webpack_require__("FiR5") }
                })
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tab-pane fade",
            attrs: {
              id: "profile",
              role: "tabpanel",
              "aria-labelledby": "profile-tab"
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-md-9" }, [
                _c("img", {
                  staticClass: "img-fluid widthFull mt-4",
                  attrs: {
                    src: __webpack_require__("2czj")
                  }
                })
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-5 mt-5 center" }, [
      _c("h5", [
        _vm._v(
          "Per procedere con la gestione della pratica contatta il team fiscale di KPMG al numero 085 4210479\r\n          "
        ),
        _c("br"),
        _vm._v(" oppure invia una mail a "),
        _c(
          "a",
          {
            staticClass: "link yellow",
            attrs: { href: "mailto:IT-FM-Vaillant@kpmg.it" }
          },
          [_vm._v("***********@kpmg.it")]
        )
      ])
    ])
  }
]
superbonus_render._withStripped = true
var superbonus_esExports = { render: superbonus_render, staticRenderFns: superbonus_staticRenderFns }
/* harmony default export */ var components_superbonus = (superbonus_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b0b1917", superbonus_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/superbonus/index.vue
var superbonus_disposed = false
var superbonus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var superbonus___vue_template_functional__ = false
/* styles */
var superbonus___vue_styles__ = null
/* scopeId */
var superbonus___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var superbonus___vue_module_identifier__ = null
var superbonus_Component = superbonus_normalizeComponent(
  superbonus,
  components_superbonus,
  superbonus___vue_template_functional__,
  superbonus___vue_styles__,
  superbonus___vue_scopeId__,
  superbonus___vue_module_identifier__
)
superbonus_Component.options.__file = "src/components/superbonus/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0b0b1917", superbonus_Component.options)
  } else {
    hotAPI.reload("data-v-0b0b1917", superbonus_Component.options)
  }
  module.hot.dispose(function (data) {
    superbonus_disposed = true
  })
})()}

/* harmony default export */ var src_components_superbonus = (superbonus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/editCalc/hovalEditCalc.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var hovalEditCalc_moment = __webpack_require__("PJh5");

var hovalEditCalc_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';









// GET DOC LIST


/* harmony default export */ var hovalEditCalc = ({
  name: "hovalEditCalc",
  data: function data() {
    var _ref;

    return _ref = {
      //  ONLY FOR EDIT *****************************
      item: {},
      // *****************************
      documents: documents_documents,
      username: "",
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",

      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione"
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale"
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi"
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua"
        },
        /*5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },*/
        5: {
          name: "Collettore solare termico",
          value: "solare"
        },
        6: {
          name: "Altro Prodotto",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione"
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV"
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche"
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: "",
      resend_success: false,
      loadingState2: false,
      loadingState: false,

      passwordFieldType: "password",
      moment: hovalEditCalc_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [],

      accessories: [],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", ""), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", 0), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", true), defineProperty_default()(_ref, "priceDcast", 0), defineProperty_default()(_ref, "iva_altri_oneri", 0.22), defineProperty_default()(_ref, "iva_accessori_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_extra", 0.22), defineProperty_default()(_ref, "iva_age_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_accessori", 0.1), defineProperty_default()(_ref, "selectorModPrice", ""), defineProperty_default()(_ref, "age_lavoro", 0), defineProperty_default()(_ref, "age_extra", 0), defineProperty_default()(_ref, "priceNew", 0), defineProperty_default()(_ref, "pricenewFlag", false), defineProperty_default()(_ref, "costoAttualizazioneChange", false), defineProperty_default()(_ref, "serviceCostChange", false), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        _vue.$log("ECOBONUS => " + _vue.ecoBonus);
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.$log("clearExtraMise => " + _vue.clearExtraMise);
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(this.ecoBonus);

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab: function validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
    },

    validateSecondTab: function validateSecondTab() {
      this.$log(this.$validator);
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          setTimeout(function () {
            if (_vue.item.costoAttualizazione != "no") {
              _vue.calcInfo.costoAttualizazione = parseFloat(_vue.item.costoAttualizazione);
              _vue.costoAttualizazioneChange = true;
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
            }
            if (_vue.item.serviceCost != "no") {
              _vue.calcInfo.serviceCost = parseFloat(_vue.item.serviceCost);
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
              _vue.serviceCostChange = true;
            }
          }, 1000);

          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });

      this.$store.dispatch(user["d" /* USER_REQUEST */]);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function modPrice(selectorModPrice) {
      var _this = this;

      var txt = "";
      txt += "<br />Importo attuale : ";
      if (selectorModPrice == "oneri") {
        txt += (parseFloat(this.calcInfo.allOneri) - parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri))).toFixed(2);

        var titleV = "Modifica importo oneri finanaziari";
      }
      if (selectorModPrice == "pratica") {
        txt += (parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri))).toFixed(2);

        var titleV = "Modifica importo costi gestione pratica";
      }
      txt += " €";
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: titleV,
        html: txt + '<br /><br /><div class="group"><lable class="niceInputLable">Importo da aggiornare :</lable><input type="number" min="0" step="0.01" id="swal-input1" placeholder = "Importo .." class="swal2-input"></div>',
        placeholder: "Importo",
        inputAttributes: {
          autocapitalize: "off"
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost = parseFloat(_vue.priceNew) / (1 + parseFloat(_vue.iva_altri_oneri));
            _this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            _this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        }
      }).then(function (result) {});
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                _this2.$log("DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO");
                _this2.$log("client_type " + _this2.client_type);
                _this2.$log("selettore_titoloPossesso " + _this2.client_ownership);
                docTemp = _this2.documents[_this2.client_type];

                _this2.documents[_this2.client_type] = {};

                selettore_titoloPossesso = _this2.client_ownership;
                selettore_enea = _this2.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this2.documents[_this2.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this2.documents[_this2.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this2.documents[_this2.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onComplate: function onComplate() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingState = true;

                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;

                /////// NEW *******************************************************************
                data.oldItem = _this3.item;
                data.serviceCost = _this3.serviceCostChange ? _this3.calcInfo.serviceCost : "no";
                data.costoAttualizazione = _this3.costoAttualizazioneChange ? _this3.calcInfo.costoAttualizazione : "no";
                /////// NEW *******************************************************************

                // ALL USER DATA
                data.user = _this3.getProfile;
                _this3.$error(data.user);
                // BONUS SELECTED
                data.bonus = _this3.ecoBonus;
                // CLIENT DATA
                data.client_name = _this3.clientName;
                data.client_lastname = _this3.clientLastname;
                data.client_type = _this3.client_type;

                data.client_mobile = _this3.client_mobile;
                data.client_phone = _this3.client_phone;
                data.client_email = _this3.client_email;

                // NEWWWWWWWWW
                if (_this3.zeroEnea) {
                  data.client_price_enea = _this3.zeroEneaOld;
                } else {
                  data.client_price_enea = _this3.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this3.zeroDcast) {
                  data.client_price_dcast = _this3.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this3.priceDcast;
                }

                // CLIENT HOUSE DATA
                data.building_province = _this3.province;
                data.building_city = _this3.city.city;
                data.building_zip = _this3.zip;
                data.building_address = _this3.adress;
                data.building_civic = _this3.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this3.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this3.eventType;
                data.intervention_date = hovalEditCalc_moment(_this3.eventStartdate).format("YYYY-MM-DD");
                // PRODUCTS & ACCESSORIES
                data.products = _this3.products;
                data.accessories = _this3.accessories;
                data.enea_request = _this3.enea;
                data.created_at = hovalEditCalc_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = hovalEditCalc_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this3.totalProducts;
                data.total_accessories_price = _this3.totalAccessories;
                data.price_work = _this3.priceWork;

                data.total_transfer_for_user = _this3.calcInfo.aInstallatore;
                data.total_transfer_for_client = _this3.calcInfo.finalPrice;
                data.total_bonus_savings = _this3.calcInfo.totalWithBonus;

                data.total_work_and_iva = _this3.calcInfo.totalBaseAndIva;

                // HTML FOR PDF
                data.htmlInvoice = _this3.$refs.invoiceData.innerHTML;
                //requiredOperations: '',
                data.building_uso_abitativo = _this3.usoAbitativo;

                data.client_ownership = _this3.client_ownership;

                data.iva_altri_oneri = _this3.iva_altri_oneri;
                data.iva_accessori_lavoro = _this3.iva_accessori_lavoro;
                data.iva_age_extra = _this3.iva_age_extra;
                data.iva_age_lavoro = _this3.iva_age_lavoro;
                data.iva_age_accessori = _this3.iva_age_accessori;

                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/editPriceQuotation",
                  method: "POST",
                  data: data,
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "Il tuo preventivo è stato modificato!";
                  alert.type = "SUCCESS";
                  _this3.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this3.$swal({
                    type: "success",
                    title: "Preventivo modificato",
                    html: alert.text
                  });
                  _this3.loadingState = false;

                  _this3.$router.push("/offerte");
                }).catch(function (resp) {
                  _this3.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this3.loadingState = false;
                });

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = 800;
      }
      //var AttPercent = 10.58
      var AttPercent = 20;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "").replace(",", ".")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (parseFloat(totAltroAcc) * this.iva_accessori_lavoro + parseFloat(totAge) * this.iva_age_lavoro).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (parseFloat(this.age_extra) * this.iva_age_extra).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * this.iva_altri_oneri).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva = parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) + parseFloat(this.age_extra) * (1 + parseFloat(temp)) + parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      if (this.ecoBonus != "Bonus Casa 50%" && this.client_type == "Partita IVA" && this.usoAbitativo == 0 && this.iva_age_lavoro == "0.22" && this.iva_age_extra == "0.22" && this.iva_accessori_lavoro == "0.22") {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBase) / 100 * parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      }

      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.priceDcast) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        var haveCondensed = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },


    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      var count = this.products.length;

      if (count) {
        this.productIndex = this.productIndex + 1;
      }

      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      var count = this.accessories.length;

      if (count) {
        this.accessoriesIndex = this.accessoriesIndex + 1;
      }

      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = hovalEditCalc_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = hovalEditCalc_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = hovalEditCalc_numeral(this.priceDcast).format("0.0,[00]");
    },

    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      if (this.corporateClient) {
        var data = {
          key: "calc",
          cc: this.corporateClient
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
          method: "POST",
          data: {
            data: data
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.allProducts = resp.data.allProducts;
          _this5.$log(_this5.allProducts);
        }).catch(function (resp) {});
      } else {
        this.setProfile();
      }
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.corporateClient) this.loadProducts();
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = "";
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = hovalEditCalc_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      this.$log(1);
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);

        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        this.$log("START LOAD IBRIDE");

        this.$log(this.products[i]);
        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;
        this.$log("condensazione => " + condensazione);
        this.$log("pompadicalore => " + pompadicalore);

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          this.$log(this.allProducts["condensazione"][x].Modello + " = " + condensazione);
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          // this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*
        if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/

        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (this.eventType == "Instalazione" && this.ecoBonus == "Bonus Casa 50%") {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162: function warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text = "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }, 1000);
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    },
    warning16: function warning16() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning15: function warning15() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning2: function warning2() {
      var alert = {};
      alert.text = "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning1: function warning1() {
      var alert = {};
      alert.text = "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;

      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context3.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context3.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context3.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context3.next = 12;
                      break;
                    }

                    _vue.checkProductWithBonusRules(input);
                    return _context3.abrupt("return", result);

                  case 12:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 13:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, _this6);
          }));

          return function preConfirm(_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this7.allProducts;
                _context4.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 18;
                  break;
                }

                x = _context4.t1.value;
                _context4.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context4.t3 = _context4.t2()).done) {
                  _context4.next = 16;
                  break;
                }

                y = _context4.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context4.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context4.abrupt("return", data[x][y]);

              case 14:
                _context4.next = 5;
                break;

              case 16:
                _context4.next = 2;
                break;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        //new
        this.calcMaxPriceByKW(this.products[x].index);

        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = hovalEditCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE " + this.totalExtraMise);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;

      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        alert.type = "ERROR";
        this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
        this.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      if (this.accessories) {
        for (var x in this.accessories) {
          price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        }
      } else {
        price = false;
      }

      if (price) {
        this.totalAccessories = hovalEditCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
      this.accessories[i].price = hovalEditCalc_numeral(this.accessories[i].price).format("0.0,[00]");
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      // /this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context5.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context5.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context5.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context5.next = 11;
                      break;
                    }

                    return _context5.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _this9.allProducts;
                _context6.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 20;
                  break;
                }

                x = _context6.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context6.next = 18;
                  break;
                }

                _context6.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context6.t3 = _context6.t2()).done) {
                  _context6.next = 18;
                  break;
                }

                y = _context6.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context6.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context6.abrupt("return", data[x][y]);

              case 16:
                _context6.next = 6;
                break;

              case 18:
                _context6.next = 2;
                break;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },


    // NEWWWWWWWWWWWWWWWWWWWWWWWWWWW **************************************** ONLY FOR EDIT

    setCap: function setCap(cap) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this10.zips) {
                  if (_this10.zips[x].cap == cap.toUpperCase()) {
                    _this10.zip = _this10.zips[x].cap;
                  }
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    setCity: function setCity(city) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this11.cities) {
                  if (_this11.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this11.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this11.city = k;
                  }
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var x;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                for (x in _this12.provincies) {
                  if (_this12.provincies[x].sigla == province.toUpperCase()) {
                    _this12.province = _this12.provincies[x].sigla;
                  }
                }

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    getInvoiceProducts: function getInvoiceProducts(code) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getInvoiceProducts",
                  method: "POST",
                  data: {
                    code: code
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var items = resp.data.products;
                  var _vue = _this13;

                  _this13.$log(items);

                  _vue.productIndex = 0;
                  _vue.accessoriesIndex = 0;

                  var prodCount = 0;
                  var accCount = 0;

                  for (var x in items) {
                    // SET PRODUCTS

                    if (items[x].tipo == "product") {
                      _vue.addProduct();

                      // SET GROUP AND WAIT
                      _vue.products[prodCount].index = "product" + prodCount;
                      _vue.products[prodCount].indexCount = "quantity" + prodCount;
                      _vue.products[prodCount].group = items[x].gruppo;

                      _vue.setGroup(_vue.products[prodCount].index);

                      // FOR PRELOAD PRODUCTS OF THIS GROUP
                      setTimeout(function (x, items, Vue, prodCount) {
                        var y = {};

                        /////////////////////////////////////////////////////////////////////////
                        for (var u in _vue.items["product" + prodCount]) {
                          if (_vue.items["product" + prodCount][u]) {
                            if (_vue.items["product" + prodCount][u].Modello == items[x].nome) {
                              y.index = parseInt(u);
                            }
                          }
                        }

                        if (!y.index) {
                          y.index = accCount + 100;
                        }
                        //////////////////////////////////////////////////////////////////////////

                        y.name = items[x].nome;
                        y.serial = items[x].codice;
                        //_vue.products[x].product = y
                        _vue.products[prodCount].price = "";
                        _vue.products[prodCount].quantity = 1;

                        setTimeout(function (x, items, Vue, prodCount) {
                          var o = items[x].prezzo.replace(".", "");
                          _vue.products[prodCount].price = o;
                          _vue.products[prodCount].quantity = parseInt(items[x].quantita);
                          _vue.calcTotalPriceProducts();
                        }, 1000, x, items, Vue, prodCount);

                        _vue.products[prodCount].error = false;

                        _vue.$log(y);

                        var e = _vue.products[prodCount];
                        e.product = y;
                        Vue.set(_vue.products, prodCount, e);

                        _vue.setProduct(_vue.products[prodCount].index);
                      }, 1500, x, items, vue_esm["a" /* default */], prodCount);

                      prodCount = prodCount + 1;

                      //_vue.productIndex = prodCount
                    }
                    // SET ACCESORIES
                    else {
                        _vue.addAccessories();

                        // SET GROUP AND WAIT
                        _vue.accessories[accCount].index = "product" + accCount;
                        _vue.accessories[accCount].indexCount = "quantity" + accCount;
                        _vue.accessories[accCount].group = items[x].gruppo;
                        _vue.setTypeAccessories(_vue.accessories[accCount].index);

                        // FOR PRELOAD PRODUCTS OF THIS GROUP
                        setTimeout(function (x, items, Vue, accCount) {
                          var y = {};

                          for (var u in _vue.itemsAccessories["product" + accCount]) {
                            if (_vue.itemsAccessories["product" + accCount][u]) {
                              if (_vue.itemsAccessories["product" + accCount][u].Modello == items[x].nome) {
                                y.index = parseInt(u);
                              }
                            }
                          }

                          if (!y.index) {
                            y.index = accCount + 100;
                          }

                          y.name = items[x].nome;
                          y.serial = items[x].codice;

                          _vue.accessories[accCount].price = "";
                          _vue.accessories[accCount].quantity = 1;

                          //_vue.products[x].product = y
                          setTimeout(function (x, items, Vue, accCount) {
                            var p = items[x].prezzo.replace(".", "");
                            _vue.accessories[accCount].price = p;
                            _vue.accessories[accCount].quantity = parseInt(items[x].quantita);
                            _vue.calcTotalPriceAccessories();
                          }, 1000, x, items, Vue, accCount);

                          _vue.accessories[accCount].error = false;

                          var e = _vue.accessories[accCount];
                          e.product = y;
                          Vue.set(_vue.accessories, accCount, e);

                          _vue.setAccessories(_vue.accessories[accCount].index);
                        }, 1500, x, items, vue_esm["a" /* default */], accCount);

                        accCount = accCount + 1;

                        //_vue.accessoriesIndex = accCount
                      }
                  }
                }).catch(function (resp) {});

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    calcIvaCustom: function calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }
    }
  },
  watch: {
    client_type: function client_type(val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function usoAbitativo(val) {
      this.calcIvaCustom(this.client_type);
    },
    getProfile: function getProfile() {
      this.setProfile();
    },

    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this14 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this14.cities = resp.data.cities;
          _this14.citiesState = false;
        }).catch(function (resp) {
          _this14.cities = [];
          _this14.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this15 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this15.zips = resp.data.zips;
          _this15.zipsState = false;
        }).catch(function (resp) {
          _this15.zips = [];
          _this15.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    this.setProfile();
    this.loadProducts();
  },
  mounted: function mounted() {
    // NEWWWWWW ***************************************************************
    if (this.$route.params.item) {
      this.item = this.$route.params.item;
      var data = this.item;
      // START POPULATE DATA
      this.$log(data);
      this.setProfile();
      this.ecoBonus = data.bonus;
      // TAB 1 CLIENT
      this.clientLastname = data.client_name;
      this.clientName = data.client_lastname;
      this.adress = data.building_address;
      this.civic = data.building_civic;
      this.email = "";
      this.phone = "";
      this.mobile = "";
      this.provincies = [];
      this.province = "";
      this.provinciesState = true;
      this.cities = [];
      this.citiesState = false;
      this.zips = [];
      this.zipsState = false;
      this.cityError = false;
      this.zipError = false;
      this.city = "";
      this.zip = "";
      this.datiCatastali = parseInt(data.to_get_cadastral_data);

      this.client_mobile = data.client_mobile;
      this.client_phone = data.client_phone;
      this.client_email = data.client_email;
      //TAB2 INTERVENTO
      this.eventType = data.intervention_type;
      this.eventStartdate = data.intervention_date;

      this.totalAccessories = data.total_accessories_price;
      this.totalProducts = data.total_product_price;
      this.enea = parseInt(data.enea_request);
      this.requiredOperations = "";
      this.client_type = data.client_type;
      this.priceEnea = data.client_price_enea ? data.client_price_enea : "0";
      this.priceDcast = "0";

      this.priceWork = data.price_work;

      this.totalExtraMise = 0;
      this.NoEnea = true;

      this.client_ownership = data.client_ownership;

      var _vue = this;
      setTimeout(function () {
        _vue.usoAbitativo = parseInt(data.building_uso_abitativo);
        _vue.iva_altri_oneri = data.iva_altri_oneri;
        _vue.iva_accessori_lavoro = data.iva_accessori_lavoro;
        _vue.iva_age_extra = data.iva_age_extra;
        _vue.iva_age_lavoro = data.iva_age_lavoro;
        _vue.iva_age_accessori = data.iva_age_accessori;
      }, 2000);

      this.$log(" IVAAAAAAAAAAAAAAAAAAAAAAAAAA");
      this.$log(this.iva_altri_oneri);
      this.$log(this.iva_accessori_lavoro);
      this.$log(this.iva_age_extra);
      this.$log(this.iva_age_lavoro);
      this.$log(this.iva_age_accessori);

      //if (data && data.client_type != 'Amministratore di condominio') {
      if (data) {
        setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
          var province;
          return regenerator_default.a.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  province = _vue.item.building_province;
                  _context13.next = 3;
                  return _vue.setProvince(province);

                case 3:
                  _context13.next = 5;
                  return _vue.getInvoiceProducts(data.id);

                case 5:

                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                    var city;
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            city = _vue.item.building_city;
                            _context12.next = 3;
                            return _vue.setCity(city);

                          case 3:

                            setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                              var cap;
                              return regenerator_default.a.wrap(function _callee11$(_context11) {
                                while (1) {
                                  switch (_context11.prev = _context11.next) {
                                    case 0:
                                      cap = _vue.item.building_zip;
                                      _context11.next = 3;
                                      return _vue.setCap(cap);

                                    case 3:
                                    case "end":
                                      return _context11.stop();
                                  }
                                }
                              }, _callee11, this);
                            })), 1500);

                          case 4:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, this);
                  })), 1500);

                case 6:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        })), 1500);
      }
    } else {
      this.$router.push("/offerte");
    }

    // ***********************************************************************************************

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f02ad4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editCalc/hovalEditCalc.vue
var hovalEditCalc_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mt-5" }, [
    _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm.proccess == "START"
          ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
              _c("b", [
                _vm._v("Modifica preventivo N. " + _vm._s(_vm.item.code))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.proccess == "START"
          ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
              _vm._v(
                "\n        Compila i seguenti step. In caso di conferma del preventivo tutti i\n        dati inseriti verranno poi utilizzati per generare i documenti\n        richiesti per lo sconto in fattura.\n      "
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row justify-content-center pb-5" }, [
      _vm.proccess == "START"
        ? _c(
            "div",
            {
              staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
              staticStyle: { "margin-top": "0 !important" }
            },
            [
              _c(
                "form-wizard",
                {
                  staticClass: "mt-0 pb-2 formp",
                  attrs: {
                    title: "",
                    subtitle: "",
                    nextButtonText: "Avanti >",
                    backButtonText: "< Indietro",
                    finishButtonText: "Salva preventivo",
                    stepSize: _vm.stepSize,
                    color: "#00337f",
                    errorColor: "#ff1100"
                  },
                  on: {
                    "on-change": _vm.stepIndex,
                    "on-complete": _vm.onComplate
                  }
                },
                [
                   true
                    ? _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Scegli Bonus",
                            icon: "",
                            "before-change": _vm.validateZeroTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull",
                              attrs: {
                                "data-vv-scope": "form-0",
                                autocomplete: "qwerqrt2"
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row justify-content-center pb-4"
                                },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "pb-0 center section-heading"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Clicca sull`icona del bonus al quale vuoi aderire.\n                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 col-md-3 pr-2 pl-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "selectBonusCont pt-5 pb-4 mb-4",
                                          class: {
                                            bonusSelected:
                                              _vm.ecoBonus == "Bonus Casa 50%"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setBonus(
                                                "Bonus Casa 50%"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusContBack",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Se vuoi aderire al\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v("Bonus Casa 50% "),
                                              _c("br"),
                                              _vm._v(
                                                "Clicca qui >\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Bonus Casa 50%"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("6PKJ")
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("DaEW")
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black",
                                              class: {
                                                white:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Bonus Casa\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 col-md-3 pr-2 pl-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "selectBonusCont pt-5 pb-4 mb-4",
                                          class: {
                                            bonusSelected:
                                              _vm.ecoBonus == "Ecobonus 50%"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setBonus(
                                                "Ecobonus 50%"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusContBack",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Se vuoi aderire al\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v("Ecobonus 50% "),
                                              _c("br"),
                                              _vm._v(
                                                "Clicca qui >\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Ecobonus 50%"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("6PKJ")
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("DaEW")
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black",
                                              class: {
                                                white:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Ecobonus\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 col-md-3 pr-2 pl-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "selectBonusCont pt-5 pb-4 mb-4",
                                          class: {
                                            bonusSelected:
                                              _vm.ecoBonus == "Ecobonus 65%"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setBonus(
                                                "Ecobonus 65%"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusContBack",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Se vuoi aderire al\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v("Ecobonus 65% "),
                                              _c("br"),
                                              _vm._v(
                                                "Clicca qui >\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Ecobonus 65%"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("w/IJ")
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("CXbD")
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black",
                                              class: {
                                                white:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Ecobonus\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-12 mb-3",
                                      staticStyle: { display: "none" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "group custInput" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.ecoBonus,
                                                expression: "ecoBonus"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-0.ecoBonus"
                                              ),
                                              valid: !!_vm.ecoBonus
                                            },
                                            attrs: {
                                              type: "text",
                                              id: "ecobonus",
                                              name: "ecobonus",
                                              "data-vv-as": "ecoBonus"
                                            },
                                            domProps: { value: _vm.ecoBonus },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.ecoBonus =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 mb-3 center" },
                                    [
                                      _vm.errors.has("form-0.ecobonus")
                                        ? _c("div", { staticClass: "red" }, [
                                            _c("b", { staticClass: "h5 red" }, [
                                              _vm._v(
                                                "Per procedere devi selezionare una tra le quattro icone\n                    sopraindicate.\n                  "
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12 mb-3" }, [
                                    _vm._v(
                                      "\n                Novatag e KPMG, non si ritengono responsabili per eventuali\n                danni economici derivanti dall.utilizo della piattaforma e\n                dall.informazioni fornite.\n              "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                   true
                    ? _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Dati Cliente",
                            icon: "",
                            "before-change": _vm.validateFirstTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull",
                              attrs: {
                                "data-vv-scope": "form-1",
                                autocomplete: "qwerqrt2"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                  Dati del cliente finale\n                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.client_type,
                                                expression: "client_type"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.client_type"
                                              ),
                                              valid: !!_vm.client_type
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "client_type",
                                              name: "client_type",
                                              "data-vv-as": "Tipologia cliente"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.client_type = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "Persona fisica"
                                                }
                                              },
                                              [_vm._v("Persona fisica")]
                                            ),
                                            _vm._v(" "),
                                            _vm.ecoBonus != "Bonus Casa 50%"
                                              ? _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "Partita IVA"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Partita IVA\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value:
                                                    "Amministratore di condominio"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Condominio (Amministratore)\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_type" }
                                          },
                                          [_vm._v("Tipologia cliente")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_type")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_type"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.clientName,
                                              expression: "clientName"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 63,
                                                min: 2
                                              },
                                              expression:
                                                "{ required: true, max: 63, min: 2 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.clientName"
                                            ),
                                            valid: !!_vm.clientName
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "clientName",
                                            name: "clientName",
                                            "data-vv-as": "Nome"
                                          },
                                          domProps: { value: _vm.clientName },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.clientName =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "clientName" }
                                          },
                                          [_vm._v("Nome")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.clientName")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.clientName"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.clientLastname,
                                              expression: "clientLastname"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 63,
                                                min: 2
                                              },
                                              expression:
                                                "{ required: true, max: 63, min: 2 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.clientLastname"
                                            ),
                                            valid: !!_vm.clientLastname
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "clientLastname",
                                            name: "clientLastname",
                                            "data-vv-as": "Cognome"
                                          },
                                          domProps: {
                                            value: _vm.clientLastname
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.clientLastname =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "clientLastname" }
                                          },
                                          [_vm._v("Cognome")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.clientLastname")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.clientLastname"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client_email,
                                              expression: "client_email"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                email: true,
                                                temporaryEmail: true,
                                                plusIssueEmail: true,
                                                max: 56
                                              },
                                              expression:
                                                "{\n                      required: true,\n                      email: true,\n                      temporaryEmail: true,\n                      plusIssueEmail: true,\n                      max: 56,\n                    }"
                                            }
                                          ],
                                          ref: "client_email",
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.client_email"
                                            ),
                                            valid: !!_vm.client_email
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "client_email",
                                            name: "client_email",
                                            "data-vv-as": "Email"
                                          },
                                          domProps: { value: _vm.client_email },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.client_email =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_email" }
                                          },
                                          [_vm._v("Email*\n                  ")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_email")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_email"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client_phone,
                                              expression: "client_phone"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: false,
                                                max: 12,
                                                min: 8,
                                                regex: /^[0]+/
                                              },
                                              expression:
                                                "{\n                      required: false,\n                      max: 12,\n                      min: 8,\n                      regex: /^[0]+/,\n                    }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.client_phone"
                                            ),
                                            valid: !!_vm.client_phone
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "client_phone",
                                            name: "client_phone",
                                            "data-vv-as": "Telefono"
                                          },
                                          domProps: { value: _vm.client_phone },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.client_phone =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_phone" }
                                          },
                                          [
                                            _vm._v(
                                              "Telefono\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_phone")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_phone"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client_mobile,
                                              expression: "client_mobile"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 12,
                                                min: 8,
                                                regex: /^[3]+/
                                              },
                                              expression:
                                                "{\n                      required: true,\n                      max: 12,\n                      min: 8,\n                      regex: /^[3]+/,\n                    }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.client_mobile"
                                            ),
                                            valid: !!_vm.client_mobile
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "client_mobile",
                                            name: "client_mobile",
                                            "data-vv-as": "Cellulare"
                                          },
                                          domProps: {
                                            value: _vm.client_mobile
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.client_mobile =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_mobile" }
                                          },
                                          [
                                            _vm._v(
                                              "Cellulare *\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_mobile")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_mobile"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.ecoBonus != "Bonus Casa 50%"
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-6 mb-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-check" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "group" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label widthFull black h5",
                                                      attrs: {
                                                        for: "usoAbitativo"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Prevalente uso abitativo\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check form-check-inline mt-2"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.usoAbitativo = 1
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.usoAbitativo,
                                                                expression:
                                                                  "usoAbitativo"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required|included:1,0",
                                                                expression:
                                                                  "'required|included:1,0'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-check-input inline mr-3",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-1.usoAbitativo"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "radio",
                                                              value: "1",
                                                              name:
                                                                "usoAbitativo"
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm.usoAbitativo,
                                                                "1"
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                _vm.usoAbitativo =
                                                                  "1"
                                                              }
                                                            }
                                                          }),
                                                          _c("b", [
                                                            _vm._v("SI")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check form-check-inline"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.usoAbitativo = 0
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.usoAbitativo,
                                                                expression:
                                                                  "usoAbitativo"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-check-input inline mr-3",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-1.usoAbitativo"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "radio",
                                                              value: "0",
                                                              name:
                                                                "usoAbitativo"
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm.usoAbitativo,
                                                                "0"
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                _vm.usoAbitativo =
                                                                  "0"
                                                              }
                                                            }
                                                          }),
                                                          _c("b", [
                                                            _vm._v("NO")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: _vm.errors.has(
                                                            "form-1.usoAbitativo"
                                                          ),
                                                          expression:
                                                            "errors.has('form-1.usoAbitativo')"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "errorMes red"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Il servizio deve essere accettato oppure rifiutato\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "widthFull center black pb-4"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  L'indirizzo dell'immobile\n                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.province,
                                                expression: "province"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.province"
                                              ),
                                              valid: !!_vm.province
                                            },
                                            attrs: {
                                              autocomplete: "randomy",
                                              id: "province",
                                              name: "province",
                                              "data-vv-as": "Provincia"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.province = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                disabled: "",
                                                value: "",
                                                selected: "selected"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.provincies, function(
                                              province
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: province.sigla,
                                                  domProps: {
                                                    value: province.sigla
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(province.sigla) +
                                                      " - " +
                                                      _vm._s(
                                                        province.provincia
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "province" }
                                          },
                                          [_vm._v("Provincia")]
                                        ),
                                        _vm._v(" "),
                                        _vm.provinciesState
                                          ? _c(
                                              "div",
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "loadSpinner",
                                                  attrs: {
                                                    id: "loadProvince",
                                                    icon: "spinner",
                                                    size: "1x",
                                                    pulse: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.province")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.province"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _vm.cityError
                                          ? _c(
                                              "span",
                                              { staticClass: "formError" },
                                              [_vm._v("Prima scegli Provincia")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.city,
                                                expression: "city"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.city"
                                              ),
                                              valid: !!_vm.city
                                            },
                                            attrs: {
                                              autocomplete: "randomu",
                                              id: "city",
                                              name: "city",
                                              "data-vv-as": "Località",
                                              disabled: _vm.citiesState
                                            },
                                            on: {
                                              click: _vm.checkProvince,
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.city = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                disabled: "",
                                                value: "",
                                                selected: "selected"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.cities, function(city) {
                                              return _c(
                                                "option",
                                                {
                                                  key: city.comune,
                                                  domProps: {
                                                    value: {
                                                      cityistat: city.istat,
                                                      city: city.comune
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(city.comune) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "city" }
                                          },
                                          [_vm._v("Località")]
                                        ),
                                        _vm._v(" "),
                                        _vm.citiesState
                                          ? _c(
                                              "div",
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "loadSpinner",
                                                  attrs: {
                                                    id: "loadCity",
                                                    icon: "spinner",
                                                    size: "1x",
                                                    pulse: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.city")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.city"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _vm.zipError
                                          ? _c(
                                              "span",
                                              { staticClass: "formError" },
                                              [_vm._v("Prima scegli città")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.zip,
                                                expression: "zip"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.zip"
                                              ),
                                              valid: !!_vm.zip
                                            },
                                            attrs: {
                                              autocomplete: "randomi",
                                              id: "zip",
                                              name: "zip",
                                              "data-vv-as": "Cap",
                                              disabled: _vm.zipsState
                                            },
                                            on: {
                                              click: _vm.checkZip,
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.zip = $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: ""
                                              },
                                              domProps: { selected: true }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.zips, function(zip) {
                                              return _c(
                                                "option",
                                                {
                                                  key: zip.cap,
                                                  domProps: { value: zip.cap }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(zip.cap) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "zip" }
                                          },
                                          [_vm._v("Cap")]
                                        ),
                                        _vm._v(" "),
                                        _vm.zipsState
                                          ? _c(
                                              "div",
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "loadSpinner",
                                                  attrs: {
                                                    id: "loadZips",
                                                    icon: "spinner",
                                                    size: "1x",
                                                    pulse: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.zip")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.zip"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.adress,
                                              expression: "adress"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 128,
                                                min: 5
                                              },
                                              expression:
                                                "{ required: true, max: 128, min: 5 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.adress"
                                            ),
                                            valid: !!_vm.adress
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "adress",
                                            name: "adress",
                                            "data-vv-as": "Indirizzo"
                                          },
                                          domProps: { value: _vm.adress },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.adress = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "adress" }
                                          },
                                          [_vm._v("Indirizzo")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.adress")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.adress"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.civic,
                                              expression: "civic"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 15,
                                                min: 1
                                              },
                                              expression:
                                                "{ required: true, max: 15, min: 1 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.civic"
                                            ),
                                            valid: !!_vm.civic
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "civic",
                                            name: "civic",
                                            "data-vv-as": "Civico"
                                          },
                                          domProps: { value: _vm.civic },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.civic = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "civic" }
                                          },
                                          [_vm._v("Civico")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.civic")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.civic"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      attrs: {
                        title: "Dati Intervento",
                        icon: "",
                        "before-change": _vm.validateSecondTab
                      }
                    },
                    [
                      _c(
                        "form",
                        {
                          staticClass: "widthFull orangeBg",
                          attrs: {
                            "data-vv-scope": "form-2",
                            autocomplete: "qwerqrt3"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [_vm._v("Dati dell'intervento")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6 mb-3" }, [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.eventType,
                                          expression: "eventType"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 63,
                                            min: 2
                                          },
                                          expression:
                                            "{ required: true, max: 63, min: 2 }"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "form-2.eventType"
                                        ),
                                        valid: !!_vm.eventType
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "eventType",
                                        name: "eventType",
                                        "data-vv-as": "Tipo di intervento"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.eventType = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", {
                                        attrs: {
                                          value: "",
                                          disabled: "",
                                          selected: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "sostituzione" } },
                                        [_vm._v("Sostituzione")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Instalazione" } },
                                        [_vm._v("Nuova Installazione")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "eventType" }
                                    },
                                    [_vm._v("Tipo di intervento")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("form-2.eventType")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "form-2.eventType"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [_vm._v("Beni Significativi")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "widthFull" },
                                    _vm._l(_vm.products, function(elem, num) {
                                      return _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-md-3" }, [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: elem.group,
                                                      expression: "elem.group"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        is_not: ""
                                                      },
                                                      expression:
                                                        "{ required: true, is_not: '' }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.g" + elem.index
                                                    ),
                                                    valid: !!elem.group
                                                  },
                                                  attrs: {
                                                    id: "g" + elem.index,
                                                    name: "g" + elem.index,
                                                    "data-vv-as": "Gruppo"
                                                  },
                                                  on: {
                                                    change: [
                                                      function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          elem,
                                                          "group",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                      function($event) {
                                                        return _vm.setGroup(
                                                          elem.index
                                                        )
                                                      }
                                                    ]
                                                  }
                                                },
                                                [
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                                    ? [
                                                        _vm._l(
                                                          _vm.groups,
                                                          function(item) {
                                                            return [
                                                              item.value ==
                                                                "condensazione" ||
                                                              item.value ==
                                                                "altroVaillant"
                                                                ? _c(
                                                                    "option",
                                                                    {
                                                                      attrs: {
                                                                        selected:
                                                                          "selected"
                                                                      },
                                                                      domProps: {
                                                                        value:
                                                                          item.value
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            item.name
                                                                          ) +
                                                                          "\n                              "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        )
                                                      ]
                                                    : _vm.ecoBonus ==
                                                      "Ecobonus 65%"
                                                    ? [
                                                        _vm._l(
                                                          _vm.groups,
                                                          function(item) {
                                                            return [
                                                              item.value !=
                                                              "tradizionale"
                                                                ? _c(
                                                                    "option",
                                                                    {
                                                                      attrs: {
                                                                        selected:
                                                                          "selected"
                                                                      },
                                                                      domProps: {
                                                                        value:
                                                                          item.value
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            item.name
                                                                          ) +
                                                                          "\n                              "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        )
                                                      ]
                                                    : [
                                                        _vm._l(
                                                          _vm.groups,
                                                          function(item) {
                                                            return [
                                                              _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    selected:
                                                                      "selected"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      item.value
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                " +
                                                                      _vm._s(
                                                                        item.name
                                                                      ) +
                                                                      "\n                              "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "niceInputLabel",
                                                  attrs: { for: "group" }
                                                },
                                                [
                                                  _vm._v(
                                                    "Scegli gruppo prodotto"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-2.g" + elem.index
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-2.g" +
                                                                elem.index
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-5" }, [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              elem.group != "ibridi" &&
                                              elem.group != "altroVaillant"
                                                ? _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.product,
                                                          expression:
                                                            "elem.product"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            is_not: ""
                                                          },
                                                          expression:
                                                            "{ required: true, is_not: '' }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.p" +
                                                            elem.index
                                                        ),
                                                        valid: !!elem.product
                                                      },
                                                      attrs: {
                                                        id: "p" + elem.index,
                                                        name: "p" + elem.index,
                                                        "data-vv-as": "Prodotto"
                                                      },
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              elem,
                                                              "product",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function($event) {
                                                            return _vm.setProduct(
                                                              elem.index
                                                            )
                                                          }
                                                        ],
                                                        click: _vm.checkIfEmpty
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.items[elem.index],
                                                      function(item, ind) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              value: {
                                                                index: ind,
                                                                name:
                                                                  item.Modello,
                                                                serial:
                                                                  item.codice
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  item.Modello
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : elem.group == "altroVaillant"
                                                ? _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          elem.product.name,
                                                        expression:
                                                          "elem.product.name"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          is_not: ""
                                                        },
                                                        expression:
                                                          "{ required: true, is_not: '' }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-2.p" + elem.index
                                                      ),
                                                      valid: !!elem.product
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "p" + elem.index,
                                                      name: "p" + elem.index,
                                                      "data-vv-as": "Prodotto"
                                                    },
                                                    domProps: {
                                                      value: elem.product.name
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.setProduct(
                                                          elem.index
                                                        )
                                                      },
                                                      click: _vm.checkIfEmpty,
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          elem.product,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.product,
                                                          expression:
                                                            "elem.product"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            is_not: ""
                                                          },
                                                          expression:
                                                            "{ required: true, is_not: '' }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.p" +
                                                            elem.index
                                                        ),
                                                        valid: !!elem.product
                                                      },
                                                      attrs: {
                                                        id: "p" + elem.index,
                                                        name: "p" + elem.index,
                                                        "data-vv-as": "Prodotto"
                                                      },
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              elem,
                                                              "product",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function($event) {
                                                            return _vm.setProduct(
                                                              elem.index
                                                            )
                                                          }
                                                        ],
                                                        click: _vm.checkIfEmpty
                                                      }
                                                    },
                                                    _vm._l(
                                                      _vm.items[elem.index],
                                                      function(item, ind) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            domProps: {
                                                              selected:
                                                                item.Modello ==
                                                                elem.product
                                                                  .name,
                                                              value: {
                                                                index: ind,
                                                                name:
                                                                  item.Modello,
                                                                serial:
                                                                  item.codice
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  item.Modello
                                                                ) +
                                                                "\n                            " +
                                                                _vm._s(
                                                                  item.ModelloPompaDiCalore
                                                                ) +
                                                                " +\n                            " +
                                                                _vm._s(
                                                                  item.ModelloCaldaiaACondensazione
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "niceInputLabel",
                                                  attrs: { for: "product" }
                                                },
                                                [_vm._v("Scegli Prodotto")]
                                              ),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-2.p" + elem.index
                                              ) && !elem.error
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-2.p" +
                                                                elem.index
                                                            )
                                                          ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              elem.error
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          Prima scegli gruppo\n                        "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-2 mr-md-0 pr-md-0"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: elem.quantity,
                                                      expression:
                                                        "elem.quantity"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        is_not: "0",
                                                        min_value: 1,
                                                        max: 4
                                                      },
                                                      expression:
                                                        "{\n                            required: true,\n                            is_not: '0',\n                            min_value: 1,\n                            max: 4,\n                          }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.q" +
                                                        elem.indexCount
                                                    ),
                                                    valid: !!elem.quantity
                                                  },
                                                  attrs: {
                                                    type: "number",
                                                    id: "q" + elem.indexCount,
                                                    min: "1",
                                                    name: "q" + elem.indexCount,
                                                    "data-vv-as": "Quantità"
                                                  },
                                                  domProps: {
                                                    value: elem.quantity
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.calcTotalPriceProducts()
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        elem,
                                                        "quantity",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: elem.indexCount
                                                    }
                                                  },
                                                  [_vm._v("Quantità")]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.q" + elem.indexCount
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.q" +
                                                                  elem.indexCount
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-2 pl-md-0 ml-md-0"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "group custInput"
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: elem.price,
                                                      expression: "elem.price"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: true,
                                                        is_not: "0"
                                                      },
                                                      expression:
                                                        "{ required: true, is_not: '0' }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.i" +
                                                        elem.indexCount
                                                    ),
                                                    valid: !!elem.price
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "i" + elem.indexCount,
                                                    min: "1",
                                                    name: "i" + elem.indexCount,
                                                    "data-vv-as": "Prezzo"
                                                  },
                                                  domProps: {
                                                    value: elem.price
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.formatPrice(
                                                        elem.index
                                                      ),
                                                        _vm.calcTotalPriceProducts()
                                                    },
                                                    keyup: function($event) {
                                                      return _vm.keymonitor(
                                                        $event,
                                                        elem.index,
                                                        "prod"
                                                      )
                                                    },
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        elem,
                                                        "price",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "highlight"
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "bar"
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: {
                                                      for: elem.indexCount
                                                    }
                                                  },
                                                  [_vm._v("Prezzo €")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "widthFull center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          (IVA esclusa)\n                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.errors.has(
                                                  "form-2.i" + elem.indexCount
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invalid-feedback"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "form-2.i" +
                                                                  elem.indexCount
                                                              )
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "removeProduct pointer",
                                                class: elem.index
                                              },
                                              [
                                                num != 0
                                                  ? _c("font-awesome-icon", {
                                                      attrs: {
                                                        icon: "trash-alt",
                                                        size: "lg"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeProduct(
                                                            num
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 mb-3 text-left pr-4"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pointer helper btn btn-secondary",
                                            on: { click: _vm.addProduct }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass:
                                                "helper pointer addProduct",
                                              attrs: {
                                                icon: "plus-circle",
                                                size: "1x"
                                              },
                                              on: { click: _vm.addProduct }
                                            }),
                                            _vm._v(
                                              "\n                      Aggiungi prodotto\n                    "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Totale importo prodotti (IVA esclusa):\n                    "
                                        ),
                                        _c("span", { staticClass: "Bold" }, [
                                          _vm._v(
                                            _vm._s(_vm.totalProducts) + " €"
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "widthFull center black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Altri Beni/Accessori opzionali\n                    "
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.accessories, function(elem, num) {
                                    return _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: elem.group,
                                                    expression: "elem.group"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {},
                                                    expression: "{}"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-2.ac" + elem.index
                                                  ),
                                                  valid: !!elem.group
                                                },
                                                attrs: {
                                                  id: "ac" + elem.index,
                                                  name: "ac" + elem.index,
                                                  "data-vv-as":
                                                    "accessori opzionali"
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        elem,
                                                        "group",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.setTypeAccessories(
                                                        elem.index
                                                      )
                                                    }
                                                  ]
                                                }
                                              },
                                              _vm._l(
                                                _vm.groupsAccessori,
                                                function(item) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        selected: "selected"
                                                      },
                                                      domProps: {
                                                        value: item.value
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(item.name) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "niceInputLabel",
                                                attrs: { for: "group" }
                                              },
                                              [
                                                _vm._v(
                                                  "Scegli accessori opzionali"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.has(
                                              "form-2.ac" + elem.index
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.ac" +
                                                              elem.index
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-5" }, [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            elem.group == "termoregolazione"
                                              ? _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: elem.product,
                                                        expression:
                                                          "elem.product"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            elem.group != ""
                                                        },
                                                        expression:
                                                          "{ required: elem.group != '' }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-2.ap" + elem.index
                                                      ),
                                                      valid: !!elem.product
                                                    },
                                                    attrs: {
                                                      id: "ap" + elem.index,
                                                      name: "ap" + elem.index,
                                                      "data-vv-as": "Accessorio"
                                                    },
                                                    on: {
                                                      change: [
                                                        function($event) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.$set(
                                                            elem,
                                                            "product",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                        function($event) {
                                                          return _vm.setAccessories(
                                                            elem.index
                                                          )
                                                        }
                                                      ],
                                                      click: _vm.checkIfEmpty
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.itemsAccessories[
                                                      elem.index
                                                    ],
                                                    function(item, ind) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            selected: "selected"
                                                          },
                                                          domProps: {
                                                            value: {
                                                              index: ind,
                                                              name:
                                                                item.Modello,
                                                              serial:
                                                                item.codice
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                item.Modello
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: elem.product.name,
                                                      expression:
                                                        "elem.product.name"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required:
                                                          elem.group != "",
                                                        max: 128
                                                      },
                                                      expression:
                                                        "{ required: elem.group != '', max: 128 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ),
                                                    valid: !!elem.product.name
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "ap" + elem.index,
                                                    name: "ap" + elem.index,
                                                    "data-vv-as": "Accessorio"
                                                  },
                                                  domProps: {
                                                    value: elem.product.name
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        elem.product,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            elem.group == "termoregolazione"
                                              ? _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "product" }
                                                  },
                                                  [_vm._v("Scegli Accessorio")]
                                                )
                                              : _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "product" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Inserisci Accessorio"
                                                    )
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _vm.errors.has(
                                              "form-2.ap" + elem.index
                                            ) && !elem.error
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.ap" +
                                                              elem.index
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            elem.error
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        Prima scegli tipo\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-2 mr-md-0 pr-md-0"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: elem.quantity,
                                                    expression: "elem.quantity"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        elem.group != "",
                                                      is_not: "0",
                                                      min_value: 1,
                                                      max: 4
                                                    },
                                                    expression:
                                                      "{\n                          required: elem.group != '',\n                          is_not: '0',\n                          min_value: 1,\n                          max: 4,\n                        }"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-2.aq" +
                                                      elem.indexCount
                                                  ),
                                                  valid: !!elem.quantity
                                                },
                                                attrs: {
                                                  type: "number",
                                                  id: "aq" + elem.indexCount,
                                                  min: "1",
                                                  name: "aq" + elem.indexCount,
                                                  "data-vv-as": "Quantità"
                                                },
                                                domProps: {
                                                  value: elem.quantity
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.calcTotalPriceAccessories()
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      elem,
                                                      "quantity",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "niceInputLabel",
                                                  attrs: {
                                                    for: elem.indexCount
                                                  }
                                                },
                                                [_vm._v("Quantità")]
                                              ),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-2.aq" + elem.indexCount
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-2.aq" +
                                                                elem.indexCount
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-2 pl-md-0 ml-md-0"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: elem.price,
                                                    expression: "elem.price"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        elem.group != "",
                                                      is_not: "0"
                                                    },
                                                    expression:
                                                      "{\n                          required: elem.group != '',\n                          is_not: '0',\n                        }"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-2.ai" +
                                                      elem.indexCount
                                                  ),
                                                  valid: !!elem.price
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ai" + elem.indexCount,
                                                  min: "1",
                                                  name: "ai" + elem.indexCount,
                                                  "data-vv-as": "Prezzo"
                                                },
                                                domProps: { value: elem.price },
                                                on: {
                                                  change: function($event) {
                                                    _vm.formatPriceAccessories(
                                                      elem.index
                                                    )
                                                    _vm.calcTotalPriceAccessories()
                                                  },
                                                  keyup: function($event) {
                                                    return _vm.keymonitor(
                                                      $event,
                                                      elem.index,
                                                      "accs"
                                                    )
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      elem,
                                                      "price",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "niceInputLabel",
                                                  attrs: {
                                                    for: elem.indexCount
                                                  }
                                                },
                                                [_vm._v("Prezzo €")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "widthFull center"
                                                },
                                                [_vm._v(" (IVA esclusa) ")]
                                              ),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-2.ai" + elem.indexCount
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-2.ai" +
                                                                elem.indexCount
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "removeProduct pointer",
                                              class: elem.index
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "trash-alt",
                                                  size: "lg"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeAccessories(
                                                      num
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 mb-3 text-left pr-4"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pointer helper btn btn-secondary",
                                            on: { click: _vm.addAccessories }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass:
                                                "helper pointer addProduct",
                                              attrs: {
                                                icon: "plus-circle",
                                                size: "1x"
                                              },
                                              on: { click: _vm.addAccessories }
                                            }),
                                            _vm._v(
                                              "\n                      Aggiungi accessorio\n                    "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Totale importo accessori opzionali (IVA esclusa):\n                    "
                                        ),
                                        _c("span", { staticClass: "Bold" }, [
                                          _vm._v(
                                            _vm._s(_vm.totalAccessories) + " €"
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-4" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "widthFull center black"
                                        },
                                        [_vm._v("Pratica ENEA")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 mb-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.priceEnea,
                                                  expression: "priceEnea"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required: true,
                                                    max: 63,
                                                    min: 2
                                                  },
                                                  expression:
                                                    "{ required: true, max: 63, min: 2 }"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "is-invalid": _vm.errors.has(
                                                  "form-2.priceEnea"
                                                ),
                                                valid: !!_vm.priceEnea
                                              },
                                              attrs: {
                                                type: "text",
                                                autocomplete: "randomq",
                                                id: "priceEnea",
                                                name: "priceEnea",
                                                "data-vv-as":
                                                  "Costo Gestione Pratica ENEA"
                                              },
                                              domProps: {
                                                value: _vm.priceEnea
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.formatpriceEnea()
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.priceEnea =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "niceInputLabel",
                                                attrs: { for: "priceEnea" }
                                              },
                                              [
                                                _vm._v(
                                                  "Costo Gestione Pratica ENEA"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                "Valore che sarà addebitato al cliente "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.errors.has("form-2.priceEnea")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.priceEnea"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !_vm.NoEnea
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-check" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "group" },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label widthFull black h5",
                                                        attrs: {
                                                          for: "datiCatastali"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Servizio di redazione e invio pratica ENEA ad un\n                          costo di €50 +IVA ( costo che ti sarà addebitato se\n                          accetti il servizio )\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check form-check-inline mt-2"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.enea = 1
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.enea,
                                                                  expression:
                                                                    "enea"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required|included:1,0",
                                                                  expression:
                                                                    "'required|included:1,0'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-check-input inline mr-3",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.enea"
                                                                )
                                                              },
                                                              attrs: {
                                                                type: "radio",
                                                                value: "1",
                                                                name: "enea"
                                                              },
                                                              domProps: {
                                                                checked: _vm._q(
                                                                  _vm.enea,
                                                                  "1"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.enea = "1"
                                                                }
                                                              }
                                                            }),
                                                            _c("b", [
                                                              _vm._v("ACCETTO")
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check form-check-inline"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.enea = 0
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.enea,
                                                                  expression:
                                                                    "enea"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required|included:1,0",
                                                                  expression:
                                                                    "'required|included:1,0'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-check-input inline mr-3",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.enea"
                                                                )
                                                              },
                                                              attrs: {
                                                                type: "radio",
                                                                value: "0",
                                                                name: "enea"
                                                              },
                                                              domProps: {
                                                                checked: _vm._q(
                                                                  _vm.enea,
                                                                  "0"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.enea = "0"
                                                                }
                                                              }
                                                            }),
                                                            _c("b", [
                                                              _vm._v(
                                                                "NON ACCETTO"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: _vm.errors.has(
                                                              "form-2.enea"
                                                            ),
                                                            expression:
                                                              "errors.has('form-2.enea')"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "errorMes red"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Il servizio deve essere accettato oppure rifiutato\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-4" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "widthFull center black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Installazione e Posa in Opera\n                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 mb-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.priceWork,
                                                  expression: "priceWork"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required: true,
                                                    max: 63,
                                                    min: 2
                                                  },
                                                  expression:
                                                    "{ required: true, max: 63, min: 2 }"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "is-invalid": _vm.errors.has(
                                                  "form-2.priceWork"
                                                ),
                                                valid: !!_vm.priceWork
                                              },
                                              attrs: {
                                                type: "text",
                                                autocomplete: "randomq",
                                                id: "priceWork",
                                                name: "priceWork",
                                                "data-vv-as":
                                                  "Importo installazione/posa in opera"
                                              },
                                              domProps: {
                                                value: _vm.priceWork
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.formatpriceWork()
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.priceWork =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "niceInputLabel",
                                                attrs: { for: "priceWork" }
                                              },
                                              [
                                                _vm._v(
                                                  "Importo installazione/posa in opera ( IVA esclusa\n                        )"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.has("form-2.priceWork")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.priceWork"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Totale importo (IVA esclusa):\n                    "
                                        ),
                                        _c("span", { staticClass: "Bold" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  (
                                                    parseFloat(
                                                      _vm.totalProducts
                                                        .replace(".", "")
                                                        .replace(",", ".")
                                                    ) +
                                                    parseFloat(
                                                      _vm.totalAccessories
                                                        .replace(".", "")
                                                        .replace(",", ".")
                                                    ) +
                                                    parseFloat(
                                                      _vm.priceWork
                                                        .replace(".", "")
                                                        .replace(",", ".")
                                                    )
                                                  ).toFixed(2)
                                                )
                                              ) +
                                              "\n                      €\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _vm.getProfile.reg_forfettario != "si"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row justify-content-center pt-2 pb-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Riepilogo aliquote IVA\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota concorrente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.iva_age_lavoro,
                                                      expression:
                                                        "iva_age_lavoro"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_age_lavoro"
                                                    ),
                                                    valid: !!_vm.iva_age_lavoro
                                                  },
                                                  attrs: {
                                                    id: "iva_age_lavoro",
                                                    name: "iva_age_lavoro",
                                                    "data-vv-as":
                                                      "Beni significativi, quota concorrente accessori e manodopera"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_age_lavoro = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota eccedente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.iva_age_extra,
                                                      expression:
                                                        "iva_age_extra"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_age_extra"
                                                    ),
                                                    valid: !!_vm.iva_age_extra
                                                  },
                                                  attrs: {
                                                    id: "iva_age_extra",
                                                    name: "iva_age_extra",
                                                    "data-vv-as":
                                                      "Beni significativi, quota eccedente accessori e manodopera"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_age_extra = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Altri Beni / Accessori opzionali / Installazione e Posa\n                      in Opera\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.iva_accessori_lavoro,
                                                      expression:
                                                        "iva_accessori_lavoro"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_accessori_lavoro"
                                                    ),
                                                    valid: !!_vm.iva_accessori_lavoro
                                                  },
                                                  attrs: {
                                                    id: "iva_accessori_lavoro",
                                                    name:
                                                      "iva_accessori_lavoro",
                                                    "data-vv-as":
                                                      "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_accessori_lavoro = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Altri oneri per il Committente\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.iva_altri_oneri,
                                                      expression:
                                                        "iva_altri_oneri"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_altri_oneri"
                                                    ),
                                                    valid: !!_vm.iva_altri_oneri
                                                  },
                                                  attrs: {
                                                    id: "iva_altri_oneri",
                                                    name: "iva_altri_oneri",
                                                    "data-vv-as":
                                                      "Altri oneri per il Committente"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_altri_oneri = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.client_type == "Persona fisica" &&
                                          _vm.usoAbitativo == 1 &&
                                          (_vm.iva_altri_oneri == "0.04" ||
                                            _vm.iva_accessori_lavoro ==
                                              "0.04" ||
                                            _vm.iva_age_extra == "0.04" ||
                                            _vm.iva_age_lavoro == "0.04")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 mb-3 center text-left"
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass: "Bold center"
                                                    },
                                                    [_vm._v("Attenzione!")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b", [
                                                    _vm._v(
                                                      "Non tutti gli acquisti e interventi, a prescindere,\n                      possono essere considerati secondo l’aliquota agevolata\n                      al 4% bensì esclusivamente quelli prettamente collegati\n                      alla specifica disabilità del cliente finale.\n                    "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _c("br"),
                                                  _c(
                                                    "b",
                                                    { staticClass: "red" },
                                                    [
                                                      _vm._v(
                                                        "Occorre, pertanto, verificare la tipologia di\n                      intervento da eseguire per verificare se il cliente\n                      potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "mt-2 center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Consulta la\n                      "
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "Bold underline black",
                                                          attrs: {
                                                            href:
                                                              "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [_vm._v("guida")]
                                                      ),
                                                      _vm._v(
                                                        "\n                      relativa alle agevolazioni fiscali per le persone con\n                      disabilità.\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-2" }, [
                                    _vm.requiredOperations
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 requiredCont"
                                          },
                                          [
                                            _c("h5", { staticClass: "green" }, [
                                              _vm._v(
                                                "\n                      Requisiti tecnici richiesti per aderire al bonus:\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("h5", {
                                              staticClass: "black",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.requiredOperations
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      attrs: {
                        title: "Anteprima",
                        subtitle: "Tutti i campi sono obbligatori",
                        icon: "",
                        "before-change": _vm.validateThirdTab
                      }
                    },
                    [
                      _vm.calcFinish
                        ? _c(
                            "form",
                            {
                              staticClass: "widthFull orio pt-3 pr-md-3",
                              attrs: {
                                "data-vv-scope": "form-3",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "invoiceData",
                                  staticClass: "widthFull"
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider fordelete"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-bordered mb-0 mt-4"
                                    },
                                    [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { attrs: { scope: "row" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Cessionario/prestatore (fornitore)"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Identificativo fiscale ai fini IVA:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.partita_iva
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Denominazione:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.azienda)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Indirizzo:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.indirizzo
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.getProfile.civico
                                                    )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Comune:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.comune
                                                  ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.getProfile.provincia
                                                    ) +
                                                    ")"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Cap: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.cap)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Email: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.email)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Cellulare: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.cellulare
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("IBAN: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.iban)
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "vertical-align": "top",
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm.getProfile.logo
                                                ? _c("img", {
                                                    staticClass: "img-fluid",
                                                    staticStyle: {
                                                      width: "50% !important",
                                                      "max-width": "150px"
                                                    },
                                                    attrs: {
                                                      src: _vm.getProfile.logo
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "vertical-align": "top"
                                              }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Benificiario/committente (cliente)"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Denominazione:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.clientName) +
                                                    " " +
                                                    _vm._s(_vm.clientLastname)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Indirizzo: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.adress) +
                                                    " " +
                                                    _vm._s(_vm.civic)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Comune: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.city.city) +
                                                    " (" +
                                                    _vm._s(_vm.province) +
                                                    ")"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Cap: "),
                                              _c("b", [
                                                _vm._v(_vm._s(_vm.zip))
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Email: "),
                                              _c("b", [
                                                _vm._v(_vm._s(_vm.client_email))
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm.client_phone
                                                ? _c("span", [
                                                    _vm._v("Telefono: "),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(_vm.client_phone)
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm.client_mobile
                                                ? _c("span", [
                                                    _vm._v("Cellulare: "),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.client_mobile
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "Regular widthFull text-left pt-4 h0 black"
                                    },
                                    [_c("b", [_vm._v("La tua offerta:")])]
                                  ),
                                  _vm._v(" "),
                                  _vm.getProfile.reg_forfettario == "si"
                                    ? _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left h0 black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89\n                della Legge n. 190/2014, così come modificato dalla Legge\n                numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\n              "
                                          )
                                        ]
                                      )
                                    : _vm.client_type == "Partita IVA" &&
                                      _vm.iva_age_lavoro == "0.00" &&
                                      _vm.iva_age_extra == "0.00"
                                    ? _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left h0 black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                Operazione soggetta al reverse charge art. 17, comma 6, lett.\n                a-ter DPR 633/1972.\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass: "table table-bordered mb-0"
                                    },
                                    [
                                      _c("thead"),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        [
                                          _c("tr", { staticClass: "greenBg" }, [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "4" } },
                                              [
                                                _c(
                                                  "b",
                                                  { staticClass: "uppercase" },
                                                  [_vm._v("Beni significativi")]
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Codice prodotto")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prodotto/servizio")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Quantita")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prezzo unitario")]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(_vm.products, function(
                                            item,
                                            ind
                                          ) {
                                            return _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.product.serial)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(item.product.name)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(_vm._s(item.quantity))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(item.price) + " €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c(
                                                  "b",
                                                  {
                                                    staticClass:
                                                      "uppercase text-right widthFull"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Totale Beni Significativi"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.totalProducts) +
                                                      " €"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c(
                                                  "b",
                                                  {
                                                    staticClass:
                                                      "uppercase text-right widthFull"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Totale Agevolabile Beni Significativi"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) -
                                                          parseFloat(
                                                            _vm.totalExtraMise
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                      "\n                        €"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", { staticClass: "greenBg" }, [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "4" } },
                                              [
                                                _c(
                                                  "b",
                                                  { staticClass: "uppercase" },
                                                  [
                                                    _vm._v(
                                                      " Altri beni ed accessori"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Codice prodotto")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prodotto/servizio")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Quantita")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prezzo unitario")]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(_vm.accessories, function(
                                            item,
                                            ind
                                          ) {
                                            return _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.product.serial)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(item.product.name)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(_vm._s(item.quantity))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(item.price) + " € "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("th", {
                                              attrs: { scope: "row" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { colspan: "2" } },
                                              [
                                                _vm._v(
                                                  "Importo installazione/posa in opera"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.priceWork) +
                                                      " € "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  colspan: "3",
                                                  align: "right"
                                                }
                                              },
                                              [
                                                _c(
                                                  "b",
                                                  { staticClass: "uppercase" },
                                                  [
                                                    _vm._v(
                                                      "Totale altri beni ed accessori\n                        "
                                                    ),
                                                    _vm.getProfile
                                                      .reg_forfettario != "si"
                                                      ? [_vm._v("imponibile")]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        parseFloat(
                                                          _vm.totalAccessories
                                                            .replace(".", "")
                                                            .replace(",", ".")
                                                        ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                      )
                                                    ) +
                                                      "\n                        €"
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row ml-0 mr-0 greyBg pt-2"
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale intervento\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      width: "220",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalBase
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.getProfile.reg_forfettario != "si"
                                    ? _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead", [
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [_vm._v("Riepilogo")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", {
                                                attrs: {
                                                  align: "left",
                                                  scope: "row"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c(
                                                    "b",
                                                    [
                                                      _vm._v(
                                                        "Importo\n                        "
                                                      ),
                                                      _vm.getProfile
                                                        .reg_forfettario != "si"
                                                        ? [_vm._v("imponibile")]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v("Aliquota IVA")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Totale (IVA Inclusa)"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota concorrente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.age_lavoro
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iva_age_lavoro * 100
                                                      ) + " %"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.age_lavoro
                                                            ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_age_lavoro
                                                              ))
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota eccedente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.age_extra
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iva_age_extra * 100
                                                      ) + " %"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.age_extra
                                                            ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_age_extra
                                                              ))
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Altri Beni / Accessori opzionali / Installazione e Posa\n                      in Opera\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                            parseFloat(
                                                              _vm.priceWork
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            )
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iva_accessori_lavoro *
                                                          100
                                                      ) + " %"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            (parseFloat(
                                                              _vm.totalAccessories
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ) +
                                                              parseFloat(
                                                                _vm.priceWork
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              )) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_accessori_lavoro
                                                              ))
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row ml-0 mr-0 greyBg pt-2"
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale fattura Spesa agevolabile\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      align: "right",
                                                      width: "220"
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalBaseAndIva
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    { staticClass: "table table-bordered" },
                                    [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "uppercase",
                                              attrs: {
                                                colspan: "2",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Sconto in fattura " +
                                                  _vm._s(this.ecoBonus) +
                                                  "\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm.ecoBonus !=
                                                      "Bonus Casa 50%" &&
                                                    this.client_type ==
                                                      "Partita IVA" &&
                                                    this.usoAbitativo == 0 &&
                                                    this.iva_age_lavoro ==
                                                      "0.22" &&
                                                    this.iva_age_extra ==
                                                      "0.22" &&
                                                    this.iva_accessori_lavoro ==
                                                      "0.22"
                                                      ? void 0
                                                      : [
                                                          _vm._v(
                                                            " (IVA INCLUSA)"
                                                          )
                                                        ]
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "small" },
                                                    [
                                                      _vm._v(
                                                        "\n                        (Art. 121, D.L. 34/20 convertito con Legge 17 luglio\n                        2020)\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      _vm.calcInfo
                                                        .totalWithBonus
                                                    )
                                                  ) + " €"
                                                )
                                              ])
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", { staticClass: "greyBg" }, [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-right uppercase",
                                              attrs: {
                                                colspan: "2",
                                                align: "right",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _c(
                                                "b",
                                                [
                                                  _vm._v(
                                                    "Totale fattura al committente per bonifico parlante\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [_vm._v("(IVA INCLUSA)")]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 16 bis, D.P.R. 917/86)"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 1, Legge 296/2006 e art. 14 D.L.\n                          63/2013)"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      parseFloat(
                                                        _vm.calcInfo
                                                          .totalBaseAndIva
                                                      ) -
                                                        parseFloat(
                                                          _vm.calcInfo
                                                            .totalWithBonus
                                                        )
                                                    )
                                                  ) +
                                                    "\n                        €"
                                                )
                                              ])
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", { staticClass: "greenBg" }, [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "4" } },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "uppercase" },
                                                [
                                                  _vm._v(
                                                    "Altri oneri per il committente"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                colspan: "2",
                                                align: "left",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Quota spesa non agevolata\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm._v(
                                                      "(IVA " +
                                                        _vm._s(
                                                          _vm.iva_altri_oneri *
                                                            100
                                                        ) +
                                                        " % INCLUSA)"
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      (
                                                        parseFloat(
                                                          _vm.totalExtraMise
                                                        ) +
                                                        parseFloat(
                                                          _vm.calcInfo
                                                            .iva22NonAge
                                                        ) +
                                                        parseFloat(
                                                          _vm.calcInfo
                                                            .iva10NonAge
                                                        )
                                                      ).toFixed(2)
                                                    )
                                                  ) +
                                                    "\n                        €"
                                                )
                                              ])
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _vm._v(
                                                "\n                      Gestione Pratica ENEA\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm._v(
                                                      "(IVA " +
                                                        _vm._s(
                                                          _vm.iva_altri_oneri *
                                                            100
                                                        ) +
                                                        " % INCLUSA)"
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check hideOnPdf"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zeroEnea,
                                                        expression: "zeroEnea"
                                                      }
                                                    ],
                                                    key: "1111",
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: "zeroEnea"
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.zeroEnea
                                                      )
                                                        ? _vm._i(
                                                            _vm.zeroEnea,
                                                            null
                                                          ) > -1
                                                        : _vm.zeroEnea
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.zeroEnea,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.zeroEnea = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.zeroEnea = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.zeroEnea = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "zeroEnea" }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Escludi questa voce dal preventivo"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.getProfile.reg_forfettario != "si"
                                            ? _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        (
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) *
                                                          (1 +
                                                            parseFloat(
                                                              _vm.iva_altri_oneri
                                                            ))
                                                        ).toFixed(2)
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.priceEnea
                                                            .replace(".", "")
                                                            .replace(",", ".")
                                                        ).toFixed(2)
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                align: "left",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Oneri Finanziari\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [_vm._v("(IVA ESENTE)")]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check hideOnPdf"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label btn btn-sm btn-primary",
                                                      attrs: {
                                                        for: "zeroOneri"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modPrice(
                                                            "oneri"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Modifica")
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.pricenewFlag
                                            ? _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .allOneri
                                                          ) -
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .serviceCost
                                                            ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .allOneri
                                                          ) -
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .serviceCost
                                                            ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                align: "left",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Costi di gestione pratica\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm._v(
                                                      "(IVA " +
                                                        _vm._s(
                                                          _vm.iva_altri_oneri *
                                                            100
                                                        ) +
                                                        " % INCLUSA)"
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check hideOnPdf"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label btn btn-sm btn-primary",
                                                      attrs: {
                                                        for: "zeroPratica"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modPrice(
                                                            "pratica"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Modifica")
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.pricenewFlag
                                            ? _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .serviceCost
                                                          ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_altri_oneri
                                                              ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .serviceCost
                                                          ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_altri_oneri
                                                              ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", { staticClass: "greyBg" }, [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-right uppercase",
                                              attrs: {
                                                colspan: "2",
                                                align: "right",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _c(
                                                "b",
                                                [
                                                  _vm._v(
                                                    "Totale altri oneri per il committente\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? _c("b", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva22NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva10NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.priceDcast
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  )) +
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  )) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                : _c("b", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva22NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva10NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.priceDcast
                                                              ) +
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                            ]
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "row ml-0 mr-0 pt-2" },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 greyBg"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass: "text-right",
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale da pagare "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                          ( a carico dell’utente finale\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                ", IVA inclusa"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                          )"
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      align: "right",
                                                      width: "220"
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .finalPrice
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass: "table mb-0 mt-3 greyBg"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "left"
                                                    }
                                                  },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario == "si"
                                                      ? [
                                                          _vm._v(
                                                            "\n                          Operazione in franchigia da Iva ex art. 1 cc. 54-89\n                          L. 190/2014\n                        "
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n\n                        L’utilizzo dei servizi descritti sul Sito comporta\n                        l’integrale accettazione dei\n                        "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "green",
                                                        attrs: {
                                                          href:
                                                            _vm.utilizzoPolicy,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Termini e delle condizioni di riferimento\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "widthFull mt-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "row justify-content-center" },
                                  [
                                    _c(
                                      "table",
                                      { staticClass: "table table-bordered" },
                                      [
                                        _c("tbody", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "row" } },
                                              [
                                                _vm._v(
                                                  "\n                        IMPORTO TOTALE DEL CREDITO CEDUTO\n                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        _vm.calcInfo
                                                          .totalWithBonus
                                                      )
                                                    ) + " €"
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var hovalEditCalc_staticRenderFns = []
hovalEditCalc_render._withStripped = true
var hovalEditCalc_esExports = { render: hovalEditCalc_render, staticRenderFns: hovalEditCalc_staticRenderFns }
/* harmony default export */ var editCalc_hovalEditCalc = (hovalEditCalc_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f02ad4e", hovalEditCalc_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/editCalc/hovalEditCalc.vue
var hovalEditCalc_disposed = false
var hovalEditCalc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var hovalEditCalc___vue_template_functional__ = false
/* styles */
var hovalEditCalc___vue_styles__ = null
/* scopeId */
var hovalEditCalc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var hovalEditCalc___vue_module_identifier__ = null
var hovalEditCalc_Component = hovalEditCalc_normalizeComponent(
  hovalEditCalc,
  editCalc_hovalEditCalc,
  hovalEditCalc___vue_template_functional__,
  hovalEditCalc___vue_styles__,
  hovalEditCalc___vue_scopeId__,
  hovalEditCalc___vue_module_identifier__
)
hovalEditCalc_Component.options.__file = "src/components/editCalc/hovalEditCalc.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f02ad4e", hovalEditCalc_Component.options)
  } else {
    hotAPI.reload("data-v-7f02ad4e", hovalEditCalc_Component.options)
  }
  module.hot.dispose(function (data) {
    hovalEditCalc_disposed = true
  })
})()}

/* harmony default export */ var components_editCalc_hovalEditCalc = (hovalEditCalc_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/editCalc/emiconEditCalc.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var emiconEditCalc_moment = __webpack_require__("PJh5");

var emiconEditCalc_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';









// GET DOC LIST


/* harmony default export */ var emiconEditCalc = ({
  name: "emicomEditCalc",
  data: function data() {
    var _ref;

    return _ref = {
      //  ONLY FOR EDIT *****************************
      item: {},
      // *****************************
      documents: documents_documents,
      username: "",
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",

      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione"
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale"
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi"
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua"
        },
        /*5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },*/
        5: {
          name: "Collettore solare termico",
          value: "solare"
        },
        6: {
          name: "Altro Prodotto",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione"
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV"
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche"
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: "",
      resend_success: false,
      loadingState2: false,
      loadingState: false,

      passwordFieldType: "password",
      moment: emiconEditCalc_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [],

      accessories: [],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", ""), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", 0), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", true), defineProperty_default()(_ref, "priceDcast", 0), defineProperty_default()(_ref, "iva_altri_oneri", 0.22), defineProperty_default()(_ref, "iva_accessori_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_extra", 0.22), defineProperty_default()(_ref, "iva_age_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_accessori", 0.1), defineProperty_default()(_ref, "selectorModPrice", ""), defineProperty_default()(_ref, "age_lavoro", 0), defineProperty_default()(_ref, "age_extra", 0), defineProperty_default()(_ref, "priceNew", 0), defineProperty_default()(_ref, "pricenewFlag", false), defineProperty_default()(_ref, "costoAttualizazioneChange", false), defineProperty_default()(_ref, "serviceCostChange", false), _ref;
  },

  components: {
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        _vue.$log("ECOBONUS => " + _vue.ecoBonus);
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        _vue.$log("clearExtraMise => " + _vue.clearExtraMise);
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(this.ecoBonus);

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab: function validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
    },

    validateSecondTab: function validateSecondTab() {
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          setTimeout(function () {
            if (_vue.item.costoAttualizazione != "no") {
              _vue.calcInfo.costoAttualizazione = parseFloat(_vue.item.costoAttualizazione);
              _vue.costoAttualizazioneChange = true;
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
            }
            if (_vue.item.serviceCost != "no") {
              _vue.calcInfo.serviceCost = parseFloat(_vue.item.serviceCost);
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
              _vue.serviceCostChange = true;
            }
          }, 1000);

          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });

      this.$store.dispatch(user["d" /* USER_REQUEST */]);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function modPrice(selectorModPrice) {
      var _this = this;

      var txt = "";
      txt += "<br />Importo attuale : ";
      if (selectorModPrice == "oneri") {
        txt += (parseFloat(this.calcInfo.allOneri) - parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri))).toFixed(2);

        var titleV = "Modifica importo oneri finanaziari";
      }
      if (selectorModPrice == "pratica") {
        txt += (parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri))).toFixed(2);

        var titleV = "Modifica importo costi gestione pratica";
      }
      txt += " €";
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: titleV,
        html: txt + '<br /><br /><div class="group"><lable class="niceInputLable">Importo da aggiornare :</lable><input type="number" min="0" step="0.01" id="swal-input1" placeholder = "Importo .." class="swal2-input"></div>',
        placeholder: "Importo",
        inputAttributes: {
          autocapitalize: "off"
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost = parseFloat(_vue.priceNew) / (1 + parseFloat(_vue.iva_altri_oneri));
            _this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            _this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        }
      }).then(function (result) {});
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                _this2.$log("DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO");
                _this2.$log("client_type " + _this2.client_type);
                _this2.$log("selettore_titoloPossesso " + _this2.client_ownership);
                docTemp = _this2.documents[_this2.client_type];

                _this2.documents[_this2.client_type] = {};

                selettore_titoloPossesso = _this2.client_ownership;
                selettore_enea = _this2.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this2.documents[_this2.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this2.documents[_this2.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this2.documents[_this2.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onComplate: function onComplate() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingState = true;

                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;

                /////// NEW *******************************************************************
                data.oldItem = _this3.item;
                data.serviceCost = _this3.serviceCostChange ? _this3.calcInfo.serviceCost : "no";
                data.costoAttualizazione = _this3.costoAttualizazioneChange ? _this3.calcInfo.costoAttualizazione : "no";
                /////// NEW *******************************************************************

                // ALL USER DATA
                data.user = _this3.getProfile;
                _this3.$error(data.user);
                // BONUS SELECTED
                data.bonus = _this3.ecoBonus;
                // CLIENT DATA
                data.client_name = _this3.clientName;
                data.client_lastname = _this3.clientLastname;
                data.client_type = _this3.client_type;

                data.client_mobile = _this3.client_mobile;
                data.client_phone = _this3.client_phone;
                data.client_email = _this3.client_email;

                // NEWWWWWWWWW
                if (_this3.zeroEnea) {
                  data.client_price_enea = _this3.zeroEneaOld;
                } else {
                  data.client_price_enea = _this3.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this3.zeroDcast) {
                  data.client_price_dcast = _this3.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this3.priceDcast;
                }

                // CLIENT HOUSE DATA
                data.building_province = _this3.province;
                data.building_city = _this3.city.city;
                data.building_zip = _this3.zip;
                data.building_address = _this3.adress;
                data.building_civic = _this3.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this3.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this3.eventType;
                data.intervention_date = emiconEditCalc_moment(_this3.eventStartdate).format("YYYY-MM-DD");
                // PRODUCTS & ACCESSORIES
                data.products = _this3.products;
                data.accessories = _this3.accessories;
                data.enea_request = _this3.enea;
                data.created_at = emiconEditCalc_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = emiconEditCalc_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this3.totalProducts;
                data.total_accessories_price = _this3.totalAccessories;
                data.price_work = _this3.priceWork;

                data.total_transfer_for_user = _this3.calcInfo.aInstallatore;
                data.total_transfer_for_client = _this3.calcInfo.finalPrice;
                data.total_bonus_savings = _this3.calcInfo.totalWithBonus;

                data.total_work_and_iva = _this3.calcInfo.totalBaseAndIva;

                // HTML FOR PDF
                data.htmlInvoice = _this3.$refs.invoiceData.innerHTML;
                //requiredOperations: '',
                data.building_uso_abitativo = _this3.usoAbitativo;

                data.client_ownership = _this3.client_ownership;

                data.iva_altri_oneri = _this3.iva_altri_oneri;
                data.iva_accessori_lavoro = _this3.iva_accessori_lavoro;
                data.iva_age_extra = _this3.iva_age_extra;
                data.iva_age_lavoro = _this3.iva_age_lavoro;
                data.iva_age_accessori = _this3.iva_age_accessori;

                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/editPriceQuotation",
                  method: "POST",
                  data: data,
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "Il tuo preventivo è stato modificato!";
                  alert.type = "SUCCESS";
                  _this3.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this3.$swal({
                    type: "success",
                    title: "Preventivo modificato",
                    html: alert.text
                  });
                  _this3.loadingState = false;

                  _this3.$router.push("/offerte");
                }).catch(function (resp) {
                  _this3.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this3.loadingState = false;
                });

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = 800;
      }
      //var AttPercent = 10.58
      var AttPercent = 20;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "").replace(",", ".")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (parseFloat(totAltroAcc) * this.iva_accessori_lavoro + parseFloat(totAge) * this.iva_age_lavoro).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (parseFloat(this.age_extra) * this.iva_age_extra).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * this.iva_altri_oneri).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva = parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) + parseFloat(this.age_extra) * (1 + parseFloat(temp)) + parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      if (this.ecoBonus != "Bonus Casa 50%" && this.client_type == "Partita IVA" && this.usoAbitativo == 0 && this.iva_age_lavoro == "0.22" && this.iva_age_extra == "0.22" && this.iva_accessori_lavoro == "0.22") {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBase) / 100 * parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      }

      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.priceDcast) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        var haveCondensed = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },


    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      var count = this.products.length;

      if (count) {
        this.productIndex = this.productIndex + 1;
      }

      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      var count = this.accessories.length;

      if (count) {
        this.accessoriesIndex = this.accessoriesIndex + 1;
      }

      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = emiconEditCalc_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = emiconEditCalc_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = emiconEditCalc_numeral(this.priceDcast).format("0.0,[00]");
    },

    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      if (this.corporateClient) {
        var data = {
          key: "calc",
          cc: this.corporateClient
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
          method: "POST",
          data: {
            data: data
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.allProducts = resp.data.allProducts;
          _this5.$log(_this5.allProducts);
        }).catch(function (resp) {});
      } else {
        this.setProfile();
      }
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.corporateClient) this.loadProducts();
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = "";
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = emiconEditCalc_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      this.$log(1);
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);

        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        this.$log("START LOAD IBRIDE");

        this.$log(this.products[i]);
        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;
        this.$log("condensazione => " + condensazione);
        this.$log("pompadicalore => " + pompadicalore);

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          this.$log(this.allProducts["condensazione"][x].Modello + " = " + condensazione);
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          // this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*
        if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/

        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (this.eventType == "Instalazione" && this.ecoBonus == "Bonus Casa 50%") {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162: function warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text = "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }, 1000);
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    },
    warning16: function warning16() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning15: function warning15() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning2: function warning2() {
      var alert = {};
      alert.text = "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning1: function warning1() {
      var alert = {};
      alert.text = "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;

      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context3.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context3.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context3.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context3.next = 12;
                      break;
                    }

                    _vue.checkProductWithBonusRules(input);
                    return _context3.abrupt("return", result);

                  case 12:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 13:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, _this6);
          }));

          return function preConfirm(_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this7.allProducts;
                _context4.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 18;
                  break;
                }

                x = _context4.t1.value;
                _context4.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context4.t3 = _context4.t2()).done) {
                  _context4.next = 16;
                  break;
                }

                y = _context4.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context4.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context4.abrupt("return", data[x][y]);

              case 14:
                _context4.next = 5;
                break;

              case 16:
                _context4.next = 2;
                break;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        //new
        this.calcMaxPriceByKW(this.products[x].index);

        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = emiconEditCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE " + this.totalExtraMise);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;

      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        alert.type = "ERROR";
        this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
        this.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      if (this.accessories) {
        for (var x in this.accessories) {
          price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        }
      } else {
        price = false;
      }

      if (price) {
        this.totalAccessories = emiconEditCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
      this.accessories[i].price = emiconEditCalc_numeral(this.accessories[i].price).format("0.0,[00]");
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      // /this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context5.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context5.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context5.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context5.next = 11;
                      break;
                    }

                    return _context5.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _this9.allProducts;
                _context6.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 20;
                  break;
                }

                x = _context6.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context6.next = 18;
                  break;
                }

                _context6.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context6.t3 = _context6.t2()).done) {
                  _context6.next = 18;
                  break;
                }

                y = _context6.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context6.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context6.abrupt("return", data[x][y]);

              case 16:
                _context6.next = 6;
                break;

              case 18:
                _context6.next = 2;
                break;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },


    // NEWWWWWWWWWWWWWWWWWWWWWWWWWWW **************************************** ONLY FOR EDIT

    setCap: function setCap(cap) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this10.zips) {
                  if (_this10.zips[x].cap == cap.toUpperCase()) {
                    _this10.zip = _this10.zips[x].cap;
                  }
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    setCity: function setCity(city) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this11.cities) {
                  if (_this11.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this11.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this11.city = k;
                  }
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var x;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                for (x in _this12.provincies) {
                  if (_this12.provincies[x].sigla == province.toUpperCase()) {
                    _this12.province = _this12.provincies[x].sigla;
                  }
                }

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    getInvoiceProducts: function getInvoiceProducts(code) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getInvoiceProducts",
                  method: "POST",
                  data: {
                    code: code
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var items = resp.data.products;
                  var _vue = _this13;
                  _this13.$log("prodotti e accessori trovati");
                  _this13.$log(items);

                  _vue.productIndex = 0;
                  _vue.accessoriesIndex = 0;

                  var prodCount = 0;
                  var accCount = 0;

                  for (var x in items) {
                    // SET PRODUCTS

                    if (items[x].tipo == "product") {
                      _vue.addProduct();

                      // SET GROUP AND WAIT
                      _vue.products[prodCount].index = "product" + prodCount;
                      _vue.products[prodCount].indexCount = "quantity" + prodCount;
                      _vue.products[prodCount].group = items[x].gruppo;

                      _vue.setGroup(_vue.products[prodCount].index);

                      // FOR PRELOAD PRODUCTS OF THIS GROUP
                      setTimeout(function (x, items, Vue, prodCount) {
                        var y = {};

                        /////////////////////////////////////////////////////////////////////////
                        for (var u in _vue.items["product" + prodCount]) {
                          if (_vue.items["product" + prodCount][u]) {
                            if (_vue.items["product" + prodCount][u].Modello == items[x].nome) {
                              y.index = parseInt(u);
                              _vue.$log("Prodotto inserito :");
                              _vue.$log(y);
                              break;
                            }
                          }
                        }

                        if (!y.index) {
                          y.index = accCount + 100;
                        }
                        //////////////////////////////////////////////////////////////////////////

                        y.name = items[x].nome;
                        y.serial = items[x].codice;
                        //_vue.products[x].product = y
                        _vue.products[prodCount].price = "";
                        _vue.products[prodCount].quantity = 1;

                        setTimeout(function (x, items, Vue, prodCount) {
                          var o = items[x].prezzo.replace(".", "");
                          _vue.products[prodCount].price = o;
                          _vue.products[prodCount].quantity = parseInt(items[x].quantita);
                          _vue.calcTotalPriceProducts();
                        }, 2500, x, items, Vue, prodCount);

                        _vue.products[prodCount].error = false;

                        _vue.$log(y);

                        var e = _vue.products[prodCount];
                        e.product = y;
                        Vue.set(_vue.products, prodCount, e);

                        _vue.setProduct(_vue.products[prodCount].index);
                      }, 2500, x, items, vue_esm["a" /* default */], prodCount);

                      prodCount = prodCount + 1;

                      //_vue.productIndex = prodCount
                    }
                    // SET ACCESORIES
                    else {
                        _vue.addAccessories();

                        // SET GROUP AND WAIT
                        _vue.accessories[accCount].index = "product" + accCount;
                        _vue.accessories[accCount].indexCount = "quantity" + accCount;
                        _vue.accessories[accCount].group = items[x].gruppo;
                        _vue.setTypeAccessories(_vue.accessories[accCount].index);

                        // FOR PRELOAD PRODUCTS OF THIS GROUP
                        setTimeout(function (x, items, Vue, accCount) {
                          var y = {};

                          for (var u in _vue.itemsAccessories["product" + accCount]) {
                            if (_vue.itemsAccessories["product" + accCount][u]) {
                              if (_vue.itemsAccessories["product" + accCount][u].Modello == items[x].nome) {
                                y.index = parseInt(u);
                              }
                            }
                          }

                          if (!y.index) {
                            y.index = accCount + 100;
                          }

                          y.name = items[x].nome;
                          y.serial = items[x].codice;

                          _vue.accessories[accCount].price = "";
                          _vue.accessories[accCount].quantity = 1;

                          //_vue.products[x].product = y
                          setTimeout(function (x, items, Vue, accCount) {
                            var p = items[x].prezzo.replace(".", "");
                            _vue.accessories[accCount].price = p;
                            _vue.accessories[accCount].quantity = parseInt(items[x].quantita);
                            _vue.calcTotalPriceAccessories();
                          }, 1000, x, items, Vue, accCount);

                          _vue.accessories[accCount].error = false;

                          var e = _vue.accessories[accCount];
                          e.product = y;
                          Vue.set(_vue.accessories, accCount, e);

                          _vue.setAccessories(_vue.accessories[accCount].index);
                        }, 1500, x, items, vue_esm["a" /* default */], accCount);

                        accCount = accCount + 1;

                        //_vue.accessoriesIndex = accCount
                      }
                  }
                }).catch(function (resp) {});

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    calcIvaCustom: function calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }
    }
  },
  watch: {
    client_type: function client_type(val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function usoAbitativo(val) {
      this.calcIvaCustom(this.client_type);
    },
    getProfile: function getProfile() {
      this.setProfile();
    },

    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this14 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this14.cities = resp.data.cities;
          _this14.citiesState = false;
        }).catch(function (resp) {
          _this14.cities = [];
          _this14.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this15 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this15.zips = resp.data.zips;
          _this15.zipsState = false;
        }).catch(function (resp) {
          _this15.zips = [];
          _this15.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    this.setProfile();
    this.loadProducts();
  },
  mounted: function mounted() {
    // NEWWWWWW ***************************************************************
    this.$error(this.$route.params.item);
    if (this.$route.params.item) {
      this.item = this.$route.params.item;
      var data = this.item;
      // START POPULATE DATA
      this.$log(data);
      this.setProfile();
      this.ecoBonus = data.bonus;
      // TAB 1 CLIENT
      this.clientLastname = data.client_name;
      this.clientName = data.client_lastname;
      this.adress = data.building_address;
      this.civic = data.building_civic;
      this.email = "";
      this.phone = "";
      this.mobile = "";
      this.provincies = [];
      this.province = "";
      this.provinciesState = true;
      this.cities = [];
      this.citiesState = false;
      this.zips = [];
      this.zipsState = false;
      this.cityError = false;
      this.zipError = false;
      this.city = "";
      this.zip = "";
      this.datiCatastali = parseInt(data.to_get_cadastral_data);

      this.client_mobile = data.client_mobile;
      this.client_phone = data.client_phone;
      this.client_email = data.client_email;
      //TAB2 INTERVENTO
      this.eventType = data.intervention_type;
      this.eventStartdate = data.intervention_date;

      this.totalAccessories = data.total_accessories_price;
      this.totalProducts = data.total_product_price;
      this.enea = parseInt(data.enea_request);
      this.requiredOperations = "";
      this.client_type = data.client_type;
      this.priceEnea = data.client_price_enea ? data.client_price_enea : "0";
      this.priceDcast = "0";

      this.priceWork = data.price_work;

      this.totalExtraMise = 0;
      this.NoEnea = true;

      this.client_ownership = data.client_ownership;

      var _vue = this;
      setTimeout(function () {
        _vue.usoAbitativo = parseInt(data.building_uso_abitativo);
        _vue.iva_altri_oneri = data.iva_altri_oneri;
        _vue.iva_accessori_lavoro = data.iva_accessori_lavoro;
        _vue.iva_age_extra = data.iva_age_extra;
        _vue.iva_age_lavoro = data.iva_age_lavoro;
        _vue.iva_age_accessori = data.iva_age_accessori;
      }, 2000);

      this.$log(" IVAAAAAAAAAAAAAAAAAAAAAAAAAA");
      this.$log(this.iva_altri_oneri);
      this.$log(this.iva_accessori_lavoro);
      this.$log(this.iva_age_extra);
      this.$log(this.iva_age_lavoro);
      this.$log(this.iva_age_accessori);

      //if (data && data.client_type != 'Amministratore di condominio') {
      if (data) {
        setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
          var province;
          return regenerator_default.a.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  province = _vue.item.building_province;
                  _context13.next = 3;
                  return _vue.setProvince(province);

                case 3:
                  _context13.next = 5;
                  return _vue.getInvoiceProducts(data.id);

                case 5:

                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                    var city;
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            city = _vue.item.building_city;
                            _context12.next = 3;
                            return _vue.setCity(city);

                          case 3:

                            setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                              var cap;
                              return regenerator_default.a.wrap(function _callee11$(_context11) {
                                while (1) {
                                  switch (_context11.prev = _context11.next) {
                                    case 0:
                                      cap = _vue.item.building_zip;
                                      _context11.next = 3;
                                      return _vue.setCap(cap);

                                    case 3:
                                    case "end":
                                      return _context11.stop();
                                  }
                                }
                              }, _callee11, this);
                            })), 1500);

                          case 4:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, this);
                  })), 1500);

                case 6:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        })), 1500);
      }
    } else {
      this.$router.push("/offerte");
    }

    // ***********************************************************************************************

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2305ee70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editCalc/emiconEditCalc.vue
var emiconEditCalc_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mt-5" }, [
    _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _vm.proccess == "START"
          ? _c("h3", { staticClass: "Regular pt-2 h0 widthFull" }, [
              _c("b", [
                _vm._v("Modifica preventivo N. " + _vm._s(_vm.item.code))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.proccess == "START"
          ? _c("p", { staticClass: "black mt-0 text-left widthFull" }, [
              _vm._v(
                "\n        Compila i seguenti step. In caso di conferma del preventivo tutti i\n        dati inseriti verranno poi utilizzati per generare i documenti\n        richiesti per lo sconto in fattura.\n      "
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row justify-content-center pb-5" }, [
      _vm.proccess == "START"
        ? _c(
            "div",
            {
              staticClass: "col-md-12 col-lg-12 vaillantCont pt-1 mt-0",
              staticStyle: { "margin-top": "0 !important" }
            },
            [
              _c(
                "form-wizard",
                {
                  staticClass: "mt-0 pb-2 formp",
                  attrs: {
                    title: "",
                    subtitle: "",
                    nextButtonText: "Avanti >",
                    backButtonText: "< Indietro",
                    finishButtonText: "Salva preventivo",
                    stepSize: _vm.stepSize,
                    color: "#00337f",
                    errorColor: "#ff1100"
                  },
                  on: {
                    "on-change": _vm.stepIndex,
                    "on-complete": _vm.onComplate
                  }
                },
                [
                   true
                    ? _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Scegli Bonus",
                            icon: "",
                            "before-change": _vm.validateZeroTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull",
                              attrs: {
                                "data-vv-scope": "form-0",
                                autocomplete: "qwerqrt2"
                              }
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "row justify-content-center pb-4"
                                },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "pb-0 center section-heading"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Clicca sull`icona del bonus al quale vuoi aderire.\n                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 col-md-3 pr-2 pl-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "selectBonusCont pt-5 pb-4 mb-4",
                                          class: {
                                            bonusSelected:
                                              _vm.ecoBonus == "Bonus Casa 50%"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setBonus(
                                                "Bonus Casa 50%"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusContBack",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Bonus Casa 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Se vuoi aderire al\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v("Bonus Casa 50% "),
                                              _c("br"),
                                              _vm._v(
                                                "Clicca qui >\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Bonus Casa 50%"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("6PKJ")
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("DaEW")
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black",
                                              class: {
                                                white:
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Bonus Casa\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 col-md-3 pr-2 pl-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "selectBonusCont pt-5 pb-4 mb-4",
                                          class: {
                                            bonusSelected:
                                              _vm.ecoBonus == "Ecobonus 50%"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setBonus(
                                                "Ecobonus 50%"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusContBack",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 50%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Se vuoi aderire al\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v("Ecobonus 50% "),
                                              _c("br"),
                                              _vm._v(
                                                "Clicca qui >\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Ecobonus 50%"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("6PKJ")
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("DaEW")
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black",
                                              class: {
                                                white:
                                                  _vm.ecoBonus == "Ecobonus 50%"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Ecobonus\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-6 col-md-3 pr-2 pl-2" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "selectBonusCont pt-5 pb-4 mb-4",
                                          class: {
                                            bonusSelected:
                                              _vm.ecoBonus == "Ecobonus 65%"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setBonus(
                                                "Ecobonus 65%"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "selectBonusContBack",
                                              on: {
                                                click: function($event) {
                                                  return _vm.setBonus(
                                                    "Ecobonus 65%"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Se vuoi aderire al\n                    "
                                              ),
                                              _c("br"),
                                              _vm._v("Ecobonus 65% "),
                                              _c("br"),
                                              _vm._v(
                                                "Clicca qui >\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ecoBonus != "Ecobonus 65%"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("w/IJ")
                                                }
                                              })
                                            : _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mb-4",
                                                attrs: {
                                                  src: __webpack_require__("CXbD")
                                                }
                                              }),
                                          _vm._v(" "),
                                          _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "widthFull center black",
                                              class: {
                                                white:
                                                  _vm.ecoBonus == "Ecobonus 65%"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Ecobonus\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col-md-12 mb-3",
                                      staticStyle: { display: "none" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "group custInput" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.ecoBonus,
                                                expression: "ecoBonus"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-0.ecoBonus"
                                              ),
                                              valid: !!_vm.ecoBonus
                                            },
                                            attrs: {
                                              type: "text",
                                              id: "ecobonus",
                                              name: "ecobonus",
                                              "data-vv-as": "ecoBonus"
                                            },
                                            domProps: { value: _vm.ecoBonus },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.ecoBonus =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 mb-3 center" },
                                    [
                                      _vm.errors.has("form-0.ecobonus")
                                        ? _c("div", { staticClass: "red" }, [
                                            _c("b", { staticClass: "h5 red" }, [
                                              _vm._v(
                                                "Per procedere devi selezionare una tra le quattro icone\n                    sopraindicate.\n                  "
                                              )
                                            ])
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12 mb-3" }, [
                                    _vm._v(
                                      "\n                Novatag e KPMG, non si ritengono responsabili per eventuali\n                danni economici derivanti dall.utilizo della piattaforma e\n                dall.informazioni fornite.\n              "
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              })
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                   true
                    ? _c(
                        "tab-content",
                        {
                          attrs: {
                            title: "Dati Cliente",
                            icon: "",
                            "before-change": _vm.validateFirstTab
                          }
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "widthFull",
                              attrs: {
                                "data-vv-scope": "form-1",
                                autocomplete: "qwerqrt2"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row justify-content-center" },
                                [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      { staticClass: "widthFull center black" },
                                      [
                                        _vm._v(
                                          "\n                  Dati del cliente finale\n                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.client_type,
                                                expression: "client_type"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: {
                                                  required: true,
                                                  max: 63,
                                                  min: 2
                                                },
                                                expression:
                                                  "{ required: true, max: 63, min: 2 }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.client_type"
                                              ),
                                              valid: !!_vm.client_type
                                            },
                                            attrs: {
                                              type: "text",
                                              autocomplete: "randomq",
                                              id: "client_type",
                                              name: "client_type",
                                              "data-vv-as": "Tipologia cliente"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.client_type = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "Persona fisica"
                                                }
                                              },
                                              [_vm._v("Persona fisica")]
                                            ),
                                            _vm._v(" "),
                                            _vm.ecoBonus != "Bonus Casa 50%"
                                              ? _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "Partita IVA"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      Partita IVA\n                    "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value:
                                                    "Amministratore di condominio"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Condominio (Amministratore)\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_type" }
                                          },
                                          [_vm._v("Tipologia cliente")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_type")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_type"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.clientName,
                                              expression: "clientName"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 63,
                                                min: 2
                                              },
                                              expression:
                                                "{ required: true, max: 63, min: 2 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.clientName"
                                            ),
                                            valid: !!_vm.clientName
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "clientName",
                                            name: "clientName",
                                            "data-vv-as": "Nome"
                                          },
                                          domProps: { value: _vm.clientName },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.clientName =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "clientName" }
                                          },
                                          [_vm._v("Nome")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.clientName")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.clientName"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.clientLastname,
                                              expression: "clientLastname"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 63,
                                                min: 2
                                              },
                                              expression:
                                                "{ required: true, max: 63, min: 2 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.clientLastname"
                                            ),
                                            valid: !!_vm.clientLastname
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "clientLastname",
                                            name: "clientLastname",
                                            "data-vv-as": "Cognome"
                                          },
                                          domProps: {
                                            value: _vm.clientLastname
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.clientLastname =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "clientLastname" }
                                          },
                                          [_vm._v("Cognome")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.clientLastname")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.clientLastname"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client_email,
                                              expression: "client_email"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                email: true,
                                                temporaryEmail: true,
                                                plusIssueEmail: true,
                                                max: 56
                                              },
                                              expression:
                                                "{\n                      required: true,\n                      email: true,\n                      temporaryEmail: true,\n                      plusIssueEmail: true,\n                      max: 56,\n                    }"
                                            }
                                          ],
                                          ref: "client_email",
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.client_email"
                                            ),
                                            valid: !!_vm.client_email
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "client_email",
                                            name: "client_email",
                                            "data-vv-as": "Email"
                                          },
                                          domProps: { value: _vm.client_email },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.client_email =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_email" }
                                          },
                                          [_vm._v("Email*\n                  ")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_email")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_email"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client_phone,
                                              expression: "client_phone"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: false,
                                                max: 12,
                                                min: 8,
                                                regex: /^[0]+/
                                              },
                                              expression:
                                                "{\n                      required: false,\n                      max: 12,\n                      min: 8,\n                      regex: /^[0]+/,\n                    }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.client_phone"
                                            ),
                                            valid: !!_vm.client_phone
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "client_phone",
                                            name: "client_phone",
                                            "data-vv-as": "Telefono"
                                          },
                                          domProps: { value: _vm.client_phone },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.client_phone =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_phone" }
                                          },
                                          [
                                            _vm._v(
                                              "Telefono\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_phone")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_phone"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client_mobile,
                                              expression: "client_mobile"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 12,
                                                min: 8,
                                                regex: /^[3]+/
                                              },
                                              expression:
                                                "{\n                      required: true,\n                      max: 12,\n                      min: 8,\n                      regex: /^[3]+/,\n                    }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.client_mobile"
                                            ),
                                            valid: !!_vm.client_mobile
                                          },
                                          attrs: {
                                            type: "text",
                                            id: "client_mobile",
                                            name: "client_mobile",
                                            "data-vv-as": "Cellulare"
                                          },
                                          domProps: {
                                            value: _vm.client_mobile
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.client_mobile =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "client_mobile" }
                                          },
                                          [
                                            _vm._v(
                                              "Cellulare *\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.client_mobile")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.client_mobile"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.ecoBonus != "Bonus Casa 50%"
                                    ? _c(
                                        "div",
                                        { staticClass: "col-md-6 mb-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-check" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "group" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label widthFull black h5",
                                                      attrs: {
                                                        for: "usoAbitativo"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Prevalente uso abitativo\n                    "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check form-check-inline mt-2"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.usoAbitativo = 1
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.usoAbitativo,
                                                                expression:
                                                                  "usoAbitativo"
                                                              },
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value:
                                                                  "required|included:1,0",
                                                                expression:
                                                                  "'required|included:1,0'"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-check-input inline mr-3",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-1.usoAbitativo"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "radio",
                                                              value: "1",
                                                              name:
                                                                "usoAbitativo"
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm.usoAbitativo,
                                                                "1"
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                _vm.usoAbitativo =
                                                                  "1"
                                                              }
                                                            }
                                                          }),
                                                          _c("b", [
                                                            _vm._v("SI")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-check form-check-inline"
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form-check-label",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.usoAbitativo = 0
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.usoAbitativo,
                                                                expression:
                                                                  "usoAbitativo"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-check-input inline mr-3",
                                                            class: {
                                                              "is-invalid": _vm.errors.has(
                                                                "form-1.usoAbitativo"
                                                              )
                                                            },
                                                            attrs: {
                                                              type: "radio",
                                                              value: "0",
                                                              name:
                                                                "usoAbitativo"
                                                            },
                                                            domProps: {
                                                              checked: _vm._q(
                                                                _vm.usoAbitativo,
                                                                "0"
                                                              )
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                _vm.usoAbitativo =
                                                                  "0"
                                                              }
                                                            }
                                                          }),
                                                          _c("b", [
                                                            _vm._v("NO")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: _vm.errors.has(
                                                            "form-1.usoAbitativo"
                                                          ),
                                                          expression:
                                                            "errors.has('form-1.usoAbitativo')"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "errorMes red"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Il servizio deve essere accettato oppure rifiutato\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c(
                                      "h4",
                                      {
                                        staticClass:
                                          "widthFull center black pb-4"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  L'indirizzo dell'immobile\n                "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.province,
                                                expression: "province"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.province"
                                              ),
                                              valid: !!_vm.province
                                            },
                                            attrs: {
                                              autocomplete: "randomy",
                                              id: "province",
                                              name: "province",
                                              "data-vv-as": "Provincia"
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.province = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                disabled: "",
                                                value: "",
                                                selected: "selected"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.provincies, function(
                                              province
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: province.sigla,
                                                  domProps: {
                                                    value: province.sigla
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(province.sigla) +
                                                      " - " +
                                                      _vm._s(
                                                        province.provincia
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "province" }
                                          },
                                          [_vm._v("Provincia")]
                                        ),
                                        _vm._v(" "),
                                        _vm.provinciesState
                                          ? _c(
                                              "div",
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "loadSpinner",
                                                  attrs: {
                                                    id: "loadProvince",
                                                    icon: "spinner",
                                                    size: "1x",
                                                    pulse: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.province")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.province"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _vm.cityError
                                          ? _c(
                                              "span",
                                              { staticClass: "formError" },
                                              [_vm._v("Prima scegli Provincia")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.city,
                                                expression: "city"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.city"
                                              ),
                                              valid: !!_vm.city
                                            },
                                            attrs: {
                                              autocomplete: "randomu",
                                              id: "city",
                                              name: "city",
                                              "data-vv-as": "Località",
                                              disabled: _vm.citiesState
                                            },
                                            on: {
                                              click: _vm.checkProvince,
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.city = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                disabled: "",
                                                value: "",
                                                selected: "selected"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.cities, function(city) {
                                              return _c(
                                                "option",
                                                {
                                                  key: city.comune,
                                                  domProps: {
                                                    value: {
                                                      cityistat: city.istat,
                                                      city: city.comune
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(city.comune) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "city" }
                                          },
                                          [_vm._v("Località")]
                                        ),
                                        _vm._v(" "),
                                        _vm.citiesState
                                          ? _c(
                                              "div",
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "loadSpinner",
                                                  attrs: {
                                                    id: "loadCity",
                                                    icon: "spinner",
                                                    size: "1x",
                                                    pulse: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.city")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.city"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _vm.zipError
                                          ? _c(
                                              "span",
                                              { staticClass: "formError" },
                                              [_vm._v("Prima scegli città")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.zip,
                                                expression: "zip"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: { required: true },
                                                expression: "{ required: true }"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            class: {
                                              "is-invalid": _vm.errors.has(
                                                "form-1.zip"
                                              ),
                                              valid: !!_vm.zip
                                            },
                                            attrs: {
                                              autocomplete: "randomi",
                                              id: "zip",
                                              name: "zip",
                                              "data-vv-as": "Cap",
                                              disabled: _vm.zipsState
                                            },
                                            on: {
                                              click: _vm.checkZip,
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.zip = $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              }
                                            }
                                          },
                                          [
                                            _c("option", {
                                              attrs: {
                                                value: "",
                                                disabled: ""
                                              },
                                              domProps: { selected: true }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(_vm.zips, function(zip) {
                                              return _c(
                                                "option",
                                                {
                                                  key: zip.cap,
                                                  domProps: { value: zip.cap }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(zip.cap) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "zip" }
                                          },
                                          [_vm._v("Cap")]
                                        ),
                                        _vm._v(" "),
                                        _vm.zipsState
                                          ? _c(
                                              "div",
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "loadSpinner",
                                                  attrs: {
                                                    id: "loadZips",
                                                    icon: "spinner",
                                                    size: "1x",
                                                    pulse: ""
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.zip")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.zip"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.adress,
                                              expression: "adress"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 128,
                                                min: 5
                                              },
                                              expression:
                                                "{ required: true, max: 128, min: 5 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.adress"
                                            ),
                                            valid: !!_vm.adress
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "adress",
                                            name: "adress",
                                            "data-vv-as": "Indirizzo"
                                          },
                                          domProps: { value: _vm.adress },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.adress = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "adress" }
                                          },
                                          [_vm._v("Indirizzo")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.adress")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.adress"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "group custInput" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.civic,
                                              expression: "civic"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                max: 15,
                                                min: 1
                                              },
                                              expression:
                                                "{ required: true, max: 15, min: 1 }"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            "is-invalid": _vm.errors.has(
                                              "form-1.civic"
                                            ),
                                            valid: !!_vm.civic
                                          },
                                          attrs: {
                                            type: "text",
                                            autocomplete: "randomq",
                                            id: "civic",
                                            name: "civic",
                                            "data-vv-as": "Civico"
                                          },
                                          domProps: { value: _vm.civic },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.civic = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "highlight"
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "bar" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "niceInputLabel",
                                            attrs: { for: "civic" }
                                          },
                                          [_vm._v("Civico")]
                                        ),
                                        _vm._v(" "),
                                        _vm.errors.has("form-1.civic")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "invalid-feedback"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-1.civic"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      attrs: {
                        title: "Dati Intervento",
                        icon: "",
                        "before-change": _vm.validateSecondTab
                      }
                    },
                    [
                      _c(
                        "form",
                        {
                          staticClass: "widthFull orangeBg",
                          attrs: {
                            "data-vv-scope": "form-2",
                            autocomplete: "qwerqrt3"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "row justify-content-center" },
                            [
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [_vm._v("Dati dell'intervento")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6 mb-3" }, [
                                _c("div", { staticClass: "group custInput" }, [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.eventType,
                                          expression: "eventType"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            max: 63,
                                            min: 2
                                          },
                                          expression:
                                            "{ required: true, max: 63, min: 2 }"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "form-2.eventType"
                                        ),
                                        valid: !!_vm.eventType
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "randomq",
                                        id: "eventType",
                                        name: "eventType",
                                        "data-vv-as": "Tipo di intervento"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.eventType = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c("option", {
                                        attrs: {
                                          value: "",
                                          disabled: "",
                                          selected: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "sostituzione" } },
                                        [_vm._v("Sostituzione")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "Instalazione" } },
                                        [_vm._v("Nuova Installazione")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "eventType" }
                                    },
                                    [_vm._v("Tipo di intervento")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("form-2.eventType")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "form-2.eventType"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [_vm._v("Beni Significativi")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "widthFull" },
                                    _vm._l(_vm.products, function(elem, num) {
                                      return _c(
                                        "div",
                                        { key: num, staticClass: "row" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-md-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: elem.group,
                                                          expression:
                                                            "elem.group"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required: true,
                                                            is_not: ""
                                                          },
                                                          expression:
                                                            "{ required: true, is_not: '' }"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      class: {
                                                        "is-invalid": _vm.errors.has(
                                                          "form-2.g" +
                                                            elem.index
                                                        ),
                                                        valid: !!elem.group
                                                      },
                                                      attrs: {
                                                        id: "g" + elem.index,
                                                        name: "g" + elem.index,
                                                        "data-vv-as": "Gruppo"
                                                      },
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.$set(
                                                              elem,
                                                              "group",
                                                              $event.target
                                                                .multiple
                                                                ? $$selectedVal
                                                                : $$selectedVal[0]
                                                            )
                                                          },
                                                          function($event) {
                                                            return _vm.setGroup(
                                                              elem.index
                                                            )
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _vm.ecoBonus ==
                                                      "Ecobonus 50%"
                                                        ? [
                                                            _vm._l(
                                                              _vm.groups,
                                                              function(item) {
                                                                return [
                                                                  item.value ==
                                                                  "condensazione"
                                                                    ? _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                item.name
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                        : _vm.ecoBonus ==
                                                          "Ecobonus 65%"
                                                        ? [
                                                            _vm._l(
                                                              _vm.groups,
                                                              function(item) {
                                                                return [
                                                                  item.value !=
                                                                  "tradizionale"
                                                                    ? _c(
                                                                        "option",
                                                                        {
                                                                          attrs: {
                                                                            selected:
                                                                              "selected"
                                                                          },
                                                                          domProps: {
                                                                            value:
                                                                              item.value
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                " +
                                                                              _vm._s(
                                                                                item.name
                                                                              ) +
                                                                              "\n                              "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                        : [
                                                            _vm._l(
                                                              _vm.groups,
                                                              function(item) {
                                                                return [
                                                                  _c(
                                                                    "option",
                                                                    {
                                                                      attrs: {
                                                                        selected:
                                                                          "selected"
                                                                      },
                                                                      domProps: {
                                                                        value:
                                                                          item.value
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            item.name
                                                                          ) +
                                                                          "\n                              "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              }
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: { for: "group" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli gruppo prodotto"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-2.g" + elem.index
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-2.g" +
                                                                    elem.index
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "widthFull black pointer m-0",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.insertProductCode(
                                                            elem.index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "search",
                                                          size: "sm"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.insertProductCode(
                                                              elem.index
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("small", [
                                                        _vm._v(
                                                          "o cerca con codice prodotto"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-5" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  elem.group != "ibridi" &&
                                                  elem.group != "altroVaillant"
                                                    ? _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product,
                                                              expression:
                                                                "elem.product"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{ required: true, is_not: '' }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.p" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.product
                                                          },
                                                          attrs: {
                                                            id:
                                                              "p" + elem.index,
                                                            name:
                                                              "p" + elem.index,
                                                            "data-vv-as":
                                                              "Prodotto"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "product",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              }
                                                            ],
                                                            click:
                                                              _vm.checkIfEmpty
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.items[elem.index],
                                                          function(item, ind) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key: ind,
                                                                domProps: {
                                                                  value: {
                                                                    index: ind,
                                                                    name:
                                                                      item.Modello,
                                                                    serial:
                                                                      item.codice
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.Modello
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : elem.group ==
                                                      "altroVaillant"
                                                    ? _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              elem.product.name,
                                                            expression:
                                                              "elem.product.name"
                                                          },
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              is_not: ""
                                                            },
                                                            expression:
                                                              "{ required: true, is_not: '' }"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        class: {
                                                          "is-invalid": _vm.errors.has(
                                                            "form-2.p" +
                                                              elem.index
                                                          ),
                                                          valid: !!elem.product
                                                        },
                                                        attrs: {
                                                          type: "text",
                                                          id: "p" + elem.index,
                                                          name:
                                                            "p" + elem.index,
                                                          "data-vv-as":
                                                            "Prodotto"
                                                        },
                                                        domProps: {
                                                          value:
                                                            elem.product.name
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.setProduct(
                                                              elem.index
                                                            )
                                                          },
                                                          click:
                                                            _vm.checkIfEmpty,
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              elem.product,
                                                              "name",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                elem.product,
                                                              expression:
                                                                "elem.product"
                                                            },
                                                            {
                                                              name: "validate",
                                                              rawName:
                                                                "v-validate",
                                                              value: {
                                                                required: true,
                                                                is_not: ""
                                                              },
                                                              expression:
                                                                "{ required: true, is_not: '' }"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          class: {
                                                            "is-invalid": _vm.errors.has(
                                                              "form-2.p" +
                                                                elem.index
                                                            ),
                                                            valid: !!elem.product
                                                          },
                                                          attrs: {
                                                            id:
                                                              "p" + elem.index,
                                                            name:
                                                              "p" + elem.index,
                                                            "data-vv-as":
                                                              "Prodotto"
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  elem,
                                                                  "product",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.setProduct(
                                                                  elem.index
                                                                )
                                                              }
                                                            ],
                                                            click:
                                                              _vm.checkIfEmpty
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.items[elem.index],
                                                          function(item, ind) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key: ind,
                                                                domProps: {
                                                                  selected:
                                                                    item.Modello ==
                                                                    elem.product
                                                                      .name,
                                                                  value: {
                                                                    index: ind,
                                                                    name:
                                                                      item.Modello,
                                                                    serial:
                                                                      item.codice
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.Modello
                                                                    ) +
                                                                    "\n                            " +
                                                                    _vm._s(
                                                                      item.ModelloPompaDiCalore
                                                                    ) +
                                                                    " +\n                            " +
                                                                    _vm._s(
                                                                      item.ModelloCaldaiaACondensazione
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: { for: "product" }
                                                    },
                                                    [_vm._v("Scegli Prodotto")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-2.p" + elem.index
                                                  ) && !elem.error
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-2.p" +
                                                                    elem.index
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  elem.error
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          Prima scegli gruppo\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mr-md-0 pr-md-0"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: elem.quantity,
                                                        expression:
                                                          "elem.quantity"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          is_not: "0",
                                                          min_value: 1,
                                                          max: 4
                                                        },
                                                        expression:
                                                          "{\n                            required: true,\n                            is_not: '0',\n                            min_value: 1,\n                            max: 4,\n                          }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-2.q" +
                                                          elem.indexCount
                                                      ),
                                                      valid: !!elem.quantity
                                                    },
                                                    attrs: {
                                                      type: "number",
                                                      id: "q" + elem.indexCount,
                                                      min: "1",
                                                      name:
                                                        "q" + elem.indexCount,
                                                      "data-vv-as": "Quantità"
                                                    },
                                                    domProps: {
                                                      value: elem.quantity
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.calcTotalPriceProducts()
                                                      },
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          elem,
                                                          "quantity",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: elem.indexCount
                                                      }
                                                    },
                                                    [_vm._v("Quantità")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-2.q" + elem.indexCount
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-2.q" +
                                                                    elem.indexCount
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 pl-md-0 ml-md-0"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "group custInput"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: elem.price,
                                                        expression: "elem.price"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required: true,
                                                          is_not: "0"
                                                        },
                                                        expression:
                                                          "{ required: true, is_not: '0' }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-2.i" +
                                                          elem.indexCount
                                                      ),
                                                      valid: !!elem.price
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      id: "i" + elem.indexCount,
                                                      min: "1",
                                                      name:
                                                        "i" + elem.indexCount,
                                                      "data-vv-as": "Prezzo"
                                                    },
                                                    domProps: {
                                                      value: elem.price
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        _vm.formatPrice(
                                                          elem.index
                                                        ),
                                                          _vm.calcTotalPriceProducts()
                                                      },
                                                      keyup: function($event) {
                                                        return _vm.keymonitor(
                                                          $event,
                                                          elem.index,
                                                          "prod"
                                                        )
                                                      },
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          elem,
                                                          "price",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "highlight"
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "bar"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "niceInputLabel",
                                                      attrs: {
                                                        for: elem.indexCount
                                                      }
                                                    },
                                                    [_vm._v("Prezzo €")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass:
                                                        "widthFull center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          (IVA esclusa)\n                        "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.errors.has(
                                                    "form-2.i" + elem.indexCount
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.errors.first(
                                                                  "form-2.i" +
                                                                    elem.indexCount
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "removeProduct pointer",
                                                  class: elem.index
                                                },
                                                [
                                                  num != 0
                                                    ? _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "trash-alt",
                                                          size: "lg"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeProduct(
                                                              num
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 mb-3 text-left pr-4"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pointer helper btn btn-secondary",
                                            on: { click: _vm.addProduct }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass:
                                                "helper pointer addProduct",
                                              attrs: {
                                                icon: "plus-circle",
                                                size: "1x"
                                              },
                                              on: { click: _vm.addProduct }
                                            }),
                                            _vm._v(
                                              "\n                      Aggiungi prodotto\n                    "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Totale importo prodotti (IVA esclusa):\n                    "
                                        ),
                                        _c("span", { staticClass: "Bold" }, [
                                          _vm._v(
                                            _vm._s(_vm.totalProducts) + " €"
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "widthFull center black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Altri Beni/Accessori opzionali\n                    "
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.accessories, function(elem, num) {
                                    return _c("div", { staticClass: "row" }, [
                                      _c("div", { staticClass: "col-md-3" }, [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: elem.group,
                                                    expression: "elem.group"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {},
                                                    expression: "{}"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-2.ac" + elem.index
                                                  ),
                                                  valid: !!elem.group
                                                },
                                                attrs: {
                                                  id: "ac" + elem.index,
                                                  name: "ac" + elem.index,
                                                  "data-vv-as":
                                                    "accessori opzionali"
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.$set(
                                                        elem,
                                                        "group",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function($event) {
                                                      return _vm.setTypeAccessories(
                                                        elem.index
                                                      )
                                                    }
                                                  ]
                                                }
                                              },
                                              _vm._l(
                                                _vm.groupsAccessori,
                                                function(item) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        selected: "selected"
                                                      },
                                                      domProps: {
                                                        value: item.value
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(item.name) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "niceInputLabel",
                                                attrs: { for: "group" }
                                              },
                                              [
                                                _vm._v(
                                                  "Scegli accessori opzionali"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.has(
                                              "form-2.ac" + elem.index
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.ac" +
                                                              elem.index
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "widthFull black pointer m-0",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.insertAccessoriesCode(
                                                      elem.index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "search",
                                                    size: "sm"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.insertAccessoriesCode(
                                                        elem.index
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    "o cerca con codice accessorio "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-5" }, [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            elem.group == "termoregolazione"
                                              ? _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: elem.product,
                                                        expression:
                                                          "elem.product"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: {
                                                          required:
                                                            elem.group != ""
                                                        },
                                                        expression:
                                                          "{ required: elem.group != '' }"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "is-invalid": _vm.errors.has(
                                                        "form-2.ap" + elem.index
                                                      ),
                                                      valid: !!elem.product
                                                    },
                                                    attrs: {
                                                      id: "ap" + elem.index,
                                                      name: "ap" + elem.index,
                                                      "data-vv-as": "Accessorio"
                                                    },
                                                    on: {
                                                      change: [
                                                        function($event) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.$set(
                                                            elem,
                                                            "product",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                        function($event) {
                                                          return _vm.setAccessories(
                                                            elem.index
                                                          )
                                                        }
                                                      ],
                                                      click: _vm.checkIfEmpty
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.itemsAccessories[
                                                      elem.index
                                                    ],
                                                    function(item, ind) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            selected: "selected"
                                                          },
                                                          domProps: {
                                                            value: {
                                                              index: ind,
                                                              name:
                                                                item.Modello,
                                                              serial:
                                                                item.codice
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                item.Modello
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: elem.product.name,
                                                      expression:
                                                        "elem.product.name"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required:
                                                          elem.group != "",
                                                        max: 128
                                                      },
                                                      expression:
                                                        "{ required: elem.group != '', max: 128 }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.ap" + elem.index
                                                    ),
                                                    valid: !!elem.product.name
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    id: "ap" + elem.index,
                                                    name: "ap" + elem.index,
                                                    "data-vv-as": "Accessorio"
                                                  },
                                                  domProps: {
                                                    value: elem.product.name
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        elem.product,
                                                        "name",
                                                        $event.target.value
                                                      )
                                                    }
                                                  }
                                                }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            elem.group == "termoregolazione"
                                              ? _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "product" }
                                                  },
                                                  [_vm._v("Scegli Accessorio")]
                                                )
                                              : _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "niceInputLabel",
                                                    attrs: { for: "product" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Inserisci Accessorio"
                                                    )
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _vm.errors.has(
                                              "form-2.ap" + elem.index
                                            ) && !elem.error
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.ap" +
                                                              elem.index
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            elem.error
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        Prima scegli tipo\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-2 mr-md-0 pr-md-0"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: elem.quantity,
                                                    expression: "elem.quantity"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        elem.group != "",
                                                      is_not: "0",
                                                      min_value: 1,
                                                      max: 4
                                                    },
                                                    expression:
                                                      "{\n                          required: elem.group != '',\n                          is_not: '0',\n                          min_value: 1,\n                          max: 4,\n                        }"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-2.aq" +
                                                      elem.indexCount
                                                  ),
                                                  valid: !!elem.quantity
                                                },
                                                attrs: {
                                                  type: "number",
                                                  id: "aq" + elem.indexCount,
                                                  min: "1",
                                                  name: "aq" + elem.indexCount,
                                                  "data-vv-as": "Quantità"
                                                },
                                                domProps: {
                                                  value: elem.quantity
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.calcTotalPriceAccessories()
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      elem,
                                                      "quantity",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "niceInputLabel",
                                                  attrs: {
                                                    for: elem.indexCount
                                                  }
                                                },
                                                [_vm._v("Quantità")]
                                              ),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-2.aq" + elem.indexCount
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-2.aq" +
                                                                elem.indexCount
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-2 pl-md-0 ml-md-0"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "group custInput" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: elem.price,
                                                    expression: "elem.price"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        elem.group != "",
                                                      is_not: "0"
                                                    },
                                                    expression:
                                                      "{\n                          required: elem.group != '',\n                          is_not: '0',\n                        }"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: {
                                                  "is-invalid": _vm.errors.has(
                                                    "form-2.ai" +
                                                      elem.indexCount
                                                  ),
                                                  valid: !!elem.price
                                                },
                                                attrs: {
                                                  type: "text",
                                                  id: "ai" + elem.indexCount,
                                                  min: "1",
                                                  name: "ai" + elem.indexCount,
                                                  "data-vv-as": "Prezzo"
                                                },
                                                domProps: { value: elem.price },
                                                on: {
                                                  change: function($event) {
                                                    _vm.formatPriceAccessories(
                                                      elem.index
                                                    )
                                                    _vm.calcTotalPriceAccessories()
                                                  },
                                                  keyup: function($event) {
                                                    return _vm.keymonitor(
                                                      $event,
                                                      elem.index,
                                                      "accs"
                                                    )
                                                  },
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      elem,
                                                      "price",
                                                      $event.target.value
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "highlight"
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "bar"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "niceInputLabel",
                                                  attrs: {
                                                    for: elem.indexCount
                                                  }
                                                },
                                                [_vm._v("Prezzo €")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "widthFull center"
                                                },
                                                [_vm._v(" (IVA esclusa) ")]
                                              ),
                                              _vm._v(" "),
                                              _vm.errors.has(
                                                "form-2.ai" + elem.indexCount
                                              )
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "invalid-feedback"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm.errors.first(
                                                              "form-2.ai" +
                                                                elem.indexCount
                                                            )
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "removeProduct pointer",
                                              class: elem.index
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "trash-alt",
                                                  size: "lg"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeAccessories(
                                                      num
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-3 mb-3 text-left pr-4"
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pointer helper btn btn-secondary",
                                            on: { click: _vm.addAccessories }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass:
                                                "helper pointer addProduct",
                                              attrs: {
                                                icon: "plus-circle",
                                                size: "1x"
                                              },
                                              on: { click: _vm.addAccessories }
                                            }),
                                            _vm._v(
                                              "\n                      Aggiungi accessorio\n                    "
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-9 mb-3 text-right pr-5 pt-2 black"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Totale importo accessori opzionali (IVA esclusa):\n                    "
                                        ),
                                        _c("span", { staticClass: "Bold" }, [
                                          _vm._v(
                                            _vm._s(_vm.totalAccessories) + " €"
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-4" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "widthFull center black"
                                        },
                                        [_vm._v("Pratica ENEA")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 mb-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.priceEnea,
                                                  expression: "priceEnea"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required: true,
                                                    max: 63,
                                                    min: 2
                                                  },
                                                  expression:
                                                    "{ required: true, max: 63, min: 2 }"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "is-invalid": _vm.errors.has(
                                                  "form-2.priceEnea"
                                                ),
                                                valid: !!_vm.priceEnea
                                              },
                                              attrs: {
                                                type: "text",
                                                autocomplete: "randomq",
                                                id: "priceEnea",
                                                name: "priceEnea",
                                                "data-vv-as":
                                                  "Costo Gestione Pratica ENEA"
                                              },
                                              domProps: {
                                                value: _vm.priceEnea
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.formatpriceEnea()
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.priceEnea =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "niceInputLabel",
                                                attrs: { for: "priceEnea" }
                                              },
                                              [
                                                _vm._v(
                                                  "Costo Gestione Pratica ENEA"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                "Valore che sarà addebitato al cliente "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.errors.has("form-2.priceEnea")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.priceEnea"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.NoEnea
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-6 mb-3" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-check" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "group" },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "form-check-label widthFull black h5",
                                                        attrs: {
                                                          for: "datiCatastali"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Servizio di redazione e invio pratica ENEA ad un\n                          costo di €50 +IVA ( costo che ti sarà addebitato se\n                          accetti il servizio )\n                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check form-check-inline mt-2"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.enea = 1
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.enea,
                                                                  expression:
                                                                    "enea"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required|included:1,0",
                                                                  expression:
                                                                    "'required|included:1,0'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-check-input inline mr-3",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.enea"
                                                                )
                                                              },
                                                              attrs: {
                                                                type: "radio",
                                                                value: "1",
                                                                name: "enea"
                                                              },
                                                              domProps: {
                                                                checked: _vm._q(
                                                                  _vm.enea,
                                                                  "1"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.enea = "1"
                                                                }
                                                              }
                                                            }),
                                                            _c("b", [
                                                              _vm._v("ACCETTO")
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-check form-check-inline"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "form-check-label",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.enea = 0
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.enea,
                                                                  expression:
                                                                    "enea"
                                                                },
                                                                {
                                                                  name:
                                                                    "validate",
                                                                  rawName:
                                                                    "v-validate",
                                                                  value:
                                                                    "required|included:1,0",
                                                                  expression:
                                                                    "'required|included:1,0'"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-check-input inline mr-3",
                                                              class: {
                                                                "is-invalid": _vm.errors.has(
                                                                  "form-2.enea"
                                                                )
                                                              },
                                                              attrs: {
                                                                type: "radio",
                                                                value: "0",
                                                                name: "enea"
                                                              },
                                                              domProps: {
                                                                checked: _vm._q(
                                                                  _vm.enea,
                                                                  "0"
                                                                )
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.enea = "0"
                                                                }
                                                              }
                                                            }),
                                                            _c("b", [
                                                              _vm._v(
                                                                "NON ACCETTO"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: _vm.errors.has(
                                                              "form-2.enea"
                                                            ),
                                                            expression:
                                                              "errors.has('form-2.enea')"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "errorMes red"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Il servizio deve essere accettato oppure rifiutato\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-4" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c(
                                        "h4",
                                        {
                                          staticClass: "widthFull center black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Installazione e Posa in Opera\n                    "
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-6 mb-3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group custInput" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.priceWork,
                                                  expression: "priceWork"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required: true,
                                                    max: 63,
                                                    min: 2
                                                  },
                                                  expression:
                                                    "{ required: true, max: 63, min: 2 }"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: {
                                                "is-invalid": _vm.errors.has(
                                                  "form-2.priceWork"
                                                ),
                                                valid: !!_vm.priceWork
                                              },
                                              attrs: {
                                                type: "text",
                                                autocomplete: "randomq",
                                                id: "priceWork",
                                                name: "priceWork",
                                                "data-vv-as":
                                                  "Importo installazione/posa in opera"
                                              },
                                              domProps: {
                                                value: _vm.priceWork
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.formatpriceWork()
                                                },
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.priceWork =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "highlight"
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "bar" }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "niceInputLabel",
                                                attrs: { for: "priceWork" }
                                              },
                                              [
                                                _vm._v(
                                                  "Importo installazione/posa in opera ( IVA esclusa\n                        )"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.has("form-2.priceWork")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "invalid-feedback"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.errors.first(
                                                            "form-2.priceWork"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-md-12 mb-3 text-right pr-5 pt-2 black"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Totale importo (IVA esclusa):\n                    "
                                        ),
                                        _c("span", { staticClass: "Bold" }, [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  (
                                                    parseFloat(
                                                      _vm.totalProducts
                                                        .replace(".", "")
                                                        .replace(",", ".")
                                                    ) +
                                                    parseFloat(
                                                      _vm.totalAccessories
                                                        .replace(".", "")
                                                        .replace(",", ".")
                                                    ) +
                                                    parseFloat(
                                                      _vm.priceWork
                                                        .replace(".", "")
                                                        .replace(",", ".")
                                                    )
                                                  ).toFixed(2)
                                                )
                                              ) +
                                              "\n                      €\n                    "
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _vm.getProfile.reg_forfettario != "si"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row justify-content-center pt-2 pb-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-12 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "widthFull center black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Riepilogo aliquote IVA\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota concorrente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.iva_age_lavoro,
                                                      expression:
                                                        "iva_age_lavoro"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_age_lavoro"
                                                    ),
                                                    valid: !!_vm.iva_age_lavoro
                                                  },
                                                  attrs: {
                                                    id: "iva_age_lavoro",
                                                    name: "iva_age_lavoro",
                                                    "data-vv-as":
                                                      "Beni significativi, quota concorrente accessori e manodopera"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_age_lavoro = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota eccedente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.iva_age_extra,
                                                      expression:
                                                        "iva_age_extra"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_age_extra"
                                                    ),
                                                    valid: !!_vm.iva_age_extra
                                                  },
                                                  attrs: {
                                                    id: "iva_age_extra",
                                                    name: "iva_age_extra",
                                                    "data-vv-as":
                                                      "Beni significativi, quota eccedente accessori e manodopera"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_age_extra = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Altri Beni / Accessori opzionali / Installazione e Posa\n                      in Opera\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.iva_accessori_lavoro,
                                                      expression:
                                                        "iva_accessori_lavoro"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_accessori_lavoro"
                                                    ),
                                                    valid: !!_vm.iva_accessori_lavoro
                                                  },
                                                  attrs: {
                                                    id: "iva_accessori_lavoro",
                                                    name:
                                                      "iva_accessori_lavoro",
                                                    "data-vv-as":
                                                      "Altri Beni / Accessori opzionali / Installazione e Posa in Opera"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_accessori_lavoro = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-6 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "widthFull text-left black"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Altri oneri per il Committente\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-2 mb-3 center"
                                            },
                                            [
                                              _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.iva_altri_oneri,
                                                      expression:
                                                        "iva_altri_oneri"
                                                    },
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true }"
                                                    }
                                                  ],
                                                  staticClass: "form-control",
                                                  class: {
                                                    "is-invalid": _vm.errors.has(
                                                      "form-2.iva_altri_oneri"
                                                    ),
                                                    valid: !!_vm.iva_altri_oneri
                                                  },
                                                  attrs: {
                                                    id: "iva_altri_oneri",
                                                    name: "iva_altri_oneri",
                                                    "data-vv-as":
                                                      "Altri oneri per il Committente"
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$selectedVal = Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function(o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function(o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                      _vm.iva_altri_oneri = $event
                                                        .target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm.client_type !=
                                                    "Partita IVA" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.10"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        10%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                    "Persona fisica" &&
                                                  _vm.usoAbitativo == 1
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.04"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        4%\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: { value: "0.22" }
                                                    },
                                                    [_vm._v("22%")]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.client_type ==
                                                  "Partita IVA"
                                                    ? _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "0.00"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        Reverse Charge\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.client_type == "Persona fisica" &&
                                          _vm.usoAbitativo == 1 &&
                                          (_vm.iva_altri_oneri == "0.04" ||
                                            _vm.iva_accessori_lavoro ==
                                              "0.04" ||
                                            _vm.iva_age_extra == "0.04" ||
                                            _vm.iva_age_lavoro == "0.04")
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 mb-3 center text-left"
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass: "Bold center"
                                                    },
                                                    [_vm._v("Attenzione!")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b", [
                                                    _vm._v(
                                                      "Non tutti gli acquisti e interventi, a prescindere,\n                      possono essere considerati secondo l’aliquota agevolata\n                      al 4% bensì esclusivamente quelli prettamente collegati\n                      alla specifica disabilità del cliente finale.\n                    "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _c("br"),
                                                  _c(
                                                    "b",
                                                    { staticClass: "red" },
                                                    [
                                                      _vm._v(
                                                        "Occorre, pertanto, verificare la tipologia di\n                      intervento da eseguire per verificare se il cliente\n                      potrà o meno beneficiare dell’aliquota IVA al 4%."
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "mt-2 center"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Consulta la\n                      "
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "Bold underline black",
                                                          attrs: {
                                                            href:
                                                              "https://storage.googleapis.com/chebonus/Guida_alle_agevolazioni_fiscali_per_le_persone_con_disabilita.pdf",
                                                            target: "_blank"
                                                          }
                                                        },
                                                        [_vm._v("guida")]
                                                      ),
                                                      _vm._v(
                                                        "\n                      relativa alle agevolazioni fiscali per le persone con\n                      disabilità.\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row pt-2" }, [
                                    _vm.requiredOperations
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-md-12 mb-3 requiredCont"
                                          },
                                          [
                                            _c("h5", { staticClass: "green" }, [
                                              _vm._v(
                                                "\n                      Requisiti tecnici richiesti per aderire al bonus:\n                    "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("h5", {
                                              staticClass: "black",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.requiredOperations
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row" })
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "row justify-content-center divider"
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab-content",
                    {
                      attrs: {
                        title: "Anteprima",
                        subtitle: "Tutti i campi sono obbligatori",
                        icon: "",
                        "before-change": _vm.validateThirdTab
                      }
                    },
                    [
                      _vm.calcFinish
                        ? _c(
                            "form",
                            {
                              staticClass: "widthFull orio pt-3 pr-md-3",
                              attrs: {
                                "data-vv-scope": "form-3",
                                autocomplete: "qwerqrt3"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "invoiceData",
                                  staticClass: "widthFull"
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "row justify-content-center divider fordelete"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-bordered mb-0 mt-4"
                                    },
                                    [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { attrs: { scope: "row" } },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Cessionario/prestatore (fornitore)"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Identificativo fiscale ai fini IVA:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.partita_iva
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Denominazione:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.azienda)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Indirizzo:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.indirizzo
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.getProfile.civico
                                                    )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Comune:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.comune
                                                  ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.getProfile.provincia
                                                    ) +
                                                    ")"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Cap: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.cap)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Email: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.email)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Cellulare: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getProfile.cellulare
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("IBAN: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.getProfile.iban)
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "vertical-align": "top",
                                                "text-align": "center"
                                              }
                                            },
                                            [
                                              _vm.getProfile.logo
                                                ? _c("img", {
                                                    staticClass: "img-fluid",
                                                    staticStyle: {
                                                      width: "50% !important",
                                                      "max-width": "150px"
                                                    },
                                                    attrs: {
                                                      src: _vm.getProfile.logo
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticStyle: {
                                                "vertical-align": "top"
                                              }
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  "Benificiario/committente (cliente)"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(
                                                "Denominazione:\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.clientName) +
                                                    " " +
                                                    _vm._s(_vm.clientLastname)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Indirizzo: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.adress) +
                                                    " " +
                                                    _vm._s(_vm.civic)
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Comune: "),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(_vm.city.city) +
                                                    " (" +
                                                    _vm._s(_vm.province) +
                                                    ")"
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Cap: "),
                                              _c("b", [
                                                _vm._v(_vm._s(_vm.zip))
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v("Email: "),
                                              _c("b", [
                                                _vm._v(_vm._s(_vm.client_email))
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm.client_phone
                                                ? _c("span", [
                                                    _vm._v("Telefono: "),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(_vm.client_phone)
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm.client_mobile
                                                ? _c("span", [
                                                    _vm._v("Cellulare: "),
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.client_mobile
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e()
                                            ]
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "Regular widthFull text-left pt-4 h0 black"
                                    },
                                    [_c("b", [_vm._v("La tua offerta:")])]
                                  ),
                                  _vm._v(" "),
                                  _vm.getProfile.reg_forfettario == "si"
                                    ? _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left h0 black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                Operazione effettuata ai sensi dell'art. 1, commi da 54 a 89\n                della Legge n. 190/2014, così come modificato dalla Legge\n                numero 208/2015 e dalla Legge 145/2018 art. 1 Commi 9-11.\n              "
                                          )
                                        ]
                                      )
                                    : _vm.client_type == "Partita IVA" &&
                                      _vm.iva_age_lavoro == "0.00" &&
                                      _vm.iva_age_extra == "0.00"
                                    ? _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "Regular widthFull text-left h0 black"
                                        },
                                        [
                                          _vm._v(
                                            "\n                Operazione soggetta al reverse charge art. 17, comma 6, lett.\n                a-ter DPR 633/1972.\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass: "table table-bordered mb-0"
                                    },
                                    [
                                      _c("thead"),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        [
                                          _c("tr", { staticClass: "greenBg" }, [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "4" } },
                                              [
                                                _c(
                                                  "b",
                                                  { staticClass: "uppercase" },
                                                  [_vm._v("Beni significativi")]
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Codice prodotto")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prodotto/servizio")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Quantita")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prezzo unitario")]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(_vm.products, function(
                                            item,
                                            ind
                                          ) {
                                            return _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.product.serial)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(item.product.name)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(_vm._s(item.quantity))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(item.price) + " €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c(
                                                  "b",
                                                  {
                                                    staticClass:
                                                      "uppercase text-right widthFull"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Totale Beni Significativi"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.totalProducts) +
                                                      " €"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c(
                                                  "b",
                                                  {
                                                    staticClass:
                                                      "uppercase text-right widthFull"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Totale Agevolabile Beni Significativi"
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        (
                                                          parseFloat(
                                                            _vm.totalProducts
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) -
                                                          parseFloat(
                                                            _vm.totalExtraMise
                                                          )
                                                        ).toFixed(2)
                                                      )
                                                    ) +
                                                      "\n                        €"
                                                  )
                                                ])
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", { staticClass: "greenBg" }, [
                                            _c(
                                              "td",
                                              { attrs: { colspan: "4" } },
                                              [
                                                _c(
                                                  "b",
                                                  { staticClass: "uppercase" },
                                                  [
                                                    _vm._v(
                                                      " Altri beni ed accessori"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Codice prodotto")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prodotto/servizio")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Quantita")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Prezzo unitario")]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm._l(_vm.accessories, function(
                                            item,
                                            ind
                                          ) {
                                            return _c("tr", [
                                              _c(
                                                "td",
                                                { attrs: { scope: "row" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.product.serial)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(item.product.name)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("b", [
                                                  _vm._v(_vm._s(item.quantity))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(item.price) + " € "
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          }),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("th", {
                                              attrs: { scope: "row" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { colspan: "2" } },
                                              [
                                                _vm._v(
                                                  "Importo installazione/posa in opera"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.priceWork) +
                                                      " € "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c(
                                              "td",
                                              {
                                                attrs: {
                                                  colspan: "3",
                                                  align: "right"
                                                }
                                              },
                                              [
                                                _c(
                                                  "b",
                                                  { staticClass: "uppercase" },
                                                  [
                                                    _vm._v(
                                                      "Totale altri beni ed accessori\n                        "
                                                    ),
                                                    _vm.getProfile
                                                      .reg_forfettario != "si"
                                                      ? [_vm._v("imponibile")]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { attrs: { align: "right" } },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        parseFloat(
                                                          _vm.totalAccessories
                                                            .replace(".", "")
                                                            .replace(",", ".")
                                                        ) +
                                                          parseFloat(
                                                            _vm.priceWork
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          )
                                                      )
                                                    ) +
                                                      "\n                        €"
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row ml-0 mr-0 greyBg pt-2"
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale intervento\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "imponibile"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      width: "220",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalBase
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.getProfile.reg_forfettario != "si"
                                    ? _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("thead", [
                                            _c(
                                              "tr",
                                              { staticClass: "greenBg" },
                                              [
                                                _c(
                                                  "td",
                                                  { attrs: { colspan: "4" } },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass: "uppercase"
                                                      },
                                                      [_vm._v("Riepilogo")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", {
                                                attrs: {
                                                  align: "left",
                                                  scope: "row"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c(
                                                    "b",
                                                    [
                                                      _vm._v(
                                                        "Importo\n                        "
                                                      ),
                                                      _vm.getProfile
                                                        .reg_forfettario != "si"
                                                        ? [_vm._v("imponibile")]
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v("Aliquota IVA")
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Totale (IVA Inclusa)"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tbody", [
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota concorrente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.age_lavoro
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iva_age_lavoro * 100
                                                      ) + " %"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.age_lavoro
                                                            ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_age_lavoro
                                                              ))
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Beni significativi, quota eccedente accessori e\n                      manodopera\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          _vm.age_extra
                                                        )
                                                      ) + " €"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iva_age_extra * 100
                                                      ) + " %"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            parseFloat(
                                                              _vm.age_extra
                                                            ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_age_extra
                                                              ))
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    align: "left",
                                                    scope: "row"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Altri Beni / Accessori opzionali / Installazione e Posa\n                      in Opera\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.totalAccessories
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) +
                                                            parseFloat(
                                                              _vm.priceWork
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            )
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.iva_accessori_lavoro *
                                                          100
                                                      ) + " %"
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          (
                                                            (parseFloat(
                                                              _vm.totalAccessories
                                                                .replace(
                                                                  ".",
                                                                  ""
                                                                )
                                                                .replace(
                                                                  ",",
                                                                  "."
                                                                )
                                                            ) +
                                                              parseFloat(
                                                                _vm.priceWork
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              )) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_accessori_lavoro
                                                              ))
                                                          ).toFixed(2)
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            ])
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row ml-0 mr-0 greyBg pt-2"
                                    },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale fattura Spesa agevolabile\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                "(IVA INCLUSA)"
                                                              )
                                                            ]
                                                          : _vm._e()
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      align: "right",
                                                      width: "220"
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .totalBaseAndIva
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    { staticClass: "table table-bordered" },
                                    [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "uppercase",
                                              attrs: {
                                                colspan: "2",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Sconto in fattura " +
                                                  _vm._s(this.ecoBonus) +
                                                  "\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm.ecoBonus !=
                                                      "Bonus Casa 50%" &&
                                                    this.client_type ==
                                                      "Partita IVA" &&
                                                    this.usoAbitativo == 0 &&
                                                    this.iva_age_lavoro ==
                                                      "0.22" &&
                                                    this.iva_age_extra ==
                                                      "0.22" &&
                                                    this.iva_accessori_lavoro ==
                                                      "0.22"
                                                      ? void 0
                                                      : [
                                                          _vm._v(
                                                            " (IVA INCLUSA)"
                                                          )
                                                        ]
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.ecoBonus != "Bonus Casa 50%"
                                                ? _c(
                                                    "span",
                                                    { staticClass: "small" },
                                                    [
                                                      _vm._v(
                                                        "\n                        (Art. 121, D.L. 34/20 convertito con Legge 17 luglio\n                        2020)\n                      "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      _vm.calcInfo
                                                        .totalWithBonus
                                                    )
                                                  ) + " €"
                                                )
                                              ])
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", { staticClass: "greyBg" }, [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-right uppercase",
                                              attrs: {
                                                colspan: "2",
                                                align: "right",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _c(
                                                "b",
                                                [
                                                  _vm._v(
                                                    "Totale fattura al committente per bonifico parlante\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [_vm._v("(IVA INCLUSA)")]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus ==
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 16 bis, D.P.R. 917/86)"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.ecoBonus !=
                                                  "Bonus Casa 50%"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass: "small"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                          (Art. 1, Legge 296/2006 e art. 14 D.L.\n                          63/2013)"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      parseFloat(
                                                        _vm.calcInfo
                                                          .totalBaseAndIva
                                                      ) -
                                                        parseFloat(
                                                          _vm.calcInfo
                                                            .totalWithBonus
                                                        )
                                                    )
                                                  ) +
                                                    "\n                        €"
                                                )
                                              ])
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", { staticClass: "greenBg" }, [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "4" } },
                                            [
                                              _c(
                                                "b",
                                                { staticClass: "uppercase" },
                                                [
                                                  _vm._v(
                                                    "Altri oneri per il committente"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                colspan: "2",
                                                align: "left",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Quota spesa non agevolata\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm._v(
                                                      "(IVA " +
                                                        _vm._s(
                                                          _vm.iva_altri_oneri *
                                                            100
                                                        ) +
                                                        " % INCLUSA)"
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      (
                                                        parseFloat(
                                                          _vm.totalExtraMise
                                                        ) +
                                                        parseFloat(
                                                          _vm.calcInfo
                                                            .iva22NonAge
                                                        ) +
                                                        parseFloat(
                                                          _vm.calcInfo
                                                            .iva10NonAge
                                                        )
                                                      ).toFixed(2)
                                                    )
                                                  ) +
                                                    "\n                        €"
                                                )
                                              ])
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _vm._v(
                                                "\n                      Gestione Pratica ENEA\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm._v(
                                                      "(IVA " +
                                                        _vm._s(
                                                          _vm.iva_altri_oneri *
                                                            100
                                                        ) +
                                                        " % INCLUSA)"
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check hideOnPdf"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.zeroEnea,
                                                        expression: "zeroEnea"
                                                      }
                                                    ],
                                                    key: "1111",
                                                    staticClass:
                                                      "form-check-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: "zeroEnea"
                                                    },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.zeroEnea
                                                      )
                                                        ? _vm._i(
                                                            _vm.zeroEnea,
                                                            null
                                                          ) > -1
                                                        : _vm.zeroEnea
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a = _vm.zeroEnea,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.zeroEnea = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.zeroEnea = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.zeroEnea = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label",
                                                      attrs: { for: "zeroEnea" }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v(
                                                          "Escludi questa voce dal preventivo"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.getProfile.reg_forfettario != "si"
                                            ? _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        (
                                                          parseFloat(
                                                            _vm.priceEnea
                                                              .replace(".", "")
                                                              .replace(",", ".")
                                                          ) *
                                                          (1 +
                                                            parseFloat(
                                                              _vm.iva_altri_oneri
                                                            ))
                                                        ).toFixed(2)
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.priceEnea
                                                            .replace(".", "")
                                                            .replace(",", ".")
                                                        ).toFixed(2)
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                align: "left",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Oneri Finanziari\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [_vm._v("(IVA ESENTE)")]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check hideOnPdf"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label btn btn-sm btn-primary",
                                                      attrs: {
                                                        for: "zeroOneri"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modPrice(
                                                            "oneri"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Modifica")
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.pricenewFlag
                                            ? _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .allOneri
                                                          ) -
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .serviceCost
                                                            ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .allOneri
                                                          ) -
                                                            parseFloat(
                                                              _vm.calcInfo
                                                                .serviceCost
                                                            ) *
                                                              (1 +
                                                                parseFloat(
                                                                  _vm.iva_altri_oneri
                                                                ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              attrs: {
                                                align: "left",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Costi di gestione pratica\n                      "
                                              ),
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? [
                                                    _vm._v(
                                                      "(IVA " +
                                                        _vm._s(
                                                          _vm.iva_altri_oneri *
                                                            100
                                                        ) +
                                                        " % INCLUSA)"
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { attrs: { align: "left" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-check hideOnPdf"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-check-label btn btn-sm btn-primary",
                                                      attrs: {
                                                        for: "zeroPratica"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.modPrice(
                                                            "pratica"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Modifica")
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.pricenewFlag
                                            ? _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .serviceCost
                                                          ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_altri_oneri
                                                              ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "td",
                                                { staticClass: "text-right" },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("formatNumber")(
                                                          parseFloat(
                                                            _vm.calcInfo
                                                              .serviceCost
                                                          ) *
                                                            (1 +
                                                              parseFloat(
                                                                _vm.iva_altri_oneri
                                                              ))
                                                        )
                                                      ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                ]
                                              )
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", { staticClass: "greyBg" }, [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "text-right uppercase",
                                              attrs: {
                                                colspan: "2",
                                                align: "right",
                                                scope: "row"
                                              }
                                            },
                                            [
                                              _c(
                                                "b",
                                                [
                                                  _vm._v(
                                                    "Totale altri oneri per il committente\n                        "
                                                  ),
                                                  _vm.getProfile
                                                    .reg_forfettario != "si"
                                                    ? [
                                                        _vm._v(
                                                          "(IVA " +
                                                            _vm._s(
                                                              _vm.iva_altri_oneri *
                                                                100
                                                            ) +
                                                            " %\n                          INCLUSA)"
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm.getProfile.reg_forfettario !=
                                              "si"
                                                ? _c("b", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva22NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva10NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.priceDcast
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  )) +
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) *
                                                                (1 +
                                                                  parseFloat(
                                                                    _vm.iva_altri_oneri
                                                                  )) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                                : _c("b", [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            (
                                                              parseFloat(
                                                                _vm.totalExtraMise
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva22NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .iva10NonAge
                                                              ) +
                                                              parseFloat(
                                                                _vm.priceDcast
                                                              ) +
                                                              parseFloat(
                                                                _vm.priceEnea
                                                                  .replace(
                                                                    ".",
                                                                    ""
                                                                  )
                                                                  .replace(
                                                                    ",",
                                                                    "."
                                                                  )
                                                              ) +
                                                              parseFloat(
                                                                _vm.calcInfo
                                                                  .allOneri
                                                              )
                                                            ).toFixed(2)
                                                          )
                                                        ) +
                                                        "\n                        €"
                                                    )
                                                  ])
                                            ]
                                          )
                                        ])
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "row ml-0 mr-0 pt-2" },
                                    [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table table-bordered mb-0 greyBg"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "th",
                                                  {
                                                    staticClass: "text-right",
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "right"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b",
                                                      {
                                                        staticClass:
                                                          "uppercase",
                                                        attrs: {
                                                          align: "right"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Totale da pagare "
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          "\n                          ( a carico dell’utente finale\n                          "
                                                        ),
                                                        _vm.getProfile
                                                          .reg_forfettario !=
                                                        "si"
                                                          ? [
                                                              _vm._v(
                                                                ", IVA inclusa"
                                                              )
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                          )"
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      align: "right",
                                                      width: "220"
                                                    }
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            _vm.calcInfo
                                                              .finalPrice
                                                          )
                                                        ) + " €"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "table",
                                        {
                                          staticClass: "table mb-0 mt-3 greyBg"
                                        },
                                        [
                                          _c("tbody", [
                                            _c(
                                              "tr",
                                              { staticClass: "greyBg" },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    attrs: {
                                                      colspan: "3",
                                                      align: "left"
                                                    }
                                                  },
                                                  [
                                                    _vm.getProfile
                                                      .reg_forfettario == "si"
                                                      ? [
                                                          _vm._v(
                                                            "\n                          Operazione in franchigia da Iva ex art. 1 cc. 54-89\n                          L. 190/2014\n                        "
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n\n                        L’utilizzo dei servizi descritti sul Sito comporta\n                        l’integrale accettazione dei\n                        "
                                                    ),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass: "green",
                                                        attrs: {
                                                          href:
                                                            _vm.utilizzoPolicy,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          Termini e delle condizioni di riferimento\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "widthFull mt-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "row justify-content-center" },
                                  [
                                    _c(
                                      "table",
                                      { staticClass: "table table-bordered" },
                                      [
                                        _c("tbody", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "row" } },
                                              [
                                                _vm._v(
                                                  "\n                        IMPORTO TOTALE DEL CREDITO CEDUTO\n                        "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatNumber")(
                                                        _vm.calcInfo
                                                          .totalWithBonus
                                                      )
                                                    ) + " €"
                                                  )
                                                ])
                                              ]
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var emiconEditCalc_staticRenderFns = []
emiconEditCalc_render._withStripped = true
var emiconEditCalc_esExports = { render: emiconEditCalc_render, staticRenderFns: emiconEditCalc_staticRenderFns }
/* harmony default export */ var editCalc_emiconEditCalc = (emiconEditCalc_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2305ee70", emiconEditCalc_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/editCalc/emiconEditCalc.vue
var emiconEditCalc_disposed = false
var emiconEditCalc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var emiconEditCalc___vue_template_functional__ = false
/* styles */
var emiconEditCalc___vue_styles__ = null
/* scopeId */
var emiconEditCalc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var emiconEditCalc___vue_module_identifier__ = null
var emiconEditCalc_Component = emiconEditCalc_normalizeComponent(
  emiconEditCalc,
  editCalc_emiconEditCalc,
  emiconEditCalc___vue_template_functional__,
  emiconEditCalc___vue_styles__,
  emiconEditCalc___vue_scopeId__,
  emiconEditCalc___vue_module_identifier__
)
emiconEditCalc_Component.options.__file = "src/components/editCalc/emiconEditCalc.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2305ee70", emiconEditCalc_Component.options)
  } else {
    hotAPI.reload("data-v-2305ee70", emiconEditCalc_Component.options)
  }
  module.hot.dispose(function (data) {
    emiconEditCalc_disposed = true
  })
})()}

/* harmony default export */ var components_editCalc_emiconEditCalc = (emiconEditCalc_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/editCalc/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var editCalc_moment = __webpack_require__("PJh5");

var editCalc_numeral = __webpack_require__("ViqS");
//import numFormat from 'vue-filter-number-format';









// GET DOC LIST




/* harmony default export */ var editCalc = ({
  name: "editacalc",
  components: {
    HovalEditCalc: components_editCalc_hovalEditCalc,
    EmiconEditCalc: components_editCalc_emiconEditCalc,
    FormWizard: vue_form_wizard["FormWizard"],
    TabContent: vue_form_wizard["TabContent"],
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      //  ONLY FOR EDIT *****************************
      item: {},
      // *****************************
      documents: documents_documents,
      username: "",
      password: "",
      token: "",
      numeral: __webpack_require__("ViqS"),
      proccess: "START",
      loading: false,
      priceAcc: "",
      corporateClient: '',
      // NEWWWWWW
      zeroEnea: false,
      zeroDcast: false,
      zeroOneri: false,
      zeroPratica: false,
      zeroEneaOld: "",
      zeroDcastOld: "",
      zeroOneriOld: "",
      zeroPraticaOld: "",
      privacyPolicy: "https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf",
      cookiePolicy: "https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf",
      utilizzoPolicy: "https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf",
      priceWork: "",
      tempMail: "",
      socialEmail: false,
      social: "",
      items: {},
      ecoBonus: "",
      itemsAccessories: {},
      calcFinish: false,
      groups: {
        0: {
          name: "Caldaia a condensazione",
          value: "condensazione"
        },
        1: {
          name: "Caldaia tradizionale",
          value: "tradizionale"
        },
        2: {
          name: "Pompa di calore",
          value: "pompadicalore"
        },
        3: {
          name: "Sistemi Ibridi kit completo",
          value: "ibridi"
        },
        4: {
          name: "Scaldacqua PDC",
          value: "scaldacqua"
        },
        /*5: {
          name: "Climatizzatore",
          value: "climatizzatore",
        },*/
        5: {
          name: "Collettore solare termico",
          value: "solare"
        },
        6: {
          name: "Altro Prodotto",
          value: "altroVaillant"
        }
      },
      groupsAccessori: {
        0: {
          name: "Termoregolazione evoluta",
          value: "termoregolazione"
        },
        1: {
          name: "Altro Accessorio",
          value: "altroV"
        },
        2: {
          name: "Valvole termostatiche",
          value: "valvole_termostatiche"
        },
        3: {
          name: "Altro materiale/valvolame",
          value: "altro"
        }
      },
      confirmed: true,
      usoAbitativo: "",
      resend_success: false,
      loadingState2: false,
      loadingState: false,

      passwordFieldType: "password",
      moment: editCalc_moment,
      productIndex: 0,
      accessoriesIndex: 0,
      calcInfo: {},
      products: [],

      accessories: [],

      quantity: "",
      finish: "2030-12-15 23:59:59",
      vw: window.innerWidth,
      stepSize: "md",

      // TAB 1 CLIENT
      clientLastname: "",
      clientName: "",
      adress: "",
      civic: "",
      email: "",
      phone: "",
      mobile: "",
      provincies: [],
      province: "",
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: "",
      zip: "",
      datiCatastali: "",

      client_mobile: "",
      client_phone: "",
      client_email: "",
      //TAB2 INTERVENTO
      eventType: "",
      eventStartdate: "",
      it: locale["it"]
    }, defineProperty_default()(_ref, "eventStartdate", ""), defineProperty_default()(_ref, "disabledDatesStart", {
      to: "",
      from: ""
    }), defineProperty_default()(_ref, "allProducts", {}), defineProperty_default()(_ref, "totalAccessories", "0,00"), defineProperty_default()(_ref, "totalProducts", "0,00"), defineProperty_default()(_ref, "enea", ""), defineProperty_default()(_ref, "requiredOperations", ""), defineProperty_default()(_ref, "client_type", ""), defineProperty_default()(_ref, "priceEnea", 0), defineProperty_default()(_ref, "client_ownership", "Proprietario"), defineProperty_default()(_ref, "totalExtraMise", 0), defineProperty_default()(_ref, "clearExtraMise", false), defineProperty_default()(_ref, "NoEnea", true), defineProperty_default()(_ref, "priceDcast", 0), defineProperty_default()(_ref, "iva_altri_oneri", 0.22), defineProperty_default()(_ref, "iva_accessori_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_extra", 0.22), defineProperty_default()(_ref, "iva_age_lavoro", 0.1), defineProperty_default()(_ref, "iva_age_accessori", 0.1), defineProperty_default()(_ref, "selectorModPrice", ""), defineProperty_default()(_ref, "age_lavoro", 0), defineProperty_default()(_ref, "age_extra", 0), defineProperty_default()(_ref, "priceNew", 0), defineProperty_default()(_ref, "pricenewFlag", false), defineProperty_default()(_ref, "costoAttualizazioneChange", false), defineProperty_default()(_ref, "serviceCostChange", false), _ref;
  },


  methods: {
    keymonitor: function keymonitor(event, index, type) {
      this.$log(event);
      if (event.key == ".") {
        if (type == "prod") {
          var i = index.slice(7, index.length);
          this.products[i].price = this.products[i].price.replace(".", ",");
        } else {
          this.$log(event.key);
          var i = index.slice(7, index.length);
          this.accessories[i].price = this.accessories[i].price.replace(".", ",");
        }
      }
    },
    setBonus: function setBonus(value) {
      this.ecoBonus = value;
      var note = {};
      note.text = "Perfetto hai scelto " + value + ' adesso clicca sul pulsante "avanti" e prosegui con il prossimo step.';
      note.type = "NOTIFICATION";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], note);

      var _vue = this;
      setTimeout(function () {
        // NEWWWWWWWW
        this.$log("ECOBONUS => " + _vue.ecoBonus);
        if (_vue.ecoBonus == "Bonus Casa 50%") {
          _vue.clearExtraMise = true;
        } else {
          _vue.clearExtraMise = false;
        }
        this.$log("clearExtraMise => " + _vue.clearExtraMise);
        _vue.calcTotalPriceProducts();
      }, 3000);
    },
    stepIndex: function stepIndex(from, to) {
      if (to == 2) {
        this.$log("CHECK ALL PRODUCTS WITH EXIST RULES");
        // CHECK ALL PRODUCTS WITH EXIST RULES
        var prod = this.products;
        for (var x in prod) {
          this.$log(prod[x]);
          this.checkProductWithBonusRules(prod[x].index);
        }

        var acc = this.accessories;
        for (var y in acc) {
          this.checkAccessoriesWithBonusRules(acc[y].index);
        }
      }

      if (from == 0 && to == 1 && this.ecoBonus == "Superbonus 110%") {
        this.$router.push("/superbonus");
      }

      this.$log(this.ecoBonus);

      this.$log(from + " => " + to);
    },
    checkIfEmpty: function checkIfEmpty(element) {
      this.$log(element.target.id);
      var id = element.target.id;
      var index = id.slice(8, id.length);
      if (id.includes("pproduct") && this.products[index].group == "") {
        this.products[index].error = true;
      } else {
        this.products[index].error = false;
      }
    },

    // WIZARD STEPS VALIDATES ***************************************************************
    validateZeroTab: function validateZeroTab() {
      var _vue = this;
      this.$validator.validateAll("form-0").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-0");
    },
    validateFirstTab: function validateFirstTab() {
      var _vue = this;
      this.$validator.validateAll("form-1").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-1");
    },

    validateSecondTab: function validateSecondTab() {
      this.$log(this.$validator);
      var _vue = this;
      this.$validator.validateAll("form-2").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.beginCalc("si");
          setTimeout(function () {
            if (_vue.item.costoAttualizazione != "no") {
              _vue.calcInfo.costoAttualizazione = parseFloat(_vue.item.costoAttualizazione);
              _vue.costoAttualizazioneChange = true;
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
            }
            if (_vue.item.serviceCost != "no") {
              _vue.calcInfo.serviceCost = parseFloat(_vue.item.serviceCost);
              _vue.beginCalc("nopopup");
              _vue.pricenewFlag = true;
              _vue.serviceCostChange = true;
            }
          }, 1000);

          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });

      this.$store.dispatch(user["d" /* USER_REQUEST */]);
      return this.$validator.validateAll("form-2");
    },
    validateThirdTab: function validateThirdTab() {
      var _vue = this;
      this.$validator.validateAll("form-3").then(function (result) {
        if (!result) {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        } else {
          _vue.$scrollTo("#app", 700, {
            offset: -170
          });
        }
      });
      return this.$validator.validateAll("form-3");
    },
    modPrice: function modPrice(selectorModPrice) {
      var _this = this;

      var txt = "";
      txt += "<br />Importo attuale : ";
      if (selectorModPrice == "oneri") {
        txt += (parseFloat(this.calcInfo.allOneri) - parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri))).toFixed(2);

        var titleV = "Modifica importo oneri finanaziari";
      }
      if (selectorModPrice == "pratica") {
        txt += (parseFloat(this.calcInfo.serviceCost) * (1 + parseFloat(this.iva_altri_oneri))).toFixed(2);

        var titleV = "Modifica importo costi gestione pratica";
      }
      txt += " €";
      var _vue = this;
      _vue.pricenewFlag = false;

      this.$swal({
        title: titleV,
        html: txt + '<br /><br /><div class="group"><lable class="niceInputLable">Importo da aggiornare :</lable><input type="number" min="0" step="0.01" id="swal-input1" placeholder = "Importo .." class="swal2-input"></div>',
        placeholder: "Importo",
        inputAttributes: {
          autocapitalize: "off"
        },
        reverseButtons: true,
        confirmButtonText: "CONTINUA",
        showCancelButton: true,
        cancelButtonText: "ANNULLA",
        cancelButtonColor: "red",
        //confirmButton: 'closeProductsModal',
        confirmButtonColor: "#b61617",
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          _vue.priceNew = document.getElementById("swal-input1").value;
          _vue.priceNew = _vue.priceNew.replace(/,/g, ".");
          _vue.priceNew = _vue.priceNew.replace("€", "");
          _vue.priceNew = _vue.priceNew.replace(/\s/g, "");
          if (selectorModPrice == "pratica") {
            _vue.calcInfo.serviceCost = parseFloat(_vue.priceNew) / (1 + parseFloat(_vue.iva_altri_oneri));
            _this.serviceCostChange = true;
          }

          if (selectorModPrice == "oneri") {
            _vue.calcInfo.costoAttualizazione = parseFloat(_vue.priceNew);
            _this.costoAttualizazioneChange = true;
          }

          _vue.beginCalc("nopopup");
          _vue.pricenewFlag = true;
        }
      }).then(function (result) {});
    },
    prepareDocumentList: function prepareDocumentList() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, docsFinal, docHtml, i, x, obl;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO
                _this2.$log("DOC LIST PARSER TO SEND IN BACKEND AND INSERT IN PREVENTIVO");
                _this2.$log("client_type " + _this2.client_type);
                _this2.$log("selettore_titoloPossesso " + _this2.client_ownership);
                docTemp = _this2.documents[_this2.client_type];

                _this2.documents[_this2.client_type] = {};

                selettore_titoloPossesso = _this2.client_ownership;
                selettore_enea = _this2.enea;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _this2.documents[_this2.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _this2.documents[_this2.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                docsFinal = _this2.documents[_this2.client_type];
                docHtml = '<br/><br/><br/><h5>Documenti da preparare ( dopo conferma preventivo )</h5><table class="table table-bordered mb-0"><thead></thead><tbody> <tr> <th>N.</th> <th>Nome Documento</th> <th>Obbligatorio</th> </tr>';
                i = 1;

                for (x in docsFinal) {
                  obl = docsFinal[x].mandatory == "yes" ? "SI" : "NO";

                  docHtml = docHtml + "<tr> <th>" + i + '</th><th align="left"> ' + docsFinal[x].name + "</th><th> " + obl + "</th></tr>";
                  i = i + 1;
                }
                docHtml = docHtml + "</tbody></table>";
                return _context.abrupt("return", docHtml);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onComplate: function onComplate() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var docsFinal, data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loadingState = true;

                //var docsFinal = await this.prepareDocumentList()
                docsFinal = "";
                // PREPARE DATA TO POST

                data = {};
                // PASS DOC LIST

                data.docs = docsFinal;

                /////// NEW *******************************************************************
                data.oldItem = _this3.item;
                data.serviceCost = _this3.serviceCostChange ? _this3.calcInfo.serviceCost : "no";
                data.costoAttualizazione = _this3.costoAttualizazioneChange ? _this3.calcInfo.costoAttualizazione : "no";
                /////// NEW *******************************************************************

                // ALL USER DATA
                data.user = _this3.getProfile;
                _this3.$error(data.user);
                // BONUS SELECTED
                data.bonus = _this3.ecoBonus;
                // CLIENT DATA
                data.client_name = _this3.clientName;
                data.client_lastname = _this3.clientLastname;
                data.client_type = _this3.client_type;

                data.client_mobile = _this3.client_mobile;
                data.client_phone = _this3.client_phone;
                data.client_email = _this3.client_email;

                // NEWWWWWWWWW
                if (_this3.zeroEnea) {
                  data.client_price_enea = _this3.zeroEneaOld;
                } else {
                  data.client_price_enea = _this3.priceEnea;
                }

                // NEWWWWWWWWW 2
                if (_this3.zeroDcast) {
                  data.client_price_dcast = _this3.zeroDcastOld;
                } else {
                  data.client_price_dcast = _this3.priceDcast;
                }

                // CLIENT HOUSE DATA
                data.building_province = _this3.province;
                data.building_city = _this3.city.city;
                data.building_zip = _this3.zip;
                data.building_address = _this3.adress;
                data.building_civic = _this3.civic;
                // TO GET CADASTRAL DATA ?
                data.to_get_cadastral_data = _this3.datiCatastali;
                // INTERVENTION DATA
                data.intervention_type = _this3.eventType;
                data.intervention_date = editCalc_moment(_this3.eventStartdate).format("YYYY-MM-DD");
                // PRODUCTS & ACCESSORIES
                data.products = _this3.products;
                data.accessories = _this3.accessories;
                data.enea_request = _this3.enea;
                data.created_at = editCalc_moment().format("YYYY-MM-DD HH:mm:00");
                data.created_date = editCalc_moment().format("DD-MM-YYYY HH:mm");

                // CASH VALUES
                data.total_product_price = _this3.totalProducts;
                data.total_accessories_price = _this3.totalAccessories;
                data.price_work = _this3.priceWork;

                data.total_transfer_for_user = _this3.calcInfo.aInstallatore;
                data.total_transfer_for_client = _this3.calcInfo.finalPrice;
                data.total_bonus_savings = _this3.calcInfo.totalWithBonus;

                data.total_work_and_iva = _this3.calcInfo.totalBaseAndIva;

                // HTML FOR PDF
                data.htmlInvoice = _this3.$refs.invoiceData.innerHTML;
                //requiredOperations: '',
                data.building_uso_abitativo = _this3.usoAbitativo;

                data.client_ownership = _this3.client_ownership;

                data.iva_altri_oneri = _this3.iva_altri_oneri;
                data.iva_accessori_lavoro = _this3.iva_accessori_lavoro;
                data.iva_age_extra = _this3.iva_age_extra;
                data.iva_age_lavoro = _this3.iva_age_lavoro;
                data.iva_age_accessori = _this3.iva_age_accessori;

                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/editPriceQuotation",
                  method: "POST",
                  data: data,
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var alert = {};
                  alert.text = "Il tuo preventivo è stato modificato!";
                  alert.type = "SUCCESS";
                  _this3.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
                  _this3.$swal({
                    type: "success",
                    title: "Preventivo modificato",
                    html: alert.text
                  });
                  _this3.loadingState = false;

                  _this3.$router.push("/offerte");
                }).catch(function (resp) {
                  _this3.$swal({
                    type: "error",
                    title: "Ops....",
                    html: "Riprova più tardi"
                  });
                  _this3.loadingState = false;
                });

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // MAIN CALC ***************************************************************
    beginCalc: function beginCalc(display) {
      //this.proccess = 'CALC'
      var percentbonusDetr;
      var percentToPay;
      if (this.ecoBonus == "Bonus Casa 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 50%") {
        percentbonusDetr = 50;
        percentToPay = 50;
      }
      if (this.ecoBonus == "Ecobonus 65%") {
        percentbonusDetr = 65;
        percentToPay = 35;
      }
      if (this.ecoBonus == "Superbonus 110%") {
        percentbonusDetr = 110;
        percentToPay = 0;
      }

      if (display != "nopopup") {
        this.calcInfo = {};
      }

      // COSTO SERVIZI
      // COSTO SERVIZI
      if (display != "nopopup") {
        //this.calcInfo.serviceCost = 160
        this.calcInfo.serviceCost = 800;
      }
      //var AttPercent = 10.58
      var AttPercent = 20;

      var totProducts = parseFloat(this.totalProducts.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE PRODOTTI
      var totalExtraMise = this.totalExtraMise; // TOTALE NON AGEVOLATO
      var totAge = (parseFloat(totProducts.replace(",", ".")) - parseFloat(totalExtraMise.replace(",", "."))).toFixed(2); // TOTALE AGEVOLATO

      var totAccess = parseFloat(this.totalAccessories.replace(".", "").replace(",", ".")).toFixed(2); // TOTALE ACCESSORI
      var workPrice = parseFloat(this.priceWork.replace(".", "").replace(",", ".")).toFixed(2); // MANODOPERA

      var totAltroAcc = (parseFloat(totAccess) + parseFloat(workPrice)).toFixed(2);
      //var totAltroAcc = ( parseFloat(workPrice) ).toFixed(2)

      // if totProducts > totAltroAcc = altroAcc
      // else totProducts
      if (parseFloat(totAge) > parseFloat(totAltroAcc)) {
        var x10 = totAltroAcc;
        var x22 = totAge - totAltroAcc;
      } else {
        var x10 = totAge;
        var x22 = 0;
      }

      this.age_lavoro = x10;
      this.age_extra = x22;

      var ratio10 = (parseFloat(x10) / parseFloat(totProducts)).toFixed(5);
      var ratio22 = (parseFloat(x22) / parseFloat(totProducts)).toFixed(5);

      var enea = 50;
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,
      */
      // TOTAL BASE
      //this.calcInfo.totalBase = parseFloat(totProducts) + parseFloat(totAccess) + parseFloat(workPrice) - parseFloat(totalExtraMise)
      this.calcInfo.totalBase = (parseFloat(totAge) + parseFloat(totAltroAcc)).toFixed(2);

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.iva10Age = (parseFloat(totAltroAcc) * this.iva_accessori_lavoro + parseFloat(totAge) * this.iva_age_lavoro).toFixed(2);
        //this.calcInfo.iva10NonAge = ((((parseFloat(totalExtraMise) )) * this.iva_altri_oneri)).toFixed(2)
        this.calcInfo.iva10NonAge = 0;

        //this.calcInfo.iva22Age = ((((parseFloat(totAge) )) * this.iva_age_extra )).toFixed(2)
        this.calcInfo.iva22Age = (parseFloat(this.age_extra) * this.iva_age_extra).toFixed(2);
        this.calcInfo.iva22NonAge = (parseFloat(totalExtraMise) * this.iva_altri_oneri).toFixed(2);
      } else {
        this.calcInfo.iva10Age = 0;
        this.calcInfo.iva10NonAge = 0;

        this.calcInfo.iva22Age = 0;
        this.calcInfo.iva22NonAge = 0;
      }

      this.$log("totProducts " + totProducts);
      this.$log("totalExtraMise " + totalExtraMise);
      this.$log("totAccess " + totAccess);
      this.$log("workPrice " + workPrice);
      this.$log("totAltroAcc " + totAltroAcc);
      this.$log("totAge " + totAge);
      this.$log("totalExtraMise " + totalExtraMise);

      this.$log("x10 " + x10);
      this.$log("x22 " + x22);
      this.$log("ratio10 " + ratio10);
      this.$log("ratio22 " + ratio22);
      this.$log(this.calcInfo);

      // IVA 10
      //if ((parseFloat(totProducts) - parseFloat(totalExtraMise) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
      /*if ((parseFloat(totProducts) ) > (parseFloat(totAccess) + parseFloat(workPrice))) {
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + ((parseFloat(totAccess) + parseFloat(workPrice)))) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        //this.calcInfo.iva22 = ((parseFloat(totProducts) - parseFloat(totalExtraMise)) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = ( (parseFloat(totProducts) ) - (parseFloat(totAccess) + parseFloat(workPrice))) / 100 * 22
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        } else {
          //this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) - parseFloat(totalExtraMise))) / 100 * 10
        this.calcInfo.iva10 = (parseFloat(totAccess) + parseFloat(workPrice) + (parseFloat(totProducts) )) / 100 * 10
        this.calcInfo.iva10 = parseFloat(this.calcInfo.iva10).toFixed(2)
          // IVA 22
        this.calcInfo.iva22 = 0
        this.calcInfo.iva22 = parseFloat(this.calcInfo.iva22).toFixed(2)
        }*/

      this.$log("totalBase - " + this.calcInfo.totalBase);

      var temp = this.iva_age_extra;

      if (this.getProfile.reg_forfettario == "si") {
        this.iva_accessori_lavoro = 0.0;
        this.iva_age_lavoro = 0.0;
        this.iva_age_accessori = 0.0;
        temp = 0.0;
      }

      this.$log("age_lavoro - " + this.age_lavoro);
      this.$log("iva_age_lavoro - " + this.iva_age_lavoro);
      this.$log("age_extra - " + this.age_extra);
      this.$log("iva_age_extra - " + this.iva_age_extra);
      this.$log("totAltroAcc - " + totAltroAcc);
      this.$log("totAltroAcc - " + this.iva_accessori_lavoro);

      //TOTAL BASE AND IVA 10 && 22
      //this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBase) + parseFloat(this.calcInfo.iva10Age) + parseFloat(this.calcInfo.iva22Age)
      this.calcInfo.totalBaseAndIva = parseFloat(this.age_lavoro) * (1 + parseFloat(this.iva_age_lavoro)) + parseFloat(this.age_extra) * (1 + parseFloat(temp)) + parseFloat(totAltroAcc) * (1 + parseFloat(this.iva_accessori_lavoro));

      this.calcInfo.totalBaseAndIva = parseFloat(this.calcInfo.totalBaseAndIva).toFixed(2);

      // TOTALE DETRAZIONE
      if (this.ecoBonus != "Bonus Casa 50%" && this.client_type == "Partita IVA" && this.usoAbitativo == 0 && this.iva_age_lavoro == "0.22" && this.iva_age_extra == "0.22" && this.iva_accessori_lavoro == "0.22") {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBase) / 100 * parseFloat(percentbonusDetr);
      } else {
        this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentbonusDetr);
      }

      this.calcInfo.totalWithBonus = parseFloat(this.calcInfo.totalWithBonus).toFixed(2);

      this.calcInfo.total35 = parseFloat(this.calcInfo.totalBaseAndIva) / 100 * parseFloat(percentToPay);
      this.calcInfo.total35 = parseFloat(this.calcInfo.total35).toFixed(2);

      if (display != "nopopup") {
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.totalWithBonus) / 100 * AttPercent;
        this.calcInfo.costoAttualizazione = parseFloat(this.calcInfo.costoAttualizazione).toFixed(2);
      }

      this.calcInfo.allOneri = parseFloat(this.calcInfo.costoAttualizazione) + parseFloat(this.calcInfo.serviceCost) + parseFloat(this.calcInfo.serviceCost) * this.iva_altri_oneri;
      this.calcInfo.allOneri = parseFloat(this.calcInfo.allOneri).toFixed(2);

      if (this.datiCatastali) {
        var dCast = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dCast = 0;
      }

      if (this.getProfile.reg_forfettario != "si") {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.priceDcast) * (parseFloat(this.iva_altri_oneri) + 1) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      } else {
        this.calcInfo.finalPrice = (parseFloat(this.calcInfo.totalBaseAndIva) - parseFloat(this.calcInfo.totalWithBonus) + (parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) + parseFloat(this.calcInfo.iva10NonAge) + parseFloat(this.priceEnea.replace(".", "").replace(",", ".")) + parseFloat(this.priceDcast) + parseFloat(this.calcInfo.allOneri))).toFixed(2);
      }
      //this.calcInfo.finalPrice = ( ( parseFloat(this.calcInfo.totalBaseAndIva) -  parseFloat(this.calcInfo.totalWithBonus) ) + (( parseFloat(totalExtraMise) + parseFloat(this.calcInfo.iva22NonAge) +  parseFloat(this.calcInfo.iva10NonAge) ) + ( parseFloat(this.priceEnea) * 1.22 ) + parseFloat(dCast) + (parseFloat(this.calcInfo.costoAttualizazione) ) )).toFixed(2)

      //this.calcInfo.finalPrice =  (parseFloat(this.calcInfo.total35) - ( parseFloat(this.calcInfo.costoAttualizazione) )).toFixed(2)

      if (this.enea) {
        var dEnea = 0 * (parseFloat(this.iva_altri_oneri) + 1);
      } else {
        var dEnea = 0;
      }

      // INSTALALTORE
      this.calcInfo.aInstallatore = (parseFloat(this.calcInfo.totalWithBonus) - parseFloat(this.calcInfo.costoAttualizazione) - dEnea - dCast).toFixed(2);

      this.calcInfo.finalPrice = parseFloat(this.calcInfo.finalPrice).toFixed(2);
      this.$log(this.calcInfo);

      // CHECK IF TOTAL PRICE NOT OVER
      var totalDiscount = this.calcInfo.totalWithBonus;

      // BONUS CASA 50  ************************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%" && display != "nopopup") {
        // MAX DETRAZIONE 96000 FOR ALL
        if (totalDiscount > 96000) {
          var alert = {};
          alert.text = "Bonus Casa 50% prevede una detrazione massima ammissibile di 96.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END BONUS CASA 50  ********************************************************************************************************************

      // ECO BONUS 50  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%" && display != "nopopup") {
        //i. SOLO la sostituzione, integrale o parziale, di impianti di climatizzazione invernale con impianti dotati di caldaie a condensazione
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE
        var presentValv = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
            }
          }
        }
        if (!presentValv) {
          var alert = {};
          alert.text = "Ecobonus 50% prevede Installazione valvole termostatiche salvo impianti a bassa temperatura (T media < 45°C) o impossibilità tecnica";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *************************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%" && display != "nopopup") {
        //c) interventi di installazione di collettori solari di cui all’art. 1, comma 346, della legge 27 dicembre 2006, n. 296 per la produzione
        // di acqua calda per usi domestici o industriali e per la copertura del fabbisogno di acqua calda in piscine, strutture sportive, case di
        //ricovero e cura,istituti scolastici e università
        if (totalDiscount > 60000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 60.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // ii. i medesimi interventi di cui al punto i, con la contestuale installazione di sistemi di termoregolazione
        // evoluti, appartenenti alle classi V, VI oppure VIII della comunicazione della Commissione 2014/C 207/02;
        if (totalDiscount > 30000) {
          var alert = {};
          alert.text = "Ecobonus 65% prevede una detrazione massima ammissibile di 30.000,00 €";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        }

        // CHECK IF PRESENT VALVOLE TERMOSTATICHE AND CONDENSAZIONE AND TERMOREGOLAZIONE
        var presentValv = false;
        var presentTerm = false;
        var haveCondensed = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            haveCondensed = true;
            for (var y in this.accessories) {
              if (this.accessories[y].group == "valvole_termostatiche") {
                presentValv = true;
              }
              if (this.accessories[y].group == "termoregolazione") {
                presentTerm = true;
              }
            }
          }
        }

        if (!presentValv || !presentTerm) {
          if (haveCondensed) {
            var alert = {};
            alert.text = "Ecobonus 65% prevede Installazione valvole termostatiche e dispositivo di controllo della temperatura che deve appartenere alle classi V, VI oppure VIII";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  ***********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%" && display != "nopopup") {}
      // END SUPERBONUS 110   ******************************************************************************************************************

      this.calcFinish = true;
    },


    // ADD REMOVE ITEMS ***************************************************************
    addProduct: function addProduct() {
      var count = this.products.length;

      if (count) {
        this.productIndex = this.productIndex + 1;
      }

      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeProduct: function removeProduct(elem) {
      this.productIndex = this.productIndex - 1;
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      this.calcTotalPriceProducts();
    },
    addAccessories: function addAccessories() {
      var count = this.accessories.length;

      if (count) {
        this.accessoriesIndex = this.accessoriesIndex + 1;
      }

      this.accessories.push({
        index: "product" + this.accessoriesIndex,
        indexCount: "quantity" + this.accessoriesIndex,
        group: "",
        product: "",
        price: "",
        quantity: "",
        kw: "",
        error: false
      });
    },
    removeAccessories: function removeAccessories(elem) {
      this.accessoriesIndex = this.accessoriesIndex - 1;
      var index = this.accessories.indexOf(elem);
      this.accessories.splice(elem, 1);
      this.calcTotalPriceAccessories();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },

    handleResize: function handleResize() {
      this.vw = window.innerWidth;
      var h = window.innerHeight;

      if (this.vw > 1200 && h > 800) {
        this.stepSize = "md";
      } else {
        this.stepSize = "sm";
      }
    },
    // PRELOAD LOCATIONS ***************************************************************
    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() - 1));
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    },
    formatpriceWork: function formatpriceWork() {
      this.priceWork = editCalc_numeral(this.priceWork).format("0.0,[00]");
    },
    formatpriceEnea: function formatpriceEnea() {
      this.priceEnea = editCalc_numeral(this.priceEnea).format("0.0,[00]");
    },
    formatpriceDcast: function formatpriceDcast() {
      this.priceDcast = editCalc_numeral(this.priceDcast).format("0.0,[00]");
    },

    // PRODUCTS ***************************************************************
    loadProducts: function loadProducts() {
      var _this5 = this;

      if (this.corporateClient) {
        var data = {
          key: "calc",
          cc: this.corporateClient
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getProducts",
          method: "POST",
          data: {
            data: data
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this5.allProducts = resp.data.allProducts;
          _this5.$log(_this5.allProducts);
        }).catch(function (resp) {});
      } else {
        this.setProfile();
      }
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
      if (this.corporateClient) this.loadProducts();
    },
    setGroup: function setGroup(index) {
      var i = index.slice(7, index.length);
      this.items[index] = this.allProducts[this.products[i].group];
      this.products[i].product = "";
      this.products[i].price = "";
      this.products[i].kw = "";
      this.products[i].quantity = "";
      this.$log(this.items);
      this.calcTotalPriceProducts();
    },
    formatPrice: function formatPrice(index) {
      var i = index.slice(7, index.length);
      this.products[i].price = editCalc_numeral(this.products[i].price).format("0.0,[00]");
      // CALC MAX POSSIBLE PRICE FOR PRODUCT BY kW
      this.calcMaxPriceByKW(index);
    },
    setProduct: function setProduct(index) {
      this.$log(1);
      var i = index.slice(7, index.length);
      if (this.products[i].group != "ibridi") {
        if (this.products[i].group != "altroVaillant") {
          this.products[i].kw = this.allProducts[this.products[i].group][this.products[i].product.index].Potenza;
          //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
          this.products[i].quantity = 1;
        } else {
          //this.products[i].product = {'index': 100 + i, 'name': this.products[i].product, 'serial': ''}
          this.products[i].quantity = 1;
        }
      } else {
        //var kw = (parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaCaldaiaCondensazione) + parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore)).toFixed(2)
        var kw = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].PotenzaPompadiCalore).toFixed(2);

        this.products[i].kw = kw;
        //this.products[i].price = (this.allProducts[this.products[i].group][this.products[i].product.index].prezzo).replace(' ', '').replace('€', '')
        this.products[i].quantity = 1;

        this.$log("START LOAD IBRIDE");

        this.$log(this.products[i]);
        // LOAD 2 PRODUCT FROM IS COMPOST IBRIDE SYSTEM
        var condensazione = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloCaldaiaACondensazione;
        var pompadicalore = this.allProducts[this.products[i].group][this.products[i].product.index].ModelloPompaDiCalore;
        this.$log("condensazione => " + condensazione);
        this.$log("pompadicalore => " + pompadicalore);

        var condensazioneSearch = false;
        var pompadicaloreSearch = false;
        // SEARCH CONDENS
        for (var x in this.allProducts["condensazione"]) {
          this.$log(this.allProducts["condensazione"][x].Modello + " = " + condensazione);
          if (this.allProducts["condensazione"][x].Modello.includes(condensazione)) {
            condensazioneSearch = this.allProducts["condensazione"][x];
          }
        }
        // SEARCH POMPA DI CALORE
        for (var x in this.allProducts["pompadicalore"]) {
          if (this.allProducts["pompadicalore"][x].Modello.includes(pompadicalore)) {
            pompadicaloreSearch = this.allProducts["pompadicalore"][x];
          }
        }
      }
      this.calcTotalPriceProducts();
      // CHECK ALL RULES OF BONUS
      this.checkProductWithBonusRules(index);
    },
    checkProductWithBonusRules: function checkProductWithBonusRules(index) {
      var i = index.slice(7, index.length);
      this.$log("FUNCTION => checkProductWithBonusRules");
      this.$log("BONUS SELECTED => " + this.ecoBonus);

      this.requiredOperations = "";

      // BONUS CASA *********************************************************************************************************************
      if (this.ecoBonus == "Bonus Casa 50%") {
        // CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE
        this.$warn("CHECK POMPE DI CALORE NOT MOUNTABLE IN PROV. PIEMONTE");
        if (this.products[i].group == "pompadicalore" && (this.province == "AL" || this.province == "AT" || this.province == "BI" || this.province == "CN" || this.province == "NO" || this.province == "TO" || this.province == "VB" || this.province == "VC")) {
          var canUseInPiemonte = this.allProducts[this.products[i].group][this.products[i].product.index].Piemonte;
          this.$warn("GROUP => pompadicalore AND REGION PIEMONTE => RESULT CAN USE: " + canUseInPiemonte);
          if (canUseInPiemonte == "no") {
            var alert = {};
            alert.text = "La pompa di calore selezionata risulta non installabile nella regione Piemonte";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
        // SET requiredOperations
        if (this.products[i].group == "pompadicalore" || this.products[i].group == "condensazione" || this.products[i].group == "ibridi" || this.products[i].group == "tradizionale") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
        // SET requiredOperations
        if (this.products[i].group == "solare") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 15";
        }
        // SET requiredOperations
        if (this.products[i].group == "scaldacqua") {
          this.requiredOperations = "Trattamento acqua UNI 8065 Prospetto 12";
        }

        // NO ENEA
        if (this.products[i].group == "tradizionale") {
          this.NoEnea = true;
          // this.priceEnea = "0";
          this.enea = 0;
        } else {
          this.NoEnea = true;
        }
      } else {
        this.$warn("CHECK POMPE DI CALORE USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "pompadicalore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => pompadicalore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            var alert = {};
            alert.text = "La Pompa di calore selezionata risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
            alert.type = "ERROR";
            this.$warn(alert.text);
            this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
            this.$swal({
              type: "error",
              title: "ATTENZIONE",
              html: alert.text
            });
          }
        }
      }
      // END BONUS CASA *********************************************************************************************************************

      // ECO BONUS 50  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group != "condensazione" && this.products[i].group != "ibridi" && this.products[i].group != "solare" && this.products[i].group != "") {
          var alert = {};
          alert.text = "Per Ecobonus 50% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi";
          alert.type = "ERROR";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "error",
            title: "ATTENZIONE",
            html: alert.text
          });
        } else {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11";
        }
      }
      // END ECO BONUS 50  *********************************************************************************************************************

      // ECO BONUS 65  *********************************************************************************************************************
      if (this.ecoBonus == "Ecobonus 65%") {
        /*
        if (this.products[i].group != 'condensazione' && this.products[i].group != 'ibridi' && this.products[i].group != 'solare' && this.products[i].group != '') {
          var alert = {}
          alert.text = 'Per Ecobonus 65% aderiscono soltanto le caldaie a condensazione con efficienza energetica stagionale per il riscaldamento d’ambiente ηs maggiore o uguale al 90% (Classe A) o kit Ibridi'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }*/

        // FOR CONDENSAZIONE
        if (this.products[i].group == "condensazione") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetti 9 e 11 ";
        }
        // FOR SOLARI
        if (this.products[i].group == "solare") {
          this.requiredOperations = " - Trattamento acqua UNI 8065 Prospetto 15";
        }
      }
      // END ECO BONUS 65  *********************************************************************************************************************

      // SUPERBONUS 110  *********************************************************************************************************************
      if (this.ecoBonus == "Superbonus 110%") {}
      // END SUPERBONUS 110   *********************************************************************************************************************

      // CHECK EVENT TYPE  *********************************************************************************************************************
      /*if (this.eventType == 'Instalazione') {
        if (this.products[i].group == 'condensazione' || this.products[i].group == 'tradizionale' || this.products[i].group == 'pompadicalore' || this.products[i].group == 'ibridi' || this.products[i].group == 'scaldacqua') {
          var alert = {}
          alert.text = 'Per ' + this.ecoBonus + ' con tipo di intervento selezionato aderiscono soltanto le Climatizzatori e Collettori solari'
          alert.type = 'ERROR'
          this.$warn(alert.text)
          this.$store.dispatch(ADD_NOTIFICATIONS, alert)
          this.$swal({
            type: 'error',
            title: 'ATTENZIONE',
            html: alert.text,
          });
        }
      }*/
      // END EVENT TYPE  *********************************************************************************************************************

      // NEWWWW REVIEW POPUPS

      if (this.eventType == "Instalazione" && this.ecoBonus == "Bonus Casa 50%") {
        if (this.products[i].group != "solare") {
          this.warning1();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 50%") {
        if (this.products[i].group == "condensazione") {
          this.warning2();
        }
      }

      if (this.eventType == "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group != "solare") {
          this.warning15();
        }
      }

      if (this.eventType != "Instalazione" && this.ecoBonus == "Ecobonus 65%") {
        if (this.products[i].group == "climatizzatore") {
          this.warning16();
        }
      }

      if (this.ecoBonus != "Bonus Casa 50%") {
        this.$warn("CHECK climatizzatore USED ONLY FOR BONUS CASA 50%");
        if (this.products[i].group == "climatizzatore") {
          var onlyBonusCasa = this.allProducts[this.products[i].group][this.products[i].product.index].onlyBonusCasa;
          this.$warn("GROUP => climatizzatore AND onlyBonusCasa: " + onlyBonusCasa);
          if (onlyBonusCasa == "yes") {
            this.warning162();
          }
        }
      }
    },
    warning162: function warning162() {
      var _vue = this;
      var alert = {};
      this.$log("INSIDE 162");
      alert.text = "Il climatizzatore selezionato risulta selezionabile solo per Bonus Casa 50% <br/> Per procedere torna indietro e cambia il tipo di bonus";
      alert.type = "ERROR";
      setTimeout(function () {
        _vue.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }, 1000);
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
    },
    warning16: function warning16() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la sostituzione di un climatizzatore è ammessa solo se si tratta dell`unico generatore di calore";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning15: function warning15() {
      var alert = {};
      alert.text = "Con Ecobonus 65% la nuova installazione è consentita solo per Collettori Solari.";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning2: function warning2() {
      var alert = {};
      alert.text = "Con Ecobonus 50% non è consentita la nuova installazione di apparecchi";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    warning1: function warning1() {
      var alert = {};
      alert.text = "Con il BonusCasa 50% la nuova installazione è consentita solo per i Collettori Solari. È ammessa la nuova installazione anche di Climatizzatori e Pompe di Calore ma solo se l`impianto termico è esistente";
      alert.type = "ERROR";
      this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
      this.$swal({
        type: "error",
        title: "ATTENZIONE",
        html: alert.text
      });
    },
    insertProductCode: function insertProductCode(input) {
      var _this6 = this;

      var i = input.slice(7, input.length);
      this.$log(i);
      var _vue = this;

      this.$swal({
        title: "Inserisci codice prodotto",
        input: "text",
        text: "esempio: 0010014674",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return _this6.searchProduct(searchItem, i, input);

                  case 2:
                    result = _context3.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context3.next = 7;
                      break;
                    }

                    _this6.$swal.showValidationMessage("Codice Prodotto " + "deve essere composto da 10 caratteri");
                    return _context3.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context3.next = 12;
                      break;
                    }

                    _vue.checkProductWithBonusRules(input);
                    return _context3.abrupt("return", result);

                  case 12:
                    //throw new Error('Prodotto non trovato')
                    _this6.$swal.showValidationMessage(" " + "Prodotto non trovato");

                  case 13:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, _this6);
          }));

          return function preConfirm(_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this6.calcTotalPriceProducts();
      });
    },
    searchProduct: function searchProduct(searchItem, index, input) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this7.allProducts;
                _context4.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 18;
                  break;
                }

                x = _context4.t1.value;
                _context4.t2 = regenerator_default.a.keys(data[x]);

              case 5:
                if ((_context4.t3 = _context4.t2()).done) {
                  _context4.next = 16;
                  break;
                }

                y = _context4.t3.value;

                if (!data[x][y].codice.includes(searchItem)) {
                  _context4.next = 14;
                  break;
                }

                //0010014674
                _this7.items[input] = _this7.allProducts[x];

                _this7.products[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this7.products[index].product = z;
                _this7.products[index].quantity = 1;
                //this.products[index].price = data[x][y].prezzo

                return _context4.abrupt("return", data[x][y]);

              case 14:
                _context4.next = 5;
                break;

              case 16:
                _context4.next = 2;
                break;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    calcTotalPriceProducts: function calcTotalPriceProducts() {
      var price = 0;
      this.totalExtraMise = 0;

      for (var x in this.products) {
        //new
        this.calcMaxPriceByKW(this.products[x].index);

        price += this.products[x].quantity * parseFloat(this.products[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        if (this.products[x].extraMise) {
          this.totalExtraMise = parseFloat(this.totalExtraMise) + parseFloat(this.products[x].extraMise);
        }
      }
      if (price) {
        this.totalProducts = editCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalProducts = "0,00";
      }

      this.totalExtraMise = this.totalExtraMise.toFixed(2);

      if (this.ecoBonus == "Bonus Casa 50%") {
        this.totalExtraMise = parseFloat(0).toFixed(2);
        this.clearExtraMise = true;
      } else {
        this.clearExtraMise = false;
      }

      this.$log("TOTAL EXTRA MISE " + this.totalExtraMise);
    },
    calcMaxPriceByKW: function calcMaxPriceByKW(index) {
      var i = index.slice(7, index.length);
      var price = this.products[i].price;

      var error = false;
      var errorType = false;

      this.products[i].extraMise = 0;

      if (this.products[i].product && price) {
        // NEW POMPE DI CALORE
        if (this.products[i].group == "climatizzatore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 600) {
              error = "600";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 600).toFixed(2);
            }
          }
        }

        // NEW POMPE DI CALORE
        if (this.products[i].group == "pompadicalore") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            if (res > 1300 && !this.products[i].product.name.includes("flexo")) {
              error = "1300";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1300).toFixed(2);
            }
            if (res > 1900 && this.products[i].product.name.includes("flexo")) {
              error = "1900";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 1900).toFixed(2);
            }
          }
        }

        // CALDAIE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "condensazione" || this.products[i].group == "tradizionale") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = parseFloat(this.products[i].kw.replace(",", ".")).toFixed(2);
            var res = (parseFloat(price) / parseFloat(kw.replace(",", "."))).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (kw <= 35 && res > 200) {
              error = "200";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 200).toFixed(2);
            } else if (kw > 35 && res > 180) {
              error = "180";
              errorType = "kw";

              this.$log(price);
              this.$log(kw);
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw.replace(",", ".")) * 180).toFixed(2);
            }
          }
        }

        // SOLARE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "solare") {
          price = parseFloat(price.replace(".", "")).toFixed(2);
          var type = this.allProducts[this.products[i].group][this.products[i].product.index].tipologia;
          var superfice = parseFloat(this.allProducts[this.products[i].group][this.products[i].product.index].superficielorda.replace(",", ".")).toFixed(2);
          var res = (parseFloat(price) / parseFloat(superfice)).toFixed(2);

          this.$log("superfice " + superfice);

          this.$log("res " + res);

          // IF PIANI max price for 1 m2 of power is 1000 Euro
          // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
          if (type == "Piani" && res > 1000) {
            error = "1000";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1000).toFixed(2);
          } else if (type == "Sottovuoto" && res > 1250) {
            error = "1250";
            errorType = "m2";
            this.products[i].extraMise = (parseFloat(price) - parseFloat(superfice) * 1250).toFixed(2);
          }
        }

        // SCALDAACQUA POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "scaldacqua") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var type = this.allProducts[this.products[i].group][this.products[i].product.index].capacita.replace(",", ".");
            //var superfice = parseFloat(this.products[i].superficielorda).toFixed(2)
            var res = (parseFloat(price) / parseFloat(type)).toFixed(2);

            // IF PIANI max price for 1 m2 of power is 1000 Euro
            // IF SOTTOVUOTO  max price for 1 m2 of power is 1250 Euro
            if (parseInt(type) <= 150 && price > 1000) {
              error = "1000";
              errorType = "lt1";
              this.products[i].extraMise = (parseFloat(price) - 1000).toFixed(2);
            } else if (parseInt(type) > 150 && price > 1250) {
              error = "1250";
              errorType = "lt2";
              this.products[i].extraMise = (parseFloat(price) - 1250).toFixed(2);
            }
          }

          //'climatizzatore'
        }

        // 'ibridi'
        // IBRIDE POWER > 35 kW || <= 35 kW
        if (this.products[i].group == "ibridi") {
          if (this.products[i].kw) {
            price = parseFloat(price.replace(".", "")).toFixed(2);
            var kw = this.products[i].kw.replace(",", ".");
            var res = (parseFloat(price) / parseFloat(kw)).toFixed(2);
            // IF KW <= 35 max price for 1 kW of power is 200 Euro
            // IF KW > 35 max price for 1 kW of power is 180 Euro
            if (res > 1550) {
              error = "1550";
              errorType = "kw";
              this.products[i].extraMise = (parseFloat(price) - parseFloat(kw) * 1550).toFixed(2);
            }
          }
        }
      }

      // SHOW POP UP IF ERROR
      if (error) {
        // Use sweetalret2

        var alert = {};

        if (errorType == "kw") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/kW di potenza nominale. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "m2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + "/m<sup>2</sup> installato. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt1") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " fino a 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        if (errorType == "lt2") {
          alert.text = "Il prezzo da te indicato supera il valore massimale MISE </br> €" + error + " oltre 150 litri di accumulo. </br></br> Se prosegui il preventivo evidenzierà la quota che non sarà inclusa nel bonus e quindi esclusa dallo sconto in fattura";
        }

        alert.type = "ERROR";
        this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
        this.$swal({
          type: "error",
          title: "ATTENZIONE",
          html: alert.text
        });
      }
    },


    // ----------------- ACCESSORIES ----------------------------------------
    calcTotalPriceAccessories: function calcTotalPriceAccessories() {
      var price = 0;
      if (this.accessories) {
        for (var x in this.accessories) {
          price += this.accessories[x].quantity * parseFloat(this.accessories[x].price.replace(".", "").replace(",", ".")).toFixed(2);
        }
      } else {
        price = false;
      }

      if (price) {
        this.totalAccessories = editCalc_numeral(price).format("0.0,[00]");
      } else {
        this.totalAccessories = "0,00";
      }
    },
    setTypeAccessories: function setTypeAccessories(index) {
      var i = index.slice(7, index.length);
      this.itemsAccessories[index] = this.allProducts[this.accessories[i].group];
      var x = this.itemsAccessories[index];
      if (x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare" && x != "termoregolazione") {
        var z = {
          index: i,
          name: "",
          serial: ""
        };
        this.accessories[i].product = z;
        this.accessories[i].price = "";
        this.accessories[i].quantity = "";
      }
      this.calcTotalPriceAccessories();
    },
    formatPriceAccessories: function formatPriceAccessories(index) {
      var i = index.slice(7, index.length);
      //this.accessories[i].price = this.accessories[i].price.replace(/\D+/g, '');
      this.accessories[i].price = editCalc_numeral(this.accessories[i].price).format("0.0,[00]");
    },
    setAccessories: function setAccessories(index) {
      var i = index.slice(7, index.length);
      var x = this.accessories[i].group;
      // /this.accessories[i].kw = this.allProducts[this.accessories[i].group][this.accessories[i].product.index].Potenza
      //this.accessories[i].price = (this.allProducts[this.accessories[i].group][this.accessories[i].product.index].prezzo).replace(' ', '').replace('€', '')
      this.formatPriceAccessories(index);
      this.accessories[i].quantity = 1;
      this.calcTotalPriceAccessories();

      // CONTROL IF PRESENT ALL RULES
      this.checkAccessoriesWithBonusRules(index);
    },
    checkAccessoriesWithBonusRules: function checkAccessoriesWithBonusRules(index) {
      var i = index.slice(7, index.length);
      var group = this.accessories[i].group;

      if (this.ecoBonus == "Ecobonus 50%" || this.ecoBonus == "Bonus Casa 50%") {
        // IF PRESENT TERMOREGOLAZIONE && CONDENSAZIONE => CAN GET BONUS 65%
        var presentCondenset = false;
        for (var x in this.products) {
          if (this.products[x].group == "condensazione") {
            presentCondenset = true;
          }
        }
        if (group == "termoregolazione" && presentCondenset) {
          var alert = {};
          alert.text = "Con caldaia a condensazione, valvole termostatiche e centraline termoregolazione evoluta puoi aderire all`Ecobonus 65%";
          alert.type = "NOTIFICATION";
          this.$warn(alert.text);
          this.$store.dispatch(notifications["a" /* ADD_NOTIFICATIONS */], alert);
          this.$swal({
            type: "info",
            title: "ATTENZIONE",
            html: alert.text
          });
        }
      }
    },
    insertAccessoriesCode: function insertAccessoriesCode(input) {
      var _this8 = this;

      var i = input.slice(7, input.length);
      this.$log(i);

      this.$swal({
        title: "Inserisci il codice accessorio",
        input: "text",
        text: "esempio: 0020124480",
        inputAttributes: {
          autocapitalize: "on"
        },
        showCancelButton: true,
        confirmButtonText: "Cerca",
        showLoaderOnConfirm: true,
        preConfirm: function () {
          var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(searchItem) {
            var result, length;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this8.searchAccessories(searchItem, i, input);

                  case 2:
                    result = _context5.sent;
                    length = searchItem.length;

                    if (!(length != 10)) {
                      _context5.next = 7;
                      break;
                    }

                    _this8.$swal.showValidationMessage("Codice Accessorio " + "deve essere composto da 10 caratteri");
                    return _context5.abrupt("return", false);

                  case 7:
                    if (!result) {
                      _context5.next = 11;
                      break;
                    }

                    return _context5.abrupt("return", result);

                  case 11:
                    //throw new Error('Prodotto non trovato')
                    _this8.$swal.showValidationMessage(" " + "Accessorio non trovato");

                  case 12:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this8);
          }));

          return function preConfirm(_x2) {
            return _ref3.apply(this, arguments);
          };
        }(),
        allowOutsideClick: function allowOutsideClick() {
          return !Swal.isLoading();
        }
      }).then(function (result) {
        _this8.calcTotalPriceAccessories();
      });
    },
    searchAccessories: function searchAccessories(searchItem, index, input) {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var data, x, y, z;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = _this9.allProducts;
                _context6.t0 = regenerator_default.a.keys(data);

              case 2:
                if ((_context6.t1 = _context6.t0()).done) {
                  _context6.next = 20;
                  break;
                }

                x = _context6.t1.value;

                if (!(x != "condensazione" && x != "tradizionale" && x != "pompadicalore" && x != "scaldacqua" && x != "climatizzatore" && x != "solare")) {
                  _context6.next = 18;
                  break;
                }

                _context6.t2 = regenerator_default.a.keys(data[x]);

              case 6:
                if ((_context6.t3 = _context6.t2()).done) {
                  _context6.next = 18;
                  break;
                }

                y = _context6.t3.value;

                if (!(data[x][y].codice == searchItem)) {
                  _context6.next = 16;
                  break;
                }

                //0010014674
                _this9.itemsAccessories[input] = _this9.allProducts[x];
                _this9.accessories[index].group = x;
                z = {
                  index: y,
                  name: data[x][y].Modello,
                  serial: data[x][y].codice
                };

                _this9.accessories[index].product = z;
                _this9.accessories[index].quantity = 1;
                //this.accessories[index].price = data[x][y].prezzo

                _this9.$log(_this9.accessories);

                return _context6.abrupt("return", data[x][y]);

              case 16:
                _context6.next = 6;
                break;

              case 18:
                _context6.next = 2;
                break;

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    mynotifications: function mynotifications() {
      return this.getNotifications;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },


    // NEWWWWWWWWWWWWWWWWWWWWWWWWWWW **************************************** ONLY FOR EDIT

    setCap: function setCap(cap) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this10.zips) {
                  if (_this10.zips[x].cap == cap.toUpperCase()) {
                    _this10.zip = _this10.zips[x].cap;
                  }
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    setCity: function setCity(city) {
      var _this11 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x, k;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this11.cities) {
                  if (_this11.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this11.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this11.city = k;
                  }
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this12 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var x;
        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                for (x in _this12.provincies) {
                  if (_this12.provincies[x].sigla == province.toUpperCase()) {
                    _this12.province = _this12.provincies[x].sigla;
                  }
                }

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    getInvoiceProducts: function getInvoiceProducts(code) {
      var _this13 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getInvoiceProducts",
                  method: "POST",
                  data: {
                    code: code
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  var items = resp.data.products;
                  var _vue = _this13;

                  _this13.$log(items);

                  _vue.productIndex = 0;
                  _vue.accessoriesIndex = 0;

                  var prodCount = 0;
                  var accCount = 0;

                  for (var x in items) {
                    // SET PRODUCTS

                    if (items[x].tipo == "product") {
                      _vue.addProduct();

                      // SET GROUP AND WAIT
                      _vue.products[prodCount].index = "product" + prodCount;
                      _vue.products[prodCount].indexCount = "quantity" + prodCount;
                      _vue.products[prodCount].group = items[x].gruppo;

                      _vue.setGroup(_vue.products[prodCount].index);

                      // FOR PRELOAD PRODUCTS OF THIS GROUP
                      setTimeout(function (x, items, Vue, prodCount) {
                        var y = {};

                        /////////////////////////////////////////////////////////////////////////
                        for (var u in _vue.items["product" + prodCount]) {
                          if (_vue.items["product" + prodCount][u]) {
                            if (_vue.items["product" + prodCount][u].Modello == items[x].nome) {
                              y.index = parseInt(u);
                            }
                          }
                        }

                        if (!y.index) {
                          y.index = accCount + 100;
                        }
                        //////////////////////////////////////////////////////////////////////////

                        y.name = items[x].nome;
                        y.serial = items[x].codice;
                        //_vue.products[x].product = y
                        _vue.products[prodCount].price = "";
                        _vue.products[prodCount].quantity = 1;

                        setTimeout(function (x, items, Vue, prodCount) {
                          var o = items[x].prezzo.replace(".", "");
                          _vue.products[prodCount].price = o;
                          _vue.products[prodCount].quantity = parseInt(items[x].quantita);
                          _vue.calcTotalPriceProducts();
                        }, 1000, x, items, Vue, prodCount);

                        _vue.products[prodCount].error = false;

                        _vue.$log(y);

                        var e = _vue.products[prodCount];
                        e.product = y;
                        Vue.set(_vue.products, prodCount, e);

                        _vue.setProduct(_vue.products[prodCount].index);
                      }, 1500, x, items, vue_esm["a" /* default */], prodCount);

                      prodCount = prodCount + 1;

                      //_vue.productIndex = prodCount
                    }
                    // SET ACCESORIES
                    else {
                        _vue.addAccessories();

                        // SET GROUP AND WAIT
                        _vue.accessories[accCount].index = "product" + accCount;
                        _vue.accessories[accCount].indexCount = "quantity" + accCount;
                        _vue.accessories[accCount].group = items[x].gruppo;
                        _vue.setTypeAccessories(_vue.accessories[accCount].index);

                        // FOR PRELOAD PRODUCTS OF THIS GROUP
                        setTimeout(function (x, items, Vue, accCount) {
                          var y = {};

                          for (var u in _vue.itemsAccessories["product" + accCount]) {
                            if (_vue.itemsAccessories["product" + accCount][u]) {
                              if (_vue.itemsAccessories["product" + accCount][u].Modello == items[x].nome) {
                                y.index = parseInt(u);
                              }
                            }
                          }

                          if (!y.index) {
                            y.index = accCount + 100;
                          }

                          y.name = items[x].nome;
                          y.serial = items[x].codice;

                          _vue.accessories[accCount].price = "";
                          _vue.accessories[accCount].quantity = 1;

                          //_vue.products[x].product = y
                          setTimeout(function (x, items, Vue, accCount) {
                            var p = items[x].prezzo.replace(".", "");
                            _vue.accessories[accCount].price = p;
                            _vue.accessories[accCount].quantity = parseInt(items[x].quantita);
                            _vue.calcTotalPriceAccessories();
                          }, 1000, x, items, Vue, accCount);

                          _vue.accessories[accCount].error = false;

                          var e = _vue.accessories[accCount];
                          e.product = y;
                          Vue.set(_vue.accessories, accCount, e);

                          _vue.setAccessories(_vue.accessories[accCount].index);
                        }, 1500, x, items, vue_esm["a" /* default */], accCount);

                        accCount = accCount + 1;

                        //_vue.accessoriesIndex = accCount
                      }
                  }
                }).catch(function (resp) {});

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    calcIvaCustom: function calcIvaCustom(val) {
      /*
      iva_altri_oneri: 0.22,
      iva_accessori_lavoro: 0.1,
      iva_age_extra: 0.22,
      iva_age_lavoro: 0.1,
      iva_age_accessori: 0.1,*/

      if (val == "Partita IVA") {
        this.iva_accessori_lavoro = 0.22;
        this.iva_age_lavoro = 0.22;
        this.iva_age_accessori = 0.22;
      } else {
        if (this.usoAbitativo == 0) {
          this.iva_accessori_lavoro = 0.22;
          this.iva_age_lavoro = 0.22;
          this.iva_age_accessori = 0.22;
        } else {
          this.iva_accessori_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_lavoro = parseFloat(0.1).toFixed(2);
          this.iva_age_accessori = parseFloat(0.1).toFixed(2);
        }
      }
    }
  },
  watch: {
    client_type: function client_type(val) {
      this.calcIvaCustom(val);
    },
    usoAbitativo: function usoAbitativo(val) {
      this.calcIvaCustom(this.client_type);
    },

    zeroEnea: function zeroEnea(val) {
      this.$log("1");
      if (val) {
        this.zeroEneaOld = this.priceEnea;
        this.priceEnea = "0";
      } else {
        this.priceEnea = this.zeroEneaOld;
      }
      this.beginCalc("nopopup");
    },
    zeroDcast: function zeroDcast(val) {
      this.$log("1");
      if (val) {
        this.zeroDcastOld = this.priceDcast;
        this.priceDcast = "0";
      } else {
        this.priceDcast = this.zeroDcastOld;
      }
      this.beginCalc("nopopup");
    },
    zeroOneri: function zeroOneri(val) {
      this.$log("2");
      if (val) {
        this.zeroOneriOld = this.calcInfo.costoAttualizazione;
        this.calcInfo.costoAttualizazione = 0;
      } else {
        this.calcInfo.costoAttualizazione = this.zeroOneriOld;
      }
      this.beginCalc("nopopup");
    },
    zeroPratica: function zeroPratica(val) {
      this.$log("3");
      if (val) {
        this.zeroPraticaOld = this.calcInfo.serviceCost;
        this.calcInfo.serviceCost = 0;
      } else {
        this.calcInfo.serviceCost = this.zeroPraticaOld;
      }
      this.beginCalc("nopopup");
    },
    products: {
      handler: function handler(val) {},

      deep: true
    },
    priceWork: function priceWork(val) {
      this.priceWork = val.replace(/[a-bA-B`~!@#$£%^&*()_|+\-=?;:"<>\{\}\[\]\\\/]/gi, "");
    },
    clientName: function clientName(val) {
      if (val) {
        this.clientName = val.replace(/\d+/g, "");
        this.clientName = this.clientName.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientName = this.clientName.toUpperCase();
      }
    },
    clientLastname: function clientLastname(val) {
      if (val) {
        this.clientLastname = val.replace(/\d+/g, "");
        this.clientLastname = this.clientLastname.replace(/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi, "");
        this.clientLastname = this.clientLastname.toUpperCase();
      }
    },
    client_mobile: function client_mobile(val) {
      if (val) {
        this.client_mobile = val.replace(/\D+/g, "");
      }
    },
    client_phone: function client_phone(val) {
      if (val) {
        this.client_phone = val.replace(/\D+/g, "");
      }
    },
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    authStatus: function authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },

    vw: function vw() {
      if (this.vw > 1200) {
        this.stepSize = "md";
      } else if (this.vw > 600) {
        this.stepSize = "sm";
      } else {
        this.stepSize = "xs";
      }
    },
    priceAcc: function priceAcc(value) {
      // /this.priceAcc = parseInt(this.priceAcc) + '.00'
    },

    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this14 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this14.cities = resp.data.cities;
          _this14.citiesState = false;
        }).catch(function (resp) {
          _this14.cities = [];
          _this14.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this15 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this15.zips = resp.data.zips;
          _this15.zipsState = false;
        }).catch(function (resp) {
          _this15.zips = [];
          _this15.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    this.loadProducts();
  },
  mounted: function mounted() {
    // NEWWWWWW ***************************************************************
    if (this.$route.params.item) {
      this.item = this.$route.params.item;
      var data = this.item;
      // START POPULATE DATA
      this.$log(data);

      this.ecoBonus = data.bonus;
      // TAB 1 CLIENT
      this.clientLastname = data.client_name;
      this.clientName = data.client_lastname;
      this.adress = data.building_address;
      this.civic = data.building_civic;
      this.email = "";
      this.phone = "";
      this.mobile = "";
      this.provincies = [];
      this.province = "";
      this.provinciesState = true;
      this.cities = [];
      this.citiesState = false;
      this.zips = [];
      this.zipsState = false;
      this.cityError = false;
      this.zipError = false;
      this.city = "";
      this.zip = "";
      this.datiCatastali = parseInt(data.to_get_cadastral_data);

      this.client_mobile = data.client_mobile;
      this.client_phone = data.client_phone;
      this.client_email = data.client_email;
      //TAB2 INTERVENTO
      this.eventType = data.intervention_type;
      this.eventStartdate = data.intervention_date;

      this.totalAccessories = data.total_accessories_price;
      this.totalProducts = data.total_product_price;
      this.enea = parseInt(data.enea_request);
      this.requiredOperations = "";
      this.client_type = data.client_type;
      this.priceEnea = data.client_price_enea ? data.client_price_enea : "0";
      this.priceDcast = "0";

      this.priceWork = data.price_work;

      this.totalExtraMise = 0;
      this.NoEnea = true;

      this.client_ownership = data.client_ownership;

      var _vue = this;
      setTimeout(function () {
        _vue.usoAbitativo = parseInt(data.building_uso_abitativo);
        _vue.iva_altri_oneri = data.iva_altri_oneri;
        _vue.iva_accessori_lavoro = data.iva_accessori_lavoro;
        _vue.iva_age_extra = data.iva_age_extra;
        _vue.iva_age_lavoro = data.iva_age_lavoro;
        _vue.iva_age_accessori = data.iva_age_accessori;
      }, 2000);

      this.$log(" IVAAAAAAAAAAAAAAAAAAAAAAAAAA");
      this.$log(this.iva_altri_oneri);
      this.$log(this.iva_accessori_lavoro);
      this.$log(this.iva_age_extra);
      this.$log(this.iva_age_lavoro);
      this.$log(this.iva_age_accessori);

      //if (data && data.client_type != 'Amministratore di condominio') {
      if (data) {
        setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
          var province;
          return regenerator_default.a.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  province = _vue.item.building_province;
                  _context13.next = 3;
                  return _vue.setProvince(province);

                case 3:
                  _context13.next = 5;
                  return _vue.getInvoiceProducts(data.id);

                case 5:

                  setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12() {
                    var city;
                    return regenerator_default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            city = _vue.item.building_city;
                            _context12.next = 3;
                            return _vue.setCity(city);

                          case 3:

                            setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
                              var cap;
                              return regenerator_default.a.wrap(function _callee11$(_context11) {
                                while (1) {
                                  switch (_context11.prev = _context11.next) {
                                    case 0:
                                      cap = _vue.item.building_zip;
                                      _context11.next = 3;
                                      return _vue.setCap(cap);

                                    case 3:
                                    case "end":
                                      return _context11.stop();
                                  }
                                }
                              }, _callee11, this);
                            })), 1500);

                          case 4:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, this);
                  })), 1500);

                case 6:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        })), 1500);
      }
    } else {
      this.$router.push("/offerte");
    }

    // ***********************************************************************************************

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.populateProvincies();

    this.disabledDatesStart = {
      to: this.calcToDateStart(), // Disable all dates up to specific date
      from: this.calcFromDateStart() // Disable all dates after specific date
    };

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getNotifications", "getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    notifications: function notifications(state) {
      return "" + state.notifications;
    }
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d13b52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editCalc/index.vue
var editCalc_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.corporateClient == "hoval"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [
          _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("HovalEditCalc")
        ],
        1
      )
    : _vm.corporateClient == "emicon"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [
          _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("EmiconEditCalc")
        ],
        1
      )
    : _vm._e()
}
var editCalc_staticRenderFns = []
editCalc_render._withStripped = true
var editCalc_esExports = { render: editCalc_render, staticRenderFns: editCalc_staticRenderFns }
/* harmony default export */ var components_editCalc = (editCalc_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42d13b52", editCalc_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/editCalc/index.vue
var editCalc_disposed = false
var editCalc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editCalc___vue_template_functional__ = false
/* styles */
var editCalc___vue_styles__ = null
/* scopeId */
var editCalc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var editCalc___vue_module_identifier__ = null
var editCalc_Component = editCalc_normalizeComponent(
  editCalc,
  components_editCalc,
  editCalc___vue_template_functional__,
  editCalc___vue_styles__,
  editCalc___vue_scopeId__,
  editCalc___vue_module_identifier__
)
editCalc_Component.options.__file = "src/components/editCalc/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-42d13b52", editCalc_Component.options)
  } else {
    hotAPI.reload("data-v-42d13b52", editCalc_Component.options)
  }
  module.hot.dispose(function (data) {
    editCalc_disposed = true
  })
})()}

/* harmony default export */ var src_components_editCalc = (editCalc_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/acceptInvoice/hoval.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var acceptInvoice_hoval_moment = __webpack_require__("PJh5");

/* harmony default export */ var acceptInvoice_hoval = ({
  name: "Hoval",
  components: {},
  data: function data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: {},
      hideData: false,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      mobile: "",
      cellulare: "",
      numero_ordine: "",
      citySE: "",
      capSE: "",

      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      client_ownership: "",
      subalterno: "",
      particella: "",
      foglio: "",
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      userForLog: {}
    };
  },

  methods: {
    convertToPractice: function convertToPractice() {
      var _this = this;

      var _vue = this;
      this.$log(this.$validator);

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;
          // PREPARE
          var data = {};
          data.client_email = _this.item.client_email;
          data.client_codice_fiscale = _this.codice_fiscale;
          data.client_partita_iva = _this.partita_iva;
          data.client_phone = _this.item.client_phone;
          data.client_mobile = _this.item.client_mobile;
          data.client_address = _this.address;
          data.client_civic = _this.civic;
          if (_this.province != "SE") {
            data.client_province = _this.province;
            data.client_city = _this.city.city;
            data.client_zip = _this.zip;
          } else {
            data.client_province = _this.province;
            data.client_city = _this.citySE;
            data.client_zip = _this.capSE;
          }

          data.client_ownership = _this.client_ownership;
          data.corporateClient = _this.getProfile.corporateClient;
          data.building_subalterno = _this.subalterno;
          data.building_particella = _this.particella;
          data.building_foglio = _this.foglio;
          data.practice_id = _this.item.id;
          data.numOrdine = _this.numero_ordine;

          data.date_accept_offer = acceptInvoice_hoval_moment().format("YYYY-MM-DD HH:mm:ss");

          data.code = _this.item.code;

          if (_this.tokenControl) {
            data.user_token = _this.$route.query.t;
          } else {
            data.user_token = _this.getProfile.userToken;
          }

          data.signed_order = _this.invoiceFrontBucketNoCrypt;
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/acceptOrder",
            method: "POST",
            data: { data: data },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");

            _vue.loadingState = false;

            if (_vue.tokenControl) {
              _vue.$swal({
                type: "success",
                title: "Pratica Inizializzata",
                html: "Abbiamo creato la pratica <b>" + _this.item.code + "</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. "
              });

              _vue.hideData = true;
            } else {
              _vue.$swal({
                type: "success",
                title: "Pratica Inizializzata",
                html: "Abbiamo creato la pratica <b>" + _this.item.code + "</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. "
              });
            }

            _vue.$router.push("/pratiche");
          }).catch(function (resp) {
            _vue.loadingState = false;
            _vue.$swal({
              type: "error",
              title: "Oops...",
              text: "Riprova piu tardi!"
            });
          });
        } else {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        }
      });
    },
    populateProvincies: function populateProvincies() {
      var _this2 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this2.provincies = resp.data.provincies;
        _this2.provinciesState = false;
      }).catch(function (resp) {
        _this2.provincies = [];
        _this2.provinciesState = false;
      });
    },
    checkUserToken: function checkUserToken(token) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$log("QRcode CHECK TOKEN");
                if (_this3.getProfile.corporateClient == "agnellimetalli") {
                  _this3.$router.push("/");
                }
                data = {
                  user_token: token
                };

                data = _this3.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/tokenControl",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this3.$log("QRcode CHECK TOKEN => OK");
                  _this3.userForLog.email = resp.data.description[0].email;
                  _this3.user;
                  _this3.tokenControl = true;
                }).catch(function (resp) {
                  _this3.$log("QRcode CHECK TOKEN => ERROR");
                  _this3.tokenControl = false;
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getPracticById: function getPracticById(userToken, id) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$log("GET PRACTIC FOR QRcode ENTER");
                data = {
                  user_token: userToken,
                  id: id
                };

                data = _this4.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context2.next = 5;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getPracticById",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this4.$log("GET PRACTIC FOR QRcode => OK");
                  // CHECK IF ACTIVE YET

                  _this4.$route.params.item = resp.data.practices[0];

                  // MENU OFF FOR THIS CASE
                  var alert = {};
                  alert.text = "NOT LOGED VIEW";
                  alert.type = "MENU_OFF";
                  //this.$store.dispatch(ADD_NOTIFICATIONS, alert)
                }).catch(function (resp) {
                  _this4.$log("GET PRACTIC FOR QRcode => ERROR");
                  _this4.tokenControl = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },
    UploadError: function UploadError() {
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Errore caricamento immagine"
      });
    },
    setCap: function setCap(cap) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var x;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (x in _this5.zips) {
                  if (_this5.zips[x].cap == cap.toUpperCase()) {
                    _this5.zip = _this5.zips[x].cap;
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    setCity: function setCity(city) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var x, k;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (x in _this6.cities) {
                  if (_this6.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this6.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this6.city = k;
                  }
                }
                _this6.$log(_this6.city);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (x in _this7.provincies) {
                  if (_this7.provincies[x].sigla == province.toUpperCase()) {
                    _this7.province = _this7.provincies[x].sigla;
                  }
                }
                _this7.$log(_this7.province);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append("fattura" + t, input.target.files[x]);
          t = t + 1;
        }

        this.loadingState = true;

        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadImageInvoice", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.loadingState = false;
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
            _vue.invoiceFrontBucketNoCrypt = e.data.fatturaNoCrypt;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.invoiceFrontBucketNoCrypt = "";
            _vue.UploadError();
            input.target.value = null;
            _vue.loadingState = false;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = "";
          _vue.invoiceFrontBucket = "";
          _vue.invoiceFrontBucketNoCrypt = "";
          _vue.UploadError();
          input.target.value = null;
          _vue.loadingState = false;
        });
      }
    },
    enterPassword: function enterPassword(token) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var alert;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this8.$swal({
                  title: "Password",
                  html: "Inserisci la password con cui ti sei registrato alla piattaforma. <br/>",
                  input: "password",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonText: "Entra",
                  cancelButtonText: "Esci",
                  allowOutsideClick: false,
                  showLoaderOnConfirm: true,
                  preConfirm: function preConfirm(alert) {
                    if (alert == "") {
                      _this8.$swal.showValidationMessage("Il campo password richiesto");
                    } else {
                      //CHECK PASSWORD
                      var data = {
                        user_token: token,
                        password: alert.trim()
                      };
                      data = _this8.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                      return axios_default()({
                        url: "https://wsbot.eu/ebonusBack/public/" + "api/passwordControl",
                        method: "POST",
                        data: { data: data },
                        headers: {
                          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                          "Content-type": "application/json"
                        }
                      }).then(function (resp) {
                        resp.data = _this8.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                        _this8.$log("QRcode CHECK PASSWORD => OK");
                        _this8.passwordControl = true;
                        _this8.userForLog.password = alert.trim();
                        return true;
                      }).catch(function (resp) {
                        _this8.passwordControl = false;
                        _this8.$swal.showValidationMessage("Password errata");
                        return false;
                      });
                    }
                  }
                });

              case 3:
                alert = _context6.sent;
                return _context6.abrupt("return", !!alert);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", false);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 7]]);
      }))();
    }
  },
  watch: {
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    capSE: function capSE(val) {
      if (val) {
        this.capSE = val.replace(/\D+/g, "");
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    mobile: function mobile(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, "");
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this9 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this9.cities = resp.data.cities;
          _this9.citiesState = false;
        }).catch(function (resp) {
          _this9.cities = [];
          _this9.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this10 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.zips = resp.data.zips;
          _this10.zipsState = false;
        }).catch(function (resp) {
          _this10.zips = [];
          _this10.zipsState = false;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this11 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var data, _vue;

      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              //http://localhost:8080/acceptInvoice?crt=38&t=9697a3c74a75d1393ce15644af776053
              _this11.$log(_this11.$route);

              if (!(_this11.$route.query.crt && _this11.$route.query.t)) {
                _context10.next = 18;
                break;
              }

              _this11.$log("QRcode ACCEPT INVOICE");

              _context10.next = 5;
              return _this11.enterPassword(_this11.$route.query.t);

            case 5:
              if (!_this11.passwordControl) {
                _context10.next = 17;
                break;
              }

              // CHECK USER TOKEN
              _this11.fromQRcode = true;
              _context10.next = 9;
              return _this11.checkUserToken(_this11.$route.query.t);

            case 9:
              if (!_this11.tokenControl) {
                _context10.next = 15;
                break;
              }

              // LOGIN USER
              /*localStorage.setItem('user-token', this.$route.query.t)
                this.$store.dispatch(SET_USER_TOKEN, this.$route.query.t)*/
              data = {
                username: _this11.userForLog.email,
                password: _this11.userForLog.password
              };

              data = _this11.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
              _this11.$store.dispatch(auth["f" /* AUTH_REQUEST */], {
                data: data
              });

              _context10.next = 15;
              return _this11.getPracticById(_this11.$route.query.t, _this11.$route.query.crt);

            case 15:
              _context10.next = 18;
              break;

            case 17:
              _this11.$router.push("/");

            case 18:

              if (_this11.$route.params.item) {
                _this11.item = _this11.$route.params.item;

                // CHECK IF ORDER OR PRACTICE
                if (_this11.$route.params.item.status == "0") {
                  _this11.$log(0);
                  if (_this11.item && _this11.item.client_type != "Amministratore di condominio") {
                    _this11.address = _this11.item.building_address;
                    _this11.civic = _this11.item.building_civic;

                    _this11.client_ownership = _this11.item.client_ownership;
                  }
                } else if (_this11.$route.params.item.status == "1") {
                  _this11.$log(11);
                  _this11.$router.push({
                    name: "loadDocuments",
                    params: {
                      item: _this11.item
                    }
                  });
                } else if (_this11.$route.params.item.status == "9") {
                  _this11.orderRemoved = true;
                } else {
                  _this11.$router.push("/pratiche");
                }
              } else {
                if (!_this11.tokenControl) {
                  _this11.$router.push("/offerte");
                }
              }

              _this11.populateProvincies();
              _this11.$log(_this11.item);

              if (_this11.item && _this11.item.client_type != "Amministratore di condominio") {
                _vue = _this11;


                _this11.$log("SET REGION");

                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                  var province;
                  return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _vue.$log("SET PROVINCE" + _vue.item.building_province);
                          province = _vue.item.building_province;
                          _context9.next = 4;
                          return _vue.setProvince(province);

                        case 4:
                          _vue.$log("SET PROVINCE SUCCESS");

                          setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                            var city;
                            return regenerator_default.a.wrap(function _callee8$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    _vue.$log("SET CITY");
                                    city = _vue.item.building_city;
                                    _context8.next = 4;
                                    return _vue.setCity(city);

                                  case 4:
                                    _vue.$log("SET CITY SUCCESS");

                                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                                      var cap;
                                      return regenerator_default.a.wrap(function _callee7$(_context7) {
                                        while (1) {
                                          switch (_context7.prev = _context7.next) {
                                            case 0:
                                              _vue.$log("SET CAP");
                                              cap = _vue.item.building_zip;
                                              _context7.next = 4;
                                              return _vue.setCap(cap);

                                            case 4:
                                              _vue.$log("SET CAP SUCCESS");

                                            case 5:
                                            case "end":
                                              return _context7.stop();
                                          }
                                        }
                                      }, _callee7, this);
                                    })), 1500);

                                  case 6:
                                  case "end":
                                    return _context8.stop();
                                }
                              }
                            }, _callee8, this);
                          })), 1500);

                        case 6:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9, this);
                })), 1500);
              }

              _this11.$scrollTo("#app", 700, { offset: -75 });

            case 23:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this11);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83256d60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acceptInvoice/hoval.vue
var acceptInvoice_hoval_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\r\n        Completa il form qui sotto.\r\n        I dati inseriti verranno poi utilizzati per creare la pratica del Bonus richiesto.\r\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.item.client_type != "Amministratore di condominio"
                      ? _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\r\n            Completa i dati del cliente finale ("
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.item.client_name) +
                                " " +
                                _vm._s(_vm.item.client_lastname)
                            )
                          ]),
                          _vm._v(")\r\n          ")
                        ])
                      : _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\r\n            Completa i dati dell'Amministratore del condominio ("
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.item.client_name) +
                                " " +
                                _vm._s(_vm.item.client_lastname)
                            )
                          ]),
                          _vm._v(")\r\n          ")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_name,
                            expression: "item.client_name"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 63, min: 2 },
                            expression: "{required:true, max: 63, min: 2}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("clientName"),
                          valid: !!_vm.item.client_name
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "clientName",
                          name: "clientName",
                          "data-vv-as": "Nome"
                        },
                        domProps: { value: _vm.item.client_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_name",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "clientName" }
                        },
                        [_vm._v("Nome *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("clientName")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("clientName")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_lastname,
                            expression: "item.client_lastname"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 63, min: 2 },
                            expression: "{required:true, max: 63, min: 2}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("clientLastname"),
                          valid: !!_vm.item.client_lastname
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "clientLastname",
                          name: "clientLastname",
                          "data-vv-as": "Cognome"
                        },
                        domProps: { value: _vm.item.client_lastname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_lastname",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "clientLastname" }
                        },
                        [_vm._v("Cognome *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("clientLastname")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("clientLastname")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3 " }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_email,
                            expression: "item.client_email"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              email: true,
                              temporaryEmail: true,
                              plusIssueEmail: true,
                              max: 56
                            },
                            expression:
                              "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("email"),
                          valid: !!_vm.item.client_email
                        },
                        attrs: {
                          type: "text",
                          id: "email",
                          name: "email",
                          "data-vv-as": "Email"
                        },
                        domProps: { value: _vm.item.client_email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_email",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "email" }
                        },
                        [_vm._v("Email* ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("email")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("email")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.item.client_type == "Persona fisica" ||
                  _vm.item.client_type == "Amministratore di condominio"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.codice_fiscale,
                                expression: "codice_fiscale"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  codiceFiscale: true,
                                  max: 16,
                                  min: 16
                                },
                                expression:
                                  "{required: true, codiceFiscale: true, max: 16, min: 16}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("codice_fiscale"),
                              valid: !!_vm.codice_fiscale
                            },
                            attrs: {
                              type: "text",
                              id: "codice_fiscale",
                              name: "codice_fiscale",
                              "data-vv-as": "Codice Fiscale"
                            },
                            domProps: { value: _vm.codice_fiscale },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.codice_fiscale = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "codice_fiscale" }
                            },
                            [_vm._v("Codice Fiscale *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("codice_fiscale")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("codice_fiscale")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm.item.client_type == "Partita IVA"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partita_iva,
                                expression: "partita_iva"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  partitaIva: true,
                                  max: 11,
                                  min: 11
                                },
                                expression:
                                  "{required: true, partitaIva: true, max: 11, min: 11}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("partita_iva"),
                              valid: !!_vm.partita_iva
                            },
                            attrs: {
                              type: "text",
                              id: "partita_iva",
                              name: "partita_iva",
                              "data-vv-as": "Partita IVA"
                            },
                            domProps: { value: _vm.partita_iva },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partita_iva = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "partita_iva" }
                            },
                            [_vm._v("Partita IVA *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("partita_iva")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("partita_iva")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_phone,
                            expression: "item.client_phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: false,
                              max: 12,
                              min: 8,
                              regex: /^[0,3]+/
                            },
                            expression:
                              "{required: false, max: 12, min: 8, regex: /^[0,3]+/}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("phone"),
                          valid: !!_vm.item.client_phone
                        },
                        attrs: {
                          type: "text",
                          id: "phone",
                          name: "phone",
                          "data-vv-as": "Telefono"
                        },
                        domProps: { value: _vm.item.client_phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_phone",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "phone" }
                        },
                        [_vm._v("Telefono ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("phone")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("phone")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_mobile,
                            expression: "item.client_mobile"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 12,
                              min: 8,
                              regex: /^[0,3]+/
                            },
                            expression:
                              "{required: true, max: 12, min: 8, regex: /^[0,3]+/}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("mobile"),
                          valid: !!_vm.item.client_mobile
                        },
                        attrs: {
                          type: "text",
                          id: "mobile",
                          name: "mobile",
                          "data-vv-as": "Cellulare"
                        },
                        domProps: { value: _vm.item.client_mobile },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_mobile",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "mobile" }
                        },
                        [_vm._v("Cellulare * ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("mobile")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("mobile")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v("\r\n            Indirizzo immobile: "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.item.building_address) +
                            " " +
                            _vm._s(_vm.item.building_civic) +
                            " - " +
                            _vm._s(_vm.item.building_zip) +
                            " " +
                            _vm._s(_vm.item.building_city) +
                            " (" +
                            _vm._s(_vm.item.building_province) +
                            ")"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black pb-4" }, [
                      _vm._v("\r\n            Indirizzo di residenza "),
                      _vm.item.client_type != "Amministratore di condominio"
                        ? _c("span", [_vm._v("(modifica se necessario)")])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.province,
                              expression: "province"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{required:true}"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("province"),
                            valid: !!_vm.province
                          },
                          attrs: {
                            autocomplete: "randomy",
                            id: "province",
                            name: "province",
                            "data-vv-as": "Provincia"
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.province = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", {
                            attrs: {
                              disabled: "",
                              value: "",
                              selected: "selected"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "option",
                            { key: 2341253542, domProps: { value: "SE" } },
                            [
                              _vm._v(
                                "\r\n                  STATO ESTERO\r\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.provincies, function(province) {
                            return _c(
                              "option",
                              {
                                key: province.sigla,
                                domProps: { value: province.sigla }
                              },
                              [
                                _vm._v(
                                  "\r\n                  " +
                                    _vm._s(province.sigla) +
                                    " - " +
                                    _vm._s(province.provincia) +
                                    "\r\n                "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "province" }
                        },
                        [_vm._v("Provincia *")]
                      ),
                      _vm._v(" "),
                      _vm.provinciesState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadProvince",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("province")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("province")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _vm.cityError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli Provincia")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("city"),
                                valid: !!_vm.city
                              },
                              attrs: {
                                autocomplete: "randomu",
                                id: "city",
                                name: "city",
                                "data-vv-as": "Località",
                                disabled: _vm.citiesState
                              },
                              on: {
                                click: _vm.checkProvince,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.city = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", {
                                attrs: {
                                  disabled: "",
                                  value: "",
                                  selected: "selected"
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.cities, function(city) {
                                return _c(
                                  "option",
                                  {
                                    key: city.comune,
                                    domProps: {
                                      value: {
                                        cityistat: city.istat,
                                        city: city.comune
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(city.comune) +
                                        "\r\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.citySE,
                                expression: "citySE"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("citySE"),
                              valid: !!_vm.citySE
                            },
                            attrs: {
                              autocomplete: "randomu",
                              id: "citySE",
                              name: "citySE",
                              "data-vv-as": "Località",
                              disabled: _vm.citiesState
                            },
                            domProps: { value: _vm.citySE },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.citySE = $event.target.value
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Località *")]
                          )
                        : _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Località e Paese*")]
                          ),
                      _vm._v(" "),
                      _vm.citiesState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadCity",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("city")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("city")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("citySE")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("citySE")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _vm.zipError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli città")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("zip"),
                                valid: !!_vm.zip
                              },
                              attrs: {
                                autocomplete: "randomi",
                                id: "zip",
                                name: "zip",
                                "data-vv-as": "Cap",
                                disabled: _vm.zipsState
                              },
                              on: {
                                click: _vm.checkZip,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.zip = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", {
                                attrs: { value: "", disabled: "" },
                                domProps: { selected: true }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.zips, function(zip) {
                                return _c(
                                  "option",
                                  {
                                    key: zip.cap,
                                    domProps: { value: zip.cap }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(zip.cap) +
                                        "\r\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.capSE,
                                expression: "capSE"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, min: 5, max: 5 },
                                expression: "{required:true, min:5, max:5}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("capSE"),
                              valid: !!_vm.capSE
                            },
                            attrs: {
                              autocomplete: "randomi",
                              id: "capSE",
                              name: "capSE",
                              "data-vv-as": "Cap",
                              disabled: _vm.zipsState
                            },
                            domProps: { value: _vm.capSE },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.capSE = $event.target.value
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "zip" }
                        },
                        [_vm._v("Cap *")]
                      ),
                      _vm._v(" "),
                      _vm.zipsState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadZips",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("zip")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("zip")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("capSE")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("capSE")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.address,
                            expression: "address"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 128, min: 5 },
                            expression: "{required:true, max: 128, min: 5}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("address"),
                          valid: !!_vm.address
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "address",
                          name: "address",
                          "data-vv-as": "Indirizzo"
                        },
                        domProps: { value: _vm.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.address = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "address" }
                        },
                        [_vm._v("Indirizzo *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("address")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("address")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.civic,
                            expression: "civic"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 15, min: 1 },
                            expression: "{required:true, max: 15, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("civic"),
                          valid: !!_vm.civic
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "civic",
                          name: "civic",
                          "data-vv-as": "Civico"
                        },
                        domProps: { value: _vm.civic },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.civic = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "civic" }
                        },
                        [_vm._v("Civico *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("civic")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("civic")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.numero_ordine,
                            expression: "numero_ordine"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 10,
                              min: 3,
                              integer: true,
                              regex: /^[1][2]+/
                            },
                            expression:
                              "{required:true, max: 10, min: 3, integer:true, regex: /^[1][2]+/,}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("numero_ordine"),
                          valid: !!_vm.numero_ordine
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "numero_ordine",
                          name: "numero_ordine",
                          "data-vv-as": "Numero d'ordine"
                        },
                        domProps: { value: _vm.numero_ordine },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.numero_ordine = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "numero_ordine" }
                        },
                        [_vm._v("Numero d'ordine * [ es : 12XXXXXXXX ] ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("numero_ordine")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("numero_ordine")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v(
                        "\r\n            Carica il preventivo firmato\r\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "center" }, [
                      _vm._v(
                        "Se necessario è possibile selezionare piu di un file"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "front-image" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              size: 10240,
                              ext: ["jpeg", "jpg", "png", "pdf"],
                              mimes: [
                                "image/jpeg",
                                "image/jpg",
                                "image/png",
                                "application/pdf"
                              ]
                            },
                            expression:
                              "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                          }
                        ],
                        ref: "fileInput",
                        staticClass: "fileInput",
                        class: {
                          "is-invalid": _vm.errors.has("invoiceFront"),
                          valid: !!_vm.invoiceFront,
                          helper: !!_vm.invoiceFrontBucket
                        },
                        attrs: {
                          type: "file",
                          multiple: "",
                          name: "invoiceFront",
                          id: "invoiceFront",
                          "data-vv-as": "Preventivo firmato"
                        },
                        on: { change: _vm.uploadFile }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel labelFileInput",
                          attrs: { for: "invoiceFront" }
                        },
                        [
                          !_vm.invoiceFrontName
                            ? _c(
                                "span",
                                {
                                  staticClass: "smallText center white",
                                  style: {
                                    backgroundImage:
                                      "url(" + _vm.invoiceFrontBucket + ")"
                                  }
                                },
                                [
                                  !_vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0"
                                        },
                                        [_vm._v("Scegli il Contratto quadro*")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _c("span", {
                                staticClass: "smallText center white",
                                style: {
                                  backgroundImage:
                                    "url(" + _vm.invoiceFrontBucket + ")"
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("invoiceFront")
                        ? _c(
                            "div",
                            {
                              staticClass: "invalid-feedback",
                              staticStyle: { top: "185px" }
                            },
                            [
                              _vm._v(
                                "\r\n              " +
                                  _vm._s(_vm.errors.first("invoiceFront")) +
                                  "\r\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploadFrontPercentage
                        ? _c(
                            "div",
                            {
                              staticClass: "progress mt-5",
                              attrs: { id: "progFront" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar ",
                                  style: {
                                    width: _vm.uploadFrontPercentage + "%"
                                  },
                                  attrs: {
                                    id: "progress-bar-front",
                                    role: "progressbar",
                                    "aria-valuenow": "50",
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\r\n                " +
                                      _vm._s(_vm.uploadFrontPercentage) +
                                      " %\r\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceFrontName
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "smallText center white mt-3 mb-0 pb-0 fileNameText"
                            },
                            [_vm._v(_vm._s(_vm.invoiceFrontName))]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 mt-5 mb-3 center" }, [
                    _vm.invoiceFrontBucket
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.invoiceFrontBucket,
                              target: "_blank"
                            }
                          },
                          [
                            _vm.invoiceFrontBucket.substring(
                              _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                              _vm.invoiceFrontBucket.length
                            ) == "pdf"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "center widthFull pdfLink",
                                    attrs: {
                                      href: _vm.invoiceFrontBucket,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("APRI  PDF")]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 center mt-5 pt-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.convertToPractice }
                      },
                      [_vm._v("Procedi")]
                    )
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\r\n        Hai completatto correttamente la pratica.\r\n      "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orderRemoved
        ? _c("div", { staticClass: "container pt-5 mt-5 " }, [
            _c(
              "div",
              {
                staticClass: "row justify-content-center text-left vaillantCont"
              },
              [
                _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                  _c("b", [
                    _vm._v("ATTENZIONE! "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" Preventivo N. " + _vm._s(_vm.item.code) + " "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" è stato eliminato ")
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-center widthFull" })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var acceptInvoice_hoval_staticRenderFns = []
acceptInvoice_hoval_render._withStripped = true
var acceptInvoice_hoval_esExports = { render: acceptInvoice_hoval_render, staticRenderFns: acceptInvoice_hoval_staticRenderFns }
/* harmony default export */ var components_acceptInvoice_hoval = (acceptInvoice_hoval_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83256d60", acceptInvoice_hoval_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/acceptInvoice/hoval.vue
var acceptInvoice_hoval_disposed = false
function acceptInvoice_hoval_injectStyle (ssrContext) {
  if (acceptInvoice_hoval_disposed) return
  __webpack_require__("Idp3")
}
var acceptInvoice_hoval_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var acceptInvoice_hoval___vue_template_functional__ = false
/* styles */
var acceptInvoice_hoval___vue_styles__ = acceptInvoice_hoval_injectStyle
/* scopeId */
var acceptInvoice_hoval___vue_scopeId__ = "data-v-83256d60"
/* moduleIdentifier (server only) */
var acceptInvoice_hoval___vue_module_identifier__ = null
var acceptInvoice_hoval_Component = acceptInvoice_hoval_normalizeComponent(
  acceptInvoice_hoval,
  components_acceptInvoice_hoval,
  acceptInvoice_hoval___vue_template_functional__,
  acceptInvoice_hoval___vue_styles__,
  acceptInvoice_hoval___vue_scopeId__,
  acceptInvoice_hoval___vue_module_identifier__
)
acceptInvoice_hoval_Component.options.__file = "src/components/acceptInvoice/hoval.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-83256d60", acceptInvoice_hoval_Component.options)
  } else {
    hotAPI.reload("data-v-83256d60", acceptInvoice_hoval_Component.options)
  }
  module.hot.dispose(function (data) {
    acceptInvoice_hoval_disposed = true
  })
})()}

/* harmony default export */ var src_components_acceptInvoice_hoval = (acceptInvoice_hoval_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/acceptInvoice/emicon.vue




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var acceptInvoice_emicon_moment = __webpack_require__("PJh5");

/* harmony default export */ var acceptInvoice_emicon = ({
  name: "Emicon",
  components: {},
  data: function data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: {},
      hideData: false,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      mobile: "",
      cellulare: "",
      numero_ordine: "",
      citySE: "",
      capSE: "",

      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      client_ownership: "",
      subalterno: "",
      particella: "",
      foglio: "",
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      userForLog: {}
    };
  },

  methods: {
    convertToPractice: function convertToPractice() {
      var _this = this;

      var _vue = this;
      this.$log(this.$validator);

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;
          // PREPARE
          var data = {};
          data.client_email = _this.item.client_email;
          data.client_codice_fiscale = _this.codice_fiscale;
          data.client_partita_iva = _this.partita_iva;
          data.client_phone = _this.item.client_phone;
          data.client_mobile = _this.item.client_mobile;
          data.client_address = _this.address;
          data.client_civic = _this.civic;
          if (_this.province != "SE") {
            data.client_province = _this.province;
            data.client_city = _this.city.city;
            data.client_zip = _this.zip;
          } else {
            data.client_province = _this.province;
            data.client_city = _this.citySE;
            data.client_zip = _this.capSE;
          }

          data.client_ownership = _this.client_ownership;
          data.corporateClient = _this.getProfile.corporateClient;
          data.building_subalterno = _this.subalterno;
          data.building_particella = _this.particella;
          data.building_foglio = _this.foglio;
          data.practice_id = _this.item.id;

          data.date_accept_offer = acceptInvoice_emicon_moment().format("YYYY-MM-DD HH:mm:ss");

          data.code = _this.item.code;

          if (_this.tokenControl) {
            data.user_token = _this.$route.query.t;
          } else {
            data.user_token = _this.getProfile.userToken;
          }

          data.signed_order = _this.invoiceFrontBucketNoCrypt;
          data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/acceptOrder",
            method: "POST",
            data: { data: data },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");

            _vue.loadingState = false;

            if (_vue.tokenControl) {
              _vue.$swal({
                type: "success",
                title: "Pratica Inizializzata",
                html: "Abbiamo creato la pratica <b>" + _this.item.code + "</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. "
              });

              _vue.hideData = true;
            } else {
              _vue.$swal({
                type: "success",
                title: "Pratica Inizializzata",
                html: "Abbiamo creato la pratica <b>" + _this.item.code + "</b> dal preventivo che hai confermato. <br/> Per procedere con la richiesta del bonus prepara e carica tutti documenti richiesti che trovi nella sezione <b>Gestione Documenti<b> di questa pratica. "
              });
            }

            _vue.$router.push("/pratiche");
          }).catch(function (resp) {
            _vue.loadingState = false;
            _vue.$swal({
              type: "error",
              title: "Oops...",
              text: "Riprova piu tardi!"
            });
          });
        } else {
          _vue.$log("ERROR IN FORM");
          _vue.$scrollTo("#" + _vue.errors.items[0].field, 700, {
            offset: -170
          });
        }
      });
    },
    populateProvincies: function populateProvincies() {
      var _this2 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        _this2.provincies = resp.data.provincies;
        _this2.provinciesState = false;
      }).catch(function (resp) {
        _this2.provincies = [];
        _this2.provinciesState = false;
      });
    },
    checkUserToken: function checkUserToken(token) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$log("QRcode CHECK TOKEN");
                if (_this3.getProfile.corporateClient == "agnellimetalli") {
                  _this3.$router.push("/");
                }
                data = {
                  user_token: token
                };

                data = _this3.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 6;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/tokenControl",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this3.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this3.$log("QRcode CHECK TOKEN => OK");
                  _this3.userForLog.email = resp.data.description[0].email;
                  _this3.user;
                  _this3.tokenControl = true;
                }).catch(function (resp) {
                  _this3.$log("QRcode CHECK TOKEN => ERROR");
                  _this3.tokenControl = false;
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getPracticById: function getPracticById(userToken, id) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var data;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.$log("GET PRACTIC FOR QRcode ENTER");
                data = {
                  user_token: userToken,
                  id: id
                };

                data = _this4.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context2.next = 5;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getPracticById",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this4.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this4.$log("GET PRACTIC FOR QRcode => OK");
                  // CHECK IF ACTIVE YET

                  _this4.$route.params.item = resp.data.practices[0];

                  // MENU OFF FOR THIS CASE
                  var alert = {};
                  alert.text = "NOT LOGED VIEW";
                  alert.type = "MENU_OFF";
                  //this.$store.dispatch(ADD_NOTIFICATIONS, alert)
                }).catch(function (resp) {
                  _this4.$log("GET PRACTIC FOR QRcode => ERROR");
                  _this4.tokenControl = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },

    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },
    UploadError: function UploadError() {
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Errore caricamento immagine"
      });
    },
    setCap: function setCap(cap) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var x;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (x in _this5.zips) {
                  if (_this5.zips[x].cap == cap.toUpperCase()) {
                    _this5.zip = _this5.zips[x].cap;
                  }
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    setCity: function setCity(city) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var x, k;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (x in _this6.cities) {
                  if (_this6.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this6.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this6.city = k;
                  }
                }
                _this6.$log(_this6.city);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var x;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                for (x in _this7.provincies) {
                  if (_this7.provincies[x].sigla == province.toUpperCase()) {
                    _this7.province = _this7.provincies[x].sigla;
                  }
                }
                _this7.$log(_this7.province);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },

    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append("fattura" + t, input.target.files[x]);
          t = t + 1;
        }

        this.loadingState = true;

        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadImageInvoice", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.loadingState = false;
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
            _vue.invoiceFrontBucketNoCrypt = e.data.fatturaNoCrypt;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.invoiceFrontBucketNoCrypt = "";
            _vue.UploadError();
            input.target.value = null;
            _vue.loadingState = false;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = "";
          _vue.invoiceFrontBucket = "";
          _vue.invoiceFrontBucketNoCrypt = "";
          _vue.UploadError();
          input.target.value = null;
          _vue.loadingState = false;
        });
      }
    },
    enterPassword: function enterPassword(token) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var alert;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return _this8.$swal({
                  title: "Password",
                  html: "Inserisci la password con cui ti sei registrato alla piattaforma. <br/>",
                  input: "password",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonText: "Entra",
                  cancelButtonText: "Esci",
                  allowOutsideClick: false,
                  showLoaderOnConfirm: true,
                  preConfirm: function preConfirm(alert) {
                    if (alert == "") {
                      _this8.$swal.showValidationMessage("Il campo password richiesto");
                    } else {
                      //CHECK PASSWORD
                      var data = {
                        user_token: token,
                        password: alert.trim()
                      };
                      data = _this8.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                      return axios_default()({
                        url: "https://wsbot.eu/ebonusBack/public/" + "api/passwordControl",
                        method: "POST",
                        data: { data: data },
                        headers: {
                          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                          "Content-type": "application/json"
                        }
                      }).then(function (resp) {
                        resp.data = _this8.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                        _this8.$log("QRcode CHECK PASSWORD => OK");
                        _this8.passwordControl = true;
                        _this8.userForLog.password = alert.trim();
                        return true;
                      }).catch(function (resp) {
                        _this8.passwordControl = false;
                        _this8.$swal.showValidationMessage("Password errata");
                        return false;
                      });
                    }
                  }
                });

              case 3:
                alert = _context6.sent;
                return _context6.abrupt("return", !!alert);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", false);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 7]]);
      }))();
    }
  },
  watch: {
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    capSE: function capSE(val) {
      if (val) {
        this.capSE = val.replace(/\D+/g, "");
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    mobile: function mobile(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, "");
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this9 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this9.cities = resp.data.cities;
          _this9.citiesState = false;
        }).catch(function (resp) {
          _this9.cities = [];
          _this9.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this10 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this10.zips = resp.data.zips;
          _this10.zipsState = false;
        }).catch(function (resp) {
          _this10.zips = [];
          _this10.zipsState = false;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this11 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var data, _vue;

      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              //http://localhost:8080/acceptInvoice?crt=38&t=9697a3c74a75d1393ce15644af776053
              _this11.$log(_this11.$route);

              if (!(_this11.$route.query.crt && _this11.$route.query.t)) {
                _context10.next = 18;
                break;
              }

              _this11.$log("QRcode ACCEPT INVOICE");

              _context10.next = 5;
              return _this11.enterPassword(_this11.$route.query.t);

            case 5:
              if (!_this11.passwordControl) {
                _context10.next = 17;
                break;
              }

              // CHECK USER TOKEN
              _this11.fromQRcode = true;
              _context10.next = 9;
              return _this11.checkUserToken(_this11.$route.query.t);

            case 9:
              if (!_this11.tokenControl) {
                _context10.next = 15;
                break;
              }

              // LOGIN USER
              /*localStorage.setItem('user-token', this.$route.query.t)
                this.$store.dispatch(SET_USER_TOKEN, this.$route.query.t)*/
              data = {
                username: _this11.userForLog.email,
                password: _this11.userForLog.password
              };

              data = _this11.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
              _this11.$store.dispatch(auth["f" /* AUTH_REQUEST */], {
                data: data
              });

              _context10.next = 15;
              return _this11.getPracticById(_this11.$route.query.t, _this11.$route.query.crt);

            case 15:
              _context10.next = 18;
              break;

            case 17:
              _this11.$router.push("/");

            case 18:

              if (_this11.$route.params.item) {
                _this11.item = _this11.$route.params.item;

                // CHECK IF ORDER OR PRACTICE
                if (_this11.$route.params.item.status == "0") {
                  _this11.$log(0);
                  if (_this11.item && _this11.item.client_type != "Amministratore di condominio") {
                    _this11.address = _this11.item.building_address;
                    _this11.civic = _this11.item.building_civic;

                    _this11.client_ownership = _this11.item.client_ownership;
                  }
                } else if (_this11.$route.params.item.status == "1") {
                  _this11.$log(11);
                  _this11.$router.push({
                    name: "loadDocuments",
                    params: {
                      item: _this11.item
                    }
                  });
                } else if (_this11.$route.params.item.status == "9") {
                  _this11.orderRemoved = true;
                } else {
                  _this11.$router.push("/pratiche");
                }
              } else {
                if (!_this11.tokenControl) {
                  _this11.$router.push("/offerte");
                }
              }

              _this11.populateProvincies();
              _this11.$log(_this11.item);

              if (_this11.item && _this11.item.client_type != "Amministratore di condominio") {
                _vue = _this11;


                _this11.$log("SET REGION");

                setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                  var province;
                  return regenerator_default.a.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _vue.$log("SET PROVINCE" + _vue.item.building_province);
                          province = _vue.item.building_province;
                          _context9.next = 4;
                          return _vue.setProvince(province);

                        case 4:
                          _vue.$log("SET PROVINCE SUCCESS");

                          setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
                            var city;
                            return regenerator_default.a.wrap(function _callee8$(_context8) {
                              while (1) {
                                switch (_context8.prev = _context8.next) {
                                  case 0:
                                    _vue.$log("SET CITY");
                                    city = _vue.item.building_city;
                                    _context8.next = 4;
                                    return _vue.setCity(city);

                                  case 4:
                                    _vue.$log("SET CITY SUCCESS");

                                    setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                                      var cap;
                                      return regenerator_default.a.wrap(function _callee7$(_context7) {
                                        while (1) {
                                          switch (_context7.prev = _context7.next) {
                                            case 0:
                                              _vue.$log("SET CAP");
                                              cap = _vue.item.building_zip;
                                              _context7.next = 4;
                                              return _vue.setCap(cap);

                                            case 4:
                                              _vue.$log("SET CAP SUCCESS");

                                            case 5:
                                            case "end":
                                              return _context7.stop();
                                          }
                                        }
                                      }, _callee7, this);
                                    })), 1500);

                                  case 6:
                                  case "end":
                                    return _context8.stop();
                                }
                              }
                            }, _callee8, this);
                          })), 1500);

                        case 6:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9, this);
                })), 1500);
              }

              _this11.$scrollTo("#app", 700, { offset: -75 });

            case 23:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this11);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35b793fb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acceptInvoice/emicon.vue
var acceptInvoice_emicon_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\r\n        Completa il form qui sotto.\r\n        I dati inseriti verranno poi utilizzati per creare la pratica del Bonus richiesto.\r\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c("div", { staticClass: "row justify-content-center pb-5 " }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.item.client_type != "Amministratore di condominio"
                      ? _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\r\n            Completa i dati del cliente finale ("
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.item.client_name) +
                                " " +
                                _vm._s(_vm.item.client_lastname)
                            )
                          ]),
                          _vm._v(")\r\n          ")
                        ])
                      : _c("h4", { staticClass: "widthFull center black" }, [
                          _vm._v(
                            "\r\n            Completa i dati dell'Amministratore del condominio ("
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(_vm.item.client_name) +
                                " " +
                                _vm._s(_vm.item.client_lastname)
                            )
                          ]),
                          _vm._v(")\r\n          ")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_name,
                            expression: "item.client_name"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 63, min: 2 },
                            expression: "{required:true, max: 63, min: 2}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("clientName"),
                          valid: !!_vm.item.client_name
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "clientName",
                          name: "clientName",
                          "data-vv-as": "Nome"
                        },
                        domProps: { value: _vm.item.client_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_name",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "clientName" }
                        },
                        [_vm._v("Nome *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("clientName")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("clientName")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_lastname,
                            expression: "item.client_lastname"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 63, min: 2 },
                            expression: "{required:true, max: 63, min: 2}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("clientLastname"),
                          valid: !!_vm.item.client_lastname
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "clientLastname",
                          name: "clientLastname",
                          "data-vv-as": "Cognome"
                        },
                        domProps: { value: _vm.item.client_lastname },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_lastname",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "clientLastname" }
                        },
                        [_vm._v("Cognome *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("clientLastname")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("clientLastname")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3 " }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_email,
                            expression: "item.client_email"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              email: true,
                              temporaryEmail: true,
                              plusIssueEmail: true,
                              max: 56
                            },
                            expression:
                              "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("email"),
                          valid: !!_vm.item.client_email
                        },
                        attrs: {
                          type: "text",
                          id: "email",
                          name: "email",
                          "data-vv-as": "Email"
                        },
                        domProps: { value: _vm.item.client_email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_email",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "email" }
                        },
                        [_vm._v("Email* ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("email")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("email")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.item.client_type == "Persona fisica" ||
                  _vm.item.client_type == "Amministratore di condominio"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.codice_fiscale,
                                expression: "codice_fiscale"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  codiceFiscale: true,
                                  max: 16,
                                  min: 16
                                },
                                expression:
                                  "{required: true, codiceFiscale: true, max: 16, min: 16}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("codice_fiscale"),
                              valid: !!_vm.codice_fiscale
                            },
                            attrs: {
                              type: "text",
                              id: "codice_fiscale",
                              name: "codice_fiscale",
                              "data-vv-as": "Codice Fiscale"
                            },
                            domProps: { value: _vm.codice_fiscale },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.codice_fiscale = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "codice_fiscale" }
                            },
                            [_vm._v("Codice Fiscale *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("codice_fiscale")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("codice_fiscale")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm.item.client_type == "Partita IVA"
                    ? _c("div", { staticClass: "col-md-4" }, [
                        _c("div", { staticClass: "group custInput" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.partita_iva,
                                expression: "partita_iva"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: true,
                                  partitaIva: true,
                                  max: 11,
                                  min: 11
                                },
                                expression:
                                  "{required: true, partitaIva: true, max: 11, min: 11}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("partita_iva"),
                              valid: !!_vm.partita_iva
                            },
                            attrs: {
                              type: "text",
                              id: "partita_iva",
                              name: "partita_iva",
                              "data-vv-as": "Partita IVA"
                            },
                            domProps: { value: _vm.partita_iva },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.partita_iva = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "partita_iva" }
                            },
                            [_vm._v("Partita IVA *")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("partita_iva")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("partita_iva")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_phone,
                            expression: "item.client_phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: false,
                              max: 12,
                              min: 8,
                              regex: /^[0,3]+/
                            },
                            expression:
                              "{required: false, max: 12, min: 8, regex: /^[0,3]+/}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("phone"),
                          valid: !!_vm.item.client_phone
                        },
                        attrs: {
                          type: "text",
                          id: "phone",
                          name: "phone",
                          "data-vv-as": "Telefono"
                        },
                        domProps: { value: _vm.item.client_phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_phone",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "phone" }
                        },
                        [_vm._v("Telefono ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("phone")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("phone")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.client_mobile,
                            expression: "item.client_mobile"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              max: 12,
                              min: 8,
                              regex: /^[0,3]+/
                            },
                            expression:
                              "{required: true, max: 12, min: 8, regex: /^[0,3]+/}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("mobile"),
                          valid: !!_vm.item.client_mobile
                        },
                        attrs: {
                          type: "text",
                          id: "mobile",
                          name: "mobile",
                          "data-vv-as": "Cellulare"
                        },
                        domProps: { value: _vm.item.client_mobile },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.item,
                              "client_mobile",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "mobile" }
                        },
                        [_vm._v("Cellulare * ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("mobile")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("mobile")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v("\r\n            Indirizzo immobile: "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.item.building_address) +
                            " " +
                            _vm._s(_vm.item.building_civic) +
                            " - " +
                            _vm._s(_vm.item.building_zip) +
                            " " +
                            _vm._s(_vm.item.building_city) +
                            " (" +
                            _vm._s(_vm.item.building_province) +
                            ")"
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black pb-4" }, [
                      _vm._v("\r\n            Indirizzo di residenza "),
                      _vm.item.client_type != "Amministratore di condominio"
                        ? _c("span", [_vm._v("(modifica se necessario)")])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.province,
                              expression: "province"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: { required: true },
                              expression: "{required:true}"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "is-invalid": _vm.errors.has("province"),
                            valid: !!_vm.province
                          },
                          attrs: {
                            autocomplete: "randomy",
                            id: "province",
                            name: "province",
                            "data-vv-as": "Provincia"
                          },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.province = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", {
                            attrs: {
                              disabled: "",
                              value: "",
                              selected: "selected"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "option",
                            { key: 2341253542, domProps: { value: "SE" } },
                            [
                              _vm._v(
                                "\r\n                  STATO ESTERO\r\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.provincies, function(province) {
                            return _c(
                              "option",
                              {
                                key: province.sigla,
                                domProps: { value: province.sigla }
                              },
                              [
                                _vm._v(
                                  "\r\n                  " +
                                    _vm._s(province.sigla) +
                                    " - " +
                                    _vm._s(province.provincia) +
                                    "\r\n                "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "province" }
                        },
                        [_vm._v("Provincia *")]
                      ),
                      _vm._v(" "),
                      _vm.provinciesState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadProvince",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("province")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("province")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _vm.cityError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli Provincia")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("city"),
                                valid: !!_vm.city
                              },
                              attrs: {
                                autocomplete: "randomu",
                                id: "city",
                                name: "city",
                                "data-vv-as": "Località",
                                disabled: _vm.citiesState
                              },
                              on: {
                                click: _vm.checkProvince,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.city = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", {
                                attrs: {
                                  disabled: "",
                                  value: "",
                                  selected: "selected"
                                }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.cities, function(city) {
                                return _c(
                                  "option",
                                  {
                                    key: city.comune,
                                    domProps: {
                                      value: {
                                        cityistat: city.istat,
                                        city: city.comune
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(city.comune) +
                                        "\r\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.citySE,
                                expression: "citySE"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("citySE"),
                              valid: !!_vm.citySE
                            },
                            attrs: {
                              autocomplete: "randomu",
                              id: "citySE",
                              name: "citySE",
                              "data-vv-as": "Località",
                              disabled: _vm.citiesState
                            },
                            domProps: { value: _vm.citySE },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.citySE = $event.target.value
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Località *")]
                          )
                        : _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Località e Paese*")]
                          ),
                      _vm._v(" "),
                      _vm.citiesState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadCity",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("city")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("city")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("citySE")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("citySE")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _vm.zipError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli città")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.province != "SE"
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required:true}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("zip"),
                                valid: !!_vm.zip
                              },
                              attrs: {
                                autocomplete: "randomi",
                                id: "zip",
                                name: "zip",
                                "data-vv-as": "Cap",
                                disabled: _vm.zipsState
                              },
                              on: {
                                click: _vm.checkZip,
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.zip = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", {
                                attrs: { value: "", disabled: "" },
                                domProps: { selected: true }
                              }),
                              _vm._v(" "),
                              _vm._l(_vm.zips, function(zip) {
                                return _c(
                                  "option",
                                  {
                                    key: zip.cap,
                                    domProps: { value: zip.cap }
                                  },
                                  [
                                    _vm._v(
                                      "\r\n                  " +
                                        _vm._s(zip.cap) +
                                        "\r\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.capSE,
                                expression: "capSE"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true, min: 5, max: 5 },
                                expression: "{required:true, min:5, max:5}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("capSE"),
                              valid: !!_vm.capSE
                            },
                            attrs: {
                              autocomplete: "randomi",
                              id: "capSE",
                              name: "capSE",
                              "data-vv-as": "Cap",
                              disabled: _vm.zipsState
                            },
                            domProps: { value: _vm.capSE },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.capSE = $event.target.value
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "zip" }
                        },
                        [_vm._v("Cap *")]
                      ),
                      _vm._v(" "),
                      _vm.zipsState
                        ? _c(
                            "div",
                            [
                              _c("font-awesome-icon", {
                                staticClass: "loadSpinner",
                                attrs: {
                                  id: "loadZips",
                                  icon: "spinner",
                                  size: "1x",
                                  pulse: ""
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("zip")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("zip")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errors.has("capSE")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n                " +
                                _vm._s(_vm.errors.first("capSE")) +
                                "\r\n              "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.address,
                            expression: "address"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 128, min: 5 },
                            expression: "{required:true, max: 128, min: 5}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("address"),
                          valid: !!_vm.address
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "address",
                          name: "address",
                          "data-vv-as": "Indirizzo"
                        },
                        domProps: { value: _vm.address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.address = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "address" }
                        },
                        [_vm._v("Indirizzo *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("address")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("address")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 mb-3" }, [
                    _c("div", { staticClass: "group custInput" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.civic,
                            expression: "civic"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: { required: true, max: 15, min: 1 },
                            expression: "{required:true, max: 15, min: 1}"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.errors.has("civic"),
                          valid: !!_vm.civic
                        },
                        attrs: {
                          type: "text",
                          autocomplete: "randomq",
                          id: "civic",
                          name: "civic",
                          "data-vv-as": "Civico"
                        },
                        domProps: { value: _vm.civic },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.civic = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "civic" }
                        },
                        [_vm._v("Civico *")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("civic")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\r\n              " +
                                _vm._s(_vm.errors.first("civic")) +
                                "\r\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("h4", { staticClass: "widthFull center black" }, [
                      _vm._v(
                        "\r\n            Carica il preventivo firmato\r\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "center" }, [
                      _vm._v(
                        "Se necessario è possibile selezionare piu di un file"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "front-image" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required: true,
                              size: 10240,
                              ext: ["jpeg", "jpg", "png", "pdf"],
                              mimes: [
                                "image/jpeg",
                                "image/jpg",
                                "image/png",
                                "application/pdf"
                              ]
                            },
                            expression:
                              "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                          }
                        ],
                        ref: "fileInput",
                        staticClass: "fileInput",
                        class: {
                          "is-invalid": _vm.errors.has("invoiceFront"),
                          valid: !!_vm.invoiceFront,
                          helper: !!_vm.invoiceFrontBucket
                        },
                        attrs: {
                          type: "file",
                          multiple: "",
                          name: "invoiceFront",
                          id: "invoiceFront",
                          "data-vv-as": "Preventivo firmato"
                        },
                        on: { change: _vm.uploadFile }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel labelFileInput",
                          attrs: { for: "invoiceFront" }
                        },
                        [
                          !_vm.invoiceFrontName
                            ? _c(
                                "span",
                                {
                                  staticClass: "smallText center white",
                                  style: {
                                    backgroundImage:
                                      "url(" + _vm.invoiceFrontBucket + ")"
                                  }
                                },
                                [
                                  !_vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0"
                                        },
                                        [_vm._v("Scegli il Contratto quadro*")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _c("span", {
                                staticClass: "smallText center white",
                                style: {
                                  backgroundImage:
                                    "url(" + _vm.invoiceFrontBucket + ")"
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("invoiceFront")
                        ? _c(
                            "div",
                            {
                              staticClass: "invalid-feedback",
                              staticStyle: { top: "185px" }
                            },
                            [
                              _vm._v(
                                "\r\n              " +
                                  _vm._s(_vm.errors.first("invoiceFront")) +
                                  "\r\n            "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploadFrontPercentage
                        ? _c(
                            "div",
                            {
                              staticClass: "progress mt-5",
                              attrs: { id: "progFront" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar ",
                                  style: {
                                    width: _vm.uploadFrontPercentage + "%"
                                  },
                                  attrs: {
                                    id: "progress-bar-front",
                                    role: "progressbar",
                                    "aria-valuenow": "50",
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\r\n                " +
                                      _vm._s(_vm.uploadFrontPercentage) +
                                      " %\r\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invoiceFrontName
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "smallText center white mt-3 mb-0 pb-0 fileNameText"
                            },
                            [_vm._v(_vm._s(_vm.invoiceFrontName))]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 mt-5 mb-3 center" }, [
                    _vm.invoiceFrontBucket
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.invoiceFrontBucket,
                              target: "_blank"
                            }
                          },
                          [
                            _vm.invoiceFrontBucket.substring(
                              _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                              _vm.invoiceFrontBucket.length
                            ) == "pdf"
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "center widthFull pdfLink",
                                    attrs: {
                                      href: _vm.invoiceFrontBucket,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("APRI  PDF")]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 center mt-5 pt-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: { click: _vm.convertToPractice }
                      },
                      [_vm._v("Procedi")]
                    )
                  ])
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [
                  _vm._v("Accetta preventivo N. " + _vm._s(_vm.item.code))
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black mt-0 text-center widthFull" }, [
                _vm._v(
                  "\r\n        Hai completatto correttamente la pratica.\r\n      "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.orderRemoved
        ? _c("div", { staticClass: "container pt-5 mt-5 " }, [
            _c(
              "div",
              {
                staticClass: "row justify-content-center text-left vaillantCont"
              },
              [
                _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                  _c("b", [
                    _vm._v("ATTENZIONE! "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" Preventivo N. " + _vm._s(_vm.item.code) + " "),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" è stato eliminato ")
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-center widthFull" })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var acceptInvoice_emicon_staticRenderFns = []
acceptInvoice_emicon_render._withStripped = true
var acceptInvoice_emicon_esExports = { render: acceptInvoice_emicon_render, staticRenderFns: acceptInvoice_emicon_staticRenderFns }
/* harmony default export */ var components_acceptInvoice_emicon = (acceptInvoice_emicon_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35b793fb", acceptInvoice_emicon_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/acceptInvoice/emicon.vue
var acceptInvoice_emicon_disposed = false
function acceptInvoice_emicon_injectStyle (ssrContext) {
  if (acceptInvoice_emicon_disposed) return
  __webpack_require__("7Hb7")
}
var acceptInvoice_emicon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var acceptInvoice_emicon___vue_template_functional__ = false
/* styles */
var acceptInvoice_emicon___vue_styles__ = acceptInvoice_emicon_injectStyle
/* scopeId */
var acceptInvoice_emicon___vue_scopeId__ = "data-v-35b793fb"
/* moduleIdentifier (server only) */
var acceptInvoice_emicon___vue_module_identifier__ = null
var acceptInvoice_emicon_Component = acceptInvoice_emicon_normalizeComponent(
  acceptInvoice_emicon,
  components_acceptInvoice_emicon,
  acceptInvoice_emicon___vue_template_functional__,
  acceptInvoice_emicon___vue_styles__,
  acceptInvoice_emicon___vue_scopeId__,
  acceptInvoice_emicon___vue_module_identifier__
)
acceptInvoice_emicon_Component.options.__file = "src/components/acceptInvoice/emicon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35b793fb", acceptInvoice_emicon_Component.options)
  } else {
    hotAPI.reload("data-v-35b793fb", acceptInvoice_emicon_Component.options)
  }
  module.hot.dispose(function (data) {
    acceptInvoice_emicon_disposed = true
  })
})()}

/* harmony default export */ var src_components_acceptInvoice_emicon = (acceptInvoice_emicon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/acceptInvoice/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var acceptInvoice_moment = __webpack_require__("PJh5");

/* harmony default export */ var acceptInvoice = ({
  name: "acceptInvoice",
  components: {
    Emicon: src_components_acceptInvoice_emicon,
    Hoval: src_components_acceptInvoice_hoval
  },
  data: function data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: {},
      hideData: false,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      mobile: "",
      cellulare: "",
      numero_ordine: "",
      citySE: "",
      capSE: "",

      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      client_ownership: "",
      subalterno: "",
      particella: "",
      foglio: "",
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      userForLog: {},
      corporateClient: ""
    };
  },

  methods: {
    setProfile: function setProfile() {
      //type 1 => no preventivatore
      this.corporateClient = this.getProfile.corporateClient;
    }
  },
  watch: {
    getProfile: function getProfile() {
      this.setProfile();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$log(_this.$route);
              _this.setProfile();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1cdd68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acceptInvoice/index.vue
var acceptInvoice_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.corporateClient == "hoval"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [_vm.loadingState ? _c("loading") : _vm._e(), _vm._v(" "), _c("Hoval")],
        1
      )
    : _vm.corporateClient == "emicon"
    ? _c(
        "div",
        { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
        [
          _vm.loadingState ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("Emicon")
        ],
        1
      )
    : _vm._e()
}
var acceptInvoice_staticRenderFns = []
acceptInvoice_render._withStripped = true
var acceptInvoice_esExports = { render: acceptInvoice_render, staticRenderFns: acceptInvoice_staticRenderFns }
/* harmony default export */ var components_acceptInvoice = (acceptInvoice_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a1cdd68", acceptInvoice_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/acceptInvoice/index.vue
var acceptInvoice_disposed = false
function acceptInvoice_injectStyle (ssrContext) {
  if (acceptInvoice_disposed) return
  __webpack_require__("MPp2")
}
var acceptInvoice_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var acceptInvoice___vue_template_functional__ = false
/* styles */
var acceptInvoice___vue_styles__ = acceptInvoice_injectStyle
/* scopeId */
var acceptInvoice___vue_scopeId__ = "data-v-3a1cdd68"
/* moduleIdentifier (server only) */
var acceptInvoice___vue_module_identifier__ = null
var acceptInvoice_Component = acceptInvoice_normalizeComponent(
  acceptInvoice,
  components_acceptInvoice,
  acceptInvoice___vue_template_functional__,
  acceptInvoice___vue_styles__,
  acceptInvoice___vue_scopeId__,
  acceptInvoice___vue_module_identifier__
)
acceptInvoice_Component.options.__file = "src/components/acceptInvoice/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a1cdd68", acceptInvoice_Component.options)
  } else {
    hotAPI.reload("data-v-3a1cdd68", acceptInvoice_Component.options)
  }
  module.hot.dispose(function (data) {
    acceptInvoice_disposed = true
  })
})()}

/* harmony default export */ var src_components_acceptInvoice = (acceptInvoice_Component.exports);

// EXTERNAL MODULE: ./node_modules/viewerjs/dist/viewer.css
var viewer = __webpack_require__("N1kN");
var viewer_default = /*#__PURE__*/__webpack_require__.n(viewer);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadDocuments/stripe.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var stripe_moment = __webpack_require__("PJh5");

/* harmony default export */ var loadDocuments_stripe = ({
  name: 'stripe',
  components: {
    //StripeCheckout
  },
  props: {
    practice: String,
    userToken: String,
    items: Array,
    invoiceNumber: String,
    amount: String
  },
  data: function data() {
    return {
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      error: '',
      loadingState: false,
      loading: false,
      moment: __webpack_require__("PJh5"),
      show_card: false,
      //STRIPE
      pk: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).STRIPE_PUBLISHABLE_KEY,
      front_url: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).FRONT_END_URL,
      iva: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).IVA,
      buyPlan: {
        price: 800,
        iva: 800 * 0.22,
        amount: 800 + 800 * 0.22,
        amount_enea: parseFloat(800 + 800 * 0.22 + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(800 + 800 * 0.22 + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(800 + 800 * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2
      }

    };
  },

  methods: {
    // composer require stripe/stripe-php
    create_stripe_session: function create_stripe_session() {
      var _this = this;

      this.loadingState = true;
      // Create an instance of the Stripe object with your publishable API key
      var stripe = Stripe(this.pk);
      var data = {
        userToken: this.userToken,
        practice: this.practice,
        items: this.items,
        amount: this.amount,
        invoiceNumber: this.invoiceNumber,
        pk: this.pk,
        errorUrl: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).FRONT_END_URL + 'paymentError/' + this.practice,
        successUrl: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).FRONT_END_URL + 'paymentSuccess/' + this.practice
      };
      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + 'api/create-stripe-checkout-session',
        method: 'POST',
        data: data,
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this.loadingState = false;
        _this.$log(resp.data);
        return stripe.redirectToCheckout({
          sessionId: resp.data.status.id
        });
      }).catch(function (resp) {

        _this.loadingState = false;
        _this.showAlert();
      });
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ci dispiace! Riprova piu tardi'
      });
    }
  },
  watch: {},
  created: function created() {
    var _this2 = this;

    this.$loadScript("https://js.stripe.com/v3/").then(function () {
      _this2.loadButtons = false;
    }).catch(function () {
      // Failed to fetch script
    });
  },
  mounted: function mounted() {

    this.$log(this);
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c3e6f9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/stripe.vue
var stripe_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widthFull center pt-1 pb-3" }, [
    _c("div", { staticClass: "row justify-content-center pb-3" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-8  center" }, [
        !_vm.show_card
          ? _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", id: "checkout-button" },
                on: { click: _vm.create_stripe_session }
              },
              [_vm._v(" Procedi ")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var stripe_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-11  center" }, [
      _c("h4", { staticClass: "center" }, [
        _c("b", [
          _vm._v("Oppure puoi pagare con la tua carta o addebito diretto SEPA")
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid widthFull mb-3 mt-3",
        attrs: { src: __webpack_require__("5uEW") }
      })
    ])
  }
]
stripe_render._withStripped = true
var stripe_esExports = { render: stripe_render, staticRenderFns: stripe_staticRenderFns }
/* harmony default export */ var components_loadDocuments_stripe = (stripe_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c3e6f9a", stripe_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loadDocuments/stripe.vue
var stripe_disposed = false
function stripe_injectStyle (ssrContext) {
  if (stripe_disposed) return
  __webpack_require__("QHXV")
}
var stripe_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var stripe___vue_template_functional__ = false
/* styles */
var stripe___vue_styles__ = stripe_injectStyle
/* scopeId */
var stripe___vue_scopeId__ = "data-v-4c3e6f9a"
/* moduleIdentifier (server only) */
var stripe___vue_module_identifier__ = null
var stripe_Component = stripe_normalizeComponent(
  loadDocuments_stripe,
  components_loadDocuments_stripe,
  stripe___vue_template_functional__,
  stripe___vue_styles__,
  stripe___vue_scopeId__,
  stripe___vue_module_identifier__
)
stripe_Component.options.__file = "src/components/loadDocuments/stripe.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c3e6f9a", stripe_Component.options)
  } else {
    hotAPI.reload("data-v-4c3e6f9a", stripe_Component.options)
  }
  module.hot.dispose(function (data) {
    stripe_disposed = true
  })
})()}

/* harmony default export */ var src_components_loadDocuments_stripe = (stripe_Component.exports);

// CONCATENATED MODULE: ./src/components/documents/documentsHoval.js
var documentsHoval_documents = {

  'Persona fisica': {
    // LISTA DOCS
    '2060D13': {
      'name': 'Elenco dei condomini rappresentati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13'
    },
    '2060D11': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11'
    },
    '2060D10': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D10'
    },
    '2060D12': {
      'name': 'Delibera dell’assemblea del condominio e tabella millesimale di ripartizione delle spese',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D12'
    },
    '2060D08': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D08'
    },
    '2060D09': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D09'
    },
    '2060D15': {
      'name': 'Dichiarazione dell’amministratore del condominio di aver adempiuto a tutti gli obblighi previsti dalla legge ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/3%20Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato.pdf',
      'codice': '2060D15'
    },
    '2060D14': {
      'name': 'Dichiarazione del singolo condòmino, attestante il rispetto dei requisiti soggettivi e l`adesione dell`opzione alternativa di sconto / cessione (Template KPMG)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario.pdf',
      'codice': '2060D14'
    },
    '2060D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11E'
    },
    '2060D12E': {
      'name': 'Dichiarazione sostitutiva di atto notorio del fornitore/installatore ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/v15.1.pdf',
      'codice': '2060D12E'
    },
    '2060D16': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16'
    },
    '2060D13E': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13E'
    },
    '2060D14E': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati (bonifico Parlante)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D14E'
    },
    '2060D15E': {
      'name': 'Delega a Fides dell`Utente finale all`invio telematico  del modello Agenzia delle Entrate (Template FIDES)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/150321Delega%20e%20Impegno%201.pdf',
      'codice': '2060D15E'
    },
    '2060D16E': {
      'name': 'Comunicazione ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16E'
    },
    '2060D17E': {
      'name': 'Ricevuta attestante l’avvenuta trasmissione (CPID) rilasciata dall’ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D17E'
    },
    '2060D18E': {
      'name': 'Contratto Cessione Credito con - Installatore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/7%20%20%20%20B)%20CONTRATTO%20CESSIONE%20CREDITO%20ECOBONUS%20DA%20INSTALLATORE%20PER%20CONDOMIO.pdf?v=1',
      'codice': '2060D18E'
    },
    '2050D20': {
      'name': 'Asseverazione di congruità delle spese rilasciata da un tecnico abilitato ',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/chebonus/Asseverazione_Congruita_Giuda.pdf',
      'codice': '2050D20',
      'from': 'Installatore'
    }

  },

  'Partita IVA': {
    // LISTA DOCS
    '2060D13': {
      'name': 'Elenco dei condomini rappresentati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13'
    },
    '2060D11': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11'
    },
    '2060D10': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D10'
    },
    '2060D12': {
      'name': 'Delibera dell’assemblea del condominio e tabella millesimale di ripartizione delle spese',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D12'
    },
    '2060D08': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D08'
    },
    '2060D09': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D09'
    },
    '2060D15': {
      'name': 'Dichiarazione dell’amministratore del condominio di aver adempiuto a tutti gli obblighi previsti dalla legge ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/3%20Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato.pdf',
      'codice': '2060D15'
    },
    '2060D14': {
      'name': 'Dichiarazione del singolo condòmino, attestante il rispetto dei requisiti soggettivi e l`adesione dell`opzione alternativa di sconto / cessione (Template KPMG)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario.pdf',
      'codice': '2060D14'
    },
    '2060D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11E'
    },
    '2060D12E': {
      'name': 'Dichiarazione sostitutiva di atto notorio del fornitore/installatore ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/v15.1.pdf',
      'codice': '2060D12E'
    },
    '2060D16': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16'
    },
    '2060D13E': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13E'
    },
    '2060D14E': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati (bonifico Parlante)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D14E'
    },
    '2060D15E': {
      'name': 'Delega a Fides dell`Utente finale all`invio telematico  del modello Agenzia delle Entrate (Template FIDES)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/150321Delega%20e%20Impegno%201.pdf',
      'codice': '2060D15E'
    },
    '2060D16E': {
      'name': 'Comunicazione ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16E'
    },
    '2060D17E': {
      'name': 'Ricevuta attestante l’avvenuta trasmissione (CPID) rilasciata dall’ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D17E'
    },
    '2060D18E': {
      'name': 'Contratto Cessione Credito con - Installatore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/7%20%20%20%20B)%20CONTRATTO%20CESSIONE%20CREDITO%20ECOBONUS%20DA%20INSTALLATORE%20PER%20CONDOMIO.pdf?v=1',
      'codice': '2060D18E'
    },
    '2050D20': {
      'name': 'Asseverazione di congruità delle spese rilasciata da un tecnico abilitato ',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/chebonus/Asseverazione_Congruita_Giuda.pdf',
      'codice': '2050D20',
      'from': 'Installatore'
    }
  },

  'Amministratore di condominio': {
    '2060D13': {
      'name': 'Elenco dei condomini rappresentati',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13'
    },
    '2060D11': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11'
    },
    '2060D10': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D10'
    },
    '2060D12': {
      'name': 'Delibera dell’assemblea del condominio e tabella millesimale di ripartizione delle spese',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D12'
    },
    '2060D08': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D08'
    },
    '2060D09': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D09'
    },
    '2060D15': {
      'name': 'Dichiarazione dell’amministratore del condominio di aver adempiuto a tutti gli obblighi previsti dalla legge ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/3%20Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato.pdf',
      'codice': '2060D15'
    },
    '2060D14': {
      'name': 'Dichiarazione del singolo condòmino, attestante il rispetto dei requisiti soggettivi e l`adesione dell`opzione alternativa di sconto / cessione (Template KPMG)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario.pdf',
      'codice': '2060D14'
    },
    '2060D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D11E'
    },
    '2060D12E': {
      'name': 'Dichiarazione sostitutiva di atto notorio del fornitore/installatore ',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/v15.1.pdf',
      'codice': '2060D12E'
    },
    '2060D16': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16'
    },
    '2060D13E': {
      'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D13E'
    },
    '2060D14E': {
      'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati (bonifico Parlante)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D14E'
    },
    '2060D15E': {
      'name': 'Delega a Fides dell`Utente finale all`invio telematico  del modello Agenzia delle Entrate (Template FIDES)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/150321Delega%20e%20Impegno%201.pdf',
      'codice': '2060D15E'
    },
    '2060D16E': {
      'name': 'Comunicazione ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D16E'
    },
    '2060D17E': {
      'name': 'Ricevuta attestante l’avvenuta trasmissione (CPID) rilasciata dall’ENEA',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2060D17E'
    },
    '2060D18E': {
      'name': 'Contratto Cessione Credito con - Installatore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/7%20%20%20%20B)%20CONTRATTO%20CESSIONE%20CREDITO%20ECOBONUS%20DA%20INSTALLATORE%20PER%20CONDOMIO.pdf?v=1',
      'codice': '2060D18E'
    },
    '2050D20': {
      'name': 'Asseverazione di congruità delle spese rilasciata da un tecnico abilitato ',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/chebonus/Asseverazione_Congruita_Giuda.pdf',
      'codice': '2050D20',
      'from': 'Installatore'
    }
  }

};

/* harmony default export */ var documentsHoval = (documentsHoval_documents);
// CONCATENATED MODULE: ./src/components/documents/documentsEmicon.js


var documentsEmicon__PersonaFisica, documentsEmicon__PartitaIVA, documentsEmicon__AmministratoreDiCo;

var documentsEmicon_documents = {

  'Persona fisica': (documentsEmicon__PersonaFisica = {
    // LISTA DOCS
    '2050D08': {
      'name': 'Documento d’identità beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08'
    },
    '2050D09': {
      'name': 'Codice Fiscale beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D09'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l’accesso alla detrazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario%20(1).pdf',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Titolo giuridico di possesso/detenzione dell’immobile (in caso di soggetti proprietari non dell’immobile)',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D15E': {
      'name': 'Prova dell’esistenza in capo all’edificio di uno dei vincoli previsti dal codice dei beni culturali e del paesaggio',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15E'
    },
    '2050D16E': {
      'name': 'Certificazione di conformità urbanistica catastale edilizia dell’immobile oggetto di intervento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16E'
    },
    '2050D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D01G': {
      'name': 'Abilitazione amministrativa-Pratica edilizia-Relazione Tecnica (con ricevuta di deposito)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D01G'
    },

    '2050D02G': {
      'name': 'Scheda descrittiva dell’intervento con codice CPID firmata dal beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D02G'
    },

    '2050D03G': {
      'name': 'Asseverazione del Tecnico abilitato o, per potenze nominali inferiori a 100 kW, dichiarazione del produttore per i requisiti tecnici e per il rispetto dei massimali di costo',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D03G'
    },

    '2050D04G': {
      'name': 'Certificato delle valvole termostatiche	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D04G'
    },

    '2050D05G': {
      'name': 'Schede tecniche dei generatori	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D05G'
    },

    '2050D06G': {
      'name': 'Libretto di impianto	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    }

  }, defineProperty_default()(documentsEmicon__PersonaFisica, '2050D06G', {
    'name': 'Lettera di incarico professionale (KPMG SA/Protos)	',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D06G'
  }), defineProperty_default()(documentsEmicon__PersonaFisica, '2050D08G', {
    'name': 'Autocertificazione prodotti installati/Dichiarazione conformità impianti',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D08G'
  }), defineProperty_default()(documentsEmicon__PersonaFisica, '2050D10A', {
    'name': 'Contratto di appalto siglato con l’impresa appaltatrice/Contratto di fornitura/Contratto d’opera/Preventivi',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D10A'
  }), defineProperty_default()(documentsEmicon__PersonaFisica, '2050D11A', {
    'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D11A'
  }), defineProperty_default()(documentsEmicon__PersonaFisica, '2050D12A', {
    'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D12A'
  }), defineProperty_default()(documentsEmicon__PersonaFisica, '2050D13A', {
    'name': 'Delega dell’Utente finale alla presentazione del Modello all`Agenzia delle Entrate',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D13A'
  }), defineProperty_default()(documentsEmicon__PersonaFisica, '2050D19', {
    'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
    'mandatory': "no",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D19'
  }), documentsEmicon__PersonaFisica),

  'Partita IVA': (documentsEmicon__PartitaIVA = {

    '2050D08G': {
      'name': 'Documento d’identità del Legale Rappresentante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08G'
    },

    '2050D09G': {
      'name': 'Codice Fiscale del Legale Rappresentante',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D09G'
    },

    '2050D12': {
      'name': 'Visura Camerale Cedente	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l’accesso alla detrazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario%20(1).pdf',
      'codice': '2050D14'
    },

    '2050D15': {
      'name': 'Titolo giuridico di possesso/detenzione dell’immobile (in caso di soggetti proprietari non dell’immobile)',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D15E': {
      'name': 'Prova dell’esistenza in capo all’edificio di uno dei vincoli previsti dal codice dei beni culturali e del paesaggio',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15E'
    },
    '2050D16E': {
      'name': 'Certificazione di conformità urbanistica catastale edilizia dell’immobile oggetto di intervento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16E'
    },
    '2050D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D01G': {
      'name': 'Abilitazione amministrativa-Pratica edilizia-Relazione Tecnica (con ricevuta di deposito)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D01G'
    },

    '2050D02G': {
      'name': 'Scheda descrittiva dell’intervento con codice CPID firmata dal beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D02G'
    },

    '2050D03G': {
      'name': 'Asseverazione del Tecnico abilitato o, per potenze nominali inferiori a 100 kW, dichiarazione del produttore per i requisiti tecnici e per il rispetto dei massimali di costo',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D03G'
    },

    '2050D04G': {
      'name': 'Certificato delle valvole termostatiche	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D04G'
    },

    '2050D05G': {
      'name': 'Schede tecniche dei generatori	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D05G'
    },

    '2050D06G': {
      'name': 'Libretto di impianto	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    }

  }, defineProperty_default()(documentsEmicon__PartitaIVA, '2050D06G', {
    'name': 'Lettera di incarico professionale (KPMG SA/Protos)	',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D06G'
  }), defineProperty_default()(documentsEmicon__PartitaIVA, '2050D08G', {
    'name': 'Autocertificazione prodotti installati/Dichiarazione conformità impianti',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D08G'
  }), defineProperty_default()(documentsEmicon__PartitaIVA, '2050D10A', {
    'name': 'Contratto di appalto siglato con l’impresa appaltatrice/Contratto di fornitura/Contratto d’opera/Preventivi',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D10A'
  }), defineProperty_default()(documentsEmicon__PartitaIVA, '2050D11A', {
    'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D11A'
  }), defineProperty_default()(documentsEmicon__PartitaIVA, '2050D12A', {
    'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D12A'
  }), defineProperty_default()(documentsEmicon__PartitaIVA, '2050D13A', {
    'name': 'Delega dell’Utente finale alla presentazione del Modello all`Agenzia delle Entrate',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D13A'
  }), defineProperty_default()(documentsEmicon__PartitaIVA, '2050D19', {
    'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
    'mandatory': "no",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D19'
  }), documentsEmicon__PartitaIVA),

  'Amministratore di condominio': (documentsEmicon__AmministratoreDiCo = {

    '2050D08C': {
      'name': ' Documento di Identità dei Beneficiari	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D08C'
    },

    '2050D09C': {
      'name': 'Codice Fiscale dei Beneficiari',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D09C'
    },

    '2050D12C': {
      'name': 'Visure Camerale dei Beneficiari	',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D12C'
    },

    '2050D18': {
      'name': 'Certificato di attribuzione al Condominio del codice fiscale',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D18'
    },

    '2050D16': {
      'name': 'Documento d’identità dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16'
    },

    '2050D17': {
      'name': 'Codice Fiscale dell’amministratore',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D17'
    },

    '2050D13': {
      'name': 'Dichiarazione dell’amministratore del condominio/condòminio incaricato che attesti di aver adempiuto a tutti gli obblighi previsti dalla legge e dal quale risulti la ripartizione delle spese e della detrazione per ciascun condòmino	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20sostitutiva%20di%20atto%20notorio%20-%20Amministratore-Cond%C3%B2mino%20incaricato%20(1).pdf',

      'codice': '2050D13'
    },

    '2050D20E': {
      'name': 'Estratto aggiornato di registro anagrafe condominiale che illustri le categorie catastali superfici volumetriche delle singole unità',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D20E'
    },
    '2050D14': {
      'name': 'Dichiarazione sostitutiva di atto notorio attestante il rispetto dei presupposti oggettivi per l’accesso alla detrazione',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'yes',
      'template_link': 'https://storage.googleapis.com/novamaster/easybonus/hoval/KPMG_Dichiarazione%20Sostitutiva%20Atto%20di%20notoriet%C3%A0_Beneficiario%20(1).pdf',
      'codice': '2050D14'
    },
    '2050D15': {
      'name': 'Titolo giuridico di possesso/detenzione dell’immobile (in caso di soggetti proprietari non dell’immobile)',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15'
    },
    '2050D15E': {
      'name': 'Prova dell’esistenza in capo all’edificio di uno dei vincoli previsti dal codice dei beni culturali e del paesaggio',
      'mandatory': "no",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D15E'
    },
    '2050D16E': {
      'name': 'Certificazione di conformità urbanistica catastale edilizia dell’immobile oggetto di intervento',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D16E'
    },
    '2050D11E': {
      'name': 'Visura Catastale/Domanda di accatastamento immobile non ancora censito	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D11E'
    },

    '2050D01G': {
      'name': 'Abilitazione amministrativa-Pratica edilizia-Relazione Tecnica (con ricevuta di deposito)',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D01G'
    },

    '2050D02G': {
      'name': 'Scheda descrittiva dell’intervento con codice CPID firmata dal beneficiario',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D02G'
    },

    '2050D03G': {
      'name': 'Asseverazione del Tecnico abilitato o, per potenze nominali inferiori a 100 kW, dichiarazione del produttore per i requisiti tecnici e per il rispetto dei massimali di costo',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D03G'
    },

    '2050D04G': {
      'name': 'Certificato delle valvole termostatiche	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D04G'
    },

    '2050D05G': {
      'name': 'Schede tecniche dei generatori	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D05G'
    },

    '2050D06G': {
      'name': 'Libretto di impianto	',
      'mandatory': "yes",
      'multidocuments': 'no',
      'multipage': 'no',
      'template': 'no',
      'codice': '2050D06G'
    }

  }, defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D06G', {
    'name': 'Lettera di incarico professionale (KPMG SA/Protos)	',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D06G'
  }), defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D08G', {
    'name': 'Autocertificazione prodotti installati/Dichiarazione conformità impianti',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D08G'
  }), defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D10A', {
    'name': 'Contratto di appalto siglato con l’impresa appaltatrice/Contratto di fornitura/Contratto d’opera/Preventivi',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D10A'
  }), defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D11A', {
    'name': 'Fatture e ricevute fiscali relative alle spese effettivamente sostenute',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D11A'
  }), defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D12A', {
    'name': 'Evidenze di pagamento da parte del soggetto committente degli interventi agevolati',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D12A'
  }), defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D13A', {
    'name': 'Delega dell’Utente finale alla presentazione del Modello all`Agenzia delle Entrate',
    'mandatory': "yes",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D13A'
  }), defineProperty_default()(documentsEmicon__AmministratoreDiCo, '2050D19', {
    'name': 'Comunicazione ENEA, ricevuta attestante l’avvenuta trasmissione e codice CPID',
    'mandatory': "no",
    'multidocuments': 'no',
    'multipage': 'no',
    'template': 'no',
    'codice': '2050D19'
  }), documentsEmicon__AmministratoreDiCo)

};

/* harmony default export */ var documentsEmicon = (documentsEmicon_documents);
// EXTERNAL MODULE: ./node_modules/image-to-base64/browser.js
var browser = __webpack_require__("vvPq");
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loadDocuments/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var loadDocuments_moment = __webpack_require__("PJh5");

var loadDocuments_viewer = __webpack_require__("EAZf");

//import { StripeCheckout } from '@vue-stripe/vue-stripe'

// GET DOC LIST






/* harmony default export */ var loadDocuments = ({
  name: "loadDocuments",
  components: {
    //StripeCheckout
    stripePayment: src_components_loadDocuments_stripe
  },
  data: function data() {
    return {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: false,
      componentKey: 0,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      cellulare: "",
      address: "",
      civic: "",
      hasPrev: false,
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: {},
      client_ownership: "",
      subalterno: "",
      particella: "",
      savedDocuments: {},
      foglio: "",
      documents: documents_documents,
      documentsHoval: documentsHoval,
      documentsEmicon: documentsEmicon,
      payment: false,

      paymentTypeD: "",
      paid: "",
      autoRenewD: "",
      priceIvaC: "",
      priceIvaA: "",
      priceIfYearSubIva: "",
      priceIva: "",

      //STRIPE
      pk: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).STRIPE_PUBLISHABLE_KEY,
      front_url: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).FRONT_END_URL,
      iva: Object({"NODE_ENV":"production","PRACTIC_PRICE":800,"FINANCE_COST":20,"PRICE_ENEA":0,"PRICE_DCAST":0,"PAYPAL_ENV":"SANDBOX","PAYPAL_PRODUCT_ID":"PROD-22A53030NG889084L","PAYPAL_ID":"ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W","PAYPAL_SECRET":"EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH","VERSION":"V1","PROJECT":"BONUS","ROOT_API":"https://wsbot.eu/ebonusBack/public/","AUTH_TOKEN":"f038eb84662817ba3e9cfd3210579a2e0f695ec3","APP":"PROD","REGISTRATION":true,"MSG_ACCOUNT_CONFIRMED":"Il tuo account e stato attivato","MSG_CONFIRM_TOKEN_NOT_FOUND":"Token non presente","MSG_EMAIL_NOT_FOUND":"Indirizzo e-mail non presente in nostra sistema","TOKEN_NOT_EXIST":"Il token scaduto o non presente","CRYPTKEY":"B%t$AD!YMfnCZnfD","TOKENKEY":"11a5s2dffe$fswe561","START":"2021-01-15 00:00:00","FINISH":"2030-12-15 23:59:59","ACCORDOQUADRO":"https://storage.googleapis.com/novamaster/easybonus/CONTRATTO%20QUADRO%20CON%20INSTALLATORE%20PER%20%20CONDOMINIO.pdf","PRIVACY":"https://storage.googleapis.com/novamaster/easybonus/Privacy.pdf","UTILIZZO":"https://storage.googleapis.com/novamaster/easybonus/Conditions.pdf","COOKIE":"https://storage.googleapis.com/novamaster/easybonus/Cookie.pdf","START_DATE":Object({"year":2021,"month":2,"day":15}),"STOP_DATE":Object({"year":2030,"month":12,"day":15})}).IVA,
      buyPlan: {
        price: 800,
        iva: 800 * 0.22,
        amount: 800 + 800 * 0.22,
        amount_enea: parseFloat(800 + 800 * 0.22 + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(800 + 800 * 0.22 + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(800 + 800 * 0.22 + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2
      },
      billingType: false,
      autoReNew: false,
      envPP: "",
      credentials: {
        sandbox: "ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W",
        production: "ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W"
        // SECRET ENSsI2hX79egH1CKfDNPQnf0SskbcGt0r9GRiVDwNMArGz2HAMP6c3-960hpQka2gXob5GzcDbAUNlfY
      },
      experienceOptions: {
        input_fields: {
          no_shipping: 1
        }
      },
      paySuccess: false,
      PPAUTHTOKEN: false,
      loadButtons: false,
      loaded: false,
      concluded: false
    };
  },

  methods: {
    submit: function submit() {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
    base64: function base64(file) {
      // read binary data
      var assert = __webpack_require__("N+Om");
      var pt = __webpack_require__("o/zv");

      var url = "https://www.mattiafossati.com/img/header-img.png";
      var path = pt.resolve("test/nodejs.png");
      var validBase64 = new RegExp("^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{0,2}==)$", "gim");

      browser_default()(url).then(function (data) {
        assert(validBase64.test(data), true);
      }).catch(function (err) {
        return assert(err, true);
      });

      browser_default()(path).then(function (data) {
        assert(validBase64.test(data).test(data), true);
      }).catch(function (err) {
        return assert(err, true);
      });
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      if (this.getProfile.type == 1) {
        this.hasPrev = false;
      } else {
        this.hasPrev = true;
      }
      if (this.getProfile.status == "admin") {
        this.adminIs = true;
        this.AdminId = this.getProfile.id;
        this.flagForCheck = this.getProfile.type;
      } else if (this.getProfile.status == "user") {
        this.adminIs = false;
        this.flagForCheck = this.getProfile.type;
      }
    },
    sendPracticeToKPMG: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _this = this;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$validator.validate().then(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(valid) {
                    var _vue, p, dataUser, data;

                    return regenerator_default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _vue = _this;

                            _this.concluded = true;
                            for (p in _vue.uploadFrontPercentage) {
                              if (!_vue.uploadFrontPercentage[p]["completed"] && _vue.uploadFrontPercentage[p]["mandatory"] == "yes") {
                                _this.concluded = false;
                              }
                            }

                            if (!_this.concluded) {
                              _context.next = 23;
                              break;
                            }

                            _this.loadingState = true;

                            if (!_this.adminIs) {
                              _context.next = 16;
                              break;
                            }

                            _this.$warn(_this.item);

                            if (!_this.item.admin_ref) {
                              _context.next = 14;
                              break;
                            }

                            _this.$log("------------------");
                            dataUser = { token: _this.item.userToken_user };

                            _this.$log(dataUser);
                            dataUser = _this.$encryptByAES(stringify_default()(dataUser), "B%t$AD!YMfnCZnfD");
                            _context.next = 14;
                            return axios_default()({
                              url: "https://wsbot.eu/ebonusBack/public/" + "api/getUserForKPMG",
                              method: "POST",
                              data: { dataUser: dataUser },
                              headers: {
                                Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                                "Content-type": "application/json"
                              }
                            }).then(function (resp) {
                              resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                              _this.$warn(resp.data);
                              _this.passUSer = resp.data;
                            }).catch(function (resp) {
                              _this.loadingState = false;
                              _this.showAlert();
                            });

                          case 14:
                            _context.next = 17;
                            break;

                          case 16:
                            _this.passUSer = _this.getProfile;

                          case 17:
                            data = {
                              docs: _this.uploadFrontPercentage,
                              practice: _this.item,
                              user: _this.passUSer
                            };


                            if (valid) {} else {}
                            data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");

                            axios_default()({
                              url: "https://wsbot.eu/ebonusBack/public/" + "api/sendPracticeToKPMG",
                              method: "POST",
                              data: { data: data },
                              headers: {
                                Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                                "Content-type": "application/json"
                              }
                            }).then(function (resp) {
                              _this.loadingState = false;
                              _vue.$router.push("/pratiche");
                            }).catch(function (resp) {
                              _this.loadingState = false;
                              _this.showAlert();
                            });
                            _context.next = 24;
                            break;

                          case 23:
                            _this.showAlertNotConcluded();

                          case 24:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendPracticeToKPMG() {
        return _ref.apply(this, arguments);
      }

      return sendPracticeToKPMG;
    }(),
    paymentAuthorized: function paymentAuthorized(data) {
      //this.$log(data);
    },
    paymentCompleted: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(data) {
        var trans, _vue;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                trans = data;
                _vue = this;

                if (!(trans.state == "approved")) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 5;
                return _vue.saveSubscription(trans);

              case 5:
                _vue.paySuccess = true;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function paymentCompleted(_x2) {
        return _ref3.apply(this, arguments);
      }

      return paymentCompleted;
    }(),
    paymentCancelled: function paymentCancelled(data) {
      this.$swal({
        type: "error",
        title: '<strong class="modalText danger">Ci dispiace, </strong>',
        html: "<p>il pagamento non è andato a buon fine</p>",
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267"
      });
    },
    getAuthToken: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var _this2 = this;

        var _vue, urlencoded, envNow;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.$log("1) CREATE TOKEN");
                _vue = this;
                urlencoded = new URLSearchParams();

                urlencoded.append("grant_type", "client_credentials");

                envNow = "";

                if (true) {
                  envNow = ".sandbox";
                }

                _context4.next = 8;
                return axios_default()({
                  url: "https://api" + envNow + ".paypal.com/v1/oauth2/token",
                  method: "POST",
                  data: urlencoded,
                  auth: {
                    username: "ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W",
                    password: "EHSR0cmtZhNrjarVcTZn-LAWrYnNfFEj-x52xc1uFvfKU8Qumx4_g5339PrPxF1DN4e6J12Z6-QNqWTH"
                  },
                  headers: {
                    //'Authorization': 'Basic Basic QWVTNlpENmliWmNnVzJXUHFoX1ppVnBSQ09iWFlOdzJMUFAtTE1yTTIxNUFEYVhsWkRCeW5US0FPXy1uTDRJa3dycS1FQUY4TG9MZWRMNU06RU5Tc0kyaFg3OWVnSDFDS2ZETlBRbmYwU3NrYmNHdDByOUdSaVZEd05NQXJHejJIQU1QNmMzLTk2MGhwUWthMmdYb2I1R3pjRGJBVU5sZlk=',
                    "Content-type": "application/x-www-form-urlencoded"
                  }
                }).then(function (resp) {
                  //this.$log(resp.data)
                  _vue.PPAUTHTOKEN = resp.data.access_token;
                  _this2.$log("1) SUCCESS");
                  //this.$warn(urlencoded)

                  //_vue.test()

                  _vue.createBillingPlan();
                }).catch(function (resp) {
                  _this2.$log(resp.response);
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAuthToken() {
        return _ref4.apply(this, arguments);
      }

      return getAuthToken;
    }(),
    saveSubscription: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(trans) {
        var _this3 = this;

        var _vue, recaptcha, token;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _vue = this;
                recaptcha = this.$recaptchaInstance;
                // (optional) Wait until recaptcha has been loaded.

                _context5.next = 4;
                return _vue.$recaptchaLoaded();

              case 4:
                _context5.next = 6;
                return _vue.$recaptcha("login");

              case 6:
                token = _context5.sent;


                this.paymentTypeD = "Practice";
                _vue.buyPlan.paymentType = "practice";
                _vue.buyPlan.expiredAt = loadDocuments_moment().add(1, "months").format("YYYY-MM-DD HH:mm:ss");

                this.autoRenewD = "Disattivato";
                _vue.buyPlan.autoRenew = "no";

                //this.$warn(trans)
                axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/addPayment",
                  method: "POST",
                  data: {
                    token: token,
                    userToken: _vue.getProfile.userToken,
                    user: _vue.getProfile,
                    subscription: _vue.buyPlan,
                    transaction: trans,
                    practice: this.item
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this3.$log(resp.data);
                }).catch(function (resp) {
                  //this.$log(resp.response)
                });
                _context5.next = 15;
                return _vue.$recaptchaLoaded();

              case 15:
                _context5.next = 17;
                return _vue.$recaptcha("login");

              case 17:
                token = _context5.sent;

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function saveSubscription(_x3) {
        return _ref5.apply(this, arguments);
      }

      return saveSubscription;
    }(),
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      this.$log(viewer);

      this.$log("ZOOOOOM");

      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show(index) {
      this.$log(this);
      var el = this.$refs["viewer" + index];

      this.$log(this.$refs);

      this.$log(el[0]);

      //const viewerV = el.$viewer

      el[0].destroyViewer();

      el[0].createViewer();

      el[0].$viewer.show();
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },


    populateProvincies: function populateProvincies() {
      var _this4 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;


      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/getProvinciesAll",
        method: "POST",
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        var data = { code: "93423599123471013491" };
        data = _this4.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/3re54fde556423DDWWE2345Esdsfwe443245trtfwEFW",
          method: "POST",
          data: {
            data: data
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        });
        _this4.provincies = resp.data.provincies;
        _this4.provinciesState = false;
      }).catch(function (resp) {
        _this4.provincies = [];
        _this4.provinciesState = false;
      });
    },
    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Ci dispiace! Riprova piu tardi"
      });
    },
    showAlertNotConcluded: function showAlertNotConcluded() {
      // Use sweetalret2
      this.$swal({
        type: "warning",
        title: "Attenzione!",
        text: "Prima di procedere concludi il caricamento di tutti i documenti"
      });
    },
    setCap: function setCap(cap) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var x;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                for (x in _this5.zips) {
                  if (_this5.zips[x].cap == cap.toUpperCase()) {
                    _this5.zip = _this5.zips[x].cap;
                  }
                }

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    setCity: function setCity(city) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var x, k;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                for (x in _this6.cities) {
                  if (_this6.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this6.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this6.city = k;
                  }
                }
                _this6.$log(_this6.city);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this6);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8() {
        var x;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                for (x in _this7.provincies) {
                  _this7.$log("START");
                  _this7.$log(_this7.provincies[x].sigla + " =?= " + province.toUpperCase());
                  if (_this7.provincies[x].sigla == province.toUpperCase()) {
                    _this7.province = _this7.provincies[x].sigla;
                  }
                }
                _this7.$log(_this7.province);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this7);
      }))();
    },
    closeDocumentBlock: function closeDocumentBlock(doc, code, name, docCode) {
      var _this8 = this;

      var _vue = this;
      var data = {};
      data.doc = doc;
      data.code = code;
      data.name = name;
      data.docCode = docCode;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/closeDocumentBlock",
        method: "POST",
        data: {
          data: data
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      }).then(function (resp) {
        var r = _this8.uploadFrontPercentage[data.doc];
        r["completed"] = 1;
        //r['hasError'] = 'no'
        vue_esm["a" /* default */].set(_this8.uploadFrontPercentage, data.doc, r);

        // NEW
        _vue.concluded = true;
        for (var p in _vue.uploadFrontPercentage) {
          if (!_vue.uploadFrontPercentage[p]["completed"] && _vue.uploadFrontPercentage[p]["mandatory"] == "yes") {
            _vue.concluded = false;
          }
        }
      }).catch(function (resp) {});
    },
    uploadFile: function uploadFile(doc, code, name, docCode) {
      this.loadingState = true;
      var data = { code: "93423599123471013491" };
      data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + "api/3re54fde556423DDWWE2345Esdsfwe443245trtfwEFW",
        method: "POST",
        data: {
          data: data
        },
        headers: {
          Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          "Content-type": "application/json"
        }
      });
      this.$log(this.$refs["fileInput" + doc]);
      var input = this.$refs["fileInput" + doc][0];

      //this.$log(input)

      console.log(doc);
      console.log(code);
      console.log(name);
      console.log(docCode);

      var ind = doc;
      //this.$log(0)
      var file = input.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.files[0].size;
      console.warn(size);
      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 2 * 10506316) {
        this.invoiceFront = input.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.files[0]);

        //this.$log(this.uploadFrontPercentage)

        formData.append("doc", doc);
        formData.append("code", code);
        formData.append("name", name);
        formData.append("docCode", docCode);

        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadDocument", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            var r = this.uploadFrontPercentage[ind];

            r["percent"] = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));

            //  Object.assign(this.uploadFrontPercentage, r)

            vue_esm["a" /* default */].set(this.uploadFrontPercentage, ind, r);

            //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          _vue.loadingState = false;
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.document)) {
            _vue.uploadFrontPercentage[ind]["percent"] = 0;
            var x = _vue.uploadFrontPercentage[ind]["images"];

            x[e.data.id] = e.data.document;
            _vue.getDocuments(_vue.$route.params.item.code, "asdg2352rsdfgv");
            _vue.uploadFrontPercentage[ind]["images"] = x;
            _vue.uploadFrontPercentage[ind]["hasError"] = "no";
            _vue.uploadFrontPercentage[ind]["countImages"] = 1;
            _vue.uploadFrontPercentage[ind]["date"] = loadDocuments_moment().format("YYYY-MM-DD HH:mm:00");
            console.log("ended");
            _vue.forcereloadDocs();
            //_vue.invoiceFrontBucket = e.data.fattura
          } else {
            _vue.uploadFrontPercentage[ind]["percent"] = 0;
            //console.log(_vue.$route.params.item.code);
            _vue.forcereloadDocs();
            //_vue.getDocuments(_vue.$route.params.item.code, "asdg2352rsdfgv");
            //console.log("ended - img");
            //_vue.componentKey += 1
            //console.log(_vue.componentKey)
            //_vue.$forceUpdate();
            /******************************** */

            /******************************** */
          }
        }).catch(function () {
          _vue.loadingState = false;
          _vue.uploadFrontPercentage.doc = 0;
          _vue.$log("|||||||");
          _vue.$error(_vue.uploadFrontPercentage);
          //  _vue.invoiceFront = ''
          ///  _vue.invoiceFrontBucket = ''

          //input.value = null
        });
      }
    },
    forcereloadDocs: function forcereloadDocs() {
      var _this9 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
        var _vue, docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, x, z, y;

        return regenerator_default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _vue = _this9;

                if (_vue.getProfile.corporateClient == "agnellimetalli") {
                  _vue.documents = documents_documents;
                }
                if (_vue.getProfile.corporateClient == "hoval") {
                  _vue.documents = documentsHoval;
                }
                if (_vue.getProfile.corporateClient == "emicon") {
                  _vue.documents = documentsEmicon;
                }

                if (true) {
                  _vue.envPP = "sandbox";
                }
                // DOC LIST PARSER
                docTemp = _vue.documents[_vue.$route.params.item.client_type];

                _vue.documents[_vue.$route.params.item.client_type] = {};

                selettore_titoloPossesso = _vue.$route.params.item.client_ownership;
                selettore_enea = _vue.$route.params.item.enea_request;


                if (selettore_enea == "0") {
                  selettore_enea = "no";
                } else {
                  selettore_enea = "yes";
                }

                for (ele in docTemp) {
                  if (docTemp[ele].hasOwnProperty("codice")) {
                    _vue.documents[_vue.$route.params.item.client_type][ele] = docTemp[ele];
                  } else if (docTemp[ele].hasOwnProperty("selector")) {
                    if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                      tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                    } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                      tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                    }
                    for (eleS in tmpList) {
                      _vue.documents[_vue.$route.params.item.client_type][eleS] = tmpList[eleS];
                    }
                  }
                }

                // ******************************************************************************************

                _vue.loadingState = true;
                //_vue.uploadFrontPercentage = {}

                assign_default()(_vue.uploadFrontPercentage, {});

                _context9.next = 15;
                return _vue.getDocuments(_vue.$route.params.item.code, "asdg2352rsdfgv");

              case 15:

                for (x in _vue.documents[_vue.$route.params.item.client_type]) {
                  z = {};

                  z.images = {};
                  z.countImages = 0;
                  z.completed = 0;

                  z.docname = _vue.documents[_vue.$route.params.item.client_type][x]["name"];

                  if ((_vue.getProfile.tipo_azienda == "Ditta Individuale" || _vue.getProfile.tipo_azienda == "Professionista iscritto ad albi") && _vue.documents[_vue.$route.params.item.client_type][x]["codice"] == "2050D0B") {
                    z.mandatory = "no";
                    _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"] = _vue.hasPrev ? "no" : "yes";
                  } else {
                    z.mandatory = _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"];
                  }

                  // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
                  if (_vue.documents[_vue.$route.params.item.client_type][x]["codice"] == "2050D11" && _vue.$route.params.item.to_get_cadastral_data == "1") {
                    z.mandatory = _vue.hasPrev ? "no" : "yes";
                    _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"] = _vue.hasPrev ? "no" : "yes";
                  } else {
                    if (_vue.documents[_vue.$route.params.item.client_type][x]["codice"] == "2050D11" && _vue.$route.params.item.to_get_cadastral_data == "0") {
                      z.mandatory = "yes";
                      _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"] = "yes";
                      _vue.$log("DOC 2050D11");
                      _vue.$log(_vue.documents[_vue.$route.params.item.client_type][x]["mandatory"]);
                    } else {
                      z.mandatory = _vue.documents[_vue.$route.params.item.client_type][x]["mandatory"];
                    }
                  }

                  z.hasError = "no";
                  for (y in _vue.savedDocuments) {
                    if (_vue.savedDocuments[y].codice == x) {
                      z.images[_vue.savedDocuments[y].id] = _vue.savedDocuments[y].url;
                      z.countImages = 1;
                      z.date = _vue.savedDocuments[y].date;
                      z.completed = parseInt(_vue.savedDocuments[y].completed);
                      z.hasError = _vue.savedDocuments[y].hasError;
                      z.error = _vue.savedDocuments[y].error;
                    }
                  }
                  z.percent = 0;
                  y = {};

                  y[x] = z;
                  vue_esm["a" /* default */].set(_vue.uploadFrontPercentage, x, z);
                }

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    getDocuments: function getDocuments(code, user_token) {
      var _this10 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10() {
        var data;
        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                data = { code: code, user_token: user_token };

                data = _this10.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context10.next = 4;
                return axios_default()({
                  //OLD getDocumentsByCode

                  url: "https://wsbot.eu/ebonusBack/public/" + "api/3re54fde556423DDWWE2345Esdsfwe443245trtfwEFW",
                  method: "POST",
                  data: {
                    data: data
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this10.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _this10.savedDocuments = resp.data.documents;
                  _this10.loadingState = false;
                }).catch(function (resp) {
                  _this10.savedDocuments = {};
                });

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    checkIfIban: function checkIfIban() {
      /*if (this.getProfile) {
        if (this.getProfile.iban == "") {
          this.$swal({
            type: "warning",
            title: "Attenzione!",
            text: "Ricordati, che dovrai inserire l`Iban delle Poste Italiane prima della cessione del credito.",
          });
            //this.$router.push('/account')
        }
      }*/
    }
  },
  watch: {
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    getProfile: function getProfile() {
      this.checkIfIban();
      this.setProfile();
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this11 = this;

      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this11.cities = resp.data.cities;
          _this11.citiesState = false;
        }).catch(function (resp) {
          _this11.cities = [];
          _this11.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this12 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat
          },
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          _this12.zips = resp.data.zips;
          _this12.zipsState = false;
        }).catch(function (resp) {
          _this12.zips = [];
          _this12.zipsState = false;
        });
      }
    }
  },
  created: function created() {
    var _this13 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      var docTemp, selettore_titoloPossesso, selettore_enea, ele, tmpList, eleS, x, z, y;
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _this13.setProfile();
              _this13.$warn(_this13.getProfile);
              if (_this13.getProfile.corporateClient == "agnellimetalli") {
                _this13.documents = documents_documents;
              }
              if (_this13.getProfile.corporateClient == "hoval") {
                _this13.documents = documentsHoval;
              }
              if (_this13.getProfile.corporateClient == "emicon") {
                _this13.documents = documentsEmicon;
              }

              if (true) {
                _this13.envPP = "sandbox";
              }
              // DOC LIST PARSER
              docTemp = _this13.documents[_this13.$route.params.item.client_type];

              _this13.documents[_this13.$route.params.item.client_type] = {};

              selettore_titoloPossesso = _this13.$route.params.item.client_ownership;
              selettore_enea = _this13.$route.params.item.enea_request;


              if (selettore_enea == "0") {
                selettore_enea = "no";
              } else {
                selettore_enea = "yes";
              }

              for (ele in docTemp) {
                if (docTemp[ele].hasOwnProperty("codice")) {
                  _this13.documents[_this13.$route.params.item.client_type][ele] = docTemp[ele];
                } else if (docTemp[ele].hasOwnProperty("selector")) {
                  if (docTemp[ele]["selector"].hasOwnProperty(selettore_titoloPossesso.toLowerCase())) {
                    tmpList = docTemp[ele]["selector"][selettore_titoloPossesso.toLowerCase()];
                  } else if (docTemp[ele]["selector"].hasOwnProperty(selettore_enea)) {
                    tmpList = docTemp[ele]["selector"][selettore_enea.toLowerCase()];
                  }
                  for (eleS in tmpList) {
                    _this13.documents[_this13.$route.params.item.client_type][eleS] = tmpList[eleS];
                  }
                }
              }

              // ******************************************************************************************

              _this13.loadingState = true;
              //this.uploadFrontPercentage = {}

              assign_default()(_this13.uploadFrontPercentage, {});

              _context11.next = 16;
              return _this13.getDocuments(_this13.$route.params.item.code, "asdg2352rsdfgv");

            case 16:

              for (x in _this13.documents[_this13.$route.params.item.client_type]) {
                z = {};

                z.images = {};
                z.countImages = 0;
                z.completed = 0;

                z.docname = _this13.documents[_this13.$route.params.item.client_type][x]["name"];

                if ((_this13.getProfile.tipo_azienda == "Ditta Individuale" || _this13.getProfile.tipo_azienda == "Professionista iscritto ad albi") && _this13.documents[_this13.$route.params.item.client_type][x]["codice"] == "2050D0B") {
                  z.mandatory = "no";
                  _this13.documents[_this13.$route.params.item.client_type][x]["mandatory"] = _this13.hasPrev ? "no" : "yes";
                } else {
                  z.mandatory = _this13.documents[_this13.$route.params.item.client_type][x]["mandatory"];
                }

                // NEWW REMOVE MANDATORY ID REQUEST DATA CATASTALE
                if (_this13.documents[_this13.$route.params.item.client_type][x]["codice"] == "2050D11" && _this13.$route.params.item.to_get_cadastral_data == "1") {
                  z.mandatory = _this13.hasPrev ? "no" : "yes";
                  _this13.documents[_this13.$route.params.item.client_type][x]["mandatory"] = _this13.hasPrev ? "no" : "yes";
                } else {
                  if (_this13.documents[_this13.$route.params.item.client_type][x]["codice"] == "2050D11" && _this13.$route.params.item.to_get_cadastral_data == "0") {
                    z.mandatory = "yes";
                    _this13.documents[_this13.$route.params.item.client_type][x]["mandatory"] = "yes";
                    _this13.$log("DOC 2050D11");
                    _this13.$log(_this13.documents[_this13.$route.params.item.client_type][x]["mandatory"]);
                  } else {
                    z.mandatory = _this13.documents[_this13.$route.params.item.client_type][x]["mandatory"];
                  }
                }

                z.hasError = "no";
                for (y in _this13.savedDocuments) {
                  if (_this13.savedDocuments[y].codice == x) {
                    z.images[_this13.savedDocuments[y].id] = _this13.savedDocuments[y].url;
                    z.countImages = 1;
                    z.date = _this13.savedDocuments[y].date;
                    z.completed = parseInt(_this13.savedDocuments[y].completed);
                    z.hasError = _this13.savedDocuments[y].hasError;
                    z.error = _this13.savedDocuments[y].error;
                  }
                }
                z.percent = 0;
                y = {};

                y[x] = z;
                vue_esm["a" /* default */].set(_this13.uploadFrontPercentage, x, z);
              }

              //this.$log(this.uploadFrontPercentage)

              _this13.loadingState = false;

            case 18:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this13);
    }))();
  },
  mounted: function mounted() {
    var _this14 = this;

    this.loadButtons = true;
    this.setProfile();
    if (this.$route.params.item) {
      this.item = this.$route.params.item;

      this.$log(this.item);

      if (this.item && this.item.client_type != "Amministratore di condominio") {
        this.address = this.item.building_address;
        this.civic = this.item.building_civic;
      }

      if (this.item.payment_id == 0) {
        this.payment = false;

        if (true) {
          this.envPP = "sandbox";
        }

        var _vue = this;

        this.$loadScript("https://www.paypal.com/sdk/js?client-id=" + "ARrJP8fqNklcKlq_DrjfogmNlKio8MAE1TRhlYXjmn4MzW7G6U-frpikqw-2k5KkzHzcP8Kqlmsftl1W" + "&vault=true&currency=EUR").then(function () {
          _this14.loadButtons = false;
        }).catch(function () {
          // Failed to fetch script
        });
      } else {
        this.payment = true;
      }

      this.loaded = true;

      // NEW
      var _vue = this;
      setTimeout(function () {
        _vue.concluded = true;
        for (var p in _vue.uploadFrontPercentage) {
          if (!_vue.uploadFrontPercentage[p]["completed"] && _vue.uploadFrontPercentage[p]["mandatory"] == "yes") {
            _vue.concluded = false;
          }
        }
      }, 1000);
    } else {
      this.$router.push("/pratiche");
    }

    this.checkIfIban();

    this.populateProvincies();
    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38471c95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loadDocuments/index.vue
var loadDocuments_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.componentKey,
      staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5"
    },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container  mt-5 mb-5 pb-5 pt-4" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\r\n          Indietro\r\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("div", { staticClass: "col-md-12 pb-0 buyPlan center" }, [
                _c("h3", { staticClass: "center darkBlue mb-3" }),
                _vm._v(" "),
                !_vm.paySuccess
                  ? _c("div", { staticClass: "widthFull" }, [
                      _c("div", { staticClass: "row " }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-6 col-md-6 col-lg-6 text-left bgWhite"
                          },
                          [
                            _c("div", { staticClass: "row " }, [
                              _vm._m(1),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-0" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.price
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(2),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-3 text-right" },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _c("b", {}, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.buyPlan.iva
                                            )
                                          ) + " € "
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.enea_request != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(4),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaEnea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(5),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-0" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.priceDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item.to_get_cadastral_data != "0"
                              ? _c("div", { staticClass: "row " }, [
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3 text-right" },
                                    [
                                      _c(
                                        "h5",
                                        { staticClass: " text-right mb-4" },
                                        [
                                          _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.ivaDcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row " }, [
                              _vm._m(7),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 text-right borderTopBlack"
                                },
                                [
                                  _c(
                                    "h5",
                                    { staticClass: " text-right mb-4" },
                                    [
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data == "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request == "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.item.enea_request != "0" &&
                                      _vm.item.to_get_cadastral_data != "0"
                                        ? _c("b", {}, [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  _vm.buyPlan.amount_enea_dcast
                                                )
                                              ) + " € "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "col-sm-0 col-md-1 col-lg-1 text-left"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-6 col-lg-4" },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "center widthFull mb-3 mt-3 bgWhite pb-3"
                              },
                              [
                                _vm._m(8),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass:
                                    "img-fluid widthFull payImage mb-2",
                                  attrs: {
                                    src: __webpack_require__("nIi4")
                                  }
                                }),
                                _vm._v(" "),
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount: "" + _vm.buyPlan.amount,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount: "" + _vm.buyPlan.amount_enea,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount: "" + _vm.buyPlan.amount_dcast,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("paypal-checkout", {
                                      attrs: {
                                        env: _vm.envPP,
                                        amount:
                                          "" + _vm.buyPlan.amount_enea_dcast,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        currency: "EUR",
                                        locale: "it_IT",
                                        client: _vm.credentials,
                                        "button-style": { size: "large" },
                                        experience: _vm.experienceOptions
                                      },
                                      on: {
                                        "payment-authorized":
                                          _vm.paymentAuthorized,
                                        "payment-completed":
                                          _vm.paymentCompleted,
                                        "payment-cancelled":
                                          _vm.paymentCancelled
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.autoReNew && !_vm.loadButtons
                                  ? _c("div", {
                                      attrs: { id: "paypal-button-container" }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "center widthFull mb-3 mt-3 bgWhite"
                              },
                              [
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        amount: "" + _vm.buyPlan.amount,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data == "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        amount: "" + _vm.buyPlan.amount_enea,
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request == "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        amount: "" + _vm.buyPlan.amount_dcast,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.item.enea_request != "0" &&
                                _vm.item.to_get_cadastral_data != "0"
                                  ? _c("stripePayment", {
                                      attrs: {
                                        amount:
                                          "" + _vm.buyPlan.amount_enea_dcast,
                                        "invoice-number":
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        items: [
                                          {
                                            name: "CHEBONUS-" + _vm.item.code,
                                            description:
                                              "PRATICA_" + _vm.item.code,
                                            price: "" + _vm.buyPlan.amount,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Pratica ENEA",
                                            description:
                                              "Servizio di redazione e invio pratica ENEA",
                                            price:
                                              "" + _vm.buyPlan.priceEnea * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          },
                                          {
                                            name: "Visura Catastale",
                                            description:
                                              "Servizio Visura Catastale",
                                            price:
                                              "" +
                                              _vm.buyPlan.priceDcast * 1.22,
                                            quantity: "1",
                                            currency: "EUR"
                                          }
                                        ],
                                        invoiceNumber:
                                          "CHEBONUS_PRATICA_" + _vm.item.code,
                                        practice: _vm.item.code,
                                        userToken: _vm.getProfile.userToken
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.paySuccess
                  ? _c("div", { staticClass: "col-sm-12 center" }, [
                      _c("img", {
                        staticClass: "img-fluid payImage",
                        attrs: {
                          src: __webpack_require__("4AGf")
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("h1", { staticClass: "center" }, [
                        _vm._v("Grazie per averci scelto, ")
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "center" }, [
                        _vm._v("il tuo pagamento è avvenuto con successo")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary rn-btn-dark mt-5",
                          on: {
                            click: function($event) {
                              _vm.payment = true
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "hover hover-1" }, [
                            _vm._v("Procedi")
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payment && _vm.loaded
        ? _c("div", { staticClass: "container  mt-5 mb-5 pb-5 pt-4" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
                  _vm._v(
                    "\r\n            Prepara e carica tutti i documenti richiesti. Al termine dell caricamento ogni singolo documento clicca su pulsante CONCLUDI.\r\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "black mt-0 text-left widthFull " },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mr-2",
                      attrs: { icon: "star-of-life", size: "" }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v("Documenti Obbligatori")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\r\n            Indietro\r\n          ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass:
                  "pb-5 mb-5 black pt-2 pl-4 pr-4 widthFull vaillantCont",
                attrs: { id: "doc-form" }
              },
              [
                _vm._l(_vm.documents[_vm.item.client_type], function(
                  doc,
                  index,
                  k
                ) {
                  return (doc.codice != "2050D11" ||
                    (_vm.item.dcast_export == "10" &&
                      doc.codice == "2050D11") ||
                    (_vm.item.to_get_cadastral_data == "0" &&
                      doc.codice == "2050D11")) &&
                    _vm.hasPrev
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-center vaillantCont pt-2 pb-2",
                          class: {
                            "pt-0": k == 0,
                            even: String(k / 2).includes(".")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-1 bordered center tablePdMob"
                            },
                            [
                              !_vm.uploadFrontPercentage[index][
                                "countImages"
                              ] ||
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "yes"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("ckMO")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("Jkjn")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("9x6x")
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-5 bordered text-center text-md-left"
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                                },
                                [
                                  doc.mandatory == "yes"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mandatoryDoc",
                                        attrs: {
                                          icon: "star-of-life",
                                          size: "xs"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(doc.name) +
                                      "\r\n              "
                                  ),
                                  _vm.uploadFrontPercentage[index][
                                    "hasError"
                                  ] == "yes"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "widthFull red mt-0 pt-0 docTitleMob pl-md-3"
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                Rilevata la seguente anomalia: "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.uploadFrontPercentage[index][
                                                "error"
                                              ]
                                            ) + "\r\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors.has("fileInput" + index)
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-custom" },
                                    [
                                      _vm._v(
                                        "\r\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "fileInput" + index
                                            )
                                          ) +
                                          "\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["percent"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      attrs: { id: "progFront" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar",
                                          style: {
                                            width:
                                              _vm.uploadFrontPercentage[index][
                                                "percent"
                                              ] + "%"
                                          },
                                          attrs: {
                                            id: "progress-bar-front",
                                            role: "progressbar",
                                            "aria-valuenow": "50",
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                " +
                                              _vm._s(
                                                _vm.uploadFrontPercentage[
                                                  index
                                                ]["percent"]
                                              ) +
                                              " %\r\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-2 text-right bordered  tablePdMob",
                              class: {
                                "d-none d-md-block": doc.template == "no",
                                "d-block d-md-block": doc.template == "yes"
                              }
                            },
                            [
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Modulo")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              (_vm.getProfile.tipo_azienda !=
                                "Ditta Individuale" &&
                                _vm.getProfile.tipo_azienda !=
                                  "Professionista iscritto ad albi" &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              ((_vm.getProfile.tipo_azienda ==
                                "Ditta Individuale" ||
                                _vm.getProfile.tipo_azienda ==
                                  "Professionista iscritto ad albi") &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href:
                                          "https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf",
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: " col-md-1 bordered tablePdMob",
                              class: {
                                "col-12 center": doc.template == "no",
                                "col-6": doc.template == "yes"
                              }
                            },
                            [
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.item.status == 1 &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("div", { staticClass: "front-image2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: doc.mandatory == "yes",
                                            size: 2 * 10240,
                                            ext: ["jpeg", "jpg", "png", "pdf"],
                                            mimes: [
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                              "application/pdf"
                                            ]
                                          },
                                          expression:
                                            "{required: doc.mandatory == 'yes',size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                        }
                                      ],
                                      ref: "fileInput" + index,
                                      refInFor: true,
                                      staticClass: "btn btn-primary btn-xl",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "fileInput" + index
                                        ),
                                        valid: !!_vm.invoiceFront,
                                        helper: !!_vm.invoiceFrontBucket
                                      },
                                      attrs: {
                                        type: "file",
                                        name: "fileInput" + index,
                                        id: "fileInput" + index,
                                        "data-vv-as": doc.name
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.uploadFile(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _vm._m(10, true)
                                  ])
                                : (_vm.uploadFrontPercentage[index][
                                    "completed"
                                  ] &&
                                    _vm.item.status == 1 &&
                                    _vm.item.hasErrors == "no") ||
                                  (_vm.item.status == 1 &&
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: {
                                        to: {
                                          name: "editDocument",
                                          params: {
                                            doc: doc,
                                            dbdoc:
                                              _vm.uploadFrontPercentage[index],
                                            item: _vm.item,
                                            docIndex: index
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\r\n              Modifica\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-1 bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Visualizza")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "viewer",
                                {
                                  ref: "viewer" + index,
                                  refInFor: true,
                                  staticClass: "imagesViewer clearfix widthFull"
                                },
                                [
                                  _vm._l(
                                    _vm.uploadFrontPercentage[index]["images"],
                                    function(image, key) {
                                      return [
                                        image
                                          .substring(
                                            image.lastIndexOf(".") + 1,
                                            image.length
                                          )
                                          .toLowerCase() != "pdf"
                                          ? _c("img", {
                                              key: key,
                                              staticClass: "img-fluid",
                                              attrs: { src: image }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: key,
                                                staticClass: "pdfViewer",
                                                attrs: {
                                                  href: image,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src: __webpack_require__("Ta3C")
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 text-center bordered tablePdMob"
                            },
                            [
                              _vm._l(
                                _vm.uploadFrontPercentage[index]["images"],
                                function(img, num) {
                                  return [
                                    img
                                      .substring(
                                        img.lastIndexOf(".") + 1,
                                        img.length
                                      )
                                      .toLowerCase() != "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb",
                                            attrs: { target: "_blank" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-alt" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb relative",
                                            attrs: {
                                              href: img,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-pdf" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "littlePdf" },
                                              [_vm._v("PDF")]
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 center bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-green btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeDocumentBlock(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Concludi")]
                                  )
                                : _vm.uploadFrontPercentage[index]["completed"]
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm._l(_vm.documents[_vm.item.client_type], function(
                  doc,
                  index,
                  k
                ) {
                  return !_vm.hasPrev
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "row justify-content-center vaillantCont pt-2 pb-2",
                          class: {
                            "pt-0": k == 0,
                            even: String(k / 2).includes(".")
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-1 bordered center tablePdMob"
                            },
                            [
                              !_vm.uploadFrontPercentage[index][
                                "countImages"
                              ] ||
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "yes"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("ckMO")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("Jkjn")
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("img", {
                                    staticClass: "img-fluid widthFull maxBomTr",
                                    attrs: {
                                      src: __webpack_require__("9x6x")
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-5 bordered text-center text-md-left"
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "widthFull black mt-0 pt-0 docTitleMob pl-md-3"
                                },
                                [
                                  doc.mandatory == "yes"
                                    ? _c("font-awesome-icon", {
                                        staticClass: "mandatoryDoc",
                                        attrs: {
                                          icon: "star-of-life",
                                          size: "xs"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " +
                                      _vm._s(doc.name) +
                                      "\r\n              "
                                  ),
                                  _vm.uploadFrontPercentage[index][
                                    "hasError"
                                  ] == "yes"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "widthFull red mt-0 pt-0 docTitleMob pl-md-3"
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                Rilevata la seguente anomalia: "
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.uploadFrontPercentage[index][
                                                "error"
                                              ]
                                            ) + "\r\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors.has("fileInput" + index)
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback-custom" },
                                    [
                                      _vm._v(
                                        "\r\n              " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "fileInput" + index
                                            )
                                          ) +
                                          "\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.uploadFrontPercentage[index]["percent"]
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "progress",
                                      attrs: { id: "progFront" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "progress-bar",
                                          style: {
                                            width:
                                              _vm.uploadFrontPercentage[index][
                                                "percent"
                                              ] + "%"
                                          },
                                          attrs: {
                                            id: "progress-bar-front",
                                            role: "progressbar",
                                            "aria-valuenow": "50",
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                " +
                                              _vm._s(
                                                _vm.uploadFrontPercentage[
                                                  index
                                                ]["percent"]
                                              ) +
                                              " %\r\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-6 col-md-2 text-right bordered  tablePdMob",
                              class: {
                                "d-none d-md-block": doc.template == "no",
                                "d-block d-md-block": doc.template == "yes"
                              }
                            },
                            [
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              doc.codice != "2050D0B"
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Modulo")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              (_vm.getProfile.tipo_azienda !=
                                "Ditta Individuale" &&
                                _vm.getProfile.tipo_azienda !=
                                  "Professionista iscritto ad albi" &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href: doc.template_link,
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              doc.template == "yes" &&
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              ((_vm.getProfile.tipo_azienda ==
                                "Ditta Individuale" ||
                                _vm.getProfile.tipo_azienda ==
                                  "Professionista iscritto ad albi") &&
                                doc.codice == "2050D0B")
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-xl mt-3 mt-md-0",
                                      attrs: {
                                        href:
                                          "https://storage.googleapis.com/stage_novatag/ecobonus/2050D0Bd.vt.pdf",
                                        target: "_blank",
                                        type: "button"
                                      }
                                    },
                                    [_vm._v("Istruzioni")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: " col-md-1 bordered tablePdMob",
                              class: {
                                "col-12 center": doc.template == "no",
                                "col-6": doc.template == "yes"
                              }
                            },
                            [
                              !_vm.uploadFrontPercentage[index]["completed"] &&
                              _vm.item.status == 1 &&
                              _vm.uploadFrontPercentage[index]["hasError"] ==
                                "no"
                                ? _c("div", { staticClass: "front-image2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: doc.mandatory == "yes",
                                            size: 2 * 10240,
                                            ext: ["jpeg", "jpg", "png", "pdf"],
                                            mimes: [
                                              "image/jpeg",
                                              "image/jpg",
                                              "image/png",
                                              "application/pdf"
                                            ]
                                          },
                                          expression:
                                            "{required: doc.mandatory == 'yes',size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                        }
                                      ],
                                      ref: "fileInput" + index,
                                      refInFor: true,
                                      staticClass: "btn btn-primary btn-xl",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "fileInput" + index
                                        ),
                                        valid: !!_vm.invoiceFront,
                                        helper: !!_vm.invoiceFrontBucket
                                      },
                                      attrs: {
                                        type: "file",
                                        name: "fileInput" + index,
                                        id: "fileInput" + index,
                                        "data-vv-as": doc.name
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.uploadFile(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _vm._m(11, true)
                                  ])
                                : (_vm.uploadFrontPercentage[index][
                                    "completed"
                                  ] &&
                                    _vm.item.status == 1 &&
                                    _vm.item.hasErrors == "no") ||
                                  (_vm.item.status == 1 &&
                                    _vm.uploadFrontPercentage[index][
                                      "hasError"
                                    ] == "yes")
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: {
                                        to: {
                                          name: "editDocument",
                                          params: {
                                            doc: doc,
                                            dbdoc:
                                              _vm.uploadFrontPercentage[index],
                                            item: _vm.item,
                                            docIndex: index
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\r\n              Modifica\r\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-4 col-md-1 bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Visualizza")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "viewer",
                                {
                                  ref: "viewer" + index,
                                  refInFor: true,
                                  staticClass: "imagesViewer clearfix widthFull"
                                },
                                [
                                  _vm._l(
                                    _vm.uploadFrontPercentage[index]["images"],
                                    function(image, key) {
                                      return [
                                        image
                                          .substring(
                                            image.lastIndexOf(".") + 1,
                                            image.length
                                          )
                                          .toLowerCase() != "pdf"
                                          ? _c("img", {
                                              key: key,
                                              staticClass: "img-fluid",
                                              attrs: { src: image }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: key,
                                                staticClass: "pdfViewer",
                                                attrs: {
                                                  href: image,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "img-fluid",
                                                  attrs: {
                                                    src: __webpack_require__("Ta3C")
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 text-center bordered tablePdMob"
                            },
                            [
                              _vm._l(
                                _vm.uploadFrontPercentage[index]["images"],
                                function(img, num) {
                                  return [
                                    img
                                      .substring(
                                        img.lastIndexOf(".") + 1,
                                        img.length
                                      )
                                      .toLowerCase() != "pdf"
                                      ? _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb",
                                            attrs: { target: "_blank" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-alt" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "a",
                                          {
                                            key: num,
                                            staticClass: "docThumb relative",
                                            attrs: { target: "_blank" }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "file-pdf" }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "small",
                                              { staticClass: "littlePdf" },
                                              [_vm._v("PDF")]
                                            )
                                          ],
                                          1
                                        )
                                  ]
                                }
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 center bordered tablePdMob"
                            },
                            [
                              _vm.uploadFrontPercentage[index]["countImages"] &&
                              !_vm.uploadFrontPercentage[index]["completed"]
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-green btn-xl",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeDocumentBlock(
                                            index,
                                            _vm.item.code,
                                            doc.name,
                                            doc.codice
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Concludi")]
                                  )
                                : _vm.uploadFrontPercentage[index]["completed"]
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.item.aditional_enea_data == null &&
                _vm.item.enea_request == "1" &&
                2 == 3
                  ? _c("div", { staticClass: "col-md-12 center mb-4" }, [
                      _c(
                        "h5",
                        { staticClass: "Regular text-center h0 widthFull " },
                        [
                          _vm.concluded
                            ? _c("b", [
                                _c("span", { staticClass: "yellow" }, [
                                  _vm._v("Attenzione!")
                                ]),
                                _vm._v(
                                  " Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni "
                                )
                              ])
                            : _c("b", [
                                _c("span", { staticClass: "yellow" }, [
                                  _vm._v("Attenzione!")
                                ]),
                                _vm._v(
                                  "  Per redigere ed inviare la pratica ENEA avremo bisogno di ulteriori informazioni che ti chiederemo alla conclusione del Set Documentale. "
                                )
                              ]),
                          _vm._v(" "),
                          _vm.concluded
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary m-2 btn-sm",
                                  attrs: {
                                    to: {
                                      name: "complateEneaData",
                                      params: { item: _vm.item }
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\r\n              Inserisci\r\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.status == 1
                  ? _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-12 text-right" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.sendPracticeToKPMG()
                                }
                              }
                            },
                            [_vm._v("Procedi")]
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var loadDocuments_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 center mb-3 text-left" }, [
      _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
        _c("b", [
          _vm._v(
            " Per completare la tua pratica, paga il servizio con una Carta o PayPal "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 text-left widthFull " }, [
        _vm._v(
          "\r\n          Il prezzo è riferito ad una pratica. A pagamento avvenuto potrai caricare i documenti richiesti e completare la pratica.\r\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v("  Prezzo Servizio/Pratica (IVA Esclusa)  ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v("  IVA 22%  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v(
          "Prezzo  Servizio di redazione e invio pratica ENEA (IVA Esclusa)  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v("  IVA 22%  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left borderTopBlack" }, [
      _c("h5", { staticClass: " text-left mb-0" }, [
        _vm._v('  Prezzo Servizio "Visura Catastale" (IVA Esclusa)  ')
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 text-left" }, [
      _c("h5", { staticClass: " text-left mb-4" }, [_vm._v("  IVA 22%  ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 borderTopBlack text-left" }, [
      _c("h5", { staticClass: " text-right mb-4" }, [
        _vm._v(
          "\r\n                    TOTALE (IVA inclusa)\r\n                  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center  mb-3 mt-0 pt-3" }, [
      _c("b", [_vm._v("Paga con")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "Regular text-left h0 widthFull " }, [
      _c("b", [_vm._v(" Gestione Documenti ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel2 labelFileInput",
        attrs: { for: "invoiceFront" }
      },
      [_c("span", { staticClass: "smallText center white" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "niceInputLabel2 labelFileInput",
        attrs: { for: "invoiceFront" }
      },
      [_c("span", { staticClass: "smallText center white" })]
    )
  }
]
loadDocuments_render._withStripped = true
var loadDocuments_esExports = { render: loadDocuments_render, staticRenderFns: loadDocuments_staticRenderFns }
/* harmony default export */ var components_loadDocuments = (loadDocuments_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38471c95", loadDocuments_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/loadDocuments/index.vue
var loadDocuments_disposed = false
function loadDocuments_injectStyle (ssrContext) {
  if (loadDocuments_disposed) return
  __webpack_require__("7EV4")
}
var loadDocuments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loadDocuments___vue_template_functional__ = false
/* styles */
var loadDocuments___vue_styles__ = loadDocuments_injectStyle
/* scopeId */
var loadDocuments___vue_scopeId__ = "data-v-38471c95"
/* moduleIdentifier (server only) */
var loadDocuments___vue_module_identifier__ = null
var loadDocuments_Component = loadDocuments_normalizeComponent(
  loadDocuments,
  components_loadDocuments,
  loadDocuments___vue_template_functional__,
  loadDocuments___vue_styles__,
  loadDocuments___vue_scopeId__,
  loadDocuments___vue_module_identifier__
)
loadDocuments_Component.options.__file = "src/components/loadDocuments/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38471c95", loadDocuments_Component.options)
  } else {
    hotAPI.reload("data-v-38471c95", loadDocuments_Component.options)
  }
  module.hot.dispose(function (data) {
    loadDocuments_disposed = true
  })
})()}

/* harmony default export */ var src_components_loadDocuments = (loadDocuments_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/editDocuments/index.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var editDocuments_moment = __webpack_require__("PJh5");

var editDocuments_viewer = __webpack_require__("EAZf");

/* harmony default export */ var editDocuments = ({
  name: "loadDocuments",
  components: {},
  data: function data() {
    var _ref;

    return _ref = {
      token: "",
      loadingState: false,
      loading: false,
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: false,
      email: "",
      codice_fiscale: "",
      partita_iva: "",
      phone: "",
      cellulare: "",
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      client_ownership: "",
      subalterno: "",
      particella: "",
      savedDocuments: {},
      foglio: ""
    }, defineProperty_default()(_ref, "item", ""), defineProperty_default()(_ref, "dbdoc", ""), defineProperty_default()(_ref, "doc", ""), defineProperty_default()(_ref, "docIndex", ""), _ref;
  },

  methods: {
    inited: function inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      this.$log(viewer);

      this.$log("ZOOOOOM");

      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show: function show(index) {
      this.$log(this);
      var el = this.$refs["viewer" + index];

      this.$log(this.$refs);

      this.$log(el[0]);

      //const viewerV = el.$viewer

      el[0].destroyViewer();

      el[0].createViewer();

      el[0].$viewer.show();
      //viewer.zoomTo(2)
      //	viewer.move(-1, 0);
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },
    removeDocument: function removeDocument(docIndex, code, name, codice, id, index) {
      var _this = this;

      var _vue = this;

      this.$swal({
        title: "Attenzione!",
        type: "warning",
        html: "<br/>Sei sicuro di voler eliminare File " + index + " del documento " + name + " ?<br/><br/>",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        _this.$log(result);
        if (result.value) {
          _this.loadingState = true;
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/removeDocument",
            method: "POST",
            data: {
              docIndex: docIndex,
              code: code,
              name: name,
              codice: codice,
              id: id
            },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _this.$log(1);
            _this.loadingState = false;
            var obj = _vue.dbdoc["images"];

            for (var x in obj) {
              if (x == id) {
                delete obj[x];
                delete _vue.dbdoc["images"][x];
              }
            }

            _vue.dbdoc["countImages"] = _vue.dbdoc["countImages"] - 1;
          }).catch(function (resp) {
            _this.loadingState = false;
          });
        }
      });
    },
    getDocuments: function getDocuments(code, user_token) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = { code: code, user_token: user_token };

                data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 4;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getDocumentsByCode",
                  method: "POST",
                  data: {
                    data: data
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this2.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  //console.log( resp.data.documents )
                  var docs = resp.data.documents;
                  _this2.dbdoc.images = {};
                  var y = 0;
                  for (var x in docs) {
                    if (docs[x].codice == _this2.docIndex) {
                      _this2.dbdoc.images[docs[x].id] = docs[x].url;
                      _this2.dbdoc.countImages = _this2.dbdoc.countImages + 1;
                      y = y + 1;
                    }
                  }

                  //console.log( this.dbdoc )
                  //console.log( this.doc )
                  //console.log( this.docIndex )
                }).catch(function (resp) {
                  //this.savedDocuments = {}
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    uploadFile: function uploadFile(doc, code, name, docCode, completed) {
      this.$log(this.$refs["fileInput" + doc]);
      var input = this.$refs["fileInput" + doc];

      this.$log(input);

      this.$log(doc);
      this.$log(code);
      this.$log(name);
      this.$log(docCode);

      var ind = doc;
      this.$log(0);
      var file = input.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.files[0].size;
      if ((extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "pdf") && size < 2 * 10506316) {
        this.invoiceFront = input.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.files[0]);

        this.$log(this.uploadFrontPercentage);

        formData.append("doc", doc);
        formData.append("code", code);
        formData.append("name", name);
        formData.append("docCode", docCode);
        formData.append("completed", completed);

        this.$log(1);

        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + "api/uploadDocument", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            var r = 0;
            r = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
            //  Object.assign(this.uploadFrontPercentage, r)

            vue_esm["a" /* default */].set(this.dbdoc, "percent", r);

            //  this.uploadFrontPercentage[ind]['percent'] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          this.$log(2);
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.document)) {
            _vue.dbdoc["percent"] = 0;

            var x = _vue.dbdoc["images"];

            x[e.data.id] = e.data.document;

            _vue.dbdoc["images"] = x;

            _vue.dbdoc["countImages"] = _vue.dbdoc["countImages"] + 1;

            //_vue.invoiceFrontBucket = e.data.fattura
          } else {
            _vue.dbdoc["percent"] = 0;
            //_vue.invoiceFront = ''
            //_vue.invoiceFrontBucket = ''

            //input.value = null
          }
          _vue.getDocuments(_vue.item.code, _vue.item.user_token);
        }).catch(function () {
          _vue.dbdoc["percent"] = 0;
          //  _vue.invoiceFront = ''
          ///  _vue.invoiceFrontBucket = ''

          //input.value = null
        });
      }
    }
  },
  watch: {},
  created: function created() {
    var _this3 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  mounted: function mounted() {
    this.$log(this.$route.params);

    if (this.$route.params.item) {
      this.item = this.$route.params.item;
      this.dbdoc = this.$route.params.dbdoc;
      this.doc = this.$route.params.doc;
      this.docIndex = this.$route.params.docIndex;

      if (this.item && this.item.client_type != "Amministratore di condominio") {
        this.address = this.item.building_address;
        this.civic = this.item.building_civic;
      }
    } else {
      this.$router.push("/pratiche");
    }

    this.$scrollTo("#app", 700, { offset: -75 });
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4811f8f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editDocuments/index.vue
var editDocuments_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-5 pt-4" }, [
        _c("div", { staticClass: "row justify-content-center text-left" }, [
          _c("h3", { staticClass: "Regular center h0 widthFull" }, [
            _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code) + " ")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 center mb-3" }, [
            _c("h4", { staticClass: "Regular text-left h0 widthFull ml-3" }, [
              _vm._v(" Modifica Documento: "),
              _c("b", [_vm._v(" " + _vm._s(_vm.doc.name) + " ")])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black mt-0 text-left widthFull ml-3" }, [
              _vm._v(
                "\r\n          In questa pagina puoi eliminare i documenti caricati e aggiungerne di nuovi.\r\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4 pt-4 center mb-3 text-right" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                  attrs: {
                    to: { name: "loadDocuments", params: { item: _vm.item } }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "arrow-left", size: "1x" }
                  }),
                  _vm._v("\r\n          Indietro\r\n        ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "pb-5 pt-3 black widthFull vaillantCont",
            attrs: { id: "doc-form" }
          },
          [
            _c(
              "div",
              { staticClass: "row justify-content-center text-left pl-4 pr-4" },
              [
                _c("div", { staticClass: "col-md-8 center mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._l(_vm.dbdoc.images, function(url, key, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-6 col-md-4 center mb-5"
                          },
                          [
                            _c("p", { staticClass: "pb-1 mb-1" }, [
                              _vm._v("File " + _vm._s(index + 1) + " ")
                            ]),
                            _vm._v(" "),
                            _c(
                              "viewer",
                              {
                                ref: "viewer" + key,
                                refInFor: true,
                                staticClass: " clearfix widthFull",
                                on: { inited: _vm.inited }
                              },
                              [
                                _c("img", {
                                  key: key,
                                  staticClass: "img-fluid editImageCont",
                                  attrs: { src: url }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-xl mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.show(key)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "eye", size: "sm" }
                                }),
                                _vm._v(" Visualizza\r\n              ")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-xl  mt-3",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeDocument(
                                      _vm.docIndex,
                                      _vm.item.code,
                                      _vm.doc.name,
                                      _vm.doc.codice,
                                      key,
                                      index
                                    )
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash-alt", size: "sm" }
                                }),
                                _vm._v(" Elimina\r\n              ")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4 center mb-3 even" }, [
                  _c(
                    "div",
                    { staticClass: "row justify-content-center text-left" },
                    [
                      _c("div", { staticClass: "col-md-12 center mb-3" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "front-image" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required: false,
                                  size: 2 * 10240,
                                  ext: ["jpeg", "jpg", "png", "pdf"],
                                  mimes: [
                                    "image/jpeg",
                                    "image/jpg",
                                    "image/png",
                                    "application/pdf"
                                  ]
                                },
                                expression:
                                  "{required:false,size: 2*10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                              }
                            ],
                            ref: "fileInput" + _vm.docIndex,
                            staticClass: "fileInput",
                            class: {
                              "is-invalid": _vm.errors.has("invoiceFront"),
                              valid: !!_vm.invoiceFront,
                              helper: !!_vm.invoiceFrontBucket
                            },
                            attrs: {
                              type: "file",
                              name: "invoiceFront",
                              id: "invoiceFront",
                              "data-vv-as": "Logo"
                            },
                            on: {
                              change: function($event) {
                                return _vm.uploadFile(
                                  _vm.docIndex,
                                  _vm.item.code,
                                  _vm.doc.name,
                                  _vm.doc.codice,
                                  _vm.dbdoc.completed
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel labelFileInput",
                              attrs: { for: "invoiceFront" }
                            },
                            [
                              !_vm.invoiceFrontName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "smallText center white mt-3 mb-0 pb-0"
                                            },
                                            [
                                              _vm._v(
                                                "Scegli il Contratto quadro*"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c("span", {
                                    staticClass: "smallText center white",
                                    style: {
                                      backgroundImage:
                                        "url(" + _vm.invoiceFrontBucket + ")"
                                    }
                                  })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("invoiceFront")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n                  " +
                                    _vm._s(_vm.errors.first("invoiceFront")) +
                                    "\r\n                "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dbdoc.percent
                            ? _c(
                                "div",
                                {
                                  staticClass: "progress mt-5",
                                  attrs: { id: "progFront" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "progress-bar ",
                                      style: { width: _vm.dbdoc.percent + "%" },
                                      attrs: {
                                        id: "progress-bar-front",
                                        role: "progressbar",
                                        "aria-valuenow": "50",
                                        "aria-valuemin": "0",
                                        "aria-valuemax": "100"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\r\n                    " +
                                          _vm._s(_vm.dbdoc.percent) +
                                          " %\r\n                  "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceFrontName
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                },
                                [_vm._v(_vm._s(_vm.invoiceFrontName))]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ]
                  )
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var editDocuments_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-3" }, [
      _c("h5", { staticClass: "Regular" }, [_c("b", [_vm._v("File caricati")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "Regular" }, [
      _c("b", [_vm._v("Carica nuovo File")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 center mt-5 mb-3" }, [
      _c("small", [
        _vm._v(
          "\r\n                Il documento può essere caricato nei formati jpeg, pdf, png, jpg (max 10MB)\r\n              "
        )
      ])
    ])
  }
]
editDocuments_render._withStripped = true
var editDocuments_esExports = { render: editDocuments_render, staticRenderFns: editDocuments_staticRenderFns }
/* harmony default export */ var components_editDocuments = (editDocuments_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4811f8f1", editDocuments_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/editDocuments/index.vue
var editDocuments_disposed = false
function editDocuments_injectStyle (ssrContext) {
  if (editDocuments_disposed) return
  __webpack_require__("ZDvS")
}
var editDocuments_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var editDocuments___vue_template_functional__ = false
/* styles */
var editDocuments___vue_styles__ = editDocuments_injectStyle
/* scopeId */
var editDocuments___vue_scopeId__ = "data-v-4811f8f1"
/* moduleIdentifier (server only) */
var editDocuments___vue_module_identifier__ = null
var editDocuments_Component = editDocuments_normalizeComponent(
  editDocuments,
  components_editDocuments,
  editDocuments___vue_template_functional__,
  editDocuments___vue_styles__,
  editDocuments___vue_scopeId__,
  editDocuments___vue_module_identifier__
)
editDocuments_Component.options.__file = "src/components/editDocuments/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4811f8f1", editDocuments_Component.options)
  } else {
    hotAPI.reload("data-v-4811f8f1", editDocuments_Component.options)
  }
  module.hot.dispose(function (data) {
    editDocuments_disposed = true
  })
})()}

/* harmony default export */ var src_components_editDocuments = (editDocuments_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/confirm/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: "confirm",
  components: {},
  data: function data() {
    return {
      result: "Verifica Token",
      status: false,
      loading: false,
      corporateClient: ''
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      var token = this.$route.query.token;
      if (token) {
        this.loading = true;
        var data = {
          token: token
        };
        data = this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + "fapi/confirmAccount",
          data: { data: data },
          method: "POST",
          headers: {
            Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            "Content-type": "application/json"
          }
        }).then(function (resp) {
          resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
          _this.corporateClient = resp.data.user.corporateClient;
          _this.status = true;
          _this.loading = false;
          if (_this.corporateClient != 'hoval') {
            _this.result = "Il tuo account è stato attivato.";
          } else {
            _this.result = "Hai correttamente confermato la tua email, non appena il tuo account verrá verificato riceverai una email di conferma.";
          }
        }).catch(function (resp) {
          _this.loading = false;
          _this.result = "Token non presente";
        });
      } else {
        this.result = "Token non presente";
      }
    }
  },
  beforeMount: function beforeMount() {
    this.confirm();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0a1213a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirm/index.vue
var confirm_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container whiteCont mt-5 mb-5" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center verticalCentred" },
          [
            _c("div", { staticClass: "col-6 mt-5 pt-5" }, [
              _c(
                "h2",
                {
                  staticClass: "mb-5 center",
                  attrs: { type: "text" },
                  model: {
                    value: _vm.result,
                    callback: function($$v) {
                      _vm.result = $$v
                    },
                    expression: "result"
                  }
                },
                [_vm._v(_vm._s(_vm.result))]
              ),
              _vm._v(" "),
              _vm.status
                ? _c(
                    "div",
                    { staticClass: "mt-5 center" },
                    [
                      _vm.corporateClient != "hoval"
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary btn-lg",
                              attrs: { to: "/login" }
                            },
                            [_vm._v("Accedi")]
                          )
                        : _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary btn-lg",
                              attrs: { to: "/" }
                            },
                            [_vm._v("Home")]
                          )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        )
      ])
    ],
    1
  )
}
var confirm_staticRenderFns = []
confirm_render._withStripped = true
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_confirm = (confirm_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0a1213a", confirm_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/confirm/index.vue
var confirm_disposed = false
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = null
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  components_confirm,
  selectortype_template_index_0_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)
confirm_Component.options.__file = "src/components/confirm/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0a1213a", confirm_Component.options)
  } else {
    hotAPI.reload("data-v-c0a1213a", confirm_Component.options)
  }
  module.hot.dispose(function (data) {
    confirm_disposed = true
  })
})()}

/* harmony default export */ var src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forgotpassword/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var forgotpassword = ({
	name: 'forgotpassword',
	components: {},
	data: function data() {
		return {
			username: '',
			state: false,
			error: '',
			loading: false
		};
	},

	methods: {
		forgot: function forgot() {
			var _this = this;

			var username = this.username;

			this.$validator.validate().then(function (valid) {
				if (valid) {
					_this.loading = true;
					axios_default()({
						url: "https://wsbot.eu/ebonusBack/public/" + 'fapi/send_forgot_pass_email',
						data: {
							email: username
						},
						method: 'POST',
						headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
						if (resp.data.error == "") {
							_this.state = true;
						}
						if (resp.data.error == "email_not_present") {
							_this.state = false;
							_this.error = "Indirizzo e-mail non presente in nostra sistema";
						}

						if (resp.data.error == "account_not_confirmed" && _this.c) {
							_this.state = false;
							_this.error = 'Attenzione! Non hai confermato il tuo account';
						}
						_this.loading = false;
					}).catch(function (resp) {
						_this.state = false;
						_this.error = "Indirizzo e-mail non presente in nostra sistema";
						_this.loading = false;
					});
				}
			});
		}
	},
	computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
		//login_error: state => `${state.login_error}`,
	}))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea681d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgotpassword/index.vue
var forgotpassword_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5 mb-5" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9 col-md-5 pt-4" }, [
            _c(
              "form",
              {
                staticClass: "forgot-password mt-3 vaillantCont pt-4 pb-4",
                attrs: { id: "forgot-form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.forgot($event)
                  }
                }
              },
              [
                !_vm.state
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.username,
                                    expression: "username"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      email: true,
                                      temporaryEmail: true,
                                      plusIssueEmail: true,
                                      max: 56
                                    },
                                    expression:
                                      "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("username"),
                                  valid: !!_vm.username
                                },
                                attrs: {
                                  type: "text",
                                  id: "username",
                                  name: "username",
                                  "data-vv-as": "Email"
                                },
                                domProps: { value: _vm.username },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.username = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "username" }
                                },
                                [_vm._v("Email")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("username")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.errors.first("username")) +
                                          "\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.error
                                ? _c("div", { staticClass: "mb-3 text-left" }, [
                                    _c(
                                      "span",
                                      { staticClass: "errorMes ml-1" },
                                      [_vm._v(_vm._s(_vm.error))]
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  : _c("div", [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary btn-lg mt-4",
                                  attrs: { to: "/" }
                                },
                                [_vm._v("Continua")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var forgotpassword_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 col-md-12" }, [
      _c("h3", { staticClass: "Bold center pt-5 widthFull" }, [
        _c("strong", [_vm._v("Recupero Password")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c(
        "label",
        { staticClass: "widthFull text-center", attrs: { for: "email" } },
        [
          _c("h5", { staticClass: "Regular black widthFull text-center" }, [
            _vm._v(
              "Inserisci l'indirizzo email che hai inserito in fase di registrazione, e clicca Invia"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "Regular black widthFull text-center mt-3" }, [
            _vm._v(
              "Ti sarà inviata una email con il link per recuperare la tua password."
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-3 mt-3 text-center " }, [
        _c(
          "button",
          { staticClass: "btn btn-primary btm-lg", attrs: { type: "submit" } },
          [_vm._v("Invia")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-3 mt-3" }, [
        _c(
          "h5",
          {
            staticClass: "center pl-4 pr-4",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", { staticClass: "black" }, [
              _vm._v(
                "Ti è stata inviata una mail con il link per reimpostare la tua password di accesso,controlla nella tua posta in arrivo."
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black" }, [
              _vm._v(
                "Se non dovessi trovarla controlla anche nella casella spam."
              )
            ])
          ]
        )
      ])
    ])
  }
]
forgotpassword_render._withStripped = true
var forgotpassword_esExports = { render: forgotpassword_render, staticRenderFns: forgotpassword_staticRenderFns }
/* harmony default export */ var components_forgotpassword = (forgotpassword_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea681d1", forgotpassword_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/forgotpassword/index.vue
var forgotpassword_disposed = false
var forgotpassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var forgotpassword___vue_template_functional__ = false
/* styles */
var forgotpassword___vue_styles__ = null
/* scopeId */
var forgotpassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var forgotpassword___vue_module_identifier__ = null
var forgotpassword_Component = forgotpassword_normalizeComponent(
  forgotpassword,
  components_forgotpassword,
  forgotpassword___vue_template_functional__,
  forgotpassword___vue_styles__,
  forgotpassword___vue_scopeId__,
  forgotpassword___vue_module_identifier__
)
forgotpassword_Component.options.__file = "src/components/forgotpassword/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ea681d1", forgotpassword_Component.options)
  } else {
    hotAPI.reload("data-v-5ea681d1", forgotpassword_Component.options)
  }
  module.hot.dispose(function (data) {
    forgotpassword_disposed = true
  })
})()}

/* harmony default export */ var src_components_forgotpassword = (forgotpassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recoverypassword/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var recoverypassword = ({
	name: 'recoverypassword',
	components: {},
	data: function data() {
		return {
			password: '',
			confirm_password: '',
			state: false,
			error: '',
			loading: false,
			first: false
		};
	},

	methods: {
		recovery: function recovery() {
			var _this = this;

			var password = this.password,
			    confirm_password = this.confirm_password;

			var token = this.$route.query.token;

			this.$validator.validate().then(function (valid) {
				if (valid && token) {
					_this.loading = true;
					if (!_this.$route.query.corporateClient) {
						var data = {
							password: password,
							token: token
						};
					} else {
						var data = {
							password: password,
							token: _this.$decryptByAES(token, "B%t$AD!YMfnCZnfD"),
							corporateClient: _this.$decryptByAES(_this.$route.query.corporateClient, "B%t$AD!YMfnCZnfD")
						};
					}
					data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
					axios_default()({
						url: "https://wsbot.eu/ebonusBack/public/" + 'fapi/change_password',
						data: { data: data },
						method: 'POST',
						headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
						_this.state = true;
						_this.loading = false;
					}).catch(function (resp) {
						_this.state = false;
						_this.error = "Il token scaduto o non presente";
						_this.loading = false;
					});
				}
			});
		}
	},
	mounted: function mounted() {
		if (this.$route.query.corporateClient) {
			this.first = true;
		}
	},
	computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
		//login_error: state => `${state.login_error}`,
	}))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264227c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recoverypassword/index.vue
var recoverypassword_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 pt-5" },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-5 mb-5" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-12 center " }, [
            !_vm.first
              ? _c(
                  "h3",
                  {
                    staticClass:
                      "Bold center pt-5 mt-5 pb-4 subtitle fancy widthFull"
                  },
                  [_c("strong", [_vm._v("Reimposta Password")])]
                )
              : _c(
                  "h3",
                  {
                    staticClass:
                      "Bold center pt-5 mt-5 pb-4 subtitle fancy widthFull"
                  },
                  [
                    _c("strong", [
                      _vm._v(
                        "Prima di effettuare il login modifica la password fornita"
                      )
                    ])
                  ]
                )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row justify-content-center verticalCentred" },
          [
            _c("div", { staticClass: "col-sm-9 col-md-5 pt-4 " }, [
              _c("div", { staticClass: "container-fluid" }, [
                _c(
                  "form",
                  {
                    staticClass: "recovery-password vaillantCont pb-4",
                    attrs: { id: "recovery-form" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.recovery($event)
                      }
                    }
                  },
                  [
                    !_vm.state
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-row justify-content-center" },
                            [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c(
                                  "div",
                                  { staticClass: "group custInput mt-5" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.password,
                                          expression: "password"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            passwordCheck: true,
                                            min: 8,
                                            max: 56
                                          },
                                          expression:
                                            "{required:true, passwordCheck: true, min: 8, max: 56}"
                                        }
                                      ],
                                      staticClass: "form-control mt-1",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "password"
                                        ),
                                        valid: !!_vm.password
                                      },
                                      attrs: {
                                        type: "password",
                                        id: "password",
                                        name: "password"
                                      },
                                      domProps: { value: _vm.password },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.password = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: { for: "password" }
                                      },
                                      [_vm._v("Nuova Password")]
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("password")
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.errors.first("password")
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "group custInput mt-5" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.confirm_password,
                                          expression: "confirm_password"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: true,
                                            passwordCheck: true,
                                            min: 8,
                                            max: 56
                                          },
                                          expression:
                                            "{required:true, passwordCheck: true, min: 8, max: 56}"
                                        }
                                      ],
                                      staticClass: "form-control mt-3",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "confirm_password"
                                        ),
                                        valid: !!_vm.confirm_password
                                      },
                                      attrs: {
                                        type: "password",
                                        id: "confirm_password",
                                        name: "confirm_password",
                                        "data-vv-as": "conferma password"
                                      },
                                      domProps: { value: _vm.confirm_password },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.confirm_password =
                                            $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "highlight" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "bar" }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "niceInputLabel",
                                        attrs: { for: "password" }
                                      },
                                      [_vm._v("Conferma Nuova Password")]
                                    ),
                                    _vm._v(" "),
                                    _vm.errors.has("confirm_password")
                                      ? _c(
                                          "div",
                                          { staticClass: "invalid-feedback" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.errors.first(
                                                    "confirm_password"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.error
                                      ? _c("div", { staticClass: "mt-3" }, [
                                          _c(
                                            "span",
                                            { staticClass: "formError ml-1" },
                                            [_vm._v(_vm._s(_vm.error))]
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(0)
                        ])
                      : _c("div", [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-row justify-content-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-12 mb-3 text-center" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-primary btn-lg",
                                      attrs: { to: "/login" }
                                    },
                                    [_vm._v("Accedi")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ])
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var recoverypassword_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-3 mt-5 text-center" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary  btn-lg", attrs: { type: "submit" } },
          [_vm._v("CONFERMA")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-5 mt-5" }, [
        _c(
          "h5",
          {
            staticClass: "center widthFull",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", { staticClass: "black" }, [
              _vm._v("La password è stata aggiornata correttamente,")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black" }, [
              _vm._v("adesso puoi accedere utilizzando la tua nuova password..")
            ])
          ]
        )
      ])
    ])
  }
]
recoverypassword_render._withStripped = true
var recoverypassword_esExports = { render: recoverypassword_render, staticRenderFns: recoverypassword_staticRenderFns }
/* harmony default export */ var components_recoverypassword = (recoverypassword_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264227c3", recoverypassword_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/recoverypassword/index.vue
var recoverypassword_disposed = false
var recoverypassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recoverypassword___vue_template_functional__ = false
/* styles */
var recoverypassword___vue_styles__ = null
/* scopeId */
var recoverypassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recoverypassword___vue_module_identifier__ = null
var recoverypassword_Component = recoverypassword_normalizeComponent(
  recoverypassword,
  components_recoverypassword,
  recoverypassword___vue_template_functional__,
  recoverypassword___vue_styles__,
  recoverypassword___vue_scopeId__,
  recoverypassword___vue_module_identifier__
)
recoverypassword_Component.options.__file = "src/components/recoverypassword/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-264227c3", recoverypassword_Component.options)
  } else {
    hotAPI.reload("data-v-264227c3", recoverypassword_Component.options)
  }
  module.hot.dispose(function (data) {
    recoverypassword_disposed = true
  })
})()}

/* harmony default export */ var src_components_recoverypassword = (recoverypassword_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/showProducts/index.vue
var showProducts = __webpack_require__("UqUd");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7191a0d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/showProducts/index.vue
var showProducts_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullWidth logo center", attrs: { id: "report" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "constainer-fluid dataContainer " },
        [
          _c("div", { staticClass: "row justify-content-center " }, [
            _c("h1", { staticClass: "Peace center violet widthFull" }, [
              _vm._v("Prodotti Caricati")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-9" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c(
                "form",
                {
                  staticClass: "form-inline d-flex mx-1 justify-content-end",
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.doSearch($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quickSearch,
                          expression: "quickSearch"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "search", placeholder: "Cerca" },
                      domProps: { value: _vm.quickSearch },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quickSearch = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("vdtnet-table", {
            ref: "table",
            attrs: {
              fields: _vm.fields,
              url: _vm.url,
              opts: _vm.options,
              "select-checkbox": 0,
              "container-classname": ""
            },
            on: {
              edit: _vm.doAlertEdit,
              reloaded: _vm.doAfterReload,
              "table-creating": _vm.doCreating,
              "table-created": _vm.doCreated
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var showProducts_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c(
        "button",
        { staticClass: "btn btn-outline-secondary", attrs: { type: "submit" } },
        [
          _c("i", { staticClass: "mdi mdi-magnify" }),
          _vm._v(" Go\n              ")
        ]
      )
    ])
  }
]
showProducts_render._withStripped = true
var showProducts_esExports = { render: showProducts_render, staticRenderFns: showProducts_staticRenderFns }
/* harmony default export */ var components_showProducts = (showProducts_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7191a0d4", showProducts_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/showProducts/index.vue
var showProducts_disposed = false
function showProducts_injectStyle (ssrContext) {
  if (showProducts_disposed) return
  __webpack_require__("DjRw")
}
var showProducts_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var showProducts___vue_template_functional__ = false
/* styles */
var showProducts___vue_styles__ = showProducts_injectStyle
/* scopeId */
var showProducts___vue_scopeId__ = "data-v-7191a0d4"
/* moduleIdentifier (server only) */
var showProducts___vue_module_identifier__ = null
var showProducts_Component = showProducts_normalizeComponent(
  showProducts["a" /* default */],
  components_showProducts,
  showProducts___vue_template_functional__,
  showProducts___vue_styles__,
  showProducts___vue_scopeId__,
  showProducts___vue_module_identifier__
)
showProducts_Component.options.__file = "src/components/showProducts/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7191a0d4", showProducts_Component.options)
  } else {
    hotAPI.reload("data-v-7191a0d4", showProducts_Component.options)
  }
  module.hot.dispose(function (data) {
    showProducts_disposed = true
  })
})()}

/* harmony default export */ var src_components_showProducts = (showProducts_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pratiche/index.vue






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var pratiche_moment = __webpack_require__("PJh5");

/* harmony default export */ var pratiche = ({
  name: "Practics",
  components: {
    BadgerAccordion: vue_badger_accordion["a" /* BadgerAccordion */],
    BadgerAccordionItem: vue_badger_accordion["b" /* BadgerAccordionItem */],
    VueSvgGauge: vue_svg_gauge["VueSvgGauge"]
  },
  data: function data() {
    var _ref;

    return _ref = {
      token: "",
      corporateClient: "",
      loadingState: false,
      loading: false,
      practices: {},
      countloop: 1,
      moment: __webpack_require__("PJh5"),
      presentPractices: true,
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: ""
    }, defineProperty_default()(_ref, "presentPractices", true), defineProperty_default()(_ref, "moment", __webpack_require__("PJh5")), defineProperty_default()(_ref, "maxTotCash", 1000000), defineProperty_default()(_ref, "totCash", 0), defineProperty_default()(_ref, "step", 1000), defineProperty_default()(_ref, "hasPrev", false), defineProperty_default()(_ref, "showFilterText", false), defineProperty_default()(_ref, "countErrorPractice", 0), defineProperty_default()(_ref, "totErrorCashClient", 0), defineProperty_default()(_ref, "totErrorCashInst", 0), defineProperty_default()(_ref, "countStep1Practice", 0), defineProperty_default()(_ref, "totStep1CashClient", 0), defineProperty_default()(_ref, "totStep1CashInst", 0), defineProperty_default()(_ref, "countStep2Practice", 0), defineProperty_default()(_ref, "totStep2CashClient", 0), defineProperty_default()(_ref, "totStep2CashInst", 0), defineProperty_default()(_ref, "countStep3Practice", 0), defineProperty_default()(_ref, "totStep3CashClient", 0), defineProperty_default()(_ref, "totStep3CashInst", 0), defineProperty_default()(_ref, "countStep4Practice", 0), defineProperty_default()(_ref, "totStep4CashClient", 0), defineProperty_default()(_ref, "totStep4CashInst", 0), defineProperty_default()(_ref, "totUserReceived", 0), defineProperty_default()(_ref, "totAmountBefore10", 0), defineProperty_default()(_ref, "totAmountAfter10", 0), defineProperty_default()(_ref, "hasRemovedPractics", false), _ref;
  },

  methods: {
    checkEneaComplate: function checkEneaComplate(val) {
      if (val) {
        if (val.includes('"status":"success"')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getPractices: function getPractices() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var _vue, token, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _vue = _this;


                _vue.totUserReceived = _this.adminIs ? _vue.getProfile.total_bonus_received : "";

                _this.loadingState = true;

                token = !_this.adminIs ? _vue.getProfile.userToken : _this.AdminId;

                if (!token) {
                  _context.next = 9;
                  break;
                }

                data = {
                  type: "all",
                  user_token: token,
                  call: _this.adminIs
                };

                data = _this.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
                _context.next = 9;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/getPractices",
                  method: "POST",
                  data: { data: data },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  resp.data = _this.$decryptByAES(resp.data, "B%t$AD!YMfnCZnfD");
                  _vue.practices = resp.data.practices;

                  _this.$log(_vue.practices);

                  _vue.totCash = 0;
                  _vue.countPractices = 0;
                  _vue.countCashInst = 0;
                  _vue.countCashClient = 0;

                  // ERRORS
                  _vue.countErrorPractice = 0;
                  _vue.totErrorCashClient = 0;
                  _vue.totErrorCashInst = 0;
                  // STEP 1
                  _vue.countStep1Practice = 0;
                  _vue.totStep1CashClient = 0;
                  _vue.totStep1CashInst = 0;
                  // STEP 2
                  _vue.countStep2Practice = 0;
                  _vue.totStep2CashClient = 0;
                  _vue.totStep2CashInst = 0;
                  // STEP 3
                  _vue.countStep3Practice = 0;
                  _vue.totStep3CashClient = 0;
                  _vue.totStep3CashInst = 0;
                  // STEP 4
                  _vue.countStep4Practice = 0;
                  _vue.totStep4CashClient = 0;
                  _vue.totStep4CashInst = 0;

                  // NEWWWWWW

                  for (var x in _vue.practices) {
                    if (_vue.practices[x].status != "10") {
                      _vue.countPractices++;
                      _vue.totCash = (parseFloat(_vue.totCash) + parseFloat(_vue.practices[x].total_work_and_iva)).toFixed(2);
                      //_vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                      _vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_bonus_savings)).toFixed(2);

                      // NEWWWWWW

                      _vue.totAmountBefore10 = (parseFloat(_vue.totAmountBefore10) + parseFloat(_vue.practices[x].amount_before_10)).toFixed(2);
                      _vue.totAmountAfter10 = (parseFloat(_vue.totAmountAfter10) + parseFloat(_vue.practices[x].amount_after_10)).toFixed(2);

                      _vue.countCashClient = (parseFloat(_vue.countCashClient) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                      _this.$log(1);
                      if (_vue.practices[x].hasErrors == "yes") {
                        _this.$log(22);
                        _vue.countErrorPractice = _vue.countErrorPractice + 1;
                        _vue.totErrorCashClient = (parseFloat(_vue.countErrorPractice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                        _vue.totErrorCashInst = (parseFloat(_vue.totErrorCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      }

                      if (_vue.practices[x].status == "1") {
                        _vue.countStep1Practice = _vue.countStep1Practice + 1;
                        _vue.totStep1CashClient = (parseFloat(_vue.countStep1Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                        _vue.totStep1CashInst = (parseFloat(_vue.totStep1CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      }

                      if (_vue.practices[x].status == "2") {
                        _vue.countStep2Practice = _vue.countStep2Practice + 1;
                        _vue.totStep2CashClient = (parseFloat(_vue.countStep2Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                        _vue.totStep2CashInst = (parseFloat(_vue.totStep2CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      }

                      if (_vue.practices[x].status == "3") {
                        _vue.countStep3Practice = _vue.countStep3Practice + 1;
                        _vue.totStep3CashClient = (parseFloat(_vue.countStep3Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                        _vue.totStep3CashInst = (parseFloat(_vue.totStep3CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      }

                      if (_vue.practices[x].status == "4") {
                        _vue.countStep4Practice = _vue.countStep4Practice + 1;
                        _vue.totStep4CashClient = (parseFloat(_vue.countStep4Practice) + parseFloat(_vue.practices[x].total_transfer_for_client)).toFixed(2);
                        _vue.totStep4CashInst = (parseFloat(_vue.totStep4CashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2);
                      }
                    }

                    if (_vue.practices[x].status == "10") {
                      _vue.hasRemovedPractics = true;
                    }

                    _this.$log(333);
                  }

                  _vue.totAmountAfter10 = (parseFloat(_vue.totAmountAfter10) - parseFloat(_vue.totUserReceived)).toFixed(2);

                  _this.totCash = parseFloat(_this.totCash);
                  if (_this.totCash < 10000) {
                    _this.maxTotCash = 10000;
                    _this.step = 1000;
                  } else if (_this.totCash < 100000) {
                    _this.maxTotCash = 100000;
                    _this.step = 10000;
                  } else if (_this.totCash < 1000000) {
                    _this.maxTotCash = 1000000;
                    _this.step = 100000;
                  } else if (_this.totCash < 100000000) {
                    _this.maxTotCash = 100000000;
                    _this.step = 1000000;
                  }
                  _vue.practicesFiltred = _vue.practices;
                  _this.$warn(_vue.practicesFiltred);

                  _this.$log(4444);

                  _vue.loadingState = false;
                }).catch(function (resp) {
                  _this.$log("errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor");
                  _vue.presentPractices = false, _vue.loadingState = false;
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!"
      });
    },
    filterValues: function filterValues() {
      var text = this.filter.toLowerCase();
      this.showFilterText = false;
      this.$log(text);
      var bank = {};
      var z = 0;

      assign_default()(this.practicesFiltred, {});

      if (text == "step1" || text == "step2" || text == "step3" || text == "step4") {
        for (var x in this.practices) {
          if (this.practices[x].status.toLowerCase() == text.replace("step", "")) {
            bank[x] = this.practices[x];
            z = z + 1;
          }
        }
      } else if (text == "pratiche con anomalie") {
        for (var x in this.practices) {
          if (this.practices[x].hasErrors == "yes") {
            bank[x] = this.practices[x];
            z = z + 1;
          }
        }
      } else {
        for (var x in this.practices) {
          this.$log(this.practices[x].hasErrors);
          if ((this.practices[x].code.toLowerCase().includes(text) || this.practices[x].client_lastname.toLowerCase().includes(text) || this.practices[x].azienda_user.toLowerCase().includes(text) || this.practices[x].partita_iva_user.toLowerCase().includes(text) || this.practices[x].client_name.toLowerCase().includes(text) || this.practices[x].building_city.toLowerCase().includes(text)) && this.practices[x].status != "10") {
            bank[x] = this.practices[x];
            z = z + 1;
          }
        }
      }
      this.countloop = this.countloop + 1;
      this.$log(z);
      this.$log(bank);
      this.practicesFiltred = bank;

      if (z == 0) {
        this.showFilterText = true;
      } else {
        this.showFilterText = false;
      }
    },
    removePractice: function removePractice(id, code, key) {
      var _this2 = this;

      var id_order = id;
      var _vue = this;

      this.$swal({
        title: "Attenzione!",
        type: "warning",
        html: "<br/>Sei sicuro di voler eliminare Pratica N. " + code + "?<br/><br/>",
        showCancelButton: true,
        confirmButtonText: "SI",
        cancelButtonText: "NO"
      }).then(function (result) {
        /* Read more about isConfirmed, isDenied below */
        _this2.$log(result);
        if (result.value) {
          var data = {
            id: id,
            user_token: _vue.getProfile.userToken,
            status: 10
          };
          data = _this2.$encryptByAES(stringify_default()(data), "B%t$AD!YMfnCZnfD");
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + "api/changeOrderState",
            method: "POST",
            data: { data: data },
            headers: {
              Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              "Content-type": "application/json"
            }
          }).then(function (resp) {
            _vue.getPractices();
            _vue.$swal("Pratica N. " + code + " <br/>è stato eliminata ", "", "success");
          }).catch(function (resp) {
            _vue.$swal("Ops. Riprova piu tardi", "", "error");
          });
        }
      });
    },
    checkBonusValues: function checkBonusValues() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var _vue, token;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _vue = _this3;

                _this3.loadingState = true;
                token = !_this3.adminIs ? _vue.getProfile.userToken : _this3.AdminId;
                _context2.next = 5;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + "api/checkBonusValues",
                  method: "POST",
                  data: {
                    user_token: token,
                    call: _this3.adminIs
                  },
                  headers: {
                    Authorization: "Bearer " + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    "Content-type": "application/json"
                  }
                }).then(function (resp) {
                  _this3.loadingState = false;
                }).catch(function (resp) {
                  _this3.loadingState = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },

    setProfile: function setProfile() {
      //type 1 => no preventivatore
      if (this.profile.type == 1) {
        this.hasPrev = false;
      }
      if (this.profile.status == "admin") {
        this.adminIs = true;
        this.AdminId = this.profile.id;
        this.flagForCheck = this.profile.type;
      } else if (this.profile.status == "user") {
        this.adminIs = false;
        this.flagForCheck = this.profile.type;
      }
    }
  },
  watch: {
    getProfile: function getProfile(val) {

      this.corporateClient = this.getProfile.corporateClient;
      if (val) {
        this.$log(val);
        this.setProfile();
        this.getPractices();
      }
    },
    filter: function filter(val) {
      this.filterValues();
    }
  },

  mounted: function mounted() {
    var x = {
      0: {
        text: "Carta Identita non legibile",
        document: "4sg233"
      },
      1: {
        text: "Codice Fiscale non legibile",
        document: "4sg233"
      }
    };
    this.setProfile();
    x = stringify_default()(x);
    this.$log(x);

    if (this.getProfile) {
      this.corporateClient = this.getProfile.corporateClient;
      this.getPractices();
    }

    this.$scrollTo("#app", 700, {
      offset: -75
    });
  },
  created: function created() {
    this.setProfile();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(["getProfile", "loginerror", "isAuthenticated", "isProfileLoaded", "authStatus"]), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    },
    managedArea: function managedArea(state) {
      return state.user.profile.type;
    }
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe741b42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pratiche/index.vue
var pratiche_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mt-5 pt-4" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.presentPractices && _vm.hasPrev
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("\n        Non hai preventivi accettati\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/offerte" }
                  },
                  [_vm._v("Gestione Preventivi")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.presentPractices && !_vm.hasPrev
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
              },
              [
                _c("h4", { staticClass: "black center widthFull mt-4" }, [
                  _vm._v("\n        Non creato ancora nessuna pratica\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary btn-lg btnYellow mt-2",
                    attrs: { to: "/calcolatore" }
                  },
                  [_vm._v("Crea Pratica")]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-content-center pb-3 pt-3 align-items-end"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "\n          col-4 col-md-3\n          pb-0\n          pl-1\n          pr-1\n          pl-md-5\n          pr-md-5\n          d-none d-md-block\n        "
                  },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.countCashClient),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        _vm.countCashClient
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Fatturato verso Clienti")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-5 col-md-3 pb-0 pr-0 pl-0" },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value: parseFloat(_vm.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(_vm.countCashInst)
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Credito Totale")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "\n          col-4 col-md-3\n          center\n          pl-1\n          pr-1\n          pl-md-5\n          pr-md-5\n          d-none d-md-block\n        "
                  },
                  [
                    _vm.totCash
                      ? _c(
                          "VueSvgGauge",
                          {
                            attrs: {
                              "start-angle": -90,
                              "end-angle": 90,
                              value:
                                parseFloat(_vm.countCashClient) +
                                parseFloat(_vm.countCashInst),
                              "separator-step": _vm.step,
                              min: 0,
                              innerRadius: 70,
                              separatorThickness: 1,
                              max: _vm.maxTotCash,
                              "gauge-color": [
                                { offset: 0, color: "#f39324" },
                                { offset: 100, color: "#00897e" }
                              ],
                              "scale-interval": 100
                            }
                          },
                          [
                            _c("div", { staticClass: "gaugeText" }, [
                              _c("p", { staticClass: "widhtFull pt-5 mt-2" }, [
                                _vm._v("€")
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatNumber")(
                                        parseFloat(_vm.countCashClient) +
                                          parseFloat(_vm.countCashInst)
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "widhtFull" }, [
                                _c("small", [_vm._v("Fatturato Totale")])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3" }, [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.filterValues($event)
                        }
                      }
                    },
                    [
                      _c("h5", { staticClass: "text-center grey pb-0 mb-0" }, [
                        _vm._v("Ricerca Pratica")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filter,
                              expression: "filter"
                            }
                          ],
                          staticClass: "form-control seachMobButton",
                          attrs: {
                            type: "text",
                            placeholder: "Numero Pratica o Cognome..."
                          },
                          domProps: { value: _vm.filter },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.filter = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group-append d-none" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.filterValues($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                CERCA\n              "
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices && _vm.hasPrev
          ? _c(
              "div",
              {
                staticClass:
                  "\n        row\n        mr-0\n        ml-0\n        justify-content-center\n        pb-0\n        pt-0\n        align-items-end\n        bgWhite\n        mb-3\n      "
              },
              [
                _c("div", { staticClass: "col-6 col-md-3 center Bold" }, [
                  _c("h5", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.totUserReceived)) +
                          " €"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Credito Ceduto*")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3 center Bold" }, [
                  _c("h5", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.totAmountBefore10)) +
                          " €"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Credito in maturazione")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 col-md-3 center Bold" }, [
                  _c("h5", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm._f("formatNumber")(_vm.totAmountAfter10)) +
                          " €"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Credito Cedibile*")])
                ]),
                _vm._v(" "),
                _vm._m(1)
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.presentPractices
          ? _c(
              "div",
              {
                staticClass: "row justify-content-center align-items-end mt-5"
              },
              [
                _c(
                  "div",
                  { staticClass: "col-4 col-md-2 text-center text-md-left" },
                  [
                    _c(
                      "div",
                      { staticClass: "buttonTextCont widthfull lightRight" },
                      [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [_c("b", [_vm._v(_vm._s(_vm.countErrorPractice))])]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-danger btn-sm uppercase widthFull",
                        on: {
                          click: function($event) {
                            _vm.filter = "Pratiche con Anomalie"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "exclamation-triangle", size: "sm" }
                        }),
                        _c("span", { staticClass: "d-none d-md-inline" }, [
                          _vm._v("\n            Con Anomalie")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-4 col-md-2 text-left text-center text-md-left"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "buttonTextCont widthfull lightGreen" },
                      [
                        _c(
                          "h1",
                          { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                          [_c("b", [_vm._v(_vm._s(_vm.countPractices))])]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-primary btn-blue btn-sm uppercase widthFull",
                        on: {
                          click: function($event) {
                            _vm.filter = ""
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "white",
                          attrs: { icon: "clipboard-list", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "d-none d-md-inline white" },
                          [_vm._v(" Tutte le pratiche")]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-4 col-4 col-md-2 text-center text-md-left"
                  },
                  [
                    _c("div", { staticClass: "buttonTextCont widthfull" }, [
                      _c(
                        "h1",
                        { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                        [_c("b", [_vm._v(_vm._s(_vm.countStep1Practice))])]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-info btn-sm uppercase widthFull",
                        on: {
                          click: function($event) {
                            _vm.filter = "Step1"
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "balance-scale", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "d-none d-md-inline" }, [
                          _vm._v(" Carica Docum...")
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  _c("div", { staticClass: "buttonTextCont widthfull" }, [
                    _c(
                      "h1",
                      { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                      [_c("b", [_vm._v(_vm._s(_vm.countStep2Practice))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm uppercase widthFull",
                      on: {
                        click: function($event) {
                          _vm.filter = "Step2"
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" Verifica")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  _c("div", { staticClass: "buttonTextCont widthfull" }, [
                    _c(
                      "h1",
                      { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                      [_c("b", [_vm._v(_vm._s(_vm.countStep3Practice))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-sm widthFull",
                      on: {
                        click: function($event) {
                          _vm.filter = "Step3"
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "balance-scale", size: "sm" }
                      }),
                      _vm._v(" "),
                      _vm._m(2)
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-4 col-md-2 text-left" }, [
                  _c("div", { staticClass: "buttonTextCont widthfull" }, [
                    _c(
                      "h1",
                      { staticClass: "widthFull mt-0 center pb-0 mb-0" },
                      [_c("b", [_vm._v(_vm._s(_vm.countStep4Practice))])]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-primary btn-sm uppercase btn-blue widthFull",
                      on: {
                        click: function($event) {
                          _vm.filter = "Step4"
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "white",
                        attrs: { icon: "euro-sign", size: "sm" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "d-none d-md-inline white" }, [
                        _vm._v(" BONIFICO ")
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pb-5" }, [
          !_vm.showFilterText
            ? _c(
                "div",
                { staticClass: "col-md-12 col-lg-12" },
                [
                  _c(
                    "badger-accordion",
                    { key: "sdfg345", staticClass: "pb-5 mt-4" },
                    _vm._l(_vm.practicesFiltred, function(item, key) {
                      return item.status != 10
                        ? _c(
                            "badger-accordion-item",
                            { key: item.code + "_" + _vm.countloop },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-9 text-center text-md-left"
                                        },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "\n                    Pratica associata a\n                    "
                                            ),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.azienda_user)
                                                )
                                              ]
                                            ),
                                            _vm._v(
                                              " con PIVA\n                    "
                                            ),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.partita_iva_user
                                                  ) + " "
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v("\n                    N. "),
                                            _c(
                                              "b",
                                              { staticClass: "underline" },
                                              [_vm._v(_vm._s(item.code))]
                                            ),
                                            _vm._v(
                                              " del\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .moment(item.created_at)
                                                    .format("DD-MM-YYYY HH:mm")
                                                ) +
                                                " (\n                    " +
                                                _vm._s(item.bonus) +
                                                " ) per\n                    "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.client_name) +
                                                  " " +
                                                  _vm._s(item.client_lastname) +
                                                  " "
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _vm.hasPrev
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-primary m-2 btn-sm",
                                                  attrs: {
                                                    href: item.signed_order,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "eye",
                                                      size: "sm"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " visualizza\n                    Preventivo Firmato\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn btn-primary btn-blue m-2 btn-sm",
                                              attrs: {
                                                to: {
                                                  name: "loadDocuments",
                                                  params: { item: item }
                                                }
                                              }
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "clipboard-check",
                                                  size: "1x"
                                                }
                                              }),
                                              _vm._v(
                                                "\n                    Gestione Documenti\n                  "
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          item.status == 1 &&
                                          item.payment_id == "0"
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-danger m-2 btn-sm",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removePractice(
                                                        item.id,
                                                        item.code,
                                                        key
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("font-awesome-icon", {
                                                    attrs: {
                                                      icon: "trash-alt",
                                                      size: "sm"
                                                    }
                                                  }),
                                                  _vm._v(
                                                    " Elimina\n                  "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 1
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: __webpack_require__("ckMO")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 2 ||
                                          item.status == 3 ||
                                          item.status == 4
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: __webpack_require__("Jkjn")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status == 5
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull traficLight maxBomTr2 ml-md-5",
                                                attrs: {
                                                  src: __webpack_require__("9x6x")
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-7 col-md-1 center pl-md-0 pr-md-0 pt-3"
                                        },
                                        [
                                          item.enea_request == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success": _vm.checkEneaComplate(
                                                    item.aditional_enea_data
                                                  )
                                                },
                                                attrs: {
                                                  src: __webpack_require__("vg18")
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.to_get_cadastral_data == "1"
                                            ? _c("img", {
                                                staticClass:
                                                  "img-fluid widthFull mt-2",
                                                class: {
                                                  "bg-success":
                                                    item.dcast_export == "10"
                                                },
                                                attrs: {
                                                  src: __webpack_require__("6Z51")
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2 center pt-3" },
                                        [
                                          item.status == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "\n                      inline-block\n                      center\n                      relative\n                      topCust2\n                      d-none d-md-inline\n                    ",
                                                  staticStyle: {
                                                    position:
                                                      "initial !important"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "qrcodeImg qrcodeImg2",
                                                    attrs: { src: item.qrcode }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("br")
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.status != 1 &&
                                          item.ade_protocol_number
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "\n                      inline-block\n                      center\n                      relative\n                      topCust2\n                      d-md-inline\n                      pt-4 pt-md-0\n                      pb-0\n                    ",
                                                  staticStyle: {
                                                    position:
                                                      "initial !important"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "pt-0 pt-md-2 pb-md-2 bgGreen white"
                                                    },
                                                    [
                                                      _c("small", [
                                                        _c("b", [
                                                          _vm._v(
                                                            "Protocollo AdE nr.\n                          " +
                                                              _vm._s(
                                                                item.ade_protocol_number
                                                              )
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.status == 1 && item.hasErrors == "no"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "yellow widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass: "mr-4 theme"
                                                    },
                                                    [_vm._v("Per procedere:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "theme" },
                                                    [
                                                      _vm._v(
                                                        "\n                      Prepara e carica tutta la documentazione nella sezione\n                      GESTIONE DOCUMENTI\n                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.aditional_enea_data == null &&
                                      item.enea_request == "1" &&
                                      item.payment_id != "0" &&
                                      2 == 3
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11 requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "Regular text-center h0 widthFull"
                                                },
                                                [
                                                  item.status == 2
                                                    ? _c("b", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "yellow"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Attenzione!"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Per redigere e\n                      inviare la Pratica ENEA abbiamo necessità di ulteriori\n                      informazioni\n                    "
                                                        )
                                                      ])
                                                    : _c("b", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "yellow"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Attenzione!"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " Per redigere ed\n                      inviare la pratica ENEA avremo bisogno di ulteriori\n                      informazioni che ti chiederemo alla conclusione del Set\n                      Documentale.\n                    "
                                                        )
                                                      ]),
                                                  _vm._v(" "),
                                                  item.status == 2
                                                    ? _c(
                                                        "router-link",
                                                        {
                                                          staticClass:
                                                            "btn btn-primary m-2 btn-sm",
                                                          attrs: {
                                                            to: {
                                                              name:
                                                                "complateEneaData",
                                                              params: {
                                                                item: item
                                                              }
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      Inserisci\n                    "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.hasErrors == "yes"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 col-md-11 mt-3 center requiredCont"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left"
                                                },
                                                [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "widthFull mr-4"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Attenzione abbiamo rilevato seguenti anomalie:"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "red widthFull text-left pl-4"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(item.errors) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col-md-12 center pt-4"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "card step-progress pt-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "step-slider" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item",
                                                      class: {
                                                        active:
                                                          item.status == 1,
                                                        "active passed":
                                                          item.status != 1
                                                      },
                                                      attrs: {
                                                        "data-id": "step1"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$router.push(
                                                            {
                                                              name:
                                                                "loadDocuments",
                                                              params: {
                                                                item: item
                                                              }
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 1 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "Carica Documentazione"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item",
                                                      class: {
                                                        notactive:
                                                          item.status == 1,
                                                        active:
                                                          item.status == 2,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2
                                                      },
                                                      attrs: {
                                                        "data-id": "step2"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 2 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v("Verifica")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 2,
                                                        active:
                                                          item.status == 3,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3
                                                      },
                                                      attrs: {
                                                        "data-id": "step3"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 3 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(
                                                              "Accettazione cessione del credito"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "step-slider-item notactive",
                                                      class: {
                                                        notactive:
                                                          item.status == 3,
                                                        active:
                                                          item.status == 4,
                                                        "active passed":
                                                          item.status != 1 &&
                                                          item.status != 2 &&
                                                          item.status != 3 &&
                                                          item.status != 4
                                                      },
                                                      attrs: {
                                                        "data-id": "step4"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "stTitle"
                                                        },
                                                        [
                                                          _vm._v("Step 4 "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("b", [
                                                            _vm._v(" Bonifico")
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "step-content"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-left",
                                          class: {
                                            "col-11": !_vm.hasPrev,
                                            "col-md-9": _vm.hasPrev
                                          }
                                        },
                                        [
                                          _c("h5", { staticClass: "black" }, [
                                            _vm._v(
                                              "\n                    Indirizzo dell'immobile\n                    "
                                            ),
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(item.building_address) +
                                                  " " +
                                                  _vm._s(item.building_civic) +
                                                  " -\n                      " +
                                                  _vm._s(item.building_zip) +
                                                  " " +
                                                  _vm._s(item.building_city) +
                                                  " (" +
                                                  _vm._s(
                                                    item.building_province
                                                  ) +
                                                  ")\n                    "
                                              )
                                            ])
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                { staticClass: "black pb-0" },
                                                [_vm._v("Dati dell'intervento")]
                                              ),
                                              _vm._v(
                                                "\n                  Tipo:\n                  "
                                              ),
                                              _c("b", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "uppercase Regular"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.intervention_type
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black pb-0 text-left widthFull"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Da Cliente:\n                    "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      "\n                      €\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              item.total_transfer_for_client
                                                            )
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black pb-0 text-left"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Da Cessione:\n                    "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      "\n                      €\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              item.total_transfer_for_user
                                                            )
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.hasPrev
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "col-md-3 text-left"
                                            },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "black pb-0 text-left"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Totale:\n                    "
                                                  ),
                                                  _c("b", [
                                                    _vm._v(
                                                      "\n                      €\n                      " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatNumber"
                                                          )(
                                                            parseFloat(
                                                              item.total_transfer_for_client
                                                            ) +
                                                              parseFloat(
                                                                item.total_transfer_for_user
                                                              )
                                                          )
                                                        )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "badger-accordion",
                    { key: "12312412512354134", staticClass: "pb-5 mt-4" },
                    [
                      _vm.hasRemovedPractics && _vm.filter == ""
                        ? _c(
                            "badger-accordion-item",
                            { attrs: { id: "id_closed" } },
                            [
                              _c(
                                "template",
                                { staticClass: "center", slot: "header" },
                                [
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "h5",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Pratiche Eliminate\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasRemovedPractics
                                    ? _c(
                                        "p",
                                        { staticClass: "text-left black" },
                                        [
                                          _vm._v(
                                            "\n                Attenzione! i dati della dashboard non includono il valori di\n                pratiche eliminate.\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "template",
                                {
                                  staticClass: "bbaLightColor",
                                  slot: "content"
                                },
                                [
                                  _c(
                                    "badger-accordion",
                                    { staticClass: "pb-5 mt-4 greyBg" },
                                    _vm._l(_vm.practicesFiltred, function(
                                      item,
                                      key
                                    ) {
                                      return item.status == 10
                                        ? _c(
                                            "badger-accordion-item",
                                            {
                                              key: item.code + "12",
                                              staticClass: "greyBg"
                                            },
                                            [
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "greyBg",
                                                  slot: "header"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-9 text-center text-md-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Pratica N.\n                          "
                                                              ),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "underline"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.code
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " del\n                          " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .moment(
                                                                        item.created_at
                                                                      )
                                                                      .format(
                                                                        "DD-MM-YYYY HH:mm"
                                                                      )
                                                                  ) +
                                                                  "\n                          ( " +
                                                                  _vm._s(
                                                                    item.bonus
                                                                  ) +
                                                                  " ) per\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      item.client_name
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item.client_lastname
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "btn btn-primary m-2 btn-sm",
                                                              attrs: {
                                                                href:
                                                                  item.signed_order,
                                                                target: "_blank"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon: "eye",
                                                                    size: "sm"
                                                                  }
                                                                }
                                                              ),
                                                              _vm._v(
                                                                "\n                          visualizza Preventivo Firmato\n                        "
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("div", {
                                                        staticClass:
                                                          "col-md-3 center pt-3"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                {
                                                  staticClass: "greyBg",
                                                  slot: "content"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row justify-content-center pb-2 pl-md-3 pr-md-3"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-9 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Indirizzo dell'immobile\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.building_address
                                                                  ) +
                                                                    "\n                            " +
                                                                    _vm._s(
                                                                      item.building_civic
                                                                    ) +
                                                                    " -\n                            " +
                                                                    _vm._s(
                                                                      item.building_zip
                                                                    ) +
                                                                    "\n                            " +
                                                                    _vm._s(
                                                                      item.building_city
                                                                    ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      item.building_province
                                                                    ) +
                                                                    ")\n                          "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Dati dell'intervento"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                        Tipo:\n                        "
                                                          ),
                                                          _c("b", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "uppercase Regular"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.intervention_type
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0 text-left widthFull"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Da Cliente:\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            €\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        parseFloat(
                                                                          item.total_transfer_for_client
                                                                        )
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0 text-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Da Cessione:\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            €\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        parseFloat(
                                                                          item.total_transfer_for_user
                                                                        )
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0 text-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                          Totale:\n                          "
                                                              ),
                                                              _c("b", [
                                                                _vm._v(
                                                                  "\n                            €\n                            " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "formatNumber"
                                                                      )(
                                                                        parseFloat(
                                                                          item.total_transfer_for_client
                                                                        ) +
                                                                          parseFloat(
                                                                            item.total_transfer_for_user
                                                                          )
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-3 text-left"
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "black pb-0"
                                                            },
                                                            [
                                                              _c("b", [
                                                                _vm._v("Data:")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "uppercase"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .moment(
                                                                          item.intervention_date
                                                                        )
                                                                        .format(
                                                                          "DD-MM-YYYY"
                                                                        )
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5"
                },
                [
                  _c("h5", { staticClass: "center" }, [
                    _vm._v("Nessun risultato per " + _vm._s(_vm.filter))
                  ])
                ]
              )
        ])
      ])
    ],
    1
  )
}
var pratiche_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center text-left" }, [
      _c("h3", { staticClass: "Regular center h0 widthFull" }, [
        _c("b", [_vm._v("Le tue pratiche ")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 col-md-3 Bold" }, [
      _c("p", [
        _vm._v(
          "\n          * Il valore del credito cedibile e il valore del credito ceduto sono\n          aggiornati agli ultimi 10 giorni\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "d-none d-md-inline white" }, [
      _vm._v("\n            richiesta a A"),
      _c(
        "span",
        { staticStyle: { "text-transform": "lowercase !important" } },
        [_vm._v("d")]
      ),
      _vm._v("E")
    ])
  }
]
pratiche_render._withStripped = true
var pratiche_esExports = { render: pratiche_render, staticRenderFns: pratiche_staticRenderFns }
/* harmony default export */ var components_pratiche = (pratiche_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe741b42", pratiche_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/pratiche/index.vue
var pratiche_disposed = false
function pratiche_injectStyle (ssrContext) {
  if (pratiche_disposed) return
  __webpack_require__("yqhM")
}
var pratiche_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pratiche___vue_template_functional__ = false
/* styles */
var pratiche___vue_styles__ = pratiche_injectStyle
/* scopeId */
var pratiche___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pratiche___vue_module_identifier__ = null
var pratiche_Component = pratiche_normalizeComponent(
  pratiche,
  components_pratiche,
  pratiche___vue_template_functional__,
  pratiche___vue_styles__,
  pratiche___vue_scopeId__,
  pratiche___vue_module_identifier__
)
pratiche_Component.options.__file = "src/components/pratiche/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fe741b42", pratiche_Component.options)
  } else {
    hotAPI.reload("data-v-fe741b42", pratiche_Component.options)
  }
  module.hot.dispose(function (data) {
    pratiche_disposed = true
  })
})()}

/* harmony default export */ var src_components_pratiche = (pratiche_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/end/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var end_moment = __webpack_require__("PJh5");

/* harmony default export */ var end = ({
	name: 'play',
	components: {
		Datepicker: vuejs_datepicker_esm["a" /* default */],
		VueTimepicker: vue2_timepicker_default.a
	},
	data: function data() {
		return {
			loadingState: false,
			userToken: '',
			partita_iva: '',
			existPIVA: false,
			existEmail: false,
			existCF: false,
			tempIva: '',
			tempCF: '',
			tempEmail: '',
			azienda: '',
			name: '',
			lastname: '',
			email: '',
			phone: '',
			cellulare: '',
			codice_fiscale: '',
			shipEqual: true,
			shipData: {},
			address: '',
			civic: '',
			region: '',
			province: '',
			city: '',
			zip: '',
			regions: [],
			regionsState: true,
			provincies: [],
			provinciesState: false,
			cities: [],
			citiesState: false,
			zips: [],
			zipsState: false,
			provinceError: false,
			cityError: false,
			zipError: false,

			ship_regions: [],
			ship_regionsState: true,
			ship_provincies: [],
			ship_provinciesState: false,
			ship_cities: [],
			ship_citiesState: false,
			ship_zips: [],
			ship_zipsState: false,
			ship_provinceError: false,
			ship_cityError: false,
			ship_zipError: false,

			ship_name: '',
			ship_lastname: '',
			near: '',
			ship_phone: '',
			ship_cellulare: '',
			ship_address: '',
			ship_civic: '',
			ship_region: '',
			ship_province: '',
			ship_city: '',
			ship_zip: '',
			note: '',

			invoiceFront: '',
			invoiceFrontName: '',
			invoiceFrontBucket: '',
			uploadFrontPercentage: 0,
			invoiceRear: '',
			invoiceRearName: '',
			invoiceRearBucket: '',
			uploadRearPercentage: 0,
			id_eps: '',

			vw: window.innerWidth
		};
	},

	methods: {

		registration: function registration() {
			var _this = this;

			this.$validator.validate().then(function (valid) {
				if (valid && _this.profile.email && _this.profile.id) {

					var data = defineProperty_default()({
						name: _this.name,
						cognome: _this.lastname,
						email: _this.email,
						password: _this.profile.password,
						azienda: _this.azienda,
						id_eps: '',
						target: 0,
						partita_iva: _this.partita_iva,
						codice_fiscale: _this.codice_fiscale,
						indirizzo: _this.address,
						civico: _this.civic,
						comune: _this.city.city,
						provincia: _this.province,
						regione: _this.region.text,
						cap: _this.zip,
						telefono: _this.phone,
						cellulare: _this.cellulare,
						privacy: 1,
						privacy1: _this.invoiceFrontBucket,
						privacy2: _this.invoiceRearBucket,

						ship_presso: _this.near,
						ship_note: _this.note,
						ship_name: _this.shipEqual ? _this.name : _this.ship_name,
						ship_cognome: _this.shipEqual ? _this.lastname : _this.ship_lastname,
						ship_indirizzo: _this.shipEqual ? _this.address : _this.ship_address,
						ship_civico: _this.shipEqual ? _this.civic : _this.ship_civic,
						ship_comune: _this.shipEqual ? _this.city.city : _this.ship_city.city,
						ship_provincia: _this.shipEqual ? _this.province : _this.ship_province,
						ship_regione: _this.shipEqual ? _this.region.text : _this.ship_region.text,
						ship_cap: _this.shipEqual ? _this.zip : _this.ship_zip,
						ship_telefono: _this.shipEqual ? _this.phone : _this.ship_phone,
						ship_cellulare: _this.shipEqual ? _this.cellulare : _this.ship_cellulare,

						type: _this.profile.email,
						confirmed: _this.profile.id
					}, 'id_eps', _this.id_eps);

					_this.$log(data);

					axios_default()({
						url: "https://wsbot.eu/ebonusBack/public/" + 'api/newUser',
						method: 'POST',
						data: {
							user: data,
							regType: 'new',
							who: _this.profile.email,
							operator_id: _this.profile.id
						},
						headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {

						_this.addClientSuccess();
						_this.$router.push('/');
					}).catch(function (error) {

						var text = error.response.data.error;
						_this.addClientError(text);
					});
				} else {
					if (!_this.profile.email) {
						alert('Sessione scaduta - devi effetuare login');
					}
				}
			});
		},

		checkIfExistUser: function checkIfExistUser(value) {
			var _this2 = this;

			var newValue = value.target.value;
			var field = this.$validator.fields.find({ name: 'partita_iva' });
			var typeCall;
			var tempVal;
			if (value.target.id == 'partita_iva') {
				typeCall = 'partita_iva';
				tempVal = this.tempIva;
			}
			if (value.target.id == 'codice_fiscale') {
				typeCall = 'codice_fiscale';
				tempVal = this.tempCF;
			}
			if (value.target.id == 'email') {
				typeCall = 'email';
				tempVal = this.tempEmail;
			}

			if (!this.errors.has(value.target.id) && tempVal != newValue && newValue) {

				if (typeCall == 'partita_iva') {
					this.tempIva = newValue;
				}
				if (typeCall == 'codice_fiscale') {
					this.tempCF = newValue;
				}
				if (typeCall == 'email') {
					this.tempEmail = newValue;
				}

				axios_default()({
					url: "https://wsbot.eu/ebonusBack/public/" + 'api/checkExUser',
					method: 'POST',
					data: {
						value: newValue,
						typeCall: typeCall
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {

					if (typeCall == 'partita_iva') {
						_this2.existPIVA = false;
					}
					if (typeCall == 'codice_fiscale') {
						_this2.existCF = false;
					}
					if (typeCall == 'email') {
						_this2.existEmail = false;
					}
				}).catch(function (error) {

					if (typeCall == 'partita_iva') {
						_this2.existPIVA = true;
					}
					if (typeCall == 'codice_fiscale') {
						_this2.existCF = true;
					}
					if (typeCall == 'email') {
						_this2.existEmail = true;
					}
				});
			}
		},

		uploadFile: function uploadFile(input) {
			var file = input.target.files[0].name;
			this.invoiceFrontName = file;
			var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
			var size = input.target.files[0].size;

			if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {

				this.invoiceFront = input.target.files[0].name;

				var formData = new FormData();
				var _vue = this; // << here
				formData.append('fattura0', input.target.files[0]);

				axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + 'api/uploadImageInvoice', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
					},
					onUploadProgress: function (progressEvent) {
						this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
					}.bind(this)
				}).then(function (e) {
					var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
					if (regex.test(e.data.fattura)) {
						_vue.uploadFrontPercentage = 0;
						_vue.invoiceFrontBucket = e.data.fattura;
					} else {
						_vue.uploadFrontPercentage = 0;
						_vue.invoiceFront = '';
						_vue.invoiceFrontBucket = '';
						_vue.UploadError();
						input.target.value = null;
					}
				}).catch(function () {
					_vue.uploadFrontPercentage = 0;
					_vue.invoiceFront = '';
					_vue.invoiceFrontBucket = '';
					_vue.UploadError();
					input.target.value = null;
				});
			}
		},

		uploadFileRear: function uploadFileRear(input) {
			var file = input.target.files[0].name;

			this.invoiceRearName = file;
			var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
			var size = input.target.files[0].size;

			if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
				this.invoiceRear = input.target.files[0].name;

				var formData = new FormData();
				var _vue = this; // << here
				formData.append('fattura0', input.target.files[0]);

				axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + 'api/uploadImageInvoice', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
					},
					onUploadProgress: function (progressEvent) {
						this.uploadRearPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
					}.bind(this)
				}).then(function (e) {
					var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
					if (regex.test(e.data.fattura)) {

						_vue.uploadRearPercentage = 0;
						_vue.invoiceRearBucket = e.data.fattura;
					} else {
						_vue.uploadRearPercentage = 0;
						_vue.invoiceRear = '';
						_vue.invoiceRearBucket = '';
						_vue.UploadError();
						input.target.value = null;
					}
				}).catch(function () {
					_vue.uploadRearPercentage = 0;
					_vue.invoiceRear = '';
					_vue.invoiceRearBucket = '';
					_vue.UploadError();
					input.target.value = null;
				});
			}
		},

		addClientSuccess: function addClientSuccess() {
			this.$swal({
				type: 'success',
				title: '<strong class="modalText ">L`installatore registrato con successo </strong>',
				html: '',
				confirmButtonText: 'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267'
			});
		},
		addClientError: function addClientError(text) {
			this.$swal({
				type: 'error',
				title: '<strong class="modalText danger">Registrazione non andato a buon fine.</strong>',
				html: text,
				confirmButtonText: 'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267'
			});
		},
		UploadError: function UploadError() {
			this.$swal({
				type: 'error',
				title: '<strong class="modalText danger">Errore caricamento immagine</strong>',
				html: '',
				confirmButtonText: 'CHIUDI',
				confirmButton: 'closeProductsModal',
				confirmButtonColor: '#15267'
			});
		},


		populateRegions: function populateRegions() {
			var _this3 = this;

			axios_default()({
				url: "https://wsbot.eu/ebonusBack/public/" + 'api/getRegions',
				method: 'POST',
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
				_this3.regions = resp.data.regions;
				_this3.regionsState = false;

				_this3.ship_regions = resp.data.regions;
				_this3.ship_regionsState = false;
			}).catch(function (resp) {
				_this3.regions = [];
				_this3.regionsState = false;

				_this3.ship_regions = [];
				_this3.ship_regionsState = false;
			});
		},

		checkRegion: function checkRegion() {
			var region = this.region;

			if (region) {
				this.provinceError = false;
			} else {
				this.provinceError = true;
			}
		},
		checkProvince: function checkProvince() {
			var province = this.province;

			if (province) {
				this.cityError = false;
			} else {
				this.cityError = true;
			}
		},
		checkZip: function checkZip() {
			var city = this.city;

			if (city) {
				this.zipError = false;
			} else {
				this.zipError = true;
			}
		},

		ship_checkRegion: function ship_checkRegion() {
			var ship_region = this.ship_region;

			if (ship_region) {
				this.ship_provinceError = false;
			} else {
				this.ship_provinceError = true;
			}
		},
		ship_checkProvince: function ship_checkProvince() {
			var ship_province = this.ship_province;

			if (ship_province) {
				this.ship_cityError = false;
			} else {
				this.ship_cityError = true;
			}
		},
		ship_checkZip: function ship_checkZip() {
			var ship_city = this.ship_city;

			if (ship_city) {
				this.ship_zipError = false;
			} else {
				this.ship_zipError = true;
			}
		},

		calcToDate: function calcToDate() {
			var start = Object({"year":2021,"month":2,"day":15});
			var date = new Date(new Date().setDate(new Date().getDate() - 5));
			var startDate = new Date(start.year, start.month - 1, start.day);
			if (startDate > date) {
				var finalTo = startDate;
			} else {
				var finalTo = date;
			}
			return finalTo;
		},
		calcFromDate: function calcFromDate() {
			var stopObj = Object({"year":2030,"month":12,"day":15});
			var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
			var nowDate = new Date();
			if (nowDate <= stopDate) {
				var finalFrom = nowDate;
			} else {
				var finalFrom = stopDate;
			}
			return finalFrom;
		},


		handleResize: function handleResize() {
			this.vw = window.innerWidth;
		}

	},
	watch: {
		azienda: function azienda(value) {
			this.azienda = value.toUpperCase();
		},
		name: function name(value) {
			this.name = value.toUpperCase();
		},
		lastname: function lastname(value) {
			this.lastname = value.toUpperCase();
		},
		ship_name: function ship_name(value) {
			this.ship_name = value.toUpperCase();
		},
		ship_lastname: function ship_lastname(value) {
			this.ship_lastname = value.toUpperCase();
		},
		number: function number(value) {
			this.number = parseInt(value);
		},
		phone: function phone(val) {
			if (val) {
				this.phone = val.replace(/\D+/g, '');
			}
		},
		id_eps: function id_eps(val) {
			if (val) {
				this.id_eps = val.replace(/\D+/g, '');
			}
		},
		cellulare: function cellulare(val) {
			if (val) {
				this.cellulare = val.replace(/\D+/g, '');
			}
		},
		ship_phone: function ship_phone(val) {
			if (val) {
				this.ship_phone = val.replace(/\D+/g, '');
			}
		},
		ship_cellulare: function ship_cellulare(val) {
			if (val) {
				this.ship_cellulare = val.replace(/\D+/g, '');
			}
		},
		region: function region(newVal) {
			var _this4 = this;

			this.zips = [];
			this.cities = [];
			this.zip = '';
			this.city = '';
			this.cityError = false;
			this.provinceError = false;
			this.zipError = false;
			this.province = '';
			this.provincies = [];
			this.provinciesState = true;

			var provincies = this.provincies,
			    provinciesState = this.provinciesState;

			axios_default()({
				url: "https://wsbot.eu/ebonusBack/public/" + 'api/getProvincies',
				method: 'POST',
				data: {
					region: newVal.id
				},
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
				_this4.provincies = resp.data.provincies;
				_this4.provinciesState = false;
			}).catch(function (resp) {
				_this4.provincies = [];
				_this4.provinciesState = false;
			});
		},
		ship_region: function ship_region(newVal) {
			var _this5 = this;

			this.ship_zips = [];
			this.ship_cities = [];
			this.ship_zip = '';
			this.ship_city = '';
			this.ship_cityError = false;
			this.ship_provinceError = false;
			this.ship_zipError = false;
			this.ship_province = '';
			this.ship_provincies = [];
			this.ship_provinciesState = true;

			var ship_provincies = this.ship_provincies,
			    ship_provinciesState = this.ship_provinciesState;

			axios_default()({
				url: "https://wsbot.eu/ebonusBack/public/" + 'api/getProvincies',
				method: 'POST',
				data: {
					region: newVal.id
				},
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
				_this5.ship_provincies = resp.data.provincies;
				_this5.ship_provinciesState = false;
			}).catch(function (resp) {
				_this5.ship_provincies = [];
				_this5.ship_provinciesState = false;
			});
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		province: function province(newProvince) {
			var _this6 = this;

			this.zips = [];
			this.cities = [];
			this.zip = '';
			this.city = '';
			this.cityError = false;
			this.zipError = false;

			if (newProvince) {
				this.citiesState = true;
				axios_default()({
					url: "https://wsbot.eu/ebonusBack/public/" + 'api/getComuni',
					method: 'POST',
					data: {
						provincia: newProvince
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this6.cities = resp.data.cities;
					_this6.citiesState = false;
				}).catch(function (resp) {
					_this6.cities = [];
					_this6.citiesState = false;
				});
			}
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		ship_province: function ship_province(newProvince) {
			var _this7 = this;

			this.ship_zips = [];
			this.ship_cities = [];
			this.ship_zip = '';
			this.ship_city = '';
			this.ship_cityError = false;
			this.ship_zipError = false;

			if (newProvince) {
				this.ship_citiesState = true;
				axios_default()({
					url: "https://wsbot.eu/ebonusBack/public/" + 'api/getComuni',
					method: 'POST',
					data: {
						provincia: newProvince
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this7.ship_cities = resp.data.cities;
					_this7.ship_citiesState = false;
				}).catch(function (resp) {
					_this7.ship_cities = [];
					_this7.ship_citiesState = false;
				});
			}
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		city: function city(newCity) {
			var _this8 = this;

			this.zipError = false;
			this.zips = [];
			this.zip = '';

			if (newCity.cityistat) {
				this.zipsState = true;
				axios_default()({
					url: "https://wsbot.eu/ebonusBack/public/" + 'api/getCap',
					method: 'POST',
					data: {
						istat: newCity.cityistat
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this8.zips = resp.data.zips;
					_this8.zipsState = false;
				}).catch(function (resp) {
					_this8.zips = [];
					_this8.zipsState = false;
				});
			}
		},
		// IF CHANGE PROVINCE -> LOAD CITIES
		ship_city: function ship_city(newCity) {
			var _this9 = this;

			this.ship_zipError = false;
			this.ship_zips = [];
			this.ship_zip = '';

			if (newCity.cityistat) {
				this.ship_zipsState = true;
				axios_default()({
					url: "https://wsbot.eu/ebonusBack/public/" + 'api/getCap',
					method: 'POST',
					data: {
						istat: newCity.cityistat
					},
					headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' } }).then(function (resp) {
					_this9.ship_zips = resp.data.zips;
					_this9.ship_zipsState = false;
				}).catch(function (resp) {
					_this9.ship_zips = [];
					_this9.ship_zipsState = false;
				});
			}
		},
		vw: function vw() {}

	},
	updated: function updated() {},
	created: function created() {
		this.$validator.extend('notZeros', {
			getMessage: function getMessage(field) {
				return ' Il campo Numero di telefono non ha un formato valido.';
			},
			validate: function validate(value) {
				// value must be > zero
				if (value > 1000000 && value.length > 1 && value != 30000000 && value != 300000000 && value != 3000000000 && value != 30000000000) return true;
				return false;
			}
		});
	},
	mounted: function mounted() {

		window.addEventListener('resize', this.handleResize);
		this.handleResize();

		this.lastnamex = this.getProfile.cognome;
		this.xuserx = this.getProfile.name;

		var _vue = this;

		setTimeout(function () {

			_vue.populateRegions(), _vue.disabledDates = {
				to: _vue.calcToDate(), // Disable all dates up to specific date
				from: _vue.calcFromDate() // Disable all dates after specific date
			};

			_vue.scrollFinished = true;
		}, 1500);
	},
	computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
		profile: function profile(state) {
			return state.user.profile;
		}
	}))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-415b2084","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/end/index.vue
var end_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var end_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "widthFull container logo dataContainer" },
      [
        _c("h1", { staticClass: "h2 center mt-5 pb-4" }, [
          _c("b"),
          _vm._v("ATTENZIONE!")
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "h2 center mt-5 pb-4 red" }, [
          _c("b", [
            _vm._v("Il programma di incentivazione  "),
            _c("br"),
            _vm._v(" è terminato il 31 luglio 2020.")
          ])
        ])
      ]
    )
  }
]
end_render._withStripped = true
var end_esExports = { render: end_render, staticRenderFns: end_staticRenderFns }
/* harmony default export */ var components_end = (end_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-415b2084", end_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/end/index.vue
var end_disposed = false
function end_injectStyle (ssrContext) {
  if (end_disposed) return
  __webpack_require__("u+93")
  __webpack_require__("+qws")
}
var end_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var end___vue_template_functional__ = false
/* styles */
var end___vue_styles__ = end_injectStyle
/* scopeId */
var end___vue_scopeId__ = "data-v-415b2084"
/* moduleIdentifier (server only) */
var end___vue_module_identifier__ = null
var end_Component = end_normalizeComponent(
  end,
  components_end,
  end___vue_template_functional__,
  end___vue_styles__,
  end___vue_scopeId__,
  end___vue_module_identifier__
)
end_Component.options.__file = "src/components/end/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-415b2084", end_Component.options)
  } else {
    hotAPI.reload("data-v-415b2084", end_Component.options)
  }
  module.hot.dispose(function (data) {
    end_disposed = true
  })
})()}

/* harmony default export */ var src_components_end = (end_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/notActive/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var notActive_moment = __webpack_require__("PJh5");
/* harmony default export */ var notActive = ({

  name: 'NotActive',
  data: function data() {
    return {
      time: false,
      countdown: 0,
      datenow: ''
    };
  },

  methods: {
    timeReactive: function timeReactive() {
      var self = this;
      this.datenow = notActive_moment();

      if (notActive_moment() >= notActive_moment("2021-01-15 00:00:00")) {
        window.location.replace('/');
      }
    }
  },
  created: function created() {
    //// COUNDOWN
    //var data = '2019-09-09 00:00:00'

    setInterval(this.timeReactive, 1000);

    var now = notActive_moment();

    var then = notActive_moment("2021-01-15 00:00:00");

    var dif = then.diff(now);

    //moment.utc(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
    this.countdown = dif;
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0de2e1c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notActive/index.vue
var notActive_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "widthFull ptHeader mainBackVaillant",
      staticStyle: { "min-height": "100vh" },
      attrs: { id: "firstElem" }
    },
    [
      _c("div", { staticClass: "container pt-5 pb-5" }, [
        _c("div", { staticClass: "row justify-content-center  pb-5" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("h2", { staticClass: "Bold blue center widthFull mb-5 mt-5" }, [
            _vm._v("\n\n         La piattaforma sarà attiva tra:\n\n       ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-7 pb-2 mb-5 pt-5 center custForm" },
            [
              _c("countdown", {
                attrs: { time: _vm.countdown },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row center justify-content-center pb-5 pt-1"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.days) +
                                        "\n\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.days == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("giorno")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("giorni")]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4  text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont " },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.hours) +
                                        "\n\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.hours == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("ora")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("ore")]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.minutes) +
                                        "\n                      "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.minutes == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("minuto")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("minuti")]
                                    )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "inlineTimeElements pl-0 pr-0 ml-4 mr-4 text-center relative"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "timeElement BoldFont" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.seconds) +
                                        "\n\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                props.seconds == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("secondo")]
                                    )
                                  : _c(
                                      "p",
                                      { staticClass: "classic Bold mt-2 mb-0" },
                                      [_vm._v("secondi")]
                                    )
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var notActive_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid   pt-5 pb-5" }, [
      _c("div", { staticClass: "row pt-5 pb-3 center" })
    ])
  }
]
notActive_render._withStripped = true
var notActive_esExports = { render: notActive_render, staticRenderFns: notActive_staticRenderFns }
/* harmony default export */ var components_notActive = (notActive_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0de2e1c8", notActive_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/notActive/index.vue
var notActive_disposed = false
function notActive_injectStyle (ssrContext) {
  if (notActive_disposed) return
  __webpack_require__("vOz5")
}
var notActive_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var notActive___vue_template_functional__ = false
/* styles */
var notActive___vue_styles__ = notActive_injectStyle
/* scopeId */
var notActive___vue_scopeId__ = "data-v-0de2e1c8"
/* moduleIdentifier (server only) */
var notActive___vue_module_identifier__ = null
var notActive_Component = notActive_normalizeComponent(
  notActive,
  components_notActive,
  notActive___vue_template_functional__,
  notActive___vue_styles__,
  notActive___vue_scopeId__,
  notActive___vue_module_identifier__
)
notActive_Component.options.__file = "src/components/notActive/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0de2e1c8", notActive_Component.options)
  } else {
    hotAPI.reload("data-v-0de2e1c8", notActive_Component.options)
  }
  module.hot.dispose(function (data) {
    notActive_disposed = true
  })
})()}

/* harmony default export */ var src_components_notActive = (notActive_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/complateEneaData/index.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var complateEneaData_moment = __webpack_require__("PJh5");

/* harmony default export */ var complateEneaData = ({
  name: 'acceptInvoice',
  components: {
    Datepicker: vuejs_datepicker_esm["a" /* default */]
  },
  data: function data() {
    return {
      token: '',
      loadingState: false,
      loading: false,
      eventEndtdate: '',
      it: locale["it"],
      eventStartdate: '',
      practices: {},
      moment: __webpack_require__("PJh5"),
      item: {},
      hideData: false,
      email: '',
      codice_fiscale: '',
      partita_iva: '',
      phone: '',
      mobile: '',
      cellulare: '',
      address: '',
      civic: '',
      azienda: '',
      region: '',
      province: '',
      city: '',
      cap: '',
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      invoiceFront: '',
      invoiceFrontName: '',
      invoiceFrontBucket: '',
      uploadFrontPercentage: 0,
      client_ownership: '',
      subalterno: '',
      particella: '',
      foglio: '',
      fromQRcode: false,
      tokenControl: false,
      passwordControl: false,
      orderRemoved: false,
      quantHouses: '',
      disabledDatesStart: {
        to: '',
        from: ''
      },
      noValvole: false
    };
  },

  methods: {
    setAditionalEneaData: function setAditionalEneaData() {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this.loadingState = true;

          var data = {
            aditional_enea_data: {
              company: _this.azienda,
              partita_iva: _this.partita_iva,
              client_ownership: _this.client_ownership,
              company_address: _this.address,
              company_civic: _this.civic,
              company_zip: _this.cap,
              intervention_start_date: complateEneaData_moment(_this.eventStartdate).format('DD-MM-YYYY'),
              intervention_end_date: complateEneaData_moment(_this.eventEndtdate).format('DD-MM-YYYY'),
              house_quantity: _this.quantHouses,
              valvole_doc: _this.invoiceFrontBucket
            },
            user_token: _this.getProfile.userToken,
            code: _this.item.code

          };

          _this.$log(data);
          axios_default()({
            url: "https://wsbot.eu/ebonusBack/public/" + 'api/addAdditionalEneaData',
            method: 'POST',
            data: data,
            headers: {
              'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
              'Content-type': 'application/json'
            }
          }).then(function (resp) {
            _this.loadingState = false;
            _this.addSuccess();
            _this.$router.push('/pratiche');
          }).catch(function (resp) {
            _this.loadingState = false;
            _this.showAlert();
          });

          //

        } else {
          _this.$scrollTo('#app', 700, {
            offset: -75
          });
        }
      });
    },
    uploadFile: function uploadFile(input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf('.') + 1).toLowerCase();
      var size = input.target.files[0].size;

      if ((extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'pdf') && size < 10240000) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        var t = 0;
        for (var x in input.target.files) {
          formData.append('fattura' + t, input.target.files[x]);
          t = t + 1;
        }

        axios_default.a.post("https://wsbot.eu/ebonusBack/public/" + 'api/uploadImageInvoice', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3"
          },
          onUploadProgress: function (progressEvent) {
            this.uploadFrontPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (e) {
          var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
          if (regex.test(e.data.fattura)) {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFrontBucket = e.data.fattura;
          } else {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = '';
            _vue.invoiceFrontBucket = '';
            _vue.UploadError();
            input.target.value = null;
          }
        }).catch(function () {
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceFront = '';
          _vue.invoiceFrontBucket = '';
          _vue.UploadError();
          input.target.value = null;
        });
      }
    },
    addSuccess: function addSuccess() {
      this.$swal({
        type: 'success',
        title: '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: '',
        confirmButtonText: 'CHIUDI',
        confirmButton: 'closeProductsModal',
        confirmButtonColor: '#15267'
      });
    },

    populateProvincies: function populateProvincies() {
      var _this2 = this;

      var provincies = this.provincies,
          provinciesState = this.provinciesState;

      axios_default()({
        url: "https://wsbot.eu/ebonusBack/public/" + 'api/getProvinciesAll',
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
          'Content-type': 'application/json'
        }
      }).then(function (resp) {
        _this2.provincies = resp.data.provincies;
        _this2.provinciesState = false;
      }).catch(function (resp) {
        _this2.provincies = [];
        _this2.provinciesState = false;
      });
    },

    getPracticById: function getPracticById(userToken, id) {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$log('GET PRACTIC FOR QRcode ENTER');
                _context.next = 3;
                return axios_default()({
                  url: "https://wsbot.eu/ebonusBack/public/" + 'api/getPracticById',
                  method: 'POST',
                  data: {
                    'user_token': userToken,
                    'id': id
                  },
                  headers: {
                    'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
                    'Content-type': 'application/json'
                  }
                }).then(function (resp) {
                  _this3.$log('GET PRACTIC FOR QRcode => OK');
                  // CHECK IF ACTIVE YET

                  _this3.$route.params.item = resp.data.practices[0];

                  // MENU OFF FOR THIS CASE
                  var alert = {};
                  alert.text = 'NOT LOGED VIEW';
                  alert.type = 'MENU_OFF';
                  //this.$store.dispatch(ADD_NOTIFICATIONS, alert)
                }).catch(function (resp) {
                  _this3.$log('GET PRACTIC FOR QRcode => ERROR');
                  _this3.tokenControl = false;
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },

    checkProvince: function checkProvince() {
      var province = this.province;

      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function checkZip() {
      var city = this.city;

      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },
    showAlert: function showAlert() {
      // Use sweetalret2
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'Riprova più tardi!'
      });
    },
    setCap: function setCap(cap) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var x;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (x in _this4.zips) {
                  if (_this4.zips[x].cap == cap.toUpperCase()) {
                    _this4.zip = _this4.zips[x].cap;
                  }
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    setCity: function setCity(city) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var x, k;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:

                for (x in _this5.cities) {
                  if (_this5.cities[x].comune == city.toUpperCase()) {
                    k = {
                      cityistat: _this5.cities[x].istat,
                      city: city.toUpperCase()
                    };

                    _this5.city = k;
                  }
                }
                _this5.$log(_this5.city);

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    setProvince: function setProvince(province) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var x;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:

                for (x in _this6.provincies) {
                  if (_this6.provincies[x].sigla == province.toUpperCase()) {
                    _this6.province = _this6.provincies[x].sigla;
                  }
                }

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    calcToDateStart: function calcToDateStart() {
      var date = new Date(2021, 0, 1);
      var finalTo = date;

      this.$log(finalTo);
      return finalTo;
    },
    calcFromDateStart: function calcFromDateStart() {
      var date = new Date(new Date().setDate(new Date().getDate() + 1000));
      var finalTo = date;
      return finalTo;
    }
  },
  watch: {
    adress: function adress(val) {
      if (val) {
        this.adress = this.adress.toUpperCase();
      }
    },
    civic: function civic(val) {
      if (val) {
        this.civic = this.civic.toUpperCase();
      }
    },
    phone: function phone(val) {
      if (val) {
        this.phone = val.replace(/\D+/g, '');
      }
    },
    mobile: function mobile(val) {
      if (val) {
        this.mobile = val.replace(/\D+/g, '');
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function province(newProvince) {
      var _this7 = this;

      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = '';
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + 'api/getComuni',
          method: 'POST',
          data: {
            provincia: newProvince
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this7.cities = resp.data.cities;
          _this7.citiesState = false;
        }).catch(function (resp) {
          _this7.cities = [];
          _this7.citiesState = false;
        });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function city(newCity) {
      var _this8 = this;

      this.zipError = false;
      this.zips = [];
      this.zip = '';

      if (newCity.cityistat) {
        this.zipsState = true;
        axios_default()({
          url: "https://wsbot.eu/ebonusBack/public/" + 'api/getCap',
          method: 'POST',
          data: {
            istat: newCity.cityistat
          },
          headers: {
            'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
            'Content-type': 'application/json'
          }
        }).then(function (resp) {
          _this8.zips = resp.data.zips;
          _this8.zipsState = false;
        }).catch(function (resp) {
          _this8.zips = [];
          _this8.zipsState = false;
        });
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this9 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:

              if (_this9.$route.params.item) {
                _this9.item = _this9.$route.params.item;
              } else {
                if (!_this9.tokenControl) {
                  _this9.$router.push('/pratiche');
                }
              }
              _this9.disabledDatesStart = {
                to: _this9.calcToDateStart(), // Disable all dates up to specific date
                from: _this9.calcFromDateStart() // Disable all dates after specific date
              };
              _this9.populateProvincies();

              _this9.$scrollTo('#app', 700, {
                offset: -75
              });

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this9);
    }))();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']), Object(vuex_esm["c" /* mapState */])({
    //response: state => `${state.status.response.data}`,
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5414bf37","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/complateEneaData/index.vue
var complateEneaData_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      !_vm.hideData && !_vm.orderRemoved
        ? _c("div", { staticClass: "container pt-4 mt-5 pb-5" }, [
            _c("div", { staticClass: "row justify-content-center text-left" }, [
              _c("h3", { staticClass: "Regular center h0 widthFull" }, [
                _c("b", [_vm._v("Pratica N. " + _vm._s(_vm.item.code))])
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 pt-md-4 mt-3 center mb-3 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-primary m-2 btn-sm ml-md-5",
                      attrs: { to: { name: "pratiche" } }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "arrow-left", size: "1x" }
                      }),
                      _vm._v("\r\n          Indietro\r\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pb-5 pt-4  black vaillantCont widthFull",
                attrs: { id: "registration-form" }
              },
              [
                _c(
                  "div",
                  { staticClass: "row justify-content-center pb-5 " },
                  [
                    _vm.item.client_type == "Persona fisica"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _vm.item.client_type == "Partita IVA"
                              ? _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\r\n              Completa i dati del cliente finale ("
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.item.client_name) +
                                          " " +
                                          _vm._s(_vm.item.client_lastname)
                                      )
                                    ]),
                                    _vm._v(")\r\n            ")
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\r\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.client_type == "Partita IVA"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _vm.item.client_type == "Partita IVA"
                              ? _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\r\n              Completa i dati del cliente finale ("
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.item.client_name) +
                                          " " +
                                          _vm._s(_vm.item.client_lastname)
                                      )
                                    ]),
                                    _vm._v(")\r\n            ")
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.azienda,
                                    expression: "azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 3 },
                                    expression:
                                      "{required:true, max: 128, min: 3}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("azienda"),
                                  valid: !!_vm.azienda
                                },
                                attrs: {
                                  type: "text",
                                  id: "azienda",
                                  name: "azienda",
                                  "data-vv-as": "Ragione sociale"
                                },
                                domProps: { value: _vm.azienda },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.azienda = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "azienda" }
                                },
                                [_vm._v("Ragione sociale * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("azienda")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("azienda")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.partita_iva,
                                    expression: "partita_iva"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      partitaIva: true,
                                      max: 11,
                                      min: 11
                                    },
                                    expression:
                                      "{required: true, partitaIva: true, max: 11, min: 11,}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("partita_iva"),
                                  valid: !!_vm.partita_iva
                                },
                                attrs: {
                                  type: "text",
                                  id: "partita_iva",
                                  name: "partita_iva",
                                  "data-vv-as": "Partita IVA"
                                },
                                domProps: { value: _vm.partita_iva },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.partita_iva = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "partita_iva" }
                                },
                                [_vm._v("Partita IVA *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("partita_iva")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(
                                            _vm.errors.first("partita_iva")
                                          ) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-4 mb-3",
                              staticStyle: { opacity: "1" }
                            },
                            [
                              _c("div", { staticClass: "group custInput" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.client_ownership,
                                        expression: "client_ownership"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          max: 63,
                                          min: 2
                                        },
                                        expression:
                                          "{required:true, max: 63, min: 2}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "client_ownership"
                                      ),
                                      valid: !!_vm.client_ownership
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomq",
                                      id: "client_ownership",
                                      name: "client_ownership",
                                      "data-vv-as": "Titolo di possesso"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.client_ownership = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { attrs: { value: "Proprietario" } },
                                      [_vm._v("Proprietario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Usufruttuario" } },
                                      [_vm._v("Usufruttuario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Locatario" } },
                                      [_vm._v("Locatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Promissario acquirente"
                                        }
                                      },
                                      [_vm._v("Promissario acquirente")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Familiare convivente del possessore/detentore"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Familiare convivente del possessore/detentore"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "Erede" } },
                                      [_vm._v("Erede")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value: "Coniuge separato assegnatario"
                                        }
                                      },
                                      [_vm._v("Coniuge separato assegnatario")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà indivisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà indivisa"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      {
                                        attrs: {
                                          value:
                                            "Socio di cooperativa a proprietà divisa"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Socio di cooperativa a proprietà divisa"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "client_ownership" }
                                  },
                                  [_vm._v("Titolo di possesso *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("client_ownership")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                " +
                                            _vm._s(
                                              _vm.errors.first(
                                                "client_ownership"
                                              )
                                            ) +
                                            "\r\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "widthFull center black" }, [
                            _vm._v("\r\n            Sede Legale\r\n          ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-4 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.address,
                                    expression: "address"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 5 },
                                    expression:
                                      "{required:true, max: 128, min: 5}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("address"),
                                  valid: !!_vm.address
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomr",
                                  id: "address",
                                  name: "address",
                                  "data-vv-as": "Indirizzo"
                                },
                                domProps: { value: _vm.address },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.address = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "address" }
                                },
                                [_vm._v("Indirizzo *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("address")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("address")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.civic,
                                    expression: "civic"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 15 },
                                    expression: "{required:true, max: 15}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("civic"),
                                  valid: !!_vm.civic
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "civic",
                                  name: "civic",
                                  "data-vv-as": "Civico"
                                },
                                domProps: { value: _vm.civic },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.civic = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "civic" }
                                },
                                [_vm._v("Civico *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("civic")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("civic")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.cap,
                                    expression: "cap"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 5, max: 6 },
                                    expression:
                                      "{required:true, min: 5, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("cap"),
                                  valid: !!_vm.cap
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "cap",
                                  name: "cap",
                                  "data-vv-as": "Cap"
                                },
                                domProps: { value: _vm.cap },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.cap = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "cap" }
                                },
                                [_vm._v("Cap *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("cap")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(_vm.errors.first("cap")) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.client_type == "Amministratore di condominio"
                      ? [
                          _c("div", { staticClass: "col-md-12" }, [
                            _c(
                              "h4",
                              { staticClass: "widthFull center black" },
                              [
                                _vm._v(
                                  "\r\n              Completa i dati dell'Amministratore del condominio ("
                                ),
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.item.client_name) +
                                      " " +
                                      _vm._s(_vm.item.client_lastname)
                                  )
                                ]),
                                _vm._v(")\r\n            ")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-6 mb-3" }, [
                            _c("div", { staticClass: "group custInput" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.quantHouses,
                                    expression: "quantHouses"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 1, max: 6 },
                                    expression:
                                      "{required:true, min: 1, max: 6}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("quantHouses"),
                                  valid: !!_vm.quantHouses
                                },
                                attrs: {
                                  type: "text",
                                  autocomplete: "randomt",
                                  id: "quantHouses",
                                  name: "quantHouses",
                                  "data-vv-as": "Numero di unità immobiliari"
                                },
                                domProps: { value: _vm.quantHouses },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.quantHouses = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "quantHouses" }
                                },
                                [
                                  _vm._v(
                                    "Numero di unità immobiliari che compongono l’edificio *"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("quantHouses")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\r\n                " +
                                          _vm._s(
                                            _vm.errors.first("quantHouses")
                                          ) +
                                          "\r\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              disabledDates: _vm.disabledDatesStart,
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventStartdate,
                              callback: function($$v) {
                                _vm.eventStartdate = $$v
                              },
                              expression: "eventStartdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventStartdate,
                                expression: "eventStartdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventStartdate"),
                              valid: !!_vm.eventStartdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventStartdate",
                              name: "eventStartdate",
                              "data-vv-as": "Data inizio"
                            },
                            domProps: { value: _vm.eventStartdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventStartdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventStartdate" }
                            },
                            [_vm._v("Data inizio")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventStartdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("eventStartdate")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4 mb-3 " }, [
                      _c(
                        "div",
                        { staticClass: "group custInput" },
                        [
                          _c("datepicker", {
                            attrs: {
                              language: _vm.it,
                              "full-month-name": true,
                              format: "dd MMMM yyyy",
                              "monday-first": true,
                              disabledDates: _vm.disabledDatesStart,
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "input-class": "form-control dateInput"
                            },
                            model: {
                              value: _vm.eventEndtdate,
                              callback: function($$v) {
                                _vm.eventEndtdate = $$v
                              },
                              expression: "eventEndtdate"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.eventEndtdate,
                                expression: "eventEndtdate"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { required: true },
                                expression: "{required:true}"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.errors.has("eventEndtdate"),
                              valid: !!_vm.eventEndtdate
                            },
                            attrs: {
                              type: "text",
                              id: "eventEndtdate",
                              name: "eventEndtdate",
                              "data-vv-as": "Data ultimazione dei lavori"
                            },
                            domProps: { value: _vm.eventEndtdate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.eventEndtdate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "highlight" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "niceInputLabel",
                              attrs: { for: "eventEndtdate" }
                            },
                            [_vm._v("Data ultimazione dei lavori (collaudo)")]
                          ),
                          _vm._v(" "),
                          _vm.errors.has("eventEndtdate")
                            ? _c("div", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\r\n              " +
                                    _vm._s(_vm.errors.first("eventEndtdate")) +
                                    "\r\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.item.bonus != "Bonus Casa 50%"
                      ? [
                          _vm._m(2),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-8 mb-3 pr-4 text-left" },
                            [
                              _c("div", { staticClass: "form-check" }, [
                                _c("div", { staticClass: "p-3" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.noValvole,
                                        expression: "noValvole"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {},
                                        expression: "{}"
                                      }
                                    ],
                                    staticClass: "form-check-input",
                                    class: {
                                      "is-invalid": _vm.errors.has("noValvole")
                                    },
                                    attrs: {
                                      type: "checkbox",
                                      id: "noValvole",
                                      name: "noValvole",
                                      "data-vv-as": ""
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.noValvole)
                                        ? _vm._i(_vm.noValvole, null) > -1
                                        : _vm.noValvole
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.noValvole,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.noValvole = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.noValvole = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.noValvole = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._m(3),
                                  _vm._v(" "),
                                  _vm.errors.has("noValvole")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\r\n                  " +
                                              _vm._s(
                                                _vm.errors.first("noValvole")
                                              ) +
                                              "\r\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.noValvole
                            ? _c("div", { staticClass: "col-md-12 mb-4" }, [
                                _c("p", { staticClass: "center" }, [
                                  _vm._v(
                                    "Se necessario è possibile selezionare piu di un file"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as":
                                        "Scheda tecnica delle valvole termostatiche"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\r\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\r\n                  " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\r\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 mb-3 center mt-5" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.setAditionalEneaData }
                        },
                        [_vm._v(" Salva ")]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var complateEneaData_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8 pt-md-4 " }, [
      _c("h5", { staticClass: "Regular h0 widthFull" }, [
        _vm._v(
          "Per redigere e inviare la Pratica ENEA abbiamo necessità di ulteriori informazioni"
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "black mt-0 widthFull" }, [
        _vm._v(
          "\r\n          Completa il form qui sotto.\r\n          I dati inseriti verranno poi utilizzati per inviare la pratica Enea.\r\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v("\r\n            Inserisci i dati dell'intervento\r\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("h4", { staticClass: "widthFull center black" }, [
        _vm._v(
          "\r\n              Scheda tecnica delle valvole termostatiche\r\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "form-check-label textStable",
        attrs: { for: "noValvole" }
      },
      [
        _c("b", [
          _vm._v(
            "Valvole termostatiche non installate come da relazione allegata alla Dichiarazione di Conformità.\r\n                  "
          ),
          _c("br"),
          _vm._v(
            "Se questo campo viene valorizzato il documento richiesto può essere omesso."
          )
        ])
      ]
    )
  }
]
complateEneaData_render._withStripped = true
var complateEneaData_esExports = { render: complateEneaData_render, staticRenderFns: complateEneaData_staticRenderFns }
/* harmony default export */ var components_complateEneaData = (complateEneaData_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5414bf37", complateEneaData_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/complateEneaData/index.vue
var complateEneaData_disposed = false
function complateEneaData_injectStyle (ssrContext) {
  if (complateEneaData_disposed) return
  __webpack_require__("Cz55")
}
var complateEneaData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var complateEneaData___vue_template_functional__ = false
/* styles */
var complateEneaData___vue_styles__ = complateEneaData_injectStyle
/* scopeId */
var complateEneaData___vue_scopeId__ = "data-v-5414bf37"
/* moduleIdentifier (server only) */
var complateEneaData___vue_module_identifier__ = null
var complateEneaData_Component = complateEneaData_normalizeComponent(
  complateEneaData,
  components_complateEneaData,
  complateEneaData___vue_template_functional__,
  complateEneaData___vue_styles__,
  complateEneaData___vue_scopeId__,
  complateEneaData___vue_module_identifier__
)
complateEneaData_Component.options.__file = "src/components/complateEneaData/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5414bf37", complateEneaData_Component.options)
  } else {
    hotAPI.reload("data-v-5414bf37", complateEneaData_Component.options)
  }
  module.hot.dispose(function (data) {
    complateEneaData_disposed = true
  })
})()}

/* harmony default export */ var src_components_complateEneaData = (complateEneaData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/paymentError/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var paymentError_moment = __webpack_require__("PJh5");

/* harmony default export */ var paymentError = ({
  name: 'play',
  components: {},
  data: function data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: ''
    };
  },

  methods: {},
  watch: {},
  updated: function updated() {},
  created: function created() {
    this.$log(this.$route.params.id);
    this.practice = this.$route.params.id;
  },
  mounted: function mounted() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f46a2896","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentError/index.vue
var paymentError_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-5 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c(
          "div",
          { staticClass: "widthFull container vaillantCont pt-5 mt-5" },
          [
            _c("div", { staticClass: "row justify-content-center pb-5 mb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6  center" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("h1", { staticClass: "h2 center Regular Bold  " }, [
                  _c("b", [_vm._v("Pratica " + _vm._s(_vm.practice))])
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(
                  "\r\n\r\n          Di solito il problema più comune con i tentativi di pagamento è che siano bloccati dalla banca.\r\n          Per favore prova a contattare la tua banca per ottenere più informazioni e autorizzare l'addebito.\r\n          Prova a impostare un metodo di pagamento diverso, una diversa carta di credito / debit o il tuo account PayPal.\r\n          Potrebbe trattarsi di un rifiuto temporaneo da parte della banca.\r\n\r\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 mt-5 center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-secondary btn-lg",
                      attrs: { to: "/pratiche" }
                    },
                    [_vm._v(" Gestione Pratiche ")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var paymentError_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12  center" }, [
      _c("img", {
        staticClass: "img-fluid widthFull errorIcon",
        attrs: { src: __webpack_require__("jmlf") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "h2 center Regular Bold red" }, [
      _c("b", [_vm._v("ATTENZIONE!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "h2 center Regular Bold pb-4 " }, [
      _c("b", [_vm._v("Pagamento non andato a buon fine.")])
    ])
  }
]
paymentError_render._withStripped = true
var paymentError_esExports = { render: paymentError_render, staticRenderFns: paymentError_staticRenderFns }
/* harmony default export */ var components_paymentError = (paymentError_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f46a2896", paymentError_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/paymentError/index.vue
var paymentError_disposed = false
function paymentError_injectStyle (ssrContext) {
  if (paymentError_disposed) return
  __webpack_require__("qex6")
}
var paymentError_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var paymentError___vue_template_functional__ = false
/* styles */
var paymentError___vue_styles__ = paymentError_injectStyle
/* scopeId */
var paymentError___vue_scopeId__ = "data-v-f46a2896"
/* moduleIdentifier (server only) */
var paymentError___vue_module_identifier__ = null
var paymentError_Component = paymentError_normalizeComponent(
  paymentError,
  components_paymentError,
  paymentError___vue_template_functional__,
  paymentError___vue_styles__,
  paymentError___vue_scopeId__,
  paymentError___vue_module_identifier__
)
paymentError_Component.options.__file = "src/components/paymentError/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f46a2896", paymentError_Component.options)
  } else {
    hotAPI.reload("data-v-f46a2896", paymentError_Component.options)
  }
  module.hot.dispose(function (data) {
    paymentError_disposed = true
  })
})()}

/* harmony default export */ var src_components_paymentError = (paymentError_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/paymentSuccess/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var paymentSuccess_moment = __webpack_require__("PJh5");

/* harmony default export */ var paymentSuccess = ({
  name: 'paymentError',
  components: {},
  data: function data() {
    return {
      loadingState: false,
      userToken: '',
      vw: window.innerWidth,
      practice: ''
    };
  },

  methods: {},
  watch: {},
  updated: function updated() {},
  created: function created() {
    this.$log(this.$route.params.id);
    this.practice = this.$route.params.id;
  },
  mounted: function mounted() {},
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(vuex_esm["c" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48050120","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentSuccess/index.vue
var paymentSuccess_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull container-fluid mainBackVaillant pt-5 mt-5" },
    [
      _c("div", { staticClass: "row justify-content-center " }, [
        _c(
          "div",
          { staticClass: "widthFull container vaillantCont pt-5 mt-5" },
          [
            _c("div", { staticClass: "row justify-content-center pb-5 mb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6  center" }, [
                _c("h1", { staticClass: "h2 center Regular Bold  " }, [
                  _c("b", [_vm._v("Pratica " + _vm._s(_vm.practice))])
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-12 mt-5 center" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-secondary btn-lg",
                      attrs: { to: "/pratiche" }
                    },
                    [_vm._v(" Gestione Pratiche ")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ])
    ]
  )
}
var paymentSuccess_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12  center" }, [
      _c("img", {
        staticClass: "img-fluid payImage",
        attrs: { src: __webpack_require__("4AGf") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "center" }, [
      _c("b", [_vm._v("Grazie per averci scelto, ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "center " }, [
      _c("b", [_vm._v("il tuo pagamento è avvenuto con successo")])
    ])
  }
]
paymentSuccess_render._withStripped = true
var paymentSuccess_esExports = { render: paymentSuccess_render, staticRenderFns: paymentSuccess_staticRenderFns }
/* harmony default export */ var components_paymentSuccess = (paymentSuccess_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48050120", paymentSuccess_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/paymentSuccess/index.vue
var paymentSuccess_disposed = false
function paymentSuccess_injectStyle (ssrContext) {
  if (paymentSuccess_disposed) return
  __webpack_require__("sSMI")
}
var paymentSuccess_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var paymentSuccess___vue_template_functional__ = false
/* styles */
var paymentSuccess___vue_styles__ = paymentSuccess_injectStyle
/* scopeId */
var paymentSuccess___vue_scopeId__ = "data-v-48050120"
/* moduleIdentifier (server only) */
var paymentSuccess___vue_module_identifier__ = null
var paymentSuccess_Component = paymentSuccess_normalizeComponent(
  paymentSuccess,
  components_paymentSuccess,
  paymentSuccess___vue_template_functional__,
  paymentSuccess___vue_styles__,
  paymentSuccess___vue_scopeId__,
  paymentSuccess___vue_module_identifier__
)
paymentSuccess_Component.options.__file = "src/components/paymentSuccess/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48050120", paymentSuccess_Component.options)
  } else {
    hotAPI.reload("data-v-48050120", paymentSuccess_Component.options)
  }
  module.hot.dispose(function (data) {
    paymentSuccess_disposed = true
  })
})()}

/* harmony default export */ var src_components_paymentSuccess = (paymentSuccess_Component.exports);

// EXTERNAL MODULE: ./src/store/index.js + 3 modules
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/router/index.js




//import CheckAge from 'components/checkage'

//import Faq from 'components/faq'

//import Privacy from 'components/privacy'
































//import Forgotpassword from 'components/forgotpassword'
//import Recoverypassword from 'components/recoverypassword'
//import ComplateRegistration from 'components/ComplateRegistration'
//import Receipts from 'components/receipts'




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router_ifNotAuthenticated = function ifNotAuthenticated(to, from, next) {
  if (!store["a" /* default */].getters.isAuthenticated || !store["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

var router_ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (store["a" /* default */].getters.isProfileLoaded || store["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

var router_moment = __webpack_require__("PJh5");

var ifActive = function ifActive(to, from, next) {

  var finish = router_moment("2030-12-15 23:59:59");
  if (router_moment() < finish) {
    next();
    return;
  }
  next('/end');
};

var ifStart = function ifStart(to, from, next) {

  var start = router_moment("2021-01-15 00:00:00");
  if (router_moment() > start) {
    next();
    return;
  }
  next('/notActive');
};

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  //base: '/nttest/easybonus/',
  //base: '/ebonus/',
  base: '/',
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_home,
    beforeEnter: router_guards([ifStart, ifActive])

  }, {
    path: '/paymentError/:id',
    name: 'paymentError',
    component: src_components_paymentError,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/paymentSuccess/:id',
    name: 'paymentSuccess',
    component: src_components_paymentSuccess,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/registration',
    name: 'addClient',
    component: src_components_addClient,
    beforeEnter: router_guards([ifStart, ifActive, router_ifNotAuthenticated])

  }, {
    path: '/confirm',
    name: 'Confirm',
    component: src_components_confirm,
    beforeEnter: router_ifNotAuthenticated
  }, {
    path: '/forgot-password',
    name: 'Forgotpassword',
    component: src_components_forgotpassword,
    beforeEnter: router_ifNotAuthenticated
  }, {
    path: '/recovery-password',
    name: 'Recoverypassword',
    component: src_components_recoverypassword,
    beforeEnter: router_ifNotAuthenticated

  }, {
    path: '/Calcolatore',
    name: 'Calcolatore',
    component: src_components_calcolatore,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/account',
    name: 'Account',
    component: src_components_account,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/offerte',
    name: 'offerte',
    component: src_components_offerte,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/superbonus',
    name: 'superbonus',
    component: src_components_superbonus,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/acceptInvoice',
    name: 'acceptInvoice',
    component: src_components_acceptInvoice
    //beforeEnter: ifAuthenticated
  }, {
    path: '/editInvoice',
    name: 'editInvoice',
    component: src_components_editCalc
    //beforeEnter: ifAuthenticated
  }, {
    path: '/loadDocuments',
    name: 'loadDocuments',
    component: src_components_loadDocuments,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])
  }, {
    path: '/editDocument',
    name: 'editDocument',
    component: src_components_editDocuments,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])
  }, {
    path: '/pratiche',
    name: 'pratiche',
    component: src_components_pratiche,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/complateEneaData',
    name: 'complateEneaData',
    component: src_components_complateEneaData,
    beforeEnter: router_guards([ifStart, ifActive, router_ifAuthenticated])

  }, {
    path: '/login',
    name: 'Login',
    component: src_components_login,
    beforeEnter: router_guards([ifStart, ifActive, router_ifNotAuthenticated])
  }, {
    path: '/loginasgod',
    name: 'loginasgod',
    component: src_components_loginasgod
  },

  /*
  	{
      path: '/privacy',
      name: 'Privacy',
      component: Privacy,
  	 // beforeEnter: ifComplateAccount,
      },*/
  {
    path: '/validUser',
    name: 'admin',
    component: src_components_admin
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/cookie-policy',
    name: 'cookie',
    component: src_components_cookie
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/regulation',
    name: 'regulation',
    component: src_components_regulation
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/end',
    name: 'end',
    component: src_components_end
    // beforeEnter: ifComplateAccount,
  }, {
    path: '/notActive',
    name: 'notActive',
    component: src_components_notActive
    // beforeEnter: ifComplateAccount,
  }]
}));

// allows using multiple guards for routes
function router_guards(guards) {
  var _this = this;

  return function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
      var changed, mNext, i;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:

              // a flag to discard remaining guards
              changed = false;

              // handle next for multiple guards

              mNext = function mNext(value) {
                // prevent calling next after it is already resolved with a value
                if (changed) return;

                // if we have 'value' reslove next with the value and set changed flag
                if (typeof value != 'undefined') {
                  changed = true;
                  next(value);
                }
              };

              // call guards


              i = 0;

            case 3:
              if (!(i < guards.length)) {
                _context.next = 11;
                break;
              }

              if (!changed) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('break', 11);

            case 6:
              _context.next = 8;
              return guards[i](to, from, mNext);

            case 8:
              i++;
              _context.next = 3;
              break;

            case 11:

              // move on if none of guards resolved next with a value
              if (!changed) next();

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/loading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  props: {},
  components: {},
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6428c8d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/loading.vue
var loading_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var loading_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg_load" }, [
      _c("img", {
        staticClass: "loadScreen imgLoad",
        attrs: { src: __webpack_require__("vp/L") }
      })
    ])
  }
]
loading_render._withStripped = true
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var lib_loading = (loading_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6428c8d2", loading_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/lib/loading.vue
var loading_disposed = false
function loading_injectStyle (ssrContext) {
  if (loading_disposed) return
  __webpack_require__("8gwm")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = "data-v-6428c8d2"
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  loading,
  lib_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)
loading_Component.options.__file = "src/components/lib/loading.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6428c8d2", loading_Component.options)
  } else {
    hotAPI.reload("data-v-6428c8d2", loading_Component.options)
  }
  module.hot.dispose(function (data) {
    loading_disposed = true
  })
})()}

/* harmony default export */ var components_lib_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/lib/center-container.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var center_container = ({
  name: 'center-container'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-896ab43a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/center-container.vue
var center_container_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "center-container" }, [_vm._t("default")], 2)
}
var center_container_staticRenderFns = []
center_container_render._withStripped = true
var center_container_esExports = { render: center_container_render, staticRenderFns: center_container_staticRenderFns }
/* harmony default export */ var lib_center_container = (center_container_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-896ab43a", center_container_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/lib/center-container.vue
var center_container_disposed = false
function center_container_injectStyle (ssrContext) {
  if (center_container_disposed) return
  __webpack_require__("Ry4p")
}
var center_container_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var center_container___vue_template_functional__ = false
/* styles */
var center_container___vue_styles__ = center_container_injectStyle
/* scopeId */
var center_container___vue_scopeId__ = "data-v-896ab43a"
/* moduleIdentifier (server only) */
var center_container___vue_module_identifier__ = null
var center_container_Component = center_container_normalizeComponent(
  center_container,
  lib_center_container,
  center_container___vue_template_functional__,
  center_container___vue_styles__,
  center_container___vue_scopeId__,
  center_container___vue_module_identifier__
)
center_container_Component.options.__file = "src/components/lib/center-container.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-896ab43a", center_container_Component.options)
  } else {
    hotAPI.reload("data-v-896ab43a", center_container_Component.options)
  }
  module.hot.dispose(function (data) {
    center_container_disposed = true
  })
})()}

/* harmony default export */ var components_lib_center_container = (center_container_Component.exports);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/js/bootstrap.js
var bootstrap = __webpack_require__("K3J8");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var index_es = __webpack_require__("C/JF");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__("fhbW");

// EXTERNAL MODULE: ./node_modules/@fortawesome/vue-fontawesome/index.es.js
var vue_fontawesome_index_es = __webpack_require__("1e6/");

// EXTERNAL MODULE: ./node_modules/vue-headful/dist/vue-headful.js
var vue_headful = __webpack_require__("WiKS");
var vue_headful_default = /*#__PURE__*/__webpack_require__.n(vue_headful);

// EXTERNAL MODULE: ./src/utils/vee-validate/index.js
var vee_validate = __webpack_require__("byWf");

// EXTERNAL MODULE: ./node_modules/vue-sweetalert2/src/index.js
var src = __webpack_require__("oYt9");

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__("bm7V");
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./node_modules/vue-moment/dist/vue-moment.js
var vue_moment = __webpack_require__("8AgW");
var vue_moment_default = /*#__PURE__*/__webpack_require__.n(vue_moment);

// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__("Av7u");
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);

// EXTERNAL MODULE: ./node_modules/@chenfengyuan/vue-countdown/dist/vue-countdown.js
var vue_countdown = __webpack_require__("aCbg");
var vue_countdown_default = /*#__PURE__*/__webpack_require__.n(vue_countdown);

// EXTERNAL MODULE: ./node_modules/v-viewer/dist/v-viewer.js
var v_viewer = __webpack_require__("EAZf");
var v_viewer_default = /*#__PURE__*/__webpack_require__.n(v_viewer);

// EXTERNAL MODULE: ./node_modules/vue-paypal-checkout/dist/vue-paypal-checkout.esm.js
var vue_paypal_checkout_esm = __webpack_require__("PH4i");

// EXTERNAL MODULE: ./node_modules/vue-recaptcha-v3/dist/ReCaptchaVuePlugin.js
var ReCaptchaVuePlugin = __webpack_require__("oHEs");
var ReCaptchaVuePlugin_default = /*#__PURE__*/__webpack_require__.n(ReCaptchaVuePlugin);

// EXTERNAL MODULE: ./node_modules/vue-plugin-load-script/index.js
var vue_plugin_load_script = __webpack_require__("wmV6");

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var dist_vue_select = __webpack_require__("T1ft");
var dist_vue_select_default = /*#__PURE__*/__webpack_require__.n(dist_vue_select);

// EXTERNAL MODULE: ./node_modules/vue-numeral-filter/dist/vue-numeral-filter.es.js
var vue_numeral_filter_es = __webpack_require__("gu9R");

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral_numeral = __webpack_require__("ViqS");
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral_numeral);

// EXTERNAL MODULE: ./node_modules/vue-filter-number-format/dist/vue-filter-number-format.esm.min.js
var vue_filter_number_format_esm_min = __webpack_require__("BLOL");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// IE EXPLORER NEEDS

















//import VueAnalytics from 'vue-analytics'


vue_esm["a" /* default */].component(vue_countdown_default.a.name, vue_countdown_default.a);
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////CRYPT DATA///////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["a" /* default */].prototype.$encryptByAES = function (string, key) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse(key);
    var encrypted = crypto_js_default.a.AES.encrypt(string, ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(); // return ciphertext in hex format
  } else {
    return JSON.parse(string);
  }
};
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////DECRYPT DATA/////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
vue_esm["a" /* default */].prototype.$decryptByAES = function (string, key) {
  if (true) {
    var ckey = crypto_js_default.a.enc.Utf8.parse(key);
    var ciphertext = crypto_js_default.a.enc.Hex.parse(string);
    var srcs = crypto_js_default.a.enc.Base64.stringify(ciphertext);
    var decrypt = crypto_js_default.a.AES.decrypt(srcs, ckey, {
      mode: crypto_js_default.a.mode.ECB,
      padding: crypto_js_default.a.pad.Pkcs7
    });
    var decrypted = decrypt.toString(crypto_js_default.a.enc.Utf8);
    return JSON.parse(decrypted);
  } else {
    return string;
  }
};

vue_esm["a" /* default */].use(v_viewer_default.a);
v_viewer_default.a.setDefaults({
  fullscreen: true,
  inline: false
});
vue_esm["a" /* default */].prototype.$log = function (string) {
  if (false) {
    console.log(string);
  }
  return true;
};
vue_esm["a" /* default */].prototype.$warn = function (string) {
  if (false) {
    console.warn(string);
  }
  return true;
};
vue_esm["a" /* default */].prototype.$error = function (string) {
  if (false) {
    console.error(string);
  }
  return true;
};

vue_esm["a" /* default */].component('paypal-checkout', vue_paypal_checkout_esm["a" /* default */]);
vue_esm["a" /* default */].component('billing-page', vue_paypal_checkout_esm["a" /* default */]);


vue_esm["a" /* default */].use(ReCaptchaVuePlugin["VueReCaptcha"], {
  siteKey: '6Le9jeQUAAAAABWhlGbyFaHC2X4EpmKwQZIryQbV', //6Le9jeQUAAAAAOnPo0iTqQHNA_IQiB4I9WFEXYvI
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true
  }
});


vue_esm["a" /* default */].use(vue_plugin_load_script["a" /* default */]);

//Vue.use(VueAnalytics, {
//  id: 'UA-49774803-10',
//  router
//})
/*
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-ST09WDML37" }
}, router);*/


vue_esm["a" /* default */].component("v-select", dist_vue_select_default.a);

// VUE MOMENT
vue_esm["a" /* default */].use(vue_moment_default.a);

// Scroll TO
vue_esm["a" /* default */].use(vue_scrollto_default.a);

// SWEET ALERT 2
vue_esm["a" /* default */].use(src["a" /* default */]);

// HEAD DATA PLUGIN
vue_esm["a" /* default */].component('vue-headful', vue_headful_default.a);
// FONT AWEASOME PLUGIN
vue_esm["a" /* default */].component('font-awesome-icon', vue_fontawesome_index_es["a" /* FontAwesomeIcon */]);

// LOADSCREEN
vue_esm["a" /* default */].component('loading', components_lib_loading);
// CENTER CONTAINER
vue_esm["a" /* default */].component('center-container', components_lib_center_container);

vue_esm["a" /* default */].config.productionTip = false;

// ADD AWEASOME ICOMS:
index_es["c" /* library */].add(free_solid_svg_icons_index_es["z" /* faSpinner */], free_solid_svg_icons_index_es["a" /* faArrowLeft */], free_solid_svg_icons_index_es["q" /* faInfoCircle */], free_solid_svg_icons_index_es["k" /* faEye */], free_solid_svg_icons_index_es["h" /* faEdit */], free_solid_svg_icons_index_es["u" /* faPrint */], free_solid_svg_icons_index_es["o" /* faFilePdf */], free_solid_svg_icons_index_es["D" /* faTrashRestoreAlt */], free_solid_svg_icons_index_es["A" /* faStarOfLife */], free_solid_svg_icons_index_es["l" /* faFileAlt */], free_solid_svg_icons_index_es["d" /* faCheck */], free_solid_svg_icons_index_es["b" /* faBalanceScale */], free_solid_svg_icons_index_es["i" /* faEuroSign */], free_solid_svg_icons_index_es["g" /* faClipboardList */], free_solid_svg_icons_index_es["m" /* faFileDownload */], free_solid_svg_icons_index_es["j" /* faExclamationTriangle */], free_solid_svg_icons_index_es["f" /* faClipboardCheck */], free_solid_svg_icons_index_es["w" /* faSearch */], free_solid_svg_icons_index_es["E" /* faUser */], free_solid_svg_icons_index_es["s" /* faPhoneVolume */], free_solid_svg_icons_index_es["t" /* faPlusCircle */], free_solid_svg_icons_index_es["r" /* faMinus */], free_solid_svg_icons_index_es["B" /* faTimesCircle */], free_solid_svg_icons_index_es["C" /* faTrashAlt */], free_solid_svg_icons_index_es["e" /* faCheckCircle */], free_solid_svg_icons_index_es["n" /* faFileInvoice */], free_solid_svg_icons_index_es["v" /* faReceipt */], free_solid_svg_icons_index_es["F" /* faWineBottle */], free_solid_svg_icons_index_es["c" /* faCamera */], free_solid_svg_icons_index_es["x" /* faShippingFast */], free_solid_svg_icons_index_es["p" /* faGlobe */], free_solid_svg_icons_index_es["y" /* faShoppingCart */]);






vue_esm["a" /* default */].use(vue_numeral_filter_es["a" /* default */], { locale: 'it' });

vue_esm["a" /* default */].filter("formatNumber", function (value) {
  var value = parseFloat(value);
  return numeral_default()(value).format("0.0,[00]"); // displaying other groupings/separators is possible, look at the docs
});

vue_esm["a" /* default */].use(vee_validate["a" /* default */].core, vee_validate["a" /* default */].config);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store["a" /* default */],
  Loading: components_lib_loading,
  template: '<App/>',
  components: { App: src_App }

});

/***/ }),

/***/ "OBAr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-03a5036f] {\r\n  font-size: 26px;\n}\n.imageIcons[data-v-03a5036f] {\r\n  vertical-align: bottom !important;\r\n  width: 50px;\n}\n.hSize[data-v-03a5036f] {\r\n  font-size: 33px !important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-03a5036f] {\r\n  max-width: 333px;\r\n  text-align: left;\r\n  margin: 0 auto;\r\n  line-height: 27px;\r\n  padding-left: 61px;\n}\r\n\r\n/* new PRICE */\n.swal2-popup .swal2-title[data-v-03a5036f],\r\n#swal2-content[data-v-03a5036f] {\r\n  color: #fffbde !important;\r\n  display: block !important;\n}\n.replaceButton[data-v-03a5036f] {\r\n  max-width: 40px;\n}\n.inputHelper[data-v-03a5036f] {\r\n  margin-top: -32px;\r\n  color: #0e3d8b;\r\n  font-size: 16px;\r\n  left: 0;\n}\n.priceVal[data-v-03a5036f],\r\n.priceCent[data-v-03a5036f] {\r\n  width: calc(50% - 1.5vw - 7.5px);\r\n  display: inline-table;\n}\n.pseudoEuro[data-v-03a5036f] {\r\n  position: absolute;\r\n  top: 6px;\n}\n.pseudoCent[data-v-03a5036f] {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 0;\n}\n.group input:focus + .pseudoEuro[data-v-03a5036f] {\r\n  display: block;\n}\n.group .valid + .pseudoEuro[data-v-03a5036f] {\r\n  display: block;\n}\n.group input:focus + .pseudoCent[data-v-03a5036f] {\r\n  display: block;\n}\n.group .valid + .pseudoCent[data-v-03a5036f] {\r\n  display: block;\n}\n.euroInput[data-v-03a5036f] {\r\n  position: relative;\r\n  width: 200%;\r\n  z-index: 4;\n}\n.euroInput[data-v-03a5036f]::before {\r\n  content: \"Euro\";\n}\n.euroInput[data-v-03a5036f]:focus,\r\n.euroInput.valid[data-v-03a5036f] {\r\n  width: 100%;\n}\n.euroInput[data-v-03a5036f]:focus::before,\r\n.euroInput.valid[data-v-03a5036f]::before {\r\n  content: \"Euro\";\r\n  color: white;\r\n  position: absolute;\n}\n.table[data-v-03a5036f] {\r\n  display: table;\n}\n.newPriceLabel[data-v-03a5036f] {\r\n  z-index: 5;\r\n  background: white;\r\n  margin-left: -5px;\r\n  padding-left: 5px;\r\n  overflow: initial;\r\n  min-width: calc(200% + 17px);\n}\r\n\r\n/*  ------------ */\n.image-margin0[data-v-03a5036f] {\r\n  margin: 0 !important;\n}\n.helper[data-v-03a5036f] {\r\n  color: #0e3d8b;\r\n  font-size: 23px;\r\n  font-family: Oswald-Medium;\n}\n.greyDesc2[data-v-03a5036f] {\r\n  font-size: 1.1vw;\r\n  color: #fffbde;\n}\n.redDesc[data-v-03a5036f] {\r\n  font-size: 1.1vw;\r\n  text-decoration: underline;\r\n  cursor: pointer;\n}\n.uploadDone[data-v-03a5036f] {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 0;\r\n  color: #a1614f;\n}\n.helperUnderline[data-v-03a5036f] {\n}\n.labelFileInput[data-v-03a5036f] {\r\n  top: -20px !important;\r\n  font-size: 22px;\r\n  color: #000000;\n}\n.fileInput[data-v-03a5036f] {\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  top: 17px;\r\n  border-bottom: none;\r\n  color: #000000;\n}\n.fileInputLabel[data-v-03a5036f] {\r\n  z-index: 3;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-right: 20px;\r\n  text-overflow: ellipsis;\r\n  color: #fffbde;\n}\n.removeProduct[data-v-03a5036f] {\r\n  position: absolute;\r\n  right: 21px;\r\n  margin: 0px !important;\r\n  top: 48px;\r\n  color: #e7201d;\n}\n.typeDisabled[data-v-03a5036f] {\r\n  color: #676767;\r\n  cursor: pointer;\n}\n.typeSelected[data-v-03a5036f] {\r\n  color: #fffbde !important;\r\n  cursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-03a5036f] {\r\n    margin-top: -12px;\r\n    color: #0e3d8b;\r\n    font-size: 16px;\r\n    left: 0;\n}\n.hSize[data-v-03a5036f] {\r\n    font-size: 19px !important;\n}\n.sweetText[data-v-03a5036f] {\r\n    font-size: 19px;\n}\n.removeProduct[data-v-03a5036f] {\r\n    position: absolute;\r\n    right: 21px;\r\n    margin: 0px !important;\r\n    top: 26px;\r\n    color: #e7201d;\n}\n.greyDesc2[data-v-03a5036f],\r\n  .redDesc[data-v-03a5036f] {\r\n    font-size: 3.1vw;\n}\n.fluid[data-v-03a5036f] {\r\n    max-width: 107px;\n}\n.mobTQ[data-v-03a5036f] {\r\n    font-size: 23px;\n}\n.smMob[data-v-03a5036f] {\r\n    font-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-03a5036f] {\r\n    max-width: 350px;\r\n    text-align: left;\r\n    margin: 0 auto;\r\n    line-height: 27px;\r\n    padding-left: 43px;\r\n    font-size: 17px;\n}\n.helper[data-v-03a5036f] {\r\n    color: #0e3d8b;\r\n    font-size: 18px;\r\n    font-family: Oswald-Medium;\n}\n.imageIcons[data-v-03a5036f] {\r\n    vertical-align: bottom !important;\r\n    width: 39px;\n}\n.fileInput[data-v-03a5036f] {\r\n    top: 8px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-03a5036f] {\r\n    top: -250%;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "P5nk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-83256d60] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-83256d60] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-83256d60] {\n  width: 75px;\n}\n.bigTitle[data-v-83256d60] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-83256d60] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-83256d60] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-83256d60] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-83256d60] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-83256d60] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-83256d60] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-83256d60] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-83256d60] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-83256d60] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-83256d60] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-83256d60] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-83256d60] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-83256d60] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-83256d60] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-83256d60] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-83256d60]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-83256d60] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-83256d60] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-83256d60]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-83256d60]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-83256d60]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-83256d60] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-83256d60] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-83256d60] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "PFng":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "QCBm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Tayt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3b3ed8a3", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eacecb2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1eacecb2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QHXV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("XKjK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6b362660", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c3e6f9a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./stripe.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c3e6f9a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./stripe.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "R0yp":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("S2iD");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7fe0be0e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-89f7b05a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./emicon.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-89f7b05a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./emicon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "R870":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RH4N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/howplayBack.08e8a97.jpg";

/***/ }),

/***/ "Ry4p":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3Gu/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b7bbfb9c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-896ab43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./center-container.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-896ab43a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./center-container.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "S2iD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-89f7b05a] {\r\n  font-size: 26px;\n}\n.imageIcons[data-v-89f7b05a] {\r\n  vertical-align: bottom !important;\r\n  width: 50px;\n}\n.hSize[data-v-89f7b05a] {\r\n  font-size: 33px !important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-89f7b05a] {\r\n  max-width: 333px;\r\n  text-align: left;\r\n  margin: 0 auto;\r\n  line-height: 27px;\r\n  padding-left: 61px;\n}\r\n\r\n/* new PRICE */\n.swal2-popup .swal2-title[data-v-89f7b05a],\r\n#swal2-content[data-v-89f7b05a] {\r\n  color: #fffbde !important;\r\n  display: block !important;\n}\n.replaceButton[data-v-89f7b05a] {\r\n  max-width: 40px;\n}\n.inputHelper[data-v-89f7b05a] {\r\n  margin-top: -32px;\r\n  color: #0e3d8b;\r\n  font-size: 16px;\r\n  left: 0;\n}\n.priceVal[data-v-89f7b05a],\r\n.priceCent[data-v-89f7b05a] {\r\n  width: calc(50% - 1.5vw - 7.5px);\r\n  display: inline-table;\n}\n.pseudoEuro[data-v-89f7b05a] {\r\n  position: absolute;\r\n  top: 6px;\n}\n.pseudoCent[data-v-89f7b05a] {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 0;\n}\n.group input:focus + .pseudoEuro[data-v-89f7b05a] {\r\n  display: block;\n}\n.group .valid + .pseudoEuro[data-v-89f7b05a] {\r\n  display: block;\n}\n.group input:focus + .pseudoCent[data-v-89f7b05a] {\r\n  display: block;\n}\n.group .valid + .pseudoCent[data-v-89f7b05a] {\r\n  display: block;\n}\n.euroInput[data-v-89f7b05a] {\r\n  position: relative;\r\n  width: 200%;\r\n  z-index: 4;\n}\n.euroInput[data-v-89f7b05a]::before {\r\n  content: \"Euro\";\n}\n.euroInput[data-v-89f7b05a]:focus,\r\n.euroInput.valid[data-v-89f7b05a] {\r\n  width: 100%;\n}\n.euroInput[data-v-89f7b05a]:focus::before,\r\n.euroInput.valid[data-v-89f7b05a]::before {\r\n  content: \"Euro\";\r\n  color: white;\r\n  position: absolute;\n}\n.table[data-v-89f7b05a] {\r\n  display: table;\n}\n.newPriceLabel[data-v-89f7b05a] {\r\n  z-index: 5;\r\n  background: white;\r\n  margin-left: -5px;\r\n  padding-left: 5px;\r\n  overflow: initial;\r\n  min-width: calc(200% + 17px);\n}\r\n\r\n/*  ------------ */\n.image-margin0[data-v-89f7b05a] {\r\n  margin: 0 !important;\n}\n.helper[data-v-89f7b05a] {\r\n  color: #0e3d8b;\r\n  font-size: 23px;\r\n  font-family: Oswald-Medium;\n}\n.greyDesc2[data-v-89f7b05a] {\r\n  font-size: 1.1vw;\r\n  color: #fffbde;\n}\n.redDesc[data-v-89f7b05a] {\r\n  font-size: 1.1vw;\r\n  text-decoration: underline;\r\n  cursor: pointer;\n}\n.uploadDone[data-v-89f7b05a] {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 0;\r\n  color: #a1614f;\n}\n.helperUnderline[data-v-89f7b05a] {\n}\n.labelFileInput[data-v-89f7b05a] {\r\n  top: -20px !important;\r\n  font-size: 22px;\r\n  color: #000000;\n}\n.fileInput[data-v-89f7b05a] {\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  top: 17px;\r\n  border-bottom: none;\r\n  color: #000000;\n}\n.fileInputLabel[data-v-89f7b05a] {\r\n  z-index: 3;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-right: 20px;\r\n  text-overflow: ellipsis;\r\n  color: #fffbde;\n}\n.removeProduct[data-v-89f7b05a] {\r\n  position: absolute;\r\n  right: 21px;\r\n  margin: 0px !important;\r\n  top: 48px;\r\n  color: #e7201d;\n}\n.typeDisabled[data-v-89f7b05a] {\r\n  color: #676767;\r\n  cursor: pointer;\n}\n.typeSelected[data-v-89f7b05a] {\r\n  color: #fffbde !important;\r\n  cursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-89f7b05a] {\r\n    margin-top: -12px;\r\n    color: #0e3d8b;\r\n    font-size: 16px;\r\n    left: 0;\n}\n.hSize[data-v-89f7b05a] {\r\n    font-size: 19px !important;\n}\n.sweetText[data-v-89f7b05a] {\r\n    font-size: 19px;\n}\n.removeProduct[data-v-89f7b05a] {\r\n    position: absolute;\r\n    right: 21px;\r\n    margin: 0px !important;\r\n    top: 26px;\r\n    color: #e7201d;\n}\n.greyDesc2[data-v-89f7b05a],\r\n  .redDesc[data-v-89f7b05a] {\r\n    font-size: 3.1vw;\n}\n.fluid[data-v-89f7b05a] {\r\n    max-width: 107px;\n}\n.mobTQ[data-v-89f7b05a] {\r\n    font-size: 23px;\n}\n.smMob[data-v-89f7b05a] {\r\n    font-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-89f7b05a] {\r\n    max-width: 350px;\r\n    text-align: left;\r\n    margin: 0 auto;\r\n    line-height: 27px;\r\n    padding-left: 43px;\r\n    font-size: 17px;\n}\n.helper[data-v-89f7b05a] {\r\n    color: #0e3d8b;\r\n    font-size: 18px;\r\n    font-family: Oswald-Medium;\n}\n.imageIcons[data-v-89f7b05a] {\r\n    vertical-align: bottom !important;\r\n    width: 39px;\n}\n.fileInput[data-v-89f7b05a] {\r\n    top: 8px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-89f7b05a] {\r\n    top: -250%;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "SwIb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.errorIcon[data-v-48050120] {\n  max-width: 150px;\n  margin: 0 auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "Ta3C":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAC9BAMAAACzCBW9AAAAIVBMVEVHcEwAAAAAAAAAAAAAAAD///+/v79AQECAgICgoKDU1NSOav4+AAAABHRSTlMAv4BfvcYLmQAAAfhJREFUaN7t2U1OwkAUB3CNJ9B4ABcewAUXMBmosmb46Bq6cF1SDlBC4xpuAHpN30w/hykz7zWRaPP+Gxrglz+8DqWFmxsOh8PhcFy5u3fnocUMhCcvdo2PiCd6jW38NbZRNSN5OVPb6BqiGdCNqomJBmreU5pRNQeiUTWSZnQN0egamslraCavqU0YmWkxRU1tZmfrrMUUNRRT1oAJEgjGlDVgimd4TVVDMFUN3tQ1eFPXoGfQqEHPulGDNc0arGnWII1RgzRGDW5uZg1u/5g1KKNqNlmdGGEufBE4zaP19EDVEc3YO2vbrBFmZB5fPiTCDNsPZb9hyLPuoYmsdJv1IjODMY7vrOuayJ9zM/Wfgom+my5z+9PrgNfO9dZO39ZBBxNm/vDa4bXTunYSf/q+DrrM4Fr7J8Ll5D5/a836n5k3dRxLYEPd7kR1ZZQ6TH51sRRBfnIJ96z01sRrwsLII85M1VVJCibSGMwX7Jel08CjJ3kM1GNwYRiDiT0z0GYoJ9qILbw4qoENrNmWZgyn8hjznWyk3OdmpI2K8M5axqWZo81ckM0iFs3XtoOPte/9qPdczm2GnVtl1vhZV2Yl9yQDB69PdTfFFAOkm5Rswr3AmN4cqzJcDnwe0jBBQsiF35H8/2N0Mc8dzC2RvPLfahwOh9Pj/AA0o1r0yCrHfwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Tayt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.contactImg[data-v-1eacecb2] {\r\n  width: 47px;\r\n  -webkit-transform: rotate(62deg);\r\n          transform: rotate(62deg);\n}\n.sidebar-opened[data-v-1eacecb2] {\r\n  right: 0;\r\n  -webkit-animation: open;\r\n          animation: open;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.dropdown-toggle[data-v-1eacecb2] {\r\n  margin-top: 0px !important;\r\n  margin-bottom: 0px !important;\n}\n.sidetab > .label[data-v-1eacecb2] {\r\n  cursor: pointer;\r\n  border: 1px solid #9898ab;\r\n  font-size: 17px !important;\r\n  padding-top: 15px !important;\r\n  color: #fdfdfd;\r\n  height: 60px;\r\n  font-size: 21px;\r\n  font-weight: bold;\r\n  background: #0091da;\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n  padding-top: 3px;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  -webkit-box-shadow: 0 0 8px #262626;\r\n  box-shadow: 0 0 8px #262626;\n}\n.sidebar-opened > .label > .contactImg[data-v-1eacecb2] {\r\n  opacity: 0;\n}\n.tabMobile > .label[data-v-1eacecb2] {\r\n  background: transparent;\r\n  padding-top: 0px !important;\n}\n.sidebar-opened > .label[data-v-1eacecb2] {\r\n  background-color: #101417;\r\n  height: 48px;\r\n  color: transparent;\n}\n.content[data-v-1eacecb2] {\r\n  height: 240px;\r\n  padding-left: 39px;\r\n  padding-top: 31px;\n}\n.content[data-v-1eacecb2] {\r\n  background-color: #f2f2f2;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding-bottom: 10px;\n}\n.sidebar-closed[data-v-1eacecb2] {\r\n  -webkit-animation: close;\r\n          animation: close;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.sidetab[data-v-1eacecb2] {\r\n  width: 256px;\r\n  height: 280px;\r\n  border-top-left-radius: 50%;\r\n  border-top-right-radius: 50%;\r\n  left: auto;\r\n  top: 75%;\r\n  margin-top: -185px;\r\n  bottom: auto;\r\n  border-radius: 10px 10px 0 0;\r\n  -webkit-transform: rotate(-90deg);\r\n          transform: rotate(-90deg);\r\n  z-index: 2147483647;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n\r\n  position: fixed;\r\n  letter-spacing: 0px !important;\n}\n.sidetab2[data-v-1eacecb2] {\r\n  border-top-left-radius: 50%;\r\n  border-top-right-radius: 50%;\r\n  right: -223px;\r\n  -webkit-animation: reveal;\r\n          animation: reveal;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.sidetab2[data-v-1eacecb2] {\r\n  width: 187px;\r\n  height: 280px;\r\n  border-top-left-radius: 50%;\r\n  border-top-right-radius: 50%;\r\n  left: auto;\r\n  top: 25%;\r\n  margin-top: -15px;\r\n  bottom: auto;\r\n  border-radius: 10px 10px 0 0;\r\n  -webkit-transform: rotate(-90deg);\r\n          transform: rotate(-90deg);\r\n  z-index: 2147483647;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n\r\n  position: fixed;\r\n  letter-spacing: 0px !important;\n}\n.sidetab[data-v-1eacecb2] {\r\n  border-top-left-radius: 50%;\r\n  border-top-right-radius: 50%;\r\n  right: -223px;\r\n  -webkit-animation: reveal;\r\n          animation: reveal;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.sidetab2[data-v-1eacecb2] {\r\n  border-top-left-radius: 50%;\r\n  border-top-right-radius: 50%;\r\n  right: -188px;\r\n  -webkit-animation: reveal;\r\n          animation: reveal;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.sidetab2 > .label[data-v-1eacecb2] {\r\n  cursor: pointer;\r\n  border: 1px solid #9898ab;\r\n  font-size: 17px !important;\r\n  padding-top: 15px !important;\r\n  color: #fdfdfd;\r\n  height: 60px;\r\n  font-size: 21px;\r\n  font-weight: bold;\r\n  background: #0091da;\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n  padding-top: 3px;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  -webkit-box-shadow: 0 0 8px #262626;\r\n  box-shadow: 0 0 8px #262626;\n}\n.sidetab2.container .content[data-v-1eacecb2] {\r\n  background-color: #f2f2f2;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding-bottom: 10px;\n}\n.sidetab2.sidebar-opened[data-v-1eacecb2] {\r\n  right: 0 !important;\r\n  -webkit-animation: open;\r\n          animation: open;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.media-label[data-v-1eacecb2] {\r\n  padding: 4px 8px;\n}\n.inner-content[data-v-1eacecb2] {\r\n  -webkit-transform: rotate(90deg);\r\n          transform: rotate(90deg);\r\n  height: 173px;\n}\n.media[data-v-1eacecb2] {\r\n  width: 215px;\n}\n.content-message[data-v-1eacecb2] {\r\n  color: rgba(0, 0, 0, 0.54);\r\n  font-size: 14px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n  padding: 10px 0;\r\n  width: 200px;\n}\n.content-message[data-v-1eacecb2] {\r\n  padding: 8px 10px;\n}\n.sidetab.container .content[data-v-1eacecb2] {\r\n  background-color: #f2f2f2;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  padding-bottom: 10px;\n}\n.sidetab.sidebar-opened[data-v-1eacecb2] {\r\n  right: 0 !important;\r\n  -webkit-animation: open;\r\n          animation: open;\r\n  -webkit-animation-duration: 0.5s;\r\n          animation-duration: 0.5s;\r\n  -webkit-animation-timing-function: ease;\r\n          animation-timing-function: ease;\n}\n.fa-question-circle[data-v-1eacecb2] {\r\n  -webkit-transform: rotate(90deg);\r\n          transform: rotate(90deg);\r\n  color: #e3000f;\r\n  background: azure;\r\n  border-radius: 50%;\n}\n@media (min-width: 20px) and (max-width: 499px) {\n.cookieText[data-v-1eacecb2] {\r\n    font-size: 14px;\n}\n.cookieBaner[data-v-1eacecb2] {\r\n    height: 350px;\n}\n.notificationContent[data-v-1eacecb2] {\r\n    position: absolute;\r\n    z-index: 2;\r\n    left: 0;\r\n    top: 85px;\r\n    background: #ffd8ab;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    -webkit-transition: 0.3s ease !important;\r\n    transition: 0.3s ease !important;\r\n    height: 0px;\r\n    border-bottom: 10px solid #0091da;\n}\n}\n@media (min-width: 500px) and (max-width: 768px) {\n.cookieText[data-v-1eacecb2] {\r\n    font-size: 18px;\n}\n.cookieBaner[data-v-1eacecb2] {\r\n    height: 250px;\n}\n.notificationContent[data-v-1eacecb2] {\r\n    position: absolute;\r\n    z-index: 2;\r\n    left: 0;\r\n    top: 85px;\r\n    background: #ffd8ab;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    -webkit-transition: 0.3s ease !important;\r\n    transition: 0.3s ease !important;\r\n    height: 0px;\r\n    border-bottom: 10px solid #0091da;\n}\n}\n@media (min-width: 769px) and (max-width: 1550px) {\n.cookieText[data-v-1eacecb2] {\r\n    font-size: 15px;\n}\n}\n#site-nav .navbar-toggler[data-v-1eacecb2] {\n}\n#site-nav .navbar-toggler[data-v-1eacecb2] {\r\n  border: none !important;\r\n  background: transparent !important;\n}\n#site-nav .navbar-toggler .icon-bar[data-v-1eacecb2] {\r\n  width: 22px;\r\n  -webkit-transition: all 0.2s !important;\r\n  transition: all 0.2s !important;\r\n  width: 30px !important;\r\n  height: 3px !important;\r\n  display: block;\r\n  margin: 5px;\n}\n#site-nav .navbar-toggler .top-bar[data-v-1eacecb2] {\r\n  -webkit-transform: rotate(45deg);\r\n          transform: rotate(45deg);\r\n  -webkit-transform-origin: 10% 10% !important;\r\n          transform-origin: 10% 10% !important;\n}\n#site-nav .navbar-toggler .middle-bar[data-v-1eacecb2] {\r\n  opacity: 0 !important;\n}\n#site-nav .navbar-toggler .bottom-bar[data-v-1eacecb2] {\r\n  -webkit-transform: rotate(-45deg);\r\n          transform: rotate(-45deg);\r\n  -webkit-transform-origin: 10% 90% !important;\r\n          transform-origin: 10% 90% !important;\n}\n#site-nav .navbar-toggler.collapsed .top-bar[data-v-1eacecb2] {\r\n  -webkit-transform: rotate(0) !important;\r\n          transform: rotate(0) !important;\n}\n#site-nav .navbar-toggler.collapsed .middle-bar[data-v-1eacecb2] {\r\n  opacity: 1 !important;\n}\n#site-nav .navbar-toggler.collapsed .bottom-bar[data-v-1eacecb2] {\r\n  -webkit-transform: rotate(0) !important;\r\n          transform: rotate(0) !important;\n}\n.navbar-toggler .icon-bar[data-v-1eacecb2] {\r\n  background-color: #003587 !important;\n}\n.navbar-toggler[data-v-1eacecb2] {\r\n  padding: 0.25rem 0.75rem;\r\n  font-size: 1.25rem;\r\n  line-height: 15;\r\n  background-color: white;\r\n  border: 1px solid transparent;\r\n  border-radius: 0.25rem;\n}\r\n", ""]);

// exports


/***/ }),

/***/ "UdIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UqUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_productsTable_vue__ = __webpack_require__("YZMT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4__ = __webpack_require__("jCvU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_datatables_net_bs4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_datatables_net_buttons_js_dataTables_buttons_js__ = __webpack_require__("122j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_datatables_net_buttons_js_dataTables_buttons_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_datatables_net_buttons_js_dataTables_buttons_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_datatables_net_buttons_js_buttons_html5_js__ = __webpack_require__("wtxW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_datatables_net_buttons_js_buttons_html5_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_datatables_net_buttons_js_buttons_html5_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_datatables_net_buttons_js_buttons_print_js__ = __webpack_require__("Wqz6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_datatables_net_buttons_js_buttons_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_datatables_net_buttons_js_buttons_print_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_datatables_net_buttons_bs4__ = __webpack_require__("BJHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_datatables_net_buttons_bs4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_datatables_net_buttons_bs4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_datatables_net_select_bs4__ = __webpack_require__("urWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_datatables_net_select_bs4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_datatables_net_select_bs4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_datatables_net_select_bs4_css_select_bootstrap4_min_css__ = __webpack_require__("7N6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_datatables_net_select_bs4_css_select_bootstrap4_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_datatables_net_select_bs4_css_select_bootstrap4_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_datatables_net_buttons_bs4_css_buttons_bootstrap4_min_css__ = __webpack_require__("r20c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_datatables_net_buttons_bs4_css_buttons_bootstrap4_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_datatables_net_buttons_bs4_css_buttons_bootstrap4_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2__ = __webpack_require__("e7x4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import Datepicker from 'vuejs-datepicker'
//import {it} from 'vuejs-datepicker/dist/locale'
//import VueTimepicker from 'vue2-timepicker'




// import buttons and plugins



// import the rest






var moment = __webpack_require__("PJh5");

var _vue = this;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'users',
	components: {
		//Datepicker,
		//VueTimepicker,
		VdtnetTable: __WEBPACK_IMPORTED_MODULE_6__table_productsTable_vue__["a" /* default */]
	},
	//props: ["fields"],
	data: function data() {
		var _this = this;

		//const vm = this
		//const compiler = require('vue-template-compiler')
		return {
			loadingState: false,
			loaded: false,
			userToken: '',
			company: '',
			//username: '',
			//it: it,
			eventName: '',
			objectMail: '',
			sms: '',
			smsSender: '',
			json: {},
			textMail: '',
			eventDescription: '',
			_vue: this,
			//role: '',
			nome: '',
			password: '',
			active: 0,
			id: 0,
			rows: {},
			url: "https://wsbot.eu/ebonusBack/public/" + 'api/loadProducts?id=' + this.$route.params.id,
			routeParam: this.$route.params.id,
			options: {
				ajax: {
					url: "https://wsbot.eu/ebonusBack/public/" + 'api/loadProducts?id=' + this.$route.params.id,
					headers: {
						'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3",
						'Content-type': 'application/json'
					},
					type: 'GET',
					dataSrc: function dataSrc(json) {
						//this.buildFields(json)
						if (_this.$route.params.id) {
							return json.data;
						} else {
							return false;
						}
					}
				},
				buttons: [
					//'copy',
					//'print',
					//{
					//	 text: 'CSV',
					//	 extend: 'csv',
					//	 fieldSeparator: ';',
					//	 extension: '.csv'
					// }
					//{
					//	 text: 'Aggiungi utente',
					//	 action: function ( e, dt, node, config ) {
					//	  	_vue.a.methods.addUser( _vue.a, dt )
					//   }

					//},

				],
				/*eslint-disable */
				dom: "Btr<'row vdtnet-footer'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'pl>>",
				/*eslint-enable */
				responsive: true,
				processing: true,
				searching: true,
				searchDelay: 1500,
				destroy: true,
				ordering: true,
				lengthChange: true,
				serverSide: true,
				fixedHeader: true,
				saveState: true
			},
			fields: {
				confirmed: {
					label: 'Esito',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {

						if (data == 0) {
							return ' In Verifica ';
						}

						if (data == 1) {
							return ' Approvato ';
						}

						if (data == 2) {
							return ' Respinto <br/> <small> ' + row.confirm_info + '</small>';
						}

						if (data == 3) {
							if (row.confirm_info == 'finish') {
								return ' Documentazione non verificata per soglia premi/agenzia raggiunta ';
							}
							if (row.confirm_info == 'finish_award') {
								return ' Documentazione non verificata - obiettivo raggiunto ';
							}
						}
					}
				},
				credits: {
					label: 'Valore',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {

						if (data == 1) {
							return ' 25% del premio ';
						}

						if (data == 2) {
							return ' 50% del premio ';
						}
					}
				},
				azienda: { label: 'Azienda', sortable: true, searchable: true },
				partita_iva: { label: 'Partita IVA', sortable: true, searchable: true },
				codice_fiscale: { label: 'Codice Fiscale', sortable: true, searchable: true },

				barcode: {
					label: 'Matricola',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {
						return ' <a class="simpleLink green" target="_blank" href="' + row.image + '"> <small>' + data + '</small> </a> ';
					}
				},
				product: { label: 'Prodotto', sortable: true, searchable: true },

				invoice_number: {
					label: 'Prova d`acquisto',
					sortable: true,
					searchable: true,
					render: function render(data, display, row) {
						return ' <a class="simpleLink green" target="_blank" href="' + row.invoice + '"> <small>' + data + '</small> </a> ';
					}
				},

				invoice_date: { label: 'Data Doc.', sortable: true, searchable: true }

			},
			quickSearch: '',
			details: {},
			customTheme: {
				logo: "https://storage.googleapis.com/novatagstage/logo_custom.png",
				background: "https://storage.googleapis.com/novatagstage/custom_background.jpg",
				textColor: "#fff",
				windowColor: "#000000e0"
			}
		};
	},

	methods: {
		doLoadTable: function doLoadTable(cb) {},
		doAlertEdit: function doAlertEdit(data) {
			window.alert('row edit click for item ID: ' + data.id);
		},
		doAfterReload: function doAfterReload(data, table) {},
		doCreating: function doCreating(comp, el) {},
		doCreated: function doCreated(comp) {},
		doSearch: function doSearch() {
			this.$refs.table.search(this.quickSearch);
		},
		doExport: function doExport(type) {
			var parms = this.$refs.table.getServerParams();
			parms.export = type;
			window.alert('GET /api/v1/export?' + jQuery.param(parms));
		},
		formatCode: function formatCode(zipcode) {
			return zipcode.split('-')[0];
		},
		loadRegistrationData: function loadRegistrationData() {
			var _this2 = this;

			var _vue = this;
			var fields = {};

			var data = { getFieldsNames: true };

			_vue.loadingState = true;
			__WEBPACK_IMPORTED_MODULE_4_axios___default()({
				url: "https://wsbot.eu/ebonusBack/public/" + 'api/loadProducts?id=' + this.$route.params.id,
				method: 'POST',
				headers: { 'Authorization': 'Bearer ' + "f038eb84662817ba3e9cfd3210579a2e0f695ec3", 'Content-type': 'application/json' },
				data: data
			}).then(function (resp) {
				_vue.loadingState = false;
				_vue.rows = resp.data;
				//this.$log(_vue.rows)
				for (var x in _vue.rows) {
					fields[_vue.rows[x].db] = { label: '' + _vue.rows[x].db + '' };
				}
				//this.$log(fields)
				_vue.fields = fields;
				var table = _vue.$refs.table;
				_this2.$log(table);
				//table.dataTable.destroy()
				//table.dataTable.fields = fields
				table.dataTable.init();
				table.dataTable.draw(false);
				table.dataTable.columns.adjust();
				table.reload();
			}).catch(function (resp) {
				_vue.loadingState = false;
				_this2.$log(resp);
			});
		}
	},
	watch: {
		'$route.params.id': {
			handler: function handler(id) {
				this.$log(id);
				if (this.loaded) {
					//window.location.reload()
				}
			},
			deep: true,
			immediate: true
		},
		getProfile: function getProfile() {
			var _vue = this;
			_vue.id = _vue.$route.params.id;
			setTimeout(function () {
				_vue.id = _vue.$route.params.id;
				_vue.loaded = true;
			}, 1000);
		}
	},
	created: function created() {
		var _this3 = this;

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!_this3.$route.params.id) {
								_context.next = 5;
								break;
							}

							_context.next = 3;
							return _this3.loadRegistrationData();

						case 3:
							_context.next = 6;
							break;

						case 5:
							_this3.$router.push('/');

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this3);
		}))();
	},


	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
			var _this4 = this;

			var _vue;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_vue = this;

							this.id = this.$route.params.id;

							if (!this.$route.params.id) {
								_context2.next = 7;
								break;
							}

							_context2.next = 5;
							return this.loadRegistrationData();

						case 5:
							_context2.next = 8;
							break;

						case 7:
							this.$router.push('/');

						case 8:

							setTimeout(function () {
								_vue.loaded = true;
							}, 1000);

							window.onresize = function () {
								_this4.vw = window.innerWidth;
							};

						case 10:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}(),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['tappa', 'isAuthenticated', 'authStatus', 'tappa', 'getProfile']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
		authLoading: function authLoading(state) {
			return state.auth.status === 'loading';
		},
		profile: function profile(state) {
			return state.user.profile;
		}
	}))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "UuNy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.i(__webpack_require__("pDSP"), "");

// module
exports.push([module.i, "\n", ""]);

// exports


/***/ }),

/***/ "XKjK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nform[data-v-4c3e6f9a] {\r\n  width: 30vw;\r\n  min-width: 500px;\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\r\n  -webkit-box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\r\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\r\n          box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\r\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\r\n  border-radius: 7px;\r\n  padding: 40px;\n}\ninput[data-v-4c3e6f9a] {\r\n  border-radius: 6px;\r\n  margin-bottom: 6px;\r\n  padding: 12px;\r\n  border: 1px solid rgba(50, 50, 93, 0.1);\r\n  height: 44px;\r\n  font-size: 16px;\r\n  width: 100%;\r\n  background: white;\n}\n.result-message[data-v-4c3e6f9a] {\r\n  line-height: 22px;\r\n  font-size: 16px;\n}\n.result-message a[data-v-4c3e6f9a] {\r\n  color: rgb(89, 111, 214);\r\n  font-weight: 600;\r\n  text-decoration: none;\n}\n.hidden[data-v-4c3e6f9a] {\r\n  display: none;\n}\n#card-error[data-v-4c3e6f9a] {\r\n  color: rgb(105, 115, 134);\r\n  text-align: left;\r\n  font-size: 13px;\r\n  line-height: 17px;\r\n  margin-top: 12px;\n}\n#card-element[data-v-4c3e6f9a] {\r\n  border-radius: 4px 4px 0 0 ;\r\n  padding: 12px;\r\n  border: 1px solid rgba(50, 50, 93, 0.1);\r\n  height: 44px;\r\n  width: 100%;\r\n  background: white;\n}\n#payment-request-button[data-v-4c3e6f9a] {\r\n  margin-bottom: 32px;\n}\r\n/* Buttons and links */\nbutton[data-v-4c3e6f9a] {\r\n  background: #5469d4;\r\n  color: #ffffff;\r\n  font-family: Arial, sans-serif;\r\n  border-radius: 0 0 4px 4px;\r\n  border: 0;\r\n  padding: 12px 16px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: block;\r\n  -webkit-transition: all 0.2s ease;\r\n  transition: all 0.2s ease;\r\n  -webkit-box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\r\n          box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\r\n  width: 100%;\n}\nbutton[data-v-4c3e6f9a]:hover {\r\n  -webkit-filter: contrast(115%);\r\n          filter: contrast(115%);\n}\nbutton[data-v-4c3e6f9a]:disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\n}\r\n/* spinner/processing state, errors */\n.spinner[data-v-4c3e6f9a],\r\n.spinner[data-v-4c3e6f9a]:before,\r\n.spinner[data-v-4c3e6f9a]:after {\r\n  border-radius: 50%;\n}\n.spinner[data-v-4c3e6f9a] {\r\n  color: #ffffff;\r\n  font-size: 22px;\r\n  text-indent: -99999px;\r\n  margin: 0px auto;\r\n  position: relative;\r\n  width: 20px;\r\n  height: 20px;\r\n  -webkit-box-shadow: inset 0 0 0 2px;\r\n          box-shadow: inset 0 0 0 2px;\r\n  -webkit-transform: translateZ(0);\r\n  transform: translateZ(0);\n}\n.spinner[data-v-4c3e6f9a]:before,\r\n.spinner[data-v-4c3e6f9a]:after {\r\n  position: absolute;\r\n  content: \"\";\n}\n.spinner[data-v-4c3e6f9a]:before {\r\n  width: 10.4px;\r\n  height: 20.4px;\r\n  background: #5469d4;\r\n  border-radius: 20.4px 0 0 20.4px;\r\n  top: -0.2px;\r\n  left: -0.2px;\r\n  -webkit-transform-origin: 10.4px 10.2px;\r\n  transform-origin: 10.4px 10.2px;\r\n  -webkit-animation: loading-data-v-4c3e6f9a 2s infinite ease 1.5s;\r\n  animation: loading-data-v-4c3e6f9a 2s infinite ease 1.5s;\n}\n.spinner[data-v-4c3e6f9a]:after {\r\n  width: 10.4px;\r\n  height: 10.2px;\r\n  background: #5469d4;\r\n  border-radius: 0 10.2px 10.2px 0;\r\n  top: -0.1px;\r\n  left: 10.2px;\r\n  -webkit-transform-origin: 0px 10.2px;\r\n  transform-origin: 0px 10.2px;\r\n  -webkit-animation: loading-data-v-4c3e6f9a 2s infinite ease;\r\n  animation: loading-data-v-4c3e6f9a 2s infinite ease;\n}\n@-webkit-keyframes loading-data-v-4c3e6f9a {\n0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\n}\n100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\n}\n}\n@keyframes loading-data-v-4c3e6f9a {\n0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\n}\n100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\n}\n}\n@media only screen and (max-width: 600px) {\nform[data-v-4c3e6f9a] {\r\n    width: 80vw;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "YSGn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DEFAULT_LOGO.fc0893f.png";

/***/ }),

/***/ "YZMT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/table/productsTable.vue
var productsTable = __webpack_require__("FMAQ");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eab2c2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/productsTable.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [_vm._m(0)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        ref: "table",
        class: _vm.className,
        attrs: { id: _vm.tableId, cellpadding: "0" }
      },
      [
        _c("thead", { staticClass: "thead-dark" }, [
          _c(
            "tr",
            _vm._l(_vm.options.columns, function(field, i) {
              return _c(
                "th",
                { key: i, class: field.className },
                [
                  _vm._t(
                    "HEAD_" + field.name,
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(field.title) }
                      })
                    ],
                    { field: field, i: i }
                  )
                ],
                2
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("tbody"),
        _vm._v(" "),
        _c("tfoot", { attrs: { id: "footR" } })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var table_productsTable = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eab2c2e", esExports)
  }
}
// CONCATENATED MODULE: ./src/components/table/productsTable.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("Z9kb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  productsTable["a" /* default */],
  table_productsTable,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/table/productsTable.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6eab2c2e", Component.options)
  } else {
    hotAPI.reload("data-v-6eab2c2e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var components_table_productsTable = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z9kb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AaPU");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6ff88bc0", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6eab2c2e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./productsTable.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6eab2c2e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./productsTable.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ZDvS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aVkd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8f701f9a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4811f8f1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4811f8f1\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aHDP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9fMG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fb2516c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25a8184a\",\"scoped\":false,\"hasInlineConfig\":false}!../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./BadgerAccordionItem.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25a8184a\",\"scoped\":false,\"hasInlineConfig\":false}!../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./BadgerAccordionItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aVkd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-4811f8f1] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-4811f8f1] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-4811f8f1] {\n  width: 75px;\n}\n.bigTitle[data-v-4811f8f1] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-4811f8f1] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-4811f8f1] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-4811f8f1] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-4811f8f1] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-4811f8f1] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-4811f8f1] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-4811f8f1] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-4811f8f1] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-4811f8f1] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-4811f8f1] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-4811f8f1] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-4811f8f1] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-4811f8f1] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-4811f8f1] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-4811f8f1] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-4811f8f1]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-4811f8f1]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.front-image2[data-v-4811f8f1] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 29px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 100%;\n  margin-bottom: 0;\n  background: #00897e !important;\n  color: white;\n  border-radius: 5px;\n  overflow: hidden;\n  cursor: pointer;\n}\n@media screen and (max-width: 1024px) {\n.front-image2[data-v-4811f8f1] {\n      margin-top: 15px !important;\n}\n}\n.front-image2 > .fileInputLabel[data-v-4811f8f1] {\n    display: none;\n}\n.front-image2 > .invalid-feedback[data-v-4811f8f1] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image2 > input[data-v-4811f8f1] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 30px;\n    z-index: 10;\n    top: 0;\n    cursor: pointer !important;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 99;\n    /*This makes the button huge. If you want a bigger button, increase the font size*/\n    font-size: 50px;\n    /*Opacity settings for all browsers*/\n    opacity: 0;\n    -moz-opacity: 0;\n    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);\n}\n.front-image2 > label[data-v-4811f8f1] {\n    /*display: none;*/\n    cursor: pointer;\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image2 > label > span[data-v-4811f8f1] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 100%;\n      margin-top: 0 !important;\n      display: block;\n      height: 29px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 0;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 19px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n      cursor: pointer;\n}\n.front-image2 > label > span[data-v-4811f8f1]:before {\n        cursor: pointer;\n        content: \"CARICA\";\n        font-family: Regular;\n        font-weight: 300 !important;\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 29px;\n        width: 100%;\n        border-radius: 7px;\n        padding-top: 3px;\n        font-size: 0.775rem !important;\n        font-weight: 600;\n        color: white;\n        border: 3px solid #00917e;\n        /*padding: .55rem .55rem !important;*/\n        font-size: 0.775rem !important;\n        line-height: 0.9 !important;\n        border-radius: 0.1rem !important;\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label > span[data-v-4811f8f1] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image2 > label[data-v-4811f8f1]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 100%;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      cursor: pointer;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-4811f8f1]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image2 > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image2 > label[data-v-4811f8f1] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.niceInputLabel2[data-v-4811f8f1] {\n  color: #ffffff !important;\n  font-size: 21px;\n  font-weight: normal;\n  position: absolute;\n  pointer-events: none;\n  left: 0;\n  top: 0;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-right: 0;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n.center-container[data-v-4811f8f1] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "bYAS":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Gloria+Hallelujah);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);

// module
exports.push([module.i, "@font-face {\r\n  font-family: \"Regular\";\r\n  src: url(" + escape(__webpack_require__("z5ke")) + ");\r\n  src: url(" + escape(__webpack_require__("z5ke")) + "?#iefix) format('embedded-opentype'),\r\n    url(" + escape(__webpack_require__("LdOU")) + ") format(\"woff2\"),\r\n    url(" + escape(__webpack_require__("mJhL")) + "),\r\n    url(" + escape(__webpack_require__("mJhL")) + "?#iefix) format(\"embedded-opentype\");\r\n}\r\n\r\n.fa-lg {\r\n  color: red;\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n.cooper {\r\n  font-family: \"Regular\" !important;\r\n  text-shadow: 0px 0px 6px white, 0px 0px 12px white;\r\n}\r\n.imgIco{\r\n  border: 1px solid \t#BEBEBE;\r\n  border-radius: 50%;\r\n  padding: 25px;\r\n  background: #D3D3D3;\r\n}\r\n\r\n\r\n\r\n.notificationContent {\r\n  position: absolute;\r\n  z-index: 2;\r\n  left: 0;\r\n  top: 85px;\r\n  background: #ffd8ab;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  transition: .3s ease !important;\r\n  height: 0px;\r\n  border-bottom: 10px solid #00337f;\r\n}\r\n.theme{\r\n  color:#00337f!important;\r\n}\r\n.reverse {\r\n  display: flex;\r\n  flex-direction: column-reverse;\r\n}\r\n\r\n.notificationC {\r\n  transition: .3s ease !important;\r\n  height: 210%;\r\n}\r\n\r\n.maxNotification {\r\n  max-height: 100%;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.leftIm {\r\n  position: absolute;\r\n  width: 25px;\r\n  left: 19px;\r\n  top: 17px;\r\n}\r\n\r\n.leftIm2 {\r\n  position: absolute;\r\n  width: 25px;\r\n  left: 9px;\r\n  top: 17px;\r\n}\r\n\r\n.posWA {\r\n  left: 141px !important;\r\n  top: 18px;\r\n  width: 45px;\r\n}\r\n\r\n.rightIm {\r\n  position: absolute;\r\n  width: 25px;\r\n  right: 20px;\r\n  top: 17px;\r\n}\r\n\r\n.posTEL {\r\n  left: 178px !important;\r\n  top: 222px;\r\n  width: 45px;\r\n  transform: rotate(90deg);\r\n  filter: invert(100%);\r\n  opacity: .2;\r\n}\r\n\r\n.shadowBox {\r\n  background: white;\r\n  box-shadow: 0px 3px 13px 0px #00000094;\r\n}\r\n\r\n.Barlow-Black {\r\n  font-family: Regular;\r\n}\r\n\r\n.yellowX {\r\n  color: #e49632 !important;\r\n}\r\n\r\n.yellowY {\r\n  background: #e49632 !important;\r\n}\r\n\r\n.titleImg {\r\n  max-width: 150px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.azzure {\r\n  color: #a82a21 !important;\r\n}\r\n\r\n.dataContainer {\r\n  padding-top: 130px;\r\n}\r\n\r\n.Regular {\r\n  font-family: Regular;\r\n}\r\n\r\n.Bold-Italic {\r\n  font-family: Regular;\r\n}\r\n\r\n.Bold {\r\n  font-family: Regular;\r\n  font-weight: 800;\r\n}\r\n\r\n.scrollactive-item.activeMenuItem {\r\n  font-family: Regular !important;\r\n  color: #a82a21 !important;\r\n}\r\n\r\n.scrollactive-item.activeMenuItem {\r\n  font-family: Regular !important;\r\n}\r\n\r\n.carousel__indicator::before {\r\n  background-color: #000 !important;\r\n  height: 2.125rem;\r\n  left: 50%;\r\n  top: 50%;\r\n  width: 100%;\r\n}\r\n\r\n.carousel__indicators--disc>.carousel__indicator {\r\n  width: 1.55rem;\r\n}\r\n\r\n.carousel__indicators--disc>.carousel__indicator::before {\r\n  border-radius: 50%;\r\n  height: 0.7rem;\r\n  width: 0.7rem;\r\n}\r\n\r\n/* MAIN\r\n\r\nhtml{\r\n\toverflow: hidden;\r\n}\r\n*/\r\nhtml, body {\r\n  height: 100%;\r\n  font-family: Regular;\r\n  color: #333;\r\n  text-rendering: optimizeSpeed;\r\n  -webkit-text-size-adjust: 100%;\r\n  -moz-text-size-adjust: 100%;\r\n  -ms-text-size-adjust: 100%;\r\n  background: #fff;\r\n}\r\n\r\n.requiredCont {\r\n  border: 2px dashed red;\r\n  padding: 15px;\r\n  padding-top: 5px\r\n}\r\n\r\n.swal2-icon.swal2-info {\r\n  border-color: #f39324;\r\n  color: #f39324;\r\n}\r\n\r\n.green {\r\n  color: #0091da !important;\r\n}\r\n\r\n.section-heading {\r\n  font-size: 1.5rem;\r\n  line-height: 1.875rem;\r\n  font-weight: normal !important;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n  color: #fff;\r\n  border-color: #a50034;\r\n  background-color: #a50034;\r\n  font-family: Regular !important;\r\n}\r\n\r\n.borderBottom {\r\n  border-bottom: 2px solid grey;\r\n}\r\n\r\n.helperUnderline::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 70%;\r\n  left: 30%;\r\n  bottom: 0;\r\n  border: 1px dashed green;\r\n}\r\n\r\nbody {\r\n  -webkit-overflow-scrolling: touch;\r\n  overflow: scroll !important;\r\n  overflow-x: hidden !important;\r\n  background: WHITE;\r\n}\r\n\r\nh1.tizaFont {\r\n  font-size: 60px;\r\n}\r\n\r\n.customLink {\r\n  font-size: 15px !important;\r\n}\r\n\r\n.fancy {\r\n  line-height: 0.2;\r\n  text-align: center;\r\n}\r\n\r\n.fancy span {\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.fancy span:before,\r\n.fancy span:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  height: 5px;\r\n  border-bottom: 2.5px solid #000000;\r\n  border-top: 2.5px solid #000000;\r\n  top: 0;\r\n  width: 1800px;\r\n}\r\n\r\n.selectBonusCont {\r\n  padding: 1rem;\r\n  border: 2px solid #e3e3e3;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  background-color: #fff;\r\n  transition: all 0.2s;\r\n  z-index: 1;\r\n  position: relative;\r\n  transition: .3s all;\r\n}\r\n\r\n.selectBonusContBack {\r\n  position: absolute;\r\n  z-index: -1;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #0091da;\r\n  color: white;\r\n  text-align: center;\r\n  align-items: center;\r\n  align-self: center;\r\n  left: 0;\r\n  top: 0;\r\n  display: grid;\r\n  opacity: 0;\r\n  font-size: 22px;\r\n  font-weight: 500;\r\n  transition: .3s all;\r\n}\r\n\r\n.bonusSelected {\r\n  background: #0091da;\r\n}\r\n\r\n.selectBonusCont:hover>.selectBonusContBack {\r\n  background-color: #0091da;\r\n  z-index: 2;\r\n  opacity: 1;\r\n}\r\n\r\n.selectBonusCont:hover {\r\n  background-color: #0091da;\r\n}\r\n\r\n.mainBackVaillant {\r\n  min-height: calc(100vh);\r\n  background-color: #eee !important;\r\n}\r\n\r\n.bgWhite{\r\n  background: white;\r\n}\r\n\r\n.vaillantCont {\r\n  background-color: #fff !important;\r\n}\r\n\r\noptgroup {\r\n  background: #006293;\r\n  color: white;\r\n}\r\n\r\n.fancy span:before {\r\n  right: 120%;\r\n  margin-right: 15px;\r\n}\r\n\r\n.fancy span:after {\r\n  left: 120%;\r\n  margin-left: 15px;\r\n}\r\n\r\nbody.swal2-shown.swal2-height-auto {\r\n  padding: 0 !important;\r\n  overflow: scroll !important;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.lightRight {\r\n  background: #ffcacf;\r\n}\r\n\r\n.dashCont>.buttonTextCont {\r\n  display: none;\r\n}\r\n\r\n.lightGreen {\r\n  background: #00897e2b;\r\n}\r\n\r\n.swal2-popup.swal2-modal.swal2-show {}\r\n\r\n.fixed-top {\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  box-shadow: 0px 0px 14px #d5d5d5;\r\n  mix-blend-mode: multiply;\r\n  background: white;\r\n}\r\n\r\n.buttonTextCont {\r\n  padding: 5px;\r\n  border: 1px solid #d0d0d0;\r\n  margin: 0 auto;\r\n}\r\n\r\n.navGreen {\r\n  mix-blend-mode: normal;\r\n  max-width: 100vw;\r\n}\r\n\r\n#app {\r\n  min-height: 100%;\r\n}\r\n\r\n.tizaFont {\r\n  font-family: Tiza;\r\n  font-weight: 900;\r\n}\r\n\r\n.fixed {\r\n  position: fixed;\r\n}\r\n\r\na {\r\n  color: #fae49f;\r\n}\r\n\r\na:hover {\r\n  color: #ffc107;\r\n}\r\n\r\n.underline {\r\n  text-decoration: underline;\r\n}\r\n\r\n.greyBg {\r\n  background: #eeeeee;\r\n}\r\n\r\n.cookieBaner {\r\n  background: #0091da;\r\n  z-index: 155557;\r\n  margin: 0;\r\n  padding-top: 10px;\r\n  padding-bottom: 5px;\r\n  left: 0;\r\n  bottom: 0;\r\n  color: #ffffff;\r\n  height: 105px;\r\n  font-weight: 800;\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  align-self: center;\r\n  font-size: 18px;\r\n  display: flex;\r\n}\r\n\r\n.navbar-brand {\r\n  margin-right: 0;\r\n}\r\n\r\n.menuItem {\r\n  text-decoration: none;\r\n  font-family: Regular !important;\r\n  font-weight: 800 !important;\r\n  font-size: 16px;\r\n  margin: 15px;\r\n}\r\n\r\n.mobPlayButton {\r\n  margin-bottom: 0 !important;\r\n  width: 27vw !important;\r\n  font-size: 16px !important;\r\n  text-align: center !important;\r\n  padding: 5px !important;\r\n  margin-left: -3vw;\r\n}\r\n\r\n.js-badger-accordion-panel-inner {\r\n  color: black;\r\n  padding-top: 0vw;\r\n  padding-bottom: 1vw;\r\n  font-family: Regular !important;\r\n  font-size: 16px;\r\n  background: white;\r\n}\r\n\r\n.badger-accordion--initialized .badger-accordion__panel {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.badger-accordion-toggle {\r\n  font-size: 14px;\r\n}\r\n\r\n.greenLinkAccordion {\r\n  color: #00897e !important;\r\n  font-size: 15px;\r\n  text-transform: uppercase;\r\n  float: right;\r\n  font-weight: 700;\r\n  margin-top: 59px;\r\n}\r\n\r\n.inline-block {\r\n  display: inline-block;\r\n}\r\n\r\n.qrcodeText {\r\n  line-height: 10px;\r\n  margin-top: -10px !important;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n.qrcodeImg {\r\n  max-width: 150px;\r\n  margin-top: -11px;\r\n}\r\n\r\n.qrcodeImg {\r\n  max-width: 150px;\r\n  margin-top: -41px;\r\n}\r\n\r\n.card {\r\n  position: relative;\r\n  margin-bottom: 24px;\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);\r\n  box-shadow: none !important;\r\n  border: none\r\n}\r\n\r\n.step-progress {\r\n  padding: 5px;\r\n  background-color: #FAFAFA;\r\n  margin: 0 auto;\r\n}\r\n\r\n.step-progress .step-slider {\r\n  width: 100%;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item {\r\n  width: 25%;\r\n  padding-top: 10px;\r\n  height: 75px;\r\n  position: relative;\r\n  float: left;\r\n  /*background-color: #E0E0E0;*/\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item:after {\r\n  content: \"\";\r\n  width: 25px;\r\n  height: 25px;\r\n  position: absolute;\r\n  top: -13px;\r\n  right: -11px;\r\n  background-color: #eeeeee;\r\n  border: 1px solid #00897e;\r\n  border-radius: 50%;\r\n  z-index: 2;\r\n  transition: all 0.3s ease-out 0.5s;\r\n  -webkit-transition: all 0.3s ease-out 0.5s;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -6px;\r\n  left: 0;\r\n  width: 0%;\r\n  height: 10px;\r\n  background-color: #f39324;\r\n  z-index: 1;\r\n  -webkit-transition: all 0.5s ease-out;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item.active:before {\r\n  width: 100%;\r\n  background-color: #00337f;\r\n}\r\n\r\n.step-progress .step-slider .step-slider-item.active:after {\r\n  border-color: #00337f;\r\n}\r\n\r\n.step-content {\r\n  padding: 16px 0;\r\n}\r\n\r\n.invalid-feedback-custom {\r\n  color: red;\r\n  font-size: 13px;\r\n}\r\n\r\n.payImage {\r\n  max-width: 300px;\r\n  width: 100%;\r\n}\r\n\r\n.step-content .step-content-foot {\r\n  text-align: right;\r\n}\r\n\r\n.step-content .step-content-foot button {\r\n  border: 0;\r\n  padding: 8px 16px;\r\n  background-color: #CFD8DC;\r\n  font-size: 14px;\r\n  border-radius: 3px;\r\n  outline: 0;\r\n}\r\n\r\n.step-content .step-content-foot button:active {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.step-content .step-content-foot button.out {\r\n  display: none;\r\n}\r\n\r\n.step-slider-item.notactive {\r\n  background: #f9f9f9;\r\n}\r\n\r\n.step-slider-item.active {\r\n  background: #0091da85;\r\n}\r\n\r\n.yellow {\r\n  color: #f39324;\r\n}\r\n\r\n.step-slider-item.active.passed {\r\n  background: #00337fc2;\r\n  color: white;\r\n}\r\n\r\n.step-content .step-content-foot button.disable {\r\n  background-color: #ECEFF1;\r\n}\r\n\r\n.step-content .step-content-foot button.active {\r\n  background-color: #00ACC1;\r\n  color: white;\r\n}\r\n\r\n.custInput>.form-control, .custInput .vdp-datepicker div>.form-control {\r\n  background: transparent !important;\r\n  border: none !important;\r\n  border-bottom: 2px solid #0091da !important;\r\n      border-radius: 0 !important;\r\n      color: #000000 !important;\r\n  height: 70px !important;\r\n  outline: none !important;\r\n  padding-top: 24px;\r\n}\r\n\r\n.custInput>.disabled {\r\n  background: grey !important;\r\n  background: linear-gradient(0deg, rgba(147, 147, 147, 0.7287289915966386) 0%, rgba(255, 255, 255, 0) 70%) !important;\r\n}\r\n\r\n.custInput>.form-control:focus, .custInput .vdp-datepicker div>.form-control:focus {\r\n  color: #000000 !important;\r\n  outline: none !important;\r\n  height: 70px !important;\r\n  padding: 7px !important;\r\n  padding-top: 23px !important;\r\n}\r\n\r\n.removeProduct {\r\n  position: absolute;\r\n  top: 35px;\r\n  right: 33px;\r\n}\r\n\r\n.addProduct {}\r\n\r\n.custInput>input:focus~label, .custInput .valid~label {\r\n  top: 1px !important;\r\n  left: 4px !important;\r\n  font-size: 12px !important;\r\n  color: black !important;\r\n  outline: none !important;\r\n}\r\n\r\n.custInput .valid {\r\n  height: 70px !important;\r\n}\r\n\r\n.custInput {\r\n  margin-top: 0px;\r\n}\r\n\r\n.custInput>.niceInputLabel {\r\n  color: #000000 !important;\r\n  left: 5px !important;\r\n  top: 29px !important;\r\n}\r\n\r\n.step-content .step-content-body {\r\n  padding: 16px 0;\r\n  text-align: center;\r\n  font-size: 18px;\r\n  display: inline;\r\n}\r\n\r\n.stTitle {\r\n  font-size: 130%;\r\n  padding-top: 20px;\r\n  font-family: Regular;\r\n}\r\n\r\n.step-content .step-content-body.out {\r\n  display: none;\r\n}\r\n\r\n.traficLight {\r\n  max-width: 120px;\r\n}\r\n\r\n.greenLinkAccordion2 {\r\n  color: #00897e !important;\r\n  font-size: 15px;\r\n  text-transform: uppercase;\r\n  float: right;\r\n  font-weight: 700;\r\n  margin-top: 45px\r\n}\r\n\r\nspan.badger-toggle-indicator {\r\n  font-size: 32px;\r\n  line-height: 25px;\r\n  font-weight: 800;\r\n}\r\n\r\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-accordion-title {\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 97% !important;\r\n  flex: 0 0 97% !important;\r\n  cursor: pointer;\r\n  text-align: left;\r\n}\r\n\r\n.badger-accordion__header .js-badger-accordion-header .badger-accordion-toggle .badger-toggle-indicator {\r\n  -webkit-box-flex: 0;\r\n  -ms-flex: 0 0 3% !important;\r\n  flex: 0 0 3% !important;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  -webkit-box-pack: end;\r\n  -ms-flex-pack: end;\r\n  justify-content: flex-end;\r\n  cursor: pointer;\r\n}\r\n\r\n.component-badger-accordion {\r\n  font-family: Bold !important;\r\n  font-size: 18px;\r\n}\r\n\r\n.DKLemonYellowSunFont {\r\n  font-family: DKLemonYellowSun;\r\n}\r\n\r\n.DINPro-Bold {\r\n  font-family: Regular !important;\r\n}\r\n\r\nhr {\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 0;\r\n  border-top: 1px solid rgb(185, 185, 185);\r\n}\r\n\r\n.howplaybtn {\r\n  position: absolute !important;\r\n  right: 0 !important;\r\n  bottom: 80px !important;\r\n}\r\n\r\n.spbutton {\r\n  color: #c70000 !important;\r\n  background: white !important;\r\n  border-radius: 30px !important;\r\n  font-size: 30px !important;\r\n  line-height: 40px !important;\r\n  font-weight: 900 !important;\r\n  padding-top: 6px !important;\r\n  padding-bottom: 3px !important;\r\n  padding-left: 40px !important;\r\n  padding-right: 40px !important;\r\n  box-shadow: inset 0px -11px 20px 7px #9a9a9a !important;\r\n}\r\n\r\n.bbaBackground {\r\n  background: #a82a21;\r\n}\r\n\r\n.alert-success {\r\n  color: #fffbde;\r\n  background-color: #00ff3d00;\r\n  border-color: transparent;\r\n  text-align: center;\r\n  font-size: x-large;\r\n}\r\n\r\n.card {\r\n  background-color: transparent;\r\n}\r\n\r\n.bbaRed {\r\n  color: #d9222a !important;\r\n}\r\n\r\nsmall {\r\n  font-size: 15px;\r\n}\r\n\r\n.textAlt {\r\n  transform: scale(.9, 1.5);\r\n}\r\n\r\n.widthFull {\r\n  width: 100%;\r\n}\r\n\r\n.mainBack {\r\n  min-width: 100vw;\r\n  width: 100vw;\r\n  min-height: 100vh;\r\n  background: url(" + escape(__webpack_require__("DydT")) + ");\r\n  background-size: cover;\r\n  background-position: left;\r\n}\r\n\r\n.calcBack {\r\n  min-width: 100vw;\r\n  width: 100vw;\r\n  min-height: 100vh;\r\n  background: url(" + escape(__webpack_require__("2TQw")) + ");\r\n  background-size: cover;\r\n  background-position: bottom;\r\n}\r\n\r\n.logo{\r\n  max-width: 150px;\r\n}\r\n\r\n.logo:before {\r\n  content: '';\r\n  width: 150px;\r\n  position: absolute;\r\n  top: 0;\r\n  left: auto;\r\n  background: url(" + escape(__webpack_require__("iQH9")) + ");\r\n  right: 107px;\r\n  background-size: contain;\r\n  background-position: left;\r\n  height: 105px;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.h1B {\r\n  font-size: 60px;\r\n}\r\n\r\n.login {\r\n  width: 100%;\r\n  color: black !important;\r\n  margin: 0 auto;\r\n}\r\n\r\n.h100 {\r\n  min-height: 100vh;\r\n  min-width: 100vw;\r\n}\r\n\r\n.center-container {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 100%;\r\n}\r\n\r\n.centerFlex {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.bm-menu {\r\n  background-color: #008479;\r\n  padding-top: 0;\r\n}\r\n\r\n.bm-burger-bars {\r\n  background-color: #3c3c3c;\r\n}\r\n\r\n.skewHalf {\r\n  min-height: 100vh;\r\n  z-index: 2;\r\n}\r\n\r\n.center-container>img {\r\n  max-width: 450px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.skewHalf::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -13vw;\r\n  top: 0;\r\n  height: 100vh;\r\n  width: 63vw;\r\n  background: #0091da;\r\n  z-index: -1;\r\n  transform: skewX(-10deg);\r\n  box-shadow: 3px -1px 13px 0px #000000c7;\r\n}\r\n\r\n.mt-header {\r\n  padding-top: 135px;\r\n}\r\n\r\n.bm-burger-button {\r\n  cursor: pointer;\r\n  height: 30px;\r\n  left: 36px;\r\n  position: absolute;\r\n  top: 45px;\r\n  width: 36px;\r\n  z-index: 100;\r\n}\r\n\r\n.whiteBackground {\r\n  /*\r\n\tbackground: url(../../assets/images/bg-pattern2.jpg);\r\n\tbackground-size: 200px 200px;\r\n\tbackground-repeat: repeat;\r\n\t*/\r\n  background: white;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    max-width: 1340px !important;\r\n  }\r\n\r\n  .swal2-popup.swal2-modal.swal2-show {\r\n    min-width: 777px;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .container {\r\n    max-width: 100vw;\r\n  }\r\n\r\n  .span.stepImage.center.pl-5.pr-5.stepDesc.pb-3 {\r\n    padding-right: 0 !important;\r\n    padding-left: 0 !important;\r\n  }\r\n}\r\n\r\n.black {\r\n  color: #333 !important;\r\n}\r\n\r\n.formBack {\r\n  background: #042366;\r\n  box-shadow: 0px 0px 11px 0px white;\r\n}\r\n\r\n.formHeader {\r\n  background: white;\r\n  color: #0e235b;\r\n  font-weight: 700;\r\n}\r\n\r\n.red {\r\n  color: red !important;\r\n}\r\n\r\n.jumbotron {\r\n  background-color: transparent;\r\n}\r\n\r\n.navbar-brand {\r\n  width: 196px;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.pdfViewer {\r\n  z-index: 5555555\r\n}\r\n\r\n.littlePdf {\r\n  position: absolute;\r\n  font-size: 9px;\r\n  margin-top: -3px;\r\n  left: -3px;\r\n  bottom: -15px\r\n}\r\n\r\n.howPlayTitle {\r\n  max-width: 486px;\r\n}\r\n\r\n.howplayContainers {\r\n  max-width: 356px;\r\n  background: white;\r\n  margin: 0 auto;\r\n}\r\n\r\n.howPlayImg {\r\n  max-width: 80%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.bg-light {\r\n  background-color: white !important;\r\n}\r\n\r\n.main {\r\n  overflow: hidden;\r\n  padding-top: 0px;\r\n  /*padding-bottom:320px;  this needs to be bigger than footer height*/\r\n  min-height: 100vh;\r\n  padding-bottom: 70px;\r\n  height: 100%;\r\n}\r\n\r\n.vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover {\r\n  background: #e15267;\r\n}\r\n\r\n.socialLogin {\r\n  min-height: 150px;\r\n}\r\n\r\n.noVisible {\r\n  opacity: 0;\r\n}\r\n\r\n.smallDesc {\r\n  font-size: 16px !important;\r\n  line-height: 19px;\r\n}\r\n\r\n.navmobile {\r\n  display: none;\r\n}\r\n\r\n/* FOOTER */\r\n.footer {\r\n  position: relative;\r\n  margin-top: -70px;\r\n  height: 70px;\r\n  clear: both;\r\n  padding-top: 0px;\r\n  background: white;\r\n}\r\n\r\n/* CUSTOM */\r\n.center {\r\n  text-align: center;\r\n}\r\n\r\n.fullWidth {\r\n  width: 100%;\r\n}\r\n\r\n.formError {\r\n  color: #d60043;\r\n  font-size: medium;\r\n  font-weight: bold;\r\n}\r\n\r\n#content {\r\n  text-align: center !important;\r\n}\r\n\r\n#oa_social_login_container {\r\n  padding-top: 10px;\r\n}\r\n\r\niframe {\r\n  width: auto !important;\r\n  padding: 15px;\r\n  border-radius: 15px !important;\r\n  padding-left: 0;\r\n  min-height: 81px;\r\n  padding-top: 0px;\r\n}\r\n\r\n.bbaWhite {\r\n  color: black;\r\n}\r\n\r\nselect option {\r\n  background: #0091da;\r\n  color: #ffffff;\r\n}\r\n\r\noption:checked {\r\n  background: #0091da !important;\r\n}\r\n\r\noption:[selected] {\r\n  background: red !important;\r\n}\r\n\r\nselect[multiple]:focus option:checked {\r\n  background: #820900 !important;\r\n}\r\n\r\niframe~.name {\r\n  color: #f8bb08;\r\n}\r\n\r\n.provider {\r\n  color: #f8bb08;\r\n}\r\n\r\n#providers {\r\n  display: inline-block !important;\r\n  float: none !important;\r\n}\r\n\r\n.verticalCentred {\r\n  height: 85vh !important;\r\n}\r\n\r\n.loadSpinner {\r\n  position: absolute;\r\n  right: 25px;\r\n  bottom: 10px;\r\n}\r\n\r\n.closeProductsModal {\r\n  background: black;\r\n}\r\n\r\n.form-control {\r\n  background-color: transparent;\r\n  color: #000000 !important;\r\n  border: none;\r\n  border-bottom: 1px solid black;\r\n  padding: 7px;\r\n  border-radius: 0px !important;\r\n  border-top: none !important;\r\n  font-family: Regular !important;\r\n  font-weight: 700;\r\n  font-size: 1.1rem;\r\n  height: 52px;\r\n  outline: none !important;\r\n}\r\n\r\n.modalText {\r\n  color: #fffbde;\r\n}\r\n\r\n.even {\r\n  color: #000000;\r\n  background: #00736a26;\r\n  border-radius: 25px;\r\n}\r\n\r\n.closeProductsModal {}\r\n\r\n.swal2-popup.swal2-modal.swal2-show {\r\n  background: linear-gradient(\r\n0deg\r\n, #0091da, #0075ac);\r\n  color: #2196F3 !important;\r\n  border-radius: 25px;\r\n  border: 1px solid #ffffff;\r\n  box-shadow: 1px 1px 20px 0px #b1e7ff;\r\n}\r\n\r\n.dashboardCount {\r\n  font-size: 55px;\r\n}\r\n\r\n.dashboardCard {\r\n  background: linear-gradient(0deg, #005f52, #0091da);\r\n  color: white !important;\r\n  padding-top: 23px;\r\n  padding-bottom: 33px;\r\n  border-radius: 7px;\r\n  border: 1px solid white;\r\n  box-shadow: 0px 5px 18px 0px #1d1d1d;\r\n}\r\n\r\n.pdfLink {\r\n  color: #0091da !important;\r\n  position: absolute;\r\n  right: 0;\r\n  left: auto;\r\n  bottom: 0;\r\n  text-decoration: underline;\r\n  font-weight: 900;\r\n  z-index: 1111111111111111;\r\n}\r\n\r\n.greenButton {\r\n  background: #00736a;\r\n  color: white;\r\n  padding: 5px;\r\n}\r\n\r\n.table td, .table th {\r\n  padding: .75rem;\r\n  vertical-align: middle;\r\n  border-top: 1px solid #dee2e6;\r\n}\r\n\r\n.swal2-success-circular-line-left, .swal2-success-fix, .swal2-success-circular-line-right {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.swal2-popup .swal2-title, #swal2-content {\r\n  color: #ffffff;\r\n}\r\n\r\ndt.badger-accordion__header {\r\n  background: white;\r\n  padding: .5rem;\r\n}\r\n\r\n.errorBg {\r\n  background: #ff7d7d;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\nbutton:focus {\r\n  outline: 1px dotted;\r\n  outline: none;\r\n}\r\n\r\n.successBg {\r\n  background: green;\r\n  padding-top: 5px;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.loadBox {\r\n  background: white;\r\n  box-shadow: 0px 0px 8px #8c8c8c;\r\n  border-radius: 7px;\r\n  padding-bottom: 1.5rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.swal2-popup .swal2-styled.swal2-confirm {\r\n  background-color: #f39324 !important;\r\n}\r\n\r\n.pointer, .nav-link {\r\n  cursor: pointer;\r\n}\r\n\r\n.nav-link {\r\n  color: #00337f !important;\r\n  font-weight: bold;\r\n  text-decoration: none !important;\r\n  /*text-transform: uppercase;*/\r\n  font-family: Regular;\r\n}\r\n\r\n.navWhite {\r\n  background: white;\r\n}\r\n\r\n.uppercase {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.btn-outline-secondary {\r\n  color: #ffffff;\r\n  border-color: #6c757d;\r\n  background: #00736a;\r\n}\r\n\r\n.seePass {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 0;\r\n  color: #a50034;\r\n}\r\n\r\n.table .thead-dark th {\r\n  color: #fff;\r\n  background-color: #00736a;\r\n  border-color: #17151a;\r\n}\r\n\r\n.btn-primary {\r\n  text-transform: uppercase !important;\r\n  font-family: Regular !important;\r\n  border-radius: 31px !important;\r\n  border-bottom-right-radius: 0px !important;\r\n  font-size: 18px !important;\r\n  padding: 13px !important;\r\n  box-shadow: -1px 0px 15px 0px #ffffff;\r\n  color: white;\r\n  border-color: #0091da !important;\r\n  background-color: #0091da !important;\r\n  padding-left: 32px !important;\r\n  padding-right: 32px !important;\r\n}\r\n\r\n.whiteCont {\r\n  margin-top: 70px !important;\r\n  background: linear-gradient(0deg, rgba(244, 244, 244, 0.7287289915966386) 0%, rgba(244, 244, 244, 0.1287289915966386) 40%, rgba(255, 255, 255, 0) 100%);\r\n  border: none;\r\n  border-radius: 49px;\r\n}\r\n\r\n.stepTitle {\r\n  font-size: 17px;\r\n  font-weight: 800;\r\n}\r\n\r\n.divider {\r\n  width: calc(100% + 100px) !important;\r\n  margin-left: -35px !important;\r\n  height: 18px !important;\r\n  background: #eeeeee !important;\r\n}\r\n\r\n.vue-form-wizard .wizard-nav-pills>li>a {\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  -ms-flex-direction: column;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0 auto;\r\n  color: rgb(0 0 0 / 40%);\r\n  position: relative;\r\n  top: 3px;\r\n}\r\n\r\n.btnWhite {\r\n  text-transform: uppercase !important;\r\n  font-family: Regular !important;\r\n  border-radius: 31px !important;\r\n  border-bottom-right-radius: 0px !important;\r\n  font-size: 22px !important;\r\n  padding: 13px !important;\r\n  box-shadow: -1px 0px 15px 0px #ffffff;\r\n  font-weight: 900;\r\n  padding-left: 32px !important;\r\n  padding-right: 32px !important;\r\n  color: #0091da;\r\n  background-color: white !important;\r\n  border-color: white !important;\r\n  min-width: 80%;\r\n  box-shadow: none;\r\n}\r\n\r\n.btnWhite:hover {\r\n  color: #0091da !important;\r\n  background-color: white !important;\r\n  border-color: white !important;\r\n  min-width: 80% !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\nsvg.svg-inline--fa.fa-search.fa-w-16.fa-sm {\r\n  color: #f39324;\r\n}\r\n\r\n.form-check-input.is-invalid~.form-check-label, .was-validated .form-check-input:invalid~.form-check-label {\r\n  color: #880726;\r\n}\r\n\r\n.imagesViewer {\r\n  display: none;\r\n}\r\n\r\n.progress {\r\n  background-color: #00000054;\r\n  border-radius: .25rem;\r\n  position: absolute;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 98%;\r\n  z-index: 5;\r\n  border-bottom-left-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.progress-bar {\r\n  color: white;\r\n  background: #0091da !important;\r\n  transition: width .6s ease;\r\n  font-size: 20px;\r\n  opacity: .8;\r\n}\r\n\r\n.rotate90 {\r\n  -webkit-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg); // IE9 only\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.viewer-open>#app {\r\n  filter: blur(3px);\r\n}\r\n\r\n.tableSimulator {\r\n  border: 1px solid grey\r\n}\r\n\r\n.docThumb {\r\n  color: #00897e;\r\n  margin: 1px;\r\n}\r\n\r\n.viewer-navbar {\r\n  background-color: #00897e;\r\n  overflow: hidden;\r\n  height: 20vh;\r\n}\r\n\r\n.viewer-list {\r\n  -webkit-box-sizing: content-box;\r\n  box-sizing: content-box;\r\n  height: 100%;\r\n  margin: 0;\r\n  overflow: hidden;\r\n  padding: 1px 0;\r\n}\r\n\r\n.viewer-list>li {\r\n  color: transparent;\r\n  cursor: pointer;\r\n  float: left;\r\n  font-size: 0;\r\n  height: 100%;\r\n  line-height: 0;\r\n  opacity: 0.5;\r\n  overflow: hidden;\r\n  -webkit-transition: opacity 0.15s;\r\n  transition: opacity 0.15s;\r\n  width: 100px;\r\n}\r\n\r\n.viewer-open {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.viewer-navbar {\r\n  background-color: rgb(0 68 63);\r\n  overflow: hidden;\r\n  height: 20vh;\r\n}\r\n\r\n.btn-primary:hover {\r\n  color: white;\r\n  background: #cc6e00 !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.btn, .wizard-btn {\r\n  border-radius: 0 !important;\r\n  font-weight: normal;\r\n  font-family: Regular !important;\r\n  display: inline-block;\r\n  margin-bottom: 0;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  -ms-touch-action: manipulation;\r\n  touch-action: manipulation;\r\n  cursor: pointer;\r\n  background-image: none;\r\n  border: 1px solid transparent;\r\n  white-space: nowrap;\r\n  padding: 6px 12px;\r\n  font-size: 14px;\r\n  line-height: 1.42857;\r\n  border-radius: 4px;\r\n  background: #0091da !important;\r\n  border: none !important;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.btn:hover {\r\n  box-shadow: 0px 1px 8px 2px #4e4d4d;\r\n}\r\n\r\n.siteBackground {\r\n  /*\r\n\tbackground: url(../../assets/images/bg-pattern.jpg);\r\n\tbackground-size: 200px 200px;\r\n\tbackground-repeat: repeat;\r\n\t*/\r\n}\r\n\r\n.dividerImg {\r\n  width: 100vw;\r\n  height: 50px;\r\n}\r\n\r\n.brownDesc {\r\n  color: #fffbde;\r\n  font-family: museo-slab;\r\n  font-weight: 600;\r\n  font-size: 1.88vw;\r\n}\r\n\r\n.redDesc {\r\n  color: #d9222a;\r\n  font-size: 2.08vw;\r\n}\r\n\r\n.red {\r\n  color: #ff222c;\r\n}\r\n\r\n.sidebarHeader {\r\n  margin-left: -11%;\r\n  background: #0091da;\r\n}\r\n\r\n.ibanForm {\r\n  background: #ffffffc4;\r\n  border-radius: 50px;\r\n  padding: 73px;\r\n}\r\n\r\n.greyDesc {\r\n  color: #fffbde;\r\n  font-size: 2.08vw;\r\n}\r\n\r\n.headerRigth {\r\n  text-align: left;\r\n}\r\n\r\n.headerLeft {\r\n  text-align: right;\r\n}\r\n\r\n.headerImgMain {\r\n  width: 70%;\r\n  z-index: 3;\r\n  position: relative;\r\n}\r\n\r\n.dateInput[readonly] {\r\n  background-color: #e9ecef00;\r\n  opacity: 1;\r\n}\r\n\r\n.display-time[readonly] {\r\n  background-color: transparent;\r\n  opacity: 1;\r\n  padding: .375rem .75rem !important;\r\n  margin-top: 3px;\r\n  font-weight: 600;\r\n  color: transparent;\r\n}\r\n\r\n.time-picker {\r\n  width: 100% !important;\r\n}\r\n\r\n.inline {\r\n  display: inline-block;\r\n}\r\n\r\n.fileInput.is-invalid~.invalid-feedback {\r\n  display: block;\r\n}\r\n\r\n.invalid-feedback {\r\n  color: #ff1100;\r\n  font-size: 15px !important;\r\n  font-weight: bold;\r\n}\r\n\r\n.time-picker.valid .display-time {\r\n  color: #ffffff !important;\r\n  margin-top: -3px !important;\r\n  font-weight: 400;\r\n}\r\n\r\n.time-picker .dropdown {\r\n  width: 100% !important;\r\n  border: 1px solid;\r\n  border-radius: 5px;\r\n  background: #ffffff !important;\r\n  z-index: 7 !important;\r\n  color: #0e235b !important;\r\n}\r\n\r\n.time-picker .dropdown .select-list {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.text-warning {\r\n  color: #be8e00 !important;\r\n}\r\n\r\n.time-picker .dropdown ul li.active, .time-picker .dropdown ul li.active:hover {\r\n  background: #135b96 !important;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.time-picker .dropdown ul li {\r\n  text-align: center;\r\n  padding: 0.3em 0;\r\n  color: #0e235b !important;\r\n}\r\n\r\n.fitAvailableHeight {\r\n  /*\r\n\tmin-height: -webkit-fill-available;\r\n\tmin-height: -moz-available;\r\n    min-height: stretch;\r\n\r\n\theight: auto;\r\n\t*/\r\n  position: relative;\r\n  display: block;\r\n  overflow: auto;\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.custom-control-input:checked~.custom-control-label::before {\r\n  color: #fff;\r\n  border-color: #185d57;\r\n  background-color: #00796e;\r\n}\r\n\r\n.time-picker .dropdown ul {\r\n  width: 50%;\r\n  margin: 5px !important;\r\n  overflow-y: scroll !important;\r\n}\r\n\r\n.grey {\r\n  color: #767676e6;\r\n}\r\n\r\n.form-control:disabled, .form-control[readonly] {\r\n  background-color: transparent;\r\n  opacity: 1;\r\n}\r\n\r\n.w-100 {\r\n  width: 100%;\r\n}\r\n\r\n.vdp-datepicker__calendar {\r\n  width: 100% !important;\r\n  min-width: 330px;\r\n  border: 1px solid #000 !important;\r\n  border-radius: 5px !important;\r\n  background-color: #ffffff;\r\n  font-weight: 700;\r\n  color: #0e235b !important;\r\n  padding: 10px;\r\n  font-family: Regular;\r\n}\r\n\r\n.vdp-datepicker__calendar .disabled {\r\n  color: #b3b3b3;\r\n  cursor: default;\r\n}\r\n\r\n.display-time {\r\n  background-color: transparent;\r\n  border: 1px solid #482f24 !important;\r\n  border-top: none !important;\r\n  border-left: none !important;\r\n  border-right: none !important;\r\n  display: block;\r\n  width: 100% !important;\r\n  height: calc(1.5em + .75rem + 2px);\r\n  padding: .375rem .75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #495057;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ced4da;\r\n  border-radius: .25rem;\r\n  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n  border-bottom: none !important;\r\n  margin-top: -3px;\r\n}\r\n\r\n.group {\r\n  position: relative;\r\n  margin: 1vw;\r\n  margin-bottom: 25px !important;\r\n}\r\n\r\n.navbar-light .navbar-toggler {\r\n  color: rgb(64, 20, 7);\r\n  border-color: rgb(64, 20, 7);\r\n  margin-right: 15px;\r\n}\r\n\r\n.borderRed {\r\n  border-bottom: 1px solid #89082d !important;\r\n  color: #89082d !important;\r\n}\r\n\r\n.image-margin0 {\r\n  margin: 0 !important;\r\n  margin-top: 0 !important;\r\n}\r\n\r\n@media (min-width: 767px) and (max-width: 992px) {\r\n  .navDesktop {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-brand.navmobile {\r\n    position: relative;\r\n    width: 100vw !important;\r\n    text-align: center;\r\n    display: block;\r\n  }\r\n\r\n  .seachMobButton {\r\n    padding: 0 !important;\r\n    height: 30px !important;\r\n  }\r\n\r\n  .navmobileImage {\r\n    width: 111px !important;\r\n    margin-right: 1vw;\r\n  }\r\n\r\n  .navbar-light .navbar-toggler {\r\n    margin-top: 25px;\r\n    position: absolute;\r\n    right: 0px;\r\n    border: none;\r\n  }\r\n\r\n  .fixed-top {\r\n    padding-top: 0px;\r\n  }\r\n}\r\n\r\n.custom-toggler.navbar-toggler {\r\n  border-color: rgb(242, 28, 20);\r\n}\r\n\r\n.custom-toggler .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgb(0, 155, 173)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\");\r\n}\r\n\r\n.btn-group-sm>.btn, .btn-sm {\r\n  padding: .55rem .75rem !important;\r\n  font-size: .875rem !important;\r\n  line-height: 1.5 !important;\r\n  border-radius: .2rem !important;\r\n}\r\n\r\n.mandatoryDoc {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 5px;\r\n}\r\n\r\n@media (min-width: 20px) and (max-width: 767px) {\r\n  .navDesktop {\r\n    display: none;\r\n  }\r\n\r\n  .qrcodeImg {\r\n    max-width: 150px;\r\n    margin-top: 1px;\r\n  }\r\n\r\n  .selectBonusContBack {\r\n    display: none;\r\n  }\r\n\r\n  .fixed-top {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .mobSearchT {\r\n    font-size: 18px !important;\r\n    padding-bottom: 0 !important;\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .howplaybtn {\r\n    position: relative !important;\r\n    right: 0 !important;\r\n    margin-top: 90px !important;\r\n  }\r\n\r\n  .selectBonusContBack {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .step-progress .step-slider .step-slider-item {\r\n    width: 100%;\r\n    padding-top: 10px;\r\n    height: 65px;\r\n    position: relative;\r\n    float: left;\r\n    /* background-color: #E0E0E0; */\r\n  }\r\n\r\n  .stTitle {\r\n    font-size: 100%;\r\n    padding-top: 20px;\r\n    font-family: Regular;\r\n  }\r\n\r\n  .center-container {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    min-height: -47vh;\r\n  }\r\n\r\n  .docTitleMob {\r\n    font-size: 1.1rem !important;\r\n  }\r\n\r\n  .editImageCont {\r\n    max-height: 150px !important;\r\n    max-width: 150px !important;\r\n    width: 100% !important;\r\n    height: 150px !important;\r\n    cursor: zoom-in;\r\n    object-fit: cover;\r\n  }\r\n\r\n  .seachMobButton {\r\n    padding: 0 !important;\r\n    height: 30px !important;\r\n    background: transparent !important;\r\n    border-radius: 0 !important;\r\n    border: none !important;\r\n    font-size: 11px;\r\n    border-bottom: 1px solid black !important;\r\n    padding-top: 10px !important;\r\n  }\r\n\r\n  .maxBomTr {\r\n    max-width: 70px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .maxBomTr2 {\r\n    max-width: 100px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .codCount {\r\n    right: 0px !important;\r\n  }\r\n\r\n  .h1, h1 {\r\n    font-size: 1.7rem;\r\n  }\r\n\r\n  .h2, h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .h3, h3 {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .h4, h4 {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .h5, h5 {\r\n    font-size: .9rem;\r\n  }\r\n\r\n  .tablePdMob {\r\n    padding-bottom: 15px;\r\n  }\r\n\r\n  .btn-sm {\r\n    padding: .25rem .5rem !important;\r\n    font-size: .675rem !important;\r\n    line-height: 1.5 !important;\r\n    border-radius: .2rem !important;\r\n  }\r\n\r\n  .logo:before {\r\n    content: '';\r\n    width: 150px !important;\r\n    position: absolute;\r\n    top: 0;\r\n    right: 7px !important;\r\n    background-size: contain;\r\n    background-position: left;\r\n    height: 57px !important;\r\n    background-repeat: no-repeat !important;\r\n  }\r\n\r\n  .bm-burger-button {\r\n    cursor: pointer;\r\n    height: 30px;\r\n    left: 12px;\r\n    position: absolute;\r\n    top: 14px;\r\n    width: 36px;\r\n    z-index: 100;\r\n    right: 12px !important;\r\n  }\r\n\r\n  .ibanForm {\r\n    background: #ffffffc4;\r\n    border-radius: 15px !important;\r\n    padding: 3px !important;\r\n    padding-top: 23px !important;\r\n  }\r\n\r\n  .loginBack {\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    height: auto;\r\n    width: 100vw;\r\n    height: 100vw;\r\n    padding-top: 30px;\r\n    padding-bottom: 30px;\r\n  }\r\n\r\n  .login {\r\n    width: 90%;\r\n    color: black !important;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .navbar-light .navbar-toggler {\r\n    margin-top: 4px;\r\n    margin-right: 0;\r\n    position: absolute;\r\n    right: 0px;\r\n    border: none;\r\n    top: 15px;\r\n  }\r\n\r\n  .titleMobSize {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .navbar-brand.navmobile {\r\n    position: relative;\r\n    width: 100vw !important;\r\n    text-align: center;\r\n    display: block;\r\n  }\r\n\r\n  .navmobileImage {\r\n    width: 111px !important;\r\n    margin-right: 1vw;\r\n  }\r\n\r\n  .cookieBaner {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n    font-weight: 800;\r\n    vertical-align: middle;\r\n    align-items: center;\r\n    align-self: center;\r\n    font-size: 12px;\r\n    display: flex;\r\n    height: 200px;\r\n  }\r\n\r\n  .swal2-popup.swal2-modal.swal2-show {\r\n    width: 100% !important;\r\n  }\r\n\r\n  .swal2-popup #swal2-content {\r\n    text-align: center;\r\n    font-size: 12px;\r\n  }\r\n\r\n  h2#swal2-title {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .tizaFont {\r\n    font-size: 18px;\r\n  }\r\n\r\n  h1.tizaFont {\r\n    font-size: 30px !important;\r\n  }\r\n\r\n  .DINPro-Bold {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .badger-accordion-toggle {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .js-badger-accordion-panel-inner {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .niceInputLabel {\r\n    font-size: 19px !important;\r\n    top: 8px !important;\r\n  }\r\n\r\n  .group input:focus~label, .group .valid~label {\r\n    top: 5px;\r\n    left: 34px;\r\n    font-size: 12px;\r\n    color: #a2a2a2 !important;\r\n  }\r\n\r\n  .headerRigth, .headerLeft {\r\n    text-align: center;\r\n  }\r\n\r\n  .redDesc, .brownDesc, .greyDesc {\r\n    font-size: 4.08vw;\r\n  }\r\n\r\n  /**.mt-5 {\r\n\t\tmargin-top: 1rem!important;\r\n\t}**/\r\n  .modalText {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .main {\r\n    padding-top: 0px;\r\n    padding-bottom: 606px;\r\n    min-height: 100vh;\r\n    height: 100%;\r\n  }\r\n\r\n  .mobPlayButton {\r\n    min-width: 30vw !important;\r\n  }\r\n\r\n  .navbar-brand {\r\n    width: 110px;\r\n  }\r\n\r\n  .lastNavLink {\r\n    margin-bottom: 30px;\r\n    padding-left: 10px !important;\r\n    padding-right: 10px !important;\r\n  }\r\n\r\n  iframe {\r\n    padding-left: 12px;\r\n    padding-top: 0px !important;\r\n  }\r\n}\r\n\r\n.playButton {\r\n  color: white;\r\n  font-family: \"Regular\";\r\n  background: #e15267;\r\n  color: white;\r\n  line-height: 21px;\r\n  font-size: 22px;\r\n  border-radius: 8px;\r\n  align-self: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.white {\r\n  color: white !important;\r\n}\r\n\r\n.nav-fill .nav-item {\r\n  vertical-align: middle;\r\n  align-items: center;\r\n  align-self: center;\r\n}\r\n\r\na:not([href]):not([tabindex]) {\r\n  color: #FF9800;\r\n  text-decoration: none;\r\n}\r\n\r\na:not([href]):not([tabindex]):focus, a:not([href]):not([tabindex]):hover {\r\n  color: #FF9800;\r\n  text-decoration: none;\r\n}\r\n\r\n/* INPUTS */\r\n/* Change Autocomplete styles in Chrome*/\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus textarea:-webkit-autofill,\r\ntextarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,\r\nselect:-webkit-autofill,\r\nselect:-webkit-autofill:hover,\r\nselect:-webkit-autofill:focus {\r\n  border-left: none !important;\r\n  border-right: none !important;\r\n  -webkit-text-fill-color: #000000 !important;\r\n  -webkit-box-shadow: 0 0 0px 1000px #0000 inset;\r\n  transition: background-color 5000s ease-in-out 0s;\r\n  background: transparent;\r\n  background-color: transparent !important;\r\n}\r\n\r\n/* form starting stylings ------------------------------- */\r\n.group {\r\n  position: relative;\r\n  margin: 1vw;\r\n}\r\n\r\ninput, .display-time {\r\n  font-size: 18px;\r\n  padding: 10px 10px 10px 5px;\r\n  display: block;\r\n  border: none;\r\n  border-bottom: 1px solid #757575;\r\n}\r\n\r\ninput:focus {\r\n  outline: none;\r\n}\r\n\r\n/* LABEL ======================================= */\r\n.niceInputLabel {\r\n  color: #ffffff !important;\r\n  font-size: 21px;\r\n  font-weight: normal;\r\n  position: absolute;\r\n  pointer-events: none;\r\n  left: 33px;\r\n  top: 20px;\r\n  transition: 0.2s ease all;\r\n  -moz-transition: 0.2s ease all;\r\n  -webkit-transition: 0.2s ease all;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-right: 20px;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n}\r\n\r\n/* active state */\r\n.group input:focus~label, .group .valid~label {\r\n  top: 5px;\r\n  left: 34px;\r\n  font-size: 12px;\r\n  color: #a2a2a2 !important\r\n}\r\n\r\n.backButton {\r\n  position: fixed;\r\n  z-index: -1;\r\n  left: 90px;\r\n  top: 27px;\r\n}\r\n\r\n/* BOTTOM BARS ================================= */\r\n.bar {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.bar:before, .bar:after {\r\n  content: '';\r\n  height: 1px;\r\n  width: 0;\r\n  bottom: 1px;\r\n  position: absolute;\r\n  background: #fffbde;\r\n  transition: 0.2s ease all;\r\n  -moz-transition: 0.2s ease all;\r\n  -webkit-transition: 0.2s ease all;\r\n}\r\n\r\n.bar:before {\r\n  left: 40%;\r\n}\r\n\r\n.bar:after {\r\n  right: 40%;\r\n}\r\n\r\n/* active state */\r\n.group input:focus~.bar:before, .group input:focus~.bar:after {\r\n  width: 50%;\r\n}\r\n\r\n/* HIGHLIGHTER ================================== */\r\n.highlight {\r\n  position: absolute;\r\n  height: 60%;\r\n  width: 100px;\r\n  top: 25%;\r\n  left: 0;\r\n  pointer-events: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n/* active state */\r\ninput:focus~.highlight {\r\n  -webkit-animation: inputHighlighter 0.3s ease;\r\n  -moz-animation: inputHighlighter 0.3s ease;\r\n  animation: inputHighlighter 0.3s ease;\r\n}\r\n\r\n/* ANIMATIONS ================ */\r\n@-webkit-keyframes inputHighlighter {\r\n  from {\r\n    background: #5264AE;\r\n  }\r\n\r\n  to {\r\n    width: 0;\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n@-moz-keyframes inputHighlighter {\r\n  from {\r\n    background: #5264AE;\r\n  }\r\n\r\n  to {\r\n    width: 0;\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n@keyframes inputHighlighter {\r\n  from {\r\n    background: #5264AE;\r\n  }\r\n\r\n  to {\r\n    width: 0;\r\n    background: transparent;\r\n  }\r\n}\r\n\r\n.form-control.is-invalid, .was-validated .form-control:invalid {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n  color: transparent;\r\n  background-image: none;\r\n}\r\n\r\n.display-time.is-invalid, .was-validated .display-time:invalid {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n  background-image: none;\r\n}\r\n\r\n.form-control.is-invalid:focus, .was-validated .form-control:invalid:focus {\r\n  border-color: #dc3545;\r\n  box-shadow: none;\r\n  border-top: none;\r\n}\r\n\r\n.display-time.is-invalid:focus, .was-validated .display-time:invalid:focus {\r\n  border-color: #dc3545;\r\n  box-shadow: none;\r\n  border-top: none;\r\n}\r\n\r\n.form-control {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n}\r\n\r\n.display-time {\r\n  border-top: none;\r\n  border-right: none;\r\n  border-left: none;\r\n  border-radius: 0;\r\n}\r\n\r\n.form-control:focus {\r\n  color: #495057;\r\n  background-color: transparent;\r\n  border-color: black;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.form-control:focus {\r\n  /*background-color: #0091da;\r\n  color: #000000 !important;\r\n  border: 1px solid #0091da !important;\r\n  padding: 33px;\r\n  border-radius: 50px !important;\r\n  border-top: 5px solid #008372 !important;\r\n  font-family: Regular !important;\r\n  font-weight: 700;\r\n  box-shadow: none!important;*/\r\n}\r\n\r\n.gaugeText>p {\r\n  line-height: 12%;\r\n  text-align: center;\r\n  align-items: baseline;\r\n}\r\n\r\n.gaugeText>p>small {\r\n  font-size: 10px;\r\n}\r\n\r\n.display-time:focus {\r\n  color: #00000000;\r\n  background-color: transparent;\r\n  border-color: #015325;\r\n  outline: 0;\r\n  box-shadow: none;\r\n}\r\n\r\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\r\n  margin: 1em 0 0.5em;\r\n  word-wrap: break-word;\r\n  -webkit-hyphens: auto;\r\n  -ms-hyphens: auto;\r\n  hyphens: auto;\r\n  overflow-wrap: break-word;\r\n  font-weight: normal;\r\n  font-family: 'Regular';\r\n  color: #333;\r\n}\r\n\r\n.btnYellow {\r\n  background: #0091da !important;\r\n    border: none !important;\r\n}\r\n\r\n.btnYellow:hover {\r\n  color: white;\r\n  background: #cc6e00 !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.howplayImages {\r\n  max-width: 600px;\r\n}\r\n\r\n.btn-green {\r\n  background: #00897e !important;\r\n}\r\n\r\n.btn-blue {\r\n  background: #00337f !important;\r\n}\r\n\r\n.btn-xl {\r\n  padding: .55rem .35rem !important;\r\n  font-size: .715rem !important;\r\n  line-height: .9 !important;\r\n  border-radius: .3rem !important;\r\n}\r\n\r\n.btn-danger {\r\n  color: #fff !important;\r\n  background-color: #dc3545 !important;\r\n  border-color: #dc3545 !important;\r\n  text-decoration: none !important\r\n}\r\n\r\n.editImageCont {\r\n  max-height: 250px;\r\n  max-width: 250px;\r\n  width: 100%;\r\n  height: 250px;\r\n  cursor: zoom-in;\r\n  object-fit: cover;\r\n}\r\n\r\n.btn-info {\r\n  color: #fff !important;\r\n  background-color: #9d9d9d !important;\r\n  border-color: #666666 !important;\r\n  text-decoration: none !important;\r\n}\r\n\r\n.swal2-icon.swal2-warning {\r\n  border-color: #FF9800;\r\n  color: #FF9800;\r\n}\r\n\r\n.mr-auto, .mx-auto {\r\n  margin-right: auto !important;\r\n  margin-top: 19px;\r\n}\r\n\r\ndt.badger-accordion__header {\r\n  background: white;\r\n  padding: .5rem;\r\n  box-shadow: 0px 0px 5px #00000078;\r\n  padding: 30px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.bordered {\r\n  /*border: 1px solid #f4f4f4;*/\r\n}\r\n\r\n.vcenter {\r\n  align-self: center;\r\n  align-items: center;\r\n  height: 100% !important;\r\n}\r\n\r\ninput.swal2-input {\r\n  max-width: 300px;\r\n}\r\n\r\n.outer {\r\n  display: table;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.swal2-shown>#app {\r\n  filter: blur(5px);\r\n}\r\n\r\n.even {\r\n  background: #00897e12 !important;\r\n  border-radius: 0px;\r\n}\r\n\r\n.middle {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n}\r\n\r\n.borderTopBlack {\r\n  border-top: 1px solid black;\r\n}\r\n\r\n.borderTopTras {\r\n  border-top: 1px solid transparent;\r\n}\r\n\r\n.inner {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 400px;\r\n  /*whatever width you want*/\r\n}\r\n\r\n.ptImage {\r\n  max-width: 150px\r\n}\r\n\r\n.viewer-list>li {\r\n  color: transparent;\r\n  cursor: pointer;\r\n  float: left;\r\n  font-size: 0;\r\n  height: 100%;\r\n  line-height: 0;\r\n  opacity: 0.5;\r\n  overflow: hidden;\r\n  -webkit-transition: opacity 0.15s;\r\n  transition: opacity 0.15s;\r\n  width: 100px;\r\n  padding: 7px;\r\n  box-shadow: inset 0px 0px 5px 0px white;\r\n  border: 3px solid white;\r\n}\r\n\r\n.greyBg {\r\n  background: lightgrey !important;\r\n}\r\n\r\n.topCust2 {\r\n  margin-top: -35px !important\r\n}\r\n\r\n.greyBg>.badger-accordion__header, .greyBg>.badger-accordion__panel .js-badger-accordion-panel-inner {\r\n  background: lightgrey !important;\r\n}\r\n\r\n.black {\r\n  color: black !important;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "biI2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JHcX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2808cd68", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a523c12\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a523c12\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "byWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It__ = __webpack_require__("vfoj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It__);




// Merge the locales.
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].localize({ it: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a });

// CUSTOM RULES:

// NOT USE TEMPORARY EMAIL
var emailTemporaryArray = ['10minutemail.com', '163.com', '1chuan.com', '1zhuan.com', '20minutemail.com', '21cn.com', '2prong.com', '30minutesmail.com', '4warding.com', '4warding.com', '4warding.net', '4warding.org', '675hosting.com', '675hosting.net', '675hosting.org', '6url.com', '75hosting.com', '75hosting.net', '75hosting.org', 'afrobacon.com', 'ajaxapp.net', 'amiri.net', 'amiriindustries.com', 'anonymail.dk', 'anonymbox.com', 'aol.com', 'bambooclub.cn', 'binkmail.com', 'blogmyway.org', 'bobmail.info', 'bofthew.com', 'bsnow.net', 'bugmenot.com', 'bumpymail.com', 'buyusedlibrarybooks.org', 'centermail.com', 'centermail.net', 'choicemail1.com', 'chongsoft.cn', 'chongsoft.com', 'chongsoft.org', 'cool.fr.nf', 'courriel.fr.nf', 'csoftmail.cn', 'deadspam.com', 'despam.it', 'despammed.com', 'discardmail.com', 'discardmail.de', 'dispose.it', 'disposeamail.com', 'dispostable.com', 'dodgeit.com', 'dodgit.com', 'dontreg.com', 'dontsendmespam.de', 'dotmsg.com', 'dumpandjunk.com', 'dumpmail.de', 'dunflimblag.mailexpire.com', 'e4ward.com', 'emaildienst.de', 'emailias.com', 'emailmiser.com', 'emailtemporanea.net', 'emailto.de', 'emailxfer.com', 'emz.net', 'enterto.com', 'etranquil.com', 'etranquil.net', 'etranquil.org', 'fakeinformation.com', 'fakemailz.com', 'fastacura.com', 'fastchevy.com', 'fastchrysler.com', 'fastkawasaki.com', 'fastmazda.com', 'fastmitsubishi.com', 'fastnissan.com', 'fastsubaru.com', 'fastsuzuki.com', 'fasttoyota.com', 'fastyamaha.com', 'filzmail.com', 'filzmail.com', 'footard.com', 'forgetmail.com', 'front14.org', 'fuckingduh.com', 'fux0ringduh.com', 'getonemail.com', 'ghosttexter.de', 'gishpuppy.com', 'gowikibooks.com', 'gowikicampus.com', 'gowikicars.com', 'gowikifilms.com', 'gowikigames.com', 'gowikimusic.com', 'gowikinetwork.com', 'gowikitravel.com', 'gowikitv.com', 'greensloth.com', 'guerrillamail.com', 'guerrillamail.net', 'guerrillamailblock.com', 'h8s.org', 'haltospam.com', 'hatespam.org', 'hidemail.de', 'hush.ai', 'i-b2c.com', 'iheartspam.org', 'imstations.com', 'incognitomail.net', 'ipoo.org', 'iwi.net', 'jetable.com', 'jetable.fr.nf', 'jetable.fr.nf', 'jetable.net', 'jetable.org', 'jnxjn.com', 'justonemail.net', 'kasmail.com', 'killmail.com', 'killmail.net', 'klassmaster.com', 'klassmaster.net', 'klzlk.com', 'legworld.cn', 'letmymail.com', 'lhsdv.com', 'link2mail.net', 'lortemail.dk', 'lovemeleaveme.com', 'lroid.com', 'mail.ru', 'mail2rss.org', 'mail333.com', 'mailblocks.com', 'mailcatch.com', 'maileater.com', 'mailexpire.com', 'mailfreeonline.com', 'mailin8r.com', 'mailinator.com', 'mailinator2.com', 'mailmetrash.com', 'mailmoat.com', 'mailnesia.com', 'mailnull.com', 'mailquack.com', 'mailshell.com', 'mailsiphon.com', 'mailslapping.com', 'mailtemp.net', 'mailzilla.com', 'mega.zik.dj', 'mega.zik.dj', 'meinspamschutz.de', 'meltmail.com', 'messagebeamer.de', 'mintemail.com', 'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'mt2009.com', 'myspaceinc.com', 'myspaceinc.net', 'myspaceinc.org', 'myspacepimpedup.com', 'myspamless.com', 'mytrashmail.com', 'neomailbox.com', 'nepwk.com', 'nervmich.net', 'nervtmich.net', 'netmails.com', 'netmails.net', 'netzidiot.de', 'nobulk.com', 'noclickemail.com', 'nomail.xl.cx', 'nospam.ze.tc', 'nospamfor.us', 'nurfuerspam.de', 'nwldx.com', 'onemoremail.net', 'oneoffemail.com', 'oneoffmail.com', 'oopi.org', 'ourklips.com', 'outlawspam.com', 'owlpic.com', 'pancakemail.com', 'pc1520.com', 'pimpedupmyspace.com', 'pjjkp.com', 'poofy.org', 'pookmail.com', 'privacy.net', 'prtnx.com', 'punkass.com', 'recyclemail.dk', 'rejectmail.com', 'rklips.com', 'safersignup.de', 'seorj.cn', 'sharklasers.com', 'shiftmail.com', 'shortmail.net', 'sibmail.com', 'sina.com', 'siteposter.net', 'slaskpost.se', 'slopsbox.com', 'sneakemail.com', 'sofimail.com', 'sofort-mail.de', 'sogetthis.com', 'sohu.com', 'spam.la', 'spam.su', 'spamavert.com', 'spambob.com', 'spambob.net', 'spambob.org', 'spambog.com', 'spambog.de', 'spambox.us', 'spamcon.org', 'spamcorptastic.com', 'spamday.com', 'spamex.com', 'spamexperts.com', 'spamfree24.com', 'spamfree24.net', 'spamfree24.org', 'spamgourmet.com', 'spamhole.com', 'spamhouse.com', 'spamify.com', 'spaminator.de', 'spaml.com', 'spammotel.com', 'spamoff.de', 'spamslicer.com', 'spamsphere.com', 'spamtrail.com', 'speed.1s.fr', 'teleworm.com', 'tempemail.net', 'tempinbox.com', 'tempmail.it', 'tempomail.fr', 'temporarily.de', 'temporaryforwarding.com', 'temporaryinbox.com', 'thankyou2010.com', 'tom.com', 'tracciabi.li', 'trash2009.com', 'trashdevil.com', 'trashdevil.de', 'trashmail.com', 'trashmail.de', 'trash-mail.de', 'trashmail.net', 'trashmail.org', 'trashymail.com', 'turual.com', 'twinmail.de', 'tyldd.com', 'uggsrock.com', 'upliftnow.com', 'uplipht.com', 'uymail.com', 'venompen.com', 'viditag.com', 'viewcastmedia.com', 'viewcastmedia.net', 'viewcastmedia.org', 'visit.onlatedotcom.info', 'walala.org', 'wegwerfadresse.de', 'wetrainbayarea.com', 'wetrainbayarea.org', 'wh4f.org', 'whopy.com', 'wilemail.com', 'willselfdestruct.com', 'wormseo.cn', 'wuzup.net', 'wwwnew.eu', 'xagloo.com', 'xemaps.com', 'xents.com', 'xmaily.com', 'yep.it', 'yopmail.com', 'yopmail.fr', 'yopmail.fr', 'yopmail.net', 'youumail.com', 'zoemail.org', 'MakeMeTheKing.com', 'tempemail.co.za', 'mail-temp.com', 'emailthrow.net ', 'rppkn.com', 'incognitomail.org', 'email60.com', 'rtrtr.com'];
var temporaryEmail = {
	getMessage: function getMessage(field) {
		return 'Le email temporanee non sono consentite';
	},
	validate: function validate(value) {
		var domain = value.split('@');
		var count = domain.length;
		domain = domain[count - 1];
		if (emailTemporaryArray.indexOf(domain) !== -1) {
			return false;
		} else {
			return true;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('temporaryEmail', temporaryEmail);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { temporaryEmail: function temporaryEmail(field) {
		return 'Le email temporanee non sono consentite';
	} });

// PASSWORD SECURITY CHECK
var checkImei = {
	getMessage: function getMessage(field) {
		return 'Codice IMEI non valido.';
	},
	validate: function validate(value) {
		var use_checksum = true;
		var sum = 0;
		if (jQuery.type(value) === "string") {
			if (value.match('^[0-9]{15}$')) {
				if (!use_checksum) return true;

				for (var i = 0, sum = 0; i < 14; i++) {
					var tmp = value[i] * (i % 2 + 1);
					sum += tmp % 10 + parseInt(tmp / 10);
				}
				return (10 - sum % 10) % 10 == value[14];
			} else {
				if (value == '') {
					return true;
				} else {
					return false;
				}
			}
		} else {
			if (value == '') {
				return true;
			} else {
				return false;
			}
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('checkImei', checkImei);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { checkImei: function checkImei(field) {
		return 'Codice IMEI non valido.';
	} });

// EMAIL CHECK PLUS + CHARACTER ( FOR GMAIL....+1@gmail.com )
var plusIssueEmail = {
	getMessage: function getMessage(field) {
		return 'L`indirizzo email contiene caratteri non consentiti';
	},
	validate: function validate(value) {
		var str = value;
		if (str.indexOf('+') == -1) {
			return true;
		} else {
			return false;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('plusIssueEmail', plusIssueEmail);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { plusIssueEmail: function plusIssueEmail(field) {
		return 'L`indirizzo email contiene caratteri non consentiti';
	} });

// PASSWORD SECURITY CHECK
var passwordCheck = {
	getMessage: function getMessage(field) {
		return 'La password deve essere composta da lettere e numeri.';
	},
	validate: function validate(value) {
		if (!/[a-z]/.test(value)) {
			return false;
		} else if (!/[0-9]/.test(value)) {
			return false;
		}
		return true;
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('passwordCheck', passwordCheck);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { passwordCheck: function passwordCheck(field) {
		return 'La password deve essere composta da lettere e numeri.';
	} });

// PASSWORD SECURITY CHECK
var emptyTime = {
	getMessage: function getMessage(field) {
		return 'Il campo Ora è richiesto.';
	},
	validate: function validate(value) {
		if (value.HH == '' || value.mm == '') {
			return false;
		}
		return true;
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('emptyTime', emptyTime);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { emptyTime: function emptyTime(field) {
		return 'Il campo Ora è richiesto.';
	} });

// NEW VALIDATE RULE FOR PARTITA IVA
var partitaIva = {
	getMessage: function getMessage(field) {
		return 'Partita IVA non valida';
	},
	validate: function validate(value) {
		var pi = value;
		if (pi.length == 11) {

			var s = 0;
			for (i = 0; i <= 9; i += 2) {
				s += pi.charCodeAt(i) - '0'.charCodeAt(0);
			}for (var i = 1; i <= 9; i += 2) {
				var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
				if (c > 9) c = c - 9;
				s += c;
			}
			var atteso = (10 - s % 10) % 10;
			if (atteso != pi.charCodeAt(10) - '0'.charCodeAt(0)) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('partitaIva', partitaIva);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { partitaIva: function partitaIva(field) {
		return 'Partita IVA non valida.';
	} });

// IBAN CHECK
var ibanControl = {
	getMessage: function getMessage(field) {
		return 'Il campo Iban non é corretto.';
	},
	validate: function validate(value) {

		// Remove spaces and to upper case
		var iban = value.replace(/ /g, "").toUpperCase(),
		    ibancheckdigits = "",
		    leadingZeroes = true,
		    cRest = "",
		    cOperator = "",
		    countrycode,
		    ibancheck,
		    charAt,
		    cChar,
		    bbanpattern,
		    bbancountrypatterns,
		    ibanregexp,
		    i,
		    p;

		// Check for IBAN code length.
		// It contains:
		// country code ISO 3166-1 - two letters,
		// two check digits,
		// Basic Bank Account Number (BBAN) - up to 30 chars
		var minimalIBANlength = 5;
		if (iban.length < minimalIBANlength) {
			return false;
		}

		// Check the country code and find the country specific format
		countrycode = iban.substring(0, 2);
		bbancountrypatterns = {
			"AL": "\\d{8}[\\dA-Z]{16}",
			"AD": "\\d{8}[\\dA-Z]{12}",
			"AT": "\\d{16}",
			"AZ": "[\\dA-Z]{4}\\d{20}",
			"BE": "\\d{12}",
			"BH": "[A-Z]{4}[\\dA-Z]{14}",
			"BA": "\\d{16}",
			"BR": "\\d{23}[A-Z][\\dA-Z]",
			"BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
			"CR": "\\d{17}",
			"HR": "\\d{17}",
			"CY": "\\d{8}[\\dA-Z]{16}",
			"CZ": "\\d{20}",
			"DK": "\\d{14}",
			"DO": "[A-Z]{4}\\d{20}",
			"EE": "\\d{16}",
			"FO": "\\d{14}",
			"FI": "\\d{14}",
			"FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
			"GE": "[\\dA-Z]{2}\\d{16}",
			"DE": "\\d{18}",
			"GI": "[A-Z]{4}[\\dA-Z]{15}",
			"GR": "\\d{7}[\\dA-Z]{16}",
			"GL": "\\d{14}",
			"GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
			"HU": "\\d{24}",
			"IS": "\\d{22}",
			"IE": "[\\dA-Z]{4}\\d{14}",
			"IL": "\\d{19}",
			"IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
			"KZ": "\\d{3}[\\dA-Z]{13}",
			"KW": "[A-Z]{4}[\\dA-Z]{22}",
			"LV": "[A-Z]{4}[\\dA-Z]{13}",
			"LB": "\\d{4}[\\dA-Z]{20}",
			"LI": "\\d{5}[\\dA-Z]{12}",
			"LT": "\\d{16}",
			"LU": "\\d{3}[\\dA-Z]{13}",
			"MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
			"MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
			"MR": "\\d{23}",
			"MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
			"MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
			"MD": "[\\dA-Z]{2}\\d{18}",
			"ME": "\\d{18}",
			"NL": "[A-Z]{4}\\d{10}",
			"NO": "\\d{11}",
			"PK": "[\\dA-Z]{4}\\d{16}",
			"PS": "[\\dA-Z]{4}\\d{21}",
			"PL": "\\d{24}",
			"PT": "\\d{21}",
			"RO": "[A-Z]{4}[\\dA-Z]{16}",
			"SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
			"SA": "\\d{2}[\\dA-Z]{18}",
			"RS": "\\d{18}",
			"SK": "\\d{20}",
			"SI": "\\d{15}",
			"ES": "\\d{20}",
			"SE": "\\d{20}",
			"CH": "\\d{5}[\\dA-Z]{12}",
			"TN": "\\d{20}",
			"TR": "\\d{5}[\\dA-Z]{17}",
			"AE": "\\d{3}\\d{16}",
			"GB": "[A-Z]{4}\\d{14}",
			"VG": "[\\dA-Z]{4}\\d{16}"
		};

		bbanpattern = bbancountrypatterns[countrycode];

		// As new countries will start using IBAN in the
		// future, we only check if the countrycode is known.
		// This prevents false negatives, while almost all
		// false positives introduced by this, will be caught
		// by the checksum validation below anyway.
		// Strict checking should return FALSE for unknown
		// countries.
		if (typeof bbanpattern !== "undefined") {
			ibanregexp = new RegExp("^[A-Z]{2}\\d{2}" + bbanpattern + "$", "");
			if (!ibanregexp.test(iban)) {
				return false; // Invalid country specific format
			}
		}

		// Now check the checksum, first convert to digits
		ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
		for (i = 0; i < ibancheck.length; i++) {
			charAt = ibancheck.charAt(i);
			if (charAt !== "0") {
				leadingZeroes = false;
			}
			if (!leadingZeroes) {
				ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
			}
		}

		// Calculate the result of: ibancheckdigits % 97
		for (p = 0; p < ibancheckdigits.length; p++) {
			cChar = ibancheckdigits.charAt(p);
			cOperator = "" + cRest + "" + cChar;
			cRest = cOperator % 97;
		}
		return cRest === 1;
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('ibanControl', ibanControl);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { ibanControl: function ibanControl(field) {
		return 'Il campo Iban non é corretto.';
	} });

// IBAN ITALIAN
var ibanItalian = {
	getMessage: function getMessage(field) {
		return 'Non si tratta di un iban italiano.';
	},
	validate: function validate(value) {
		if (value == '') {
			return true;
		} else {
			if (value) {

				var lower = value.toLowerCase();

				//console.log( lower.indexOf("it") )
				if (lower.indexOf("it") == 0) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('ibanItalian', ibanItalian);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { ibanItalian: function ibanItalian(field) {
		return 'Non si tratta di un iban italiano.';
	} });

// NEW VALIDATE RULE FOR IBAN
var ibanPoste = {
	getMessage: function getMessage(field) {
		return 'IBAN inserito non risulta essere un IBAN di Poste Italiane';
	},
	validate: function validate(value) {
		// Remove spaces and to upper case
		var iban = value.replace(/ /g, "").toUpperCase();
		if (iban.substring(5, 10) == '07601') {
			return true;
		} else {
			return false;
		}
	}
};

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('ibanPoste', ibanPoste);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { ibanPoste: function ibanPoste(field) {
		return 'IBAN inserito non risulta essere un IBAN di Poste Italiane .';
	} });

// PASSWORD SECURITY CHECK
var codiceFiscale = {
	getMessage: function getMessage(field) {
		return 'Codice Fiscale non valido.';
	},
	validate: function validate(value) {
		var cf = value;
		var validi, i, s, set1, set2, setpari, setdisp;
		if (cf == '') {
			return '';
		}
		cf = cf.toUpperCase();

		if (cf.length != 16) {
			return false;
		}

		validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
		for (i = 0; i < 16; i++) {
			if (validi.indexOf(cf.charAt(i)) == -1) {
				return false;
			}
		}
		set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
		setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
		s = 0;
		for (i = 1; i <= 13; i += 2) {
			s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
		}

		for (i = 0; i <= 14; i += 2) {
			s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
		}

		if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
			return false;
		} else {
			return true;
		}
	}
};
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* Validator */].extend('codiceFiscale', codiceFiscale);
__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a.messages, { codiceFiscale: function codiceFiscale(field) {
		return 'Codice Fiscale non valido.';
	} });

// VEE VALIDATE CONFIG
var config = {
	aria: true,
	classNames: {},
	classes: false,
	delay: 0,
	dictionary: {
		it: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_It___default.a
	},
	errorBagName: 'errors', // change if property conflicts
	events: 'input|blur',
	fieldsBagName: 'fields',
	i18n: null, // the vue-i18n plugin instance
	i18nRootKey: 'validations', // the nested key under which the validation messages will be located
	inject: true,
	locale: 'it',
	validity: false,
	useConstraintAttrs: true
};

/* harmony default export */ __webpack_exports__["a"] = ({
	config: config,
	core: __WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* default */]
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ckMO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/traficLight_red.a023321.png";

/***/ }),

/***/ "dPwX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-648fb19c]{\n\tfont-size: 18px;\n}\n.page__title[data-v-648fb19c]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-648fb19c] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-648fb19c] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-648fb19c]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-648fb19c]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-648fb19c] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "du22":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.regulationContainer[data-v-711de7bd]{\n\tfont-size: 18px;\n}\n.page__title[data-v-711de7bd]{\n\tfont-size: 18px!important;\n\tfont-weight: 800;\n}\n.navigation[data-v-711de7bd] {\n\tposition: fixed;\n\tbottom: 0;\n\tbackground: #fffbde;\n\tcolor: #8a222f;\n\tleft: 0;\n\twidth: 100%;\n\tpadding: 5px;\n\tfont-size: 22px;\n\ttext-align: center;\n}\n.navItem[data-v-711de7bd] {\n\tmargin: 10px;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n\tcursor: pointer;\n\ttext-decoration: underline;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.regulationContainer[data-v-711de7bd]{\n\t\tfont-size: 14px;\n}\n.col-md-4.text-right[data-v-711de7bd]{\n\t\ttext-align: left!important;\n}\n.navigation[data-v-711de7bd] {\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\tpadding: 8px;\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n}\n}\n\n", ""]);

// exports


/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "en44":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("du22");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1d2c0314", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-711de7bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-711de7bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fcBF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("noPh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3445f528", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "gCMD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),

/***/ "h0Rp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "hEAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/badger-accordion/dist/badger-accordion.esm.js
var badger_accordion_esm = __webpack_require__("pQNc");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordion.vue

//
//
//
//
//
//



// Helper-function to unwrap child-component-wrapper
function unwrap(wrapper) {
    // place childNodes in document fragment
    var docFrag = document.createDocumentFragment();
    while (wrapper.firstChild) {
        var child = wrapper.removeChild(wrapper.firstChild);
        docFrag.appendChild(child);
    }

    // replace wrapper with document fragment
    wrapper.parentNode.replaceChild(docFrag, wrapper);
}

/* harmony default export */ var BadgerAccordion = ({
    name: 'BadgerAccordion',
    props: {
        options: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        icons: {
            default: function _default() {
                return { opened: '-', closed: '+' };
            }
        },
        iconComponent: {
            default: null
        }
    },
    data: function data() {
        return {
            accordion: null,
            itemsReady: false,
            show: true,
            rerendering: false,
            children: this.$children
        };
    },

    watch: {
        "accordion.states": {
            handler: function handler(states) {
                this.calculateAllPanelsHeight();
                this.$children.forEach(function (child, n) {
                    if (typeof_default()(states[n]) == 'object') {
                        child.changeState(states[n].state == 'open');
                    }
                });
            },

            deep: true
        }
    },
    created: function created() {
        var _this = this;

        // On child-item rendered initiate badger-accordion
        this.$on('item:ready', function () {
            // Unwrap child-wrapper due issues with badger-accordion
            unwrap(_this.$refs.badger.querySelector('.badger-accordion-item'));
            // Init badger-accordion if child-component is loaded
            _this.accordion = new badger_accordion_esm["a" /* default */](_this.$refs.badger, _this.options || {});
            _this.$forceUpdate();
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$watch(function () {
            return _this2.children.length;
        }, function (items) {
            _this2.rerender();
        });
    },


    methods: {
        init: function init() {
            this.accordion.init();
        },
        getState: function getState() {
            var headerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            return this.accordion.getState(headerIds);
        },
        open: function open(headerIndex) {
            this.accordion.open(headerIndex);
        },
        close: function close(headerIndex) {
            this.accordion.close(headerIndex);
        },
        togglePanel: function togglePanel(animationAction, headerIndex) {
            this.accordion.togglePanel(animationAction, headerIndex);
        },
        openAll: function openAll() {
            this.accordion.openAll();
        },
        closeAll: function closeAll() {
            this.accordion.closeAll();
        },
        calculateAllPanelsHeight: function calculateAllPanelsHeight() {
            this.accordion.calculateAllPanelsHeight();
        },
        calculatePanelHeight: function calculatePanelHeight(panel) {
            this.accordion.calculatePanelHeight(panel);
        },
        rerender: function rerender() {
            var _this3 = this;

            if (!this.rerendering) {
                this.rerendering = true;
                this.show = false;
                this.$nextTick(function () {
                    _this3.show = true;
                    _this3.$nextTick(function () {
                        _this3.rerendering = false;
                    });
                });
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17205bd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordion.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "dl",
        { ref: "badger", staticClass: "component-badger-accordion" },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_BadgerAccordion = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17205bd2", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-badger-accordion/src/BadgerAccordion.vue
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BadgerAccordion,
  src_BadgerAccordion,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-badger-accordion/src/BadgerAccordion.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17205bd2", Component.options)
  } else {
    hotAPI.reload("data-v-17205bd2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vue_badger_accordion_src_BadgerAccordion = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iQH9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "iedL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-415b2084] {\r\n  font-size: 26px;\n}\n.imageIcons[data-v-415b2084] {\r\n\t\tvertical-align: bottom!important;\r\n\t\twidth: 50px;\n}\n.hSize[data-v-415b2084] {\r\n    font-size: 33px!important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-415b2084] {\r\n\t\tmax-width: 333px;\r\n\t\ttext-align: left;\r\n\t\tmargin: 0 auto;\r\n\t\tline-height: 27px;\r\n\t\tpadding-left: 61px;\n}\r\n\r\n\r\n\t/* new PRICE */\n.swal2-popup .swal2-title[data-v-415b2084], #swal2-content[data-v-415b2084] {\r\n\t\tcolor: #fffbde!important;\r\n\t\tdisplay: block!important;\n}\n.replaceButton[data-v-415b2084]{\r\n\t\tmax-width: 40px;\n}\n.inputHelper[data-v-415b2084]{\r\n    margin-top: -32px;\r\n    color: #0e3d8b;\r\n    font-size: 16px;\r\n    left: 0;\n}\n.priceVal[data-v-415b2084], .priceCent[data-v-415b2084]{\r\n\t\twidth: calc(50% - 1.5vw - 7.5px);\r\n\t\tdisplay: inline-table;\n}\n.pseudoEuro[data-v-415b2084] {\r\n\t\tposition: absolute;\r\n\t\ttop: 6px;\n}\n.pseudoCent[data-v-415b2084] {\r\n\t\tposition: absolute;\r\n\t\ttop: 6px;\r\n\t\tright:0;\n}\n.group input:focus + .pseudoEuro[data-v-415b2084] {\r\n\t\tdisplay:block;\n}\n.group .valid + .pseudoEuro[data-v-415b2084]{\r\n\t\tdisplay:block;\n}\n.group input:focus + .pseudoCent[data-v-415b2084] {\r\n\t\tdisplay:block;\n}\n.group .valid + .pseudoCent[data-v-415b2084]{\r\n\t\tdisplay:block;\n}\n.euroInput[data-v-415b2084]{\r\n\t\tposition: relative;\r\n\t\twidth:200%;\r\n\t\tz-index: 4;\n}\n.euroInput[data-v-415b2084]::before{\r\n\t\tcontent: 'Euro';\n}\n.euroInput[data-v-415b2084]:focus, .euroInput.valid[data-v-415b2084]{\r\n\t\twidth:100%;\n}\n.euroInput[data-v-415b2084]:focus::before, .euroInput.valid[data-v-415b2084]::before{\r\n\t\tcontent: 'Euro';\r\n\t\tcolor: white;\r\n\t\tposition: absolute;\n}\n.table[data-v-415b2084]{\r\n\t\tdisplay: table;\n}\n.newPriceLabel[data-v-415b2084]{\r\n\t\tz-index: 5;\r\n\t\tbackground: white;\r\n\t\tmargin-left: -5px;\r\n\t\tpadding-left: 5px;\r\n\t\toverflow: initial;\r\n\t\tmin-width: calc(200% + 17px);\n}\r\n\r\n\r\n\t/*  ------------ */\n.image-margin0[data-v-415b2084]{\r\n\t\tmargin: 0!important;\n}\n.helper[data-v-415b2084]{\r\n\t\tcolor: #0e3d8b;\r\n\t\tfont-size: 23px;\r\n\t\tfont-family: Oswald-Medium;\n}\n.greyDesc2[data-v-415b2084]{\r\n\t\tfont-size: 1.1vw;\r\n\t\tcolor: #fffbde;\n}\n.redDesc[data-v-415b2084]{\r\n\t\tfont-size: 1.1vw;\r\n\t\ttext-decoration: underline;\r\n\t\tcursor: pointer;\n}\n.uploadDone[data-v-415b2084] {\r\n\t\tposition: absolute;\r\n\t\ttop: 10px;\r\n\t\tright: 0;\r\n\t\tcolor: #a1614f;\n}\n.helperUnderline[data-v-415b2084] {\n}\n.labelFileInput[data-v-415b2084]{\r\n\t\ttop: -20px!important;\r\n\t\tfont-size: 22px;\r\n\t\tcolor: #000000;\n}\n.fileInput[data-v-415b2084]{\r\n\t\tposition: absolute;\r\n\t\tz-index: 1;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\tpadding: 0;\r\n\t\ttop: 17px;\r\n\t\tborder-bottom: none;\r\n\t\tcolor: #000000;\n}\n.fileInputLabel[data-v-415b2084]{\r\n\t\tz-index: 3;\r\n\t\twhite-space: nowrap;\r\n\t\toverflow: hidden;\r\n\t\tpadding-right: 20px;\r\n\t\ttext-overflow: ellipsis;\r\n\t\tcolor: #fffbde;\n}\n.removeProduct[data-v-415b2084]{\r\n\t\tposition: absolute;\r\n\t\tright: 21px;\r\n\t\tmargin: 0px!important;\r\n\t\ttop: 48px;\r\n\t\tcolor: #e7201d;\n}\n.typeDisabled[data-v-415b2084]{\r\n\t\tcolor: #676767;\r\n\t\tcursor: pointer;\n}\n.typeSelected[data-v-415b2084] {\r\n\t\tcolor: #fffbde!important;\r\n\t\tcursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-415b2084] {\r\n      margin-top: -12px;\r\n      color: #0e3d8b;\r\n      font-size: 16px;\r\n      left: 0;\n}\n.hSize[data-v-415b2084] {\r\n      font-size: 19px!important;\n}\n.sweetText[data-v-415b2084] {\r\n      font-size: 19px;\n}\n.removeProduct[data-v-415b2084]{\r\n    position: absolute;\r\n    right: 21px;\r\n    margin: 0px!important;\r\n    top: 26px;\r\n    color: #e7201d;\n}\n.greyDesc2[data-v-415b2084], .redDesc[data-v-415b2084]{\r\n\t\t\tfont-size: 3.1vw;\n}\n.fluid[data-v-415b2084] {\r\n\t\t\tmax-width: 107px;\n}\n.mobTQ[data-v-415b2084]{\r\n\t\t\tfont-size: 23px;\n}\n.smMob[data-v-415b2084]{\r\n\t\t\tfont-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-415b2084] {\r\n\t\t\tmax-width: 350px;\r\n\t\t\ttext-align: left;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\tline-height: 27px;\r\n\t\t\tpadding-left: 43px;\r\n\t\t\tfont-size: 17px;\n}\n.helper[data-v-415b2084] {\r\n\t\t\tcolor: #0e3d8b;\r\n\t\t\tfont-size: 18px;\r\n\t\t\tfont-family: Oswald-Medium;\n}\n.imageIcons[data-v-415b2084] {\r\n\t\t\tvertical-align: bottom!important;\r\n\t\t\twidth: 39px;\n}\n.fileInput[data-v-415b2084] {\r\n\r\n\t\t\ttop: 8px!important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-415b2084]{\r\n\t\t\t top: -250%;\n}\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n", ""]);

// exports


/***/ }),

/***/ "j4gP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("G6ei");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("391cb462", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-89f7b05a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./emicon.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-89f7b05a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./emicon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jfmn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/headerBack.11769a0.jpg";

/***/ }),

/***/ "jkql":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notifications.e642b82.png";

/***/ }),

/***/ "jmlf":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "kMKJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-bcfb22e0] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-bcfb22e0] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-bcfb22e0] {\n  width: 75px;\n}\n.bigTitle[data-v-bcfb22e0] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-bcfb22e0] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-bcfb22e0] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-bcfb22e0] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-bcfb22e0] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-bcfb22e0] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-bcfb22e0] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-bcfb22e0] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-bcfb22e0] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-bcfb22e0] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-bcfb22e0] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-bcfb22e0] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-bcfb22e0] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-bcfb22e0] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-bcfb22e0] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-bcfb22e0] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-bcfb22e0]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #0091da;\n        border: 3px solid #0091da;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-bcfb22e0] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-bcfb22e0] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-bcfb22e0]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-bcfb22e0]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-bcfb22e0]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-bcfb22e0] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-bcfb22e0] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-bcfb22e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "kU6H":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("yNpN");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5398d824", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25d2da78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./hoval.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25d2da78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./hoval.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ki2I":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.azzure[data-v-62fe346e] {\r\n  color: #0490a5 !important;\n}\n.footer__social .social[data-v-62fe346e] {\r\n  padding: 0.5rem 0;\r\n  display: block;\n}\n.social[data-v-62fe346e] {\r\n  margin: 0 -0.25rem;\r\n  list-style: none;\r\n  padding: 0;\r\n  font-size: 0;\n}\n.footer__social .social [class^=\"social__\"][data-v-62fe346e] {\r\n  padding: 0 0.25rem 0.5rem;\r\n  display: inline-block;\r\n  float: none;\r\n  font-size: 0;\n}\n.social > li > a[data-v-62fe346e] {\r\n  display: block;\r\n  background-size: 100% 100%;\r\n  text-indent: -99em;\r\n  overflow: hidden;\r\n  width: 32px;\r\n  height: 32px;\n}\n.footerText[data-v-62fe346e] {\r\n  font-size: 14px;\r\n  margin-bottom: 0px;\n}\n.footerBrownDesc[data-v-62fe346e] {\r\n  color: #000000;\r\n  font-family: museo-slab;\r\n  font-size: 16px;\n}\n.footerImageRight[data-v-62fe346e] {\r\n  text-align: right;\n}\n.support[data-v-62fe346e] {\r\n  color: #000000;\r\n  font-size: 16px;\n}\n.techImage[data-v-62fe346e] {\r\n  width: 90%;\n}\n.tech[data-v-62fe346e] {\r\n  position: absolute;\r\n  top: -80px;\r\n  left: -80px;\r\n  font-size: small;\n}\n.bottomBrand[data-v-62fe346e] {\r\n  padding: 28px;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.footerImageRight[data-v-62fe346e] {\r\n    text-align: left;\n}\n.footerText[data-v-62fe346e] {\r\n    font-size: 12px;\r\n    margin-bottom: 0px;\n}\n.tech[data-v-62fe346e] {\r\n    top: -100px;\n}\n.bottomBrand[data-v-62fe346e] {\r\n    width: 27vw;\r\n    padding-top: 10px;\r\n    padding: 10px;\n}\n.footer[data-v-62fe346e] {\r\n    margin-top: -606px;\r\n    height: 606px;\n}\n.alignBottomMobile[data-v-62fe346e] {\r\n    -ms-flex-item-align: end;\r\n        align-self: flex-end;\n}\n.techImage[data-v-62fe346e] {\r\n    width: 59%;\n}\n.tech[data-v-62fe346e] {\r\n    top: -60px;\r\n    left: -57px;\r\n    width: 172px;\n}\n.footerBrownDesc[data-v-62fe346e][data-v-62fe346e] {\r\n    color: #000000;\r\n    font-family: museo-slab;\r\n    font-size: 13px;\n}\n.support[data-v-62fe346e][data-v-62fe346e] {\r\n    color: #000000;\r\n    font-size: 11px;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "l+T2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "time-picker" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.displayTime,
          expression: "displayTime"
        }
      ],
      staticClass: "display-time",
      attrs: { id: _vm.id, type: "text", readonly: "" },
      domProps: { value: _vm.displayTime },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.toggleDropdown($event)
        },
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.displayTime = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    !_vm.hideClearButton
      ? _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showDropdown && _vm.showClearBtn,
                expression: "!showDropdown && showClearBtn"
              }
            ],
            staticClass: "clear-btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.clearTime($event)
              }
            }
          },
          [_vm._v("×")]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showDropdown
      ? _c("div", {
          staticClass: "time-picker-overlay",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleDropdown($event)
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDropdown,
            expression: "showDropdown"
          }
        ],
        staticClass: "dropdown"
      },
      [
        _c("div", { staticClass: "select-list" }, [
          _c(
            "ul",
            { staticClass: "hours" },
            [
              _c("li", {
                staticClass: "hint",
                domProps: { textContent: _vm._s(_vm.hourType) }
              }),
              _vm._v(" "),
              _vm._l(_vm.hours, function(hr) {
                return _c("li", {
                  class: { active: _vm.hour === hr },
                  domProps: { textContent: _vm._s(hr) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select("hour", hr)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "minutes" },
            [
              _c("li", {
                staticClass: "hint",
                domProps: { textContent: _vm._s(_vm.minuteType) }
              }),
              _vm._v(" "),
              _vm._l(_vm.minutes, function(m) {
                return _c("li", {
                  class: { active: _vm.minute === m },
                  domProps: { textContent: _vm._s(m) },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.select("minute", m)
                    }
                  }
                })
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.secondType
            ? _c(
                "ul",
                { staticClass: "seconds" },
                [
                  _c("li", {
                    staticClass: "hint",
                    domProps: { textContent: _vm._s(_vm.secondType) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.seconds, function(s) {
                    return _c("li", {
                      class: { active: _vm.second === s },
                      domProps: { textContent: _vm._s(s) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.select("second", s)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.apmType
            ? _c(
                "ul",
                { staticClass: "apms" },
                [
                  _c("li", {
                    staticClass: "hint",
                    domProps: { textContent: _vm._s(_vm.apmType) }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.apms, function(a) {
                    return _c("li", {
                      class: { active: _vm.apm === a },
                      domProps: { textContent: _vm._s(a) },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.select("apm", a)
                        }
                      }
                    })
                  })
                ],
                2
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4588f32", esExports)
  }
}

/***/ }),

/***/ "l+gf":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UuNy");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3e50e643", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4588f32\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-timepicker.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c4588f32\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./vue-timepicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "m64w":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-25d2da78] {\r\n  font-size: 26px;\n}\n.imageIcons[data-v-25d2da78] {\r\n  vertical-align: bottom !important;\r\n  width: 50px;\n}\n.hSize[data-v-25d2da78] {\r\n  font-size: 33px !important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-25d2da78] {\r\n  max-width: 333px;\r\n  text-align: left;\r\n  margin: 0 auto;\r\n  line-height: 27px;\r\n  padding-left: 61px;\n}\r\n\r\n/* new PRICE */\n.swal2-popup .swal2-title[data-v-25d2da78],\r\n#swal2-content[data-v-25d2da78] {\r\n  color: #fffbde !important;\r\n  display: block !important;\n}\n.replaceButton[data-v-25d2da78] {\r\n  max-width: 40px;\n}\n.inputHelper[data-v-25d2da78] {\r\n  margin-top: -32px;\r\n  color: #0e3d8b;\r\n  font-size: 16px;\r\n  left: 0;\n}\n.priceVal[data-v-25d2da78],\r\n.priceCent[data-v-25d2da78] {\r\n  width: calc(50% - 1.5vw - 7.5px);\r\n  display: inline-table;\n}\n.pseudoEuro[data-v-25d2da78] {\r\n  position: absolute;\r\n  top: 6px;\n}\n.pseudoCent[data-v-25d2da78] {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 0;\n}\n.group input:focus + .pseudoEuro[data-v-25d2da78] {\r\n  display: block;\n}\n.group .valid + .pseudoEuro[data-v-25d2da78] {\r\n  display: block;\n}\n.group input:focus + .pseudoCent[data-v-25d2da78] {\r\n  display: block;\n}\n.group .valid + .pseudoCent[data-v-25d2da78] {\r\n  display: block;\n}\n.euroInput[data-v-25d2da78] {\r\n  position: relative;\r\n  width: 200%;\r\n  z-index: 4;\n}\n.euroInput[data-v-25d2da78]::before {\r\n  content: \"Euro\";\n}\n.euroInput[data-v-25d2da78]:focus,\r\n.euroInput.valid[data-v-25d2da78] {\r\n  width: 100%;\n}\n.euroInput[data-v-25d2da78]:focus::before,\r\n.euroInput.valid[data-v-25d2da78]::before {\r\n  content: \"Euro\";\r\n  color: white;\r\n  position: absolute;\n}\n.table[data-v-25d2da78] {\r\n  display: table;\n}\n.newPriceLabel[data-v-25d2da78] {\r\n  z-index: 5;\r\n  background: white;\r\n  margin-left: -5px;\r\n  padding-left: 5px;\r\n  overflow: initial;\r\n  min-width: calc(200% + 17px);\n}\r\n\r\n/*  ------------ */\n.image-margin0[data-v-25d2da78] {\r\n  margin: 0 !important;\n}\n.helper[data-v-25d2da78] {\r\n  color: #0e3d8b;\r\n  font-size: 23px;\r\n  font-family: Oswald-Medium;\n}\n.greyDesc2[data-v-25d2da78] {\r\n  font-size: 1.1vw;\r\n  color: #fffbde;\n}\n.redDesc[data-v-25d2da78] {\r\n  font-size: 1.1vw;\r\n  text-decoration: underline;\r\n  cursor: pointer;\n}\n.uploadDone[data-v-25d2da78] {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 0;\r\n  color: #a1614f;\n}\n.helperUnderline[data-v-25d2da78] {\n}\n.labelFileInput[data-v-25d2da78] {\r\n  top: -20px !important;\r\n  font-size: 22px;\r\n  color: #000000;\n}\n.fileInput[data-v-25d2da78] {\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  top: 17px;\r\n  border-bottom: none;\r\n  color: #000000;\n}\n.fileInputLabel[data-v-25d2da78] {\r\n  z-index: 3;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-right: 20px;\r\n  text-overflow: ellipsis;\r\n  color: #fffbde;\n}\n.removeProduct[data-v-25d2da78] {\r\n  position: absolute;\r\n  right: 21px;\r\n  margin: 0px !important;\r\n  top: 48px;\r\n  color: #e7201d;\n}\n.typeDisabled[data-v-25d2da78] {\r\n  color: #676767;\r\n  cursor: pointer;\n}\n.typeSelected[data-v-25d2da78] {\r\n  color: #fffbde !important;\r\n  cursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-25d2da78] {\r\n    margin-top: -12px;\r\n    color: #0e3d8b;\r\n    font-size: 16px;\r\n    left: 0;\n}\n.hSize[data-v-25d2da78] {\r\n    font-size: 19px !important;\n}\n.sweetText[data-v-25d2da78] {\r\n    font-size: 19px;\n}\n.removeProduct[data-v-25d2da78] {\r\n    position: absolute;\r\n    right: 21px;\r\n    margin: 0px !important;\r\n    top: 26px;\r\n    color: #e7201d;\n}\n.greyDesc2[data-v-25d2da78],\r\n  .redDesc[data-v-25d2da78] {\r\n    font-size: 3.1vw;\n}\n.fluid[data-v-25d2da78] {\r\n    max-width: 107px;\n}\n.mobTQ[data-v-25d2da78] {\r\n    font-size: 23px;\n}\n.smMob[data-v-25d2da78] {\r\n    font-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-25d2da78] {\r\n    max-width: 350px;\r\n    text-align: left;\r\n    margin: 0 auto;\r\n    line-height: 27px;\r\n    padding-left: 43px;\r\n    font-size: 17px;\n}\n.helper[data-v-25d2da78] {\r\n    color: #0e3d8b;\r\n    font-size: 18px;\r\n    font-family: Oswald-Medium;\n}\n.imageIcons[data-v-25d2da78] {\r\n    vertical-align: bottom !important;\r\n    width: 39px;\n}\n.fileInput[data-v-25d2da78] {\r\n    top: 8px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-25d2da78] {\r\n    top: -250%;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "mJhL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/arial.6dd6913.otf";

/***/ }),

/***/ "mrXZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("m64w");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e1aa70e4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25d2da78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./hoval.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25d2da78\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./hoval.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nIi4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ndT8":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "noPh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-03a5036f] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-03a5036f] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-03a5036f] {\n  width: 75px;\n}\n.bigTitle[data-v-03a5036f] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-03a5036f] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-03a5036f] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-03a5036f] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-03a5036f] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-03a5036f] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-03a5036f] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-03a5036f] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-03a5036f] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-03a5036f] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-03a5036f] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-03a5036f] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-03a5036f] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-03a5036f] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-03a5036f] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-03a5036f] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-03a5036f]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-03a5036f] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-03a5036f] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-03a5036f]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-03a5036f]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-03a5036f]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-03a5036f] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-03a5036f] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-03a5036f] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "oOUs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "pDSP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, ".time-picker {\n  display: inline-block;\n  position: relative;\n  font-size: 1em;\n  width: 10em;\n  font-family: sans-serif;\n  vertical-align: middle;\n}\n\n.time-picker * {\n  box-sizing: border-box;\n}\n\n.time-picker input.display-time {\n  border: 1px solid #d2d2d2;\n  width: 10em;\n  height: 2.2em;\n  padding: 0.3em 0.5em;\n  font-size: 1em;\n}\n\n.time-picker .clear-btn {\n  position: absolute;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  margin-top: -0.15em;\n  z-index: 3;\n  font-size: 1.1em;\n  line-height: 1em;\n  vertical-align: middle;\n  width: 1.3em;\n  color: #d2d2d2;\n  background: rgba(255,255,255,0);\n  text-align: center;\n  font-style: normal;\n\n  -webkit-transition: color .2s;\n  transition: color .2s;\n}\n\n.time-picker .clear-btn:hover {\n  color: #797979;\n  cursor: pointer;\n}\n\n.time-picker .time-picker-overlay {\n  z-index: 2;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.time-picker .dropdown {\n  position: absolute;\n  z-index: 5;\n  top: calc(2.2em + 2px);\n  left: 0;\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.15);\n  width: 10em;\n  height: 10em;\n  font-weight: normal;\n}\n\n.time-picker .dropdown .select-list {\n  width: 10em;\n  height: 10em;\n  overflow: hidden;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  justify-content: space-between;\n}\n\n.time-picker .dropdown ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.time-picker .dropdown ul.minutes,\n.time-picker .dropdown ul.seconds,\n.time-picker .dropdown ul.apms{\n  border-left: 1px solid #fff;\n}\n\n.time-picker .dropdown ul li {\n  text-align: center;\n  padding: 0.3em 0;\n  color: #161616;\n}\n\n.time-picker .dropdown ul li:not(.hint):hover {\n  background: rgba(0,0,0,.08);\n  color: #161616;\n  cursor: pointer;\n}\n\n.time-picker .dropdown ul li.active,\n.time-picker .dropdown ul li.active:hover {\n  background: #41B883;\n  color: #fff;\n}\n\n.time-picker .dropdown .hint {\n  color: #a5a5a5;\n  cursor: default;\n  font-size: 0.8em;\n}\n", ""]);

// exports


/***/ }),

/***/ "pNxK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kMKJ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c2861fea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bcfb22e0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pWsl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.sweetText[data-v-bcfb22e0] {\r\n  font-size: 26px;\n}\n.imageIcons[data-v-bcfb22e0] {\r\n  vertical-align: bottom !important;\r\n  width: 50px;\n}\n.hSize[data-v-bcfb22e0] {\r\n  font-size: 33px !important;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-bcfb22e0] {\r\n  max-width: 333px;\r\n  text-align: left;\r\n  margin: 0 auto;\r\n  line-height: 27px;\r\n  padding-left: 61px;\n}\r\n\r\n/* new PRICE */\n.swal2-popup .swal2-title[data-v-bcfb22e0],\r\n#swal2-content[data-v-bcfb22e0] {\r\n  color: #fffbde !important;\r\n  display: block !important;\n}\n.replaceButton[data-v-bcfb22e0] {\r\n  max-width: 40px;\n}\n.inputHelper[data-v-bcfb22e0] {\r\n  margin-top: -32px;\r\n  color: #0e3d8b;\r\n  font-size: 16px;\r\n  left: 0;\n}\n.priceVal[data-v-bcfb22e0],\r\n.priceCent[data-v-bcfb22e0] {\r\n  width: calc(50% - 1.5vw - 7.5px);\r\n  display: inline-table;\n}\n.pseudoEuro[data-v-bcfb22e0] {\r\n  position: absolute;\r\n  top: 6px;\n}\n.pseudoCent[data-v-bcfb22e0] {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 0;\n}\n.group input:focus + .pseudoEuro[data-v-bcfb22e0] {\r\n  display: block;\n}\n.group .valid + .pseudoEuro[data-v-bcfb22e0] {\r\n  display: block;\n}\n.group input:focus + .pseudoCent[data-v-bcfb22e0] {\r\n  display: block;\n}\n.group .valid + .pseudoCent[data-v-bcfb22e0] {\r\n  display: block;\n}\n.euroInput[data-v-bcfb22e0] {\r\n  position: relative;\r\n  width: 200%;\r\n  z-index: 4;\n}\n.euroInput[data-v-bcfb22e0]::before {\r\n  content: \"Euro\";\n}\n.euroInput[data-v-bcfb22e0]:focus,\r\n.euroInput.valid[data-v-bcfb22e0] {\r\n  width: 100%;\n}\n.euroInput[data-v-bcfb22e0]:focus::before,\r\n.euroInput.valid[data-v-bcfb22e0]::before {\r\n  content: \"Euro\";\r\n  color: white;\r\n  position: absolute;\n}\n.table[data-v-bcfb22e0] {\r\n  display: table;\n}\n.newPriceLabel[data-v-bcfb22e0] {\r\n  z-index: 5;\r\n  background: white;\r\n  margin-left: -5px;\r\n  padding-left: 5px;\r\n  overflow: initial;\r\n  min-width: calc(200% + 17px);\n}\r\n\r\n/*  ------------ */\n.image-margin0[data-v-bcfb22e0] {\r\n  margin: 0 !important;\n}\n.helper[data-v-bcfb22e0] {\r\n  color: #0e3d8b;\r\n  font-size: 23px;\r\n  font-family: Oswald-Medium;\n}\n.greyDesc2[data-v-bcfb22e0] {\r\n  font-size: 1.1vw;\r\n  color: #fffbde;\n}\n.redDesc[data-v-bcfb22e0] {\r\n  font-size: 1.1vw;\r\n  text-decoration: underline;\r\n  cursor: pointer;\n}\n.uploadDone[data-v-bcfb22e0] {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 0;\r\n  color: #a1614f;\n}\n.helperUnderline[data-v-bcfb22e0] {\n}\n.labelFileInput[data-v-bcfb22e0] {\r\n  top: -20px !important;\r\n  font-size: 22px;\r\n  color: #000000;\n}\n.fileInput[data-v-bcfb22e0] {\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  top: 17px;\r\n  border-bottom: none;\r\n  color: #000000;\n}\n.fileInputLabel[data-v-bcfb22e0] {\r\n  z-index: 3;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  padding-right: 20px;\r\n  text-overflow: ellipsis;\r\n  color: #fffbde;\n}\n.removeProduct[data-v-bcfb22e0] {\r\n  position: absolute;\r\n  right: 21px;\r\n  margin: 0px !important;\r\n  top: 48px;\r\n  color: #e7201d;\n}\n.typeDisabled[data-v-bcfb22e0] {\r\n  color: #676767;\r\n  cursor: pointer;\n}\n.typeSelected[data-v-bcfb22e0] {\r\n  color: #fffbde !important;\r\n  cursor: pointer;\n}\n@media (min-width: 20px) and (max-width: 767px) {\n.inputHelper[data-v-bcfb22e0] {\r\n    margin-top: -12px;\r\n    color: #0e3d8b;\r\n    font-size: 16px;\r\n    left: 0;\n}\n.hSize[data-v-bcfb22e0] {\r\n    font-size: 19px !important;\n}\n.sweetText[data-v-bcfb22e0] {\r\n    font-size: 19px;\n}\n.removeProduct[data-v-bcfb22e0] {\r\n    position: absolute;\r\n    right: 21px;\r\n    margin: 0px !important;\r\n    top: 26px;\r\n    color: #e7201d;\n}\n.greyDesc2[data-v-bcfb22e0],\r\n  .redDesc[data-v-bcfb22e0] {\r\n    font-size: 3.1vw;\n}\n.fluid[data-v-bcfb22e0] {\r\n    max-width: 107px;\n}\n.mobTQ[data-v-bcfb22e0] {\r\n    font-size: 23px;\n}\n.smMob[data-v-bcfb22e0] {\r\n    font-size: 1rem;\n}\n.howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7][data-v-bcfb22e0] {\r\n    max-width: 350px;\r\n    text-align: left;\r\n    margin: 0 auto;\r\n    line-height: 27px;\r\n    padding-left: 43px;\r\n    font-size: 17px;\n}\n.helper[data-v-bcfb22e0] {\r\n    color: #0e3d8b;\r\n    font-size: 18px;\r\n    font-family: Oswald-Medium;\n}\n.imageIcons[data-v-bcfb22e0] {\r\n    vertical-align: bottom !important;\r\n    width: 39px;\n}\n.fileInput[data-v-bcfb22e0] {\r\n    top: 8px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 1205px) {\n.disabledDatesMessage[data-v-bcfb22e0] {\r\n    top: -250%;\n}\n}\r\n", ""]);

// exports


/***/ }),

/***/ "q2xu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v4.6.0 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */:root{--blue:#007bff;--indigo:#6610f2;--purple:#6f42c1;--pink:#e83e8c;--red:#dc3545;--orange:#fd7e14;--yellow:#ffc107;--green:#28a745;--teal:#20c997;--cyan:#17a2b8;--white:#fff;--gray:#6c757d;--gray-dark:#343a40;--primary:#007bff;--secondary:#6c757d;--success:#28a745;--info:#17a2b8;--warning:#ffc107;--danger:#dc3545;--light:#f8f9fa;--dark:#343a40;--breakpoint-xs:0;--breakpoint-sm:576px;--breakpoint-md:768px;--breakpoint-lg:992px;--breakpoint-xl:1200px;--font-family-sans-serif:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-family-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}*,::after,::before{box-sizing:border-box}html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}article,aside,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}[tabindex=\"-1\"]:focus:not(:focus-visible){outline:0!important}hr{box-sizing:content-box;height:0;overflow:visible}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:#007bff;text-decoration:none;background-color:transparent}a:hover{color:#0056b3;text-decoration:underline}a:not([href]):not([class]){color:inherit;text-decoration:none}a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}pre{margin-top:0;margin-bottom:1rem;overflow:auto;-ms-overflow-style:scrollbar}figure{margin:0 0 1rem}img{vertical-align:middle;border-style:none}svg{overflow:hidden;vertical-align:middle}table{border-collapse:collapse}caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}th{text-align:inherit;text-align:-webkit-match-parent}label{display:inline-block;margin-bottom:.5rem}button{border-radius:0}button:focus:not(:focus-visible){outline:0}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,input{overflow:visible}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{padding:0;border-style:none}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}textarea{overflow:auto;resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}progress{vertical-align:baseline}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:none}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}output{display:inline-block}summary{display:list-item;cursor:pointer}template{display:none}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-weight:500;line-height:1.2}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300;line-height:1.2}.display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.display-4{font-size:3.5rem;font-weight:300;line-height:1.2}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-unstyled{padding-left:0;list-style:none}.list-inline{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:.5rem}.initialism{font-size:90%;text-transform:uppercase}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote-footer{display:block;font-size:80%;color:#6c757d}.blockquote-footer::before{content:\"\\2014\\A0\"}.img-fluid{max-width:100%;height:auto}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#6c757d}code{font-size:87.5%;color:#e83e8c;word-wrap:break-word}a>code{color:inherit}kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;font-size:87.5%;color:#212529}pre code{font-size:inherit;color:inherit;word-break:normal}.pre-scrollable{max-height:340px;overflow-y:scroll}.container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:576px){.container,.container-sm{max-width:540px}}@media (min-width:768px){.container,.container-md,.container-sm{max-width:720px}}@media (min-width:992px){.container,.container-lg,.container-md,.container-sm{max-width:960px}}@media (min-width:1200px){.container,.container-lg,.container-md,.container-sm,.container-xl{max-width:1140px}}.row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.no-gutters{margin-right:0;margin-left:0}.no-gutters>.col,.no-gutters>[class*=col-]{padding-right:0;padding-left:0}.col,.col-1,.col-10,.col-11,.col-12,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-auto,.col-lg,.col-lg-1,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-auto,.col-md,.col-md-1,.col-md-10,.col-md-11,.col-md-12,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-auto,.col-sm,.col-sm-1,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-auto,.col-xl,.col-xl-1,.col-xl-10,.col-xl-11,.col-xl-12,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.col{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-first{-ms-flex-order:-1;order:-1}.order-last{-ms-flex-order:13;order:13}.order-0{-ms-flex-order:0;order:0}.order-1{-ms-flex-order:1;order:1}.order-2{-ms-flex-order:2;order:2}.order-3{-ms-flex-order:3;order:3}.order-4{-ms-flex-order:4;order:4}.order-5{-ms-flex-order:5;order:5}.order-6{-ms-flex-order:6;order:6}.order-7{-ms-flex-order:7;order:7}.order-8{-ms-flex-order:8;order:8}.order-9{-ms-flex-order:9;order:9}.order-10{-ms-flex-order:10;order:10}.order-11{-ms-flex-order:11;order:11}.order-12{-ms-flex-order:12;order:12}.offset-1{margin-left:8.333333%}.offset-2{margin-left:16.666667%}.offset-3{margin-left:25%}.offset-4{margin-left:33.333333%}.offset-5{margin-left:41.666667%}.offset-6{margin-left:50%}.offset-7{margin-left:58.333333%}.offset-8{margin-left:66.666667%}.offset-9{margin-left:75%}.offset-10{margin-left:83.333333%}.offset-11{margin-left:91.666667%}@media (min-width:576px){.col-sm{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-sm-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-sm-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-sm-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-sm-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-sm-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-sm-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-sm-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-sm-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-sm-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-sm-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-sm-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-sm-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-sm-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-sm-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-sm-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-sm-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-sm-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-sm-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-sm-first{-ms-flex-order:-1;order:-1}.order-sm-last{-ms-flex-order:13;order:13}.order-sm-0{-ms-flex-order:0;order:0}.order-sm-1{-ms-flex-order:1;order:1}.order-sm-2{-ms-flex-order:2;order:2}.order-sm-3{-ms-flex-order:3;order:3}.order-sm-4{-ms-flex-order:4;order:4}.order-sm-5{-ms-flex-order:5;order:5}.order-sm-6{-ms-flex-order:6;order:6}.order-sm-7{-ms-flex-order:7;order:7}.order-sm-8{-ms-flex-order:8;order:8}.order-sm-9{-ms-flex-order:9;order:9}.order-sm-10{-ms-flex-order:10;order:10}.order-sm-11{-ms-flex-order:11;order:11}.order-sm-12{-ms-flex-order:12;order:12}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.333333%}.offset-sm-2{margin-left:16.666667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.333333%}.offset-sm-5{margin-left:41.666667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.333333%}.offset-sm-8{margin-left:66.666667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.333333%}.offset-sm-11{margin-left:91.666667%}}@media (min-width:768px){.col-md{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-md-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-md-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-md-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-md-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-md-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-md-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-md-first{-ms-flex-order:-1;order:-1}.order-md-last{-ms-flex-order:13;order:13}.order-md-0{-ms-flex-order:0;order:0}.order-md-1{-ms-flex-order:1;order:1}.order-md-2{-ms-flex-order:2;order:2}.order-md-3{-ms-flex-order:3;order:3}.order-md-4{-ms-flex-order:4;order:4}.order-md-5{-ms-flex-order:5;order:5}.order-md-6{-ms-flex-order:6;order:6}.order-md-7{-ms-flex-order:7;order:7}.order-md-8{-ms-flex-order:8;order:8}.order-md-9{-ms-flex-order:9;order:9}.order-md-10{-ms-flex-order:10;order:10}.order-md-11{-ms-flex-order:11;order:11}.order-md-12{-ms-flex-order:12;order:12}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.333333%}.offset-md-2{margin-left:16.666667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.333333%}.offset-md-5{margin-left:41.666667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.333333%}.offset-md-8{margin-left:66.666667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.333333%}.offset-md-11{margin-left:91.666667%}}@media (min-width:992px){.col-lg{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-lg-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-lg-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-lg-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-lg-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-lg-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-lg-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-lg-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-lg-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-lg-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-lg-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-lg-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-lg-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-lg-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-lg-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-lg-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-lg-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-lg-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-lg-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-lg-first{-ms-flex-order:-1;order:-1}.order-lg-last{-ms-flex-order:13;order:13}.order-lg-0{-ms-flex-order:0;order:0}.order-lg-1{-ms-flex-order:1;order:1}.order-lg-2{-ms-flex-order:2;order:2}.order-lg-3{-ms-flex-order:3;order:3}.order-lg-4{-ms-flex-order:4;order:4}.order-lg-5{-ms-flex-order:5;order:5}.order-lg-6{-ms-flex-order:6;order:6}.order-lg-7{-ms-flex-order:7;order:7}.order-lg-8{-ms-flex-order:8;order:8}.order-lg-9{-ms-flex-order:9;order:9}.order-lg-10{-ms-flex-order:10;order:10}.order-lg-11{-ms-flex-order:11;order:11}.order-lg-12{-ms-flex-order:12;order:12}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.333333%}.offset-lg-2{margin-left:16.666667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.333333%}.offset-lg-5{margin-left:41.666667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.333333%}.offset-lg-8{margin-left:66.666667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.333333%}.offset-lg-11{margin-left:91.666667%}}@media (min-width:1200px){.col-xl{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;max-width:100%}.row-cols-xl-1>*{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.row-cols-xl-2>*{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.row-cols-xl-3>*{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.row-cols-xl-4>*{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.row-cols-xl-5>*{-ms-flex:0 0 20%;flex:0 0 20%;max-width:20%}.row-cols-xl-6>*{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-auto{-ms-flex:0 0 auto;flex:0 0 auto;width:auto;max-width:100%}.col-xl-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-xl-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-xl-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-xl-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-xl-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-xl-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-xl-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-xl-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-xl-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-xl-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-xl-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-xl-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}.order-xl-first{-ms-flex-order:-1;order:-1}.order-xl-last{-ms-flex-order:13;order:13}.order-xl-0{-ms-flex-order:0;order:0}.order-xl-1{-ms-flex-order:1;order:1}.order-xl-2{-ms-flex-order:2;order:2}.order-xl-3{-ms-flex-order:3;order:3}.order-xl-4{-ms-flex-order:4;order:4}.order-xl-5{-ms-flex-order:5;order:5}.order-xl-6{-ms-flex-order:6;order:6}.order-xl-7{-ms-flex-order:7;order:7}.order-xl-8{-ms-flex-order:8;order:8}.order-xl-9{-ms-flex-order:9;order:9}.order-xl-10{-ms-flex-order:10;order:10}.order-xl-11{-ms-flex-order:11;order:11}.order-xl-12{-ms-flex-order:12;order:12}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.333333%}.offset-xl-2{margin-left:16.666667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.333333%}.offset-xl-5{margin-left:41.666667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.333333%}.offset-xl-8{margin-left:66.666667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.333333%}.offset-xl-11{margin-left:91.666667%}}.table{width:100%;margin-bottom:1rem;color:#212529}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody+tbody{border-top:2px solid #dee2e6}.table-sm td,.table-sm th{padding:.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered td,.table-bordered th{border:1px solid #dee2e6}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-borderless tbody+tbody,.table-borderless td,.table-borderless th,.table-borderless thead th{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-hover tbody tr:hover{color:#212529;background-color:rgba(0,0,0,.075)}.table-primary,.table-primary>td,.table-primary>th{background-color:#b8daff}.table-primary tbody+tbody,.table-primary td,.table-primary th,.table-primary thead th{border-color:#7abaff}.table-hover .table-primary:hover{background-color:#9fcdff}.table-hover .table-primary:hover>td,.table-hover .table-primary:hover>th{background-color:#9fcdff}.table-secondary,.table-secondary>td,.table-secondary>th{background-color:#d6d8db}.table-secondary tbody+tbody,.table-secondary td,.table-secondary th,.table-secondary thead th{border-color:#b3b7bb}.table-hover .table-secondary:hover{background-color:#c8cbcf}.table-hover .table-secondary:hover>td,.table-hover .table-secondary:hover>th{background-color:#c8cbcf}.table-success,.table-success>td,.table-success>th{background-color:#c3e6cb}.table-success tbody+tbody,.table-success td,.table-success th,.table-success thead th{border-color:#8fd19e}.table-hover .table-success:hover{background-color:#b1dfbb}.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#b1dfbb}.table-info,.table-info>td,.table-info>th{background-color:#bee5eb}.table-info tbody+tbody,.table-info td,.table-info th,.table-info thead th{border-color:#86cfda}.table-hover .table-info:hover{background-color:#abdde5}.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#abdde5}.table-warning,.table-warning>td,.table-warning>th{background-color:#ffeeba}.table-warning tbody+tbody,.table-warning td,.table-warning th,.table-warning thead th{border-color:#ffdf7e}.table-hover .table-warning:hover{background-color:#ffe8a1}.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#ffe8a1}.table-danger,.table-danger>td,.table-danger>th{background-color:#f5c6cb}.table-danger tbody+tbody,.table-danger td,.table-danger th,.table-danger thead th{border-color:#ed969e}.table-hover .table-danger:hover{background-color:#f1b0b7}.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#f1b0b7}.table-light,.table-light>td,.table-light>th{background-color:#fdfdfe}.table-light tbody+tbody,.table-light td,.table-light th,.table-light thead th{border-color:#fbfcfc}.table-hover .table-light:hover{background-color:#ececf6}.table-hover .table-light:hover>td,.table-hover .table-light:hover>th{background-color:#ececf6}.table-dark,.table-dark>td,.table-dark>th{background-color:#c6c8ca}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#95999c}.table-hover .table-dark:hover{background-color:#b9bbbe}.table-hover .table-dark:hover>td,.table-hover .table-dark:hover>th{background-color:#b9bbbe}.table-active,.table-active>td,.table-active>th{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover{background-color:rgba(0,0,0,.075)}.table-hover .table-active:hover>td,.table-hover .table-active:hover>th{background-color:rgba(0,0,0,.075)}.table .thead-dark th{color:#fff;background-color:#343a40;border-color:#454d55}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#343a40}.table-dark td,.table-dark th,.table-dark thead th{border-color:#454d55}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,.05)}.table-dark.table-hover tbody tr:hover{color:#fff;background-color:rgba(255,255,255,.075)}@media (max-width:575.98px){.table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-sm>.table-bordered{border:0}}@media (max-width:767.98px){.table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-md>.table-bordered{border:0}}@media (max-width:991.98px){.table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-lg>.table-bordered{border:0}}@media (max-width:1199.98px){.table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive-xl>.table-bordered{border:0}}.table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}.table-responsive>.table-bordered{border:0}.form-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.form-control::-moz-placeholder{color:#6c757d;opacity:1}.form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.form-control::placeholder{color:#6c757d;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#e9ecef;opacity:1}input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{-webkit-appearance:none;-moz-appearance:none;appearance:none}select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.form-control-file,.form-control-range{display:block;width:100%}.col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.form-control-plaintext{display:block;width:100%;padding:.375rem 0;margin-bottom:0;font-size:1rem;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.form-control-plaintext.form-control-lg,.form-control-plaintext.form-control-sm{padding-right:0;padding-left:0}.form-control-sm{height:calc(1.5em + .5rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.form-control-lg{height:calc(1.5em + 1rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}select.form-control[multiple],select.form-control[size]{height:auto}textarea.form-control{height:auto}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.form-row>.col,.form-row>[class*=col-]{padding-right:5px;padding-left:5px}.form-check{position:relative;display:block;padding-left:1.25rem}.form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{color:#6c757d}.form-check-label{margin-bottom:0}.form-check-inline{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;padding-left:0;margin-right:.75rem}.form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.valid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,.9);border-radius:.25rem}.form-row>.col>.valid-tooltip,.form-row>[class*=col-]>.valid-tooltip{left:5px}.is-valid~.valid-feedback,.is-valid~.valid-tooltip,.was-validated :valid~.valid-feedback,.was-validated :valid~.valid-tooltip{display:block}.form-control.is-valid,.was-validated .form-control:valid{border-color:#28a745;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-valid:focus,.was-validated .form-control:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.was-validated textarea.form-control:valid,textarea.form-control.is-valid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-valid,.was-validated .custom-select:valid{border-color:#28a745;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.custom-select.is-valid:focus,.was-validated .custom-select:valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.form-check-input.is-valid~.form-check-label,.was-validated .form-check-input:valid~.form-check-label{color:#28a745}.form-check-input.is-valid~.valid-feedback,.form-check-input.is-valid~.valid-tooltip,.was-validated .form-check-input:valid~.valid-feedback,.was-validated .form-check-input:valid~.valid-tooltip{display:block}.custom-control-input.is-valid~.custom-control-label,.was-validated .custom-control-input:valid~.custom-control-label{color:#28a745}.custom-control-input.is-valid~.custom-control-label::before,.was-validated .custom-control-input:valid~.custom-control-label::before{border-color:#28a745}.custom-control-input.is-valid:checked~.custom-control-label::before,.was-validated .custom-control-input:valid:checked~.custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.custom-control-input.is-valid:focus~.custom-control-label::before,.was-validated .custom-control-input:valid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.custom-control-input.is-valid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:valid:focus:not(:checked)~.custom-control-label::before{border-color:#28a745}.custom-file-input.is-valid~.custom-file-label,.was-validated .custom-file-input:valid~.custom-file-label{border-color:#28a745}.custom-file-input.is-valid:focus~.custom-file-label,.was-validated .custom-file-input:valid:focus~.custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,.25)}.invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.invalid-tooltip{position:absolute;top:100%;left:0;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,.9);border-radius:.25rem}.form-row>.col>.invalid-tooltip,.form-row>[class*=col-]>.invalid-tooltip{left:5px}.is-invalid~.invalid-feedback,.is-invalid~.invalid-tooltip,.was-validated :invalid~.invalid-feedback,.was-validated :invalid~.invalid-tooltip{display:block}.form-control.is-invalid,.was-validated .form-control:invalid{border-color:#dc3545;padding-right:calc(1.5em + .75rem);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");background-repeat:no-repeat;background-position:right calc(.375em + .1875rem) center;background-size:calc(.75em + .375rem) calc(.75em + .375rem)}.form-control.is-invalid:focus,.was-validated .form-control:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.was-validated textarea.form-control:invalid,textarea.form-control.is-invalid{padding-right:calc(1.5em + .75rem);background-position:top calc(.375em + .1875rem) right calc(.375em + .1875rem)}.custom-select.is-invalid,.was-validated .custom-select:invalid{border-color:#dc3545;padding-right:calc(.75em + 2.3125rem);background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat,#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\") center right 1.75rem/calc(.75em + .375rem) calc(.75em + .375rem) no-repeat}.custom-select.is-invalid:focus,.was-validated .custom-select:invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-check-input.is-invalid~.form-check-label,.was-validated .form-check-input:invalid~.form-check-label{color:#dc3545}.form-check-input.is-invalid~.invalid-feedback,.form-check-input.is-invalid~.invalid-tooltip,.was-validated .form-check-input:invalid~.invalid-feedback,.was-validated .form-check-input:invalid~.invalid-tooltip{display:block}.custom-control-input.is-invalid~.custom-control-label,.was-validated .custom-control-input:invalid~.custom-control-label{color:#dc3545}.custom-control-input.is-invalid~.custom-control-label::before,.was-validated .custom-control-input:invalid~.custom-control-label::before{border-color:#dc3545}.custom-control-input.is-invalid:checked~.custom-control-label::before,.was-validated .custom-control-input:invalid:checked~.custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.custom-control-input.is-invalid:focus~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.custom-control-input.is-invalid:focus:not(:checked)~.custom-control-label::before,.was-validated .custom-control-input:invalid:focus:not(:checked)~.custom-control-label::before{border-color:#dc3545}.custom-file-input.is-invalid~.custom-file-label,.was-validated .custom-file-input:invalid~.custom-file-label{border-color:#dc3545}.custom-file-input.is-invalid:focus~.custom-file-label,.was-validated .custom-file-input:invalid:focus~.custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,.25)}.form-inline{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center}.form-inline .form-check{width:100%}@media (min-width:576px){.form-inline label{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;margin-bottom:0}.form-inline .form-group{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:center;align-items:center;margin-bottom:0}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-plaintext{display:inline-block}.form-inline .custom-select,.form-inline .input-group{width:auto}.form-inline .form-check{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:auto;padding-left:0}.form-inline .form-check-input{position:relative;-ms-flex-negative:0;flex-shrink:0;margin-top:0;margin-right:.25rem;margin-left:0}.form-inline .custom-control{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.form-inline .custom-control-label{margin-bottom:0}}.btn{display:inline-block;font-weight:400;color:#212529;text-align:center;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:transparent;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1.5;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:#212529;text-decoration:none}.btn.focus,.btn:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.btn.disabled,.btn:disabled{opacity:.65}.btn:not(:disabled):not(.disabled){cursor:pointer}a.btn.disabled,fieldset:disabled a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:hover{color:#fff;background-color:#0069d9;border-color:#0062cc}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#0069d9;border-color:#0062cc;box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-primary.disabled,.btn-primary:disabled{color:#fff;background-color:#007bff;border-color:#007bff}.btn-primary:not(:disabled):not(.disabled).active,.btn-primary:not(:disabled):not(.disabled):active,.show>.btn-primary.dropdown-toggle{color:#fff;background-color:#0062cc;border-color:#005cbf}.btn-primary:not(:disabled):not(.disabled).active:focus,.btn-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(38,143,255,.5)}.btn-secondary{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:hover{color:#fff;background-color:#5a6268;border-color:#545b62}.btn-secondary.focus,.btn-secondary:focus{color:#fff;background-color:#5a6268;border-color:#545b62;box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-secondary.disabled,.btn-secondary:disabled{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-secondary:not(:disabled):not(.disabled).active,.btn-secondary:not(:disabled):not(.disabled):active,.show>.btn-secondary.dropdown-toggle{color:#fff;background-color:#545b62;border-color:#4e555b}.btn-secondary:not(:disabled):not(.disabled).active:focus,.btn-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(130,138,145,.5)}.btn-success{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:hover{color:#fff;background-color:#218838;border-color:#1e7e34}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#218838;border-color:#1e7e34;box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-success.disabled,.btn-success:disabled{color:#fff;background-color:#28a745;border-color:#28a745}.btn-success:not(:disabled):not(.disabled).active,.btn-success:not(:disabled):not(.disabled):active,.show>.btn-success.dropdown-toggle{color:#fff;background-color:#1e7e34;border-color:#1c7430}.btn-success:not(:disabled):not(.disabled).active:focus,.btn-success:not(:disabled):not(.disabled):active:focus,.show>.btn-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(72,180,97,.5)}.btn-info{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:hover{color:#fff;background-color:#138496;border-color:#117a8b}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#138496;border-color:#117a8b;box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-info.disabled,.btn-info:disabled{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-info:not(:disabled):not(.disabled).active,.btn-info:not(:disabled):not(.disabled):active,.show>.btn-info.dropdown-toggle{color:#fff;background-color:#117a8b;border-color:#10707f}.btn-info:not(:disabled):not(.disabled).active:focus,.btn-info:not(:disabled):not(.disabled):active:focus,.show>.btn-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(58,176,195,.5)}.btn-warning{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:hover{color:#212529;background-color:#e0a800;border-color:#d39e00}.btn-warning.focus,.btn-warning:focus{color:#212529;background-color:#e0a800;border-color:#d39e00;box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-warning.disabled,.btn-warning:disabled{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-warning:not(:disabled):not(.disabled).active,.btn-warning:not(:disabled):not(.disabled):active,.show>.btn-warning.dropdown-toggle{color:#212529;background-color:#d39e00;border-color:#c69500}.btn-warning:not(:disabled):not(.disabled).active:focus,.btn-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(222,170,12,.5)}.btn-danger{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:hover{color:#fff;background-color:#c82333;border-color:#bd2130}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c82333;border-color:#bd2130;box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-danger.disabled,.btn-danger:disabled{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-danger:not(:disabled):not(.disabled).active,.btn-danger:not(:disabled):not(.disabled):active,.show>.btn-danger.dropdown-toggle{color:#fff;background-color:#bd2130;border-color:#b21f2d}.btn-danger:not(:disabled):not(.disabled).active:focus,.btn-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(225,83,97,.5)}.btn-light{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:hover{color:#212529;background-color:#e2e6ea;border-color:#dae0e5}.btn-light.focus,.btn-light:focus{color:#212529;background-color:#e2e6ea;border-color:#dae0e5;box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-light.disabled,.btn-light:disabled{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-light:not(:disabled):not(.disabled).active,.btn-light:not(:disabled):not(.disabled):active,.show>.btn-light.dropdown-toggle{color:#212529;background-color:#dae0e5;border-color:#d3d9df}.btn-light:not(:disabled):not(.disabled).active:focus,.btn-light:not(:disabled):not(.disabled):active:focus,.show>.btn-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(216,217,219,.5)}.btn-dark{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:hover{color:#fff;background-color:#23272b;border-color:#1d2124}.btn-dark.focus,.btn-dark:focus{color:#fff;background-color:#23272b;border-color:#1d2124;box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-dark.disabled,.btn-dark:disabled{color:#fff;background-color:#343a40;border-color:#343a40}.btn-dark:not(:disabled):not(.disabled).active,.btn-dark:not(:disabled):not(.disabled):active,.show>.btn-dark.dropdown-toggle{color:#fff;background-color:#1d2124;border-color:#171a1d}.btn-dark:not(:disabled):not(.disabled).active:focus,.btn-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(82,88,93,.5)}.btn-outline-primary{color:#007bff;border-color:#007bff}.btn-outline-primary:hover{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary.focus,.btn-outline-primary:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-primary.disabled,.btn-outline-primary:disabled{color:#007bff;background-color:transparent}.btn-outline-primary:not(:disabled):not(.disabled).active,.btn-outline-primary:not(:disabled):not(.disabled):active,.show>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#007bff;border-color:#007bff}.btn-outline-primary:not(:disabled):not(.disabled).active:focus,.btn-outline-primary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-primary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.btn-outline-secondary{color:#6c757d;border-color:#6c757d}.btn-outline-secondary:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary.focus,.btn-outline-secondary:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-secondary.disabled,.btn-outline-secondary:disabled{color:#6c757d;background-color:transparent}.btn-outline-secondary:not(:disabled):not(.disabled).active,.btn-outline-secondary:not(:disabled):not(.disabled):active,.show>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#6c757d;border-color:#6c757d}.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-secondary.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.btn-outline-success{color:#28a745;border-color:#28a745}.btn-outline-success:hover{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success.focus,.btn-outline-success:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-success.disabled,.btn-outline-success:disabled{color:#28a745;background-color:transparent}.btn-outline-success:not(:disabled):not(.disabled).active,.btn-outline-success:not(:disabled):not(.disabled):active,.show>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#28a745;border-color:#28a745}.btn-outline-success:not(:disabled):not(.disabled).active:focus,.btn-outline-success:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-success.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.btn-outline-info{color:#17a2b8;border-color:#17a2b8}.btn-outline-info:hover{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info.focus,.btn-outline-info:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-info.disabled,.btn-outline-info:disabled{color:#17a2b8;background-color:transparent}.btn-outline-info:not(:disabled):not(.disabled).active,.btn-outline-info:not(:disabled):not(.disabled):active,.show>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#17a2b8;border-color:#17a2b8}.btn-outline-info:not(:disabled):not(.disabled).active:focus,.btn-outline-info:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-info.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.btn-outline-warning{color:#ffc107;border-color:#ffc107}.btn-outline-warning:hover{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning.focus,.btn-outline-warning:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-warning.disabled,.btn-outline-warning:disabled{color:#ffc107;background-color:transparent}.btn-outline-warning:not(:disabled):not(.disabled).active,.btn-outline-warning:not(:disabled):not(.disabled):active,.show>.btn-outline-warning.dropdown-toggle{color:#212529;background-color:#ffc107;border-color:#ffc107}.btn-outline-warning:not(:disabled):not(.disabled).active:focus,.btn-outline-warning:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-warning.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.btn-outline-danger{color:#dc3545;border-color:#dc3545}.btn-outline-danger:hover{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger.focus,.btn-outline-danger:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-danger.disabled,.btn-outline-danger:disabled{color:#dc3545;background-color:transparent}.btn-outline-danger:not(:disabled):not(.disabled).active,.btn-outline-danger:not(:disabled):not(.disabled):active,.show>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#dc3545;border-color:#dc3545}.btn-outline-danger:not(:disabled):not(.disabled).active:focus,.btn-outline-danger:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-danger.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.btn-outline-light{color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:hover{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light.focus,.btn-outline-light:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-light.disabled,.btn-outline-light:disabled{color:#f8f9fa;background-color:transparent}.btn-outline-light:not(:disabled):not(.disabled).active,.btn-outline-light:not(:disabled):not(.disabled):active,.show>.btn-outline-light.dropdown-toggle{color:#212529;background-color:#f8f9fa;border-color:#f8f9fa}.btn-outline-light:not(:disabled):not(.disabled).active:focus,.btn-outline-light:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-light.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.btn-outline-dark{color:#343a40;border-color:#343a40}.btn-outline-dark:hover{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark.focus,.btn-outline-dark:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-outline-dark.disabled,.btn-outline-dark:disabled{color:#343a40;background-color:transparent}.btn-outline-dark:not(:disabled):not(.disabled).active,.btn-outline-dark:not(:disabled):not(.disabled):active,.show>.btn-outline-dark.dropdown-toggle{color:#fff;background-color:#343a40;border-color:#343a40}.btn-outline-dark:not(:disabled):not(.disabled).active:focus,.btn-outline-dark:not(:disabled):not(.disabled):active:focus,.show>.btn-outline-dark.dropdown-toggle:focus{box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.btn-link{font-weight:400;color:#007bff;text-decoration:none}.btn-link:hover{color:#0056b3;text-decoration:underline}.btn-link.focus,.btn-link:focus{text-decoration:underline}.btn-link.disabled,.btn-link:disabled{color:#6c757d;pointer-events:none}.btn-group-lg>.btn,.btn-lg{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.collapsing{position:relative;height:0;overflow:hidden;transition:height .35s ease}@media (prefers-reduced-motion:reduce){.collapsing{transition:none}}.dropdown,.dropleft,.dropright,.dropup{position:relative}.dropdown-toggle{white-space:nowrap}.dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.dropdown-toggle:empty::after{margin-left:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-menu-left{right:auto;left:0}.dropdown-menu-right{right:0;left:auto}@media (min-width:576px){.dropdown-menu-sm-left{right:auto;left:0}.dropdown-menu-sm-right{right:0;left:auto}}@media (min-width:768px){.dropdown-menu-md-left{right:auto;left:0}.dropdown-menu-md-right{right:0;left:auto}}@media (min-width:992px){.dropdown-menu-lg-left{right:auto;left:0}.dropdown-menu-lg-right{right:0;left:auto}}@media (min-width:1200px){.dropdown-menu-xl-left{right:auto;left:0}.dropdown-menu-xl-right{right:0;left:auto}}.dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.dropup .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.dropright .dropdown-toggle:empty::after{margin-left:0}.dropright .dropdown-toggle::after{vertical-align:0}.dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.dropleft .dropdown-toggle::after{display:none}.dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.dropleft .dropdown-toggle:empty::after{margin-left:0}.dropleft .dropdown-toggle::before{vertical-align:0}.dropdown-menu[x-placement^=bottom],.dropdown-menu[x-placement^=left],.dropdown-menu[x-placement^=right],.dropdown-menu[x-placement^=top]{right:auto;bottom:auto}.dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#16181b;text-decoration:none;background-color:#e9ecef}.dropdown-item.active,.dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.dropdown-item.disabled,.dropdown-item:disabled{color:#adb5bd;pointer-events:none;background-color:transparent}.dropdown-menu.show{display:block}.dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.btn-group,.btn-group-vertical{position:relative;display:-ms-inline-flexbox;display:inline-flex;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;-ms-flex:1 1 auto;flex:1 1 auto}.btn-group-vertical>.btn:hover,.btn-group>.btn:hover{z-index:1}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus{z-index:1}.btn-toolbar{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:start;justify-content:flex-start}.btn-toolbar .input-group{width:auto}.btn-group>.btn-group:not(:first-child),.btn-group>.btn:not(:first-child){margin-left:-1px}.btn-group>.btn-group:not(:last-child)>.btn,.btn-group>.btn:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:not(:first-child)>.btn,.btn-group>.btn:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.dropdown-toggle-split::after,.dropright .dropdown-toggle-split::after,.dropup .dropdown-toggle-split::after{margin-left:0}.dropleft .dropdown-toggle-split::before{margin-right:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn-group-vertical{-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:center;justify-content:center}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group{width:100%}.btn-group-vertical>.btn-group:not(:first-child),.btn-group-vertical>.btn:not(:first-child){margin-top:-1px}.btn-group-vertical>.btn-group:not(:last-child)>.btn,.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child)>.btn,.btn-group-vertical>.btn:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.btn-group-toggle>.btn,.btn-group-toggle>.btn-group>.btn{margin-bottom:0}.btn-group-toggle>.btn input[type=checkbox],.btn-group-toggle>.btn input[type=radio],.btn-group-toggle>.btn-group>.btn input[type=checkbox],.btn-group-toggle>.btn-group>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;width:100%}.input-group>.custom-file,.input-group>.custom-select,.input-group>.form-control,.input-group>.form-control-plaintext{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;width:1%;min-width:0;margin-bottom:0}.input-group>.custom-file+.custom-file,.input-group>.custom-file+.custom-select,.input-group>.custom-file+.form-control,.input-group>.custom-select+.custom-file,.input-group>.custom-select+.custom-select,.input-group>.custom-select+.form-control,.input-group>.form-control+.custom-file,.input-group>.form-control+.custom-select,.input-group>.form-control+.form-control,.input-group>.form-control-plaintext+.custom-file,.input-group>.form-control-plaintext+.custom-select,.input-group>.form-control-plaintext+.form-control{margin-left:-1px}.input-group>.custom-file .custom-file-input:focus~.custom-file-label,.input-group>.custom-select:focus,.input-group>.form-control:focus{z-index:3}.input-group>.custom-file .custom-file-input:focus{z-index:4}.input-group>.custom-select:not(:first-child),.input-group>.form-control:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.input-group>.custom-file{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.input-group>.custom-file:not(:first-child) .custom-file-label,.input-group>.custom-file:not(:last-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.input-group:not(.has-validation)>.custom-file:not(:last-child) .custom-file-label::after,.input-group:not(.has-validation)>.custom-select:not(:last-child),.input-group:not(.has-validation)>.form-control:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.input-group.has-validation>.custom-file:nth-last-child(n+3) .custom-file-label::after,.input-group.has-validation>.custom-select:nth-last-child(n+3),.input-group.has-validation>.form-control:nth-last-child(n+3){border-top-right-radius:0;border-bottom-right-radius:0}.input-group-append,.input-group-prepend{display:-ms-flexbox;display:flex}.input-group-append .btn,.input-group-prepend .btn{position:relative;z-index:2}.input-group-append .btn:focus,.input-group-prepend .btn:focus{z-index:3}.input-group-append .btn+.btn,.input-group-append .btn+.input-group-text,.input-group-append .input-group-text+.btn,.input-group-append .input-group-text+.input-group-text,.input-group-prepend .btn+.btn,.input-group-prepend .btn+.input-group-text,.input-group-prepend .input-group-text+.btn,.input-group-prepend .input-group-text+.input-group-text{margin-left:-1px}.input-group-prepend{margin-right:-1px}.input-group-append{margin-left:-1px}.input-group-text{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.input-group-text input[type=checkbox],.input-group-text input[type=radio]{margin-top:0}.input-group-lg>.custom-select,.input-group-lg>.form-control:not(textarea){height:calc(1.5em + 1rem + 2px)}.input-group-lg>.custom-select,.input-group-lg>.form-control,.input-group-lg>.input-group-append>.btn,.input-group-lg>.input-group-append>.input-group-text,.input-group-lg>.input-group-prepend>.btn,.input-group-lg>.input-group-prepend>.input-group-text{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.input-group-sm>.custom-select,.input-group-sm>.form-control:not(textarea){height:calc(1.5em + .5rem + 2px)}.input-group-sm>.custom-select,.input-group-sm>.form-control,.input-group-sm>.input-group-append>.btn,.input-group-sm>.input-group-append>.input-group-text,.input-group-sm>.input-group-prepend>.btn,.input-group-sm>.input-group-prepend>.input-group-text{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.input-group-lg>.custom-select,.input-group-sm>.custom-select{padding-right:1.75rem}.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.btn,.input-group.has-validation>.input-group-append:nth-last-child(n+3)>.input-group-text,.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.btn,.input-group:not(.has-validation)>.input-group-append:not(:last-child)>.input-group-text,.input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group>.input-group-append:last-child>.input-group-text:not(:last-child),.input-group>.input-group-prepend>.btn,.input-group>.input-group-prepend>.input-group-text{border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.input-group-append>.btn,.input-group>.input-group-append>.input-group-text,.input-group>.input-group-prepend:first-child>.btn:not(:first-child),.input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child),.input-group>.input-group-prepend:not(:first-child)>.btn,.input-group>.input-group-prepend:not(:first-child)>.input-group-text{border-top-left-radius:0;border-bottom-left-radius:0}.custom-control{position:relative;z-index:1;display:block;min-height:1.5rem;padding-left:1.5rem;-webkit-print-color-adjust:exact;color-adjust:exact}.custom-control-inline{display:-ms-inline-flexbox;display:inline-flex;margin-right:1rem}.custom-control-input{position:absolute;left:0;z-index:-1;width:1rem;height:1.25rem;opacity:0}.custom-control-input:checked~.custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.custom-control-input:focus~.custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-control-input:focus:not(:checked)~.custom-control-label::before{border-color:#80bdff}.custom-control-input:not(:disabled):active~.custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.custom-control-input:disabled~.custom-control-label,.custom-control-input[disabled]~.custom-control-label{color:#6c757d}.custom-control-input:disabled~.custom-control-label::before,.custom-control-input[disabled]~.custom-control-label::before{background-color:#e9ecef}.custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background:50%/50% 50% no-repeat}.custom-checkbox .custom-control-label::before{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::before{border-color:#007bff;background-color:#007bff}.custom-checkbox .custom-control-input:indeterminate~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-checkbox .custom-control-input:disabled:indeterminate~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-radio .custom-control-label::before{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.custom-radio .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-switch{padding-left:2.25rem}.custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:transform .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-transform .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-switch .custom-control-label::after{transition:none}}.custom-switch .custom-control-input:checked~.custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.custom-switch .custom-control-input:disabled:checked~.custom-control-label::before{background-color:rgba(0,123,255,.5)}.custom-select{display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:#fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right .75rem center/8px 10px no-repeat;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-select:focus::-ms-value{color:#495057;background-color:#fff}.custom-select[multiple],.custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.custom-select:disabled{color:#6c757d;background-color:#e9ecef}.custom-select::-ms-expand{display:none}.custom-select:-moz-focusring{color:transparent;text-shadow:0 0 0 #495057}.custom-select-sm{height:calc(1.5em + .5rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.custom-select-lg{height:calc(1.5em + 1rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.custom-file{position:relative;display:inline-block;width:100%;height:calc(1.5em + .75rem + 2px);margin-bottom:0}.custom-file-input{position:relative;z-index:2;width:100%;height:calc(1.5em + .75rem + 2px);margin:0;overflow:hidden;opacity:0}.custom-file-input:focus~.custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.custom-file-input:disabled~.custom-file-label,.custom-file-input[disabled]~.custom-file-label{background-color:#e9ecef}.custom-file-input:lang(en)~.custom-file-label::after{content:\"Browse\"}.custom-file-input~.custom-file-label[data-browse]::after{content:attr(data-browse)}.custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(1.5em + .75rem + 2px);padding:.375rem .75rem;overflow:hidden;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:calc(1.5em + .75rem);padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.custom-range{width:100%;height:1.4rem;padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.custom-range:focus{outline:0}.custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,.25)}.custom-range::-moz-focus-outer{border:0}.custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;-webkit-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-webkit-slider-thumb{-webkit-transition:none;transition:none}}.custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;-moz-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-moz-range-thumb{-moz-transition:none;transition:none}}.custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;-ms-transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;appearance:none}@media (prefers-reduced-motion:reduce){.custom-range::-ms-thumb{-ms-transition:none;transition:none}}.custom-range::-ms-thumb:active{background-color:#b3d7ff}.custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.custom-range:disabled::-moz-range-track{cursor:default}.custom-range:disabled::-ms-thumb{background-color:#adb5bd}.custom-control-label::before,.custom-file-label,.custom-select{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.custom-control-label::before,.custom-file-label,.custom-select{transition:none}}.nav{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:.5rem 1rem}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.nav-tabs{border-bottom:1px solid #dee2e6}.nav-tabs .nav-link{margin-bottom:-1px;border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#e9ecef #e9ecef #dee2e6}.nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.show .nav-link,.nav-tabs .nav-link.active{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.nav-pills .nav-link{border-radius:.25rem}.nav-pills .nav-link.active,.nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.nav-fill .nav-item,.nav-fill>.nav-link{-ms-flex:1 1 auto;flex:1 1 auto;text-align:center}.nav-justified .nav-item,.nav-justified>.nav-link{-ms-flex-preferred-size:0;flex-basis:0;-ms-flex-positive:1;flex-grow:1;text-align:center}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;padding:.5rem 1rem}.navbar .container,.navbar .container-fluid,.navbar .container-lg,.navbar .container-md,.navbar .container-sm,.navbar .container-xl{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-nav{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link{padding-right:0;padding-left:0}.navbar-nav .dropdown-menu{position:static;float:none}.navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.navbar-collapse{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-align:center;align-items:center}.navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:50%/100% 100% no-repeat}.navbar-nav-scroll{max-height:75vh;overflow-y:auto}@media (max-width:575.98px){.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{padding-right:0;padding-left:0}}@media (min-width:576px){.navbar-expand-sm{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-sm .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-sm>.container,.navbar-expand-sm>.container-fluid,.navbar-expand-sm>.container-lg,.navbar-expand-sm>.container-md,.navbar-expand-sm>.container-sm,.navbar-expand-sm>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-sm .navbar-nav-scroll{overflow:visible}.navbar-expand-sm .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-sm .navbar-toggler{display:none}}@media (max-width:767.98px){.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{padding-right:0;padding-left:0}}@media (min-width:768px){.navbar-expand-md{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-md .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-md>.container,.navbar-expand-md>.container-fluid,.navbar-expand-md>.container-lg,.navbar-expand-md>.container-md,.navbar-expand-md>.container-sm,.navbar-expand-md>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-md .navbar-nav-scroll{overflow:visible}.navbar-expand-md .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-md .navbar-toggler{display:none}}@media (max-width:991.98px){.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{padding-right:0;padding-left:0}}@media (min-width:992px){.navbar-expand-lg{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-lg .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-lg>.container,.navbar-expand-lg>.container-fluid,.navbar-expand-lg>.container-lg,.navbar-expand-lg>.container-md,.navbar-expand-lg>.container-sm,.navbar-expand-lg>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-lg .navbar-nav-scroll{overflow:visible}.navbar-expand-lg .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}}@media (max-width:1199.98px){.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{padding-right:0;padding-left:0}}@media (min-width:1200px){.navbar-expand-xl{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand-xl .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand-xl>.container,.navbar-expand-xl>.container-fluid,.navbar-expand-xl>.container-lg,.navbar-expand-xl>.container-md,.navbar-expand-xl>.container-sm,.navbar-expand-xl>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand-xl .navbar-nav-scroll{overflow:visible}.navbar-expand-xl .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand-xl .navbar-toggler{display:none}}.navbar-expand{-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{padding-right:0;padding-left:0}.navbar-expand .navbar-nav{-ms-flex-direction:row;flex-direction:row}.navbar-expand .navbar-nav .dropdown-menu{position:absolute}.navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.navbar-expand>.container,.navbar-expand>.container-fluid,.navbar-expand>.container-lg,.navbar-expand>.container-md,.navbar-expand>.container-sm,.navbar-expand>.container-xl{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.navbar-expand .navbar-nav-scroll{overflow:visible}.navbar-expand .navbar-collapse{display:-ms-flexbox!important;display:flex!important;-ms-flex-preferred-size:auto;flex-basis:auto}.navbar-expand .navbar-toggler{display:none}.navbar-light .navbar-brand{color:rgba(0,0,0,.9)}.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.9)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.5)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.7)}.navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.show,.navbar-light .navbar-nav .show>.nav-link{color:rgba(0,0,0,.9)}.navbar-light .navbar-toggler{color:rgba(0,0,0,.5);border-color:rgba(0,0,0,.1)}.navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-light .navbar-text{color:rgba(0,0,0,.5)}.navbar-light .navbar-text a{color:rgba(0,0,0,.9)}.navbar-light .navbar-text a:focus,.navbar-light .navbar-text a:hover{color:rgba(0,0,0,.9)}.navbar-dark .navbar-brand{color:#fff}.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:rgba(255,255,255,.75)}.navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,.25)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.show,.navbar-dark .navbar-nav .show>.nav-link{color:#fff}.navbar-dark .navbar-toggler{color:rgba(255,255,255,.5);border-color:rgba(255,255,255,.1)}.navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.navbar-dark .navbar-text{color:rgba(255,255,255,.5)}.navbar-dark .navbar-text a{color:#fff}.navbar-dark .navbar-text a:focus,.navbar-dark .navbar-text a:hover{color:#fff}.card{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,.125);border-radius:.25rem}.card>hr{margin-right:0;margin-left:0}.card>.list-group{border-top:inherit;border-bottom:inherit}.card>.list-group:first-child{border-top-width:0;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card>.list-group:last-child{border-bottom-width:0;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card>.card-header+.list-group,.card>.list-group+.card-footer{border-top:0}.card-body{-ms-flex:1 1 auto;flex:1 1 auto;min-height:1px;padding:1.25rem}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem;margin-bottom:0}.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card-header{padding:.75rem 1.25rem;margin-bottom:0;background-color:rgba(0,0,0,.03);border-bottom:1px solid rgba(0,0,0,.125)}.card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,.03);border-top:1px solid rgba(0,0,0,.125)}.card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem;border-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom,.card-img-top{-ms-flex-negative:0;flex-shrink:0;width:100%}.card-img,.card-img-top{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.card-img,.card-img-bottom{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.card-deck .card{margin-bottom:15px}@media (min-width:576px){.card-deck{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.card-deck .card{-ms-flex:1 0 0%;flex:1 0 0%;margin-right:15px;margin-bottom:0;margin-left:15px}}.card-group>.card{margin-bottom:15px}@media (min-width:576px){.card-group{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.card-group>.card{-ms-flex:1 0 0%;flex:1 0 0%;margin-bottom:0}.card-group>.card+.card{margin-left:0;border-left:0}.card-group>.card:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top{border-top-right-radius:0}.card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom{border-bottom-right-radius:0}.card-group>.card:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top{border-top-left-radius:0}.card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom{border-bottom-left-radius:0}}.card-columns .card{margin-bottom:.75rem}@media (min-width:576px){.card-columns{-webkit-column-count:3;-moz-column-count:3;column-count:3;-webkit-column-gap:1.25rem;-moz-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.card-columns .card{display:inline-block;width:100%}}.accordion{overflow-anchor:none}.accordion>.card{overflow:hidden}.accordion>.card:not(:last-of-type){border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.accordion>.card:not(:first-of-type){border-top-left-radius:0;border-top-right-radius:0}.accordion>.card>.card-header{border-radius:0;margin-bottom:-1px}.breadcrumb{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.breadcrumb-item+.breadcrumb-item::before{float:left;padding-right:.5rem;color:#6c757d;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.breadcrumb-item.active{color:#6c757d}.pagination{display:-ms-flexbox;display:flex;padding-left:0;list-style:none;border-radius:.25rem}.page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.page-link:focus{z-index:3;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.25)}.page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.page-item.active .page-link{z-index:3;color:#fff;background-color:#007bff;border-color:#007bff}.page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.badge{transition:none}}a.badge:focus,a.badge:hover{text-decoration:none}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.badge-primary{color:#fff;background-color:#007bff}a.badge-primary:focus,a.badge-primary:hover{color:#fff;background-color:#0062cc}a.badge-primary.focus,a.badge-primary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,.5)}.badge-secondary{color:#fff;background-color:#6c757d}a.badge-secondary:focus,a.badge-secondary:hover{color:#fff;background-color:#545b62}a.badge-secondary.focus,a.badge-secondary:focus{outline:0;box-shadow:0 0 0 .2rem rgba(108,117,125,.5)}.badge-success{color:#fff;background-color:#28a745}a.badge-success:focus,a.badge-success:hover{color:#fff;background-color:#1e7e34}a.badge-success.focus,a.badge-success:focus{outline:0;box-shadow:0 0 0 .2rem rgba(40,167,69,.5)}.badge-info{color:#fff;background-color:#17a2b8}a.badge-info:focus,a.badge-info:hover{color:#fff;background-color:#117a8b}a.badge-info.focus,a.badge-info:focus{outline:0;box-shadow:0 0 0 .2rem rgba(23,162,184,.5)}.badge-warning{color:#212529;background-color:#ffc107}a.badge-warning:focus,a.badge-warning:hover{color:#212529;background-color:#d39e00}a.badge-warning.focus,a.badge-warning:focus{outline:0;box-shadow:0 0 0 .2rem rgba(255,193,7,.5)}.badge-danger{color:#fff;background-color:#dc3545}a.badge-danger:focus,a.badge-danger:hover{color:#fff;background-color:#bd2130}a.badge-danger.focus,a.badge-danger:focus{outline:0;box-shadow:0 0 0 .2rem rgba(220,53,69,.5)}.badge-light{color:#212529;background-color:#f8f9fa}a.badge-light:focus,a.badge-light:hover{color:#212529;background-color:#dae0e5}a.badge-light.focus,a.badge-light:focus{outline:0;box-shadow:0 0 0 .2rem rgba(248,249,250,.5)}.badge-dark{color:#fff;background-color:#343a40}a.badge-dark:focus,a.badge-dark:hover{color:#fff;background-color:#1d2124}a.badge-dark.focus,a.badge-dark:focus{outline:0;box-shadow:0 0 0 .2rem rgba(52,58,64,.5)}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width:576px){.jumbotron{padding:4rem 2rem}}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:4rem}.alert-dismissible .close{position:absolute;top:0;right:0;z-index:2;padding:.75rem 1.25rem;color:inherit}.alert-primary{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-primary hr{border-top-color:#9fcdff}.alert-primary .alert-link{color:#002752}.alert-secondary{color:#383d41;background-color:#e2e3e5;border-color:#d6d8db}.alert-secondary hr{border-top-color:#c8cbcf}.alert-secondary .alert-link{color:#202326}.alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.alert-success hr{border-top-color:#b1dfbb}.alert-success .alert-link{color:#0b2e13}.alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.alert-info hr{border-top-color:#abdde5}.alert-info .alert-link{color:#062c33}.alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.alert-warning hr{border-top-color:#ffe8a1}.alert-warning .alert-link{color:#533f03}.alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.alert-danger hr{border-top-color:#f1b0b7}.alert-danger .alert-link{color:#491217}.alert-light{color:#818182;background-color:#fefefe;border-color:#fdfdfe}.alert-light hr{border-top-color:#ececf6}.alert-light .alert-link{color:#686868}.alert-dark{color:#1b1e21;background-color:#d6d8d9;border-color:#c6c8ca}.alert-dark hr{border-top-color:#b9bbbe}.alert-dark .alert-link{color:#040505}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.progress{display:-ms-flexbox;display:flex;height:1rem;overflow:hidden;line-height:0;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.progress-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;overflow:hidden;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width .6s ease}@media (prefers-reduced-motion:reduce){.progress-bar{transition:none}}.progress-bar-striped{background-image:linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);background-size:1rem 1rem}.progress-bar-animated{-webkit-animation:1s linear infinite progress-bar-stripes;animation:1s linear infinite progress-bar-stripes}@media (prefers-reduced-motion:reduce){.progress-bar-animated{-webkit-animation:none;animation:none}}.media{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start}.media-body{-ms-flex:1;flex:1}.list-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;padding-left:0;margin-bottom:0;border-radius:.25rem}.list-group-item-action{width:100%;color:#495057;text-align:inherit}.list-group-item-action:focus,.list-group-item-action:hover{z-index:1;color:#495057;text-decoration:none;background-color:#f8f9fa}.list-group-item-action:active{color:#212529;background-color:#e9ecef}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;background-color:#fff;border:1px solid rgba(0,0,0,.125)}.list-group-item:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit}.list-group-item:last-child{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit}.list-group-item.disabled,.list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.list-group-item+.list-group-item{border-top-width:0}.list-group-item+.list-group-item.active{margin-top:-1px;border-top-width:1px}.list-group-horizontal{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal>.list-group-item.active{margin-top:0}.list-group-horizontal>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}@media (min-width:576px){.list-group-horizontal-sm{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-sm>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-sm>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-sm>.list-group-item.active{margin-top:0}.list-group-horizontal-sm>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-sm>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:768px){.list-group-horizontal-md{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-md>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-md>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-md>.list-group-item.active{margin-top:0}.list-group-horizontal-md>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-md>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:992px){.list-group-horizontal-lg{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-lg>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-lg>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-lg>.list-group-item.active{margin-top:0}.list-group-horizontal-lg>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-lg>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}@media (min-width:1200px){.list-group-horizontal-xl{-ms-flex-direction:row;flex-direction:row}.list-group-horizontal-xl>.list-group-item:first-child{border-bottom-left-radius:.25rem;border-top-right-radius:0}.list-group-horizontal-xl>.list-group-item:last-child{border-top-right-radius:.25rem;border-bottom-left-radius:0}.list-group-horizontal-xl>.list-group-item.active{margin-top:0}.list-group-horizontal-xl>.list-group-item+.list-group-item{border-top-width:1px;border-left-width:0}.list-group-horizontal-xl>.list-group-item+.list-group-item.active{margin-left:-1px;border-left-width:1px}}.list-group-flush{border-radius:0}.list-group-flush>.list-group-item{border-width:0 0 1px}.list-group-flush>.list-group-item:last-child{border-bottom-width:0}.list-group-item-primary{color:#004085;background-color:#b8daff}.list-group-item-primary.list-group-item-action:focus,.list-group-item-primary.list-group-item-action:hover{color:#004085;background-color:#9fcdff}.list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#004085;border-color:#004085}.list-group-item-secondary{color:#383d41;background-color:#d6d8db}.list-group-item-secondary.list-group-item-action:focus,.list-group-item-secondary.list-group-item-action:hover{color:#383d41;background-color:#c8cbcf}.list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#383d41;border-color:#383d41}.list-group-item-success{color:#155724;background-color:#c3e6cb}.list-group-item-success.list-group-item-action:focus,.list-group-item-success.list-group-item-action:hover{color:#155724;background-color:#b1dfbb}.list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.list-group-item-info{color:#0c5460;background-color:#bee5eb}.list-group-item-info.list-group-item-action:focus,.list-group-item-info.list-group-item-action:hover{color:#0c5460;background-color:#abdde5}.list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.list-group-item-warning{color:#856404;background-color:#ffeeba}.list-group-item-warning.list-group-item-action:focus,.list-group-item-warning.list-group-item-action:hover{color:#856404;background-color:#ffe8a1}.list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.list-group-item-danger{color:#721c24;background-color:#f5c6cb}.list-group-item-danger.list-group-item-action:focus,.list-group-item-danger.list-group-item-action:hover{color:#721c24;background-color:#f1b0b7}.list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.list-group-item-light{color:#818182;background-color:#fdfdfe}.list-group-item-light.list-group-item-action:focus,.list-group-item-light.list-group-item-action:hover{color:#818182;background-color:#ececf6}.list-group-item-light.list-group-item-action.active{color:#fff;background-color:#818182;border-color:#818182}.list-group-item-dark{color:#1b1e21;background-color:#c6c8ca}.list-group-item-dark.list-group-item-action:focus,.list-group-item-dark.list-group-item-action:hover{color:#1b1e21;background-color:#b9bbbe}.list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#1b1e21;border-color:#1b1e21}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.close:hover{color:#000;text-decoration:none}.close:not(:disabled):not(.disabled):focus,.close:not(:disabled):not(.disabled):hover{opacity:.75}button.close{padding:0;background-color:transparent;border:0}a.close.disabled{pointer-events:none}.toast{-ms-flex-preferred-size:350px;flex-basis:350px;max-width:350px;font-size:.875rem;background-color:rgba(255,255,255,.85);background-clip:padding-box;border:1px solid rgba(0,0,0,.1);box-shadow:0 .25rem .75rem rgba(0,0,0,.1);opacity:0;border-radius:.25rem}.toast:not(:last-child){margin-bottom:.75rem}.toast.showing{opacity:1}.toast.show{display:block;opacity:1}.toast.hide{display:none}.toast-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:.25rem .75rem;color:#6c757d;background-color:rgba(255,255,255,.85);background-clip:padding-box;border-bottom:1px solid rgba(0,0,0,.05);border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.toast-body{padding:.75rem}.modal-open{overflow:hidden}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal{position:fixed;top:0;left:0;z-index:1050;display:none;width:100%;height:100%;overflow:hidden;outline:0}.modal-dialog{position:relative;width:auto;margin:.5rem;pointer-events:none}.modal.fade .modal-dialog{transition:-webkit-transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translate(0,-50px);transform:translate(0,-50px)}@media (prefers-reduced-motion:reduce){.modal.fade .modal-dialog{transition:none}}.modal.show .modal-dialog{-webkit-transform:none;transform:none}.modal.modal-static .modal-dialog{-webkit-transform:scale(1.02);transform:scale(1.02)}.modal-dialog-scrollable{display:-ms-flexbox;display:flex;max-height:calc(100% - 1rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 1rem);overflow:hidden}.modal-dialog-scrollable .modal-footer,.modal-dialog-scrollable .modal-header{-ms-flex-negative:0;flex-shrink:0}.modal-dialog-scrollable .modal-body{overflow-y:auto}.modal-dialog-centered{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;min-height:calc(100% - 1rem)}.modal-dialog-centered::before{display:block;height:calc(100vh - 1rem);height:-webkit-min-content;height:-moz-min-content;height:min-content;content:\"\"}.modal-dialog-centered.modal-dialog-scrollable{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;height:100%}.modal-dialog-centered.modal-dialog-scrollable .modal-content{max-height:none}.modal-dialog-centered.modal-dialog-scrollable::before{content:none}.modal-content{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;left:0;z-index:1040;width:100vw;height:100vh;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:.5}.modal-header{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;-ms-flex-pack:justify;justify-content:space-between;padding:1rem 1rem;border-bottom:1px solid #dee2e6;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.modal-header .close{padding:1rem 1rem;margin:-1rem -1rem -1rem auto}.modal-title{margin-bottom:0;line-height:1.5}.modal-body{position:relative;-ms-flex:1 1 auto;flex:1 1 auto;padding:1rem}.modal-footer{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;padding:.75rem;border-top:1px solid #dee2e6;border-bottom-right-radius:calc(.3rem - 1px);border-bottom-left-radius:calc(.3rem - 1px)}.modal-footer>*{margin:.25rem}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:576px){.modal-dialog{max-width:500px;margin:1.75rem auto}.modal-dialog-scrollable{max-height:calc(100% - 3.5rem)}.modal-dialog-scrollable .modal-content{max-height:calc(100vh - 3.5rem)}.modal-dialog-centered{min-height:calc(100% - 3.5rem)}.modal-dialog-centered::before{height:calc(100vh - 3.5rem);height:-webkit-min-content;height:-moz-min-content;height:min-content}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg,.modal-xl{max-width:800px}}@media (min-width:1200px){.modal-xl{max-width:1140px}}.tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.show{opacity:.9}.tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.bs-tooltip-auto[x-placement^=top],.bs-tooltip-top{padding:.4rem 0}.bs-tooltip-auto[x-placement^=top] .arrow,.bs-tooltip-top .arrow{bottom:0}.bs-tooltip-auto[x-placement^=top] .arrow::before,.bs-tooltip-top .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.bs-tooltip-auto[x-placement^=right],.bs-tooltip-right{padding:0 .4rem}.bs-tooltip-auto[x-placement^=right] .arrow,.bs-tooltip-right .arrow{left:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=right] .arrow::before,.bs-tooltip-right .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.bs-tooltip-auto[x-placement^=bottom],.bs-tooltip-bottom{padding:.4rem 0}.bs-tooltip-auto[x-placement^=bottom] .arrow,.bs-tooltip-bottom .arrow{top:0}.bs-tooltip-auto[x-placement^=bottom] .arrow::before,.bs-tooltip-bottom .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.bs-tooltip-auto[x-placement^=left],.bs-tooltip-left{padding:0 .4rem}.bs-tooltip-auto[x-placement^=left] .arrow,.bs-tooltip-left .arrow{right:0;width:.4rem;height:.8rem}.bs-tooltip-auto[x-placement^=left] .arrow::before,.bs-tooltip-left .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.popover .arrow::after,.popover .arrow::before{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.bs-popover-auto[x-placement^=top],.bs-popover-top{margin-bottom:.5rem}.bs-popover-auto[x-placement^=top]>.arrow,.bs-popover-top>.arrow{bottom:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=top]>.arrow::before,.bs-popover-top>.arrow::before{bottom:0;border-width:.5rem .5rem 0;border-top-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=top]>.arrow::after,.bs-popover-top>.arrow::after{bottom:1px;border-width:.5rem .5rem 0;border-top-color:#fff}.bs-popover-auto[x-placement^=right],.bs-popover-right{margin-left:.5rem}.bs-popover-auto[x-placement^=right]>.arrow,.bs-popover-right>.arrow{left:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=right]>.arrow::before,.bs-popover-right>.arrow::before{left:0;border-width:.5rem .5rem .5rem 0;border-right-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=right]>.arrow::after,.bs-popover-right>.arrow::after{left:1px;border-width:.5rem .5rem .5rem 0;border-right-color:#fff}.bs-popover-auto[x-placement^=bottom],.bs-popover-bottom{margin-top:.5rem}.bs-popover-auto[x-placement^=bottom]>.arrow,.bs-popover-bottom>.arrow{top:calc(-.5rem - 1px)}.bs-popover-auto[x-placement^=bottom]>.arrow::before,.bs-popover-bottom>.arrow::before{top:0;border-width:0 .5rem .5rem .5rem;border-bottom-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=bottom]>.arrow::after,.bs-popover-bottom>.arrow::after{top:1px;border-width:0 .5rem .5rem .5rem;border-bottom-color:#fff}.bs-popover-auto[x-placement^=bottom] .popover-header::before,.bs-popover-bottom .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.bs-popover-auto[x-placement^=left],.bs-popover-left{margin-right:.5rem}.bs-popover-auto[x-placement^=left]>.arrow,.bs-popover-left>.arrow{right:calc(-.5rem - 1px);width:.5rem;height:1rem;margin:.3rem 0}.bs-popover-auto[x-placement^=left]>.arrow::before,.bs-popover-left>.arrow::before{right:0;border-width:.5rem 0 .5rem .5rem;border-left-color:rgba(0,0,0,.25)}.bs-popover-auto[x-placement^=left]>.arrow::after,.bs-popover-left>.arrow::after{right:1px;border-width:.5rem 0 .5rem .5rem;border-left-color:#fff}.popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.popover-header:empty{display:none}.popover-body{padding:.5rem .75rem;color:#212529}.carousel{position:relative}.carousel.pointer-event{-ms-touch-action:pan-y;touch-action:pan-y}.carousel-inner{position:relative;width:100%;overflow:hidden}.carousel-inner::after{display:block;clear:both;content:\"\"}.carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out}@media (prefers-reduced-motion:reduce){.carousel-item{transition:none}}.carousel-item-next,.carousel-item-prev,.carousel-item.active{display:block}.active.carousel-item-right,.carousel-item-next:not(.carousel-item-left){-webkit-transform:translateX(100%);transform:translateX(100%)}.active.carousel-item-left,.carousel-item-prev:not(.carousel-item-right){-webkit-transform:translateX(-100%);transform:translateX(-100%)}.carousel-fade .carousel-item{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.carousel-fade .carousel-item-next.carousel-item-left,.carousel-fade .carousel-item-prev.carousel-item-right,.carousel-fade .carousel-item.active{z-index:1;opacity:1}.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:opacity 0s .6s}@media (prefers-reduced-motion:reduce){.carousel-fade .active.carousel-item-left,.carousel-fade .active.carousel-item-right{transition:none}}.carousel-control-next,.carousel-control-prev{position:absolute;top:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity .15s ease}@media (prefers-reduced-motion:reduce){.carousel-control-next,.carousel-control-prev{transition:none}}.carousel-control-next:focus,.carousel-control-next:hover,.carousel-control-prev:focus,.carousel-control-prev:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control-prev{left:0}.carousel-control-next{right:0}.carousel-control-next-icon,.carousel-control-prev-icon{display:inline-block;width:20px;height:20px;background:50%/100% 100% no-repeat}.carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")}.carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")}.carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.carousel-indicators li{box-sizing:content-box;-ms-flex:0 1 auto;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity .6s ease}@media (prefers-reduced-motion:reduce){.carousel-indicators li{transition:none}}.carousel-indicators .active{opacity:1}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}@-webkit-keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinner-border{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.spinner-border{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;border:.25em solid currentColor;border-right-color:transparent;border-radius:50%;-webkit-animation:.75s linear infinite spinner-border;animation:.75s linear infinite spinner-border}.spinner-border-sm{width:1rem;height:1rem;border-width:.2em}@-webkit-keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}@keyframes spinner-grow{0%{-webkit-transform:scale(0);transform:scale(0)}50%{opacity:1;-webkit-transform:none;transform:none}}.spinner-grow{display:inline-block;width:2rem;height:2rem;vertical-align:text-bottom;background-color:currentColor;border-radius:50%;opacity:0;-webkit-animation:.75s linear infinite spinner-grow;animation:.75s linear infinite spinner-grow}.spinner-grow-sm{width:1rem;height:1rem}@media (prefers-reduced-motion:reduce){.spinner-border,.spinner-grow{-webkit-animation-duration:1.5s;animation-duration:1.5s}}.align-baseline{vertical-align:baseline!important}.align-top{vertical-align:top!important}.align-middle{vertical-align:middle!important}.align-bottom{vertical-align:bottom!important}.align-text-bottom{vertical-align:text-bottom!important}.align-text-top{vertical-align:text-top!important}.bg-primary{background-color:#007bff!important}a.bg-primary:focus,a.bg-primary:hover,button.bg-primary:focus,button.bg-primary:hover{background-color:#0062cc!important}.bg-secondary{background-color:#6c757d!important}a.bg-secondary:focus,a.bg-secondary:hover,button.bg-secondary:focus,button.bg-secondary:hover{background-color:#545b62!important}.bg-success{background-color:#28a745!important}a.bg-success:focus,a.bg-success:hover,button.bg-success:focus,button.bg-success:hover{background-color:#1e7e34!important}.bg-info{background-color:#17a2b8!important}a.bg-info:focus,a.bg-info:hover,button.bg-info:focus,button.bg-info:hover{background-color:#117a8b!important}.bg-warning{background-color:#ffc107!important}a.bg-warning:focus,a.bg-warning:hover,button.bg-warning:focus,button.bg-warning:hover{background-color:#d39e00!important}.bg-danger{background-color:#dc3545!important}a.bg-danger:focus,a.bg-danger:hover,button.bg-danger:focus,button.bg-danger:hover{background-color:#bd2130!important}.bg-light{background-color:#f8f9fa!important}a.bg-light:focus,a.bg-light:hover,button.bg-light:focus,button.bg-light:hover{background-color:#dae0e5!important}.bg-dark{background-color:#343a40!important}a.bg-dark:focus,a.bg-dark:hover,button.bg-dark:focus,button.bg-dark:hover{background-color:#1d2124!important}.bg-white{background-color:#fff!important}.bg-transparent{background-color:transparent!important}.border{border:1px solid #dee2e6!important}.border-top{border-top:1px solid #dee2e6!important}.border-right{border-right:1px solid #dee2e6!important}.border-bottom{border-bottom:1px solid #dee2e6!important}.border-left{border-left:1px solid #dee2e6!important}.border-0{border:0!important}.border-top-0{border-top:0!important}.border-right-0{border-right:0!important}.border-bottom-0{border-bottom:0!important}.border-left-0{border-left:0!important}.border-primary{border-color:#007bff!important}.border-secondary{border-color:#6c757d!important}.border-success{border-color:#28a745!important}.border-info{border-color:#17a2b8!important}.border-warning{border-color:#ffc107!important}.border-danger{border-color:#dc3545!important}.border-light{border-color:#f8f9fa!important}.border-dark{border-color:#343a40!important}.border-white{border-color:#fff!important}.rounded-sm{border-radius:.2rem!important}.rounded{border-radius:.25rem!important}.rounded-top{border-top-left-radius:.25rem!important;border-top-right-radius:.25rem!important}.rounded-right{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important}.rounded-bottom{border-bottom-right-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-left{border-top-left-radius:.25rem!important;border-bottom-left-radius:.25rem!important}.rounded-lg{border-radius:.3rem!important}.rounded-circle{border-radius:50%!important}.rounded-pill{border-radius:50rem!important}.rounded-0{border-radius:0!important}.clearfix::after{display:block;clear:both;content:\"\"}.d-none{display:none!important}.d-inline{display:inline!important}.d-inline-block{display:inline-block!important}.d-block{display:block!important}.d-table{display:table!important}.d-table-row{display:table-row!important}.d-table-cell{display:table-cell!important}.d-flex{display:-ms-flexbox!important;display:flex!important}.d-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}@media (min-width:576px){.d-sm-none{display:none!important}.d-sm-inline{display:inline!important}.d-sm-inline-block{display:inline-block!important}.d-sm-block{display:block!important}.d-sm-table{display:table!important}.d-sm-table-row{display:table-row!important}.d-sm-table-cell{display:table-cell!important}.d-sm-flex{display:-ms-flexbox!important;display:flex!important}.d-sm-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:768px){.d-md-none{display:none!important}.d-md-inline{display:inline!important}.d-md-inline-block{display:inline-block!important}.d-md-block{display:block!important}.d-md-table{display:table!important}.d-md-table-row{display:table-row!important}.d-md-table-cell{display:table-cell!important}.d-md-flex{display:-ms-flexbox!important;display:flex!important}.d-md-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:992px){.d-lg-none{display:none!important}.d-lg-inline{display:inline!important}.d-lg-inline-block{display:inline-block!important}.d-lg-block{display:block!important}.d-lg-table{display:table!important}.d-lg-table-row{display:table-row!important}.d-lg-table-cell{display:table-cell!important}.d-lg-flex{display:-ms-flexbox!important;display:flex!important}.d-lg-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media (min-width:1200px){.d-xl-none{display:none!important}.d-xl-inline{display:inline!important}.d-xl-inline-block{display:inline-block!important}.d-xl-block{display:block!important}.d-xl-table{display:table!important}.d-xl-table-row{display:table-row!important}.d-xl-table-cell{display:table-cell!important}.d-xl-flex{display:-ms-flexbox!important;display:flex!important}.d-xl-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}@media print{.d-print-none{display:none!important}.d-print-inline{display:inline!important}.d-print-inline-block{display:inline-block!important}.d-print-block{display:block!important}.d-print-table{display:table!important}.d-print-table-row{display:table-row!important}.d-print-table-cell{display:table-cell!important}.d-print-flex{display:-ms-flexbox!important;display:flex!important}.d-print-inline-flex{display:-ms-inline-flexbox!important;display:inline-flex!important}}.embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.embed-responsive::before{display:block;content:\"\"}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9::before{padding-top:42.857143%}.embed-responsive-16by9::before{padding-top:56.25%}.embed-responsive-4by3::before{padding-top:75%}.embed-responsive-1by1::before{padding-top:100%}.flex-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-center{-ms-flex-align:center!important;align-items:center!important}.align-items-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}@media (min-width:576px){.flex-sm-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-sm-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-sm-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-sm-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-sm-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-sm-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-sm-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-sm-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-sm-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-sm-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-sm-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-sm-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-sm-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-sm-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-sm-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-sm-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-sm-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-sm-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-sm-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-sm-center{-ms-flex-align:center!important;align-items:center!important}.align-items-sm-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-sm-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-sm-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-sm-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-sm-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-sm-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-sm-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-sm-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-sm-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-sm-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-sm-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-sm-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-sm-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-sm-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:768px){.flex-md-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-md-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-md-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-md-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-md-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-md-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-md-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-md-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-md-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-md-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-md-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-md-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-md-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-md-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-md-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-md-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-md-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-md-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-md-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-md-center{-ms-flex-align:center!important;align-items:center!important}.align-items-md-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-md-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-md-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-md-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-md-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-md-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-md-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-md-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-md-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-md-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-md-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-md-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-md-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-md-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:992px){.flex-lg-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-lg-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-lg-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-lg-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-lg-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-lg-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-lg-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-lg-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-lg-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-lg-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-lg-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-lg-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-lg-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-lg-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-lg-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-lg-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-lg-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-lg-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-lg-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-lg-center{-ms-flex-align:center!important;align-items:center!important}.align-items-lg-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-lg-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-lg-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-lg-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-lg-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-lg-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-lg-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-lg-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-lg-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-lg-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-lg-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-lg-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-lg-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-lg-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}@media (min-width:1200px){.flex-xl-row{-ms-flex-direction:row!important;flex-direction:row!important}.flex-xl-column{-ms-flex-direction:column!important;flex-direction:column!important}.flex-xl-row-reverse{-ms-flex-direction:row-reverse!important;flex-direction:row-reverse!important}.flex-xl-column-reverse{-ms-flex-direction:column-reverse!important;flex-direction:column-reverse!important}.flex-xl-wrap{-ms-flex-wrap:wrap!important;flex-wrap:wrap!important}.flex-xl-nowrap{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}.flex-xl-wrap-reverse{-ms-flex-wrap:wrap-reverse!important;flex-wrap:wrap-reverse!important}.flex-xl-fill{-ms-flex:1 1 auto!important;flex:1 1 auto!important}.flex-xl-grow-0{-ms-flex-positive:0!important;flex-grow:0!important}.flex-xl-grow-1{-ms-flex-positive:1!important;flex-grow:1!important}.flex-xl-shrink-0{-ms-flex-negative:0!important;flex-shrink:0!important}.flex-xl-shrink-1{-ms-flex-negative:1!important;flex-shrink:1!important}.justify-content-xl-start{-ms-flex-pack:start!important;justify-content:flex-start!important}.justify-content-xl-end{-ms-flex-pack:end!important;justify-content:flex-end!important}.justify-content-xl-center{-ms-flex-pack:center!important;justify-content:center!important}.justify-content-xl-between{-ms-flex-pack:justify!important;justify-content:space-between!important}.justify-content-xl-around{-ms-flex-pack:distribute!important;justify-content:space-around!important}.align-items-xl-start{-ms-flex-align:start!important;align-items:flex-start!important}.align-items-xl-end{-ms-flex-align:end!important;align-items:flex-end!important}.align-items-xl-center{-ms-flex-align:center!important;align-items:center!important}.align-items-xl-baseline{-ms-flex-align:baseline!important;align-items:baseline!important}.align-items-xl-stretch{-ms-flex-align:stretch!important;align-items:stretch!important}.align-content-xl-start{-ms-flex-line-pack:start!important;align-content:flex-start!important}.align-content-xl-end{-ms-flex-line-pack:end!important;align-content:flex-end!important}.align-content-xl-center{-ms-flex-line-pack:center!important;align-content:center!important}.align-content-xl-between{-ms-flex-line-pack:justify!important;align-content:space-between!important}.align-content-xl-around{-ms-flex-line-pack:distribute!important;align-content:space-around!important}.align-content-xl-stretch{-ms-flex-line-pack:stretch!important;align-content:stretch!important}.align-self-xl-auto{-ms-flex-item-align:auto!important;align-self:auto!important}.align-self-xl-start{-ms-flex-item-align:start!important;align-self:flex-start!important}.align-self-xl-end{-ms-flex-item-align:end!important;align-self:flex-end!important}.align-self-xl-center{-ms-flex-item-align:center!important;align-self:center!important}.align-self-xl-baseline{-ms-flex-item-align:baseline!important;align-self:baseline!important}.align-self-xl-stretch{-ms-flex-item-align:stretch!important;align-self:stretch!important}}.float-left{float:left!important}.float-right{float:right!important}.float-none{float:none!important}@media (min-width:576px){.float-sm-left{float:left!important}.float-sm-right{float:right!important}.float-sm-none{float:none!important}}@media (min-width:768px){.float-md-left{float:left!important}.float-md-right{float:right!important}.float-md-none{float:none!important}}@media (min-width:992px){.float-lg-left{float:left!important}.float-lg-right{float:right!important}.float-lg-none{float:none!important}}@media (min-width:1200px){.float-xl-left{float:left!important}.float-xl-right{float:right!important}.float-xl-none{float:none!important}}.user-select-all{-webkit-user-select:all!important;-moz-user-select:all!important;user-select:all!important}.user-select-auto{-webkit-user-select:auto!important;-moz-user-select:auto!important;-ms-user-select:auto!important;user-select:auto!important}.user-select-none{-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.overflow-auto{overflow:auto!important}.overflow-hidden{overflow:hidden!important}.position-static{position:static!important}.position-relative{position:relative!important}.position-absolute{position:absolute!important}.position-fixed{position:fixed!important}.position-sticky{position:-webkit-sticky!important;position:sticky!important}.fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position:-webkit-sticky) or (position:sticky)){.sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.shadow-sm{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,.175)!important}.shadow-none{box-shadow:none!important}.w-25{width:25%!important}.w-50{width:50%!important}.w-75{width:75%!important}.w-100{width:100%!important}.w-auto{width:auto!important}.h-25{height:25%!important}.h-50{height:50%!important}.h-75{height:75%!important}.h-100{height:100%!important}.h-auto{height:auto!important}.mw-100{max-width:100%!important}.mh-100{max-height:100%!important}.min-vw-100{min-width:100vw!important}.min-vh-100{min-height:100vh!important}.vw-100{width:100vw!important}.vh-100{height:100vh!important}.m-0{margin:0!important}.mt-0,.my-0{margin-top:0!important}.mr-0,.mx-0{margin-right:0!important}.mb-0,.my-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.m-1{margin:.25rem!important}.mt-1,.my-1{margin-top:.25rem!important}.mr-1,.mx-1{margin-right:.25rem!important}.mb-1,.my-1{margin-bottom:.25rem!important}.ml-1,.mx-1{margin-left:.25rem!important}.m-2{margin:.5rem!important}.mt-2,.my-2{margin-top:.5rem!important}.mr-2,.mx-2{margin-right:.5rem!important}.mb-2,.my-2{margin-bottom:.5rem!important}.ml-2,.mx-2{margin-left:.5rem!important}.m-3{margin:1rem!important}.mt-3,.my-3{margin-top:1rem!important}.mr-3,.mx-3{margin-right:1rem!important}.mb-3,.my-3{margin-bottom:1rem!important}.ml-3,.mx-3{margin-left:1rem!important}.m-4{margin:1.5rem!important}.mt-4,.my-4{margin-top:1.5rem!important}.mr-4,.mx-4{margin-right:1.5rem!important}.mb-4,.my-4{margin-bottom:1.5rem!important}.ml-4,.mx-4{margin-left:1.5rem!important}.m-5{margin:3rem!important}.mt-5,.my-5{margin-top:3rem!important}.mr-5,.mx-5{margin-right:3rem!important}.mb-5,.my-5{margin-bottom:3rem!important}.ml-5,.mx-5{margin-left:3rem!important}.p-0{padding:0!important}.pt-0,.py-0{padding-top:0!important}.pr-0,.px-0{padding-right:0!important}.pb-0,.py-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.p-1{padding:.25rem!important}.pt-1,.py-1{padding-top:.25rem!important}.pr-1,.px-1{padding-right:.25rem!important}.pb-1,.py-1{padding-bottom:.25rem!important}.pl-1,.px-1{padding-left:.25rem!important}.p-2{padding:.5rem!important}.pt-2,.py-2{padding-top:.5rem!important}.pr-2,.px-2{padding-right:.5rem!important}.pb-2,.py-2{padding-bottom:.5rem!important}.pl-2,.px-2{padding-left:.5rem!important}.p-3{padding:1rem!important}.pt-3,.py-3{padding-top:1rem!important}.pr-3,.px-3{padding-right:1rem!important}.pb-3,.py-3{padding-bottom:1rem!important}.pl-3,.px-3{padding-left:1rem!important}.p-4{padding:1.5rem!important}.pt-4,.py-4{padding-top:1.5rem!important}.pr-4,.px-4{padding-right:1.5rem!important}.pb-4,.py-4{padding-bottom:1.5rem!important}.pl-4,.px-4{padding-left:1.5rem!important}.p-5{padding:3rem!important}.pt-5,.py-5{padding-top:3rem!important}.pr-5,.px-5{padding-right:3rem!important}.pb-5,.py-5{padding-bottom:3rem!important}.pl-5,.px-5{padding-left:3rem!important}.m-n1{margin:-.25rem!important}.mt-n1,.my-n1{margin-top:-.25rem!important}.mr-n1,.mx-n1{margin-right:-.25rem!important}.mb-n1,.my-n1{margin-bottom:-.25rem!important}.ml-n1,.mx-n1{margin-left:-.25rem!important}.m-n2{margin:-.5rem!important}.mt-n2,.my-n2{margin-top:-.5rem!important}.mr-n2,.mx-n2{margin-right:-.5rem!important}.mb-n2,.my-n2{margin-bottom:-.5rem!important}.ml-n2,.mx-n2{margin-left:-.5rem!important}.m-n3{margin:-1rem!important}.mt-n3,.my-n3{margin-top:-1rem!important}.mr-n3,.mx-n3{margin-right:-1rem!important}.mb-n3,.my-n3{margin-bottom:-1rem!important}.ml-n3,.mx-n3{margin-left:-1rem!important}.m-n4{margin:-1.5rem!important}.mt-n4,.my-n4{margin-top:-1.5rem!important}.mr-n4,.mx-n4{margin-right:-1.5rem!important}.mb-n4,.my-n4{margin-bottom:-1.5rem!important}.ml-n4,.mx-n4{margin-left:-1.5rem!important}.m-n5{margin:-3rem!important}.mt-n5,.my-n5{margin-top:-3rem!important}.mr-n5,.mx-n5{margin-right:-3rem!important}.mb-n5,.my-n5{margin-bottom:-3rem!important}.ml-n5,.mx-n5{margin-left:-3rem!important}.m-auto{margin:auto!important}.mt-auto,.my-auto{margin-top:auto!important}.mr-auto,.mx-auto{margin-right:auto!important}.mb-auto,.my-auto{margin-bottom:auto!important}.ml-auto,.mx-auto{margin-left:auto!important}@media (min-width:576px){.m-sm-0{margin:0!important}.mt-sm-0,.my-sm-0{margin-top:0!important}.mr-sm-0,.mx-sm-0{margin-right:0!important}.mb-sm-0,.my-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.m-sm-1{margin:.25rem!important}.mt-sm-1,.my-sm-1{margin-top:.25rem!important}.mr-sm-1,.mx-sm-1{margin-right:.25rem!important}.mb-sm-1,.my-sm-1{margin-bottom:.25rem!important}.ml-sm-1,.mx-sm-1{margin-left:.25rem!important}.m-sm-2{margin:.5rem!important}.mt-sm-2,.my-sm-2{margin-top:.5rem!important}.mr-sm-2,.mx-sm-2{margin-right:.5rem!important}.mb-sm-2,.my-sm-2{margin-bottom:.5rem!important}.ml-sm-2,.mx-sm-2{margin-left:.5rem!important}.m-sm-3{margin:1rem!important}.mt-sm-3,.my-sm-3{margin-top:1rem!important}.mr-sm-3,.mx-sm-3{margin-right:1rem!important}.mb-sm-3,.my-sm-3{margin-bottom:1rem!important}.ml-sm-3,.mx-sm-3{margin-left:1rem!important}.m-sm-4{margin:1.5rem!important}.mt-sm-4,.my-sm-4{margin-top:1.5rem!important}.mr-sm-4,.mx-sm-4{margin-right:1.5rem!important}.mb-sm-4,.my-sm-4{margin-bottom:1.5rem!important}.ml-sm-4,.mx-sm-4{margin-left:1.5rem!important}.m-sm-5{margin:3rem!important}.mt-sm-5,.my-sm-5{margin-top:3rem!important}.mr-sm-5,.mx-sm-5{margin-right:3rem!important}.mb-sm-5,.my-sm-5{margin-bottom:3rem!important}.ml-sm-5,.mx-sm-5{margin-left:3rem!important}.p-sm-0{padding:0!important}.pt-sm-0,.py-sm-0{padding-top:0!important}.pr-sm-0,.px-sm-0{padding-right:0!important}.pb-sm-0,.py-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.p-sm-1{padding:.25rem!important}.pt-sm-1,.py-sm-1{padding-top:.25rem!important}.pr-sm-1,.px-sm-1{padding-right:.25rem!important}.pb-sm-1,.py-sm-1{padding-bottom:.25rem!important}.pl-sm-1,.px-sm-1{padding-left:.25rem!important}.p-sm-2{padding:.5rem!important}.pt-sm-2,.py-sm-2{padding-top:.5rem!important}.pr-sm-2,.px-sm-2{padding-right:.5rem!important}.pb-sm-2,.py-sm-2{padding-bottom:.5rem!important}.pl-sm-2,.px-sm-2{padding-left:.5rem!important}.p-sm-3{padding:1rem!important}.pt-sm-3,.py-sm-3{padding-top:1rem!important}.pr-sm-3,.px-sm-3{padding-right:1rem!important}.pb-sm-3,.py-sm-3{padding-bottom:1rem!important}.pl-sm-3,.px-sm-3{padding-left:1rem!important}.p-sm-4{padding:1.5rem!important}.pt-sm-4,.py-sm-4{padding-top:1.5rem!important}.pr-sm-4,.px-sm-4{padding-right:1.5rem!important}.pb-sm-4,.py-sm-4{padding-bottom:1.5rem!important}.pl-sm-4,.px-sm-4{padding-left:1.5rem!important}.p-sm-5{padding:3rem!important}.pt-sm-5,.py-sm-5{padding-top:3rem!important}.pr-sm-5,.px-sm-5{padding-right:3rem!important}.pb-sm-5,.py-sm-5{padding-bottom:3rem!important}.pl-sm-5,.px-sm-5{padding-left:3rem!important}.m-sm-n1{margin:-.25rem!important}.mt-sm-n1,.my-sm-n1{margin-top:-.25rem!important}.mr-sm-n1,.mx-sm-n1{margin-right:-.25rem!important}.mb-sm-n1,.my-sm-n1{margin-bottom:-.25rem!important}.ml-sm-n1,.mx-sm-n1{margin-left:-.25rem!important}.m-sm-n2{margin:-.5rem!important}.mt-sm-n2,.my-sm-n2{margin-top:-.5rem!important}.mr-sm-n2,.mx-sm-n2{margin-right:-.5rem!important}.mb-sm-n2,.my-sm-n2{margin-bottom:-.5rem!important}.ml-sm-n2,.mx-sm-n2{margin-left:-.5rem!important}.m-sm-n3{margin:-1rem!important}.mt-sm-n3,.my-sm-n3{margin-top:-1rem!important}.mr-sm-n3,.mx-sm-n3{margin-right:-1rem!important}.mb-sm-n3,.my-sm-n3{margin-bottom:-1rem!important}.ml-sm-n3,.mx-sm-n3{margin-left:-1rem!important}.m-sm-n4{margin:-1.5rem!important}.mt-sm-n4,.my-sm-n4{margin-top:-1.5rem!important}.mr-sm-n4,.mx-sm-n4{margin-right:-1.5rem!important}.mb-sm-n4,.my-sm-n4{margin-bottom:-1.5rem!important}.ml-sm-n4,.mx-sm-n4{margin-left:-1.5rem!important}.m-sm-n5{margin:-3rem!important}.mt-sm-n5,.my-sm-n5{margin-top:-3rem!important}.mr-sm-n5,.mx-sm-n5{margin-right:-3rem!important}.mb-sm-n5,.my-sm-n5{margin-bottom:-3rem!important}.ml-sm-n5,.mx-sm-n5{margin-left:-3rem!important}.m-sm-auto{margin:auto!important}.mt-sm-auto,.my-sm-auto{margin-top:auto!important}.mr-sm-auto,.mx-sm-auto{margin-right:auto!important}.mb-sm-auto,.my-sm-auto{margin-bottom:auto!important}.ml-sm-auto,.mx-sm-auto{margin-left:auto!important}}@media (min-width:768px){.m-md-0{margin:0!important}.mt-md-0,.my-md-0{margin-top:0!important}.mr-md-0,.mx-md-0{margin-right:0!important}.mb-md-0,.my-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.m-md-1{margin:.25rem!important}.mt-md-1,.my-md-1{margin-top:.25rem!important}.mr-md-1,.mx-md-1{margin-right:.25rem!important}.mb-md-1,.my-md-1{margin-bottom:.25rem!important}.ml-md-1,.mx-md-1{margin-left:.25rem!important}.m-md-2{margin:.5rem!important}.mt-md-2,.my-md-2{margin-top:.5rem!important}.mr-md-2,.mx-md-2{margin-right:.5rem!important}.mb-md-2,.my-md-2{margin-bottom:.5rem!important}.ml-md-2,.mx-md-2{margin-left:.5rem!important}.m-md-3{margin:1rem!important}.mt-md-3,.my-md-3{margin-top:1rem!important}.mr-md-3,.mx-md-3{margin-right:1rem!important}.mb-md-3,.my-md-3{margin-bottom:1rem!important}.ml-md-3,.mx-md-3{margin-left:1rem!important}.m-md-4{margin:1.5rem!important}.mt-md-4,.my-md-4{margin-top:1.5rem!important}.mr-md-4,.mx-md-4{margin-right:1.5rem!important}.mb-md-4,.my-md-4{margin-bottom:1.5rem!important}.ml-md-4,.mx-md-4{margin-left:1.5rem!important}.m-md-5{margin:3rem!important}.mt-md-5,.my-md-5{margin-top:3rem!important}.mr-md-5,.mx-md-5{margin-right:3rem!important}.mb-md-5,.my-md-5{margin-bottom:3rem!important}.ml-md-5,.mx-md-5{margin-left:3rem!important}.p-md-0{padding:0!important}.pt-md-0,.py-md-0{padding-top:0!important}.pr-md-0,.px-md-0{padding-right:0!important}.pb-md-0,.py-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.p-md-1{padding:.25rem!important}.pt-md-1,.py-md-1{padding-top:.25rem!important}.pr-md-1,.px-md-1{padding-right:.25rem!important}.pb-md-1,.py-md-1{padding-bottom:.25rem!important}.pl-md-1,.px-md-1{padding-left:.25rem!important}.p-md-2{padding:.5rem!important}.pt-md-2,.py-md-2{padding-top:.5rem!important}.pr-md-2,.px-md-2{padding-right:.5rem!important}.pb-md-2,.py-md-2{padding-bottom:.5rem!important}.pl-md-2,.px-md-2{padding-left:.5rem!important}.p-md-3{padding:1rem!important}.pt-md-3,.py-md-3{padding-top:1rem!important}.pr-md-3,.px-md-3{padding-right:1rem!important}.pb-md-3,.py-md-3{padding-bottom:1rem!important}.pl-md-3,.px-md-3{padding-left:1rem!important}.p-md-4{padding:1.5rem!important}.pt-md-4,.py-md-4{padding-top:1.5rem!important}.pr-md-4,.px-md-4{padding-right:1.5rem!important}.pb-md-4,.py-md-4{padding-bottom:1.5rem!important}.pl-md-4,.px-md-4{padding-left:1.5rem!important}.p-md-5{padding:3rem!important}.pt-md-5,.py-md-5{padding-top:3rem!important}.pr-md-5,.px-md-5{padding-right:3rem!important}.pb-md-5,.py-md-5{padding-bottom:3rem!important}.pl-md-5,.px-md-5{padding-left:3rem!important}.m-md-n1{margin:-.25rem!important}.mt-md-n1,.my-md-n1{margin-top:-.25rem!important}.mr-md-n1,.mx-md-n1{margin-right:-.25rem!important}.mb-md-n1,.my-md-n1{margin-bottom:-.25rem!important}.ml-md-n1,.mx-md-n1{margin-left:-.25rem!important}.m-md-n2{margin:-.5rem!important}.mt-md-n2,.my-md-n2{margin-top:-.5rem!important}.mr-md-n2,.mx-md-n2{margin-right:-.5rem!important}.mb-md-n2,.my-md-n2{margin-bottom:-.5rem!important}.ml-md-n2,.mx-md-n2{margin-left:-.5rem!important}.m-md-n3{margin:-1rem!important}.mt-md-n3,.my-md-n3{margin-top:-1rem!important}.mr-md-n3,.mx-md-n3{margin-right:-1rem!important}.mb-md-n3,.my-md-n3{margin-bottom:-1rem!important}.ml-md-n3,.mx-md-n3{margin-left:-1rem!important}.m-md-n4{margin:-1.5rem!important}.mt-md-n4,.my-md-n4{margin-top:-1.5rem!important}.mr-md-n4,.mx-md-n4{margin-right:-1.5rem!important}.mb-md-n4,.my-md-n4{margin-bottom:-1.5rem!important}.ml-md-n4,.mx-md-n4{margin-left:-1.5rem!important}.m-md-n5{margin:-3rem!important}.mt-md-n5,.my-md-n5{margin-top:-3rem!important}.mr-md-n5,.mx-md-n5{margin-right:-3rem!important}.mb-md-n5,.my-md-n5{margin-bottom:-3rem!important}.ml-md-n5,.mx-md-n5{margin-left:-3rem!important}.m-md-auto{margin:auto!important}.mt-md-auto,.my-md-auto{margin-top:auto!important}.mr-md-auto,.mx-md-auto{margin-right:auto!important}.mb-md-auto,.my-md-auto{margin-bottom:auto!important}.ml-md-auto,.mx-md-auto{margin-left:auto!important}}@media (min-width:992px){.m-lg-0{margin:0!important}.mt-lg-0,.my-lg-0{margin-top:0!important}.mr-lg-0,.mx-lg-0{margin-right:0!important}.mb-lg-0,.my-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.m-lg-1{margin:.25rem!important}.mt-lg-1,.my-lg-1{margin-top:.25rem!important}.mr-lg-1,.mx-lg-1{margin-right:.25rem!important}.mb-lg-1,.my-lg-1{margin-bottom:.25rem!important}.ml-lg-1,.mx-lg-1{margin-left:.25rem!important}.m-lg-2{margin:.5rem!important}.mt-lg-2,.my-lg-2{margin-top:.5rem!important}.mr-lg-2,.mx-lg-2{margin-right:.5rem!important}.mb-lg-2,.my-lg-2{margin-bottom:.5rem!important}.ml-lg-2,.mx-lg-2{margin-left:.5rem!important}.m-lg-3{margin:1rem!important}.mt-lg-3,.my-lg-3{margin-top:1rem!important}.mr-lg-3,.mx-lg-3{margin-right:1rem!important}.mb-lg-3,.my-lg-3{margin-bottom:1rem!important}.ml-lg-3,.mx-lg-3{margin-left:1rem!important}.m-lg-4{margin:1.5rem!important}.mt-lg-4,.my-lg-4{margin-top:1.5rem!important}.mr-lg-4,.mx-lg-4{margin-right:1.5rem!important}.mb-lg-4,.my-lg-4{margin-bottom:1.5rem!important}.ml-lg-4,.mx-lg-4{margin-left:1.5rem!important}.m-lg-5{margin:3rem!important}.mt-lg-5,.my-lg-5{margin-top:3rem!important}.mr-lg-5,.mx-lg-5{margin-right:3rem!important}.mb-lg-5,.my-lg-5{margin-bottom:3rem!important}.ml-lg-5,.mx-lg-5{margin-left:3rem!important}.p-lg-0{padding:0!important}.pt-lg-0,.py-lg-0{padding-top:0!important}.pr-lg-0,.px-lg-0{padding-right:0!important}.pb-lg-0,.py-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.p-lg-1{padding:.25rem!important}.pt-lg-1,.py-lg-1{padding-top:.25rem!important}.pr-lg-1,.px-lg-1{padding-right:.25rem!important}.pb-lg-1,.py-lg-1{padding-bottom:.25rem!important}.pl-lg-1,.px-lg-1{padding-left:.25rem!important}.p-lg-2{padding:.5rem!important}.pt-lg-2,.py-lg-2{padding-top:.5rem!important}.pr-lg-2,.px-lg-2{padding-right:.5rem!important}.pb-lg-2,.py-lg-2{padding-bottom:.5rem!important}.pl-lg-2,.px-lg-2{padding-left:.5rem!important}.p-lg-3{padding:1rem!important}.pt-lg-3,.py-lg-3{padding-top:1rem!important}.pr-lg-3,.px-lg-3{padding-right:1rem!important}.pb-lg-3,.py-lg-3{padding-bottom:1rem!important}.pl-lg-3,.px-lg-3{padding-left:1rem!important}.p-lg-4{padding:1.5rem!important}.pt-lg-4,.py-lg-4{padding-top:1.5rem!important}.pr-lg-4,.px-lg-4{padding-right:1.5rem!important}.pb-lg-4,.py-lg-4{padding-bottom:1.5rem!important}.pl-lg-4,.px-lg-4{padding-left:1.5rem!important}.p-lg-5{padding:3rem!important}.pt-lg-5,.py-lg-5{padding-top:3rem!important}.pr-lg-5,.px-lg-5{padding-right:3rem!important}.pb-lg-5,.py-lg-5{padding-bottom:3rem!important}.pl-lg-5,.px-lg-5{padding-left:3rem!important}.m-lg-n1{margin:-.25rem!important}.mt-lg-n1,.my-lg-n1{margin-top:-.25rem!important}.mr-lg-n1,.mx-lg-n1{margin-right:-.25rem!important}.mb-lg-n1,.my-lg-n1{margin-bottom:-.25rem!important}.ml-lg-n1,.mx-lg-n1{margin-left:-.25rem!important}.m-lg-n2{margin:-.5rem!important}.mt-lg-n2,.my-lg-n2{margin-top:-.5rem!important}.mr-lg-n2,.mx-lg-n2{margin-right:-.5rem!important}.mb-lg-n2,.my-lg-n2{margin-bottom:-.5rem!important}.ml-lg-n2,.mx-lg-n2{margin-left:-.5rem!important}.m-lg-n3{margin:-1rem!important}.mt-lg-n3,.my-lg-n3{margin-top:-1rem!important}.mr-lg-n3,.mx-lg-n3{margin-right:-1rem!important}.mb-lg-n3,.my-lg-n3{margin-bottom:-1rem!important}.ml-lg-n3,.mx-lg-n3{margin-left:-1rem!important}.m-lg-n4{margin:-1.5rem!important}.mt-lg-n4,.my-lg-n4{margin-top:-1.5rem!important}.mr-lg-n4,.mx-lg-n4{margin-right:-1.5rem!important}.mb-lg-n4,.my-lg-n4{margin-bottom:-1.5rem!important}.ml-lg-n4,.mx-lg-n4{margin-left:-1.5rem!important}.m-lg-n5{margin:-3rem!important}.mt-lg-n5,.my-lg-n5{margin-top:-3rem!important}.mr-lg-n5,.mx-lg-n5{margin-right:-3rem!important}.mb-lg-n5,.my-lg-n5{margin-bottom:-3rem!important}.ml-lg-n5,.mx-lg-n5{margin-left:-3rem!important}.m-lg-auto{margin:auto!important}.mt-lg-auto,.my-lg-auto{margin-top:auto!important}.mr-lg-auto,.mx-lg-auto{margin-right:auto!important}.mb-lg-auto,.my-lg-auto{margin-bottom:auto!important}.ml-lg-auto,.mx-lg-auto{margin-left:auto!important}}@media (min-width:1200px){.m-xl-0{margin:0!important}.mt-xl-0,.my-xl-0{margin-top:0!important}.mr-xl-0,.mx-xl-0{margin-right:0!important}.mb-xl-0,.my-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.m-xl-1{margin:.25rem!important}.mt-xl-1,.my-xl-1{margin-top:.25rem!important}.mr-xl-1,.mx-xl-1{margin-right:.25rem!important}.mb-xl-1,.my-xl-1{margin-bottom:.25rem!important}.ml-xl-1,.mx-xl-1{margin-left:.25rem!important}.m-xl-2{margin:.5rem!important}.mt-xl-2,.my-xl-2{margin-top:.5rem!important}.mr-xl-2,.mx-xl-2{margin-right:.5rem!important}.mb-xl-2,.my-xl-2{margin-bottom:.5rem!important}.ml-xl-2,.mx-xl-2{margin-left:.5rem!important}.m-xl-3{margin:1rem!important}.mt-xl-3,.my-xl-3{margin-top:1rem!important}.mr-xl-3,.mx-xl-3{margin-right:1rem!important}.mb-xl-3,.my-xl-3{margin-bottom:1rem!important}.ml-xl-3,.mx-xl-3{margin-left:1rem!important}.m-xl-4{margin:1.5rem!important}.mt-xl-4,.my-xl-4{margin-top:1.5rem!important}.mr-xl-4,.mx-xl-4{margin-right:1.5rem!important}.mb-xl-4,.my-xl-4{margin-bottom:1.5rem!important}.ml-xl-4,.mx-xl-4{margin-left:1.5rem!important}.m-xl-5{margin:3rem!important}.mt-xl-5,.my-xl-5{margin-top:3rem!important}.mr-xl-5,.mx-xl-5{margin-right:3rem!important}.mb-xl-5,.my-xl-5{margin-bottom:3rem!important}.ml-xl-5,.mx-xl-5{margin-left:3rem!important}.p-xl-0{padding:0!important}.pt-xl-0,.py-xl-0{padding-top:0!important}.pr-xl-0,.px-xl-0{padding-right:0!important}.pb-xl-0,.py-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.p-xl-1{padding:.25rem!important}.pt-xl-1,.py-xl-1{padding-top:.25rem!important}.pr-xl-1,.px-xl-1{padding-right:.25rem!important}.pb-xl-1,.py-xl-1{padding-bottom:.25rem!important}.pl-xl-1,.px-xl-1{padding-left:.25rem!important}.p-xl-2{padding:.5rem!important}.pt-xl-2,.py-xl-2{padding-top:.5rem!important}.pr-xl-2,.px-xl-2{padding-right:.5rem!important}.pb-xl-2,.py-xl-2{padding-bottom:.5rem!important}.pl-xl-2,.px-xl-2{padding-left:.5rem!important}.p-xl-3{padding:1rem!important}.pt-xl-3,.py-xl-3{padding-top:1rem!important}.pr-xl-3,.px-xl-3{padding-right:1rem!important}.pb-xl-3,.py-xl-3{padding-bottom:1rem!important}.pl-xl-3,.px-xl-3{padding-left:1rem!important}.p-xl-4{padding:1.5rem!important}.pt-xl-4,.py-xl-4{padding-top:1.5rem!important}.pr-xl-4,.px-xl-4{padding-right:1.5rem!important}.pb-xl-4,.py-xl-4{padding-bottom:1.5rem!important}.pl-xl-4,.px-xl-4{padding-left:1.5rem!important}.p-xl-5{padding:3rem!important}.pt-xl-5,.py-xl-5{padding-top:3rem!important}.pr-xl-5,.px-xl-5{padding-right:3rem!important}.pb-xl-5,.py-xl-5{padding-bottom:3rem!important}.pl-xl-5,.px-xl-5{padding-left:3rem!important}.m-xl-n1{margin:-.25rem!important}.mt-xl-n1,.my-xl-n1{margin-top:-.25rem!important}.mr-xl-n1,.mx-xl-n1{margin-right:-.25rem!important}.mb-xl-n1,.my-xl-n1{margin-bottom:-.25rem!important}.ml-xl-n1,.mx-xl-n1{margin-left:-.25rem!important}.m-xl-n2{margin:-.5rem!important}.mt-xl-n2,.my-xl-n2{margin-top:-.5rem!important}.mr-xl-n2,.mx-xl-n2{margin-right:-.5rem!important}.mb-xl-n2,.my-xl-n2{margin-bottom:-.5rem!important}.ml-xl-n2,.mx-xl-n2{margin-left:-.5rem!important}.m-xl-n3{margin:-1rem!important}.mt-xl-n3,.my-xl-n3{margin-top:-1rem!important}.mr-xl-n3,.mx-xl-n3{margin-right:-1rem!important}.mb-xl-n3,.my-xl-n3{margin-bottom:-1rem!important}.ml-xl-n3,.mx-xl-n3{margin-left:-1rem!important}.m-xl-n4{margin:-1.5rem!important}.mt-xl-n4,.my-xl-n4{margin-top:-1.5rem!important}.mr-xl-n4,.mx-xl-n4{margin-right:-1.5rem!important}.mb-xl-n4,.my-xl-n4{margin-bottom:-1.5rem!important}.ml-xl-n4,.mx-xl-n4{margin-left:-1.5rem!important}.m-xl-n5{margin:-3rem!important}.mt-xl-n5,.my-xl-n5{margin-top:-3rem!important}.mr-xl-n5,.mx-xl-n5{margin-right:-3rem!important}.mb-xl-n5,.my-xl-n5{margin-bottom:-3rem!important}.ml-xl-n5,.mx-xl-n5{margin-left:-3rem!important}.m-xl-auto{margin:auto!important}.mt-xl-auto,.my-xl-auto{margin-top:auto!important}.mr-xl-auto,.mx-xl-auto{margin-right:auto!important}.mb-xl-auto,.my-xl-auto{margin-bottom:auto!important}.ml-xl-auto,.mx-xl-auto{margin-left:auto!important}}.stretched-link::after{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;pointer-events:auto;content:\"\";background-color:rgba(0,0,0,0)}.text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace!important}.text-justify{text-align:justify!important}.text-wrap{white-space:normal!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-left{text-align:left!important}.text-right{text-align:right!important}.text-center{text-align:center!important}@media (min-width:576px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-light{font-weight:300!important}.font-weight-lighter{font-weight:lighter!important}.font-weight-normal{font-weight:400!important}.font-weight-bold{font-weight:700!important}.font-weight-bolder{font-weight:bolder!important}.font-italic{font-style:italic!important}.text-white{color:#fff!important}.text-primary{color:#007bff!important}a.text-primary:focus,a.text-primary:hover{color:#0056b3!important}.text-secondary{color:#6c757d!important}a.text-secondary:focus,a.text-secondary:hover{color:#494f54!important}.text-success{color:#28a745!important}a.text-success:focus,a.text-success:hover{color:#19692c!important}.text-info{color:#17a2b8!important}a.text-info:focus,a.text-info:hover{color:#0f6674!important}.text-warning{color:#ffc107!important}a.text-warning:focus,a.text-warning:hover{color:#ba8b00!important}.text-danger{color:#dc3545!important}a.text-danger:focus,a.text-danger:hover{color:#a71d2a!important}.text-light{color:#f8f9fa!important}a.text-light:focus,a.text-light:hover{color:#cbd3da!important}.text-dark{color:#343a40!important}a.text-dark:focus,a.text-dark:hover{color:#121416!important}.text-body{color:#212529!important}.text-muted{color:#6c757d!important}.text-black-50{color:rgba(0,0,0,.5)!important}.text-white-50{color:rgba(255,255,255,.5)!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.text-decoration-none{text-decoration:none!important}.text-break{word-break:break-word!important;word-wrap:break-word!important}.text-reset{color:inherit!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media print{*,::after,::before{text-shadow:none!important;box-shadow:none!important}a:not(.btn){text-decoration:underline}abbr[title]::after{content:\" (\" attr(title) \")\"}pre{white-space:pre-wrap!important}blockquote,pre{border:1px solid #adb5bd;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}@page{size:a3}body{min-width:992px!important}.container{min-width:992px!important}.navbar{display:none}.badge{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #dee2e6!important}.table-dark{color:inherit}.table-dark tbody+tbody,.table-dark td,.table-dark th,.table-dark thead th{border-color:#dee2e6}.table .thead-dark th{color:inherit;border-color:#dee2e6}}", ""]);

// exports


/***/ }),

/***/ "q2yx":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "q5vZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-35b793fb] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-35b793fb] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-35b793fb] {\n  width: 75px;\n}\n.bigTitle[data-v-35b793fb] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-35b793fb] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-35b793fb] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-35b793fb] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-35b793fb] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-35b793fb] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-35b793fb] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-35b793fb] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-35b793fb] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-35b793fb] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 177px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-35b793fb] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-35b793fb] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-35b793fb] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-35b793fb] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-35b793fb] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-35b793fb] {\n      background-color: transparent;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: none;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-35b793fb]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #00917e;\n        border: 3px solid #00917e;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-35b793fb] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-35b793fb] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-35b793fb]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-35b793fb]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-35b793fb]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-35b793fb] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-35b793fb] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-35b793fb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "qex6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("z1r2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2c8b2ad8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f46a2896\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-f46a2896\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "qsgh":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "r20c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sDGe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAABNCAIAAABCAp0wAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA41pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wUmlnaHRzPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvcmlnaHRzLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcFJpZ2h0czpNYXJrZWQ9IkZhbHNlIiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InV1aWQ6ODg1NjhGNjMzMURDREUxMUJCMEZERjBFOTY2NTEzNTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6REQwRTg5NjAwRkFDMTFFMjk5RDlDQ0Y3OUY2MjA2NkEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6REQwRTg5NUYwRkFDMTFFMjk5RDlDQ0Y3OUY2MjA2NkEiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjEyRTNBOUU0MUEyMDY4MTE4MjJBQ0EwNTk2QUUzMTlCIiBzdFJlZjpkb2N1bWVudElEPSIwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+8rBrcgAACGdJREFUeNrsnQl0FPUdx3dmM3tncwfCI1CkKmA4ChVsPIIJKBYR1IgHh6KCFSi1BSO2BlC80lgjaFPqq0/0KcGEGA6BxAQoqECNXEIABcRARUIO2N1k9pqd6X+zkMz8Z3dDnvW9kP1+3j7e7n+uzeYzv+M/s4E5rUvQANCVYPERAEgJAKQEkBIASAkgJQCQEkBKACAlAJASQEoAOkfUZa2l1XJpA6kx35kfxfrGDrZL7c3Gxyo3E72HDneDD44beK1Gx8lHhG+PS04XlPrpMJdzQwYbG9Or7gQ1eGHBc81vrgi/Yfy/3jJNe0A+ItrsZ5Kv6gYfXMqxfdo+qfKRupGjvQcOQSmkbwApAYCUAFICACkBgJQAUgLQaaK61tthGO7aq7mhaWxyMqPXSW6PeLbO8/Uh4ZtjP/uRLWbdr4Zo+/ZhrVaNVis5HGJDo/Dd996j32pEEaJEopRsbIxlzizzjCna1N7qpULtKX7lqua/vy3a7G2D+swMy+zH5auJZ8+dnztfvbk2pWfsm/nyEcnR3PTobI0kkee6kSOsC/+kH3sro9OptxUbm5zrNzleWy4c/w66RJCUxonj4wpfZxNDXluK6tvHunih+cnHzs+a59pcGRj01Z4yTriDWtO+NM9Xd47e/6Q7qTX5VSV+Ixkm5sXc6Pm/J09Cni0J8eYZU01TJp9/fC7/0ccwJiJqyugF8xKK3wtjZHvAS05KXFtkeWLGxfB54qQ6eunHjA4i/aTx1AhftIb86zdywbwwRrYnd50ufuUK/c2/gTFdOlLqrh9unv5gB3vv3y/8CuZHpsS8tKhTx41dnk+SOL+6lDx3lVda5j4hX2rIzOA/LFacdvFx+psUMon1ja6t28n798fITpy/bEze0nPpYyBN15XSdP895PGTjt2/X+wbeepxz579zo/Xi+fqtb1SjNkTucHXUSvEFRZ4dlWTQtO1iZZSHSkN42/XRCl+TL50nUYQonOeomIk6av4ohLv/oNSSwublGh6MJs6tG7EMPKeSYSGN922pozJe4ExGqhBW84ix/J/BFoQf42YV0C6EOuSZxXJ1GyyvpjbNG2m+/OdEu9kTMb2FN+zBzdogPfwUXnBSufu1WtIOjbcTse8hrvud//7s7aXjjcKE1a/a7zrt5SXkLLb1pRRV/dXtymOvALHssI2I1vDl2R/5W+k76bjdPZEbZ9UEttIIqbLyqzRcn0NYzPlS32nTnt2V3NpAxm9otf2/OcruZGtq/r494voujbY5ADoJlKaHrqPGvH9cIb4F3Rl2+KX6RuKWTZQPJCyks7XsgxuuC2LMegVYbK4jIjOREeTwlT+8B6kbz0mAVgdZeVRGXS39G3Ioou/lvdWhbpzW3I080XFlnlPKveQ4chf5tpcRUfKm9NJdpY8Hn/uVibftr7bvf3zoPcakyqWG3IdNyRNnz6KtEdMtAWKXElSNq94x1m6voPpnpw/UNmzDfKLp0ZcldvC7Mr16TZKSm7YEH98/e8P3kOHubRB8pStu+HX7h07GY7zdzkyvDVH6C9jMIz+xlH6sZn6kSO4oYPZhHg4cQVLKRw/6d7xRQczPiHmjLTJSeoWR6g5EmZX6m/2sHGxxD+phXeVV8mlDJSVREp9xk1sjFXZ4pTKXxrvHEearahfXgUPUFNqGGOQykx+CTHYUluQ/XBciLLyVk3rhRxq3EkKyktY//J0QukHMBI15aUaURCCGNZ6B0anPA7g3lVNhJYHRd3woSQRGyaMU/TXu6uF72vbYqR10TMh3x7v9Ow74Kneq/F4/NOZIBKkFOsbApeeFTn9F33D3A0U1a8vrY7TJV5oDZ+C4K7casyeJO/NiUzanj1C5W5q4rN1d5JzY4Wrooq46605qvH5/GXALTdCykhJ36Q1Vk9B629JD7MJdanQX2Ue+aa9DarYQi21zJmpeO3z8WvWXrQ/tbf6KlHTtFmN905teXul9+uagJEgsqT059zPdtJd0cNTQr9N1vTwQ/QeZG2Wc3OlYsr9UrnZbu3W7f7wHGjbB1xD+11zhC8pC9KQ9UiGIhEkpbNkLTWiu364ekb9oq+PTeMGDaD3ULpOXg949h4Iczh57qam01utFIJuZZr+ABSJIClJ6PLf1K0krrBAPa9pnHBHbMGr1KDnyz3kodjh5k9DVgsut2v9pvZMrrrhkhuapksfpQyS2phXnzfclgVFIqXRCTQWtqdzEzd8pGyxDYmfFPPFZc6yDb6zddpeKabJd6uv9ZFtL+Tk0pZXbLE+lxP8BNhYLtod7WHxwEHykrVGyw7MJK5b7Xj5NfcXuxmDgUsbZH50qrruBN1dSv9Fmi3N/3y37abd9qQ5+W7yCLOhI3+ZZ9eXdOz8ap9Y38gmBblZmLpjXHJ7Wt55P/qPcxQpwxpNQiOEiOj0HcA2/8+ujRWd2oRUh7YlrwRZIIrE8iDDNrt6dt3+Ur5wsha/fkgZLId7vQ33TXe8/tZlfWNQEOwv5DU98rtQUzZtX99R9ENlG9Rz8pKjuWF8tnDsBAy4YtO3JAW5Buhxd7idyDupDSW7aj8+n+3ZJc6SMmvuM4ZxYzQsG1RH5yfl9qV/Df+3LV1V28TzF6g9+L8jFtTwEyfrbsiMWbzQPHOG+kI8OVv4D4t9tactT82meqaLP5rdwVCfiQ/fxP3/wHSp/zBU2yNZn5XBDRusTUkhoki803fmR+/e/a6tO8SGxp8rWcTFkpNBN3KENjlJIqdfQ6Nnz35XeVXbvCaIaCkB0ODPtgBICQCkBJASAEgJICUAkBJASgAgJQCQEkBKACAlgJQAQEoAKQGAlABASgApAYCUAFICACkBpAQAUgJICQCkBABSAkgJAKQEkBIASAm6O/8TYACS3yh7C+j/awAAAABJRU5ErkJggg=="

/***/ }),

/***/ "sSMI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SwIb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2afc900a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48050120\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48050120\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "u+93":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("54oZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("62e45bdd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-415b2084\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v4hK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OBAr");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2e8fec5c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-03a5036f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vOz5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("H0mA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5fe9b6fd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0de2e1c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0de2e1c8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vdnq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BadgerAccordionItem = ({
    name: 'BadgerAccordionItem',
    mounted: function mounted() {
        // If item rendered emit readyness to parent
        this.$parent.$emit('item:ready');
    },
    data: function data() {
        return {
            opened: false
        };
    },

    methods: {
        changeState: function changeState(state) {
            this.opened = state;
        },
        getIcon: function getIcon() {
            return this.icon;
        }
    },
    computed: {
        iconComponent: function iconComponent() {
            if (this.$parent.iconComponent) {
                return this.$parent.iconComponent;
            }

            return this.iconLoaded;
        },
        iconOpened: function iconOpened() {
            return this.$parent.icons ? this.$parent.icons.opened : '';
        },
        iconClosed: function iconClosed() {
            return this.$parent.icons ? this.$parent.icons.closed : '';
        },
        icon: function icon() {
            return this.opened ? this.iconOpened : this.iconClosed;
        },
        iconLoaded: function iconLoaded() {
            return {
                template: '<span>' + this.icon + '</span>'
            };
        }
    },
    watch: {
        opened: function opened(newValue) {
            this.$emit(newValue ? 'open' : 'close');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a8184a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "badger-accordion-item" }, [
    _c("dt", { staticClass: "badger-accordion__header" }, [
      _c("div", { staticClass: "js-badger-accordion-header" }, [
        _c(
          "button",
          { staticClass: "badger-accordion-toggle" },
          [
            _c(
              "span",
              { staticClass: "badger-accordion-title" },
              [_vm._t("header", [_vm._v("Collapse-Title")])],
              2
            ),
            _vm._v(" "),
            _vm.icon !== "" && _vm.iconComponent
              ? _c(_vm.iconComponent, {
                  tag: "component",
                  staticClass: "badger-toggle-indicator",
                  attrs: { opened: _vm.opened }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "dd",
      { staticClass: "badger-accordion__panel js-badger-accordion-panel" },
      [
        _c(
          "div",
          { staticClass: "js-badger-accordion-panel-inner" },
          [_vm._t("content")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_BadgerAccordionItem = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a8184a", esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("aHDP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  BadgerAccordionItem,
  src_BadgerAccordionItem,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-badger-accordion/src/BadgerAccordionItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25a8184a", Component.options)
  } else {
    hotAPI.reload("data-v-25a8184a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var vue_badger_accordion_src_BadgerAccordionItem = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vg18":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "vp/L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/load.bf322df.gif";

/***/ }),

/***/ "w/IJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "x/1t":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.btnOverlay[data-v-67f3a69c]{\r\n\tmargin-top: -350px!important;\n}\n.headerBack[data-v-67f3a69c]{\r\n\r\nbackground: url(" + escape(__webpack_require__("jfmn")) + ");\r\nbackground-size: cover;\r\nbackground-position: bottom;\r\nbackground-repeat: no-repeat;\n}\n.section[data-v-67f3a69c]{\r\n\tmin-height: calc(100vh - 0px);\n}\n.howplayBack[data-v-67f3a69c]{\r\n\r\nbackground: url(" + escape(__webpack_require__("RH4N")) + ");\r\nbackground-size: cover;\r\nbackground-position: top;\r\nbackground-repeat: no-repeat;\n}\n.servicesBack[data-v-67f3a69c]{\r\n\r\nbackground: url(" + escape(__webpack_require__("FIF3")) + ");\r\nbackground-size: cover;\r\nbackground-position: bottom;\r\nbackground-repeat: no-repeat;\n}\n.verySmall[data-v-67f3a69c] {\r\n    font-size: 14px!important;\r\n    padding: 8px!important;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    vertical-align: middle;\r\n    margin: 10px;\n}\n.disabled[data-v-67f3a69c] {\r\n    background: #4d4d4d!important;\n}\n.back[data-v-67f3a69c]{\r\n\tbackground: #ececec;\n}\r\n\r\n", ""]);

// exports


/***/ }),

/***/ "x3vu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HJqQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e56d5352", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yIMT":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "yLEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_UPDATE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_SET_DEFAULT_SHIP_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_CHECK_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_COOKIES; });
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';
var USER_UPDATE_DATA = 'USER_UPDATE_DATA';
var USER_SET_DEFAULT_SHIP_DATA = 'USER_SET_DEFAULT_SHIP_DATA';
var USER_CHECK_AGE = 'USER_CHECK_AGE';
var ACCEPT_COOKIES = 'ACCEPT_COOKIES';

/***/ }),

/***/ "yNpN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.fileNameText[data-v-25d2da78] {\n  position: absolute;\n  bottom: -37px;\n  font-size: 17px;\n  width: 100%;\n  text-align: center;\n  color: #0e3d8b !important;\n  z-index: 12313;\n  white-space: nowrap;\n  word-wrap: break-word;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.borderTop[data-v-25d2da78] {\n  border-top: 3px solid #003d13;\n  padding-top: 15px;\n}\n.shopIcon[data-v-25d2da78] {\n  width: 75px;\n}\n.bigTitle[data-v-25d2da78] {\n  font-size: 47px;\n  color: #003d13;\n}\n@media screen and (max-width: 667px) {\n.bigTitle[data-v-25d2da78] {\n      font-size: 27px;\n}\n}\n.hideFileUpload[data-v-25d2da78] {\n  position: absolute;\n  width: 100%;\n  height: 110%;\n  background: #000000;\n  opacity: 0.4;\n  top: -18px;\n  left: 0;\n  -webkit-filter: blur(24px);\n          filter: blur(24px);\n  z-index: 10000;\n}\n@media screen and (max-width: 667px) {\nh5[data-v-25d2da78] {\n    font-size: 14px;\n}\n}\n.corporateImg[data-v-25d2da78] {\n  max-height: 153px;\n}\n.backImageInvoice[data-v-25d2da78] {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n}\n.backImageInvoice > img[data-v-25d2da78] {\n    max-height: 477px;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.zoomImage[data-v-25d2da78] {\n  position: absolute;\n  left: 48%;\n  top: 230px;\n  cursor: pointer;\n}\n.vcenter[data-v-25d2da78] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-item-align: center;\n      align-self: center;\n  vertical-align: middle;\n  display: inherit;\n}\n.front-image[data-v-25d2da78] {\n  position: relative;\n  margin: 0 auto;\n  display: block;\n  height: 147px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-item-align: center;\n  align-self: center;\n  width: 191px;\n  margin-bottom: 17px;\n}\n@media screen and (max-width: 1024px) {\n.front-image[data-v-25d2da78] {\n      margin-top: 15px !important;\n}\n}\n.front-image > .fileInputLabel[data-v-25d2da78] {\n    display: none;\n}\n.front-image > .invalid-feedback[data-v-25d2da78] {\n    display: block;\n    position: absolute;\n    bottom: 15px;\n    font-weight: 800;\n}\n.front-image > input[data-v-25d2da78] {\n    position: absolute;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    left: 5px;\n    width: 100%;\n    height: 200px;\n    z-index: 10;\n    top: -20px;\n}\n.front-image > label[data-v-25d2da78] {\n    /*display: none;*/\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-item-align: center;\n    align-self: center;\n    position: relative;\n    padding: 0 !important !important;\n    left: 0;\n}\n.front-image > label > span[data-v-25d2da78] {\n      background-color: #dee6ff;\n      background-size: contain;\n      background-position: center;\n      background-repeat: no-repeat;\n      border: 1px solid white;\n      width: 192px;\n      margin-top: 19px !important;\n      display: block;\n      height: 155px;\n      margin: 0 auto;\n      cursor: pointer;\n      word-break: break-all;\n      padding: 5px;\n      color: white;\n      border-radius: 7px;\n      overflow-wrap: break-word;\n      white-space: normal;\n      line-height: 29px;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      align-self: center;\n      vertical-align: middle;\n      margin: auto;\n      display: inline-grid;\n      background-size: cover;\n      background-position: center;\n}\n.front-image > label > span[data-v-25d2da78]:before {\n        content: \"+\";\n        display: block;\n        clear: both;\n        text-align: center;\n        height: 141px;\n        width: 179px;\n        border-radius: 7px;\n        padding-top: 51px;\n        font-size: 51px;\n        font-weight: 600;\n        color: #0091da;\n        border: 3px solid #0091da;\n}\n@media screen and (max-width: 667px) {\n.front-image > label > span[data-v-25d2da78] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label > span[data-v-25d2da78] {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n.front-image > label[data-v-25d2da78]:after {\n      content: \"\";\n      display: block;\n      clear: both;\n      text-align: center;\n      width: 237px;\n      font-size: 10px;\n      text-decoration: underline;\n      color: black;\n      /*\r\n      display: block;\r\nclear: both;\r\ntext-align: center;\r\nheight: 188px;\r\nwidth: 188px;\r\nborder-radius: 7px;\r\nfont-size: 10px;\r\ntext-decoration: underline;\r\ncolor: black;\r\nborder: 3px solid #0e3d8b;*/\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-25d2da78]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-25d2da78]:after {\n          margin: 0 auto !important !important;\n          float: none;\n}\n}\n@media screen and (max-width: 667px) {\n.front-image > label[data-v-25d2da78] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n@media screen and (min-width: 667px) and (max-width: 1024px) {\n.front-image > label[data-v-25d2da78] {\n        width: 100% !important;\n        float: none !important;\n        text-align: center !important;\n        margin: 0 auto !important !important;\n}\n}\n.center-container[data-v-25d2da78] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "yqhM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Fp4o");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3a935d3f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fe741b42\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fe741b42\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "z1r2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.errorIcon[data-v-f46a2896] {\n  max-width: 150px;\n  margin: 0 auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "z5ke":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/arial.c28c322.eot";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app-2e946aca18c5db5143b4d.js